
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4cW8x", function(module, exports) {
/* ai-answer-dialog.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $3u5lg = parcelRequire("3u5lg");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $5AzUy = parcelRequire("5AzUy");


var $3PNw6 = parcelRequire("3PNw6");


var $a1L5E = parcelRequire("a1L5E");


var $fNTq8 = parcelRequire("fNTq8");

var $cFVPs = parcelRequire("cFVPs");


var $f3OgL = parcelRequire("f3OgL");


var $k8VpS = parcelRequire("k8VpS");


var $aMSTz = parcelRequire("aMSTz");


var $6JEx2 = parcelRequire("6JEx2");


var $bZMnB = parcelRequire("bZMnB");


var $eySxZ = parcelRequire("eySxZ");





var $eVK28 = parcelRequire("eVK28");

const $f557ddd0ea926672$export$baca5c7d93c77000 = ({ userId: userId, cloudId: cloudId, source: source })=>{
    return (0, $cozmU.useMemo)(()=>(0, $eVK28.sha256)(`${userId}-${cloudId}-${Date.now().toString()}-${source}`), [
        userId,
        cloudId,
        source
    ]);
};








const $06f67127312b8dc5$export$6dde22325042712e = (config)=>{
    const { isEnabled: isEnabled, isInViewport: isInViewport, tabHasFocus: tabHasFocus, thresholdMs: thresholdMs, onDwellStart: onDwellStart, onDwellThreshold: onDwellThreshold, onDwellEnd: onDwellEnd } = config;
    const [isThresholdReached, setIsThresholdReached] = (0, $cozmU.useState)(false);
    const [dwellTimer, setDwellTimer] = (0, $cozmU.useState)(null);
    const dwellStartTimeRef = (0, $cozmU.useRef)();
    const isDwellActiveRef = (0, $cozmU.useRef)(false);
    const isInterruptedRef = (0, $cozmU.useRef)(false);
    const isThresholdReachedRef = (0, $cozmU.useRef)(false);
    const isInViewportRef = (0, $cozmU.useRef)(isInViewport);
    const tabHasFocusRef = (0, $cozmU.useRef)(tabHasFocus);
    const onDwellEndRef = (0, $cozmU.useRef)(onDwellEnd);
    // Keep refs in sync with current values
    isInViewportRef.current = isInViewport;
    tabHasFocusRef.current = tabHasFocus;
    onDwellEndRef.current = onDwellEnd;
    // Reset state when disabled
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) {
            setIsThresholdReached(false);
            isThresholdReachedRef.current = false;
            isDwellActiveRef.current = false;
            isInterruptedRef.current = false;
            dwellStartTimeRef.current = undefined;
            if (dwellTimer) {
                clearTimeout(dwellTimer);
                setDwellTimer(null);
            }
        }
    }, [
        isEnabled,
        dwellTimer
    ]);
    // Handle dwell start
    (0, $cozmU.useEffect)(()=>{
        if (isEnabled && isInViewport && tabHasFocus) // Start dwell if not already active or if interrupted
        {
            if (!isDwellActiveRef.current || isInterruptedRef.current) {
                // Clear any existing timer
                if (dwellTimer) {
                    clearTimeout(dwellTimer);
                    setDwellTimer(null);
                }
                isDwellActiveRef.current = true;
                isInterruptedRef.current = false;
                dwellStartTimeRef.current = Date.now();
                // Fire dwell start event (always fire for QSR tracking)
                onDwellStart?.();
                // Set fresh threshold timer if threshold hasn't been reached yet
                if (!isThresholdReachedRef.current) {
                    const timer = setTimeout(()=>{
                        setDwellTimer(null);
                        // Only fire threshold event if still in viewport, has focus, and not already reached
                        if (isInViewportRef.current && tabHasFocusRef.current && !isThresholdReachedRef.current) {
                            const dwellTime = dwellStartTimeRef.current ? Date.now() - dwellStartTimeRef.current : 0;
                            isThresholdReachedRef.current = true;
                            setIsThresholdReached(true);
                            onDwellThreshold?.(dwellTime);
                        }
                    }, thresholdMs);
                    setDwellTimer(timer);
                }
            }
        }
    }, [
        isEnabled,
        isInViewport,
        tabHasFocus,
        thresholdMs,
        onDwellStart,
        onDwellThreshold,
        dwellTimer
    ]);
    // Handle dwell end (leaving viewport or losing tab focus)
    (0, $cozmU.useEffect)(()=>{
        if (isEnabled && (!isInViewport || !tabHasFocus) && isDwellActiveRef.current) {
            isDwellActiveRef.current = false;
            isInterruptedRef.current = true;
            const dwellTime = dwellStartTimeRef.current ? Date.now() - dwellStartTimeRef.current : 0;
            // Clear timer when leaving viewport or losing focus
            if (dwellTimer) {
                clearTimeout(dwellTimer);
                setDwellTimer(null);
            }
            // Reset threshold state if dwell hasn't been reached yet to allow consecutive sessions
            if (!isThresholdReached) // Reset start time to prepare for next dwell session
            dwellStartTimeRef.current = undefined;
            // Fire dwell end event
            onDwellEnd?.(dwellTime);
        }
    }, [
        isEnabled,
        isInViewport,
        tabHasFocus,
        onDwellEnd,
        dwellTimer,
        isThresholdReached
    ]);
    // Handle page navigation and unmount
    (0, $cozmU.useEffect)(()=>{
        const handleNavigation = ()=>{
            if (isDwellActiveRef.current && dwellStartTimeRef.current) {
                const dwellTime = Date.now() - dwellStartTimeRef.current;
                onDwellEndRef.current?.(dwellTime);
                isDwellActiveRef.current = false; // Prevent duplicate firing
            }
        };
        const removeNavigationListener = (0, $cbY7C.bind)(window, {
            type: 'beforeunload',
            listener: handleNavigation
        });
        return ()=>{
            removeNavigationListener();
            if (isDwellActiveRef.current && dwellStartTimeRef.current) {
                const dwellTime = Date.now() - dwellStartTimeRef.current;
                onDwellEndRef.current?.(dwellTime);
            }
        };
    }, []);
    // Cleanup on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (dwellTimer) clearTimeout(dwellTimer);
        };
    }, [
        dwellTimer
    ]);
};



var $zzZbq = parcelRequire("zzZbq");

const $b8dde4ad487d9f98$export$38439c13a4683ecf = (smartAnswersRoute)=>{
    switch(smartAnswersRoute){
        case (0, $zzZbq.QueryIntent).PERSON:
            return 'Person Card';
        case (0, $zzZbq.QueryIntent).TEAM:
            return 'Team Card';
        case (0, $zzZbq.QueryIntent).LOCATION:
            return 'Location Card';
        case (0, $zzZbq.QueryIntent).DATE:
            return 'Date Card';
        case (0, $zzZbq.QueryIntent).TOPIC:
            return 'Topic Card';
        case (0, $zzZbq.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY:
            return 'Jira Card';
        case (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD:
            return 'Jira NLQ Keyword Card';
        case (0, $zzZbq.QueryIntent).AGENT:
            return 'Agent Card';
        case (0, $zzZbq.QueryIntent).JIRA_ISSUE:
            return 'Jira Issue Card';
        case (0, $zzZbq.QueryIntent).ORG_CHART:
            return 'Org Chart Card';
        case (0, $zzZbq.QueryIntent).NAVIGATIONAL:
            return 'Navigational';
        case (0, $zzZbq.QueryIntent).NAV_CONTENT:
            return 'Nav Card';
        case (0, $zzZbq.QueryIntent).BOOKMARK:
            return 'Bookmark Knowledge Card';
        case (0, $zzZbq.QueryIntent).VISUAL:
            return 'Visual Card';
        case (0, $zzZbq.QueryIntent).NONE:
            return 'None';
        case (0, $zzZbq.QueryIntent).DEFAULT:
            return 'Default';
        case (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY:
        case (0, $zzZbq.QueryIntent).KEYWORD_OR_ACRONYM:
        default:
            return 'Plain Text';
    }
};



var $7DMz5 = parcelRequire("7DMz5");




/* index.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $w6R6I = parcelRequire("w6R6I");








var $eDWBm = parcelRequire("eDWBm");





var $htnqN = parcelRequire("htnqN");

/* reading-aids-container.tsx generated by @compiled/babel-plugin v3.0.1 */ 



var $hekY6 = parcelRequire("hekY6");

const $43c2452d73591196$export$a9f6f8fd5598a12e = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDOLYo _1mT5xdRAKS _0NUa3rWHam _39xV024DOi _0KLXruoI2d _4bt5LAnQyn _2WAcuGLTLW _3oUqlsYbGa _0jfunhYbGa _3cvhttYbGa _0WcmCNGrMT",
            __cmplp.className
        ])
    });
});


/* reading-aids-popup-container.tsx generated by @compiled/babel-plugin v3.0.1 */ 





var $9aYkv = parcelRequire("9aYkv");

const $74af3b3d0be03000$export$f79f209cc21596d = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, continueAnimation: continueAnimation, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1rywqsk": (0, $9aYkv.default)(__cmplp.isLoading || __cmplp.continueAnimation ? 'rotationAnimation linear 3s infinite' : ''),
            "--_8bhvpm": (0, $9aYkv.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            __cmplp.isLoading || __cmplp.continueAnimation ? 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)' : "var(--ds-surface-overlay, #FFFFFF)")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDKTcp _4FKVYEFQfX _2fBhtecplg _2uo31fIuZq _1mT5xdRAKS _2OUyjtGk8v",
            __cmplp.className
        ])
    });
});



var $cuvLu = parcelRequire("cuvLu");







const $e8f4d0b6d7c43b83$export$694ee0cc469a8709 = (isReadingAids, smartAnswersRoute)=>{
    if (isReadingAids) return (0, $zzZbq.AnswerCardType).DEFINITION;
    switch(smartAnswersRoute){
        case (0, $zzZbq.QueryIntent).PERSON:
            return (0, $zzZbq.AnswerCardType).PERSON;
        case (0, $zzZbq.QueryIntent).TEAM:
            return (0, $zzZbq.AnswerCardType).TEAM;
        case (0, $zzZbq.QueryIntent).AGENT:
            return (0, $zzZbq.AnswerCardType).AGENT;
        case (0, $zzZbq.QueryIntent).DATE:
            return (0, $zzZbq.AnswerCardType).DATE;
        case (0, $zzZbq.QueryIntent).LOCATION:
            return (0, $zzZbq.AnswerCardType).LOCATION;
        case (0, $zzZbq.QueryIntent).TOPIC:
            return (0, $zzZbq.AnswerCardType).TOPIC;
        case (0, $zzZbq.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY:
        case (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD:
            return (0, $zzZbq.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY;
        case (0, $zzZbq.QueryIntent).JIRA_ISSUE:
            return (0, $zzZbq.AnswerCardType).JIRA_ISSUE;
        case (0, $zzZbq.QueryIntent).NAV_CONTENT:
            return (0, $zzZbq.AnswerCardType).NAV_CONTENT;
        case (0, $zzZbq.QueryIntent).BOOKMARK:
            return (0, $zzZbq.AnswerCardType).BOOKMARK_KNOWLEDGE_CARD;
        case (0, $zzZbq.QueryIntent).VISUAL:
            return (0, $zzZbq.AnswerCardType).VISUAL;
        case (0, $zzZbq.QueryIntent).ORG_CHART:
            return (0, $zzZbq.AnswerCardType).ORG_CHART;
        case (0, $zzZbq.QueryIntent).NAVIGATIONAL:
            return (0, $zzZbq.AnswerCardType).NAVIGATIONAL;
        case (0, $zzZbq.QueryIntent).NONE:
            return (0, $zzZbq.AnswerCardType).NONE;
        case (0, $zzZbq.QueryIntent).DEFAULT:
            return (0, $zzZbq.AnswerCardType).DEFAULT;
        case (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY:
        case (0, $zzZbq.QueryIntent).KEYWORD_OR_ACRONYM:
        default:
            return (0, $zzZbq.AnswerCardType).SAIN;
    }
};



var $aTjYs = parcelRequire("aTjYs");




const $4e7a34c8df556253$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    error_boundary_fallback_text: {
        id: "search_ai.error_boundary_fallback_text",
        defaultMessage: "Something went wrong. Try refreshing the page or trying again later."
    }
});


const $14367db50208fb8a$var$styles = {
    root: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC",
    readingAids: "_2sNsIg20Hp _0Of8r28HPE _1ZnuxbNHnM _1wydGW8HPE _2Zuz6QNHnM _1UtDYzyXux _1EqgXl8WQH _0NUa3rgZxp _2WAcuGIZbP",
    nonReadingAids: "_2sNsIgmnOE _0Of8r2kG2W _1ZnuxbNHnM _1wydGWkG2W _2Zuz6QNHnM _1UtDYzUktF _0NUa3rpL1x _2WAcuGIZbP _39xV02N91d"
};
const $14367db50208fb8a$export$e926676385687eaf = ({ isReadingAids: isReadingAids, wrapper: wrapper, source: source, cloudId: cloudId, children: children, smartAnswersRoute: smartAnswersRoute })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const answerCardType = (0, $e8f4d0b6d7c43b83$export$694ee0cc469a8709)(!!isReadingAids, smartAnswersRoute);
    const DefaultWrapper = isReadingAids ? (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $74af3b3d0be03000$export$f79f209cc21596d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $43c2452d73591196$export$a9f6f8fd5598a12e), null, props.children)) : (0, $aMSTz.SearchDialog);
    const Wrapper = wrapper ? wrapper : DefaultWrapper;
    const logError = (0, $cozmU.useCallback)((error)=>{
        // Currently we are in between deprecating UFOv1 and adopting react-UFO  for platform packages, so this is a temporary way for us to collect error logs
        // https://atlassian.slack.com/archives/C01AY8132S3/p1716509785878689
        const errorAttributes = {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack?.split('\n').at(1),
            isHello: (0, $aTjYs.isHello)(cloudId),
            answerCardType: answerCardType
        };
        createAnalyticsEvent({
            action: 'failed',
            actionSubject: 'aiAnswerDialog',
            source: source || 'unknown',
            eventType: 'track',
            attributes: errorAttributes
        }).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
        if ((0, $iDrrr.fg)('kd_sain_error_boundary_shown_event')) createAnalyticsEvent({
            action: 'shown',
            actionSubject: 'aiAnswerError',
            source: source || 'unknown',
            eventType: 'track',
            attributes: {
                ...errorAttributes,
                errorState: (0, $htnqN.NLPSearchErrorState).RenderError
            }
        }).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
        (0, $cuvLu.logger).error({
            error: errorAttributes,
            functionName: 'ErrorBoundary: Depricated'
        });
    }, [
        source,
        createAnalyticsEvent,
        cloudId,
        answerCardType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eDWBm.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($14367db50208fb8a$var$styles.root, isReadingAids ? $14367db50208fb8a$var$styles.root : $14367db50208fb8a$var$styles.readingAids)
        }, formatMessage((0, $4e7a34c8df556253$export$defe85febe8b728c).error_boundary_fallback_text))),
        onException: logError
    }, children);
};













var $hpFQM = parcelRequire("hpFQM");


var $7AtIp = parcelRequire("7AtIp");


var $i5c0A = parcelRequire("i5c0A");




// Types for agent data structure
const $a8292cdc307d0451$export$da698a596bf7d462 = 'KnowledgeCardAgentSearchQuery';
const $a8292cdc307d0451$export$1bee71aceca6bc6 = `
query ${$a8292cdc307d0451$export$da698a596bf7d462}($cloudId: String!, $input: AgentStudioAgentQueryInput!, $limit: Int!) {
    agentStudio_getAgents(cloudId: $cloudId, input: $input, first: $limit) 
    @optIn(to: "AgentStudio")
    {
      edges {
        node {
          id
          identityAccountId
          name
          description
          creator {
            canonicalAccountId
            accountId
            accountStatus
            id
            name
          }
          creatorType
          externalConfigReference
          instructions
          conversationStarters
        }
      }
    }
  }`;


const $7af6e4b8739a3031$var$getAgentSearchInput = (query)=>{
    // Extract agent name from query if it's in a specific format
    // For now, use the query as-is, but this could be enhanced to parse specific formats
    return query.trim();
};
const $7af6e4b8739a3031$export$9cab63c7e0de7ad8 = ({ query: query, limit: limit, sourceProduct: sourceProduct, cloudId: cloudId, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    const agentSearchInput = $7af6e4b8739a3031$var$getAgentSearchInput(query);
    return (0, $i5c0A.fetchAggResponse)({
        graphQuery: (0, $a8292cdc307d0451$export$1bee71aceca6bc6),
        variables: {
            cloudId: cloudId,
            input: {
                name: agentSearchInput
            },
            limit: limit
        },
        operationName: (0, $a8292cdc307d0451$export$da698a596bf7d462),
        headers: {
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then((response)=>{
        if (response.errors) throw new Error(`GraphQL errors: ${JSON.stringify(response.errors)}`);
        const edges = response.data?.agentStudio_getAgents?.edges || [];
        const agents = edges.map((edge)=>{
            const agent = edge.node;
            return {
                ...agent,
                // Normalize agent ID by splitting on "/" and taking the last item
                id: agent.id.split('/').pop(),
                // Replace creator object with just the creator ID
                creator: agent.creator?.id,
                creator_type: agent.creatorType,
                identity_account_id: agent.identityAccountId
            };
        });
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(agents),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                ...(0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation') ? {
                    extraAPIAnalyticsAttributes: {
                        requestId: response.gatewayTracingHeaders?.['atl-request-id'] ?? null,
                        traceId: response.gatewayTracingHeaders?.['x-trace-id'] ?? null
                    }
                } : {}
            }
        };
    }).catch((error)=>{
        if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
            error: error,
            functionName: 'fetchAgentCardData'
        });
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    });
};






var $hMCZS = parcelRequire("hMCZS");




















var $1AuMq = parcelRequire("1AuMq");

const $df52b12138df743d$var$MAX_CONTRIBUTORS = 3;
const $df52b12138df743d$export$737fdf482f7ddb38 = (recentWork)=>{
    const uniqRecents = new Set();
    return recentWork.reduce((result, recentWorkItem)=>{
        const containerName = recentWorkItem.containers.length > 0 ? recentWorkItem.containers[0].name : recentWorkItem.object.product;
        // creating a key with the container name and title to
        // prevent the posibilty of multiple items with the same name
        const key = `${containerName}:${recentWorkItem.object.name || ''}`;
        if (uniqRecents.has(key)) return result;
        uniqRecents.add(key);
        const curRecentWorkItem = {
            title: recentWorkItem.object.name || '',
            url: recentWorkItem.object.url,
            containerName: containerName,
            event: recentWorkItem.eventType,
            timestamp: recentWorkItem.timestamp,
            iconUrl: !!recentWorkItem.object.icon ? recentWorkItem.object.icon.value : '',
            contributors: recentWorkItem.contributors.slice(0, 3).map((contributor)=>({
                    name: contributor.name,
                    id: contributor.accountId
                })),
            othersCount: recentWorkItem.contributors.length > $df52b12138df743d$var$MAX_CONTRIBUTORS ? recentWorkItem.contributors.length - $df52b12138df743d$var$MAX_CONTRIBUTORS : 0,
            contentTypeName: recentWorkItem.object.__typename
        };
        return result.concat(curRecentWorkItem);
    }, []);
};
const $df52b12138df743d$export$b8d37f4ee3cee5b6 = ({ locale: locale, zoneInfo: zoneInfo })=>{
    return zoneInfo ? new Date().toLocaleTimeString(locale, {
        timeZone: zoneInfo,
        hour: 'numeric',
        minute: 'numeric'
    }).replace(' ', '').toLowerCase() : undefined;
};
const $df52b12138df743d$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $df52b12138df743d$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $df52b12138df743d$var$getAtlasHost = ()=>{
    const host = window.location.host;
    const isStaging = host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
    return isStaging ? $df52b12138df743d$var$ATLAS_STAGING_URL : $df52b12138df743d$var$ATLAS_PROD_URL;
};
const $df52b12138df743d$var$getAtlasURL = (orgId)=>{
    const atlasHost = $df52b12138df743d$var$getAtlasHost();
    return orgId ? `${atlasHost}/o/${orgId}` : atlasHost;
};
const $df52b12138df743d$export$d00d38d973440568 = (agent, orgId)=>{
    const atlasURL = $df52b12138df743d$var$getAtlasURL(orgId);
    return `${atlasURL}/people/agent/${agent.id}`;
};
const $df52b12138df743d$export$782629dc0d11ee5c = (teamId, orgId)=>{
    const atlasURL = $df52b12138df743d$var$getAtlasURL(orgId);
    return `${atlasURL}/people/team/${teamId}`;
};


const $6b0fc42a17642d56$export$5d21e0d2847bfa41 = 'KnowledgeCardUserSearchQuery';
const $6b0fc42a17642d56$export$15ff3b6f089f4729 = `
query ${$6b0fc42a17642d56$export$5d21e0d2847bfa41}($userQuery: String!, $siteId: String!) {
  knowledgeDiscovery {
   	searchUser (
        userQuery: $userQuery
        siteId: $siteId
    ) @optIn(to: "KnowledgeDiscovery Search User"){
      ... on KnowledgeDiscoveryUsers {
        users {
            name
            id
            avatarUrl
            title
            zoneInfo
            location
        }
      }
      ... on QueryError {
        message
      }
    }
  }
}
`;
const $6b0fc42a17642d56$export$4401a05b6c351189 = 'KnowledgeCardPrimaryUserDataQuery';
const $6b0fc42a17642d56$export$10a5d89b90ea01b3 = `
    query ${$6b0fc42a17642d56$export$4401a05b6c351189}(
        $accountId: String!
        $accountIdARI: ID!
        $tenantId: String!
        $requestingUserId: String!
        $featureServiceModel: String!
        ) {
        user(accountId: $accountIdARI) {
            id
            picture
            name
            accountStatus
            ... on AtlassianAccountUser {
                email
                zoneinfo
                extendedProfile {
                    jobTitle
                    department
                    organization
                    location
                }
            }
        }
        smarts {
            recommendedUser(recommendationsQuery: {
            context: {
                userId: $accountId, tenantId: $tenantId
            },
            modelRequestParams: {
                caller: "search-ai",
                experience: "CgUserNearbyUser"
                featureServiceModel: $featureServiceModel
            },
            requestingUserId: $requestingUserId,
            maxNumberOfResults: 8
            }
            ) {
            id
            user {
                id
                picture
                name
                accountStatus
                ... on AtlassianAccountUser {
                email
                extendedProfile {
                    jobTitle
                    department
                }
                }
            }
            }
        }
    }
`;


const $634e333e90210143$export$b40bb50f32e7d452 = ({ personQuery: personQuery, tenantId: tenantId, sourceProduct: sourceProduct, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    const siteARI = sourceProduct ? `ari:cloud:${sourceProduct}::site/${tenantId}` : '';
    return (0, $i5c0A.fetchAggResponse)({
        graphQuery: (0, $6b0fc42a17642d56$export$15ff3b6f089f4729),
        variables: {
            userQuery: personQuery,
            siteId: siteARI
        },
        operationName: (0, $6b0fc42a17642d56$export$5d21e0d2847bfa41),
        headers: {
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: tenantId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors })=>{
        const users = data?.knowledgeDiscovery?.searchUser?.users || [];
        const message = data?.knowledgeDiscovery?.searchUser?.message;
        if (errors || message) throw new Error(JSON.stringify({
            errors: errors,
            message: message
        }));
        const mappedResults = users.map((user)=>({
                id: user.id,
                name: user.name,
                avatarUrl: user.avatarUrl || '',
                title: user.title || '',
                zoneInfo: user.zoneInfo || '',
                location: user.location || ''
            }));
        const finalResult = {
            user_metadata_only_cards: mappedResults
        };
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(finalResult),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON
            }
        };
    }).catch((error)=>{
        if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
            error: error,
            functionName: 'fetchPersonKnowledgeCardDataWithPostFiltering'
        });
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    });
};
const $634e333e90210143$export$3b2275a59c992e87 = async ({ personQuery: personQuery, tenantId: tenantId, sourceProduct: sourceProduct, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    const siteARI = sourceProduct ? `ari:cloud:${sourceProduct}::site/${tenantId}` : '';
    return (0, $i5c0A.fetchAggResponse)({
        graphQuery: (0, $6b0fc42a17642d56$export$15ff3b6f089f4729),
        variables: {
            userQuery: personQuery,
            siteId: siteARI
        },
        operationName: (0, $6b0fc42a17642d56$export$5d21e0d2847bfa41),
        headers: {
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: tenantId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors, gatewayTracingHeaders: gatewayTracingHeaders })=>{
        const users = data?.knowledgeDiscovery?.searchUser?.users || [];
        const message = data?.knowledgeDiscovery?.searchUser?.message;
        if (errors || message) throw new Error(JSON.stringify({
            errors: errors,
            message: message
        }));
        const mappedResults = users.map((user)=>({
                id: user.id,
                name: user.name,
                avatarUrl: user.avatarUrl || '',
                title: user.title || '',
                zoneInfo: user.zoneInfo || '',
                location: user.location || ''
            }));
        const finalResult = {
            user_metadata_only_cards: mappedResults
        };
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(finalResult),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                extraAPIAnalyticsAttributes: {
                    requestId: gatewayTracingHeaders?.['atl-request-id'] ?? null,
                    traceId: gatewayTracingHeaders?.['x-trace-id'] ?? null
                }
            }
        };
    }).catch((error)=>{
        if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
            error: error,
            functionName: 'fetchPersonKnowledgeCardDataWithPostFiltering'
        });
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    });
};
const $634e333e90210143$export$3e632a26e137d79e = ({ accountId: accountId, tenantId: tenantId, requestingUserId: requestingUserId, activityClient: activityClient, locale: locale, workspaceId: workspaceId, product: product, traceHeaders: traceHeaders })=>{
    const featureServiceModel = (0, $7DMz5.SAINFeatureControl).getCollabGraphExperimentModel();
    const aggPromise = (0, $i5c0A.fetchAggResponse)({
        graphQuery: (0, $6b0fc42a17642d56$export$10a5d89b90ea01b3),
        variables: {
            accountId: accountId,
            accountIdARI: `ari:cloud:identity::user/${accountId}`,
            tenantId: tenantId,
            requestingUserId: requestingUserId,
            featureServiceModel: featureServiceModel
        },
        operationName: (0, $6b0fc42a17642d56$export$4401a05b6c351189),
        headers: {
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: tenantId,
                product: product ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    });
    const activityPromise = activityClient.fetchActivities([
        100
    ], {
        limit: 50,
        actors: [
            `ari:cloud:identity::user/${accountId}`
        ]
    }, [
        'workedOn'
    ], false);
    const toUserProfile = (toAccountId)=>(0, $hMCZS.navigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: toAccountId
            },
            cloudId: tenantId
        }).href;
    // Handle the primary user data first, then attempt to fetch activity data
    return Promise.allSettled([
        aggPromise,
        activityPromise
    ]).then((results)=>{
        const [aggResult, activityResult] = results;
        // Handle GraphQL call failure
        if (aggResult.status === 'rejected') throw new Error('Failed to fetch user data');
        const aggResponse = aggResult.value;
        // Create the base user data structure
        const primaryUserData = {
            account_id: accountId,
            name: aggResponse.data?.user.name || '',
            job_title: aggResponse.data?.user.extendedProfile?.jobTitle,
            profile_url: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? toUserProfile(accountId) : `/people/${accountId}`,
            avatar_url: aggResponse.data?.user.picture,
            email: aggResponse.data?.user.email,
            location: aggResponse.data?.user.extendedProfile?.location,
            department: aggResponse.data?.user.extendedProfile?.department,
            organization: aggResponse.data?.user.extendedProfile?.organization,
            time: aggResponse.data?.user.zoneinfo ? (0, $df52b12138df743d$export$b8d37f4ee3cee5b6)({
                locale: locale,
                zoneInfo: aggResponse.data.user.zoneinfo
            }) : undefined,
            collaborators: aggResponse.data?.smarts.recommendedUser.reduce((acc, node)=>{
                if ((0, $1AuMq.trimARI)(node.user.id) !== accountId) acc.push({
                    name: node.user.name,
                    picture: node.user.picture,
                    title: !!node.user.extendedProfile?.jobTitle ? node.user.extendedProfile.jobTitle : null,
                    url: !!node.user.id ? (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? toUserProfile((0, $1AuMq.trimARI)(node.user.id)) : `/people/${(0, $1AuMq.trimARI)(node.user.id)}` : null,
                    accountId: node.user.id,
                    department: !!node.user.extendedProfile?.department ? node.user.extendedProfile.department : null,
                    email: !!node.user.email ? node.user.email : null
                });
                return acc;
            }, []),
            viewAllLink: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? toUserProfile(accountId) : `/people/${accountId}`,
            recentActivity: []
        };
        // Add activity data if the call succeeded
        if (activityResult.status === 'fulfilled' && activityResult.value.workedOn && activityResult.value.workedOn.length > 0) primaryUserData.recentActivity = (0, $df52b12138df743d$export$737fdf482f7ddb38)(activityResult.value.workedOn);
        return primaryUserData;
    });
};
























const $cd3be417d12ec829$export$330a89c6d5120b7c = 'KnowledgeCardTeamSearchQuery';
const $cd3be417d12ec829$export$f20269ab1c2af3aa = `
query ${$cd3be417d12ec829$export$330a89c6d5120b7c}($teamQuery: String!, $orgId: String!, $siteId: String!) {
  knowledgeDiscovery {
   	searchTeam (
        teamName: $teamQuery
        orgId: $orgId
        siteId: $siteId
    ) @optIn(to: "KnowledgeDiscovery Search Team"){
      ... on KnowledgeDiscoveryTeam {
        id
      }
      ... on QueryError {
        message
      }
    }
  }
}
`;
const $cd3be417d12ec829$export$1cc3d8f1a53775f = 'KnowledgeCardTeamDataQuery';
const $cd3be417d12ec829$export$b98556be52d17f2f = `
query ${$cd3be417d12ec829$export$1cc3d8f1a53775f}($teamId: ID!, $siteId: String!) {
    team {
      teamV2 (
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        id
        displayName
        smallAvatarImageUrl
        members {
          nodes {
            member {
              id
              accountId
              name
              picture
              ... on AtlassianAccountUser {
                email
                extendedProfile {
                  jobTitle
                  department
                }
              }
            }
            state
          }
        }
      }
    }
  }
`;


const $2bf628be7eb8a184$export$588cacdc66ef53ad = {
    team_metadata: {
        id: '',
        name: '',
        avatarUrl: null,
        url: null,
        memberCount: 0,
        members: [],
        recentActivity: []
    }
};


const $5440ea745c72f677$var$NO_TEAM_MESSAGE = 'NO_TEAM';
const $5440ea745c72f677$export$1d3fe260188fa7d9 = ({ activityClient: activityClient, teamQuery: teamQuery, orgId: orgId, siteId: siteId, sourceProduct: sourceProduct, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    let teamResult;
    let teamData;
    let activityResult;
    const siteARI = sourceProduct ? `ari:cloud:${sourceProduct}::site/${siteId}` : '';
    const toTeam = (teamId)=>(0, $hMCZS.navigateToTeamsApp)({
            type: 'TEAM',
            payload: {
                teamId: teamId
            },
            cloudId: siteId,
            orgId: orgId
        }).href;
    let actors = [];
    return (0, $i5c0A.fetchAggResponse)({
        graphQuery: (0, $cd3be417d12ec829$export$f20269ab1c2af3aa),
        variables: {
            teamQuery: teamQuery,
            orgId: orgId,
            siteId: siteARI
        },
        operationName: (0, $cd3be417d12ec829$export$330a89c6d5120b7c),
        headers: {
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: siteId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors })=>{
        const id = data?.knowledgeDiscovery.searchTeam?.id;
        if (!errors && id) teamResult = id;
        else throw new Error($5440ea745c72f677$var$NO_TEAM_MESSAGE);
        return (0, $i5c0A.fetchAggResponse)({
            graphQuery: (0, $cd3be417d12ec829$export$b98556be52d17f2f),
            variables: {
                teamId: teamResult,
                siteId: siteId
            },
            operationName: (0, $cd3be417d12ec829$export$1cc3d8f1a53775f),
            headers: {
                ...(0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: siteId,
                    product: sourceProduct ?? ''
                }),
                ...traceHeaders ?? undefined
            }
        });
    }).then(({ data: data, errors: errors })=>{
        if (!errors && data?.team.teamV2?.id) teamData = data;
        else throw new Error($5440ea745c72f677$var$NO_TEAM_MESSAGE);
        actors = teamData.team.teamV2?.members?.nodes?.map((node)=>node.member ? node.member.id : '').filter((member)=>!!member) || [];
        return activityClient.fetchActivities([
            100
        ], {
            limit: 100,
            actors: actors,
            rootContainerIds: [
                `ari:cloud:platform::site/${siteId}`
            ]
        }, [
            'workedOn'
        ], false);
    }).then((data)=>{
        if (data.workedOn && data.workedOn.length > 0) activityResult = data.workedOn;
        const filteredActivityResult = $5440ea745c72f677$export$bd0b250fe24a4365(activityResult || [], actors);
        const finalResult = {
            team_metadata: {
                id: teamData?.team.teamV2?.id || '',
                name: teamData?.team.teamV2?.displayName || '',
                avatarUrl: teamData?.team.teamV2?.smallAvatarImageUrl || null,
                url: teamData?.team.teamV2?.id ? (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? toTeam(teamData?.team.teamV2?.id) : `/people/team/${(0, $1AuMq.trimARI)(teamData?.team.teamV2?.id)}` : null,
                memberCount: teamData?.team.teamV2?.members.nodes.length || 0,
                members: teamData?.team.teamV2?.members?.nodes ? $5440ea745c72f677$var$sanitizeAndMapTeamMembers(teamData.team.teamV2.members.nodes) : [],
                recentActivity: filteredActivityResult ? (0, $df52b12138df743d$export$737fdf482f7ddb38)(filteredActivityResult) : []
            }
        };
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(finalResult),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON
            }
        };
    }).catch((error)=>{
        if (error instanceof Object && 'message' in error && error.message === $5440ea745c72f677$var$NO_TEAM_MESSAGE) return {
            nlpSearch: {
                nlpResult: JSON.stringify((0, $2bf628be7eb8a184$export$588cacdc66ef53ad)),
                errorState: null,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        };
        if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
            error: error,
            functionName: 'fetchTeamKnowledgeCardDataWithRanking'
        });
        return Promise.reject(error);
    });
};
const $5440ea745c72f677$export$b9b0423f67d54dce = async ({ activityClient: activityClient, teamQuery: teamQuery, orgId: orgId, siteId: siteId, sourceProduct: sourceProduct, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    const siteARI = sourceProduct ? `ari:cloud:${sourceProduct}::site/${siteId}` : '';
    const toTeam = (teamId)=>(0, $hMCZS.navigateToTeamsApp)({
            type: 'TEAM',
            payload: {
                teamId: teamId
            },
            cloudId: siteId,
            orgId: orgId
        }).href;
    return (0, $i5c0A.fetchAggResponse)({
        graphQuery: (0, $cd3be417d12ec829$export$f20269ab1c2af3aa),
        variables: {
            teamQuery: teamQuery,
            orgId: orgId,
            siteId: siteARI
        },
        operationName: (0, $cd3be417d12ec829$export$330a89c6d5120b7c),
        headers: {
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: siteId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors })=>{
        const id = data?.knowledgeDiscovery.searchTeam?.id;
        if (errors || !id) throw new Error($5440ea745c72f677$var$NO_TEAM_MESSAGE);
        return (0, $i5c0A.fetchAggResponse)({
            graphQuery: (0, $cd3be417d12ec829$export$b98556be52d17f2f),
            variables: {
                teamId: id,
                siteId: siteId
            },
            operationName: (0, $cd3be417d12ec829$export$1cc3d8f1a53775f),
            headers: {
                ...(0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: siteId,
                    product: sourceProduct ?? ''
                }),
                ...traceHeaders ?? undefined
            }
        });
    }).then(async ({ data: data, errors: errors, extensions: extensions, gatewayTracingHeaders: gatewayTracingHeaders })=>{
        if (errors || !data?.team.teamV2?.id) throw new Error($5440ea745c72f677$var$NO_TEAM_MESSAGE);
        const actors = data.team.teamV2?.members?.nodes?.map((node)=>node.member ? node.member.id : '').filter((member)=>!!member) || [];
        const activityData = await activityClient.fetchActivities([
            100
        ], {
            limit: 100,
            actors: actors,
            rootContainerIds: [
                `ari:cloud:platform::site/${siteId}`
            ]
        }, [
            'workedOn'
        ], false);
        return {
            activityData: activityData,
            actors: actors,
            extensions: extensions,
            gatewayTracingHeaders: gatewayTracingHeaders,
            teamData: data
        };
    }).then(({ activityData: activityData, actors: actors, gatewayTracingHeaders: gatewayTracingHeaders, teamData: teamData })=>{
        let activityResult = [];
        if (activityData.workedOn && activityData.workedOn.length > 0) activityResult = activityData.workedOn;
        const filteredActivityResult = $5440ea745c72f677$export$bd0b250fe24a4365(activityResult, actors);
        const finalResult = {
            team_metadata: {
                id: teamData?.team.teamV2?.id || '',
                name: teamData?.team.teamV2?.displayName || '',
                avatarUrl: teamData?.team.teamV2?.smallAvatarImageUrl || null,
                url: teamData?.team.teamV2?.id ? (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? toTeam(teamData?.team.teamV2?.id) : `/people/team/${(0, $1AuMq.trimARI)(teamData?.team.teamV2?.id)}` : null,
                memberCount: teamData?.team.teamV2?.members.nodes.length || 0,
                members: teamData?.team.teamV2?.members?.nodes ? $5440ea745c72f677$var$sanitizeAndMapTeamMembers(teamData.team.teamV2.members.nodes) : [],
                recentActivity: filteredActivityResult ? (0, $df52b12138df743d$export$737fdf482f7ddb38)(filteredActivityResult) : []
            }
        };
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(finalResult),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                extraAPIAnalyticsAttributes: {
                    requestId: gatewayTracingHeaders?.['atl-request-id'] ?? null,
                    traceId: gatewayTracingHeaders?.['x-trace-id'] ?? null
                }
            }
        };
    }).catch((error)=>{
        if (error instanceof Object && 'message' in error && error.message === $5440ea745c72f677$var$NO_TEAM_MESSAGE) return {
            nlpSearch: {
                nlpResult: JSON.stringify((0, $2bf628be7eb8a184$export$588cacdc66ef53ad)),
                errorState: null,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        };
        if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
            error: error,
            functionName: 'fetchTeamKnowledgeCardDataWithRanking'
        });
        return Promise.reject(error);
    });
};
const $5440ea745c72f677$var$sanitizeAndMapTeamMembers = (members)=>{
    return members.reduce(function(result, memberNode) {
        if (!!memberNode.member) return result.concat({
            name: memberNode.member.name || '',
            picture: memberNode.member.picture || null,
            title: memberNode.member.extendedProfile?.jobTitle || null,
            url: !!memberNode.member.id ? `/people/${(0, $1AuMq.trimARI)(memberNode.member.id)}` : null,
            accountId: !!memberNode.member.id ? (0, $1AuMq.trimARI)(memberNode.member.id) : null,
            department: memberNode.member.extendedProfile?.department || null,
            email: memberNode.member.email || null
        });
        return result;
    }, []);
};
const $5440ea745c72f677$var$excludedEventTypes = [
    'commented',
    'updated'
];
const $5440ea745c72f677$export$bd0b250fe24a4365 = (activityResult, members)=>{
    const teamMemberSet = new Set(members);
    return activityResult.reduce((filtered, activity)=>{
        const involvedTeamMembers = activity.contributors.filter((contributor)=>teamMemberSet.has(`ari:cloud:identity::user/${contributor.accountId}`));
        if (involvedTeamMembers.length >= 1 && !$5440ea745c72f677$var$excludedEventTypes.includes(activity.eventType)) filtered.push({
            ...activity,
            contributors: involvedTeamMembers
        });
        return filtered;
    }, []);
};




















const $9386e59ea9a4ea77$export$f928298386dd496b = 'KnowledgeDiscoveryPlatformTopicByIdQuery';
const $9386e59ea9a4ea77$export$9c5339bca50e4652 = `
	query ${$9386e59ea9a4ea77$export$f928298386dd496b}($cloudId: String!, $topicId: String!, $userCount: Int!) {
		knowledgeDiscovery {
			topic(cloudId: $cloudId, id: $topicId) {
				...on KnowledgeDiscoveryTopic {
					id
					name
					description
				}
				...on QueryError {
					message
				}
			}
			users: relatedEntities(
				cloudId: $cloudId
				entityId: $topicId
				entityType: TOPIC
				relatedEntityType: USER
				first: $userCount
			) @optIn(to: "KnowledgeDiscovery Get Related Entities") {
				...on KnowledgeDiscoveryRelatedEntityConnection {
					nodes {
						...on KnowledgeDiscoveryUser {
							user {
								id
								name
								picture
								accountId
								accountStatus
								...on AtlassianAccountUser {
									extendedProfile {
										jobTitle
									}
								}
							}
						}
					}
				}
				...on QueryError {
					message
				}
			}
		}
	}
`;


const $f015000a0fe91d29$var$getTopicId = (topicIds)=>{
    const list = JSON.parse(topicIds);
    if (Array.isArray(list) && list.length) return list[0];
    return '';
};
const $f015000a0fe91d29$var$NO_TOPIC_FOUND_MESSAGE = 'No topic found for id:';
const $f015000a0fe91d29$export$d25837238feb3ab6 = ({ cloudId: cloudId, query: query, workspaceId: workspaceId, sourceProduct: sourceProduct, traceHeaders: traceHeaders })=>{
    const userCount = 5;
    // transformedQuery from intent detection passed as query prop to SearchAIDialog from SearchPage
    // transformedQuery is a str e.g. "["f6aac8a1-7907-4fb0-88ca-d7a564b45db3"]" and need to extract id
    const topicId = $f015000a0fe91d29$var$getTopicId(query);
    return (0, $i5c0A.fetchAggResponse)({
        graphQuery: (0, $9386e59ea9a4ea77$export$9c5339bca50e4652),
        variables: {
            cloudId: cloudId,
            topicId: topicId,
            userCount: userCount
        },
        operationName: (0, $9386e59ea9a4ea77$export$f928298386dd496b),
        headers: {
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors })=>{
        const message = data?.knowledgeDiscovery.topic.message;
        // if message includes no topic found, we move forward to rendering card
        // in no topic found state (right now is nothing similar to People/Team card)
        if (errors || message && !message.includes($f015000a0fe91d29$var$NO_TOPIC_FOUND_MESSAGE)) throw new Error(JSON.stringify({
            errors: errors,
            message: message
        }));
        const topicUserData = data?.knowledgeDiscovery || {};
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(topicUserData),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON
            }
        };
    }).catch((error)=>{
        if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
            error: error,
            functionName: 'fetchTopicCardData'
        });
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    });
};






var $70CUF = parcelRequire("70CUF");


var $3hVWe = parcelRequire("3hVWe");







/* JiraNlToJqlCard.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $I7hWB = parcelRequire("I7hWB");


var $c2Doe = parcelRequire("c2Doe");











var $b3ffN = parcelRequire("b3ffN");




const $d6ee00d3c7ff7f25$export$10fed66da45c02f6 = ({ searchSessionId: searchSessionId, queryHash: queryHash, brand: brand, source: source, query: query, loadTime: loadTime, success: success, answerCardType: answerCardType, answerString: answerString, endState: endState, jiraNlToJqlCardVariant: jiraNlToJqlCardVariant, nlToJqlLoadTime: nlToJqlLoadTime, issueSearchLoadTime: issueSearchLoadTime, phaseTimingSource: phaseTimingSource })=>{
    return {
        action: 'loaded',
        actionSubject: 'aiAnswerJiraNlToJqlCard',
        source: source,
        eventType: 'track',
        attributes: {
            searchSessionId: searchSessionId,
            queryHash: queryHash,
            brand: brand,
            source: source,
            loadTime: loadTime,
            success: success,
            answerCardType: answerCardType,
            endState: endState,
            jiraNlToJqlCardVariant: jiraNlToJqlCardVariant,
            nlToJqlLoadTime: nlToJqlLoadTime,
            issueSearchLoadTime: issueSearchLoadTime,
            phaseTimingSource: phaseTimingSource
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};


const $fce67a5f4fe3c54f$export$447238500b8bc926 = ({ searchSessionId: searchSessionId, queryHash: queryHash, brand: brand, source: source, query: query, answerCardType: answerCardType, answerString: answerString })=>{
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerJiraCardViewAll',
        source: source,
        eventType: 'ui',
        attributes: {
            searchSessionId: searchSessionId,
            queryHash: queryHash,
            brand: brand,
            source: source,
            answerCardType: answerCardType
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};



var $aYqz2 = parcelRequire("aYqz2");


var $uY2pq = parcelRequire("uY2pq");








var $8tNXq = parcelRequire("8tNXq");











var $9oghv = parcelRequire("9oghv");


var $kpjET = parcelRequire("kpjET");


var $aiIBH = parcelRequire("aiIBH");













const $04e88a3273a73ea1$export$d77346a16f68afc1 = `
query IssueSearchStable($cloudId: ID!, $first: Int, $issueSearchInput: JiraIssueSearchInput!) {
  jira {
    issueSearchStable(
      cloudId: $cloudId
      first: $first
      issueSearchInput: $issueSearchInput
    ) {
      totalIssueSearchResultCount
      totalCount
      edges {
        node {
          key
          webUrl
          summary
          issueTypeField {
            issueType {
              name
              avatar {
                xsmall
                small
                medium
                large
              }
            }
          }
          status {
            name
            statusCategory {
              name
              colorName
              statusCategoryId
            }
          }
          assigneeField {
            user {
              picture
              name
              accountId
            }
          }
          priorityField {
            priority {
              name
              iconUrl
              color
            }
          }
        }
      }
    }
  }
}
`;


const $b2c833a5b9632464$var$MAIN_ISSUE_SEARCH_QUERY_OPERATION_NAME = 'IssueSearchStable';
const $b2c833a5b9632464$var$fetchIssueSearchQuery = async ({ variables: variables, workspaceId: workspaceId, product: product })=>{
    return (0, $i5c0A.fetchAggResponse)({
        variables: variables,
        graphQuery: (0, $04e88a3273a73ea1$export$d77346a16f68afc1),
        operationName: $b2c833a5b9632464$var$MAIN_ISSUE_SEARCH_QUERY_OPERATION_NAME,
        headers: {
            'X-ExperimentalApi': 'JiraIssueSearch',
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: variables.cloudId,
                product: product
            })
        }
    }).then((response)=>{
        return {
            data: response.data,
            extensions: response.extensions
        };
    }).catch((error)=>{
        (0, $cuvLu.logger).error({
            error: error,
            functionName: 'useIssueSearchQuery'
        });
        // rethrow error to be handled by the caller
        throw error;
    });
};
const $b2c833a5b9632464$export$11659072884978f5 = ({ cloudId: cloudId, jql: jql, workspaceId: workspaceId, product: product })=>{
    const [loading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(false);
    const [issues, setIssues] = (0, $cozmU.useState)();
    const [totalIssuesCount, setTotalIssuesCount] = (0, $cozmU.useState)();
    const [extensions, setExtensions] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                setIsLoading(true);
                const { data: data, extensions: extensions } = await $b2c833a5b9632464$var$fetchIssueSearchQuery({
                    variables: {
                        cloudId: cloudId,
                        first: 5,
                        issueSearchInput: {
                            jql: jql || ''
                        }
                    },
                    workspaceId: workspaceId,
                    product: product
                });
                if (data?.errors?.length) {
                    setError(true);
                    throw new Error(data.errors[0].message || 'Unknown error');
                }
                setIssues(data?.jira?.issueSearchStable?.edges || []);
                setTotalIssuesCount(data?.jira?.issueSearchStable?.totalIssueSearchResultCount);
                setExtensions(extensions);
            } catch (e) {
                (0, $cuvLu.logger).error({
                    error: e,
                    functionName: 'useIssueNavigatorQuery'
                });
                setError(true);
            } finally{
                setIsLoading(false);
            }
        };
        if (Boolean(jql)) fetchData();
    }, [
        cloudId,
        jql,
        workspaceId,
        product
    ]);
    return {
        issues: issues,
        extensions: extensions,
        totalIssuesCount: totalIssuesCount,
        loading: loading,
        error: error
    };
};












var $gABt9 = parcelRequire("gABt9");


var $jarkA = parcelRequire("jarkA");

async function $e0e4b115d41f7a74$export$180c897189be2f25({ variables: variables, operationName: operationName, aggUrl: url, headers: headers, cache: cache }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName,
                // `operation` is added alongside `q` so UFO's Jira resource-timing
                // `sanitiseEndpoints` keys this fetch by its operation name instead
                // of collapsing it into the anonymous `gateway_api_graphql` bucket.
                ...(0, $iDrrr.fg)('kd_fe_ufo_named_agg_resources') && {
                    operation: operationName
                }
            }
        }
    };
    // if there's a ttl use fetch with in-mem cacheing
    if (cache && (0, $iDrrr.fg)('kd_fe_enable_agg_cache')) return $e0e4b115d41f7a74$var$fetchPersistedAggResponseWithCache({
        cache: cache,
        aggUrl: url,
        options: options
    });
    return (0, $gABt9.utils).requestService({
        url: url
    }, options);
}
async function $e0e4b115d41f7a74$var$fetchPersistedAggResponseWithCache({ aggUrl: url, cache: cache, options: options }) {
    let cachedResponse = (0, $jarkA.InMemCache).getData(cache.key);
    if (cachedResponse && (0, $jarkA.InMemCache).isValid(cache.key)) return Promise.resolve(cachedResponse);
    // return a pending promise that was cached earlier
    const inflightRequest = (0, $jarkA.InMemCache).getInflightRequest(cache.key);
    if (inflightRequest) return inflightRequest;
    // cache miss, fetch data from agg and store ref to promise
    const request = new Promise(async (resolve, reject)=>{
        try {
            const response = await (0, $gABt9.utils).requestService({
                url: url
            }, options);
            (0, $jarkA.InMemCache).setData({
                key: cache.key,
                response: response,
                ttl: cache.ttl
            });
            resolve(response);
        } catch (error) {
            reject(error);
        } finally{
            (0, $jarkA.InMemCache).removeInflightRequest(cache.key);
        }
    });
    (0, $jarkA.InMemCache).setInflightRequest({
        key: cache.key,
        request: request
    });
    return request;
}





const $2cca25495c5a9447$var$OPERATION_NAME = 'useNaturalLanguageToJqlQuery';
const $2cca25495c5a9447$var$fetchNaturalLanguageToJqlQuery = async ({ variables: variables, workspaceId: workspaceId, product: product })=>{
    return (0, $e0e4b115d41f7a74$export$180c897189be2f25)({
        variables: variables,
        operationName: $2cca25495c5a9447$var$OPERATION_NAME,
        aggUrl: '/gateway/api/graphql/slow/pq/0d32e3740e78f81c3620f117dc1c654e0d259815cecf53bfdaf62665b57d126b',
        headers: {
            'X-ExperimentalApi': 'JiraIssueSearch',
            'x-atlassian-capability': 'NIN_NEW_ISSUE_NAVIGATOR--other',
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: variables.cloudId,
                product: product
            })
        },
        cache: {
            key: `${$2cca25495c5a9447$var$OPERATION_NAME}.${variables.naturalLanguageInput}`,
            ttl: 300000
        }
    }).then((response)=>response.data);
};
const $2cca25495c5a9447$export$eca952b1040f8ff3 = ({ cloudId: cloudId, query: query, workspaceId: workspaceId, product: product, enabled: enabled = true })=>{
    const [loading, setIsLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(false);
    const [jql, setJql] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) {
            setIsLoading(false);
            setError(false);
            setJql(undefined);
            return;
        }
        const fetchData = async ()=>{
            try {
                setIsLoading(true);
                const data = await $2cca25495c5a9447$var$fetchNaturalLanguageToJqlQuery({
                    variables: {
                        cloudId: cloudId,
                        naturalLanguageInput: query,
                        iteration: 'ITERATION_2',
                        project: null
                    },
                    workspaceId: workspaceId,
                    product: product
                });
                const generatedJQL = data?.jira?.naturalLanguageToJql?.generatedJQL || undefined;
                if (data?.jira?.naturalLanguageToJql?.generatedJQLError) {
                    setError(true);
                    throw new Error(data.jira.naturalLanguageToJql.generatedJQLError.message);
                }
                if (data?.errors?.length) {
                    setError(true);
                    throw new Error(data.errors[0].message || 'Unknown error');
                }
                // catch all
                if (!Boolean(generatedJQL)) {
                    setError(true);
                    throw new Error('No JQL generated');
                }
                setJql(generatedJQL);
            } catch (e) {
                (0, $cuvLu.logger).error({
                    error: e,
                    functionName: 'useNaturalLanguageToJqlQuery'
                });
                setError(true);
            } finally{
                setIsLoading(false);
            }
        };
        if (!!cloudId) fetchData();
    }, [
        enabled,
        cloudId,
        query,
        product,
        workspaceId
    ]);
    return {
        jql: jql,
        loading: loading,
        error: error
    };
};





const $76b1398b70af7db1$export$4ab7a1642c5a2b25 = (rawQuery)=>{
    const trimmed = rawQuery.trim();
    if (trimmed.length === 0) return null;
    // Escape backslashes first so the subsequent escapes don't get re-escaped,
    // then escape double quotes because they delimit the JQL string.
    const escapedBase = trimmed.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    if (!(0, $iDrrr.fg)('kd_sain_jira_card_keyword_jql_escaping')) {
        // Legacy behaviour: also escape the JQL wildcards `*` and `?` so user
        // input is matched literally, and always append the trailing `*`.
        const escapedLegacy = escapedBase.replace(/\*/g, '\\*').replace(/\?/g, '\\?');
        return `textfields ~ "${escapedLegacy}*"`;
    }
    // Wildcards are intentionally left alone so the user's `*` and `?` behave as
    // they typed them.
    //
    // The suffix check runs against the trimmed input rather than the escaped
    // output so a real trailing quote is detected instead of the escaped `\"`.
    const endsWithWildcardOrQuote = /["*?]$/.test(trimmed);
    const suffix = endsWithWildcardOrQuote ? '' : '*';
    return `textfields ~ "${escapedBase}${suffix}"`;
};


/* ErrorCard.tsx generated by @compiled/babel-plugin v3.0.1 */ 






var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");







var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $j9bgP = parcelRequire("j9bgP");




const $6ee04b9bd73a1654$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    headerWork: {
        id: "search_ai.jira_nl_to_jql_card.table_header.work",
        defaultMessage: "Work"
    },
    headerStatus: {
        id: "search_ai.jira_nl_to_jql_card.table_header.status",
        defaultMessage: "Status"
    },
    headerAssignee: {
        id: "search_ai.jira_nl_to_jql_card.table_header.assignee",
        defaultMessage: "Assignee"
    },
    headerPriority: {
        id: "search_ai.jira_nl_to_jql_card.table_header.priority",
        defaultMessage: "Priority"
    },
    cardTitle: {
        id: "search_ai.jira_nl_to_jql_card.card.title",
        defaultMessage: "Top Jira work items"
    },
    smartlinkCardTitle: {
        id: "search_ai.jira_nl_to_jql_smartlink_card.card.title",
        defaultMessage: "Answer"
    },
    errorMessage: {
        id: "search_ai.jira_nl_to_jql_card.error",
        defaultMessage: "Rovo couldn't generate an answer for \"{title}\". Try rephrasing your query."
    },
    errorMessageWithViewAll: {
        id: "search_ai.jira_nl_to_jql_error_card.error_with_view_all",
        defaultMessage: "Rovo couldn't generate an answer for \"{query}\". Try rephrasing your query or navigate to Jira work items to reformulate your query."
    },
    noResultsMessage: {
        id: "search_ai.jira_nl_to_jql_card.no_results",
        defaultMessage: "No results found"
    },
    unassigned: {
        id: "search_ai.jira_nl_to_jql_card.unassigned",
        defaultMessage: "Unassigned"
    },
    viewAll: {
        id: "search_ai.jira_nl_to_jql_card.viewall",
        defaultMessage: "{totalCount, plural, one {View {totalCount, number} work item} other {View all {totalCount, number} work items}}"
    },
    viewAllNoCount: {
        id: "search_ai.jira_nl_to_jql_card.viewall_no_count",
        defaultMessage: "View all work items"
    },
    close: {
        id: "search_ai.jira_nl_to_jql_card.close",
        defaultMessage: "Close"
    },
    expand: {
        id: "search_ai.jira_nl_to_jql_card.expand",
        defaultMessage: "Expand table"
    },
    collapse: {
        id: "search_ai.jira_nl_to_jql_card.collapse",
        defaultMessage: "Collapse table"
    },
    dismiss: {
        id: "search_ai.jira_nl_to_jql_card.dismiss",
        defaultMessage: "Dismiss"
    },
    hide: {
        id: "search_ai.jira_nl_to_jql_card.hide",
        defaultMessage: "Hide table"
    },
    unhide: {
        id: "search_ai.jira_nl_to_jql_card.unhide",
        defaultMessage: "Show table"
    }
});


const $c7397925ebe4947f$var$styles = {
    container: "_0bjKvDKxmn _30huDKOeNX _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    onlineDebuggerButtonContainer: "_2XsHFMIZbP _39xV02E6Kk"
};
const $c7397925ebe4947f$export$a2c93507c97cd090 = ({ query: query })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(true);
    const showOnlineDebuggerButton = (0, $iDrrr.fg)('kd_sain_online_debugger');
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, isOpen ? /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $c7397925ebe4947f$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "bold"
    }, formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).errorMessage, {
        title: query
    })), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).close),
        onClick: ()=>setIsOpen(false)
    })), showOnlineDebuggerButton && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $c7397925ebe4947f$var$styles.onlineDebuggerButtonContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $j9bgP.OnlineDebuggerButton), null))) : null);
};


/* IssueTable.tsx generated by @compiled/babel-plugin v3.0.1 */ 













/* IssueKeyNode.tsx generated by @compiled/babel-plugin v3.0.1 */ 






var $7vK9E = parcelRequire("7vK9E");




var $1YHM8 = parcelRequire("1YHM8");

const $a682b9c97392c96a$export$ea403d9edffb26a2 = ({ searchSessionId: searchSessionId, queryHash: queryHash, brand: brand, source: source, query: query, issuekey: issuekey, answerCardType: answerCardType, answerString: answerString, isAuxClick: isAuxClick, isContextMenu: isContextMenu })=>{
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerJiraCardWorkItemLink',
        source: source,
        eventType: 'ui',
        attributes: {
            searchSessionId: searchSessionId,
            queryHash: queryHash,
            brand: brand,
            source: source,
            answerCardType: answerCardType,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        },
        nonPrivacySafeAttributes: {
            answerString: answerString,
            query: query,
            issuekey: issuekey
        }
    };
};












var $jtIlq = parcelRequire("jtIlq");

const $1eaffb3e826a5326$var$styles = {
    noWrap: "_1ANEUSLRg7"
};
const $1eaffb3e826a5326$export$227b36be34e771c5 = ({ issuekey: issuekey, url: url, analyticsAttributes: analyticsAttributes, fireEngagementEvent: fireEngagementEvent })=>{
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        const isAuxClick = e?.button === 1;
        const isContextMenu = e?.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $a682b9c97392c96a$export$ea403d9edffb26a2)({
            ...analyticsAttributes,
            issuekey: issuekey,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        fireAnalyticsEvent((0, $jtIlq.onNonGenerativeKnowledgeCardLinkClick)({
            ...analyticsAttributes,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        if ((0, $iDrrr.fg)('kd_fix_nl2jql_mau_instrumentation')) fireEngagementEvent((0, $bZMnB.SainAction).JIRA_NL_TO_JQL_WORK_ITEM_CLICKED);
    }, [
        fireAnalyticsEvent,
        fireEngagementEvent,
        analyticsAttributes,
        issuekey
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        onAuxClick: (e)=>{
            if (e.button !== 1) return;
            handleClick(e);
        },
        onContextMenu: handleClick
    }, /*#__PURE__*/ $cozmU.createElement((0, $1YHM8.StandaloneHoverCard), {
        url: url
    }, /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
        href: url,
        xcss: $1eaffb3e826a5326$var$styles.noWrap,
        onClick: handleClick
    }, issuekey)));
};


/* IssuePriorityNode.tsx generated by @compiled/babel-plugin v3.0.1 */ 






var $lpNn5 = parcelRequire("lpNn5");

const $c41d65128d47dc0a$export$a62149baee0d175c = ({ IssuePriorityField: IssuePriorityField })=>{
    if (!IssuePriorityField?.priority) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "start"
    }, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: IssuePriorityField.priority.name,
        // tooltip content is the same as the items content
        isScreenReaderAnnouncementDisabled: true
    }, /*#__PURE__*/ $cozmU.createElement("img", {
        height: "16",
        width: "16",
        src: IssuePriorityField.priority.iconUrl,
        alt: IssuePriorityField.priority.name
    })));
};


/* IssueStatusNode.tsx generated by @compiled/babel-plugin v3.0.1 */ 



var $9KSWX = parcelRequire("9KSWX");

const $30e068cd4e7a88d9$export$47dfea36fbf85d70 = ({ status: status })=>{
    if (!status?.name || !status?.statusCategory.statusCategoryId) return null;
    let appearance = 'neutral';
    switch(status.statusCategory.statusCategoryId){
        case '2':
            appearance = 'neutral';
            break;
        case '4':
            appearance = 'information';
            break;
        case '3':
            appearance = 'success';
            break;
    }
    return /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: true
    }, status.name.toUpperCase());
};


/* IssueTextNode.tsx generated by @compiled/babel-plugin v3.0.1 */ 










const $a0e14a339a2fec66$var$styles = {
    container: "_39xV02N91d"
};
const $a0e14a339a2fec66$export$e899559221712ff = ({ text: text })=>{
    const textRef = (0, $cozmU.useRef)(null);
    if (!text) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, "\xa0");
    return /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: text,
        // tooltip content is the same as the items content
        isScreenReaderAnnouncementDisabled: true,
        canAppear: ()=>{
            const element = textRef.current; // Only showing the tooltip for this item when
            // the element has been clamped.
            return !!element && element.scrollHeight > element.clientHeight;
        }
    }, (props)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            ...props,
            xcss: $a0e14a339a2fec66$var$styles.container
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            ref: textRef,
            maxLines: 1
        }, text)));
};


/* IssueTypeNode.tsx generated by @compiled/babel-plugin v3.0.1 */ 


const $c8a42c076811fe29$export$e34e3b13a9b68282 = ({ IssueTypeField: IssueTypeField })=>{
    return /*#__PURE__*/ $cozmU.createElement("img", {
        height: "16",
        width: "16",
        src: IssueTypeField.issueType.avatar.small,
        alt: IssueTypeField.issueType.name
    });
};


/* IssueUserNode.tsx generated by @compiled/babel-plugin v3.0.1 */ 






var $arQY7 = parcelRequire("arQY7");


var $2QrXF = parcelRequire("2QrXF");











const $89f5bca3f8de55ba$var$styles = {
    avatar: "_2XsHFM4F84"
};
const $89f5bca3f8de55ba$export$ab6075737389532b = ({ user: user })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const User = !Boolean(user) ? /*#__PURE__*/ $cozmU.createElement((0, $2QrXF.default), {
        avatar: /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            appearance: "circle",
            size: "small",
            name: "unassigned"
        }),
        primaryText: formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).unassigned)
    }) : /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: user?.name,
        // tooltip content is the same as the items content
        isScreenReaderAnnouncementDisabled: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $2QrXF.default), {
        avatar: /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            appearance: "circle",
            src: user?.picture,
            size: "small",
            name: user?.name
        }),
        primaryText: user?.name
    }));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($89f5bca3f8de55ba$var$styles.avatar)
    }, User);
};



const $12f16ca3035f7e90$var$styles = {
    tableWrapper: "_0bjKvD8fU6 _3hxITi6wH8 _3vBAKH9r67 _2V7sgONvrM _4bt5LAIZbP",
    table: "_3hxITinQyn _3Kbj8ay1CL",
    header: "_3hxITiYbGa",
    headerCell: "_2sNsIgd8bj _3hxITi6wH8 _3vBAKH9r67 _2V7sgONvrM _1UtDYzZpcK _0KLXrunmFW _0Of8r2Pgdg _1Znuxb2ADO _1wydGWPgdg _2Zuz6Q2ADO _0jFU0VUF4f _1RrJLit2nV",
    cell: "_4bt5LAnQyn _2WAcuGnQyn _3hxITi6wH8 _3vBAKH9r67 _2V7sgONvrM _0Of8r2Pgdg _1Znuxb2ADO _1wydGWPgdg _2Zuz6Q2ADO _39xV02N91d _0jFU0VUF4f"
};
const $12f16ca3035f7e90$var$HeaderRow = ({ headerLabels: headerLabels })=>{
    return headerLabels.map((item, index)=>{
        return /*#__PURE__*/ $cozmU.createElement("th", {
            key: `issue.header.${index}`,
            style: {
                width: item.width,
                // Override to avoid global first child padding
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ...index === 0 && {
                    paddingLeft: "var(--ds-space-100, 8px)"
                }
            },
            className: (0, $hekY6.default)([
                $12f16ca3035f7e90$var$styles.headerCell
            ])
        }, item.label);
    });
};
const $12f16ca3035f7e90$var$BodyRows = ({ issues: issues, analyticsAttributes: analyticsAttributes, fireEngagementEvent: fireEngagementEvent })=>issues.map((issue, rowIndex)=>{
        const issueNode = issue.node;
        const issueTypeField = issueNode.issueTypeField;
        const issueStatus = issueNode.status;
        const issueAssignee = issueNode.assigneeField.user;
        const issuePriority = issueNode.priorityField;
        return /*#__PURE__*/ $cozmU.createElement("tr", {
            key: `issue.row.${rowIndex}`
        }, /*#__PURE__*/ $cozmU.createElement("td" // Override to avoid global first child padding
        , {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: {
                paddingLeft: "var(--ds-space-100, 8px)"
            },
            className: (0, $hekY6.default)([
                $12f16ca3035f7e90$var$styles.cell
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            alignInline: "start",
            space: "space.075"
        }, /*#__PURE__*/ $cozmU.createElement((0, $c8a42c076811fe29$export$e34e3b13a9b68282), {
            IssueTypeField: issueTypeField
        }), /*#__PURE__*/ $cozmU.createElement((0, $1eaffb3e826a5326$export$227b36be34e771c5), {
            url: issueNode.webUrl,
            issuekey: issueNode.key,
            analyticsAttributes: analyticsAttributes,
            fireEngagementEvent: fireEngagementEvent
        }), /*#__PURE__*/ $cozmU.createElement((0, $a0e14a339a2fec66$export$e899559221712ff), {
            text: issueNode.summary
        }))), /*#__PURE__*/ $cozmU.createElement("td", {
            className: (0, $hekY6.default)([
                $12f16ca3035f7e90$var$styles.cell
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $30e068cd4e7a88d9$export$47dfea36fbf85d70), {
            status: issueStatus
        })), /*#__PURE__*/ $cozmU.createElement("td", {
            className: (0, $hekY6.default)([
                $12f16ca3035f7e90$var$styles.cell
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $89f5bca3f8de55ba$export$ab6075737389532b), {
            user: issueAssignee
        })), /*#__PURE__*/ $cozmU.createElement("td", {
            className: (0, $hekY6.default)([
                $12f16ca3035f7e90$var$styles.cell
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $c41d65128d47dc0a$export$a62149baee0d175c), {
            IssuePriorityField: issuePriority
        })));
    });
const $12f16ca3035f7e90$export$548da6a0023fca70 = ({ issues: issues, analyticsAttributes: analyticsAttributes, fireEngagementEvent: fireEngagementEvent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const headerLabels = [
        {
            label: formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).headerWork),
            width: '60%'
        },
        {
            label: formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).headerStatus),
            width: '15%'
        },
        {
            label: formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).headerAssignee),
            width: '15%'
        },
        {
            label: formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).headerPriority),
            width: '10%'
        }
    ];
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $12f16ca3035f7e90$var$styles.tableWrapper
    }, /*#__PURE__*/ $cozmU.createElement("table", {
        "data-testid": "issue-table",
        className: (0, $hekY6.default)([
            $12f16ca3035f7e90$var$styles.table
        ])
    }, /*#__PURE__*/ $cozmU.createElement("thead", {
        className: (0, $hekY6.default)([
            $12f16ca3035f7e90$var$styles.header
        ])
    }, /*#__PURE__*/ $cozmU.createElement("tr", null, /*#__PURE__*/ $cozmU.createElement($12f16ca3035f7e90$var$HeaderRow, {
        headerLabels: headerLabels
    }))), /*#__PURE__*/ $cozmU.createElement("tbody", null, issues.length > 0 ? /*#__PURE__*/ $cozmU.createElement($12f16ca3035f7e90$var$BodyRows, {
        issues: issues,
        analyticsAttributes: analyticsAttributes,
        fireEngagementEvent: fireEngagementEvent
    }) : /*#__PURE__*/ $cozmU.createElement("tr", null, /*#__PURE__*/ $cozmU.createElement("td", {
        align: "center",
        colSpan: headerLabels.length,
        className: (0, $hekY6.default)([
            $12f16ca3035f7e90$var$styles.cell
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "center"
    }, formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).noResultsMessage)))))));
};










var $eKMV3 = parcelRequire("eKMV3");


var $ldJ1U = parcelRequire("ldJ1U");





const $f0ebab6d2240cdcf$export$28a2392dc2b2dd58 = (props)=>{
    const { totalIssuesCount: totalIssuesCount, url: url, callback: callback, spacing: spacing = 'default' } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        href: url,
        appearance: "default",
        onClick: callback,
        onAuxClick: callback,
        onContextMenu: callback,
        testId: "view-all-button",
        spacing: spacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldJ1U.JiraIcon), {
        appearance: "brand",
        size: "xxsmall"
    }), totalIssuesCount !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $6ee04b9bd73a1654$export$defe85febe8b728c).viewAll,
        values: {
            totalCount: totalIssuesCount
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6ee04b9bd73a1654$export$defe85febe8b728c).viewAllNoCount)));
};


const $f0bc144b7e8592f4$var$styles = {
    container: "_0bjKvDKxmn _30huDKOeNX",
    tableContainer: "_0bjKvD8fU6 _1mT5xdRAKS _2XsHFM5zaO _0adFHs5zaO _1DCdHi2ADO",
    sidePadding: "_2Zuz6Q5zaO _1Znuxb5zaO",
    headerContainer: "_0Of8r28HPE _1Znuxb5zaO _1wydGW2ADO",
    footer: "_2Y7lL45zaO _0xmtko8HPE",
    viewAllContainer: "_0Of8r21Y8M _1wydGW1Y8M _2fwxA5ecOK"
};
const $f0bc144b7e8592f4$var$buildJiraLink = ({ issueUrl: issueUrl, jql: jql })=>{
    const hostname = new URL(issueUrl).hostname;
    const jiraLink = new URL(`https://${hostname}/issues/`);
    jiraLink.searchParams.append('jql', jql);
    return jiraLink.toString();
};
const $f0bc144b7e8592f4$export$ba6b7dafd54d334 = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const renderStartTime = (0, $cozmU.useRef)(performance.now());
    const analyticsFiredRef = (0, $cozmU.useRef)(false);
    const nlToJqlEndTimeRef = (0, $cozmU.useRef)(undefined);
    const issueSearchStartTimeRef = (0, $cozmU.useRef)(undefined);
    const { query: query, title: title, cloudId: cloudId, aiBrand: aiBrand, searchSessionId: searchSessionId, workspaceId: workspaceId, product: product, onFMPReached: onFMPReached, bypassWithKeywordJql: bypassWithKeywordJql = false } = props;
    const [issueUrl, setIssueUrl] = (0, $cozmU.useState)(null);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { commonAttributes: commonAttributes, setData: setData, callbacks: callbacks } = (0, $3hVWe.useAIAnswerContext)();
    const onSainJqlResolved = callbacks?.onSainJqlResolved; // When bypassing the agentic NL→JQL flow (JIRA_NLQ_KEYWORD intent), compute
    // the deterministic keyword JQL synchronously and skip the network call.
    const keywordJql = (0, $cozmU.useMemo)(()=>bypassWithKeywordJql ? (0, $76b1398b70af7db1$export$4ab7a1642c5a2b25)(query) : null, [
        bypassWithKeywordJql,
        query
    ]);
    const nlResult = (0, $2cca25495c5a9447$export$eca952b1040f8ff3)({
        cloudId: cloudId,
        query: query,
        workspaceId: workspaceId,
        product: product,
        enabled: !bypassWithKeywordJql
    });
    const jqlLoading = bypassWithKeywordJql ? false : nlResult.loading; // In bypass mode, only the empty-query case is treated as an error here;
    // downstream `issues?.length === 0` still drives the empty-state UI.
    const jqlError = bypassWithKeywordJql ? keywordJql === null : nlResult.error;
    const jql = bypassWithKeywordJql ? keywordJql ?? undefined : nlResult.jql;
    (0, $cozmU.useEffect)(()=>{
        onSainJqlResolved?.(jql ?? null);
    }, [
        jql,
        onSainJqlResolved
    ]);
    const { issues: issues, totalIssuesCount: totalIssuesCount, loading: issuesLoading, error: issuesError, extensions: issuesExtensions } = (0, $b2c833a5b9632464$export$11659072884978f5)({
        cloudId: cloudId,
        jql: jql,
        workspaceId: workspaceId,
        product: product
    });
    const analyticsAttributes = (0, $cozmU.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $9oghv.sha256Hash)(query),
            brand: aiBrand,
            source: 'jira_nl_2_jql_card',
            query: query,
            answerString: jql || '',
            answerCardType: (0, $zzZbq.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY,
            queryLength: query.length,
            wordCount: (query.match(/\w+/g) || []).length,
            queryIntent: commonAttributes.queryIntent,
            jiraNlToJqlCardVariant: 'issue-table'
        }), [
        searchSessionId,
        query,
        aiBrand,
        jql,
        commonAttributes.queryIntent
    ]);
    const analyticsAttributesWithoutUGC = (0, $cozmU.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $9oghv.sha256Hash)(query),
            brand: aiBrand,
            source: 'jira_nl_2_jql_card',
            answerCardType: (0, $zzZbq.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY
        }), [
        searchSessionId,
        query,
        aiBrand
    ]);
    const fireJiraNlToJqlCardLoaded = (0, $cozmU.useCallback)(({ success: success, endState: endState })=>{
        const apiLoadedTime = performance.now();
        const totalDuration = apiLoadedTime - renderStartTime.current;
        const nlToJqlLoadTime = nlToJqlEndTimeRef.current !== undefined ? nlToJqlEndTimeRef.current - renderStartTime.current : undefined;
        const issueSearchLoadTime = issueSearchStartTimeRef.current !== undefined ? apiLoadedTime - issueSearchStartTimeRef.current : undefined;
        const phaseTimingAttributes = {
            nlToJqlLoadTime: nlToJqlLoadTime,
            issueSearchLoadTime: issueSearchLoadTime,
            ...nlToJqlLoadTime !== undefined || issueSearchLoadTime !== undefined ? {
                phaseTimingSource: 'measured'
            } : {}
        };
        fireAnalyticsEvent((0, $d6ee00d3c7ff7f25$export$10fed66da45c02f6)({
            ...analyticsAttributes,
            success: success,
            loadTime: totalDuration,
            endState: endState,
            jiraNlToJqlCardVariant: 'issue-table',
            ...phaseTimingAttributes
        }));
        (0, $7DMz5.SAINFeatureControl).triggerNonPrimaryClickTrackingExposure();
    }, [
        fireAnalyticsEvent,
        analyticsAttributes
    ]); // using the first issue's webUrl to build a jira url for the view all 'x' items button
    (0, $cozmU.useEffect)(()=>{
        if (!issuesLoading && !issuesError && issues?.length && issues[0]) try {
            const firstIssueUrl = issues[0].node.webUrl;
            setIssueUrl($f0bc144b7e8592f4$var$buildJiraLink({
                issueUrl: firstIssueUrl || '',
                jql: jql || ''
            }));
        } catch (error) {
            (0, $cuvLu.logger).error({
                error: error,
                functionName: 'JiraNlToJqlCard'
            });
        }
    }, [
        issuesLoading,
        issuesError,
        issues,
        jql
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (jqlLoading) return;
        if (jqlError && nlToJqlEndTimeRef.current === undefined) {
            nlToJqlEndTimeRef.current = performance.now();
            return;
        }
        if (jql && nlToJqlEndTimeRef.current === undefined) {
            const now = performance.now();
            nlToJqlEndTimeRef.current = now;
            issueSearchStartTimeRef.current = now;
        }
    }, [
        jqlLoading,
        jqlError,
        jql
    ]);
    (0, $cozmU.useEffect)(()=>{
        trackAIInteractionInit();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []); // Set debug data for online debugger when API response is available
    // Separate from analytics effect to avoid infinite loop with commonAttributes
    (0, $cozmU.useEffect)(()=>{
        if (!issuesLoading && issuesExtensions?.gateway && (0, $iDrrr.fg)('kd_sain_online_debugger')) setData({
            errorState: null,
            format: null,
            uniqueSources: [],
            disclaimer: null,
            extraAPIAnalyticsAttributes: {
                traceId: issuesExtensions.gateway.trace_id ?? null,
                requestId: issuesExtensions.gateway.request_id ?? null
            }
        });
    }, [
        issuesLoading,
        issuesExtensions?.gateway,
        setData
    ]); // fire Analytics Events on final state changes
    (0, $cozmU.useEffect)(()=>{
        if (analyticsFiredRef.current) return;
        if (!jqlLoading && !jqlError && !issuesLoading && !issuesError && issues?.length && issues[0]) {
            /*
       * * Success block
       */ analyticsFiredRef.current = true;
            onFMPReached();
            fireJiraNlToJqlCardLoaded({
                success: true,
                endState: 'answered'
            });
            if ((0, $iDrrr.fg)('kd_fix_nl2jql_mau_instrumentation')) fireSAINUsageEvent({
                commonAttributes: {
                    ...commonAttributes,
                    extraAttributes: {
                        ...commonAttributes?.extraAttributes,
                        requestId: issuesExtensions?.gateway?.request_id ?? null
                    }
                }
            });
            else fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
        } else if (!jqlLoading && jqlError) {
            /*
       * * JQL error block
       */ analyticsFiredRef.current = true;
            fireJiraNlToJqlCardLoaded({
                success: false,
                endState: 'jql-error'
            });
        } else if (!issuesLoading && issuesError) {
            /*
       * * Issues error block
       */ analyticsFiredRef.current = true;
            fireJiraNlToJqlCardLoaded({
                success: false,
                endState: 'issues-error'
            });
        } else if (!jqlLoading && !issuesLoading && issues?.length === 0) {
            /*
       * * No issues block,
       * * while this is not an error, we're still marking it as a failure cause the user sees an error card
       */ analyticsFiredRef.current = true;
            fireJiraNlToJqlCardLoaded({
                success: false,
                endState: 'no-issues'
            });
        }
    }, [
        jqlLoading,
        issuesLoading,
        issuesError,
        jqlError,
        issues,
        onFMPReached,
        fireJiraNlToJqlCardLoaded,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        commonAttributes,
        issuesExtensions?.gateway?.request_id
    ]);
    const fireEngagementEvent = (0, $cozmU.useCallback)((sainAction)=>{
        fireSAINUsageEvent({
            metCriteria: sainAction,
            commonAttributes: {
                ...commonAttributes,
                extraAttributes: {
                    ...commonAttributes?.extraAttributes,
                    requestId: issuesExtensions?.gateway?.request_id ?? null
                }
            }
        });
    }, [
        fireSAINUsageEvent,
        commonAttributes,
        issuesExtensions?.gateway?.request_id
    ]);
    const onViewAllButtonClicked = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $fce67a5f4fe3c54f$export$447238500b8bc926)({
            ...analyticsAttributes,
            totalIssuesCount: totalIssuesCount || 0
        }));
        if ((0, $iDrrr.fg)('kd_fix_nl2jql_mau_instrumentation')) fireEngagementEvent((0, $bZMnB.SainAction).JIRA_NL_TO_JQL_VIEW_ALL);
    }, [
        fireAnalyticsEvent,
        fireEngagementEvent,
        analyticsAttributes,
        totalIssuesCount
    ]);
    if (jqlLoading || issuesLoading) return /*#__PURE__*/ $cozmU.createElement((0, $b3ffN.AnimatedWrapper), null, /*#__PURE__*/ $cozmU.createElement((0, $aiIBH.SmartAnswerCardBodyGenerating), {
        heightOverride: "jiraNlToJqlCard"
    }));
    if (jqlError || issuesError || issues?.length === 0) return /*#__PURE__*/ $cozmU.createElement((0, $c7397925ebe4947f$export$a2c93507c97cd090), {
        query: query
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $f0bc144b7e8592f4$var$styles.container,
        testId: "jira-nl-to-jql-card-wrapper"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($f0bc144b7e8592f4$var$styles.headerContainer, $f0bc144b7e8592f4$var$styles.sidePadding)
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, title || formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).cardTitle))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $f0bc144b7e8592f4$var$styles.tableContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: {
            attributes: {
                ...analyticsAttributesWithoutUGC,
                location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_JIRA_NL_TO_JQL_CARD
            },
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_JIRA_NL_TO_JQL_CARD
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $12f16ca3035f7e90$export$548da6a0023fca70), {
        issues: issues || [],
        analyticsAttributes: analyticsAttributes,
        fireEngagementEvent: fireEngagementEvent
    })))), totalIssuesCount && totalIssuesCount > 0 && issueUrl ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($f0bc144b7e8592f4$var$styles.viewAllContainer, $f0bc144b7e8592f4$var$styles.sidePadding)
    }, /*#__PURE__*/ $cozmU.createElement((0, $f0ebab6d2240cdcf$export$28a2392dc2b2dd58), {
        totalIssuesCount: totalIssuesCount,
        url: issueUrl,
        callback: onViewAllButtonClicked
    })) : null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $f0bc144b7e8592f4$var$styles.footer
    }, /*#__PURE__*/ $cozmU.createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true
    })));
});


/* JiraNlToJqlSmartlinkCard.tsx generated by @compiled/babel-plugin v3.0.1 */ 






var $3d3WW = parcelRequire("3d3WW");








var $f0b2F = parcelRequire("f0b2F");


var $3UfFE = parcelRequire("3UfFE");


var $a79Sy = parcelRequire("a79Sy");


var $bsSbN = parcelRequire("bsSbN");


var $4ESzI = parcelRequire("4ESzI");


var $aK1EY = parcelRequire("aK1EY");


var $b1qV0 = parcelRequire("b1qV0");





var $4dGdo = parcelRequire("4dGdo");


















var $4Tg3t = parcelRequire("4Tg3t");

const $5df1629f53f4597d$export$d5927f4d78af7f29 = (props)=>{
    const { query: query, answerString: answerString, source: source, jiraNlToJqlCardVariant: jiraNlToJqlCardVariant } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerCollapse',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            jiraNlToJqlCardVariant: jiraNlToJqlCardVariant
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};








const $e14deeb67bd569aa$export$a499208a458c0e59 = (props)=>{
    const { query: query, answerString: answerString, source: source, jiraNlToJqlCardVariant: jiraNlToJqlCardVariant } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerExpand',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            jiraNlToJqlCardVariant: jiraNlToJqlCardVariant
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};





const $a020d6fc16168401$export$93f0009a720af69b = (props)=>{
    const { source: source, query: query, answerString: answerString, elementInteracted: elementInteracted, jiraNlToJqlCardVariant: jiraNlToJqlCardVariant, isAuxClick: isAuxClick, isContextMenu: isContextMenu } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            elementInteracted: elementInteracted,
            jiraNlToJqlCardVariant: jiraNlToJqlCardVariant,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
















































const $db35164133ee90b3$var$JIRA_AGENT_GENERATE_JQL_PATH = '/api/rovo/v1/jira-ticket-retrieval/generate-jql';
const $db35164133ee90b3$var$JIRA_AGENT_GENERATE_JQL_URL = `${(0, $zzZbq.ASSISTANCE_SERVICE_API_BASE_URL)}${$db35164133ee90b3$var$JIRA_AGENT_GENERATE_JQL_PATH}`;
async function $db35164133ee90b3$var$fetchJiraAgentGenerateJql({ request: request, workspaceId: workspaceId, cloudId: cloudId, product: product, traceHeaders: traceHeaders }) {
    const response = await fetch($db35164133ee90b3$var$JIRA_AGENT_GENERATE_JQL_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Product': product,
            'X-Experience-Id': 'sain',
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            }),
            ...traceHeaders
        },
        body: JSON.stringify(request)
    });
    if (!response.ok) throw new Error(`Jira Agent generate-jql failed: ${response.status} ${response.statusText}`);
    const data = await response.json();
    return data;
}
const $db35164133ee90b3$export$2cc525a82b3249e7 = ({ query: query, cloudId: cloudId, workspaceId: workspaceId, product: product, traceHeaders: traceHeaders, enabled: enabled = true })=>{
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(false);
    const [jql, setJql] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) {
            setLoading(false);
            setError(false);
            setJql(undefined);
            return;
        }
        if (!query.trim() || !cloudId) {
            setLoading(false);
            setError(false);
            setJql(undefined);
            return;
        }
        let cancelled = false;
        const fetchData = async ()=>{
            setLoading(true);
            setError(false);
            try {
                const data = await $db35164133ee90b3$var$fetchJiraAgentGenerateJql({
                    request: {
                        query: query.trim()
                    },
                    workspaceId: workspaceId,
                    cloudId: cloudId,
                    product: product,
                    traceHeaders: traceHeaders
                });
                if (cancelled) return;
                const generatedJql = 'JQL' in data ? data.JQL : undefined;
                const error = 'error' in data ? data.error : undefined;
                if (!generatedJql || error) {
                    setError(true);
                    setJql(undefined);
                    return;
                }
                setJql(generatedJql);
                setError(false);
            } catch (e) {
                if (!cancelled) {
                    (0, $cuvLu.logger).error({
                        error: e,
                        functionName: 'useJiraAgent'
                    });
                    setError(true);
                    setJql(undefined);
                }
            } finally{
                if (!cancelled) setLoading(false);
            }
        };
        fetchData();
        return ()=>{
            cancelled = true;
        };
    }, [
        enabled,
        query,
        cloudId,
        workspaceId,
        product,
        traceHeaders
    ]);
    return {
        jql: jql,
        loading: loading,
        error: error
    };
};



const $acc42ef9a5028623$export$ac77cca39f27bb5f = (query, jql)=>{
    const trimmedQuery = query.trim();
    if (jql) return `/issues/?jql=${encodeURIComponent(jql)}&text=${encodeURIComponent(trimmedQuery)}&referrer=sain`;
    const params = new URLSearchParams({
        searchString: trimmedQuery,
        referrer: 'sain'
    });
    return `/jira/search?${params.toString()}`;
};



/* JiraNlToJqlErrorCard.tsx generated by @compiled/babel-plugin v3.0.1 */ 




























const $162db3c479f357e1$var$styles = {
    container: "_0bjKvD8fU6 _30huDKOeNX _0KLXruoI2d _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    messageContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2Zuz6Q1Y8M _1Znuxb1Y8M",
    viewAllContainer: "_2fwxA5ecOK"
};
function $162db3c479f357e1$export$bcbdfb57198b378b({ query: query, viewAllUrl: viewAllUrl, onViewAllClick: onViewAllClick }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(true);
    if (!isOpen) return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200",
        xcss: $162db3c479f357e1$var$styles.container,
        testId: "jira-nl-to-jql-error-card"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "start",
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $162db3c479f357e1$var$styles.messageContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).errorMessageWithViewAll, {
        query: query
    }))), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).close),
        onClick: ()=>setIsOpen(false),
        testId: "jira-nl-to-jql-error-card-close"
    })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $162db3c479f357e1$var$styles.viewAllContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $f0ebab6d2240cdcf$export$28a2392dc2b2dd58), {
        url: viewAllUrl,
        callback: onViewAllClick ?? (()=>{}),
        spacing: "compact"
    })), (0, $iDrrr.fg)('kd_sain_online_debugger') && /*#__PURE__*/ $cozmU.createElement((0, $j9bgP.OnlineDebuggerButton), null)));
}









const $9ac56043691df2ab$export$b7c741dc710857de = 240;
const $9ac56043691df2ab$export$aa6e67a972e6a35d = 495;
const $9ac56043691df2ab$var$TABLE_RESIZE_DURATION_MS = (0, $4dGdo.durations).medium;
/** Cubic ease-in-out for progress 0–1 (matches easeInOut curve feel). */ function $9ac56043691df2ab$var$easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
function $9ac56043691df2ab$export$a2a5ea5cc7c20545(animationsEnabled, options) {
    const expandToAuto = options?.expandToAuto ?? false;
    const [isHidden, setIsHidden] = (0, $cozmU.useState)(false);
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const [contentWrapperTransitioning, setContentWrapperTransitioning] = (0, $cozmU.useState)(false);
    const [justRevealed, setJustRevealed] = (0, $cozmU.useState)(false);
    const [revealHeightZero, setRevealHeightZero] = (0, $cozmU.useState)(false);
    const [animatedTableHeight, setAnimatedTableHeight] = (0, $cozmU.useState)($9ac56043691df2ab$export$b7c741dc710857de);
    const tableHeightRef = (0, $cozmU.useRef)($9ac56043691df2ab$export$b7c741dc710857de);
    const tableAnimationFrameRef = (0, $cozmU.useRef)(null);
    tableHeightRef.current = animatedTableHeight;
    // Expand/collapse: when expandToAuto we keep height at COLLAPSED so the card uses height:auto and collapse doesn't jump
    (0, $cozmU.useEffect)(()=>{
        const expandedTarget = expandToAuto && isExpanded ? $9ac56043691df2ab$export$b7c741dc710857de : $9ac56043691df2ab$export$aa6e67a972e6a35d;
        const targetHeight = isExpanded ? expandedTarget : $9ac56043691df2ab$export$b7c741dc710857de;
        const startHeight = tableHeightRef.current;
        if (startHeight === targetHeight) return;
        if (!animationsEnabled) {
            tableHeightRef.current = targetHeight;
            setAnimatedTableHeight(targetHeight);
            return;
        }
        if (tableAnimationFrameRef.current !== null) cancelAnimationFrame(tableAnimationFrameRef.current);
        const startTime = performance.now();
        const tick = (now)=>{
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / $9ac56043691df2ab$var$TABLE_RESIZE_DURATION_MS, 1);
            const eased = $9ac56043691df2ab$var$easeInOutCubic(progress);
            const current = Math.round(startHeight + (targetHeight - startHeight) * eased);
            tableHeightRef.current = current;
            setAnimatedTableHeight(current);
            if (progress < 1) tableAnimationFrameRef.current = requestAnimationFrame(tick);
            else tableAnimationFrameRef.current = null;
        };
        tableAnimationFrameRef.current = requestAnimationFrame(tick);
        return ()=>{
            if (tableAnimationFrameRef.current !== null) {
                cancelAnimationFrame(tableAnimationFrameRef.current);
                tableAnimationFrameRef.current = null;
            }
        };
    }, [
        isExpanded,
        animationsEnabled,
        expandToAuto
    ]);
    // After reveal, clear both flags in one frame so opacity and height stay in sync
    (0, $cozmU.useEffect)(()=>{
        if (!justRevealed && !revealHeightZero) return;
        const frameId = requestAnimationFrame(()=>{
            setJustRevealed(false);
            setRevealHeightZero(false);
        });
        return ()=>cancelAnimationFrame(frameId);
    }, [
        justRevealed,
        revealHeightZero
    ]);
    const onHideClick = (0, $cozmU.useCallback)(()=>{
        if (animationsEnabled) setContentWrapperTransitioning(true);
        setIsHidden(true);
    }, [
        animationsEnabled
    ]);
    const onRevealClick = (0, $cozmU.useCallback)(()=>{
        if (animationsEnabled) {
            setJustRevealed(true);
            setRevealHeightZero(true);
            setContentWrapperTransitioning(true);
        }
        setIsHidden(false);
    }, [
        animationsEnabled
    ]);
    const onExpandClick = (0, $cozmU.useCallback)(()=>{
        setIsExpanded(true);
    }, []);
    const onCollapseClick = (0, $cozmU.useCallback)(()=>{
        setIsExpanded(false);
    }, []);
    const onContentWrapperTransitionEnd = (0, $cozmU.useCallback)((e)=>{
        if (e.propertyName === 'height') setContentWrapperTransitioning(false);
    }, []);
    return {
        isHidden: isHidden,
        isExpanded: isExpanded,
        contentWrapperTransitioning: contentWrapperTransitioning,
        justRevealed: justRevealed,
        revealHeightZero: revealHeightZero,
        animatedTableHeight: animatedTableHeight,
        onHideClick: onHideClick,
        onRevealClick: onRevealClick,
        onExpandClick: onExpandClick,
        onCollapseClick: onCollapseClick,
        onContentWrapperTransitionEnd: onContentWrapperTransitionEnd
    };
}



const $51159ee7c0863918$var$styles = {
    container: "_0bjKvD8fU6 _2Y7lL45zaO _0KLXrunmFW _0Of8r25zaO _1wydGW5zaO",
    tableContainer: "_0bjKvD8fU6 _30huDKOeNX _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS",
    viewAllContainer: "_2fwxA5ecOK",
    resizingContentWrapper: "_4bt5LAnQyn _2WAcuGnQyn"
}; /** Scroll area height while datasource is loading; matches collapsed resolved table height (TABLE_HEIGHT_COLLAPSED). */ 
const $51159ee7c0863918$var$DATASOURCE_LOADING_TABLE_HEIGHT = (0, $9ac56043691df2ab$export$b7c741dc710857de); /** Height of DatasourceTableView footer (item count, refresh, etc.) so container wraps table + footer. */ 
const $51159ee7c0863918$var$TABLE_FOOTER_HEIGHT = 41; /** Stack gap (space.150) + disclaimer section so we can drive content wrapper height in sync with table expand. */ 
const $51159ee7c0863918$var$CONTENT_BELOW_TABLE_HEIGHT = 36; /** space.150 in px; added to wrapper height when paddingTop is used so content is not cut off (border-box). */ 
const $51159ee7c0863918$var$CONTENT_WRAPPER_PADDING_TOP_PX = 12;
const $51159ee7c0863918$var$DATASOURCE_RESOLVE_TIMEOUT_MS = 10000;
const $51159ee7c0863918$var$EXPAND_BUTTON_ROW_THRESHOLD = 4; /** When expanded and row count is in this range, use height: auto instead of fixed expanded height. */ 
const $51159ee7c0863918$var$EXPAND_TO_AUTO_ROW_THRESHOLD = 10;
const $51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_MS = (0, $4dGdo.durations).large;
const $51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_EASING = 'cubic-bezier(0.15, 1, 0.3, 1)';
const $51159ee7c0863918$var$CONTENT_WRAPPER_OPACITY_TRANSITION = `opacity ${$51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_MS}ms ${$51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_EASING}`;
const $51159ee7c0863918$var$CONTENT_WRAPPER_HEIGHT_TRANSITION = `height ${$51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_MS}ms ${$51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_EASING}`;
const $51159ee7c0863918$var$CONTENT_WRAPPER_PADDING_TOP_TRANSITION = `padding-top ${$51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_MS}ms ${$51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_EASING}`;
const $51159ee7c0863918$export$68d51edc6150de19 = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const renderStartTime = (0, $cozmU.useRef)(performance.now());
    const analyticsFiredRef = (0, $cozmU.useRef)(false);
    const nlToJqlEndTimeRef = (0, $cozmU.useRef)(undefined);
    const { query: query, cloudId: cloudId, aiBrand: aiBrand, searchSessionId: searchSessionId, workspaceId: workspaceId, product: product, onFMPReached: onFMPReached, bypassWithKeywordJql: bypassWithKeywordJql = false } = props;
    const tableScrollContainerRef = (0, $cozmU.useRef)(null);
    const [showExpandButton, setShowExpandButton] = (0, $cozmU.useState)(false);
    const [tableRowCount, setTableRowCount] = (0, $cozmU.useState)(0);
    const [datasourceOutcome, setDatasourceOutcome] = (0, $cozmU.useState)(null);
    const isDatasourceResolved = datasourceOutcome !== null;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { commonAttributes: commonAttributes, setData: setData, traceHeaders: traceHeaders, callbacks: callbacks } = (0, $3hVWe.useAIAnswerContext)();
    const onSainJqlResolved = callbacks?.onSainJqlResolved;
    const animationsEnabled = (0, $iDrrr.fg)('kd_sain_jira_card_animations');
    const expandToAuto = showExpandButton && tableRowCount <= $51159ee7c0863918$var$EXPAND_TO_AUTO_ROW_THRESHOLD;
    const animation = (0, $9ac56043691df2ab$export$a2a5ea5cc7c20545)(animationsEnabled, {
        expandToAuto: expandToAuto
    }); // When bypassing the agentic NL→JQL flow (JIRA_NLQ_KEYWORD intent), compute
    // the deterministic keyword JQL synchronously and skip both BE calls.
    const keywordJql = (0, $cozmU.useMemo)(()=>bypassWithKeywordJql ? (0, $76b1398b70af7db1$export$4ab7a1642c5a2b25)(query) : null, [
        bypassWithKeywordJql,
        query
    ]);
    const useJiraAgentApi = (0, $iDrrr.fg)('kd_sain_jira_card_migrate_jira_agent');
    const jiraAgentResult = (0, $db35164133ee90b3$export$2cc525a82b3249e7)({
        query: query,
        cloudId: cloudId,
        workspaceId: workspaceId,
        product: product,
        traceHeaders: traceHeaders,
        enabled: !bypassWithKeywordJql && useJiraAgentApi
    });
    const nlResult = (0, $2cca25495c5a9447$export$eca952b1040f8ff3)({
        cloudId: cloudId,
        query: query,
        workspaceId: workspaceId,
        product: product,
        enabled: !bypassWithKeywordJql && !useJiraAgentApi
    });
    const jqlLoading = bypassWithKeywordJql ? false : useJiraAgentApi ? jiraAgentResult.loading : nlResult.loading;
    const jqlError = bypassWithKeywordJql ? keywordJql === null : useJiraAgentApi ? jiraAgentResult.error : nlResult.error;
    const jql = bypassWithKeywordJql ? keywordJql ?? undefined : useJiraAgentApi ? jiraAgentResult.jql : nlResult.jql;
    (0, $cozmU.useEffect)(()=>{
        onSainJqlResolved?.(jql ?? null);
    }, [
        jql,
        onSainJqlResolved
    ]);
    const jiraSearchUrl = (0, $cozmU.useMemo)(()=>jql ? (0, $acc42ef9a5028623$export$ac77cca39f27bb5f)(query, jql) : null, [
        jql,
        query
    ]); /** URL for "View all work items" on the error card (no JQL, search by query text only). */ 
    const errorCardViewAllUrl = (0, $cozmU.useMemo)(()=>(0, $acc42ef9a5028623$export$ac77cca39f27bb5f)(query), [
        query
    ]);
    const analyticsAttributes = (0, $cozmU.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $9oghv.sha256Hash)(query),
            brand: aiBrand,
            source: 'jira_nl_2_jql_card',
            query: query,
            answerString: jql ? (0, $9oghv.sha256Hash)(jql) : '',
            answerCardType: (0, $zzZbq.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY,
            queryLength: query.length,
            wordCount: (query.match(/\w+/g) || []).length,
            queryIntent: commonAttributes.queryIntent,
            jiraNlToJqlCardVariant: 'smartlink'
        }), [
        searchSessionId,
        query,
        aiBrand,
        jql,
        commonAttributes.queryIntent
    ]);
    const analyticsAttributesWithoutUGC = (0, $cozmU.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $9oghv.sha256Hash)(query),
            brand: aiBrand,
            source: 'jira_nl_2_jql_card',
            answerCardType: (0, $zzZbq.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY,
            queryLength: query.length,
            wordCount: (query.match(/\w+/g) || []).length,
            queryIntent: commonAttributes.queryIntent,
            jiraNlToJqlCardVariant: 'smartlink'
        }), [
        searchSessionId,
        query,
        aiBrand,
        commonAttributes.queryIntent
    ]);
    const fireJiraNlToJqlCardLoaded = (0, $cozmU.useCallback)(({ success: success, endState: endState })=>{
        const apiLoadedTime = performance.now();
        const totalDuration = apiLoadedTime - renderStartTime.current;
        const nlToJqlLoadTime = nlToJqlEndTimeRef.current !== undefined ? nlToJqlEndTimeRef.current - renderStartTime.current : undefined; // Only derive issueSearchLoadTime when an issue search actually occurred
        // (i.e. not on jql-error, where the JQL phase failed before issue search started)
        const issueSearchLoadTime = nlToJqlLoadTime !== undefined && endState !== 'jql-error' ? totalDuration - nlToJqlLoadTime : undefined;
        const phaseTimingAttributes = {
            nlToJqlLoadTime: nlToJqlLoadTime,
            issueSearchLoadTime: issueSearchLoadTime,
            ...nlToJqlLoadTime !== undefined || issueSearchLoadTime !== undefined ? {
                phaseTimingSource: 'derived'
            } : {}
        };
        fireAnalyticsEvent((0, $d6ee00d3c7ff7f25$export$10fed66da45c02f6)({
            ...analyticsAttributes,
            success: success,
            loadTime: totalDuration,
            endState: endState,
            jiraNlToJqlCardVariant: 'smartlink',
            ...phaseTimingAttributes
        }));
        (0, $7DMz5.SAINFeatureControl).triggerNonPrimaryClickTrackingExposure();
    }, [
        fireAnalyticsEvent,
        analyticsAttributes
    ]);
    const updateDOMDerivedState = (0, $cozmU.useCallback)(()=>{
        const el = tableScrollContainerRef.current;
        if (!el) return;
        const dataRows = el.querySelectorAll('table tbody tr');
        const count = dataRows.length;
        setTableRowCount(count);
        setShowExpandButton(count > $51159ee7c0863918$var$EXPAND_BUTTON_ROW_THRESHOLD);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const el = tableScrollContainerRef.current;
        if (!el) return;
        updateDOMDerivedState(); // Debounce added to prevent excessive re-renders and wait for the DOM to settle
        let debounceId = null;
        const observer = new MutationObserver(()=>{
            if (debounceId !== null) clearTimeout(debounceId);
            debounceId = setTimeout(()=>{
                debounceId = null;
                updateDOMDerivedState();
            }, 150);
        });
        observer.observe(el, {
            childList: true,
            subtree: true
        });
        return ()=>{
            if (debounceId !== null) clearTimeout(debounceId);
            observer.disconnect();
        };
    }, [
        animation.isExpanded,
        jql,
        updateDOMDerivedState
    ]);
    (0, $cozmU.useEffect)(()=>{
        trackAIInteractionInit();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $cozmU.useEffect)(()=>{
        if (!jqlLoading && (jql || jqlError) && nlToJqlEndTimeRef.current === undefined) nlToJqlEndTimeRef.current = performance.now();
    }, [
        jqlLoading,
        jql,
        jqlError
    ]); // fire Analytics Events on final state changes
    // Waits for isDatasourceResolved so loadTime includes the DatasourceTableView's own API fetch,
    // giving an accurate TTI/FMP that covers both the NL→JQL call and the issue search.
    (0, $cozmU.useEffect)(()=>{
        if (analyticsFiredRef.current) return;
        if (!jqlLoading && !jqlError && jql && datasourceOutcome === 'answered') {
            analyticsFiredRef.current = true;
            onFMPReached();
            fireJiraNlToJqlCardLoaded({
                success: true,
                endState: 'answered'
            });
            if ((0, $iDrrr.fg)('kd_fix_nl2jql_mau_instrumentation')) fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
        } else if (!jqlLoading && jqlError) {
            analyticsFiredRef.current = true;
            fireJiraNlToJqlCardLoaded({
                success: false,
                endState: 'jql-error'
            });
        } else if (!jqlLoading && jql && datasourceOutcome === 'issues-error') {
            analyticsFiredRef.current = true;
            fireJiraNlToJqlCardLoaded({
                success: false,
                endState: 'issues-error'
            });
        } else if (!jqlLoading && jql && datasourceOutcome === 'no-issues') {
            analyticsFiredRef.current = true;
            fireJiraNlToJqlCardLoaded({
                success: false,
                endState: 'no-issues'
            });
        }
    }, [
        jqlLoading,
        jqlError,
        jql,
        datasourceOutcome,
        onFMPReached,
        fireJiraNlToJqlCardLoaded,
        fireSAINUsageEvent,
        commonAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isDatasourceResolved || jqlLoading || jqlError || !jql) return;
        const id = setTimeout(()=>{
            if (!analyticsFiredRef.current) {
                analyticsFiredRef.current = true;
                fireJiraNlToJqlCardLoaded({
                    success: false,
                    endState: 'datasource-timeout'
                });
            }
            setDatasourceOutcome('datasource-timeout');
        }, $51159ee7c0863918$var$DATASOURCE_RESOLVE_TIMEOUT_MS);
        return ()=>clearTimeout(id);
    }, [
        isDatasourceResolved,
        jqlLoading,
        jqlError,
        jql,
        fireJiraNlToJqlCardLoaded
    ]); // Set debug data for online debugger when API response is available
    // Separate from analytics effect to avoid infinite loop with commonAttributes
    (0, $cozmU.useEffect)(()=>{
        if (!jqlLoading && jql && (0, $iDrrr.fg)('kd_sain_online_debugger')) setData({
            errorState: null,
            format: null,
            uniqueSources: [],
            disclaimer: null,
            extraAPIAnalyticsAttributes: {
                traceId: commonAttributes.extraAttributes?.requestId ?? null,
                requestId: commonAttributes.extraAttributes?.requestId ?? null
            }
        });
    }, [
        jqlLoading,
        jql,
        setData,
        commonAttributes.extraAttributes?.requestId
    ]);
    const fireEngagementEvent = (0, $cozmU.useCallback)((sainAction)=>{
        fireSAINUsageEvent({
            metCriteria: sainAction,
            commonAttributes: commonAttributes
        });
    }, [
        fireSAINUsageEvent,
        commonAttributes
    ]);
    const handleDatasourceAnalyticsEvent = (0, $cozmU.useCallback)((event)=>{
        const { payload: payload } = event;
        if (payload.action === 'renderSuccess' && payload.actionSubject === 'datasource') setDatasourceOutcome('answered');
        const isEmptyResult = payload.action === 'shown' && payload.actionSubject === 'emptyResult';
        const isDatasourceError = payload.action === 'shown' && payload.actionSubject === 'error' && !payload.actionSubjectId;
        if ((isEmptyResult || isDatasourceError) && (0, $iDrrr.fg)('kd_fix_nl2jql_smartlink_end_states')) {
            if (isEmptyResult) setDatasourceOutcome('no-issues');
            else setDatasourceOutcome('issues-error');
        }
        if (payload.action === 'clicked') {
            if (payload.actionSubject === 'link') fireAnalyticsEvent((0, $jtIlq.onNonGenerativeKnowledgeCardLinkClick)({
                ...analyticsAttributes,
                isAuxClick: payload.attributes?.clickType === 'middle',
                isContextMenu: payload.attributes?.clickType === 'right',
                elementInteracted: 'jira-issue-key'
            }));
            else fireAnalyticsEvent((0, $jtIlq.onNonGenerativeKnowledgeCardLinkClick)({
                ...analyticsAttributes,
                isAuxClick: payload.attributes?.clickType === 'middle',
                isContextMenu: payload.attributes?.clickType === 'right',
                elementInteracted: payload.actionSubject
            }));
            if ((0, $iDrrr.fg)('kd_fix_nl2jql_mau_instrumentation')) {
                if (payload.actionSubject === 'link') {
                    fireEngagementEvent((0, $bZMnB.SainAction).JIRA_NL_TO_JQL_WORK_ITEM_CLICKED);
                    fireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
                        ...commonAttributes,
                        elementInteracted: 'jira-issue-key',
                        answerString: jql ? (0, $9oghv.sha256Hash)(jql) : '',
                        jiraNlToJqlCardVariant: 'smartlink',
                        isAuxClick: payload.attributes?.clickType === 'middle'
                    }));
                } else {
                    fireEngagementEvent((0, $bZMnB.SainAction).JIRA_NL_TO_JQL_CLICKED);
                    fireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
                        ...commonAttributes,
                        elementInteracted: payload.actionSubject,
                        jiraNlToJqlCardVariant: 'smartlink'
                    }));
                }
            }
        }
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireEngagementEvent,
        jql,
        analyticsAttributes
    ]);
    const onViewAllButtonClicked = (0, $cozmU.useCallback)((e)=>{
        const isAuxClick = e?.button === 1;
        const isContextMenu = e?.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
            ...commonAttributes,
            elementInteracted: 'jira-view-all-button',
            answerString: jql ? (0, $9oghv.sha256Hash)(jql) : '',
            jiraNlToJqlCardVariant: 'smartlink',
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        if ((0, $iDrrr.fg)('kd_fix_nl2jql_mau_instrumentation')) fireEngagementEvent((0, $bZMnB.SainAction).JIRA_NL_TO_JQL_VIEW_ALL);
    }, [
        fireAnalyticsEvent,
        fireEngagementEvent,
        commonAttributes,
        jql
    ]);
    const onExpandButtonClicked = (0, $cozmU.useCallback)(()=>{
        animation.onExpandClick();
        fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)({
            ...commonAttributes,
            jiraNlToJqlCardVariant: 'smartlink'
        }));
        fireEngagementEvent((0, $bZMnB.SainAction).EXPAND_CLICKED);
    }, [
        animation,
        fireAnalyticsEvent,
        commonAttributes,
        fireEngagementEvent
    ]);
    const onCollapseButtonClicked = (0, $cozmU.useCallback)(()=>{
        animation.onCollapseClick();
        fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)({
            ...commonAttributes,
            jiraNlToJqlCardVariant: 'smartlink'
        }));
    }, [
        animation,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    const onHideButtonClicked = (0, $cozmU.useCallback)(()=>{
        animation.onHideClick();
        fireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
            ...commonAttributes,
            elementInteracted: 'jira-hide-table-button',
            jiraNlToJqlCardVariant: 'smartlink'
        }));
    }, [
        animation,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    const onRevealButtonClicked = (0, $cozmU.useCallback)(()=>{
        animation.onRevealClick();
        fireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
            ...commonAttributes,
            elementInteracted: 'jira-reveal-table-button',
            jiraNlToJqlCardVariant: 'smartlink'
        }));
    }, [
        animation,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    if (jqlLoading) return /*#__PURE__*/ $cozmU.createElement((0, $b3ffN.AnimatedWrapper), null, /*#__PURE__*/ $cozmU.createElement((0, $aiIBH.SmartAnswerCardBodyGenerating), {
        heightOverride: "jiraNlToJqlSmartlinkCard"
    }));
    if (jqlError || !jql) return /*#__PURE__*/ $cozmU.createElement((0, $162db3c479f357e1$export$bcbdfb57198b378b), {
        query: query,
        viewAllUrl: errorCardViewAllUrl,
        onViewAllClick: onViewAllButtonClicked
    });
     // When expanded with 5–10 rows, use height auto so the table isn't stuck at a fixed tall height
    const useAutoHeightWhenExpanded = expandToAuto && animation.isExpanded;
    const useFixedTableHeight = !isDatasourceResolved || showExpandButton && !useAutoHeightWhenExpanded;
    const tableScrollHeight = isDatasourceResolved ? animation.animatedTableHeight : $51159ee7c0863918$var$DATASOURCE_LOADING_TABLE_HEIGHT;
    const tableContainerHeight = useFixedTableHeight ? tableScrollHeight + $51159ee7c0863918$var$TABLE_FOOTER_HEIGHT : 'auto';
    const scrollableContainerHeight = useFixedTableHeight ? tableScrollHeight : undefined;
    const contentWrapperHeight = animation.revealHeightZero || animation.isHidden ? 0 : useFixedTableHeight ? tableScrollHeight + $51159ee7c0863918$var$TABLE_FOOTER_HEIGHT + $51159ee7c0863918$var$CONTENT_BELOW_TABLE_HEIGHT + $51159ee7c0863918$var$CONTENT_WRAPPER_PADDING_TOP_PX : 'auto';
    const headerSection = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
        label: "AI Content",
        size: "medium"
    }), /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall",
        as: "h2"
    }, formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).smartlinkCardTitle))), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, jiraSearchUrl ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $51159ee7c0863918$var$styles.viewAllContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $f0ebab6d2240cdcf$export$28a2392dc2b2dd58), {
        url: jiraSearchUrl,
        callback: onViewAllButtonClicked,
        spacing: "compact"
    })) : null, !animation.isHidden && showExpandButton && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "default",
        onClick: animation.isExpanded ? onCollapseButtonClicked : onExpandButtonClicked,
        testId: "jira-sain-card-expand-collapse-button",
        icon: animation.isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($3UfFE))) : (0, (/*@__PURE__*/$parcel$interopDefault($4ESzI))),
        spacing: "compact",
        label: animation.isExpanded ? formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).collapse) : formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).expand),
        isTooltipDisabled: false
    }), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "default",
        onClick: animation.isHidden ? onRevealButtonClicked : onHideButtonClicked,
        testId: animation.isHidden ? 'jira-sain-card-reveal-button' : 'jira-sain-card-hide-button',
        icon: animation.isHidden ? (0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))) : (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))),
        spacing: "compact",
        label: animation.isHidden ? formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).unhide) : formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).hide),
        isTooltipDisabled: false
    })));
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $51159ee7c0863918$var$styles.container,
        testId: "jira-nl-to-jql-card-wrapper"
    }, headerSection, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $51159ee7c0863918$var$styles.resizingContentWrapper,
        testId: "jira-nl-to-jql-content-wrapper",
        style: {
            paddingTop: animation.revealHeightZero || animation.isHidden ? 0 : "var(--ds-space-150, 12px)",
            // this is a false positive, the height is not static
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            height: contentWrapperHeight,
            transition: animationsEnabled && (animation.isHidden || animation.contentWrapperTransitioning) ? `${$51159ee7c0863918$var$CONTENT_WRAPPER_HEIGHT_TRANSITION}, ${$51159ee7c0863918$var$CONTENT_WRAPPER_PADDING_TOP_TRANSITION}` : 'none'
        },
        onTransitionEnd: animation.onContentWrapperTransitionEnd
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- opacity transition for hide/reveal
    ), {
        style: {
            opacity: animationsEnabled && (animation.isHidden || animation.justRevealed) ? 0 : 1,
            transition: animationsEnabled && (animation.isHidden || animation.contentWrapperTransitioning) ? $51159ee7c0863918$var$CONTENT_WRAPPER_OPACITY_TRANSITION : 'none'
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $51159ee7c0863918$var$styles.tableContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            height: tableContainerHeight
        },
        ref: tableScrollContainerRef
    }, /*#__PURE__*/ $cozmU.createElement((0, $3d3WW.default), {
        channel: "media",
        onEvent: handleDatasourceAnalyticsEvent
    }, /*#__PURE__*/ $cozmU.createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: {
            attributes: {
                ...analyticsAttributesWithoutUGC,
                location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_JIRA_NL_TO_JQL_CARD
            },
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_JIRA_NL_TO_JQL_CARD
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $aK1EY.DatasourceTableViewWithWrappers), {
        datasourceId: (0, $b1qV0.JIRA_LIST_OF_LINKS_DATASOURCE_ID),
        parameters: {
            cloudId: cloudId,
            jql: jql
        },
        url: jiraSearchUrl ?? undefined,
        scrollableContainerHeight: scrollableContainerHeight
    }))))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true,
        showCopyButton: true,
        copyText: jiraSearchUrl ?? ''
    }))))));
});



var $dsm4u = parcelRequire("dsm4u");

/* VisualKnowledgeCard.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $cJ0FD = parcelRequire("cJ0FD");












var $eN8p6 = parcelRequire("eN8p6");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");








var $a9aSv = parcelRequire("a9aSv");


var $jttUL = parcelRequire("jttUL");

const $7e6c8f186625f3e4$var$DEFAULT_SKELETON_COUNT = 4;
const $7e6c8f186625f3e4$var$styles = {
    skeletonItem: "_3YEZNOdnbC _39xV024chP"
}; /**
    * __ImagesSkeleton__
    *
    * A skeleton placeholder that mirrors the layout of the `Images` component
    * while image data is loading. Renders shimmering placeholders inside a
    * `Carousel` container.
    *
    * Provide `aria-label` with a translated string such as "Loading related images"
    * to announce the loading state to screen readers.
    */ 
const $7e6c8f186625f3e4$export$83c1b29561e0555a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ImagesSkeleton(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { heading: heading, "aria-label": ariaLabel } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = Array.from({
            length: $7e6c8f186625f3e4$var$DEFAULT_SKELETON_COUNT
        }, $7e6c8f186625f3e4$var$_temp);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== heading) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $jttUL.Carousel), {
            heading: heading
        }, t1);
        $[1] = heading;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== ariaLabel || $[4] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            role: "status",
            "aria-label": ariaLabel,
            "aria-busy": "true"
        }, t2);
        $[3] = ariaLabel;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function ImagesSkeleton({ heading: heading, 'aria-label': ariaLabel }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        role: "status",
        "aria-label": ariaLabel,
        "aria-busy": "true"
    }, /*#__PURE__*/ $cozmU.createElement((0, $jttUL.Carousel), {
        heading: heading
    }, Array.from({
        length: $7e6c8f186625f3e4$var$DEFAULT_SKELETON_COUNT
    }, (_, index)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: index,
            xcss: $7e6c8f186625f3e4$var$styles.skeletonItem
        }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "100%",
            height: "150px",
            borderRadius: "var(--ds-radius-large, 8px)",
            isShimmering: true,
            testId: `images-skeleton-item-${index}`
        })))));
};
function $7e6c8f186625f3e4$var$_temp(_, index) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        key: index,
        xcss: $7e6c8f186625f3e4$var$styles.skeletonItem
    }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "100%",
        height: "150px",
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true,
        testId: `images-skeleton-item-${index}`
    }));
}






var $1mpi6 = parcelRequire("1mpi6");



















function $0c511e94a5ddad93$export$b49ab013235250d9() {
    const lastRunKey = (0, $cozmU.useRef)(null);
    return (0, $cozmU.useCallback)((key, action)=>{
        if (key === null || key === undefined) return;
        if (lastRunKey.current === key) return;
        lastRunKey.current = key;
        action();
    }, []);
}














const $0de40b4d8c1636a6$var$IMAGE_SEARCH_URL = '/gateway/api/assist/api/rovo/v1/image-search';
const $0de40b4d8c1636a6$var$DEFAULT_IMAGE_SEARCH_LIMIT = 20;
async function $0de40b4d8c1636a6$export$be0d73ca56f1a1d({ searchQuery: searchQuery, cloudId: cloudId, workspaceId: workspaceId, product: product, limit: limit = $0de40b4d8c1636a6$var$DEFAULT_IMAGE_SEARCH_LIMIT }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': product,
                'X-Experience-Id': 'ai-mate',
                'X-Cloudid': cloudId,
                ...(0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: product
                })
            },
            body: JSON.stringify({
                searchQuery: searchQuery,
                limit: limit
            })
        }
    };
    return (0, $gABt9.utils).requestService({
        url: $0de40b4d8c1636a6$var$IMAGE_SEARCH_URL
    }, options);
}


const $a2b5d773fabc49f3$export$316e28c88346523f = ({ searchQuery: searchQuery, cloudId: cloudId, workspaceId: workspaceId, product: product })=>{
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(false);
    const [images, setImages] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                setLoading(true);
                setError(false);
                const data = await (0, $0de40b4d8c1636a6$export$be0d73ca56f1a1d)({
                    searchQuery: searchQuery,
                    cloudId: cloudId,
                    workspaceId: workspaceId,
                    product: product
                });
                const filteredImages = data.images.filter((image)=>image.url && image.thumbnailUrl);
                setImages(filteredImages);
            } catch (e) {
                (0, $cuvLu.logger).error({
                    error: e,
                    functionName: 'useImages'
                });
                setError(true);
            } finally{
                setLoading(false);
            }
        };
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        images: images,
        loading: loading,
        error: error
    };
};


var $b574ea4305b1efef$exports = {};
$b574ea4305b1efef$exports = new URL("visual-knowledge-card-empty-dark.4b1b4fc7.svg", import.meta.url).toString();


var $6821377106e67a2b$exports = {};
$6821377106e67a2b$exports = new URL("visual-knowledge-card-empty-light.74a7204b.svg", import.meta.url).toString();


var $feed221c694a57aa$exports = {};
$feed221c694a57aa$exports = new URL("visual-knowledge-card-error-dark.86770ffd.svg", import.meta.url).toString();


var $a170e3a0c9804798$exports = {};
$a170e3a0c9804798$exports = new URL("visual-knowledge-card-error-light.a73803d2.svg", import.meta.url).toString();


const $472bcf0ba3d83c5e$export$776be90c8b2f701e = 4;
const $472bcf0ba3d83c5e$var$IMAGE_THUMBNAIL_LOCATION = 'imageThumbnail';
const $472bcf0ba3d83c5e$var$IMAGE_SOURCE_LINK_LOCATION = 'imageSourceLink';
const $472bcf0ba3d83c5e$var$IMAGE_CAROUSEL_ARROW_LOCATION = 'imageCarouselArrow';
const $472bcf0ba3d83c5e$var$messages = (0, $kSwu1.defineMessages)({
    heading: {
        id: "search_ai.visual_knowledge_card.heading",
        defaultMessage: "Images"
    },
    loadingLabel: {
        id: "search_ai.visual_knowledge_card.loading_label",
        defaultMessage: "Loading images"
    },
    statusBodyText: {
        id: "search_ai.visual_knowledge_card.body_text",
        defaultMessage: "Try searching again."
    },
    errorTitle: {
        id: "search_ai.visual_knowledge_card.error_title",
        defaultMessage: "Something went wrong and we couldn't find related images."
    },
    emptyTitle: {
        id: "search_ai.visual_knowledge_card.empty_title",
        defaultMessage: "We couldn't find any images for this search."
    }
});
const $472bcf0ba3d83c5e$var$styles = {
    stateContainer: "_0bjKvD8fU6 _0KLXrunmFW _0Of8r22ADO _1Znuxb5zaO _1wydGW2ADO _2Zuz6Q5zaO",
    title: "_2sNsIgmnOE _1UtDYzKGUX",
    body: "_2sNsIg7NXe _1UtDYzKGUX"
};
const $472bcf0ba3d83c5e$var$VisualKnowledgeCardStatusMessage = ({ heading: heading, imageSrc: imageSrc, imageSrcDark: imageSrcDark, title: title, body: body })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xsmall"
    }, heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $472bcf0ba3d83c5e$var$styles.stateContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: imageSrc,
        srcDark: imageSrcDark,
        width: 72,
        height: 72,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $472bcf0ba3d83c5e$var$styles.title
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $472bcf0ba3d83c5e$var$styles.body
    }, body)))));
const $472bcf0ba3d83c5e$export$cf8f12b9d9c373ce = ({ onFMPReached: onFMPReached })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, query: query, queryHash: queryHash, workspaceId: workspaceId } = commonAttributes;
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { images: images, loading: loading, error: error } = (0, $a2b5d773fabc49f3$export$316e28c88346523f)({
        searchQuery: query,
        cloudId: cloudId,
        workspaceId: workspaceId,
        product: sourceProduct ?? ''
    });
    const buildAnalyticsAttributes = (0, $cozmU.useCallback)(()=>({
            searchSessionId: commonAttributes.searchSessionId,
            queryHash: commonAttributes.queryHash,
            brand: commonAttributes.brand,
            source: commonAttributes.source,
            query: commonAttributes.query,
            answerString: commonAttributes.answerString,
            // The card's own identity; the dialog-level commonAttributes.answerCardType is broader (SAIN).
            answerCardType: (0, $zzZbq.AnswerCardType).VISUAL,
            imageMaxVisibleCount: $472bcf0ba3d83c5e$export$776be90c8b2f701e,
            isHello: (0, $aTjYs.isHello)(commonAttributes.cloudId)
        }), [
        commonAttributes
    ]);
    const runImpressionOncePerQuery = (0, $0c511e94a5ddad93$export$b49ab013235250d9)();
    const hasImages = !loading && !error && !!images && images.length > 0;
    (0, $cozmU.useEffect)(()=>{
        if (!hasImages) return;
        runImpressionOncePerQuery(queryHash, ()=>{
            onFMPReached();
            trackAIInteractionInit();
            fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
            fireAnalyticsEvent((0, $1mpi6.onNonGenerativeAIAnswerResultShown)({
                ...buildAnalyticsAttributes(),
                imageCount: images.length
            }));
        });
    }, [
        hasImages,
        queryHash,
        images,
        commonAttributes,
        buildAnalyticsAttributes,
        trackAIInteractionInit,
        fireSAINUsageEvent,
        fireAnalyticsEvent,
        runImpressionOncePerQuery,
        onFMPReached
    ]);
    const handleImageClick = (0, $cozmU.useCallback)((index)=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $jtIlq.onNonGenerativeKnowledgeCardLinkClick)({
            ...buildAnalyticsAttributes(),
            location: $472bcf0ba3d83c5e$var$IMAGE_THUMBNAIL_LOCATION,
            imageIndex: index,
            imageCount: images?.length,
            imageSimilarity: images?.[index]?.similarity
        }));
    }, [
        buildAnalyticsAttributes,
        commonAttributes,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        images
    ]);
    const handleSourceLinkClick = (0, $cozmU.useCallback)((index)=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $jtIlq.onNonGenerativeKnowledgeCardLinkClick)({
            ...buildAnalyticsAttributes(),
            location: $472bcf0ba3d83c5e$var$IMAGE_SOURCE_LINK_LOCATION,
            imageIndex: index,
            imageCount: images?.length,
            imageSimilarity: images?.[index]?.similarity
        }));
    }, [
        buildAnalyticsAttributes,
        commonAttributes,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        images
    ]);
    const handleCarouselArrowClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $jtIlq.onNonGenerativeKnowledgeCardLinkClick)({
            ...buildAnalyticsAttributes(),
            location: $472bcf0ba3d83c5e$var$IMAGE_CAROUSEL_ARROW_LOCATION,
            imageCount: images?.length
        }));
    }, [
        buildAnalyticsAttributes,
        fireAnalyticsEvent,
        images
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7e6c8f186625f3e4$export$83c1b29561e0555a), {
        heading: formatMessage($472bcf0ba3d83c5e$var$messages.heading),
        "aria-label": formatMessage($472bcf0ba3d83c5e$var$messages.loadingLabel)
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($472bcf0ba3d83c5e$var$VisualKnowledgeCardStatusMessage, {
        heading: formatMessage($472bcf0ba3d83c5e$var$messages.heading),
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($a170e3a0c9804798$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($feed221c694a57aa$exports))),
        title: formatMessage($472bcf0ba3d83c5e$var$messages.errorTitle),
        body: formatMessage($472bcf0ba3d83c5e$var$messages.statusBodyText)
    });
    if (!images || images.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($472bcf0ba3d83c5e$var$VisualKnowledgeCardStatusMessage, {
        heading: formatMessage($472bcf0ba3d83c5e$var$messages.heading),
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($6821377106e67a2b$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($b574ea4305b1efef$exports))),
        title: formatMessage($472bcf0ba3d83c5e$var$messages.emptyTitle),
        body: formatMessage($472bcf0ba3d83c5e$var$messages.statusBodyText)
    });
    const mappedImages = images.map((image)=>({
            altText: image.altText,
            imageUrl: image.thumbnailUrl,
            sourceTitle: image.title,
            sourceUrl: image.url
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eN8p6.Images), {
        heading: formatMessage($472bcf0ba3d83c5e$var$messages.heading),
        images: mappedImages,
        maxVisibleCount: $472bcf0ba3d83c5e$export$776be90c8b2f701e,
        onCarouselArrowClick: handleCarouselArrowClick,
        onImageClick: handleImageClick,
        onSourceLinkClick: handleSourceLinkClick
    });
};


/* agent-knowledge-card.tsx generated by @compiled/babel-plugin v3.0.1 */ 













var $eKpjD = parcelRequire("eKpjD");


var $6gGPb = parcelRequire("6gGPb");










/* knowledge-carousel.tsx generated by @compiled/babel-plugin v3.0.1 */ 






var $5Sv3D = parcelRequire("5Sv3D");





var $kdlgT = parcelRequire("kdlgT");


var $aRvnq = parcelRequire("aRvnq");










/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 


const $223e2747cf2a82ba$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    scrollLeft: {
        id: "search_ai.knowledge_carousel.scroll_left",
        defaultMessage: "Scroll left"
    },
    scrollRight: {
        id: "search_ai.knowledge_carousel.scroll_right",
        defaultMessage: "Scroll right"
    }
});


const $ec82c8c1e1d8eeb1$var$styles = {
    scrollContainerStyle: "_2mHwu85zaO _0hPCNLFlnN _3iDTPbQ4SZ _4bt5LAIZbP _3oUqlsYbGa _1ANEUSLRg7"
};
const $ec82c8c1e1d8eeb1$var$isScrollable = (elem)=>elem ? elem.scrollWidth > elem.clientWidth : false;
const $ec82c8c1e1d8eeb1$var$isScrollAtLeftEdge = (elem)=>elem ? elem.scrollLeft <= 1 : false;
const $ec82c8c1e1d8eeb1$var$isScrollAtRightEdge = (elem)=>elem ? elem?.scrollWidth - elem?.scrollLeft - elem?.clientWidth <= 1 : false;
const $ec82c8c1e1d8eeb1$export$61c045a5252abd1d = ({ children: children, heading: heading, scrollOffset: scrollOffset })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const scrollContainerRef = (0, $cozmU.useRef)(null);
    const [isContentScrollable, setIsContentScrollable] = (0, $cozmU.useState)(false);
    const [shouldDisableLeftArrowButton, setShouldDisableLeftArrowButton] = (0, $cozmU.useState)(true);
    const [shouldDisableRightArrowButton, setShouldDisableRightArrowButton] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setIsContentScrollable($ec82c8c1e1d8eeb1$var$isScrollable(scrollContainerRef.current));
        setShouldDisableLeftArrowButton($ec82c8c1e1d8eeb1$var$isScrollAtLeftEdge(scrollContainerRef.current));
        setShouldDisableRightArrowButton($ec82c8c1e1d8eeb1$var$isScrollAtRightEdge(scrollContainerRef.current));
    }, []);
    const [onScroll] = (0, $5Sv3D.default)(()=>{
        setShouldDisableLeftArrowButton($ec82c8c1e1d8eeb1$var$isScrollAtLeftEdge(scrollContainerRef.current));
        setShouldDisableRightArrowButton($ec82c8c1e1d8eeb1$var$isScrollAtRightEdge(scrollContainerRef.current));
    }, 10);
    const scrollLeft = ()=>{
        setShouldDisableRightArrowButton(false);
        scrollContainerRef.current?.scrollBy({
            top: 0,
            left: -scrollOffset,
            behavior: 'smooth'
        });
    };
    const scrollRight = ()=>{
        setShouldDisableLeftArrowButton(false);
        scrollContainerRef.current?.scrollBy({
            top: 0,
            left: scrollOffset,
            behavior: 'smooth'
        });
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, typeof heading === 'string' ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "large",
        weight: "semibold"
    }, heading) : heading, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050"
    }, isContentScrollable ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        shape: "circle",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        isTooltipDisabled: true,
        label: formatMessage((0, $223e2747cf2a82ba$export$defe85febe8b728c).scrollLeft),
        onClick: scrollLeft,
        spacing: "compact",
        isDisabled: shouldDisableLeftArrowButton
    }), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        shape: "circle",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
        isTooltipDisabled: true,
        label: formatMessage((0, $223e2747cf2a82ba$export$defe85febe8b728c).scrollRight),
        onClick: scrollRight,
        spacing: "compact",
        isDisabled: shouldDisableRightArrowButton
    })) : null)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: scrollContainerRef,
        onScroll: onScroll,
        xcss: $ec82c8c1e1d8eeb1$var$styles.scrollContainerStyle
    }, children));
};









var $1hQ0e = parcelRequire("1hQ0e");







const $6aa1c731e5464443$export$48c2363cbebfe859 = (props)=>{
    const { source: source, elementType: elementType } = props;
    return {
        action: 'viewed',
        actionSubject: 'aiResultHover',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            elementType: elementType
        }
    };
};





const $5a2790b37fbfb80b$export$ccaa86fdb4ea3d58 = (props)=>{
    const { source: source, elementType: elementType, hoverTime: hoverTime } = props;
    return {
        action: 'dismissed',
        actionSubject: 'aiResultHover',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            elementType: elementType,
            hoverTime: hoverTime
        }
    };
};





const $44276ea9228fcce0$var$document = (0, $1hQ0e.getDocument)();
// Timeout constants for hover behavior, these come from the people and teams profilecard package
const $44276ea9228fcce0$var$HOVER_START_DELAY = 800; // Delay before starting hover on trigger
const $44276ea9228fcce0$var$HOVER_END_DELAY = 250; // Delay before ending hover when mouse leaves elements
const $44276ea9228fcce0$export$79db6a77ac4a8ace = ({ elementType: elementType, onHoverStart: onHoverStart, onHoverStop: onHoverStop, hoverCardSelector: hoverCardSelector, hoverStartDelay: hoverStartDelay = $44276ea9228fcce0$var$HOVER_START_DELAY, hoverEndDelay: hoverEndDelay = $44276ea9228fcce0$var$HOVER_END_DELAY })=>{
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [isHovering, setIsHovering] = (0, $cozmU.useState)(false);
    const hoverStartTimeRef = (0, $cozmU.useRef)(null);
    const isOnTriggerRef = (0, $cozmU.useRef)(false);
    const isOnHoverCardRef = (0, $cozmU.useRef)(false);
    /**
   * Checks if the mouse is currently over the hover card element.
   */ const isMouseOnHoverCard = (0, $cozmU.useCallback)((event)=>{
        if (!$44276ea9228fcce0$var$document) return false;
        const hoverCardElement = $44276ea9228fcce0$var$document.querySelector(hoverCardSelector);
        if (!hoverCardElement) return false;
        return hoverCardElement.contains(event.target);
    }, [
        hoverCardSelector
    ]);
    /**
   * Handles mouse movement to track position relative to hover card and manage hover state.
   */ const handleMouseMove = (0, $cozmU.useCallback)((event)=>{
        const isOnHoverCard = isMouseOnHoverCard(event);
        isOnHoverCardRef.current = isOnHoverCard;
        // If mouse leaves hover card, check if we should end hover after delay
        if (!isOnHoverCard) setTimeout(()=>{
            // End hover if mouse is not on either element after delay
            if (!isOnHoverCardRef.current && hoverStartTimeRef.current && !isOnTriggerRef.current) {
                const hoverTime = Date.now() - hoverStartTimeRef.current;
                hoverStartTimeRef.current = null;
                if (onHoverStop) onHoverStop(hoverTime);
                else fireAnalyticsEvent((0, $5a2790b37fbfb80b$export$ccaa86fdb4ea3d58)({
                    elementType: elementType,
                    hoverTime: hoverTime,
                    ...commonAttributes
                }));
                setIsHovering(false);
            }
        }, hoverEndDelay);
    }, [
        isMouseOnHoverCard,
        onHoverStop,
        fireAnalyticsEvent,
        commonAttributes,
        elementType,
        hoverEndDelay
    ]);
    /**
   * Handles the start of a hover interaction on the trigger.
   * Manages hover state and prevents duplicate hover interactions.
   */ const handleHoverStart = (0, $cozmU.useCallback)((event)=>{
        // Don't start hover if mouse is already on hover card
        const isOnHoverCard = isMouseOnHoverCard(event.nativeEvent);
        if (isOnHoverCard) return;
        // Check if hover card is currently open
        let anyHoverCardOpen;
        if ($44276ea9228fcce0$var$document) anyHoverCardOpen = $44276ea9228fcce0$var$document.querySelector(hoverCardSelector);
        // If hover card is open and we're already hovering, continue existing hover
        if (anyHoverCardOpen && isHovering) {
            isOnTriggerRef.current = true;
            return;
        }
        // Don't start new hover if hover card is already open
        if (anyHoverCardOpen) return;
        isOnTriggerRef.current = true;
        // Start hover after delay to prevent premature triggering
        setTimeout(()=>{
            // Only start hover if user is still on trigger after delay
            if (!isHovering && isOnTriggerRef.current) {
                const startTime = Date.now();
                hoverStartTimeRef.current = startTime;
                setIsHovering(true);
                if (onHoverStart) onHoverStart();
                else fireAnalyticsEvent((0, $6aa1c731e5464443$export$48c2363cbebfe859)({
                    elementType: elementType,
                    ...commonAttributes
                }));
            }
        }, hoverStartDelay);
    }, [
        elementType,
        onHoverStart,
        fireAnalyticsEvent,
        commonAttributes,
        isHovering,
        isMouseOnHoverCard,
        hoverCardSelector,
        hoverStartDelay
    ]);
    /**
   * Handles the end of a hover interaction on the trigger.
   * Updates trigger state to track mouse position.
   */ const handleHoverLeave = (0, $cozmU.useCallback)(()=>{
        isOnTriggerRef.current = false;
    }, []);
    // Set up global mouse move tracking
    (0, $cozmU.useEffect)(()=>{
        if (!$44276ea9228fcce0$var$document) return;
        const removeMouseMoveListener = (0, $cbY7C.bind)($44276ea9228fcce0$var$document, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        return ()=>{
            removeMouseMoveListener();
        };
    }, [
        handleMouseMove
    ]);
    return {
        isHovering: isHovering,
        handleHoverStart: handleHoverStart,
        handleHoverLeave: handleHoverLeave
    };
};






var $jXQUy = parcelRequire("jXQUy");

/* knowledge-card-loading.tsx generated by @compiled/babel-plugin v3.0.1 */ 




























var $7qJqb = parcelRequire("7qJqb");




const $935ec00e5e72a55d$export$91710431dd421e57 = (props, isAnimated)=>{
    const { query: query, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'knowledgeCardLoadingDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            isAnimated: isAnimated
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};









var $9LgVw = parcelRequire("9LgVw");

const $4fd6fa5a10eca60c$var$styles = {
    containerNewSAINLoading: "_1Znuxb5zaO _2Zuz6Q5zaO _0Of8r25zaO _1wydGW5zaO _0jFU0Vk3g7",
    inline: "_2Zuz6Q2ADO _1Znuxb2ADO _0jFU0VUF4f",
    agentCardHeightOverride: "_0jFU0VEayI"
};
const $4fd6fa5a10eca60c$var$messages = (0, $kSwu1.defineMessages)({
    knowledge_card_loading: {
        id: "search_ai.knowledge_card_loading",
        defaultMessage: "Searching across your connected apps"
    },
    knowledge_card_rovo_is_thinking: {
        id: "search_ai.knowledge_card_rovo_is_thinking",
        defaultMessage: "Rovo is thinking"
    }
});
function $4fd6fa5a10eca60c$export$a08238eb59773648({ queryIntent: queryIntent }) {
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $935ec00e5e72a55d$export$91710431dd421e57)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3ffN.AnimatedWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: (0, $w6R6I.cx)($4fd6fa5a10eca60c$var$styles.containerNewSAINLoading, queryIntent === (0, $zzZbq.QueryIntent).AGENT && $4fd6fa5a10eca60c$var$styles.agentCardHeightOverride),
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: 'space.100',
        xcss: $4fd6fa5a10eca60c$var$styles.inline,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9LgVw))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: 'color.text.subtle'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4fd6fa5a10eca60c$var$messages.knowledge_card_rovo_is_thinking)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7qJqb.RovoGeneratingAnimation), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "16px",
        color: "var(--ds-skeleton-subtle, #17171708)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "16px",
        color: "var(--ds-skeleton-subtle, #17171708)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "90%",
        height: "16px",
        color: "var(--ds-skeleton-subtle, #17171708)"
    })));
}



var $9T3jg = parcelRequire("9T3jg");




const $d80ef16958371a2e$export$885a78bb6bce677d = (props)=>{
    const { source: source, agentId: agentId, position: position } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAgentKnowledgeCardCarousel',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            agentId: agentId,
            position: position
        }
    };
};





const $9dbfa7cbc81cad25$export$6266151addd8e413 = (props)=>{
    const { source: source, agentCount: agentCount } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAgentKnowledgeCardCarousel',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            agentCount: agentCount
        }
    };
};





const $46b3e6d1a35c49a1$export$4ce3543705832c97 = (props)=>{
    const { source: source, agentId: agentId } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAgentKnowledgeCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            agentId: agentId
        }
    };
};





const $19a6060145576e12$export$44d9aa4134474084 = (props)=>{
    const { source: source, cardType: cardType } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'knowledgeCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            cardType: cardType
        }
    };
};


/* separator-line.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $8ba51f29bf3689a9$var$styles = {
    lineRefresh: "_0jFU0VHZdu _39xV02N91d _0KLXruG6qS"
};
const $8ba51f29bf3689a9$export$4fb305a2fc986af3 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $8ba51f29bf3689a9$var$styles.lineRefresh
    });




























var $cb86z = parcelRequire("cb86z");


var $3TiFP = parcelRequire("3TiFP");











var $j9SBi = parcelRequire("j9SBi");


var $15IyG = parcelRequire("15IyG");




const $0c4b83a6aec4026d$var$youSingularWorkedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.worked.today",
        defaultMessage: "You worked on this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.worked.yesterday",
        defaultMessage: "You worked on this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.worked.otherTime",
        defaultMessage: "You worked on this {time}"
    }
});
const $0c4b83a6aec4026d$var$youSingularCreatedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.created.today",
        defaultMessage: "You created this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.created.yesterday",
        defaultMessage: "You created this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.created.otherTime",
        defaultMessage: "You created this on {time}"
    }
});
const $0c4b83a6aec4026d$var$youSingularEditedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.edited.today",
        defaultMessage: "You edited this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.edited.yesterday",
        defaultMessage: "You edited this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.edited.otherTime",
        defaultMessage: "You edited this on {time}"
    }
});
const $0c4b83a6aec4026d$var$youSingularCommentedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.commented.today",
        defaultMessage: "You commented here today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.commented.yesterday",
        defaultMessage: "You commented here yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.commented.otherTime",
        defaultMessage: "You commented here on {time}"
    }
});
const $0c4b83a6aec4026d$var$youSingularUpdatedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.updated.today",
        defaultMessage: "You updated this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.updated.yesterday",
        defaultMessage: "You updated this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.updated.otherTime",
        defaultMessage: "You updated this on {time}"
    }
});
const $0c4b83a6aec4026d$var$otherSingularWorkedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.worked.today",
        defaultMessage: "{name} worked on this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.worked.yesterday",
        defaultMessage: "{name} worked on this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.worked.otherTime",
        defaultMessage: "{name} worked on this on {time}"
    }
});
const $0c4b83a6aec4026d$var$otherSingularCreatedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.created.today",
        defaultMessage: "{name} created this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.created.yesterday",
        defaultMessage: "{name} created this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.created.otherTime",
        defaultMessage: "{name} created this on {time}"
    }
});
const $0c4b83a6aec4026d$var$otherSingularEditedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.edited.today",
        defaultMessage: "{name} edited this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.edited.yesterday",
        defaultMessage: "{name} edited this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.edited.otherTime",
        defaultMessage: "{name} edited this on {time}"
    }
});
const $0c4b83a6aec4026d$var$otherSingularCommentedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.commented.today",
        defaultMessage: "{name} commented here today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.commented.yesterday",
        defaultMessage: "{name} commented here yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.commented.otherTime",
        defaultMessage: "{name} commented here on {time}"
    }
});
const $0c4b83a6aec4026d$var$otherSingularUpdatedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.updated.today",
        defaultMessage: "{name} updated this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.updated.yesterday",
        defaultMessage: "{name} updated this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.updated.otherTime",
        defaultMessage: "{name} updated this on {time}"
    }
});
const $0c4b83a6aec4026d$var$youPluralActivityMessages = (0, $kSwu1.defineMessages)({
    double: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_plural.double",
        defaultMessage: "You and {name1} have both worked on this"
    },
    triple: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_plural.triple",
        defaultMessage: "You, {name1}, and {name2} have all worked on this"
    },
    many: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_plural.many",
        defaultMessage: "You, {name1}, and {count} others have all worked on this"
    }
});
const $0c4b83a6aec4026d$var$otherPluralActivityMessages = (0, $kSwu1.defineMessages)({
    double: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_plural.double",
        defaultMessage: "{name1} and {name2} have both worked on this"
    },
    triple: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_plural.triple",
        defaultMessage: "{name1}, {name2}, and {name3} have all worked on this"
    },
    many: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_plural.many",
        defaultMessage: "{name1}, {name2}, and {count} others have all worked on this"
    }
});
const $0c4b83a6aec4026d$export$97eb62906ce0e051 = {
    worked: $0c4b83a6aec4026d$var$youSingularWorkedMessages,
    created: $0c4b83a6aec4026d$var$youSingularCreatedMessages,
    edited: $0c4b83a6aec4026d$var$youSingularEditedMessages,
    commented: $0c4b83a6aec4026d$var$youSingularCommentedMessages,
    updated: $0c4b83a6aec4026d$var$youSingularUpdatedMessages
};
const $0c4b83a6aec4026d$export$fca5bc54abc98673 = {
    worked: $0c4b83a6aec4026d$var$otherSingularWorkedMessages,
    created: $0c4b83a6aec4026d$var$otherSingularCreatedMessages,
    edited: $0c4b83a6aec4026d$var$otherSingularEditedMessages,
    commented: $0c4b83a6aec4026d$var$otherSingularCommentedMessages,
    updated: $0c4b83a6aec4026d$var$otherSingularUpdatedMessages
};
const $0c4b83a6aec4026d$export$b9d6808884fda53b = {
    you: $0c4b83a6aec4026d$var$youPluralActivityMessages,
    other: $0c4b83a6aec4026d$var$otherPluralActivityMessages
};


const $998049cf2dbeb756$export$4d98da88c6a5014a = ({ currentUserId: currentUserId, event: event, contributors: contributors, othersCount: othersCount, timestamp: timestamp, formatMessage: formatMessage, formatDate: formatDate })=>{
    const involvesCurrentUser = contributors.some((contributor)=>contributor.id === currentUserId);
    // If the event is singular with a single contributor
    if (contributors.length === 1) {
        const formattedDate = formatDate(timestamp, {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        });
        let message;
        switch(event){
            case 'created':
                message = involvesCurrentUser ? (0, $0c4b83a6aec4026d$export$97eb62906ce0e051).created : (0, $0c4b83a6aec4026d$export$fca5bc54abc98673).created;
                break;
            case 'edited':
                message = involvesCurrentUser ? (0, $0c4b83a6aec4026d$export$97eb62906ce0e051).edited : (0, $0c4b83a6aec4026d$export$fca5bc54abc98673).edited;
                break;
            case 'commented':
                message = involvesCurrentUser ? (0, $0c4b83a6aec4026d$export$97eb62906ce0e051).commented : (0, $0c4b83a6aec4026d$export$fca5bc54abc98673).commented;
                break;
            case 'updated':
                message = involvesCurrentUser ? (0, $0c4b83a6aec4026d$export$97eb62906ce0e051).updated : (0, $0c4b83a6aec4026d$export$fca5bc54abc98673).updated;
                break;
            case 'worked':
            default:
                message = involvesCurrentUser ? (0, $0c4b83a6aec4026d$export$97eb62906ce0e051).worked : (0, $0c4b83a6aec4026d$export$fca5bc54abc98673).worked;
                break;
        }
        if ((0, $j9SBi.default)(timestamp)) return involvesCurrentUser ? formatMessage(message.today) : formatMessage(message.today, {
            name: contributors[0].name
        });
        else if ((0, $15IyG.default)(timestamp)) return involvesCurrentUser ? formatMessage(message.yesterday) : formatMessage(message.yesterday, {
            name: contributors[0].name
        });
        else return involvesCurrentUser ? formatMessage(message.otherTime, {
            time: formattedDate
        }) : formatMessage(message.yesterday, {
            name: contributors[0].name,
            time: formattedDate
        });
    } else if (involvesCurrentUser) {
        const contributorsWithoutCurrentUser = contributors.filter((contributor)=>contributor.id !== currentUserId);
        if (othersCount > 0) return formatMessage((0, $0c4b83a6aec4026d$export$b9d6808884fda53b).you.many, {
            name1: contributorsWithoutCurrentUser[0].name,
            count: othersCount
        });
        else return contributors.length === 2 ? formatMessage((0, $0c4b83a6aec4026d$export$b9d6808884fda53b).you.double, {
            name1: contributorsWithoutCurrentUser[0].name
        }) : formatMessage((0, $0c4b83a6aec4026d$export$b9d6808884fda53b).you.triple, {
            name1: contributorsWithoutCurrentUser[0].name,
            name2: contributorsWithoutCurrentUser[1].name
        });
    } else {
        if (othersCount > 0) return formatMessage((0, $0c4b83a6aec4026d$export$b9d6808884fda53b).other.many, {
            name1: contributors[0].name,
            name2: contributors[1].name,
            count: othersCount
        });
        else return contributors.length === 2 ? formatMessage((0, $0c4b83a6aec4026d$export$b9d6808884fda53b).other.double, {
            name1: contributors[0].name,
            name2: contributors[1].name
        }) : formatMessage((0, $0c4b83a6aec4026d$export$b9d6808884fda53b).other.triple, {
            name1: contributors[0].name,
            name2: contributors[1].name,
            name3: contributors[2].name
        });
    }
};









var $aqqYN = parcelRequire("aqqYN");


var $1UlLI = parcelRequire("1UlLI");


const $cce772d1072e95eb$var$HoverCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("jAV5L")).then(({ HoverCard: HoverCard })=>({
            default: HoverCard
        })));
const $cce772d1072e95eb$export$65943680306d629 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ item: activity, onClickCallback: onClickCallback, searchAIAnalyticsContextData: searchAIAnalyticsContextData })=>{
    const { userDetails: { id: searcherId } } = (0, $3hVWe.useAIAnswerContext)();
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: searchAIAnalyticsContextData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cce772d1072e95eb$var$HoverCard, {
        url: activity.url,
        key: `knowledge-card-activity-${activity.url}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aqqYN.KnowledgeCardsRowRefresh), {
        primaryText: activity.title,
        secondaryText: `${activity.containerName} \u{2022} ${(0, $998049cf2dbeb756$export$4d98da88c6a5014a)({
            currentUserId: searcherId || '',
            event: activity.event,
            contributors: activity.contributors,
            othersCount: activity.othersCount,
            formatMessage: formatMessage,
            formatDate: formatDate,
            timestamp: new Date(activity.timestamp)
        })}`,
        pictureUrl: activity.iconUrl,
        type: (0, $1UlLI.KnowledgeCardsRowType).WORK,
        contentTypeName: activity.contentTypeName,
        onClick: ()=>{
            onClickCallback?.();
            window.open(activity.url, '_self', 'noopener, noreferrer');
        },
        onAuxClick: (e)=>{
            if (e.button !== 1) return;
            onClickCallback?.({
                isAuxClick: true
            });
            window.open(activity.url, '_blank', 'noopener, noreferrer');
        },
        onContextMenu: ()=>{
            onClickCallback?.({
                isContextMenu: true
            });
        }
    })))));
});


/* knowledge-card-body.tsx generated by @compiled/babel-plugin v3.0.1 */ 






var $ad7Ou = parcelRequire("ad7Ou");








var $i1t43 = parcelRequire("i1t43");



















const $572d81ab3ae88f65$export$b02bdd5f3105358f = ({ location: location, commonAttributes: commonAttributes })=>{
    const filtered = (0, $4Tg3t.filterCommonAttributes)(commonAttributes);
    return {
        location: location,
        attributes: {
            ...filtered,
            location: location
        }
    };
};












var $lPcf8 = parcelRequire("lPcf8");










const $acbcdb4ca700ade0$var$CardBodyWrapper = {
    default: "_1mT5xdRAKS _1Znuxb5zaO _2Zuz6Q5zaO"
};
const $acbcdb4ca700ade0$var$ColumnBottomPadding = {
    default: "_1wydGW1Y8M"
};
const $acbcdb4ca700ade0$var$DynamicRowStyling = {
    column: "_3iDTPbQ4SZ _0aFT5vbt8w _42d1HA1Y8M _17lj8p1Y8M",
    grid: "_3iDTPbgBM8 _2iEGP2Lmr7 _17lj8p5zaO _42d1HA1Y8M"
};
const $acbcdb4ca700ade0$var$EXPANDED_MAX_ITEMS_SHOWN = 6;
const $acbcdb4ca700ade0$var$MAX_ITEMS_SHOWN = 2;
const $acbcdb4ca700ade0$var$SINGLE_COLUMN_MAX_ITEMS_SHOWN = 4; // 2 rows * 2 items per row
const $acbcdb4ca700ade0$var$SINGLE_COLUMN_EXPANDED_MAX_ITEMS_SHOWN = 12; // 6 rows * 2 items per row
const $acbcdb4ca700ade0$export$ef08b123bd77f721 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ columnsConfig: columnsConfig, profileUrl: profileUrl, footerButtonText: footerButtonText, footerButtonAction: footerButtonAction, testId: testId })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setExpanded] = (0, $cozmU.useState)(false); // Determine if we should show a single column layout (when only one column has data)
    const hasDataColumns = columnsConfig.filter((config)=>config.data.length > 0);
    const showSingleColumn = hasDataColumns.length === 1; // Calculate total items across all columns for expand logic
    const totalItems = columnsConfig.reduce((sum, config)=>sum + config.data.length, 0);
    const shouldShowExpandButton = showSingleColumn ? totalItems > $acbcdb4ca700ade0$var$SINGLE_COLUMN_MAX_ITEMS_SHOWN : totalItems > $acbcdb4ca700ade0$var$MAX_ITEMS_SHOWN * columnsConfig.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $acbcdb4ca700ade0$var$CardBodyWrapper.default,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200"
    }, columnsConfig.map((columnConfig, columnIndex)=>{
        if (columnConfig.data.length === 0) return null;
        const maxItems = !isExpanded ? showSingleColumn ? $acbcdb4ca700ade0$var$SINGLE_COLUMN_MAX_ITEMS_SHOWN : $acbcdb4ca700ade0$var$MAX_ITEMS_SHOWN : Math.min(columnConfig.data.length, showSingleColumn ? $acbcdb4ca700ade0$var$SINGLE_COLUMN_EXPANDED_MAX_ITEMS_SHOWN : $acbcdb4ca700ade0$var$EXPANDED_MAX_ITEMS_SHOWN);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            key: columnIndex,
            grow: "fill",
            space: "space.050",
            xcss: $acbcdb4ca700ade0$var$ColumnBottomPadding.default
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingInlineStart: "space.200",
            paddingInlineEnd: "space.200",
            paddingBlockEnd: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            spread: "space-between",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall",
            as: "h3"
        }, columnConfig.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: columnConfig.viewAllLinkHref,
            appearance: "subtle",
            onClick: (e)=>{
                columnConfig.viewAllLinkOnClick(e);
            },
            onAuxClick: (e)=>{
                if (e.button !== 1) return;
                columnConfig.viewAllLinkOnClick(e);
            },
            onContextMenu: (e)=>{
                columnConfig.viewAllLinkOnClick(e);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, formatMessage((0, $cb86z.messages).knowledge_cards_view_all_link))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: showSingleColumn ? $acbcdb4ca700ade0$var$DynamicRowStyling.grid : $acbcdb4ca700ade0$var$DynamicRowStyling.column
        }, columnConfig.data.slice(0, maxItems).map((item, index)=>{
            // Calculate if this item is shown after card body expansion
            // For single column layout: items with index >= 4 are shown after expansion
            // For multi-column layout: items with index >= 2 are shown after expansion
            const shownAfterCardBodyExpanded = showSingleColumn ? index >= $acbcdb4ca700ade0$var$SINGLE_COLUMN_MAX_ITEMS_SHOWN && isExpanded : index >= $acbcdb4ca700ade0$var$MAX_ITEMS_SHOWN && isExpanded;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(columnConfig.component, {
                key: index,
                item: item,
                maxItems: maxItems,
                onClickCallback: columnConfig?.onClickCallback ? (opts)=>columnConfig.onClickCallback(index, shownAfterCardBodyExpanded, opts) : undefined,
                searchAIAnalyticsContextData: columnConfig.searchAIAnalyticsContextLocation ? (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
                    location: columnConfig.searchAIAnalyticsContextLocation,
                    commonAttributes: commonAttributes
                }) : undefined
            });
        }))))));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, shouldShowExpandButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignInline: "center",
        space: "space.025"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        href: profileUrl || '',
        onClick: ()=>{
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'footer-view-all'
            }));
            fireSAINUsageEvent({
                metCriteria: footerButtonAction,
                commonAttributes: commonAttributes
            });
        },
        onAuxClick: (e)=>{
            if (e.button !== 1) return;
            if (!(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'footer-view-all',
                isAuxClick: true
            }));
            fireSAINUsageEvent({
                metCriteria: footerButtonAction,
                commonAttributes: commonAttributes
            });
        },
        onContextMenu: ()=>{
            if (!(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'footer-view-all',
                isContextMenu: true
            }));
            fireSAINUsageEvent({
                metCriteria: footerButtonAction,
                commonAttributes: commonAttributes
            });
        },
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        weight: "medium"
    }, footerButtonText)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: ()=>{
            setExpanded((e)=>!e);
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'show-more'
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
                commonAttributes: commonAttributes
            });
        },
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        weight: "medium"
    }, formatMessage((0, $cb86z.messages).ai_answer_expand_button_label)))) : null));
});












var $7y6O1 = parcelRequire("7y6O1");















const $4e4c19c18699fbff$export$40f705aca7f6b285 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ item: teamData, onClickCallback: onClickCallback })=>{
    const { commonAttributes: commonAttributes, userDetails: userDetails } = (0, $3hVWe.useAIAnswerContext)();
    const { orgId: orgId } = commonAttributes;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const team = teamData.team;
    const teamUrl = (0, $df52b12138df743d$export$782629dc0d11ee5c)(team.id.split('/').pop() || team.id, orgId);
    const handleTeamClick = (e)=>{
        const isAuxClick = 'button' in e && e.button === 1;
        if (isAuxClick) window.open(teamUrl, '_blank', 'noopener,noreferrer');
        else window.open(teamUrl, '_self', 'noopener, noreferrer');
    };
    const { handleHoverStart: handleHoverStart, handleHoverLeave: handleHoverLeave } = (0, $44276ea9228fcce0$export$79db6a77ac4a8ace)({
        elementType: 'team',
        hoverCardSelector: '[data-testid="team-profilecard"]'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7y6O1.TeamProfileCardWithTrigger), {
        trigger: "hover",
        teamAri: team.id,
        cloudId: commonAttributes.cloudId,
        placement: "bottom-start",
        userId: userDetails.id || ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onMouseEnter: handleHoverStart,
        onMouseLeave: handleHoverLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aqqYN.KnowledgeCardsRowRefresh), {
        primaryText: team.displayName,
        secondaryText: formatMessage((0, $cb86z.messages).knowledge_cards_team_member_count, {
            count: teamData.memberCount
        }),
        pictureUrl: team.smallAvatarImageUrl,
        type: (0, $1UlLI.KnowledgeCardsRowType).AGENT,
        onClick: (e)=>{
            onClickCallback?.();
            handleTeamClick(e);
        },
        onAuxClick: (e)=>{
            if (e.button !== 1) return;
            onClickCallback?.({
                isAuxClick: true
            });
            handleTeamClick(e);
        },
        onContextMenu: ()=>{
            onClickCallback?.({
                isContextMenu: true
            });
        }
    })));
});


const $5c155516f42291cf$export$e35364d8cf1f1804 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ currentUserId: _currentUserId, teamsData: teamsData, activityData: activityData, profileUrl: profileUrl, viewAllUrl: _viewAllUrl })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleRecentWorkViewAllClick = (0, $cozmU.useMemo)(()=>(e)=>{
            const isAuxClick = 'button' in e && e.button === 1;
            const isContextMenu = 'button' in e && e.button === 2;
            if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'recent-work-view-all',
                isAuxClick: isAuxClick,
                isContextMenu: isContextMenu
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).RECENT_WORK_CLICKED,
                commonAttributes: commonAttributes
            });
        }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        commonAttributes
    ]);
    const handleAgentTeamsViewAllClick = (0, $cozmU.useMemo)(()=>(e)=>{
            const isAuxClick = 'button' in e && e.button === 1;
            const isContextMenu = 'button' in e && e.button === 2;
            if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'agent-teams-view-all',
                isAuxClick: isAuxClick,
                isContextMenu: isContextMenu
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).TEAM_LIST_CLICKED,
                commonAttributes: commonAttributes
            });
        }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        commonAttributes
    ]);
    // Determine which columns to render
    const hasRecentActivity = (0, $cozmU.useMemo)(()=>activityData && Array.isArray(activityData) && activityData.length > 0, [
        activityData
    ]);
    const hasTeams = (0, $cozmU.useMemo)(()=>teamsData?.teamSearch?.nodes && teamsData.teamSearch.nodes.length > 0, [
        teamsData?.teamSearch?.nodes
    ]);
    const columnsConfig = (0, $cozmU.useMemo)(()=>[
            // Teams Column
            ...hasTeams && teamsData?.teamSearch?.nodes ? [
                {
                    viewAllLinkOnClick: handleAgentTeamsViewAllClick,
                    viewAllLinkHref: profileUrl,
                    data: teamsData.teamSearch.nodes,
                    component: (0, $4e4c19c18699fbff$export$40f705aca7f6b285),
                    header: formatMessage((0, $cb86z.messages).knowledge_cards_teams_subheader),
                    onClickCallback: (position, shownAfterCardBodyExpanded, opts)=>{
                        if ((opts?.isAuxClick || opts?.isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
                        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                            ...commonAttributes,
                            location: 'team-list-item',
                            position: position,
                            shownAfterCardBodyExpanded: shownAfterCardBodyExpanded,
                            isAuxClick: opts?.isAuxClick,
                            isContextMenu: opts?.isContextMenu
                        }));
                        fireSAINUsageEvent({
                            metCriteria: (0, $bZMnB.SainAction).TEAM_LIST_ITEM_CLICKED,
                            commonAttributes: commonAttributes
                        });
                    }
                }
            ] : [],
            // Recent Activity Column
            ...hasRecentActivity ? [
                {
                    viewAllLinkOnClick: handleRecentWorkViewAllClick,
                    viewAllLinkHref: profileUrl,
                    data: activityData,
                    component: (0, $cce772d1072e95eb$export$65943680306d629),
                    header: formatMessage((0, $cb86z.messages).knowledge_cards_worked_on_subheader),
                    onClickCallback: (position, shownAfterCardBodyExpanded, opts)=>{
                        if ((opts?.isAuxClick || opts?.isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
                        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                            ...commonAttributes,
                            location: 'recent-work-item',
                            position: position,
                            shownAfterCardBodyExpanded: shownAfterCardBodyExpanded,
                            isAuxClick: opts?.isAuxClick,
                            isContextMenu: opts?.isContextMenu
                        }));
                        fireSAINUsageEvent({
                            metCriteria: (0, $bZMnB.SainAction).RECENT_WORK_CLICKED,
                            commonAttributes: commonAttributes
                        });
                    },
                    searchAIAnalyticsContextLocation: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_AGENT_CARD
                }
            ] : []
        ], [
        hasTeams,
        teamsData?.teamSearch.nodes,
        handleAgentTeamsViewAllClick,
        profileUrl,
        formatMessage,
        hasRecentActivity,
        handleRecentWorkViewAllClick,
        activityData,
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acbcdb4ca700ade0$export$ef08b123bd77f721), {
        columnsConfig: columnsConfig,
        profileUrl: profileUrl,
        footerButtonText: formatMessage((0, $cb86z.messages).knowledge_cards_view_agent),
        footerButtonAction: (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED,
        testId: "agent-card-body"
    });
});



















var $hdBxM = parcelRequire("hdBxM");


var $aihbI = parcelRequire("aihbI");


var $eHdk6 = parcelRequire("eHdk6");







/* knowledge-card-header.tsx generated by @compiled/babel-plugin v3.0.1 */ 















var $ldb9Z = parcelRequire("ldb9Z");






























const $371756d199ccc649$export$f7dcb977daa6621d = (email)=>{
    // try catch is for the clipboard function
    try {
        navigator.clipboard.writeText(email);
    } catch (error) {
        (0, $cuvLu.logger).error({
            error: error,
            functionName: 'onEmailCopy'
        });
    }
};


const $ff2c12cd5348c884$var$HeaderWrapper = {
    default: "_2Zuz6Q5zaO _1Znuxb5zaO"
};
const $ff2c12cd5348c884$var$PrimaryInfoWrapper = {
    default: "_3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d _0aFT5vbt8w _37wbyuDIqT"
};
const $ff2c12cd5348c884$var$HeaderActionsWrapper = {
    default: "_3YEZNOdnbC _2XsHFMIZbP"
};
const $ff2c12cd5348c884$export$c7c90b1402552129 = ({ name: name, email: email, profileUrl: profileUrl, profileLinkText: profileLinkText, media: media, orgText: orgText, additionalInfo: additionalInfo, onLinkClick: onLinkClick, headerActions: headerActions, testId: testId })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const emailTooltip = {
        position: 'bottom',
        content: formatMessage((0, $cb86z.messages).knowledge_cards_copy_email_address),
        hideTooltipOnClick: true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        xcss: $ff2c12cd5348c884$var$HeaderWrapper.default,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignInline: "start",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200",
        alignBlock: "center"
    }, media, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $ff2c12cd5348c884$var$PrimaryInfoWrapper.default
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small",
        as: "h2"
    }, name), orgText && orgText, additionalInfo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        xcss: $ff2c12cd5348c884$var$HeaderActionsWrapper.default
    }, headerActions, !!email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ldb9Z))), {
                ...props,
                color: "var(--ds-icon, #292A2E)"
            }),
        label: formatMessage((0, $cb86z.messages).ai_answer_who_questions_hover_email_icon),
        onClick: ()=>{
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'header-copy-email'
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).COPY_CLICKED,
                commonAttributes: commonAttributes
            });
            (0, $371756d199ccc649$export$f7dcb977daa6621d)(email);
        },
        isTooltipDisabled: false,
        tooltip: emailTooltip
    }), profileUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        href: profileUrl,
        onClick: (e)=>{
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'header-view-profile'
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED,
                commonAttributes: commonAttributes
            });
            onLinkClick?.(e);
        },
        onAuxClick: (e)=>{
            if (e.button !== 1) return;
            if (!(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'header-view-profile',
                isAuxClick: true
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED,
                commonAttributes: commonAttributes
            });
        },
        onContextMenu: ()=>{
            if (!(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'header-view-profile',
                isContextMenu: true
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED,
                commonAttributes: commonAttributes
            });
        }
    }, profileLinkText)));
};



const $6a152749034bfcee$export$162531e7c7ccb21f = ({ agent: agent })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, orgId: orgId } = commonAttributes;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const media = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        agentId: agent.id,
        agentNamedId: agent.id,
        agentIdentityAccountId: agent.identity_account_id,
        size: "xlarge"
    }));
    const additionalInfo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        maxLines: 2
    }, agent.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage((0, $cb86z.messages).knowledge_cards_rovo_agent_by)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aihbI.AgentCreatedBy), {
        agent: agent,
        siteId: cloudId,
        simplified: true
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff2c12cd5348c884$export$c7c90b1402552129), {
        name: agent.name,
        profileUrl: (0, $df52b12138df743d$export$d00d38d973440568)(agent, orgId),
        profileLinkText: formatMessage((0, $cb86z.messages).knowledge_cards_view_agent),
        media: media,
        additionalInfo: additionalInfo,
        testId: "agent-card-header",
        headerActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eHdk6.FollowUpButton), {
            followUpIndex: 0,
            followUpType: "agent",
            followUpText: "Chat to agent",
            experienceId: "sain",
            onClick: ()=>{
                publish({
                    type: 'chat-new',
                    source: 'sain',
                    data: {
                        agentId: agent.id,
                        dialogues: [],
                        sourceId: commonAttributes.searchSessionId,
                        name: `Chat with ${agent.name}`
                    }
                });
            }
        }))
    });
};

















const $c3b283c365a749e4$export$bfb683339256dc9e = 'KnowledgeCardAgentTeamsQuery';
const $c3b283c365a749e4$var$KNOWLEDGE_CARD_AGENT_TEAMS_QUERY = `
  query ${$c3b283c365a749e4$export$bfb683339256dc9e}(
    $first: Int,
    $after: String,
    $organizationId: ID!,
    $query: String = "",
    $memberIds: [ID] = [],
    $sortBy: [TeamSort],
    $siteId: String!,
    $showEmptyTeams: Boolean = false
  ) {
    team {
      teamSearch: teamSearchV2(
        first: $first
        after: $after
        organizationId: $organizationId
        filter: { query: $query, membership: { memberIds: $memberIds } }
        sortBy: $sortBy
        siteId: $siteId
        showEmptyTeams: $showEmptyTeams
      ) @optIn(to: ["Team-search-v2"]) {
        nodes {
          ...TeamNodeV2
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }

  fragment TeamNodeV2 on TeamSearchResultV2 {
		team {
			id
			organizationId
			membershipSettings
			description
			displayName
			state
			largeAvatarImageUrl
			smallAvatarImageUrl
			largeHeaderImageUrl
			smallHeaderImageUrl
			isVerified
			members {
				nodes {
					member {
						id
						accountStatus
						name
						picture
					}
				}
			}
		}
		memberCount
		includesYou
	}
`;
const $c3b283c365a749e4$export$76c925f889384cac = (agent)=>{
    const { commonAttributes: commonAttributes, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, workspaceId: workspaceId, orgId: orgId } = commonAttributes;
    // Loading states
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [teamsLoading, setTeamsLoading] = (0, $cozmU.useState)(false);
    const [activityLoading, setActivityLoading] = (0, $cozmU.useState)(false);
    // Data states
    const [teamsData, setTeamsData] = (0, $cozmU.useState)(null);
    const [activityData, setActivityData] = (0, $cozmU.useState)(null);
    // Error states
    const [error, setError] = (0, $cozmU.useState)(null);
    const [teamsError, setTeamsError] = (0, $cozmU.useState)(null);
    const [activityError, setActivityError] = (0, $cozmU.useState)(null);
    // Refetch counter to trigger refetches
    const [refetchCounter, setRefetchCounter] = (0, $cozmU.useState)(0);
    // Fetch teams data
    const fetchTeamsData = (0, $cozmU.useCallback)(async ()=>{
        if (!agent?.id || !cloudId) return;
        setTeamsLoading(true);
        setTeamsError(null);
        try {
            const response = await (0, $i5c0A.fetchAggResponse)({
                graphQuery: $c3b283c365a749e4$var$KNOWLEDGE_CARD_AGENT_TEAMS_QUERY,
                variables: {
                    first: 12,
                    organizationId: `ari:cloud:platform::org/${orgId}`,
                    siteId: cloudId,
                    showEmptyTeams: true,
                    memberIds: [
                        agent.identity_account_id?.split('/').pop() || ''
                    ]
                },
                operationName: $c3b283c365a749e4$export$bfb683339256dc9e,
                headers: (0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: sourceProduct ?? ''
                })
            });
            const { data: data, errors: errors } = response;
            if (errors && errors.length > 0) throw new Error(errors.map((e)=>e.message).join(', '));
            if (data?.team) setTeamsData(data.team);
            else throw new Error('No teams data received');
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Failed to fetch teams data';
            setTeamsError(errorMessage);
            setError(errorMessage);
        } finally{
            setTeamsLoading(false);
        }
    }, [
        agent?.id,
        agent?.identity_account_id,
        cloudId,
        workspaceId,
        sourceProduct,
        orgId
    ]);
    const activityClient = (0, $k8VpS.useActivityClient)('v3', 'people');
    // Fetch activity data
    const fetchActivityData = (0, $cozmU.useCallback)(async ()=>{
        if (!agent?.identity_account_id) return;
        setActivityLoading(true);
        setActivityError(null);
        try {
            const activityData = await activityClient.fetchActivities([
                100
            ], {
                limit: 50,
                actors: [
                    agent.identity_account_id.startsWith('ari:cloud:identity::user/') ? agent.identity_account_id : `ari:cloud:identity::user/${agent.identity_account_id}`
                ]
            }, [
                'workedOn'
            ], false);
            setActivityData(activityData.workedOn);
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Failed to fetch activity data';
            setActivityError(errorMessage);
            setError(errorMessage);
        } finally{
            setActivityLoading(false);
        }
    }, [
        agent?.identity_account_id,
        activityClient
    ]);
    // Combined loading state - true if either API is loading
    const combinedLoading = teamsLoading || activityLoading;
    // Refetch function
    const refetch = (0, $cozmU.useCallback)(()=>{
        setRefetchCounter((prev)=>prev + 1);
    }, []);
    // Effect to fetch data when agent changes or refetch is triggered
    (0, $cozmU.useEffect)(()=>{
        if (!agent?.id) {
            // Reset all states when no agent is provided
            setTeamsData(null);
            setActivityData(null);
            setTeamsError(null);
            setActivityError(null);
            setError(null);
            return;
        }
        // Reset error states when starting new fetch
        setError(null);
        // Fetch data conditionally based on available dependencies
        const fetchData = async ()=>{
            const promises = [];
            // Only fetch teams if we have the required data
            if (agent.identity_account_id && cloudId && orgId) promises.push(fetchTeamsData());
            // Only fetch activity if we have the required data
            if (agent.identity_account_id) promises.push(fetchActivityData());
            // Execute available fetches in parallel
            if (promises.length > 0) await Promise.all(promises);
        };
        fetchData();
    }, [
        agent?.id,
        agent?.identity_account_id,
        cloudId,
        orgId,
        fetchTeamsData,
        fetchActivityData,
        refetchCounter
    ]);
    // Update combined loading state
    (0, $cozmU.useEffect)(()=>{
        setLoading(combinedLoading);
    }, [
        combinedLoading
    ]);
    return {
        loading: loading,
        teamsLoading: teamsLoading,
        activityLoading: activityLoading,
        teamsData: teamsData,
        activityData: activityData,
        error: error,
        teamsError: teamsError,
        activityError: activityError,
        refetch: refetch
    };
};


const $a6a88c586e988f54$var$CardContainerStyles = {
    refresh: "_0bjKvDKxmn _2mHwu85zaO _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0Of8r25zaO _1wydGW5zaO",
    disclaimer: "_2Zuz6Q5zaO _1Znuxb5zaO"
};
const $a6a88c586e988f54$var$AgentCardWrapperStyles = {
    wrapper: "_0bjKvD8fU6 _23rrnHDRYy _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1bHrqEWD6W _2O5VijdnbC _3YEZNOdnbC _39xV02WD6W _4ouGXIoaux _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _1mT5xdRAKS _1ANEUSzUZr _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0ReiIH7zJH _4ezyzhQiA2 _1pwPA0pFbM _0t5mr7N8t6 _3s1x1CUaiG"
};
const $a6a88c586e988f54$var$AGENTS_SCROLL_OFFSET = 392;
const $a6a88c586e988f54$var$messages = (0, $kSwu1.defineMessages)({
    multiple_agents_matches_header: {
        id: "search_ai.knowledge_cards.multiple_agents_matches_header",
        defaultMessage: "Agent matches"
    }
});
const $a6a88c586e988f54$var$IndividualAgentKnowledgeCard = ({ agent: agent })=>{
    const { teamsData: teamsData, activityData: activityData, loading: loading } = (0, $c3b283c365a749e4$export$76c925f889384cac)(agent);
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { orgId: orgId } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)(); // Fire analytics event when individual agent knowledge card is shown
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (agent) fireAnalyticsEvent((0, $46b3e6d1a35c49a1$export$4ce3543705832c97)({
            ...commonAttributes,
            agentId: agent.id
        }));
    }, [
        agent,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    if (!agent) return null;
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fd6fa5a10eca60c$export$a08238eb59773648), {
        queryIntent: (0, $zzZbq.QueryIntent).AGENT
    });
    const showKnowledgeCardBody = teamsData?.teamSearch?.nodes && teamsData.teamSearch.nodes.length > 0 || activityData && Array.isArray(activityData) && activityData.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $a6a88c586e988f54$var$CardContainerStyles.refresh
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a152749034bfcee$export$162531e7c7ccb21f), {
        agent: agent
    }), showKnowledgeCardBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8ba51f29bf3689a9$export$4fb305a2fc986af3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, showKnowledgeCardBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c155516f42291cf$export$e35364d8cf1f1804), {
        currentUserId: agent.identity_account_id || '',
        teamsData: teamsData,
        activityData: activityData,
        profileUrl: (0, $df52b12138df743d$export$d00d38d973440568)(agent, orgId)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a6a88c586e988f54$var$CardContainerStyles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true
    })))));
};
const $a6a88c586e988f54$export$f3d65ac3e9ec58cd = ({ onFMPReached: onFMPReached })=>{
    const { commonAttributes: commonAttributes, loading: loading, userDetails: userDetails } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId } = commonAttributes;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const [selectedAgent, setSelectedAgent] = (0, $cozmU.useState)();
    const { answerString: answerString } = commonAttributes; // Parses the answerString to extract agent results, returning an empty array if parsing fails or if the result is not an array.
    const agentResults = (0, $cozmU.useMemo)(()=>{
        if (!answerString) return [];
        try {
            const parsed = JSON.parse(answerString);
            return Array.isArray(parsed) ? parsed : [];
        } catch  {
            return [];
        }
    }, [
        answerString
    ]); // Fire analytics event when carousel is shown (only when multiple agents exist)
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (agentResults && agentResults.length > 1) fireAnalyticsEvent((0, $9dbfa7cbc81cad25$export$6266151addd8e413)({
            ...commonAttributes,
            agentCount: agentResults.length
        }));
    }, [
        agentResults,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    const profileClient = (0, $cozmU.useMemo)(()=>(0, $jXQUy.createProfileClient)(cloudId), [
        cloudId
    ]);
    const getHandleSelectAgent = (0, $cozmU.useCallback)((index)=>()=>{
            const selectedAgentData = agentResults[index];
            setSelectedAgent(selectedAgentData); // Fire analytics event for carousel item click
            fireAnalyticsEvent((0, $d80ef16958371a2e$export$885a78bb6bce677d)({
                ...commonAttributes,
                agentId: selectedAgentData.id,
                position: index
            }));
        }, [
        agentResults,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (agentResults.length === 1) setSelectedAgent(agentResults[0]);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        agentResults
    ]);
    (0, $cozmU.useEffect)(()=>{
        onFMPReached?.();
        fireAnalyticsEvent((0, $19a6060145576e12$export$44d9aa4134474084)({
            ...commonAttributes,
            cardType: (0, $9T3jg.KnowledgeCardsIntentType).AGENT
        })); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { handleHoverStart: handleHoverStart, handleHoverLeave: handleHoverLeave } = (0, $44276ea9228fcce0$export$79db6a77ac4a8ace)({
        elementType: 'agent',
        hoverCardSelector: '[data-testid="agent-knowledge-card-trigger"]'
    });
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fd6fa5a10eca60c$export$a08238eb59773648), null);
    if (agentResults.length === 0) return null;
    if (selectedAgent !== undefined || agentResults.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a6a88c586e988f54$var$IndividualAgentKnowledgeCard, {
        agent: selectedAgent
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ec82c8c1e1d8eeb1$export$61c045a5252abd1d), {
        heading: formatMessage($a6a88c586e988f54$var$messages.multiple_agents_matches_header),
        scrollOffset: $a6a88c586e988f54$var$AGENTS_SCROLL_OFFSET
    }, agentResults.map((agent, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onClick: getHandleSelectAgent(index),
            testId: "agent-knowledge-card-wrapper",
            key: agent.id,
            xcss: $a6a88c586e988f54$var$AgentCardWrapperStyles.wrapper,
            onMouseEnter: handleHoverStart,
            onMouseLeave: handleHoverLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKpjD.AgentProfileCardTrigger), {
            trigger: "hover",
            agentId: agent.id,
            resourceClient: profileClient,
            cloudId: cloudId,
            viewingUserId: userDetails.id,
            disabledAriaAttributes: true,
            testId: "agent-knowledge-card-trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            agentId: agent.id,
            agentNamedId: agent.id,
            agentIdentityAccountId: agent.identity_account_id,
            size: "xxlarge"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1,
            size: "medium",
            weight: "medium",
            align: "center"
        }, agent.name), agent.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1,
            size: "medium",
            color: "color.text.subtlest",
            align: "center"
        }, agent.description))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true
    }));
};



/* person-knowledge-card.tsx generated by @compiled/babel-plugin v3.0.1 */ 



var $9EOlJ = parcelRequire("9EOlJ");


















var $8aG6j = parcelRequire("8aG6j");
























var $1LXnB = parcelRequire("1LXnB");



















const $3a9123b42ae8c5e9$var$wrapperStyles = {
    root: "_0bjKvD8fU6 _23rrnHDRYy _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02N91d _0jFU0VN91d _4ouGXIoaux _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _1mT5xdRAKS _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0ReiIH7zJH _4ezyzhQiA2 _1pwPA0pFbM _0t5mr7N8t6 _3s1x1CUaiG"
};
const $3a9123b42ae8c5e9$export$a3474cd1dd8e70a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { id: id, children: children, testId: testId } = t0;
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($3a9123b42ae8c5e9$var$wrapperStyles.root);
        $[0] = t1;
    } else t1 = $[0];
    const t2 = isHovered ? "elevation.surface.hovered" : "elevation.surface";
    let t3;
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsHovered(true);
        t4 = ()=>setIsHovered(false);
        $[1] = t3;
        $[2] = t4;
    } else {
        t3 = $[1];
        t4 = $[2];
    }
    const t5 = testId || `person-card-${id}`;
    let t6;
    if ($[3] !== children || $[4] !== t2 || $[5] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t1,
            backgroundColor: t2,
            onMouseEnter: t3,
            onMouseLeave: t4,
            testId: t5,
            children: children
        });
        $[3] = children;
        $[4] = t2;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : ({ id: id, children: children, testId: testId })=>{
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3a9123b42ae8c5e9$var$wrapperStyles.root),
        backgroundColor: isHovered ? 'elevation.surface.hovered' : 'elevation.surface',
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        testId: testId || `person-card-${id}`,
        children: children
    });
};


const $67cd5bff95eb1aaf$var$AVATAR_BREAKPOINT = 180;
const $67cd5bff95eb1aaf$var$unbouncedStyles = {
    name: "_2sNsIgEqul _4bt5LAnQyn _2WAcuGnQyn _1kk5Tkf7mX _2fwxA5DIqT _39HuIbz8Lp _3iDTPbgJ9S _1U1ZhbbI28 _4Gn54RiZR3"
};
const $67cd5bff95eb1aaf$var$styles = {
    emptyLine: "_0jFU0VSPN1"
};
const $67cd5bff95eb1aaf$export$4c094c8f61edecb4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PersonCard(t0) {
    const $ = (0, $bDgLe.c)(27);
    const { data: t1 } = t0;
    const { avatarUrl: avatarUrl, id: id, name: name, jobTitle: jobTitle, location: location, localTime: localTime } = t1;
    const shouldShowEmptyLine = !jobTitle && !location && !localTime;
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(0);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1LXnB.WidthObserver), {
            setWidth: setWidth
        });
        $[0] = t2;
    } else t2 = $[0];
    const t3 = (0, $iDrrr.fg)("teams-a11y-screen-reader-high-priority") ? undefined : name;
    const t4 = width < $67cd5bff95eb1aaf$var$AVATAR_BREAKPOINT ? "xlarge" : "xxlarge";
    let t5;
    if ($[1] !== avatarUrl || $[2] !== t3 || $[3] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
            src: avatarUrl,
            name: t3,
            size: t4
        });
        $[1] = avatarUrl;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== name) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "h2",
            xcss: $67cd5bff95eb1aaf$var$unbouncedStyles.name,
            children: name
        });
        $[5] = name;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== jobTitle) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            maxLines: 2,
            size: "small",
            color: "color.text.subtlest",
            align: "center",
            children: jobTitle
        });
        $[7] = jobTitle;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== localTime || $[10] !== location) {
        t8 = [
            location,
            localTime
        ].filter(Boolean);
        $[9] = localTime;
        $[10] = location;
        $[11] = t8;
    } else t8 = $[11];
    const t9 = t8.join(" ");
    let t10;
    if ($[12] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            maxLines: 1,
            size: "small",
            color: "color.text.subtlest",
            align: "center",
            children: t9
        });
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== shouldShowEmptyLine) {
        t11 = shouldShowEmptyLine && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $67cd5bff95eb1aaf$var$styles.emptyLine
        });
        $[14] = shouldShowEmptyLine;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== t10 || $[17] !== t11 || $[18] !== t6 || $[19] !== t7) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            space: "space.050",
            alignInline: "center",
            children: [
                t6,
                t7,
                t10,
                t11
            ]
        });
        $[16] = t10;
        $[17] = t11;
        $[18] = t6;
        $[19] = t7;
        $[20] = t12;
    } else t12 = $[20];
    let t13;
    if ($[21] !== t12 || $[22] !== t5) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            space: "space.150",
            alignInline: "center",
            children: [
                t5,
                t12
            ]
        });
        $[21] = t12;
        $[22] = t5;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== id || $[25] !== t13) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3a9123b42ae8c5e9$export$a3474cd1dd8e70a), {
            id: id,
            children: [
                t2,
                t13
            ]
        });
        $[24] = id;
        $[25] = t13;
        $[26] = t14;
    } else t14 = $[26];
    return t14;
} : function PersonCard({ data: { avatarUrl: avatarUrl, id: id, name: name, jobTitle: jobTitle, location: location, localTime: localTime } }) {
    const shouldShowEmptyLine = !jobTitle && !location && !localTime;
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(0);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3a9123b42ae8c5e9$export$a3474cd1dd8e70a), {
        id: id,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1LXnB.WidthObserver), {
                setWidth: setWidth
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.150",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                        src: avatarUrl,
                        name: (0, $iDrrr.fg)('teams-a11y-screen-reader-high-priority') ? undefined : name,
                        size: width < $67cd5bff95eb1aaf$var$AVATAR_BREAKPOINT ? 'xlarge' : 'xxlarge'
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                        space: "space.050",
                        alignInline: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                as: "h2",
                                xcss: $67cd5bff95eb1aaf$var$unbouncedStyles.name,
                                children: name
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                maxLines: 2,
                                size: "small",
                                color: "color.text.subtlest",
                                align: "center",
                                children: jobTitle
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                maxLines: 1,
                                size: "small",
                                color: "color.text.subtlest",
                                align: "center",
                                children: [
                                    location,
                                    localTime
                                ].filter(Boolean).join(' ')
                            }),
                            shouldShowEmptyLine && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $67cd5bff95eb1aaf$var$styles.emptyLine
                            })
                        ]
                    })
                ]
            })
        ]
    });
};






var $b5HfQ = parcelRequire("b5HfQ");

var $7Uv0v = parcelRequire("7Uv0v");


var $kjetH = parcelRequire("kjetH");


var $kEVoQ = parcelRequire("kEVoQ");










const $189f541bd063b636$export$bd496fce1657ba31 = ({ isStreamed: isStreamed, loadTime: loadTime, fmpLoadTime: fmpLoadTime, ...props })=>{
    const { query: query, answerString: answerString, source: source, errorState: errorState, errorCode: errorCode, networkErrorReason: networkErrorReason, networkErrorDetails: networkErrorDetails, backendFailureType: backendFailureType, networkErrorDiagnosticType: networkErrorDiagnosticType, networkErrorFailureStage: networkErrorFailureStage, responseContentType: responseContentType, networkErrorTraceId: networkErrorTraceId, streamEventsReceived: streamEventsReceived, networkErrorDuration: networkErrorDuration, extraAttributes: extraAttributes } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerError',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            isStreamed: isStreamed,
            loadTime: loadTime,
            fmpLoadTime: fmpLoadTime,
            errorState: errorState,
            ...(0, $iDrrr.fg)('kd_granular_network_errors') && {
                errorCode: errorCode,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                // Prefer the trace id captured from the backend error response (e.g.
                // Stargate's atl-traceid) so failures can be correlated with
                // backend/gateway logs; fall back to the client request id.
                traceId: networkErrorTraceId ?? extraAttributes?.requestId,
                backendFailureType: backendFailureType,
                streamEventsReceived: streamEventsReceived,
                networkErrorDuration: networkErrorDuration
            },
            ...(0, $iDrrr.fg)('kd_sain_stream_error_diagnostics') && {
                networkErrorDiagnosticType: networkErrorDiagnosticType,
                networkErrorFailureStage: networkErrorFailureStage,
                responseContentType: responseContentType,
                ...networkErrorTraceId && {
                    traceId: networkErrorTraceId
                }
            }
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};











var $d227efab07c2b9f0$export$eae917983a0398aa = /*#__PURE__*/ function(NLPSearchJSONResultFormat) {
    NLPSearchJSONResultFormat["WHO"] = "who";
    NLPSearchJSONResultFormat["WORK"] = "work";
    NLPSearchJSONResultFormat["TEAM"] = "team";
    NLPSearchJSONResultFormat["PERSON"] = "person";
    NLPSearchJSONResultFormat["AGENT"] = "agent";
    return NLPSearchJSONResultFormat;
}({});


const $d325f5b9eeee6e40$export$d905ae2a714518e8 = ({ answerString: answerString, smartAnswersRoute: smartAnswersRoute })=>{
    const parsed = JSON.parse(answerString);
    if ('user_metadata' in parsed && !!parsed.user_metadata) return {
        parsedResult: parsed.user_metadata,
        parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).WHO
    };
    else if ('user_metadata_only_cards' in parsed && !!parsed.user_metadata_only_cards) return {
        parsedResult: parsed.user_metadata_only_cards,
        parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).PERSON
    };
    else if ('user_metadata_with_activity' in parsed && !!parsed.user_metadata_with_activity) return {
        parsedResult: parsed.user_metadata_with_activity,
        parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).WORK
    };
    else if ('team_metadata' in parsed && !!parsed.team_metadata) return {
        parsedResult: parsed.team_metadata,
        parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).TEAM
    };
    else if (Array.isArray(parsed) && parsed.length > 0 && smartAnswersRoute === (0, $zzZbq.QueryIntent).AGENT) return {
        parsedResult: parsed,
        parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).AGENT
    };
    else // This line should never be reached, this means that an unsupported type was in the JSON result
    return {
        parsedResult: parsed,
        parsedType: undefined
    };
};


























const $26d7d2244f378b33$var$PEOPLE_TEAMS_LOCATION_MAP = {
    userProfilePreview: {
        thirdPartyMessage: 'userProfilePreview-thirdPartyMessage',
        reportingLines: 'userProfilePreview-reportingLines',
        viewProfile: 'userProfilePreview-view-profile',
        recentWorkSection: 'userProfilePreview-recentWork',
        recentWorkViewAll: 'userProfilePreview-recentWorkViewAll',
        recentWorkShowMore: 'userProfilePreview-recentWorkShowMore',
        collaboratorsSection: 'userProfilePreview-collaborators'
    },
    userInlinePreview: {
        thirdPartyMessage: 'userInlinePreview-thirdPartyMessage',
        reportingLines: 'userInlinePreview-reportingLines',
        viewProfile: 'userInlinePreview-viewProfile'
    },
    hierarchyChart: {
        managerNode: 'hierarchyChart-managerNode',
        directReportNode: 'hierarchyChart-directReportNode',
        peerNode: 'hierarchyChart-peerNode',
        overflow: 'hierarchyChart-overflow',
        viewFullReportingLine: 'hierarchyChart-viewFullReportingLine'
    }
};
const $26d7d2244f378b33$var$USER_PROFILE_PREVIEW_TAB_LOCATION_MAP = {
    recentWork: 'userProfilePreview-recentWorkTab',
    reportingLine: 'userProfilePreview-reportingLineTab',
    collaborators: 'userProfilePreview-collaboratorsTab'
};
const $26d7d2244f378b33$var$PEOPLE_TEAMS_ACTION_MAP = {
    userProfilePreview: {
        thirdPartyMessage: (0, $bZMnB.SainAction).THIRD_PARTY_MESSAGE_CLICKED,
        reportingLines: (0, $bZMnB.SainAction).REPORTING_LINES_CLICKED,
        viewProfile: (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED,
        recentWorkSection: (0, $bZMnB.SainAction).PROFILE_SECTION_CLICKED,
        collaboratorsSection: (0, $bZMnB.SainAction).PROFILE_SECTION_CLICKED
    },
    userInlinePreview: {
        thirdPartyMessage: (0, $bZMnB.SainAction).THIRD_PARTY_MESSAGE_CLICKED,
        reportingLines: (0, $bZMnB.SainAction).REPORTING_LINES_CLICKED,
        viewProfile: (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED
    },
    hierarchyChart: {
        managerNode: (0, $bZMnB.SainAction).HIERARCHY_NODE_CLICKED,
        directReportNode: (0, $bZMnB.SainAction).HIERARCHY_NODE_CLICKED,
        peerNode: (0, $bZMnB.SainAction).HIERARCHY_NODE_CLICKED,
        overflow: (0, $bZMnB.SainAction).REPORTING_LINES_CLICKED,
        viewFullReportingLine: (0, $bZMnB.SainAction).REPORTING_LINES_CLICKED
    }
};
const $26d7d2244f378b33$export$987bf6a808c14d7d = (payload)=>{
    if (payload.action !== 'clicked') return undefined;
    let location;
    let tabSainAction;
    if (payload.actionSubject === 'userProfilePreview' && payload.actionSubjectId === 'tab') {
        const tab = payload.attributes?.tab ?? '';
        location = $26d7d2244f378b33$var$USER_PROFILE_PREVIEW_TAB_LOCATION_MAP[tab];
        if (location) tabSainAction = (0, $bZMnB.SainAction).PROFILE_TAB_CLICKED;
    } else {
        const locationMap = $26d7d2244f378b33$var$PEOPLE_TEAMS_LOCATION_MAP[payload.actionSubject ?? ''];
        location = locationMap?.[payload.actionSubjectId ?? ''];
    }
    if (!location) return undefined;
    const isCollaborator = payload.actionSubject === 'userInlinePreview' && payload.renderContext === 'collaborator';
    if (isCollaborator) location = `${location}-collaborator`;
    const sainAction = isCollaborator ? (0, $bZMnB.SainAction).COLLABORATOR_CLICKED : tabSainAction ?? $26d7d2244f378b33$var$PEOPLE_TEAMS_ACTION_MAP[payload.actionSubject ?? '']?.[payload.actionSubjectId ?? ''];
    return {
        location: location,
        sainAction: sainAction
    };
};





const $016c76767add6663$export$3d5fec32962921db = ({ children: children })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const handlePeopleTeamsEvent = (0, $cozmU.useCallback)((event)=>{
        const resolved = (0, $26d7d2244f378b33$export$987bf6a808c14d7d)(event.payload);
        if (!resolved) return;
        // Fire the `aiAnswerDialog clicked` track event (existing location-based pattern).
        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: resolved.location
        }));
        // Fire the matching SAIN usage (MAU) event for parity with the existing person card
        // instrumentation in person-card-body.tsx.
        if (resolved.sainAction) fireSAINUsageEvent({
            metCriteria: resolved.sainAction,
            commonAttributes: commonAttributes
        });
    }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        commonAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: "peopleTeams",
        onEvent: handlePeopleTeamsEvent
    }, children);
};






























const $9815e23bc9044028$export$5ee3eeb70eb524d1 = (props)=>{
    const { source: source, personCardVariant: personCardVariant, errorMessage: errorMessage } = props;
    return {
        action: 'errored',
        actionSubject: 'aiAnswerPersonKnowledgeCard',
        source: source,
        eventType: 'operational',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            personCardVariant: personCardVariant,
            errorMessage: errorMessage
        }
    };
};





const $2c764823b2ef4dc8$export$c59cd1b0c182839c = (props)=>{
    const { source: source, personCardVariant: personCardVariant, loadTime: loadTime } = props;
    return {
        action: 'loaded',
        actionSubject: 'aiAnswerPersonKnowledgeCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            personCardVariant: personCardVariant,
            loadTime: loadTime
        }
    };
};























































var $hSs5g = parcelRequire("hSs5g");


var $9zU5G = parcelRequire("9zU5G");
























var $66eSg = parcelRequire("66eSg");

const $17582a7702efaf6e$export$87f3c1fc8ab2e681 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ item: user, onClickCallback: onClickCallback })=>{
    const { commonAttributes: commonAttributes, userDetails: userDetails } = (0, $3hVWe.useAIAnswerContext)();
    const { toUser: toUser } = (0, $66eSg.useTeamsAppLinks)({
        type: (0, $9T3jg.KnowledgeCardsIntentType).PERSON,
        currentUserId: user.accountId || '',
        cloudId: commonAttributes.cloudId
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const userUrl = `/people/${(0, $1AuMq.trimARI)(user.accountId || '')}`;
    const handleUserClick = (e)=>{
        if ((0, $iDrrr.fg)('platform-adopt-teams-nav-config')) toUser(user.accountId || '').onNavigate(e);
        else window.open(user.url || userUrl, '_self', 'noopener, noreferrer');
    };
    const profileClient = (0, $cozmU.useMemo)(()=>(0, $jXQUy.createProfileClient)(commonAttributes.cloudId), [
        commonAttributes.cloudId
    ]);
    const agent = (0, $cozmU.useMemo)(()=>({
            resourceClient: profileClient
        }), [
        profileClient
    ]);
    const { handleHoverStart: handleHoverStart, handleHoverLeave: handleHoverLeave } = (0, $44276ea9228fcce0$export$79db6a77ac4a8ace)({
        elementType: 'collaborator',
        hoverCardSelector: '[data-testid="profilecard"]'
    });
    if ((0, $iDrrr.fg)('people-teams_migrate-user-profile-card') || (0, $cXtTj.default).getExperimentValue('pt_user_profile_card_migration_exp', 'isEnabled', false)) {
        const rowContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onMouseEnter: handleHoverStart,
            onMouseLeave: handleHoverLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aqqYN.KnowledgeCardsRowRefresh), {
            primaryText: user.name,
            secondaryText: !!user.title || !!user.department ? [
                user.title,
                user.department
            ].filter((str)=>!!str).join(', ') : '',
            pictureUrl: user.picture || '',
            type: (0, $1UlLI.KnowledgeCardsRowType).PERSON,
            onClick: (e)=>{
                onClickCallback?.();
                handleUserClick(e);
            },
            onAuxClick: (e)=>{
                if (e.button !== 1) return;
                onClickCallback?.({
                    isAuxClick: true
                });
                window.open(user.url || userUrl, '_blank', 'noopener,noreferrer');
            },
            onContextMenu: ()=>{
                onClickCallback?.({
                    isContextMenu: true
                });
            }
        }));
        if (!commonAttributes.orgId || !userDetails.id) return rowContent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zU5G.UserProfileCardWithTrigger), {
            userId: (0, $1AuMq.trimARI)(user.accountId || ''),
            cloudId: commonAttributes.cloudId,
            orgId: commonAttributes.orgId,
            viewerId: userDetails.id,
            placement: "bottom-end",
            trigger: "hover",
            agent: agent,
            onProfileClick: ()=>onClickCallback?.()
        }, rowContent);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSs5g.default), {
        userId: (0, $1AuMq.trimARI)(user.accountId || ''),
        resourceClient: profileClient,
        actions: [
            {
                label: formatMessage((0, $cb86z.messages).knowledge_cards_person_hover_profile_link),
                link: toUser(user.accountId || '').href,
                callback: (e)=>{
                    onClickCallback?.();
                    toUser(user.accountId || '').onNavigate(e);
                }
            }
        ],
        ariaLabel: user.name,
        position: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onMouseEnter: handleHoverStart,
        onMouseLeave: handleHoverLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aqqYN.KnowledgeCardsRowRefresh), {
        primaryText: user.name,
        secondaryText: !!user.title || !!user.department ? [
            user.title,
            user.department
        ].filter((str)=>!!str).join(', ') : '',
        pictureUrl: user.picture || '',
        type: (0, $1UlLI.KnowledgeCardsRowType).PERSON,
        onClick: (e)=>{
            onClickCallback?.();
            handleUserClick(e);
        },
        onAuxClick: (e)=>{
            if (e.button !== 1) return;
            onClickCallback?.({
                isAuxClick: true
            });
            window.open(user.url || userUrl, '_blank', 'noopener,noreferrer');
        },
        onContextMenu: ()=>{
            onClickCallback?.({
                isContextMenu: true
            });
        }
    })));
});








const $3ffa4c5e2a30b7df$export$2460aa15a0a1d61e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ currentUserId: currentUserId, recommendedUsers: recommendedUsers, recentActivity: recentActivity, profileUrl: profileUrl, viewAllUrl: viewAllUrl })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { viewAllLink: viewAllLink, viewAllOnNavigate: viewAllOnNavigate, worksWithHref: worksWithHref, worksWithOnNavigate: worksWithOnNavigate, profileHref: profileHref } = (0, $66eSg.useTeamsAppLinks)({
        type: (0, $9T3jg.KnowledgeCardsIntentType).PERSON,
        currentUserId: currentUserId,
        viewAllUrl: viewAllUrl,
        cloudId: commonAttributes.cloudId
    });
    const handleRecentWorkViewAllClick = (e)=>{
        const isAuxClick = 'button' in e && e.button === 1;
        const isContextMenu = 'button' in e && e.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: 'recent-work-view-all',
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).RECENT_WORK_CLICKED,
            commonAttributes: commonAttributes
        });
        if (!isAuxClick && !isContextMenu && (0, $iDrrr.fg)('platform-adopt-teams-nav-config')) viewAllOnNavigate(e);
    };
    const handleCollaboratorsViewAllClick = (e)=>{
        const isAuxClick = 'button' in e && e.button === 1;
        const isContextMenu = 'button' in e && e.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: 'reporting-lines-link',
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).REPORTING_LINES_CLICKED,
            commonAttributes: commonAttributes
        });
        if (!isAuxClick && !isContextMenu && (0, $iDrrr.fg)('platform-adopt-teams-nav-config')) worksWithOnNavigate(e);
    };
    const columnsConfig = [
        // Recent Activity Column
        ...recentActivity.length > 0 ? [
            {
                viewAllLinkOnClick: handleRecentWorkViewAllClick,
                viewAllLinkHref: viewAllLink,
                data: recentActivity,
                component: (0, $cce772d1072e95eb$export$65943680306d629),
                header: formatMessage((0, $cb86z.messages).knowledge_cards_recent_work_subheader),
                onClickCallback: (position, shownAfterCardBodyExpanded, opts)=>{
                    if ((opts?.isAuxClick || opts?.isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
                    fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                        ...commonAttributes,
                        location: 'recent-work-item',
                        position: position,
                        shownAfterCardBodyExpanded: shownAfterCardBodyExpanded,
                        isAuxClick: opts?.isAuxClick,
                        isContextMenu: opts?.isContextMenu
                    }));
                    fireSAINUsageEvent({
                        metCriteria: (0, $bZMnB.SainAction).RECENT_WORK_CLICKED,
                        commonAttributes: commonAttributes
                    });
                },
                searchAIAnalyticsContextLocation: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_PERSON_CARD
            }
        ] : [],
        // Recommended Users Column
        ...recommendedUsers.length > 0 ? [
            {
                viewAllLinkOnClick: handleCollaboratorsViewAllClick,
                viewAllLinkHref: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? worksWithHref : `https://hello.atlassian.net/people/${currentUserId || ''}#workswith`,
                data: recommendedUsers,
                component: (0, $17582a7702efaf6e$export$87f3c1fc8ab2e681),
                onClickCallback: (position, shownAfterCardBodyExpanded, opts)=>{
                    if ((opts?.isAuxClick || opts?.isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
                    fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                        ...commonAttributes,
                        location: 'user-list-item',
                        position: position,
                        shownAfterCardBodyExpanded: shownAfterCardBodyExpanded,
                        isAuxClick: opts?.isAuxClick,
                        isContextMenu: opts?.isContextMenu
                    }));
                    fireSAINUsageEvent({
                        metCriteria: (0, $bZMnB.SainAction).COLLABORATOR_CLICKED,
                        commonAttributes: commonAttributes
                    });
                },
                header: formatMessage((0, $cb86z.messages).knowledge_cards_collaborators_subheader)
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acbcdb4ca700ade0$export$ef08b123bd77f721), {
        columnsConfig: columnsConfig,
        profileUrl: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : profileUrl,
        footerButtonText: formatMessage((0, $cb86z.messages).ai_answer_who_questions_view_profile),
        footerButtonAction: (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED,
        testId: "person-knowledge-card-body"
    });
});


/* person-card-header.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $eleTd = parcelRequire("eleTd");


var $hS5Ee = parcelRequire("hS5Ee");


var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");











// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 








parcelRequire("cozmU");





var $2tuSz = parcelRequire("2tuSz");













const $344277174d1dbd8f$var$ReportingLinesContext = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $344277174d1dbd8f$export$ec53f07922eb01bd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, product: product, WrappedWithProfilecard: WrappedWithProfilecard, viewedEventAttributes: viewedEventAttributes, selectedCardRef: selectedCardRef } = t0;
    let t1;
    if ($[0] !== WrappedWithProfilecard || $[1] !== product || $[2] !== selectedCardRef || $[3] !== viewedEventAttributes) {
        t1 = {
            product: product,
            WrappedWithProfilecard: WrappedWithProfilecard,
            viewedEventAttributes: viewedEventAttributes,
            selectedCardRef: selectedCardRef
        };
        $[0] = WrappedWithProfilecard;
        $[1] = product;
        $[2] = selectedCardRef;
        $[3] = viewedEventAttributes;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== children || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($344277174d1dbd8f$var$ReportingLinesContext.Provider, {
            value: t1,
            children: children
        });
        $[5] = children;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ children: children, product: product, WrappedWithProfilecard: WrappedWithProfilecard, viewedEventAttributes: viewedEventAttributes, selectedCardRef: selectedCardRef })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($344277174d1dbd8f$var$ReportingLinesContext.Provider, {
        value: {
            product: product,
            WrappedWithProfilecard: WrappedWithProfilecard,
            viewedEventAttributes: viewedEventAttributes,
            selectedCardRef: selectedCardRef
        },
        children: children
    });
};
const $344277174d1dbd8f$export$f1dff4eb3ba8d70b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($344277174d1dbd8f$var$ReportingLinesContext);
} : ()=>(0, $cozmU.useContext)($344277174d1dbd8f$var$ReportingLinesContext);















var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $dZPDC = parcelRequire("dZPDC");

/**
 * @generated SignedSource<<af5c7b9f0112fcb3936b12e803491ba9>>
 * @relayHash ccfbb5fe5c8d3491128064c412dd8acc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa70005846b63a1771e14cc8c0c9f42b6a2e35ad2f5a1b37b25abe156a15d801
const $4c7f90faeb681ceb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "aaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "siteId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "accountIdentifier"
        },
        {
            "kind": "ScalarField",
            "name": "identifierType"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfDirectReports"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfTotalReports"
        },
        {
            "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
            "kind": "LinkedField",
            "name": "pii",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "ScalarField",
                    "name": "accountStatus"
                },
                {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
                    "kind": "LinkedField",
                    "name": "extendedProfile",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "jobTitle"
                        }
                    ]
                }
            ]
        }
    ], v2 = [
        {
            "concreteType": "KnowledgeDiscoveryQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeDiscovery",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "aaid",
                            "variableName": "aaid"
                        },
                        {
                            "kind": "Variable",
                            "name": "orgId",
                            "variableName": "orgId"
                        },
                        {
                            "kind": "Variable",
                            "name": "siteId",
                            "variableName": "siteId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "reportingLines",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                    "kind": "LinkedField",
                                    "name": "managers",
                                    "plural": true,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                    "kind": "LinkedField",
                                    "name": "reports",
                                    "plural": true,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                    "kind": "LinkedField",
                                    "name": "peers",
                                    "plural": true,
                                    "selections": v1 /*: any*/ 
                                }
                            ],
                            "type": "KnowledgeDiscoveryReportingLines"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getReportingLinesFromKnowledgeDiscoveryQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getReportingLinesFromKnowledgeDiscoveryQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "fa70005846b63a1771e14cc8c0c9f42b6a2e35ad2f5a1b37b25abe156a15d801",
            "metadata": {},
            "name": "getReportingLinesFromKnowledgeDiscoveryQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4c7f90faeb681ceb$var$node.hash = "b74ed008970594ee294e43ffaa01a664";
var $4c7f90faeb681ceb$export$2e2bcd8739ae039 = $4c7f90faeb681ceb$var$node;



var $6SsN4 = parcelRequire("6SsN4");


var $kTGj5 = parcelRequire("kTGj5");

const $46ee34180a49488c$var$ACCOUNT_IDENTIFIER_TYPES = [
    'ATLASSIAN_ID',
    'BASE64_HASH',
    'UNKNOWN'
];
const $46ee34180a49488c$var$toIdentifierType = (identifierType)=>$46ee34180a49488c$var$ACCOUNT_IDENTIFIER_TYPES.find((type)=>type === identifierType);
const $46ee34180a49488c$var$mapUser = (user)=>({
        accountIdentifier: user.accountIdentifier ?? undefined,
        identifierType: $46ee34180a49488c$var$toIdentifierType(user.identifierType),
        numberOfDirectReports: user.numberOfDirectReports ?? 0,
        numberOfTotalReports: user.numberOfTotalReports ?? 0,
        pii: user.pii ? {
            name: user.pii.name ?? undefined,
            picture: user.pii.picture ?? undefined,
            accountStatus: user.pii.accountStatus ?? undefined,
            extendedProfile: user.pii.extendedProfile ? {
                jobTitle: user.pii.extendedProfile.jobTitle ?? undefined
            } : undefined
        } : undefined
    });
const $46ee34180a49488c$export$46017c13c5acc361 = (payload)=>{
    if (!payload?.user) return undefined;
    const mapSection = (users)=>users ? users.filter((user)=>user != null).map($46ee34180a49488c$var$mapUser) : undefined;
    return {
        user: $46ee34180a49488c$var$mapUser(payload.user),
        managers: mapSection(payload.managers),
        peers: mapSection(payload.peers),
        reports: mapSection(payload.reports)
    };
};


const $a2f877b6b38dc13c$export$f9342e660ee419cb = (cloudId)=>(0, $kTGj5.PlatformSiteAri).create({
        siteId: cloudId
    }).toString();
const $a2f877b6b38dc13c$export$80f73c3f74343d18 = async (environment, userId, { cloudId: cloudId, orgId: orgId })=>{
    // Fields below are consumed via `mapKnowledgeDiscoveryReportingLines`, which
    // maps the whole payload into the store's `ReportingLines` shape. The Relay
    // lint rule cannot follow the mapper, so it is disabled for this query.
    /* eslint-disable @atlassian/relay/unused-fields */ const data = await (0, $6SsN4.fetchQuery)(environment, (0, $4c7f90faeb681ceb$export$2e2bcd8739ae039), {
        aaid: userId,
        orgId: orgId,
        siteId: $a2f877b6b38dc13c$export$f9342e660ee419cb(cloudId)
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    /* eslint-enable @atlassian/relay/unused-fields */ const reportingLines = data?.knowledgeDiscovery?.reportingLines;
    if (reportingLines?.__typename !== 'KnowledgeDiscoveryReportingLines') return undefined;
    return (0, $46ee34180a49488c$export$46017c13c5acc361)(reportingLines);
};


const $aeecbceb6b802fef$var$initialState = {
    isLoading: false,
    data: undefined,
    error: undefined,
    selectedUserId: null
};
const $aeecbceb6b802fef$export$e324594224ef24da = {
    getReportingLines: (teamId)=>async ({ setState: setState })=>{
            setState({
                isLoading: true,
                error: undefined
            });
            try {
                const data = await (0, $dZPDC.teamsClient).getReportingLines(teamId);
                setState({
                    isLoading: false,
                    data: data,
                    error: undefined
                });
            } catch (e) {
                setState({
                    isLoading: false,
                    error: e instanceof Error ? e : new Error(String(e))
                });
            }
        },
    getReportingLinesFromKnowledgeDiscovery: (userId, environment, context)=>async ({ setState: setState })=>{
            setState({
                isLoading: true,
                error: undefined
            });
            try {
                const reportingLines = await (0, $a2f877b6b38dc13c$export$80f73c3f74343d18)(environment, userId, context);
                setState({
                    isLoading: false,
                    data: reportingLines ? {
                        reportingLines: reportingLines
                    } : undefined,
                    error: undefined
                });
            } catch (e) {
                setState({
                    isLoading: false,
                    error: e instanceof Error ? e : new Error(String(e))
                });
            }
        },
    selectUser: (userId)=>({ setState: setState })=>{
            setState({
                selectedUserId: userId
            });
        }
};
const $aeecbceb6b802fef$var$ReportingLinesStore = (0, $8s9DV.createStore)({
    initialState: $aeecbceb6b802fef$var$initialState,
    actions: $aeecbceb6b802fef$export$e324594224ef24da
});
const $aeecbceb6b802fef$export$fa989b0eaa9784de = (0, $kBr4q.createHook)($aeecbceb6b802fef$var$ReportingLinesStore);


















var $lUcpS = parcelRequire("lUcpS");


var $3DKrH = parcelRequire("3DKrH");


const $4be671d2cf26d734$export$bc3f9f082175bfd1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (userId, options)=>{
    const $ = (0, $bDgLe.c)(17);
    const [t0, t1] = (0, $aeecbceb6b802fef$export$fa989b0eaa9784de)();
    const { data: data, isLoading: isLoading, error: error } = t0;
    const { getReportingLines: getReportingLines, getReportingLinesFromKnowledgeDiscovery: getReportingLinesFromKnowledgeDiscovery } = t1;
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const { cloudId: cloudIdFromConfig, orgId: orgIdFromConfig } = (0, $3DKrH.useAppConfig)();
    const cloudId = options?.cloudId ?? cloudIdFromConfig ?? undefined;
    const orgId = options?.orgId ?? orgIdFromConfig ?? undefined;
    let t2;
    let t3;
    if ($[0] !== cloudId || $[1] !== environment || $[2] !== getReportingLines || $[3] !== getReportingLinesFromKnowledgeDiscovery || $[4] !== orgId || $[5] !== userId) {
        t2 = ()=>{
            if (!!cloudId && !!orgId && (0, $iDrrr.fg)("ptc-reporting-lines-knowledge-discovery-query")) getReportingLinesFromKnowledgeDiscovery(userId, environment, {
                cloudId: cloudId,
                orgId: orgId
            });
            else getReportingLines(userId);
        };
        t3 = [
            userId,
            cloudId,
            orgId,
            environment,
            getReportingLines,
            getReportingLinesFromKnowledgeDiscovery
        ];
        $[0] = cloudId;
        $[1] = environment;
        $[2] = getReportingLines;
        $[3] = getReportingLinesFromKnowledgeDiscovery;
        $[4] = orgId;
        $[5] = userId;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[8] !== fireEvent) {
        t4 = (users)=>users?.filter((user)=>{
                const isActiveAccountStatus = user.pii?.accountStatus === "active";
                if (!isActiveAccountStatus) fireEvent("operational.reporting-lines-user.failed", {
                    aaid: user.accountIdentifier || "undefined"
                });
                return isActiveAccountStatus;
            });
        $[8] = fireEvent;
        $[9] = t4;
    } else t4 = $[9];
    const filterNonactiveUsers = t4;
    let t5;
    if ($[10] !== data || $[11] !== filterNonactiveUsers) {
        t5 = data?.reportingLines ? {
            managers: filterNonactiveUsers(data.reportingLines.managers),
            peers: filterNonactiveUsers(data.reportingLines.peers),
            reports: filterNonactiveUsers(data.reportingLines.reports),
            user: data.reportingLines.user,
            lastModifiedDate: data.reportingLines.lastModifiedDate
        } : data?.reportingLines;
        $[10] = data;
        $[11] = filterNonactiveUsers;
        $[12] = t5;
    } else t5 = $[12];
    const filteredReportingLines = t5;
    let t6;
    if ($[13] !== error || $[14] !== filteredReportingLines || $[15] !== isLoading) {
        t6 = {
            isLoading: isLoading,
            reportingLines: filteredReportingLines,
            error: error
        };
        $[13] = error;
        $[14] = filteredReportingLines;
        $[15] = isLoading;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : (userId, options)=>{
    const [{ data: data, isLoading: isLoading, error: error }, { getReportingLines: getReportingLines, getReportingLinesFromKnowledgeDiscovery: getReportingLinesFromKnowledgeDiscovery }] = (0, $aeecbceb6b802fef$export$fa989b0eaa9784de)();
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const { cloudId: cloudIdFromConfig, orgId: orgIdFromConfig } = (0, $3DKrH.useAppConfig)();
    const cloudId = options?.cloudId ?? cloudIdFromConfig ?? undefined;
    const orgId = options?.orgId ?? orgIdFromConfig ?? undefined;
    (0, $cozmU.useEffect)(()=>{
        if (!!cloudId && !!orgId && (0, $iDrrr.fg)('ptc-reporting-lines-knowledge-discovery-query')) getReportingLinesFromKnowledgeDiscovery(userId, environment, {
            cloudId: cloudId,
            orgId: orgId
        });
        else getReportingLines(userId);
    }, [
        userId,
        cloudId,
        orgId,
        environment,
        getReportingLines,
        getReportingLinesFromKnowledgeDiscovery
    ]);
    const filterNonactiveUsers = (users)=>{
        return users?.filter((user)=>{
            const isActiveAccountStatus = user.pii?.accountStatus === 'active';
            if (!isActiveAccountStatus) // @ts-ignore - hyphenated action subjects are not supported in @atlaskit/teams-app-internal-analytics
            fireEvent('operational.reporting-lines-user.failed', {
                aaid: user.accountIdentifier || 'undefined'
            });
            return isActiveAccountStatus;
        });
    };
    const filteredReportingLines = data?.reportingLines ? {
        managers: filterNonactiveUsers(data.reportingLines.managers),
        peers: filterNonactiveUsers(data.reportingLines.peers),
        reports: filterNonactiveUsers(data.reportingLines.reports),
        user: data.reportingLines.user,
        lastModifiedDate: data.reportingLines.lastModifiedDate
    } : data?.reportingLines;
    return {
        isLoading: isLoading,
        reportingLines: filteredReportingLines,
        error: error
    };
};











parcelRequire("cozmU");
































var $56jml = parcelRequire("56jml");

var $p4wJt = parcelRequire("p4wJt");

var $4MoGw = parcelRequire("4MoGw");

var $65ENq = parcelRequire("65ENq");


var $6AG3B = parcelRequire("6AG3B");

var $b5YqG = parcelRequire("b5YqG");











parcelRequire("cozmU");

const $a0efbc9ff5a6ae53$var$Meeple = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Meeple() {
    const $ = (0, $bDgLe.c)(10);
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M100 38.5C100 36.567 98.433 35 96.5 35C94.567 35 93 36.567 93 38.5V77.5H59.5C40.9985 77.5 26 92.4985 26 111V122H33V111C33 96.3645 44.8645 84.5 59.5 84.5H93V111.5C93 113.433 94.567 115 96.5 115C98.433 115 100 113.433 100 111.5V84.5H134.5C149.136 84.5 161 96.3645 161 111V122H168V111C168 92.4985 153.002 77.5 134.5 77.5H100V38.5Z",
            fill: "url(#paint0_linear)"
        });
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
            cx: "28",
            cy: "134",
            r: "26.5",
            fill: "url(#pattern0)",
            stroke: "white",
            strokeWidth: "3"
        });
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
            cx: "166",
            cy: "134",
            r: "26.5",
            fill: "url(#pattern1)",
            stroke: "white",
            strokeWidth: "3"
        });
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
            cx: "97",
            cy: "28",
            r: "26.5",
            fill: "url(#pattern2)",
            stroke: "white",
            strokeWidth: "3"
        });
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
            cx: "97",
            cy: "134",
            r: "26.5",
            fill: "url(#pattern3)",
            stroke: "white",
            strokeWidth: "3"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
    }
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("pattern", {
            id: "pattern0",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("use", {
                xlinkHref: "#image0",
                transform: "scale(0.0025)"
            })
        });
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("pattern", {
            id: "pattern1",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("use", {
                xlinkHref: "#image1",
                transform: "scale(0.0025)"
            })
        });
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("pattern", {
            id: "pattern2",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("use", {
                xlinkHref: "#image2",
                transform: "scale(0.0025)"
            })
        });
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("pattern", {
            id: "pattern3",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("use", {
                xlinkHref: "#image3",
                transform: "scale(0.0025)"
            })
        });
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
            width: "194",
            height: "162",
            viewBox: "0 0 194 162",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t0,
                t1,
                t2,
                t3,
                t4,
                /*#__PURE__*/ (0, $8aG6j.jsxs)("defs", {
                    children: [
                        t5,
                        t6,
                        t7,
                        t8,
                        /*#__PURE__*/ (0, $8aG6j.jsxs)("linearGradient", {
                            id: "paint0_linear",
                            x1: "97",
                            y1: "81",
                            x2: "97",
                            y2: "122",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                                    stopColor: "#A5ADBA"
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#A5ADBA",
                                    stopOpacity: "0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("image", {
                            id: "image0",
                            width: "400",
                            height: "400",
                            xlinkHref: "data:image/jpeg;base64,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"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("image", {
                            id: "image1",
                            width: "400",
                            height: "400",
                            xlinkHref: "data:image/jpeg;base64,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"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("image", {
                            id: "image2",
                            width: "400",
                            height: "400",
                            xlinkHref: "data:image/jpeg;base64,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"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("image", {
                            id: "image3",
                            width: "400",
                            height: "400",
                            xlinkHref: "data:image/jpeg;base64,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"
                        })
                    ]
                })
            ]
        });
        $[9] = t9;
    } else t9 = $[9];
    return t9;
} : function Meeple() {
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "194",
        height: "162",
        viewBox: "0 0 194 162",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M100 38.5C100 36.567 98.433 35 96.5 35C94.567 35 93 36.567 93 38.5V77.5H59.5C40.9985 77.5 26 92.4985 26 111V122H33V111C33 96.3645 44.8645 84.5 59.5 84.5H93V111.5C93 113.433 94.567 115 96.5 115C98.433 115 100 113.433 100 111.5V84.5H134.5C149.136 84.5 161 96.3645 161 111V122H168V111C168 92.4985 153.002 77.5 134.5 77.5H100V38.5Z",
                fill: "url(#paint0_linear)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                cx: "28",
                cy: "134",
                r: "26.5",
                fill: "url(#pattern0)",
                stroke: "white",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                cx: "166",
                cy: "134",
                r: "26.5",
                fill: "url(#pattern1)",
                stroke: "white",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                cx: "97",
                cy: "28",
                r: "26.5",
                fill: "url(#pattern2)",
                stroke: "white",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                cx: "97",
                cy: "134",
                r: "26.5",
                fill: "url(#pattern3)",
                stroke: "white",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("pattern", {
                        id: "pattern0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("use", {
                            xlinkHref: "#image0",
                            transform: "scale(0.0025)"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("pattern", {
                        id: "pattern1",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("use", {
                            xlinkHref: "#image1",
                            transform: "scale(0.0025)"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("pattern", {
                        id: "pattern2",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("use", {
                            xlinkHref: "#image2",
                            transform: "scale(0.0025)"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("pattern", {
                        id: "pattern3",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("use", {
                            xlinkHref: "#image3",
                            transform: "scale(0.0025)"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)("linearGradient", {
                        id: "paint0_linear",
                        x1: "97",
                        y1: "81",
                        x2: "97",
                        y2: "122",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                                stopColor: "#A5ADBA"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                                offset: "1",
                                stopColor: "#A5ADBA",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("image", {
                        id: "image0",
                        width: "400",
                        height: "400",
                        xlinkHref: "data:image/jpeg;base64,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"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("image", {
                        id: "image1",
                        width: "400",
                        height: "400",
                        xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QBYRXhpZgAATU0AKgAAAAgAAgESAAMAAAABAAEAAIdpAAQAAAABAAAAJgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAABkKADAAQAAAABAAABkAAAAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/8AAEQgBkAGQAwERAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/bAEMAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/bAEMBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/dAAQAMv/aAAwDAQACEQMRAD8A6Cv8fz/rACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD/9DoK/x/P+sAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAP/0egr/H8/6wAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA//S6Cv8fz/rACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD/9PoK/x/P+sAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAP/1Ogr/H8/6wAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA9F8N/Cnx34pCSafoNzb2b4I1DVP+JbZlD0kja52zXSHpm0hmwevQ7fy/irxk8O+EHUo5nxFhcTjqbcZZblH/CrjozW9OrDC89DCVFvy43EYbTa14nx2dcfcK5E5Qxea0a2Ji2nhMD/ALbiFJbwmqPNSoy62xFWh5bpHtOjfsxXDKr+IPFEMTcb7bR7N5x74vbxoCMdB/oB9ewr8Gzz6W2GjKdPhrhGvWjryYvPMdDDvy5sBgI4hPu7ZjHtZXvL80zLxwpJuOUZHUmvs18xxMaT8r4XDU6q/wDLtW21ueiWP7O3w8tFUXK61qbDlmu9S8oMe426fFY7V9AG3DoWPJr8xzH6T3ibjJSeFlkOUxd+WOCyp1nFdPezLEY+8urbXK3tTSbjH4/FeMPGFdt0ZZbgov4Vh8F7Sy6a4upibvu7JN6qKulHoovgn8MIgAvhWFscZl1LWZicdz5mpNyfpj6Y+X5er4++LlZty4wrxv0pZVkNFLyXssqhb8fNt3Z40/E3jipe+fVV/gweW09+3Jg47fP9RJfgj8L5s7vC0Sk94tT1uHH0EWpoP6fmTVUfH/xdofDxhWkuqrZTkFf8a2UTl9zj6q9x0/E7jmnblz6o/wDr5gssq/f7TAyfX/g/y4F/+zv8O7zP2aPWdLJ6fYtT80KfpqUWoEj1+YZ7Y4NfSZd9J3xPwTX1qrkWcJPX+0MoVFteuVYjLUn20a2buk0ethPGHjHD29tPLcdbf61glBv/AMI5YRL1XrZ2aPPdZ/ZiYBn8P+KFZsHbbazZlRntuvbIvgdjjTyR15+7X6XkX0totxp8S8ISjG/v4rIscpu3aOX49QTdru7zNX2srtn1+W+OCuo5vkbS+1Wy3E3a72w2JhG+nfFrt3Z414k+EHj7wwrzXeiS39mgJa+0YnUrdVH3nkjhVruBAOTJc20CAdzzt/deFvG7w34slTo4PiCjl2OqNKOX57FZViXJ/DCnVry+o4ipJuyp4XF15trZXi5fpGTeInCeduNOhmdPCYiVksLmSWCqtvaMJ1H9Xqzb2hRr1ZPtqjzMggkEEEHBB4II6gjsQa/WE00mmmmrprVNPZp9U0fbpppNO6eqa2a7rff1+8SmAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAH//V6Cv8fz/rACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgDtPC3w98XeMWB0LRri4tdxV9RnAtdNjKnDg3k5jikdP4ooGlnHaFs4r4Ti/wAS+CeBoP8A1izzC4bF8inDK8O3jM1qqSvBrA4dVK1KFT7FfERo4d63rK0nH5rPeL+HuHItZrmNGlX5eaODpN18bNP4bYakp1IRl9mpVVOl/wBPFb3fftD/AGY2KpJ4k8TBGOPMs9Ett+PUDUL7AJ7f8g3GeQxxhv5t4h+lpBTqUuFeFHOCbVPHZ/iuRyXRyy3L5Nq710zO9vsrXl/Jc08b0pShkuSOUdeXEZnX5W+18JhYu3/hZ6pHo9n+z38N7ZVWa01XUCBy93qs6M/uwsfsSAn/AGVT2AwTX5ZjvpMeKeLnKWHxuT5XGT0p4HJsPVjDyi8yePqO39+UvV6o+NxHi9xnXk3TxOAwie0cPgKUox9PrX1qX/gTk/Wy5Z5/gD8M5kKx6VfWp/vwaxqDOPp9puLlPzT8/wCLnw/0kvFehNTq5zl+Mit6WIyTLIQfq8JhsLU+6f3aGVLxa42pyTnmGGrr+Srl2DUX6uhQoz+6cf8A5HiNV/Zj0WaRW0XxNqVhGXBki1G0t9Twh+8IpIJNNYEdV8wS54DN/HX6Bk/0tc+oU5Qz7hPKsyqKm1SrZXjsVlP7xL3XWpYmnmympPSfs5UbXbjHRQPp8B435nTg45nkuCxcuV8tTB4itgfe6OcKtPHKSenNyyp94r7MfUfCHwi8FeDhDNa6aupapGFJ1bVQl3ciQYPmW0TJ9lsiDnY1tCkwU7XmlILN+Q8b+NXHvHDr0MZms8ryis5RWS5M54LBuk9PZ4urGcsXj01Zzji8ROg5rmp0KV+WPwvEXiDxLxG6lPEY2WDwM7pZfgHLD0HB3XLWmpe3xV1bmVebpuSvGEE+SPp1fkp8QFABQAUAFABQAUAFAHn/AIu+GHg7xojtqulpDfsDs1fTttpqSt2aSVFMd0B2S9juEXJ2KG5r9L4K8W+OeA504ZNm9SvlsJJzyXM+fHZVOK3jToTmqmDctOaeX1sJUlZKdSUU4H1vD3G/EfDUoxy/HTqYSL97L8XfEYKS6qNOU+ag31lhp0ZvZtr4fkfx78DPEvhJZtQ0rf4j0RNzvPawsuo2UYyc3liplZ40X711amWMKrSTpbKQtf2p4c/SF4T40lRy3OOThbP6jjThh8ZXjLLMdUeiWBzGaowhVqS0jg8ZGlVcpQpYeri5qUo/0Hwp4pZLn7p4TMOXJszk1GNOvVTweJm9EsPipRpxjOT2oV1CbclClOu0zw+v6BP1AKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAP/1ugr/H8/6wAoAKACgAoAKACgAoAKACgAoAKACgAoAKANLSNH1TXtQt9L0eyn1C/um2w21um9z/edySqRRRj5pZpWSGJAXkcIGK+VnWeZRw5luJzjPMww+W5bhIc9fFYmfJCN/hhCKvUrVqj92jQowqVq07U6VOc5JHFmGY4HKsJWx2Y4mlhMJQjzVK1aXLFdoxXxVKk37tOlTU6lSVowhKTUZfY3gD9n3SNHWHUvGPk63qnyyLpaEnR7NuCEmU7W1KVT98ShbPJZPInCpO38N+JP0ls7zyWIyrgZV+H8ofNSnm8+WOeY6Oznh5Rco5TRktYOi54+yjUWKwspToH85cW+LmY5jKrguHPaZZgNYPHSssxxMduam0msFB/Z9m5Ym1pe2pXnSPoyKKKCKOGCKOGGJFjiiiRY4o0UYVI40AVEUDCqoCgcAAcV/LtatWxFWpXxFWrXr1pyqVa1apOrVq1Ju86lSpNuc5ybvKUm5Nu7bvc/HKlSdWc6lWc6lSpJznUqSc5zlJ3lKcpXlKTd223dvV3JKyICgAoAKACgAoAKACgAoAKACgAoAKACgAoA8D+JnwP0rxYJ9Y8OiDRvER3SSxhfL03Vn6n7THH/AMet255+2QptkYsbqORn86L+j/Cf6QWccGPDZHxO8TnvDCcKVGo5e1zXJqe0fqlSpNfXMFTjp9RrzTpQUVhK1KEHh6/6xwT4oY/IHSy7OHVzHJ1aEJOXPjcBHZewnO/t6EV/zDVJXhG3sJ04x9nP4j1TStR0TULrS9VtJrG/s5TFcW067XjYcgjlleN1IeKVGaOWNlkjdkdXb+/8ozjLM/y3CZvk2NoZhluOpKthcXh5c1OpB3TTTtKnUpyUqdajUjGrRqxnSqwhUhKEf6dwGPweZ4ShjsBiKeKwmJgqlGtSd4yi+j6xnFpxqU5qM6c04Tipxko59ekdYUAFABQAUAFABQAUAFABQAUAFABQAUAFAH//1+gr/H8/6wAoAKACgAoAKACgAoAKACgAoAKACgAoA6Twp4U1jxlrNvomiwebcTfPNM+VtrK2UgS3d3KM+XBEGHQM8jlIYUkmdI3+V4y4yyPgXIsTn+fYn2OFoWp0KFPlni8fi5qTo4LBUXKPtcRV5ZPVxp0qcalevUp0KVScfFz/AD/LuG8trZnmdX2dGn7tOnHWtia7TdPD4eH26s7P+WMIKVSpKNOE5x/QbwD8PND8AaYLXToxcajOif2nq8yAXV9IvJUfe+z2iNkwWkblEGGkMs5eZ/8ANDxH8TuIfEnNXjM0qvDZZhqk/wCyckoTk8Hl9KV0pS+H61jpwt9YxtWPPUbcKUaGGjTw8P5E4s4wzTi3GuvjZulg6UpfUsvpzbw+Fg9E37sPa4iUbe1xE480npFQpKFOPfV+cHygUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAHl/xL+GOlfEDTWJWOy8QWkTDTNVC4ORlls77blprGRiezS2rsZrf70sU/654UeLWceGmaxSlVx3DWNrweb5M53VnaEsfl/PaFDMKUEvtRpYyEI0MTflo1sP8AccFcb4/hHGqznicoxFSLx2ActLP3XicLzaUsVCK3vGFeMVSrbU6lL8+dX0jUdC1K70jVbWSz1CxmaG4t5RyrDlWVh8skUiFZIZULxyxOkkbsjhm/0wyTOsr4iyrBZ1k2LpY7Lcwoxr4XE0m+WUH7soTi/fpVqU4ypV6NRQq0a0J0qkIzhOMf67y7MMHmuCw+YZfXhicJiqaqUasHo09HGSdpQqQknCpTmlOnUjKE1GUWjNr1DtCgAoAKACgAoAKACgAoAKACgAoAKACgD//Q6Cv8fz/rACgAoAKACgAoAKACgAoAKACgAoAKAL2mabe6zqFnpWm273V/f3EdtawR/ekllbaoJPyoi8vJI5CRxq0kjKisy+dm2a5fkWWY7OM1xMMJl2W4ari8XiKj92nRox5pWS96dSWkKVKCdSrVlClTjKcoxly47G4XLcHicfjasaGFwlGdevVltCnBXdlvKT0jCEbynNqEE5SSP0Z+HHgDT/h/oUdhAI59UuhHNrOohfnu7oKf3UbMN62VrueO1iPYvM6rNNKW/wAu/FLxJzPxK4iq5liHVw2UYR1KGRZU53hgsG5K9WrGLcJY/GcsauMrJyvJQoQl7ChQjH+N+MuLcZxbms8XVc6WBoOdPLcE37uHoN/HNL3Xia/LGdeoua7UacX7OlBHoNfmh8iFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAHiPxn+GaeNNHOraVAv/CTaRCzW+xQH1SyXLyabIwwXlUlpbAtnbNvg4S5Z0/f/AfxYqcBZ2smzjES/wBUs7rwhivaSbp5Pj58tOlmtNN2hRklGjmUYKLlQjTxHvTwkIVf07w242lwzmKwGPqy/sTMKijW5pNxwOJlaMMbBapU3ZU8Wla9Llq6yoKE/gdlZGZHVlZWKsrAhlZTgqwOCGBBBBGQRg4wa/0fjKM4xnCUZwnFSjOLUoyjJXjKMldOLTumnZrVXuj+sYyUkpRalGSUoyi01JNXTTWjTWqa0a1Q2qGFABQAUAFABQAUAFABQAUAFABQAUAf/9HoK/x/P+sAKACgAoAKACgAoAKACgAoAKACgAoA+yP2d/AS2VhJ451KEfa9RWW10NJF5t7BXMdzeqDkrLeyI0ETAKwtYnZWaO8ZV/hj6T3iPPHZjS8PcrrtYLLJUcZxBOnP3cTmUoKrhMvk4u06OApThiK0JOUXjatOMoRq4FOP84eMPFksTi48L4Kp/s2DlTr5nKEtK2LceejhnbR08NCSq1E3JPETinGM8OnL6gr+Rj8OCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPiD9oDwCNB1pPFmmw7dK8QTsL5EXCWmtFTJI2AMLHqSK9yvJ/0mO7JIVokr/QH6NfiR/rFkM+DM1r8+ccN0IvLp1JXqY3IVKNKlFN/FUyqpKnhJfD/slTBW5pQrSj/T3hHxb/amWy4fxtS+PymmnhZTleWIy1NQgtbtzwcpRovXSjPD2u41GfO1f0+fsQUAFABQAUAFABQAUAFABQAUAFABQB//0ugr/H8/6wAoAKACgAoAKACgAoAKACgAoAKAOj8I+Hp/FfiXR/D9uSralexxSyKMmC0QGa9uMcA/Z7SOeYAn5igXjIr5bjbifD8G8KZ5xNiVGccqwFStRpSbjHEYyo40MBhW1qlicbVw9ByWsVU5uh43EOcUsgyXMs3q2awWGnUpwe1XEStTw1Hpb2uInSptrZSvrax+nllZ22n2drYWcSwWllbw2ttCgwkUFvGsUUaj0SNFUdenJPWv8ksdjcVmWNxeY46tPE43H4mvjMXiKjvOvicTVnWrVZvrKpUnKT21eiVrH8PYnEVsXiK+KxFSVXEYmtUr16sviqVq03UqTl5ynJyfroWa5TEKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA5jxn4ZtvF/hnVvD9ztX7fbMLaZhn7NfRETWVyMfNiG5SNnVSpeLfGTtdhX1vAvFeK4I4syXiXC80v7OxcXiqEXb61l9ZOjj8K7+7evhKlWFOUlJU63s6qXNTie5w3ndbh7O8vzehzP6pXTrU4u3t8NNezxNF6pfvKE5xi5XUZ8k0rwR+Y95aXGn3d1YXcTQ3dlcz2lzC33ori3leGaNsZG5JEZTg9R3r/WnA43C5lgsHmOCqxr4PH4XD43CV4fDWw2KpQr0Ksb2fLUpTjNXW0uh/b2GxFHF4ehisPNVcPiaNLEUKkfhqUa0I1Kc15ShJSXqVq6jYKACgAoAKACgAoAKACgAoAKACgD//0+gr/H8/6wAoAKACgAoAKACgAoAKACgAoAKAPp39mfQVuda1/wARSx5GmWUGnWjsPlFxqUjyTvGf+ekVvaCJvSO7x/FX8lfSw4ilhcg4c4Yo1OWWb5hiMzxkIvV4XKqcKWHp1F1p1sVjfaxXWpgk/sn4f42ZrKjluU5PTnZ47E1cZiIp6+xwUYwpRn/cqVsQ5rvPD3+yfZdfwofzeFABQAUAFABQAUAer/CX4Uaz8U9e+xWxex0OxKS65rRi3x2cLZKW1uGKpPqF1tZbeHOEUPcy/uomVv6M+jf9HPij6QvF/wDZWAlVyjhLKHSr8WcVSoe1o5ZhptulgcFGThTxedZhyyhgsK58tKnGrjcTbD0JRq/AeIPH+W8B5V9ZrqGKzTFqcMryxT5Z4ipHSVas171LB0OZOtV3lJxo071Jxccf4jfDnX/hp4gl0PW4vMiffNpWqxI4stWsg2FuLdmzslTKpd2jM0trKdrF4ngml+X8cPBDjHwH40xPCfFVB1sNV9pieHuIcPSnDK+I8qU+WGNwcpOapYileFPMcunUliMvxMuSbq0KuFxWK9Lg3jLKeNsop5plk+SpHlp4/AVJxeJy/E8t5UayVuanKzlh8QoxhXpq6UZxqU4cBX42fWhQAUAFABQAUAFABQAUAFABQAUAFABQAUAfBn7QXhn+xPHDapCm2z8S2q6guAAq38G221CMD+8zLBeSHnL3jHjpX+jP0aeK3n/h9HKK9Tnx3CmLnlkuZ3nLLsRzYvLKj1dowjLE4GlFJWp4GO5/VvhHnX9p8LrA1Zc2IyWvLCO+snhKt62Ek/KKdbDwVtI4db3PCq/oc/UwoAKACgAoAKACgAoAKACgAoAKAP/U6Cv8fz/rACgAoAKACgAoAKACgAoAKACgAoA+8f2dtOFn8PRd7QG1bWdRvN+PmaODydOVd3Uqr2UpUcAMz45LFv8AOn6T+aPHeJjwSm3DJciyvA8l/dhUxH1jNJu23NOnj6PM9W4xgn8KUf5T8YcY8TxfLD8zccBluCw/L0UqvtMZJ2u1eUcTC7srqMU72R7vX86n5WFABQAUAFABQB6x8KfhH4g+KWri3slex0GzlT+2deljJt7RDhjbWoOBd6lLGQYbZWxGGWa5aGAh2/o36Ov0beMvpB8TLB5XTq5RwflmIorinjCvQlLB5dSdqksDl8ZOEcxzzEUXfDYGnLloxnDE46pQwzjOfwHH3iFlHAmXOtiZRxWbYmE/7NyqE0quImrxVau1d4fBU5q1SvJXm06dBTqqUT9TPCfhPQvBOhWfh7w9ZrZ6fZr7NPdTsB515eTYDXF3cMA0srdgkcYSFI40/wChLw58OeEfCnhLLOCuCsrp5XkmWU9FpPF4/FzUfrWZ5pirKeNzLGziqmJxNRLaFGjTo4ajRoQ/g/P8/wA14mzTE5xnGJlicZiZavalQpRb9nhsNS+Gjh6KdqdOPeU5udWdScqPjrwJ4e+IWg3GgeIrUTQSZktLuIKt7pl4FKx3thMysYpkzhlIaG4jLwXCPC7JXleLfhFwX41cH43g3jbLlisHWvXy7MaHJTzXIszjCUKGa5Ripwn9XxdHmcZwlGeGxdCVTCYyjXw1WdGfVwtxVnHB+bUc3yev7OrC0MRh580sLjsO2nPC4ukpR9pSna6acalKajVpThUjGZ+WPxM+GHiH4Ya42l6xH9osLgySaPrUMbLZapbIR8y5LeReQhlF5Yuxkt3ZWV5raW3uJf8Anp8evAHjTwB4tqcP8S0Xjcnxsq1bhjirC0ZwyviDAU5L3oXlUWDzPDRnTjmWVVakq2DqSjUhPE4Kvg8ZiP7x4I45yfjnK1jsun7HF0VCOY5ZVmnicBXktpWt7XD1HGTw+KjFQqxi01SrQq0Yeb1+Fn2gUAFABQAUAFABQAUAFABQAUAFABQAUAfO/wC0lov27wdp+sImZdD1aMSNj7llqcf2abntuvI9PHv+Ar+nvor59/Z/HGZ5HUny0eIMmqOnC/x4/KKixVDS6vy4Grmb2bXkmz9h8GMy+q8R4vLpO1PNMvm4q/xYnAz9tT062w88W+tvm3H4fr/QI/p8KACgAoAKACgAoAKACgAoAKACgD//1egr/H8/6wAoAKACgAoAKACgAoAKACgAoAKAP0Y+C8Qh+GPhRB3tb2X8Z9Vv5j695P8A9XSv8vPHis6/i1xlN393F5fR17YfJstoL5Wpq3lY/jjxJqe043z+T6V8NT/8FYDCUl26Q/4fc9Qr8iPhgoAKACgAoA+ifg38ANb+IstvrWtC40TwarhjeFPLvtaCN80GkRyoVEJIKS6nKjW8bZS3S6mSVIv7b+jB9DTivxvxGD4q4qjjeFPC+nVU3mcqapZvxTGnP95hOG6FenJRwsmnSr59iKU8FRlzU8FSzDE0q9PD/jviR4t5ZwbTq5Zljo5nxJKNvqylz4XLeZe7VzCUJJuqk1KngoSjWmrSrSo05QnP9JtA8P6N4W0mz0PQNPg0zS7GPy7e1t1IUZ5eWR2LST3EzZknuJnknnkLSSyM5Y1/utwdwZwx4f8ADmWcJcHZNg8i4fyiiqGCy/BQahG75qtevVm518VjMTUbrYvGYmrWxWKrynWxFarVnKZ/Feb5vmWe5hic0zbF1cbjsVPnrV6ru3/LCEV7lKlTjaFKjSUKVKCUKcIxXLHZr6c80KAOc8V+E9B8a6LdaB4jsI7/AE66GdrfLPbTqCIruznH7y2u4CxMc0ZzgvHIJIZJIn+G8RfDjg/xV4VzDg3jjJ6GcZLmEebkn+7xeAxcIzjh8yyvGRXtcBmOEc5OhiqLUlGVSjVjWw1bEYer7OQcQZtwzmdDNsmxc8JjKDtde9Sr0m06mHxNJ+5Xw9WyU6c1a6jODhUhGcfzC+LvwX174W6iZW8zVPC15MU0vXUjxtY5ZLDVEQbbW/VQdp4gvUVpbY7kuLe1/wABfpK/RZ4x+j5nbxE1X4g8PszxUqfD/F1KhZQnPmnTyjP6dJOGXZzTpxfs2+XB5pShPE4CSnTxeCwX9y+HniVlPHeD9muTA59hqaljsqlO90rJ4vAylrXwkpNcyu62Gk1TrpxlSrVfF6/lo/SgoAKACgAoAKACgAoAKACgAoAKACgDz34r6f8A2l8OfF1vt3GPSJr8DGedLeLUgR7j7JkYr9M8Gsy/srxR4JxXNy+0zuhlzd7aZxTq5S0/JrG2fk3c+v4Cxf1LjHh6teynmNPCt3tpjozwTv5WxB+bNf6qH9ohQAUAFABQAUAFABQAUAFABQAUAf/W6Cv8fz/rACgAoAKACgAoAKACgAoAKACgAoA/RP4JTrcfDDwuynJji1GBx3VoNXv48Hr1UKw/2SOnSv8AMHx+w8sN4t8XRkrKrWyvEQfSUa+SZZVutvtSlF9pJrW1z+O/E2lKlxxnqatz1MHVj5xq5fhJ3XzbT8010PVa/HT4MKACgAoA+0vgX+zj/aaWfjL4hWjLpzhLnR/DFwrI9+h+eK+1lGwyWTDD2+nEK94pWS722pFvdf6n/RG+g5/b1LK/E/xpy2pTyWoqWP4Y4BxlOVKrm9N8tTDZtxRSklOjlVRWq4PJJRjVzKDhVzLky9/VMw/mjxU8ZvqMsTw3wfiE8ZFyo5lnlGSlHCyV41MLls17ssStY1sYrxw7Thh+bEXrYX7ziijhjjhhjSKKJEiiiiRY44o41CpHGigKiIoCoigKqgAAAAV/sJQoUMLQo4XC0aWGw2GpU6GHw9CnCjQoUKMFTpUaNKmo06VKlTjGFOnCMYQhFRilFJH8oTnOrOdSpOVSpUlKdSpOTnOc5vmlOcpXlKUpNylKTu27u7Y+tSQoAKACgChqml6drVhdaVq1lbajp19E0F3ZXcSTW88TdVeNwRkEBkYYdHVZEZXRWXx8/wCH8k4qybMeHuI8qwOd5Hm2GnhMxyvMsPTxWDxeHqbwq0ailFuMlGpTqRtUo1YQrUpQqwhOPXgcdjMsxdDH5fia2DxmFqRq4fE4epKnWpVI/ajOOuqbjJaxlFyjJOMnGX52fGn9nPUfBZuvEvg6O51bwoC893Y/NPqfh+PlnMmFZ77S4h0vBm4tYx/pyukb3sv+JP0p/oP534WvMOO/DCjjuI/DuLq4vMsp/eYzPuDKOs6k61lKtm3D9BXccyipY3L6C/4VYTo0Z5pX/sXw08ZcHxKqGScRzo5fn75aWHxXu0cDm8toqF/dwuPns8O7Ua89cK4znHCw+Wa/z1P3gKACgAoAKACgAoAKACgAoAKACgDB8VRef4X8SQdfO0HWIsevmafcp/Wvo+Dq31fi7hbEXt7DiPI61+3sszws7/LlPVyKp7LPMmq/8+81y6p/4BjKMv0Py1r/AF9P7rCgAoAKACgAoAKACgAoAKACgAoA/9foK/x/P+sAKACgAoAKACgAoAKACgAoAKACgD7m/Zv1NbvwPeaeT+80nXLpAuc/6PeQ291E59N07XS4x/BnnJr/AD2+lNlMsF4g4HMoxfss54fwdRztZPE4HEYrB1YJ9eXDwwcnt/Et0Tl/LfjNgnh+KMPi0vcx+V0J83/T7D1K2HnHZbUo0Hu/itpZH0FX80H5GFABQB9ofs3/AANj1U2nxD8X2gfTo5BN4Z0e5jyt/LE3y6zexOMNZRSLnT4GBF3Kv2qT/RUt/tf+pv0Gfok0eIXlvjZ4l5aquSUayxXAXDOOo3p5viKE/wB3xRmtCrFxnleHrQvkuEqQlHMcRD+0aq+oUsIsw/mnxn8Up4D6xwdw7iHHGSh7PO8xoztLCwqR97LcNOOqxNSD/wBsqxaeHhL2EJKvKs8P98V/sWfyaFABQAUAFABQAUABAIIIyDwQehHoevX6fnSaTTTSaaaaaumno009Gmt0/wBQTtqtGtU10PkL4xfsy2HiD7X4j+H0VvpWuNunu/D+Ut9J1R+Wd7A/JFpl9Jz+7JTT7hypb7G/nTy/5p/Sc+gTk3Gn9occeC+HwPDvFk/a4vMuDL0sFw7xFV1nUqZRJ+zw/D+bVndextDJcZVcHUWV1HiMXiP6I8OfG/F5R7DJuL6lbH5WuWlh839+tj8BHaMcWtZ47Cw/n97GUYppLExVOlH4C1LTdQ0e+utM1WyudO1CylaC6sryF7e5t5V6pLFIFdSQQykjDIwZSyFWb/GrPchzrhjN8fkHEWV4/JM6yvETwmY5XmeGq4TG4PEQ+KnXw9aMKkG04zhLl5alOUKlNyhKM5f1tgsbg8ywtDHYDE0MZg8TTVXD4nD1I1aNaD2lCpBuL1TTW8ZJxklJNRo15J1BQAUAFABQAUAFABQAUAFAGJ4mlEHhvxBOTgQ6JqspJ4AEdhO5JPbgV7/ClF4jinhqgk26+f5NRSW7dTMcNBJebcj08lpurnOU0lvUzPAU1bXWeKpRWml9X3+4/LKv9gT+7QoAKACgAoAKACgAoAKACgAoAKAP/9DoK/x/P+sAKACgAoAKACgAoAKACgAoAKAOk8JeGNQ8Y6/p/h/TQBPeyHzZ3BMVnaxjfc3c2P8AlnBEpYLlTLIUhQ+ZIlfLcacW5ZwPw3mXEuatvD4CkvZYeEkq2NxlV+zwmCoX/wCXuIrSjFytKNGn7SvUXsqUzxeIM8wnDmU4vNsa26WGh7lKLSqYivN8tDD0739+rUaXNa1OHPVleEJH6OeEfCGi+CtHh0fRbcRxoFe5unCm71C524e6u5QAXlf+FQfLhTEUKRxqEr/LbjXjbPuPc8r55n2JdWrNyhhMJTco4PLcJzOVPB4KjKUlTpQveU25Va9TmrV5zqylM/jXiDiHMuJcxqZjmVZznJuNGhFyVDCUb3jQw9NtqEI9XrOpK9SpKU5NnUV8ieGFAHt3wJ+Fz/ErxfGt9DIfDGhGG/1+UblW4UuTaaSkgwRLqMkbiTayOllFdyJIkywh/wCsPohfR9q+O/iVRp5vhq3+oHCTw2b8Y4lOdOGNi6knlvDdKtC0o4jO61CrGvKnKFShlWHzGvTq0sTHCqr+YeKvHUeCuHZywtSP9uZr7TCZTB2k6LUV9YzCUG7OGDhOLgmnGeJnh4SjKm6nL+qsMMNtDFb28UcFvBFHDBBCixxQwxIEiiijQBI440UIiKAqqAqgAYr/AKIcLhcNgcNhsFgsPRwmDwdCjhcJhcNShQw2Gw2HpxpUMPh6NNRp0aNGlCFOlSpxjCnCMYQSikj+CatWpWqVK1apOrVqznVq1aknOpUqVJOU6k5yvKc5yblKUneUm27tktbkHl3ib42/CHwdLJbeJfiT4N0q8hyJdPl1/T5tTjwcHfplrNPfryCObccjGQeK+azHjHhTKJSp5jxDlGGqw+KhLG0J4iPrhqVSpXWumsN9NPs/dZH4Y+IfElOFbJOC+JMfh6n8PF08qxdPBTvr7uNr06OEejv/AB3o72V0zhI/2tv2c5ZfJX4p6GHyBmS01uKLk/8APeXSkgx6nzOBySQK8WPilwBKXIuJsEn3lSxkI6/35YWMPx06tayl9VP6PvjJCn7R8B5o42btDEZZUqaav91DHOrfsmk3sk7WPVfC3xL+Hnjf5fB/jfwr4llA3NbaNrum393GMbj51nBcPdQkLyRLChxzjrt+my3iLIc50yrOcszGVm3TwmNw9arG2r5qMKkqsLLX3oLTXT7PwWe8FcYcMa8RcL59ksL8sa2ZZVjcJh5u9v3eJq0Y0Kt3penUkm9Lu1jt69k+YCgAoAKACgDy/wCJPwj8I/E6x8rWrX7Lq0MZTT/EFiqR6lZ9SscjEbb2z3E7rO6EiAPI1u1tOwnX+f8Ax0+jb4bePmUvD8U5d9Q4kwtCVLJuMsqp0qOe5Y1zSp0a1Rx9nmuWKpKTqZXmHPRSqVamDqYLFzWKj91wX4hcQ8D4rnyzEe3y+rNSxeUYqUp4LEdJThHm5sNibJcuJock3ywjWVaknSPzc+JXwe8X/DK8Yatam+0SSXZY+IrGN30643E+XFcHltPvCOtpdbS7Bzay3MSGWv8ADDx3+jH4l+AeZTXEeXvNuFK9f2WU8bZRRrVMkxqnJ+woY2/PUyXM5xXvZdj2vaTjVeAxOYUKTxB/aPBPiNw7xxh08vr/AFXM4Q5sVk+KnCOMotL350bWjjMMntXoc3LFx9vToVJezj5LPcQW0ZluZoreJesk8iRRj6u7Ko4yeT+XWvwHBZfj8yxEMJl2CxePxVT4MNgsNWxeIn09yjQhOpLVpe7F76H6DSpVa01To0qlab2hShKpN+kYpt/d91jnJvGnhWBismuWJI/54u1wP++rdJVPT1H61+iYPwX8U8dBTo8EZ3CL2WMo0sun86WYVcNUj/28o/pH2KXDee1UnDK8Ul/08gqL+6tODX3fJ7RdB4z8LXBCx65YAnp50pth+dyIlz7Z/PgrGO8GvFLL4OpiOCM9nGN7/UsNDMpf+AZdVxc2vNQfyFV4bz2iuaeV4tr/AKdU/bP7qLqN/dH/AOR6KKaG4jWWCWOaJuVkidJI2/3XQsrfgfz/AIfzzF4PF4CvPC47C4nB4mm7VMPi6FXD16b10nSrRhUi9PtRj17Xl49SnUpScKtOdOcd4VIyhJesZJNfNfeSVzEBQAUAFABQBw/xMuXtPh/4xmRWZj4f1KDCAlgLq2e1Z8DOBGsxkZuiqpY4AJr9B8KMLDGeJXA1GpKEYribKcReo0oyeDxVPFwp66OVWVBU4R+3OSj1R9RwVRjiOLuHKcmopZvgavvOybw9aNdRv3m6aglrzOSSTukfmfX+r5/bAUAFABQAUAFABQAUAFABQAUAFAH/0egr/H8/6wAoAKACgAoAKACgAoAKACgAoA+y/wBmrwzHbaNq/iuaMfadSujpVk7L80dhZBJblo2/u3V5II5Bz81gnuF/hX6VnFlTFZ7knB1Co/quVYNZxj4Rk+WpmOPdSlhYVYbc+EwNN1aUtPdzKotbrl/m7xqzudfMsvyGlN+xwND69iYp6SxeK5oUYzj/ADUMNHng77Yue59O1/JJ+IBQA5EeR1jjVnd2VERFLO7scKqquWZmJAVQMk8DOaunTqVqlOjRpzq1as406VKnGU6lSpOSjCnThFOU5zk1GMYpylJpJNtIUpRhGU5yUYxTlKUmlGMYq7lJuySSTbbdkld2sz9cfg14Aj+HXgTStGkjVdXu1/tXX5BgltWvI4zLBvHDR2EKQ6fEV+R1tjMAGmct/wBJ30XfBmj4H+EPD/C1ejTjxLmMf9YeMa8OWUqnEWZ0aUq+E9otKlHJ8LTwuT0JRfs6kcFLFJRnianN/nr4k8XT4y4qx+ZQnJ5dh39QymDulHL8NOap1eVtuM8XUlUxc0/ei6yptuNOBxvx5/aT8CfAbTUGsO2t+Lb+3M+jeD9OnRL+6j3NGl7qNwUmj0jSvNVk+2TxSzXDJKlhaXrwXCxfpPG/iHknBOGSxTeMzWtTc8JlNCajWqRvyqtiKnvRwmG5k17WcZTm1JUKVZxqKH0nhR4LcVeK2Nl/Z0VlnD+FqqnmXEWMpTlhKE7KUsNg6KdOeY4/kkpfV6VSFOkpU5YvEYaNWk6v5uHxH+1p+2Fe3UWgm80PwK08lvLFp9zceF/A1nGTta21HUxu1DxNPGpQ3VqG1qaJ2E0em2kTKi/z5/aHil4r1qkcD7bB5K6koSjh6k8tyWjG+tPEYlOVfMZxXL7SnfFzi7TjhqUZLl/s9ZN9H76OmGoVM2WGzTiqNKFanPF0KWecU4idk41sHgbfU8kpTfN7Cu1l1OpFOnPG15xfN7T4S/4JtaWkMUvjr4lX9zcMFM9j4S0q3soYG/jSLVdYe/kugedsr6PaY6mFsGvsMr+j3hlCMs64hr1KjS56OV4anRhB9VHE4pV3UXaUsJS84n5pxB9NLHSqzp8K8FYSjRi5KniuIMfWxNWqvsyngMujhY0Ha3NCOZYjyqaJno0n/BOf4JGExx+Jvick2DtnbWfDD/NjgvF/wiKIyg8lU8tiOPMHBr6CXgDwc4cscx4jU+k3jMtevnH+x0mr9Fyv+89OX42H0x/E5VVOeS8ETp3V6Sy3PIadeWf+sUpKVusnNL+V3PHfGP8AwTk1vTgdS+GfxIiury2ZZrTTvE1jLpFykkR3q0Gv6RLeKLnIHk7tItEWQAtcoCXT5LNvo/4yh/tHDnEMKtam1Olh8xoywtRSj7ycMdhfaL2l/gvhaSUrN1Fd8v6Pw59MrLMY1g+NuDKmHw1ZOnXxmSYqGYUZQn7so1cpzGGHl7GzftOXMK83C6jRm1aXDeHP2jP2kv2ZNftfCXxl0bWPE2gZKxWnie4+0ahJaRuqSXfhjxrH9uTVEhBQeRdXWq2kahbQDTpGMieLl/H/AIheHOOpZXxdhMXmOB2jSzKftK8qSdpVctziPtViVDRclWriaUV+6X1eTlM+oznwb8FvG/KcRn/hvmWXZJm9lKeIySl7HCQxEouUKGecMz+rSwMqr5n7WhRwGIm267+uQioT/U74XfFjwT8YfDUPijwRqq39oWWHULGZRb6rot8UDtp+rWO5mtrlQSUdWltbpF8+yubm3KTN/S/DXFGTcWZdDMsmxKrUrqFejNcmKwda13QxVG7dOovstOVKpFc9GpUg1OX8IcdcAcT+HWd1Mi4nwDwuItKrhMVSbrYDMsKpcscXl+K5Yxr0ZNLmjKNOvQm/ZYmjQrKVM9Ir6E+MCgAoAinnhtoZrm5mit7e3iknuJ55EihghiQySzTSuVSOKONWeSR2VERSzEAE1M5wpwnUqTjTp04ynOc5KMIQguaU5ylaMYxim5Sbskru1jSlSq16tOjRp1K1atUhSpUqUJVKtWrUkoU6dOnFOU6k5NRhCKcpSaSTbSPzD+P/AO3JBeT3vw8+CmkWfiiW+c6Td+KtR01dYsL2eZ/JNn4Z8PT280WtF5CscV9qMM9lcuGW00y+ge3vW/mbxH8WcvzjD47hHh/KsDxDg8yp1Mux9bNMBSzTLsfTrfu6mEwuUYqjXw+Y06jfJz4uhVw9V6U8LXhKFWX9w+En0XKuGpYXjDxNzDE5FTwsVmGHyLB455bi8NSpx9osTnecUqtOplvLBOdTCYKpTxNGLTxGOwtWFXDR+fdB/Yn/AGhPHulzeKPESWHh+SRGubXRvEWoMniG8WT5/LttJt4jYaRkZVLPVL7SHhIWNreFNpX8WwfgDxjkHCeYY/gngbhzCYylReJwfCv13B8L4vOJr3vZKvSy/E4TC4mSbVNZtUwi5vdq1KEfeP13NvpNeEPCmPp5Hk8sXm8ITVDEZlk+EU8ow8oe7zV8wrVFi8wtZOWJwGFzCFRNzVarP3TzbUPgVD4dvp9J8Sf2/Y6patsuLS4hhsJI27N5U1vMzRSD5opEkaORCHjkdGDt/npxn9IzxY4Rz3HcPZzwDlXCebYCo6eKyniHA51PMaF3+7m/+FDLIVaVSPv0MTToVMPiabjWoTnSnCUvtcH4p1M5wtLMMl/snFYDELmo4ijUq4uEl/L7SnXppTg/dqQnCM4TTjOEZKUTMuPhHorqfsupanA/YzfZrlAf9xYrZiBx/wAtOfXkV4WX/S04zpVI/wBqcN8M42imuaOCWZ5bWlHr+9rY/M6ak+jWHaX8sjuo+IOZxa9vg8FVj1VNV6Mv/ApVasU9/sW/A5S58EeMfCzte6FeyXcafOzaezxXDKuTmbT5HdJ1wB+6RrvPePAr9Vy3xs8H/FChDJeOclw+U4iuvZU48Q0qGJy+E6jtbBZ/QVKtgKm/+01o5Vy/Zrc0oo96jxPw5nsVhs1w0MPOXur63GM6Kb/594uHLKi9X78lQt0k7tR6Twx8TY7mRNP8Rolnc7vKW/VTHbvIDt23cOD9lfdw0inyd331gQFm/N/E76NFfLsNW4g8OqtfN8u5PrNXIKs1iMfSoOPtPa5Tio/8jOio6ww1T/bXBR9lWx1SahHxs74JnQhLGZPKWJoW53hG+etGD15sPUTXt4pbQa9q18MqkmevAggEHIPII6Eeo69fr+dfyPKLi3GScZRbjKMk04tOzTT1TT0aeqejPz1q2j0a0afQKQBQAUAQXVtb3ttc2d1Es9rdwTW1zC4yk1vPG0U0TjjKyRuyMM8hiOK6MHi8TgMXhcdg608Pi8FiKGLwtem7VKGJw1WNahWg+k6dWEZxfSUUa0K9XDV6OJoTlSr4erTr0akdJU6tKaqU5xfSUJxUl5o/LzxRoknhvxFrWhSksdL1G6tEkbrLBHKfs03b/X25il6cb+1f668IZ/S4q4XyHiKilGOb5XhMbUpx2o4ipSj9aw67/V8Sq1BvW7p3TejP7lyLM4Z1k2WZrBJLHYOhiJRW1OrOC9tT/wC4dZTp+fLoYNfRnrBQAUAFABQAUAFABQAUAFABQB//0ugr/H8/6wAoAKACgAoAKACgAoAKACgAoA/SD4QWiWXw28JRIu0Sac123qXvrq4vXY9M5ac49Bgc4Br/ACz8bcbPH+KnGlapLmdLNI4KPZQy7B4XAQiu1o4dX7u76s/jLxDxEsTxpxBUk7uGNWHXlHC0KWGil6RpL569WekV+VnxgUAe3/s8eE18WfFPQY54fOsNB83xLfqSANulGP7AGDZEiNrE+mpLEQ3mQNKCpUMV/rH6E/hxDxH+kJwfRxmG+s5PwesRx3nEHKCiqfD0qP8AY6lGd41qdTifF5FSxGH5Ze2wk8QmuRTlH8v8YeIHw/wJmsqVT2eLzb2eSYRq9+bHqf1uzWsJRy6ljZU53jy1Y07Pmsj7Z/aP+OemfAjwBPr7JBe+J9XeXS/B+jzElL3VfK3yXt2iMkv9laTE63V+yMhlZrWwSWGa+hmT/e3xB40w/BORTxzUK2ZYtzw2U4Sb0q4nlvKtVSal9WwkWqtdq3M3Soc0J14Tj/MXgz4W43xV4tpZTGVXC5Hl8aeO4izGmlzYbAe05YYbDylGVP6/mE4yoYRT0pxjXxbp1aeFqU5fnd+zd+zlrv7RniHUvjN8Zr7VL7w1d6rJcIlxI8F7441KGQrcRpOjI9j4a04xrYN9gWFX8s6Vpj2iWUzQfgfh74f43j/H4ji7i6tia2XVcVKaVSUoVs6xEJWqRU0oujl9BxVB+wUE+X6thpU1Rnyf2J40eMuV+DeUYLw28NsNgcLneGwEKMpUYQq4bhfB1IKVGcqUlOOJzvGKbxcfrftXHn+v46OIli6cZ/sHpmmadoun2ek6RY2mmaXp1vFaWGn2FvFaWdnawLsit7a2hVYoYo1AVI0UKB69a/rDDYbD4OhRwuFo0sNhsPTjSoUKFONKjSpwVowp04KMYRitEopI/wA6sdjsZmeMxOYZjisRjsdjK08RisZiq06+JxFepLmqVa1aq5VKlScneUpO78rWjerY5QoAKAOO8eeAPCXxL8N33hPxpo9trOjXy5MUw2z2lwqssN/p10hW4sb+33MYLq2eOVQzxsxhlkR/IzvIsq4iy+tlmcYSni8JWXwz0qUqiTUa1CrFOpRr073hUpuMldxfNCUon0nCnFvEHBOdYbP+Gsyr5bmWFdlUpPmpYii2nUwuMw8r0sVhK3KlVoVozg2ozSjUjCpD8dfF/hf4jfsM/F/TvEXhe9u9Z8E6yxFjc3QMVl4m0ZZEfUPC/iFIAbeHWbAMHt7uJMbjbavYwxbrqwt/5NzXLc/8F+K8PmGW1quMyfFtqjUqLko5jg1JSr5bj4w9yGLoJqVOrFLX2eKoqN50If6M8O55wd9KTw7xmT57hsPl3E+WxTxVGhaeKyXMpQlHCZ7k8qjVWpluLcXGth5zloq2X4qpK2HxlX9ifh9478P/ABL8HaF438MXJuNH16yW6hD7RcWk6s0N7p14isyx3un3cc1ndxqzIJoXMTyRMkjf1lkWd4HiLKcFnOW1HUwmNpKpDmsqlKafJVoVopyUa1CrGdKpFNrng3Fyi4yP85uLuFc24J4jzXhjPKKo5jlOJdCo48zo4ilJKphsZhpSSc8NjMPOlicPNqMnTqxU4QqKcIdlXrnzYUAfkn+1/wDH3xF8SfGA/Z7+FBu76yGqRaJ4ibSSTdeK/EnniJvD0EiMMaNpNwPL1BnZYbrUIZzORYaek0/8t+K3HGP4hzZcB8Me1rUfrMcHmDwv8TM8w5+X6hCSl/umFnpXbcYVa8Zub9jQU5/6CfR28Jsn4L4cfi9x8sPhcT9RqZnk8cw0oZDk3snNZxVhJSf9pZhRfPg1GM6lDCVKSpReLxkqeH+uP2bP2VfC3wQ0211zVYrbxB8Sry0X+0ddlRZbbQzPGPtGleGkdT9ngTc0FxqjKl/qQ8wlrWzlWwT9S8PPDLLODcPTxmKjTx3EVakvrGNlHmp4Lnj+8wuXxa9yEbuFTEu1bEav93RkqEf588afHnPvE/G18rwFStlPBWGxEvqWVU5OFfNFSn+6x+dTi/31WXKqtHApywuCbgkq+Jg8XL60r9SP5+OL8afD3wj8QLD7B4o0e3v9istreqPI1OwZud9lfxYng+bDtDua2mKgXEMqAo35Z4p+C3ht4zZP/Y/iBwzg83VKE4ZfmsF9Uz3J5T19plWcUOTGYVc/LUqYbnngcVKEVjMLiaa5JfTcNcX8Q8I4v63kWY1sJzSi6+Ff73BYtLTlxOEnzUqnutxjU5Y1qak3Rq05Pnj8I/Eb9lvxZ4ZM+o+Dnk8XaKu6T7IiJH4htIxk7Xs0xFqYUYAk08faZWyRpyKvzf5CeOP7PnxF4DljM88MatfxI4Wp+0rPLaVKnR41yygry5KmW0rUM/UI8sVXyVRx1ebbWR0acXUP6q4M8duH87VLB8Rxhw/mcuWH1iUpTyfETel44iV54Ft3bhjL0IK3+2Sk+Q+XZoZbeWSCeKSCeF2imhmRo5YpEYq8ckbgPG6MCrIwDKwIIBBFf5+YnDYnBYivg8Zh6+ExeFq1KGJwuJpVKGIw9elJwq0a9Cqo1KVWnNOFSnUjGcJJxkk1Y/dadSnWpwq0akKtKpGM6dSnOM6dSEleM4TjeM4yTTjKLs07q+h5z4y8C2niCKW+sUS21lEJV1ASK+2jIiuR8o80gbI7nO4fKsu+NV2fvfg545ZrwDisLked1a2ZcHVq0YTpVHOriciVWaU8XlrvKbw0G/a4jLrOnU9+pho0sROp9Y+x4c4pxGUThhsS5V8tlKzi7yqYXmetSho3yL4p0LSjLWVPlm5c3K/DzxZc210PCutGRGV2g095wRLbzxnB0+Ytg7SQVtg3zRuPs67leIJ+qfSE8KsvzTLJeKXBsKFWFShSx2f0cByVMLmGBrxjOnxDhPZe66kYzjPMXT5oYihL6/LkqUsVUr+9xfkFGvQ/t7LFGUZRjVxcaNnTq0ppNYymo3V0rOtbSUf3zfNGo5+2V/FJ+ZhQAUAFAHwH+0DZLa/Ei+mVQv8AaGm6Vetjuy232Et9SLIZ9TyeSa/0j+jVj5Yzwry6hKTl/Zma5xgI3d7Rliv7QUVu7L6/onstFZWR/WfhHiZV+DMLTbb+p43H4ZX6Rdb60l10X1nTtsrWseJ1++n6aFABQAUAFABQAUAFABQAUAFAH//T6Cv8fz/rACgAoAKACgAoAKACgAoAKACgD9Hvg9eR33w18KSxnIisJLNweoksbu5s3B9OYMrnqhU96/y18cMDUy/xV4yo1FZ1syp46DW0qeY4LC46DXfTEcsrXtNSWlrH8aeImGnheNM/pzVvaYuOJj2cMVh6WIi130q2dtpKS6HpVflJ8UFAH3R+xvogEPjbxJJECXk0rRLOfuojW5v9SiHs5l0pz/uCv9c/2X/CkY4XxX45r4eLlVr8PcKZZi38UI0KeOzfPMOn/LVeI4eqy86ML9D+WPpIZo3U4YyWFRpRhj80xFLpJzlRwmCqPzj7PHxX+Nnx38TZ9Q/av/a4tvAtldzf8Ij4f1SfwzBNbvmKz8N+GpZbjxbrMDY8j7Vqt3BerYXRTE4k0S2kMqxRbv6n4jnX8T/FOnktGrP+ysDiZ5dCdOV40cvy6UqmaYuD1h7TE1YVlQqNNT5sHTk5KMT+i+CKWE8Avo+V+KcVh6f+sOb4GlndWnWjaeJznOoU6PD+W1Ypqr7DAYerhZYugp3pcmZ14KEpzP2T0fSNM0DStN0PRrKDTtJ0iyttO02wtk2W9pZWcKQW1vEvZI4o1UE5Y4yxLEs39bYTC4bA4XD4LB0YYfC4WjTw+HoU1ywpUaUFCnTiu0YpLq3u222z/N/McwxubY/GZpmWJq4zMMwxNfGY3F15c1bEYnEVJVa1apLW8p1JSk7aK9o2SSNGug4woAKACgAoA8w+Mfww0f4v/DzxD4G1dI1Oo2rTaRfum59I161V5NJ1SFgC6/Z7nCXKxlGubCW7s2YR3Dhvm+LeG8JxXkOPyXFqKeIpueErtXlhcbTTlhsTB2bXs6llUUbOpQnVpNuM5I+58OOOMx8O+MMo4py6U5LBV408xwkZcscxyqvJQx+BqK6i/bUbyoSmpRo4unh8SoudGB+dH7A3j/VvCHj7xn8CPExktWuptUv9Nsbhzu0/xZ4bc2fiHTYUzjfe6dbyXM+CVU6CSoBmdm/APA7PcVlWeZvwTmLlTdWeJrYejN60M0y5ulj8PFa61sPSlUnrZPBXXxty/sf6WXCWX8RcJ8NeKuRqFeNCngcJjMVRjaOMyDOoLE5Pjakt+XDYytCjSv70lmqUm1ShE/Wav6jP8/zwL9pv4oyfCP4N+KfE9lMIdeu4o/Dvhlt21113WvMghuoj0Mul2a32sohDB/7OKEYY18N4jcSy4V4SzPMaM+THVoxy/LnezWNxnNCNWO6csNRVfFpNWl9X5Xe5+teCHAsPELxHyHI8VTdTKsPUnnGdq14vK8s5atWhU6qnjsTLC5bKScXD65zp3ij5E/4J8fB6GLS9X+NuvW/n6nqtxe6F4QluR5rwWMEhi8QazE77j9p1C+D6QlwNs8cNlqcRJhv3DflfgRwnCOGxXGOOp+0xOJqVsDlUqi5nCjTly47Fxbb/AHleunhVUXvxjQxEbuNaXN/Qv0vPEWpPHZf4Y5TW9jgsBRw2a8RQovkjVxVaCqZTltSMbWo4PCuGYSpO9KpUxeBmoxnhIM/Tiv6NP4gCgAoAKAPMfHvwg8CfEWNn1/SFj1PZsi13TStlrEWBtTdcqrR3iRjiODULe8gjyTGit81fgfjD9Gjwh8bqNSpxjw1To586XssPxdkUoZVxNh+WPJS9pjqdKpSzOlRjpRwuc4bMcLSTbo0Kc5c8fuOFPETirg2cY5TmEp4Lm5qmVY1SxWXVLu8rUJSUsPKb+KrhKuGqy0UpySsfEnj79lrxv4ZM174XZfGOkrucRWkYt9dgjHOJNNZ2W9K8IradLPPK2W+xRKcL/lD4x/s+PFfgN4rNfD+pDxO4cp89VUMvoxwXF2Dor3uWvkU61SnmjgnGnCeSYnGYvEzUqryvCwtCH9PcJeO3DGd+zwuexfDmPlaPtMRP22VVZ7XhjVGMsNd3k1jKVGlTVl9aqNe9+fPxb8M3Ol3kOuC2uLC9huFstUglie2ube7i+a1nkicLLDMvltDKXVWVltxjcSa8T6NfFWOhLPvCbizC4ihiMvpYrE4DLc3w1ShiKFCU/ZZ3kmKwmLjCpDlniIYuGEq0edRq5h7RKEYxj/XXh/ndHHYapljrUcXhatGWJwNWE4VqFWhPSvShOLlCpTlz+1goyaalWd2rKPpHhfWBruhWGokr50sXl3QXgLdQExT/AC/wh3UyovOI5E5OQa/lnxO4QfA3HGfcOxU/qeGxX1jLJzbk6mV42EcVgbz/AOXk6VGosNWqaXxFCrommj43PMueVZpi8Er+zp1Oeg31oVUqlLX7TjGShN6XnGWitY36+CPJCgAoA+Ff2kHVviBbBcZj8N6cj4/vG81Nxn0Ox1/DB7iv9DvoswnDw2xcpX5anFWaTp3/AJFgMopu3l7SnP537M/qbwZjKPCVdu9p51jJRv8AyrDYGGnlzRl31v2aj4DX9JH60FABQAUAFABQAUAFABQAUAFAH//U6Cv8fz/rACgAoAKACgAoAKACgAoAKACgD68/Zq8Vo9tq/g25kxLFKda0sM334ZBFBqECZwB5Mi29wiLkt9ouZMAIxr+JvpWcG1IYrJOOcJSbo1qUchzdwjpTr0nWxGWYmpa7ft6U8ThZ1JWjH6thad3KpFH88+NWQTjXy/iOhC9OpBZbjnFfDVg6lXCVZWu37SEqtGUnyqPsaMNXOKPqyv44PwUKAP0H+CmpHwR+zX4v8YxgJLp9l488WIxXO6XRNJkSJiD987tHRAOc7dvOdtf7tfQMw/8Aqz9FfGZ/GCpzx+fcccR8/Kv3s8uo0MphN7c7TyKNJX6QUVezR/IPibglxP41cPcOTblDGYnhTIJRUrctPM8fCU0n9n3cxlK/S7fU+Xf+CbvhpLvXvih44ulMl3Y6donh2zuJPnd/7bu73VdXJdst5m7RtKLNnc4lbP8Atfrv0fMujWx3EmdVVzVaFDB4CjOWrf1yrWxOKd3qpXwmGu7+9zu9rH7p9M/O5YfKeBuF6DUMPisZmmcYijD3Yx/szD4XAZelFWXJy5lj0la0fZqyVvd/WOv6hP4BCgAoAKACgAoAKAPxt+MkQ+Fv7d3hzxFY/wCiWmt+KfA3iGcINv8AofiL7NoHiZl24y166azK5PWS5cNn+L+SeLY/6teNmX4+h+6pYzM8lx87K37rMPZ4HMbWerrNYyTbt71R6OzP9H/Dip/r39FXOcnxX+0YjK8i4pyilzO7+s5P7bNskTveyw0ZZbTiltChFqza5f2Sr+tj/OA/LX/gpR4jlWD4WeEYpCIJpvEfiO+iycNLbppumaVJjpmNLrWVycn95xjJ3fzT9IbMJqHDOVRl+7nLMMwrQ7zprD4bCy/7dVXFrb7XQ/uz6FmTU3V474hqQTq06eTZNhanWNOtLG47Hw72lLD5bLR/Y1vaJ+gfwf8AC8Pgr4WfD7wvDGIjo/hHQ7e5AULv1B7CG41OdlGAHudRmuriTH8crdetfu3CeWwyfhnIcthHl+qZVgqdRWtevKhCpiZtLZ1MROrUl5yfc/kbxFz2pxNx5xfntSbn/aPEOaVqLu3y4SOLq0cDSTd240cHToUYf3YLbRHo9fQHxgUAFABQAUAFAHz3+0r8NPDnj34R/EKS+0WxuNe0zwhrWq6Jqn2dF1KC/wBEspdWsoI7xFWcwT3FlHDJA7vAUkJMRKqV/JfE/wANuD+KcuxnEmYcN5ViOLMgyvMMVkXESwlKlnmDnRwVdvC08zoqnjKmCxNNzw9bA1qtTB1I1eadBzjCcf17wU42znhTxC4QjhcyxdHKcdxDluX5ngfbTeCq4TM8TTy/E1Z4aTdL2tKjiZ1YVYRjVUoWVWKclL8sf2Xfhf4h+KXh7xxF4avNPN/4UvtGuZNKv5HtWu4Ndt9RSNrO82y24lWXRZVeG5FvEN6ubgFglf5ieJn0V+L/AB3q1uKeAcdkn9u8N5dhMux2RZtWq5fPNsLWr5hicFUy/MVTrYNYunU+tUZ0sw+p0HTdKTx0eVUz+7/HPjrJ+BM44XqZ1h8YsLn+FzKhDH4SEa8cPVyqtg5TWJw/NCq6bhmcJRqUfbVPdcfYStzHZeJvBPizwbc/ZfE/h/U9GkLFI5Lu3b7JcMuc/ZL6LzLG8Axy1rcSqOck9a/z9498KPEfwux39n8f8GZ7wxWlN06FfMMFP+zcZKN+b+z83w7xGVZlFWd54DHYiCs7yVrHzuScT8P8SUfb5Hm+CzKCipThQrL6xST2+sYWpyYrDt3WlejSl/dOXr8+PdCgD87PjVqq6r8SfEbxsGisZrbSo8HOG0+0hguVPuLxbnjt0PINf6feAmTyyfwq4Wp1YOFbMKOKzipdW5o5njMRicJNbaSwEsK0+u6ummf2J4Z4CWA4LyaM1apiqdfHz0teOLxFSrRe7vfDOjrpfdI8qr9iPvAoAKACgAoAKACgAoAKACgAoA//1egr/H8/6wAoAKACgAoAKACgAoAKACgAoA3fDPiC98La9pev6ef9J026ScJuKrPD9y5tZCAT5V1bvLbyY52SEqQRlfnuK+G8Bxfw7m/DeZRvhc1wdTDupyqc8PW0qYXF0otxTrYPEwo4mld2dSlFSvFtS8rO8ow2e5Vjspxa/c42hKlzWTlSqfFRrwT056FaMKsNlzQV7p2P060jU7TW9L0/V7CTzbPUrSC8tm4z5dxGsiq4BO2RN2yRCcpIrIcFTX+Smc5RjchzfMskzCk6ePyvHYjL8TTV2vbYarKlJ021edOo489KaTVSnKE43jJH8QZhgcRlmOxeX4uPJiMFiKuGrR1tz0ZuEnFu14StzQltKDjJXTTOB8ZeDvjz4Uv4RrmlappUeqxtf6UofSlhnsGYGJo41maWBkR4xJbXiw30LMFuoUl3Cv8AQnOPDbwV8NMk4Mj4i8K0+GcbxLw3gs5wFPiSjnEs0xlKpQoSxU8ZHDPERw+Oo16yjjMFU9hVwlScabw1Km6cI/UcNcTeE/EOFq/2VmGBx9TLqkcJmHu5g6lHFxTU4zm6Sp1lKcJuFfDOeFqqN6FSUEmd9a6b+2O/wo1FLSPxS3wpk8PeIZtRjjufDH2CTw+RqE3iEvF5/wDabxMBqBnSMG4f51gU7o1b+svDnCcTLwoy7/iHFKvDwoq5dnWIy+GXyw1PL55dVx+ZVc6nCljOXMnGpj3mM6vtIe1lJz9klD2al8rXxv0cY8fYN4iWRLj2Gb5PTwdSpQzv63DN08HTydRq8n1KNRN4NUpTaox911XG03H6m/4JrXKt4a+Ktnui3Qa74ZuSoz54W6sNViVpP4fKY2bCHHO9Z8/w1+/fR5qJ5fxNSvG8Mbl1RpX50qtDFRTl05W6L5LK91O99D8J+mpRcc74DxFp2q5XndFN29m3QxeAm1DrzpYiLqXduWVK1veP0zr+iz+IwoAKACgAoAKACgD8X/27bKTxN+0p4W8O6Y0Y1G+8J+DvD8ZYuFTUdU8Ra79lMxjV5BhdRtWOxHfyypVWbAr+QvGujLMfEPLcBhnH6xWyvKcDG97KvicfjfZc3KnLbEUm7Jy5Xonoj/Sn6K2Khkngrn2cY6M3g8LxBxHm00uW88Hgcnyv26p87hB3lg8RFc01HnT5pRS93Y/4d4/Gn/oongf/AMGXir/5RV1/8QE4v/6H2S/+FOaf/MJ53/E4Hhn/ANEfxR/4Q5B/89j5m+PfwD8ZfAjUvDth4v1vSNdk8RWV9d2Fzo8+p3EMSWE8ENxBK2p2Vm4lBuIZNsSuux1JYE4r86434HzbgnEYChmuMwmNePo1qtCphKmJqQiqE4QqQk8TRoyUr1IStFSVpJt62j+3eE/ixw34q4POMVw7lmY5VHJ8VhcPiqGY0cDRq1JYulVqUatOOBxWJi4NUakL1JRlzQaSaV4/0H6Ncw3ukaVeWxU293ptjcwFPuGGe1iliKf7JRxt9sV/d+EqQrYTC1abThVw9CpBrZwnTjKLXk01Y/yGzKjUw2Y4/D1k1Ww+NxVGqpfEqlKvOE1LbVSi76b9jSroOIKACgAoAKACgDh/idNHb/Db4hXE0vkQweB/Fk0s3H7mOLQb93l+bK/u1UvyMcc5rxuI5xp8PZ9UnLkhTybNJyn/ACRjga8pS1uvdSvqunU+o4IpzrcacIUacPa1KvFGQU6dPX95Oea4SMYaWfvyajo766W0Pwk+AP7O3jf48jxU/hDX9F0BPC50Vb+TWrjVbdbt9Z/tU2yWp0yxvfMa3GlzNOJvK2CeApv3ts/ifgbgHOeN/wC03lWNweCjlv1RV5YypiqaqvF/WXTjSeGoVuZ01hpuany254W3fN/qn4teMPC/hS8hjxFlOZ5tLPVmUsJDLaOX15YeOW/UFWlXWOxWF5FWeOpKk6bnzOlV5uXlXP8ARL/8E8fjPsbf8QvAzKASVOo+KiCAM9DoLA9O4/PPy/ez8AuLJxlGpnmRzg170ZV8zlGS7OMsA0/R/hoz8ej9MHw1TTjwhxTF30awWQJr5rNrr8fxvHR8IfsTfEfwwuratc+LvD2pXKWBWw0TTH1Nk1OXzFd1nu9RttPhtJo442FpmKZJZpBHNcWcW+Svw3x0+iDxZxzwBj8PkGK4ZxHE+U4ijmuUYP2NWnVzKNCnXji8rw+Z1aWFhl+IxdOpH6v7eNXBYnEUqVHFVMHGUMbh/Iz76U3BWfTy/L6HDmdYGhPFXxea4+OAjPA0+SUYSpYbB18VUxFKc5J4h+1pTp0oc1KlXm1A8n1y4Ph+01e61KKS2Oi21/PfwTo0U0B06KWS5iljcK0csZhdHR1VldSCAQRX+NGF4fzSvxFh+Fq+ExGCzmtnNHIa2BxdCpRxWEzKpjY4CphsTh6ihVpV6GJbp1qU4wnCcJRkotNH6XldJZviMuoYKpCuszrYSlhKtKSqU6yxk6cKFSnKLcZwmqkZRlGVpRd02mmflVfXk+oXt3f3Lb7m+uri8uH/AL09zK80rd/vSOx6/nX+vWX4HD5ZgMFluEh7PC5fhMNgcND+TD4SjChRhpZe7TpxWi6dD+88LhqWDw2GwlFctHC0KOGox/lpUKcaVNdNoxS2+4q11m4UAFABQAUAFABQAUAFABQAUAf/1ugr/H8/6wAoAKACgAoAKACgAoAKACgAoAKAP1z/AOCcPh2Px8s8mrp9o034a6hLdLDIu+Ka4v2iu9Dt5i2RsS8k1S8UHI/4lscRRonZa+P8K/ATLeOfpS0+M81wcMRw3wrwxlXGGNw9SlGphcdxdDGYjJsgwmJpy932VOnlv9t9Y16+VKjVhOnVrM/zz+mfnM+ElThl8vY43jXCU6Dqwlyzp0cLGph80q07bSnhoYHDNqzX12dVSVSCcvur9q7RBd+FdE11E3TaNrLWsj45Sz1e2YSsTjp9rsbFAPl5kz2C199+0r4PjmvhbwdxnSpc+K4R4tll1aaWtPKeKMBOGInKVr2/tPKMnpJN2vVurO/N/J30e81eG4jzXKZStSzPK/bwTfxYrLq8XTSXf6visXLTpCx658EdPs9d+A/hzSLsGSx1bQ9f0m8UYBa3u9U1ixu0HUA7XlTJHXk5zX9AfQ3pYfMfoseGOGl71DE5JxFgq1uqfFHEOFxEeuqkqkdunU+J8T8Zicq8Vs6zHDvkxWAzXKcwwzd7Krh8DluKw8ns/ijCWnyb3Pzr/Yf1y5+F3x/8bfCXxE/2W412HU/DzI/7tJPE/gq+vJrVfmO0pNp51/7M24+a8tukW/z1rm8GsbU4b45zjhfHv2VTGwxOAab5VLMsnr1Z01rZNTofXvZv7UpU1FS54s/sX6UGV0OOvCThjxAyeP1ijlVTA5xGUfflDI+JcLh6VeXuq/NSxn9le2Vl7OMK0qij7NqP7F1/WZ/nKFABQAUAFABQAUAfjJ4YuB+0B+3Z/b9iTeeHtB8V/wBuQXUZ3266D8OLaC20e+XGR9l1bVtO0t1HOZNWXfnc9fyLltT/AF68a/r1D97gMDmf12FWLTprA8P06dPCVlZNOnisVh8M1t72K1erP9Jc8o/8Qk+it/ZOKX1fN82yH+y6tCS5a0s14yrVa+Y4aV7fv8Bl+Mx0ZW2hgHy35Yo/Zuv66P8ANo/O7/gov4Lm1f4ceD/G1tC0reDfEVxp9+yD/UaV4qgt4WuZT08tdV0nSbRcnIkvl243PX4H4/ZPPFcP5TnNODk8ox9ShXa+xhszhTi6kv7qxWFwtJXekq2lrs/sP6G/EtPL+M+IuGK1RQjxJk9HF4WMv+XuPyGrVqKjDrzvAZhmFd23hhXfaJ9Dfso+PYPiF8CPAeoicS6hoWlxeENaTcGlh1HwzHHpyNcEf8tb7TY9P1TnBKX6E8klvvfDDPIZ9wTklfnUq+Cw0cqxiunKOIy6MaCdS3262HjQxOuvLXT6s/H/AB84Uq8IeKvFeDdJ08HmmOqcQ5bLlcadTB53OeMkqV/+XeGxs8XgeylhZJaJH0XX35+OBQAUAFABQAUAfKX7aHj2DwP8A/FkAmEep+NFh8F6XFuAeZdY3nWSVHzeVHoFvqgZwNglkgjcr5q7vzHxezuGTcD5pDnUcTm6hlGGhdJzWLv9bdt+WOBhiU2k1zShF25os/e/o1cKVeKPFjIKrpOeB4adTiXHVOVuNN5dyrLVf4eeWbVcC4xb5nThVnG/s2eff8E+vBc3h74M3/ie7haK48c+Jr2/tSw2l9G0aNNGs2KnDDdqMGsyIxwHhkidMoyu/g+BOTzwHCNfMqsHGpnWY1q9JtWvg8HFYSjpvriIYuSeilCUWlZqUvr/AKXfEtPN/EnCZHh6inS4WyTDYTEJO6jmWZTlmWJSktNMHVy2EorWFSE4y1XLH7rkx5cmemxs/Taa/a3s/Rn8rLdeqOGs+i9uePf8evf0OMdsgNxw3+X9f1p+FpehPd/1/l01Vn8078v5t/8ABRPwlH4b8Eal490uPyV8TQW/h/WFjQLH/aUl5YwR3JIx+81DSpLqKVQACdP83LvNK1f5k/Sn8Ecuy/6QPhZ4rZXhI0MJxbjM0wXFNOlSUKH+s/DeQYzNMlzJuOjxWbYLCSpV1aKlPI/rL5q2Jrzl/c/0NeIZ5zxJguEsdN1JZHVrZtlspycpfUoYbFVp0Ff7GEx8KE6fxWWM5FywpwjL8L66z/VAKACgAoAKACgAoAKACgAoAKACgD//1+gr/H8/6wAoAKACgAoAKACgAoAKACgAoAKAP3N/4JUWcUfwr+KN+M/aLrx5Y2snGP3Fl4ftJYGDcEjzL66HJwNrYwSa/pj6Orwr/wBceScXjU+H1iYK3PHD2zp4Ny62lUeM5U9rSa+Nn+WX0+cTOfHXA2Ef8Khwpiq8NdquJzfEwqp9E+TC0HpZu6eyvL7f+OOmjVPhl4wg27jb6aupLgfdOlXVvqTOCPRLVw3C/IzDozCtPpe8Px4k+jj4rYF01Ulg+HFxBTejlTlwxmGD4hnUj1jajltVTafvUpTi9HJS/lHwrxzy/j3hitzcqrY94F66SWY0K2BUX0d54iNk9motapEH7LOpLffCPT7UNuOjazremuP7jS3f9sBT9V1VX/4H9K/Pv2e+exzb6NmSYCM1OXDHE/FmRzind0pYjMv9ZVB9m4cQwqJdqifU9fx3wTwviFjK7jZZlluV42L/AJlTw/8AZ3N/4FgJR/7d8j4g/bi+GGt/D74heHv2hvBAls0vNR0ltYu7SPJ0bxjoxibSNWlUDy1ttYtbSCF96eU2oWMwuneXVYUb7nxn4bxmRZ9gOPMm5qKrYjCvF1aSv9TzbCcrwuKkrcqp4ulShB3vB16E/atzxMIS/p/6LvHGV8XcIZv4QcTuGJlh8Hj45dh8ROyzLhzMlOOYZfTk2puvl1fEVaseWTqRweKpvDqMMDUnD7/+A3xr8P8Axy8CWXijSnittYtVhsfFWhb8z6LrQiDSxhCS76deFXudKuzlbi1JjcreW15BB+6cEcYYHjTJKOZYZxp4ukoUczwXNeeDxijeUbXcnh62tTC1dVUp3i3GrTrU4fyR4r+Geb+F3FWJyPHxnXy6u6mKyHNeW1LM8sdRqnPmSUYYzDXjQx+H3o11zx58NWw9ar7XX2B+ZhQAUAFABQB8SftnftDWfwu8F3fgXw9ehviD4006a1jFu483w54fu99tfaxcMuXgu7yH7RZaKo2Siczaip26eqXH454u8e0eG8oq5JgKyee5vh500qcvey/AVb062LqW1hVrR56ODWkufnrpx9glP+nPo2eD+J464lw/FWcYVrhDhrGU683Vi1DOc3w/LWwuW0U/dq4fDVHRxWZu0oOkqWDavjJTpYX7BvwUuPAnga8+I3iCzNv4j+IMNsdLgnjKXOneEIGM1kWDYaN9fuCupyJgq9jb6PISJDIi8XglwdPJMlq8QY6k4Zhn0Kbw0JxaqYfKoPno3vZxeOqNYmUbNOjTwkrqTlCPq/St8TKXFXFOG4NyjEKtk3CFSusdVpTUqOM4iqpUsVblupxymingYS0ccVVzKHvQ5Jy++K/cD+TjkfHvgzSfiJ4M8SeCdcTdpniXSbrTJ3Ch5LaSVd1pfwK2F+1adeJb39oW4W5t4mOQMV5WeZRhc+yjMMnxqvhswwtTDzdk5U5SV6VaCentKFVQrUn0qU4vofQ8J8S5hwfxJkvE+VytjslzChjaUXJxhXjTlbEYWq1d+wxmHlVwtdJXdGtUSvdH5E/s5/ErVf2VPjJ4o+FPxNL2HhnVtTi0vV7lg/2TStVhbbofi22MgBOianYTp9smUI8mnXFlfSY/sz7O/wDK3AHEWK8MuLcy4Z4jvQy7FYmOGxdR39lhcTB2wea07rXB4ihOPtZpRbw9SlWlFvDqEv8AQvxk4KwHj14b5Hx7wQo4vO8vwNTHZdRi4/WMfgKivmnD1ZQdlmeBxdKTw1NylGOMoYrCQSWN9tH9oY5I5Y0lidJYpUWSOSNleOSN1DI6OpKujqQyspKspBBIINf17GUZRUotSjJKUZRacZRaummrppqzTTs1qrn+as4TpzlTqRlCcJShOE4uM4Ti7SjKMrSjKLTUotXT0drD6ZIUAFABQBBdXVtY21ze3txDaWdnBNdXd1cypBbW1tbxtLPcXE0hWOGGGJHkllkZUjRWdyFBNRVq06NOpWrVIUqVKE6tWrUlGFOnTpxcp1Kk5NRhCEU5SlJqMYpttJNmtChXxVejhsNRq4jEYirToYehRpyq1q9etNU6VGlSgnOpVqVJRhTpwTlOclGKbaR+K/xj8aa1+2R8evDngHwEZ/8AhDtIuZ9L0W8khkEEdiZIpfE/ji/hO1ord4LeIWUMxjlktLXT7YJDqOoSQN/H/FucYzxa43y/I8kc/wCycJUnhsHVlCXIqLlGWY5zXho405Qpx9jCajJ0qWHp8kK9eUD/AEv8OOGct+jj4UZzxZxWqX+seYUaWOzPDwqQdWWK5JwyPhfCVNY1K0Ktaf1qpSU6cMRiMXWc62DwcK8P2S8L+HNK8H+HND8K6Hb/AGXR/D2l2WkadBwWW1sLeO3iMrADzJ5AnmXExG6aZ3lfLua/rbLcvw2U5fgsswUPZ4XAYajhMPDS6p0IKEXJq3NOSjzVJvWc5Sk7ttn+cGeZzj+Is5zTPs0re3zHOMfisxxlXaMq+LrTrVFCN3yUoOXJSpp8tOlGFONoxRp30nlWd1JnG2CXH+8UIX06sQOv5V1zdoy9H+R5kFecV3kvzONs+Nvpxn/Pp7AYGM85NckN/P0/q3b/AIY75q911+7+r/qfKH/BQDSV1f8AZd8YQ7d09nqWg6parj5i+mXRvJ9vBO4WMV033RwGTGCTX84/ShxmBy/gnhXHY2pGm6XiPw5hcE5W97G51gc74fpwV2rN0s2rty6KL2veP9JfRDzCWXeOXDlS/LSxGCzXA1305cbh44eld6KzxU8PHXrJPW1j+bqv5iP9pQoAKACgAoAKACgAoAKACgAoAKAP/9DoK/x/P+sAKACgAoAKACgAoAKACgAoAKAFAJIABJJAAAySTwAAOSSegH9aTainKTSSTbbdkktW23ZJJatt/dYTaSbbSSV23oklu2+iSP3Y/YAmi+Hmn/8ACvtSZba68UaXDq7CT5SfEds095NZZzhZl068ngLdHGlRqpLsgb436G/jxgc0+kF4k8J4vGwp5Tx5g8HDg91Zfu6+P4Ihi6VLD4aX2JZzlOKzXNuWTtOeEhRjarOnCX+Vf0uaVTjDEPi/BKVbD5Hj6mXpw1SyavGjhqWK7+zeMw9KrazcXj5yk1GMuX7C8b/E74a3Ota/8IJfGnh0fEPUPDGrMng99Qh/tiSK60W4uVj+zdPtT6ex1BLAst7Jp5+3LB9lImr/AEW8TMTlGccH8ecHyx2EnmmbcEcU4H+znUjKvOGOyDHUuR07pOc6VVz9i25ul+85ORuR/LfDXB/F+HweTcfw4ezb/VXBZ7l3Nn6w1T6hCpQzOjSdT2vLf2McVFYZ4mMZYaOKthnW9vemeZ/sca+uzxn4WkkAYPp+v2cWeWVg+nalJt9EK6UpIz/rADjC7v8AO39mDxlF0fFHw+r1kpxq5LxlllDm1nGpCrkmeVlHe1N0+HoOSvrVSla0Ob9T+kflL5+Gs9hFuLjjMpxM7aRcXHGYKN+81LHuzt8Gl9eX7E8T+GdD8ZeH9X8LeJdPh1XQtcspbDUrG4B2T28o6q6lZIZ4ZFSe1uYWSe1uYormCRJokdf9Wsyy7BZvgMVlmY0IYnBY2jKhiKE72nCXZq0oThJKdOpBqdOpGFSDjOKZ/OWR53mnDeb5fnuS4urgM1yvE08XgsVStzUq1O+jjK8KlKpFypV6NSMqVajOpRqwnTnOEvxo8beAPjB+xL8Q/wDhNPA15dan4E1C4EFrqssD3Okalp7zGRPDHja0h8uK31CMZW2vEMAuj/p2jXFrdC6s7T+Rs5yPivwcz7+2Mlq1cTklepyU8VKEqmFxFCU+aOW5xSgoRhXjtTqr2Sq/xsJUp1FVpUP9I+GOLfDv6TnB/wDq1xThqGC4qwdF1a+Ap1YUcwweLjT5J55wziKvPUq4ST1r4eUa3sU1hcypVqHsMRiP0T+Cn7Wfwt+MVrZ2X9qW/hHxpIkcdz4T166ht5Z7sqN40HUZfJtNchd9/kRwmLU/LUyXOmQJtLfvvB/ijw1xZSo0vrMMqzeSjGpleOqwpynVa1+pYiXLSxkG0+SMXHE2V6mGgrc38deJn0f+O/DmvicT9Rq8Q8NQlOVHP8poVK0KVBP3XmuDh7TEZZVjHl9pOrz4Lnly0cdVd4x+oa/ST8MCgCOaaG3iknuJY4IIUaWaaZ1jiijQbnkkkcqkaIoLM7EKoGTwDUznCnGU6kowhBOU5zkoxjFK7lKUrKKS1bbslrpYunTqVqkKVGnOrVqSjCnTpwlOpUnJ2jCEI3lOUm0oxirtuyvofCHx8/bi8E+A7O+8P/DG7sfHHjR1eBdTtmF14S0GQ7la4nv4mEet3cXDQWWmSS2W/P2zUEMRtZ/xPjjxmyfJKVbA8N1aOc5u04LE02quV4KWzqTrxkljKsd4UsM5Ur39rWi4unP+q/Cb6LvE/FeJwubccYfFcL8MxcarwVeP1fiDNYK0o0aWFqRc8sw9TVVcTjoU8So2WGwlRVPb0Pnr9nL9mfxh8afFY+Nvx2Oo3eiXl5HrFpYa4rpqXji6URtZz3Vqyxiz8JwIkS28CxxQ6haxQ2VhbrpGJG+D8P8Aw6zbi/NP9ceNfb1cHWrRxdKhjLrEZzVSi6VSpTcF7LK4RUFTglCFelCFGhTjhfeP1/xl8beHfDTIP+IY+FaweHzPC4eeXYjF5W4ywXDFCTmsRSoV4ym8RxBVlKpKtVc6tXB4ipVxOLqzzFckf12VVRVRFVERQqooCqqqMKqqMAKAMAAYA4GMCv6pSSSSSSSSSSsklokktEktkv0P885Scm5SblKTcpSk23Jt3bberberb1b1Y6mIKAPkb9qj9mLT/jroces6EbXTPiRoFq8Wj6hP+6tdbsFZ5joGrSqCUj815JdMviH+wXMsqOv2W6uGT8s8TPDihxrgo4vBOnhuIMDTccJXn7tLGUE5TeBxUknZc0pSw1Z39jUlJNezqzcf6E8B/HDGeFmaTy3NFXx3BebYiNTMcJS9+vleLko0/wC18vg9JTVOEIY7Cpx+t0IU5RvXoUlL4s+BX7VvjX4Bao3wl+OGk67N4e0WRNNgN1bs3ibwaiBVggSOZl/trw4Iij2sSTNLBZNHLo89zZLbWEv49wV4nZxwNiXwtxlhcbPAYOSw8PaQbzHKErKEIqbj9by9Rs6UYylKFG0sJUq0VToH9L+KngJw14s4BeIHhfmGV084zOMsbVVCslknEkpNurVlKmpf2bnLnzRrzlThTrYmMqeY0sNiZV8XH9XvBvj3wZ8Q9Jj1zwT4l0nxJpjhd0+mXaTSWzuNwgv7Q7LzTroDlrS/t7e5QY3RDrX9P5RnmUZ9hY43J8wwuYYeVrzw9WM5U21fkr0narh6qW9KtCFRdY6n8C8ScJ8ScH5hPK+JslzDJcbBy5aWNw8qcK0Yuzq4XELmw+MoN6Rr4WrWoy+zUeqj11eqfPBQBxHjr4k+BfhppL61468T6V4dsQrtCL64H22+ZBlodN06HzdQ1O4wP9RY2txKB8xUKrNXjZ1xDkvDuGeLzrMsNl9GzcPbVF7as0m3HD4ePNXxE9Pgo06kvKy936jhXgvirjbHxy3hbI8fnGKcoqo8LRf1bCxk7KpjcZU5MJgqV3/FxVehC+ilJtRj+Tfxp/aU+If7Tevx/CX4NaJrVt4V1OYW7WMCLHr3ipEdfMutemilNvo3h23OJJbR7oWoiH2rWbtlKWlp/L3F/iHn/iNjo8L8JYPGU8sxM1TdCCSxuZxUlzVcdOEpU8JgKekp0nUVJQXtcXVacadL+/fDTwV4P8EMpn4geJOZ5ZWz7A0/bRxVWTnlWQylF8lDKqU6ca2ZZzW1hDEQw8q8qjWHy3DRkp4jEffn7Mn7N+kfATwzI91Jbat4+1+GI+JtdiVjBBEhEsWhaO0oWSPS7ST55pmjjn1S7X7XcpHFFZWll+5eHPh9hOB8ulKrKnis8x0I/wBo42CfJCKfNDBYTmUZRw1KXvTm4qeJqr2tTlhGhRofyX43eM2Y+LGdwjQhWy/hPKalRZJldRpVas5LknmuYqEpQnj8RC8adOMp0sDh5fV6MpTnisRivp+v0g/DjD8QT+Vp5jBw1xLHEPoD5rHvxiPaT23c461jXlyw3tdpfLfT7vuub4eN6ifSKb/Rfntp+FpeO+L/AIsfDb4YtoafEDxr4e8IP4iu3s9FXXNQhsjqE0RhE7R+ZnZa2xuLcXd9MqWVn50AubiLz4g/iY/O8pyeWHWaZhhcC8XN08P9Zqxp+1kuXmtdO0Ic0eepLlpw5o881zRUvtOHeB+L+MVmUuFuHc1z5ZVQjiMweXYWeIWFp1Of2Snypc1esqVV4fDU3PEV1SqujTl7KfL4j+134nsbrRdB8AK8Vz/aDza3rNuPmAsBbXGnafFKwxlL37XqL7BghLWJzlXjZv8AMj9pN4p0sBgfD7wxyfHRjnCzeHiBm6oSXtsvpZbSxOXcNe0krxTxmKxWbYqNJrmj/ZuHrSXJVpOX7V9HPIsVQzDNeLpQnR+qRp5XltZ6N4r21LGYypBNaSw3sMJDn95N15wWsJo/nf8AF/h6fwp4l1nw/cBidNvZYoZHGDPaP+9srnuP9ItJIZuOhfbwVIrm4J4mw3GPCmR8SYZwUc0wFKtXpwd44fGw/c4/C6tt/VsbSr0Lu3Moc1rSR/sTw7nFHP8AJcuzai42xmGhOrGO1LEx/d4mj/3BxEKtPzUU1uc3X1J7QUAFABQAUAFABQAUAFABQAUAf//R6Cv8fz/rACgAoAKACgAoAKACgAoAKACgD2/4E+CT4o8WJqt5Dv0fw00V9PvH7u41EljptryCG2yxteTDaw8u2EUgAuENfz99Ijj9cI8GVMmwNfkzziuNbL8PyS/eYXK1FRzXGaNODnRqRwNCV4y9ripVqT5sNM/L/FTidZHkE8vw9TlzHOlUwtLldp0cGklja+mseaE1hqb9189Z1ISvRly/oJp9/eaXfWmpadcy2d/YXMN3Z3ULbZbe5t5FlhmjbkBkdQwyCDjBDAkV/nnkudZrw5m+WZ/kePxGV5zk2OwuZ5XmOEn7PE4LHYKtCvhsTRnqlOlVhGSUlKErcs4yg5Rl/I+LwmGx+FxGCxlGnicJi6NTD4nD1VzU61CtBwqU5r+WcZNO1mt000me0+Bfhn8E/iT8Zl+PWsXut6T8XYLeO5uvC8mqWcHhLWdetdDGiQ+IdKt3sW1GSZrSJJ5NGj1RY4r2MTm1mtlkNx/td4A/SD8NfHKEsVxFjqfDPi7h8pqUsfw7isZh8JlHEuY08unhP7X4XdaCqYmWIjH29bI44h4zBVeflo4zB0vrlX8V4y4i8SeCOAJeGmW4XL8x8PqtaVKhndPA4itn2WZXXzL+0amVZhUhiPqkKca85UoZlLBt1MNLkVWliHGMMz4DeKv+ES+KXhm8ll8qy1O5OgagSdqG21jFrE0jdFjt782V27N8qrbknAyy/wCbX0PfENeG/wBILgLM8RXVDKs+x0uDc6cpclJ4HiZRwGGqV5tqMKGDzl5VmNacrxjDBNysk5R+s8V8h/1h4EzvDU4c+KwNFZvg7K8lWy69epGEd5TrYRYnDxSs26ytfY/Wev8Ao8P8/SjqemabrNhd6Vq9hZ6ppl/A9tfadqFtDeWV5byDEkFza3CSQzxOOGjkR1PcHFY4jDYfGUKuFxdCjicNXg6dbD16cK1GrTl8UKlOopQnFreMk0dWCx2Ny3F4fH5di8TgMdhKsa+FxmDr1MNisPWg7wq0K9GdOrSqRfwzhOMl0au+b88/ix/wT08I+IZ7nV/hXrzeC76ZpJW8O6ulxqfhp5G52WV2jtq+jRFjuZWGtQoP3dtbW8YVF/BeKPAbK8fOpiuGcc8orTcpPAYtTxGXOT6Uaq5sVhI3d2n9cil7tOEI2R/X/AH0vuIcnpUcu48ypcTYWmo01nOXypYHO4wjpzYnDyisvzGailGLi8tqSfv161abcjwWH4Xft5/CICz8L6p4o1XSLQBLZdC8Uab4p0dEj4CWeg6/M91bx4A/drocCuMAhipr4iHDXjdwr+6y3E5nisLSVqawWZYfM8IlHZUcDjpTqQVvsrBwT26H6vV46+ij4hN4nPcDkeAzHENyrvNcjxuRZjKU9XLE5rlFKnQqzu377zSs07tcqdy0fiB/wUVugbP+zfHUbH5GlHw28IWhIbji8PhiKNCOvmRzIy9SwwDWn9u+PtW9L6vncXs5f6vZVSvftV/s6CVv5oyVv5tjBcJfQ5of7T9c4Wkl7ypvjTiKvbl1/wB2Wd1Jyv8AyThNPZRexWP7Nn7ZnxmljT4k+Ir/AEvSJJEkaPxl4xWewRQQTLbeGfD0uqQxXC/wJNY6eWdVDyxqBIuf/EPfFzi6SXEOYV8NhZSUnHN82VShFLVyp5bgJ4iEKi+ypUKN5JJuKSkbrxp+jd4bU5y4LyfC47MIQlGM+G+HHSxcm1ZU62d5xSwVWpSf2pU8Vi1GPM405SfKfXvwb/Yc+F/w1ntNb8UO/wARvFFsUlhm1mzit/DlhcKQyS2Ph7zbmOeaJvuXGr3WoqHVLi2trOZV2/q3CXgxw3w9OljMyk+IMyptThPF0YU8vozWqlRwF6sZzg9p4qrXV0qkKdKaXL/PHiP9KLjnjWlXyzI4x4NyOspU6lLLcTUrZzi6UlaUMVnHJh50qU18VHL8Pg24ylRrVsTTkz7WAxwOAOAB2r9hP5mCgAoAKACgDx/4s/Ar4bfGnTVsvG+hJPfW8TRab4i09ksfEWlKSzbbPUljcyW+9mc2F9Heac8jea9qZQrr8pxRwVw9xfh1RznBKdanFxw+PoONHMMMnd2o4lQm3C7cvYVo1cO5PmdJySZ+ieH/AIqcaeGmNeK4YzSVLC1qiqY3J8Yp4rJse0lG+JwTnBRrcqjFYvC1MPjIwXJHEKDlA/OnxR+wX8XvAmqvr3wY8fJqJhLtabdTu/Bfiy3QnckEd9azHTbkjaFkuTqWkiRwrizRSQn4BmXgjxXkmKeN4QzyOIcOZ0rYmrk+aQT1VONanJYepbaVT6xhlJq6pQWh/ZGR/Sv8POKsBHKvErhOeDVRRWIvgcPxNw/WklaVWeFxFJY2je7lCisHjnCPNF4io0nPITWf+Cing0fYvI8e3yxAKWfQ/CXjgsF4H/Ex+wa9LKT3YXRd+pY4Jrlji/H3Kf3Ps88rKOl5YLK85vy/9RDpY2Ur66+1blvd+6d8st+h1xH/ALV7XhTCyqNu0c04h4X5XLX/AHP61ldOml0i8PGK2SVrBJf/APBRTxuDZNH49sFlGzfHp3hLwCUV+MjUI7bw9NGV5O8XIkTqDkrtJV/H3OV7FxzygpK144fK8iaT/wCn8aeXzi1fdT5l05r+64YT6HXDD+sqfCeLlTfNyzxvEHFik462+qTr5vSmn/K6DhLrHc3/AAh+wD8S/GOqDXvjR4/SyNw6Pew2V/deLPFV4q/eiuNY1Lbp9nKQT5dwsuuouOYGzmu7KvAziLNsSsdxfnioupJSrwo16maZnWS3hPF4hOhRlvy1FPGpf8+3c8jiH6WvBXDmAeU+GnCUsSqUZRwtTE4ShkGQ4aT+GpRy7B3xeJgrLnouGVyd1asrH6O/C74NfDv4O6QdJ8C6BBpxnVBqOrTn7XrurvHyH1PVJVFxMocs8VpGYrC2Z3+yWsCsy1/QPDXCOQcJ4V4XJcDDDuaisRip/vcbi3HZ4jEySqTSd5RpR5KFNyfsqVNNxP40468SOMPEbMFmHFWbVcYqUpvB5fS/2fK8vjPeOCwMP3VOTjaE68/a4utGMfb4is4qUfUa+lPhQoA4PxLd+ZqENqCCttHubn/lrN82CO+EWM/8CPbdXFiJXqKKb91a2/vW/TXbTzuj0MLC1Nz6ylZekf8Agvz26fa+Ev2v/hV8EfiTH4V1L4h6j4h/4SfwqLuPSdF8KatY2l5q1hqL21xNY64L3T9TFhpjTWyOmoQpaXqK9ytobqRlWD+P/pSeM/hP4Y5TSrcS5jPN+OMPRqLI+Cskx+GjmmNeIjGdOpnadPEvJcm5oRnLMK9KFerD2sMvo42tF04/1H9HjinxL4aqZ1hOFMHlcchzuVCeYZrnuAxVfDYHE4SNWlDEZX7DFYN4zHezrSjLCznWwzlGjLEewjFyq/Oms6xfa9qM+p6hJ5lxMIYlVS/lW9rawx21nZ2yuztHa2VrFDa20ZdykMSBpHYF3/wi47434i8R+K854z4qxrx2d53ifb4iok40MPRp04UMHgMFSbl9XwGX4SlQwWCw6lL2OGoU4SnUmpTl/QuV5ZhMnwNHL8FT5KFHnk2+XnrVq1SVbEYms4xhGVfE151K9aailKrUk0opqMfj/wDaU8IiS30vxpaR/Pbsmj6ttX70EheTTrl8YA8qYzWru24t59rHwEUV/TP0VONXTxOccB4yr+7xMZ55kvO/hr0o06OaYSF9W61BYfGU6cbRisNjaj96o3L+ivBbiFwrY7hrET9yspZjl/M9qsFGGMoxvf46ap14RVkvZYibTcrnyHX9sn9DBQAUAFABQAUAFABQAUAFABQB/9LoK/x/P+sAKACgAoAKACgAoAKACgAoAUAkgAEknAA5JJ6ADuSaTaSbbSSV23oklu2+iSBtJNt2S1beyXd7bev3H6T/AAx8Ip4L8HaXpTRhNQmjGoau2AGbUrtEeaNiCd32RBFZIeMx26tjLGv8qvFrjapx5xznGcQqueW0KryzJIXbhDKsFOcKFSCfwvG1HVzCpH7NXFTim4xio/xZxvxDLiXiPH49TcsJTm8Jl8bvljgsPKUaUop7e3k54mS6TrSV2klH0CvzU+SFBIIIJBBBBBwQRyCCOQQehH9KcZSjJSi3GUWpRlFtSjJO6aas007NNO6eqsJpNNNJpqzT1TT3TXVNACVIZSVZSCrA4II5BBGCCDyCDx7U4ylCUZwlKE4SUoTi3GUZRd4yjJWcZRaTTTunqraA0mmmk00001dNPRpp6NNbp/qfr38IPGg8e/D7w/r0kok1EW39na1z8y6vp2Le7dx/AbwCPUETLbYbuIE5zX/S79GjxUj4xeDHBvGNavGtnSwKyTihXTqQ4lyVRweZVasVdU3mPLRzijTu3DC5lh03Jts/zu8ROGXwnxfm+Uwg4YP2/wBcy3T3Xl+MvWw8Yv7X1e88JOXWrh6luh6ZX7yfEhQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAZmtavZaBo+qa5qUnlWGkWF3qN3JxkQWcLzyBASN0jKhWNBy8jKigs2G8HiniTKuDuGs/wCK88rrDZPw3lGY53mVb3eaGDy3C1cXXVOMnFTrThScKNJPmq1pU6cLzmlLuyzL8Tm2Y4HK8HD2mLzDF4fB4eGtnVxFWNKDk0m1BOSlOVrRgpSdkj8pPEPxt+I3iC61CZvENzp1ve3U86W2mRWtk9tFK7mO3jvraCLUGSGJlhV3utzKgJ+b5q/57+NvpofSI4zrZnT/AOIg5jw7lGOxmKrYXLOGcJlWR18vwtatUnQwVHPMswGFz+pHDUJQoKtVzKVWqqaqVJOo5yn/AHjk/hNwLlFPC2yOhjsTh6VOE8RmFTE4uNerCCU608JiK1XBKVSadTljh4xi5WjHlSieUzTTXEsk9xLJPPM7SSzTSNLLLI5yzySOS7uxyWZiSTySetfy7i8Xi8fisRjsfisRjcbi61TEYrF4uvUxOKxNerJzq1sRiK0p1a1apJuVSpUnKc5NuTbZ+jUqVKhThRo04UaVOKhTpUoRp06cIq0YQhFKMIxWijFJJaJKyRHXOWc54u0KPxN4Y1zQpFVjqWnXMEBf7sd2E8yymOQcGC7jgmBx1jHSvqOCeIqvCfFvD/EVKU4rKs0wuIrqF1KpgnP2WPoaXdsRgqmIoPTao97ns8PZrPJM7yvNYOS+pYyjVqKO88PzcmJpr/r7h51ab30ns9j8vGVkZkYFWVirKRgqynBBB5BB4IP9K/12jKM4xnCSlGcVKMou6lGSupJrRpppprdH9zRkpJSi04ySkmtU01dNPS6ad9vuG1QwoAKACgAoAKACgAoAKACgD//T6Cv8fz/rACgAoAKACgAoAKACgAoAKAO0+HOmx6t478KWEyh4ZdbsZJkIyskNrKLuWNhg/LJHAyNx0Y9K+D8Uc0q5N4d8ZZjQk4V6PD+YUqFSLcZUq+LoywdGrFq7U6VTERqQ0+KK31PmuMsbPL+Fc/xVJuNWGWYqFOadnCpXg6EJp62lCVVSWm662P00r/Js/iQKACgAoA+p/wBlj4h/8I34ul8H6hPs0jxeUS03tiO28QQKRZkZ4X+0od9g+0bpbkacpKqh3f6Gfs9PGr/UfxJxPhlnWL9nw34lSpU8s9rO1HA8Z4SnKOWyhe8Yf27hefJ6iiufEY+OSQbUKTPwbx44P/tnh6nxFg6XNmHDylLEcsffrZRVlfEJ2s5fUqnLi430p0HjGruVj9Ia/wBzD+MAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPjP8Aa0+If2HS9P8Ah3ps+LrVxFquvmNuY9MgmJ06yfHAN7ewtdSrkOsVjBuBiuhu/wAuf2j/AI1/2Rw/k3gnkeL5cfxKqHEPGTo1PeoZBg8S3kuVVeXZ5rmmGlmFem3CpToZTheZToZhaX9J/R+4P+tY/F8YY2lehl3PgMo51pPHVaf+2YqN0v8AdsNUVCEryjKeKqtWqULHwHX+Np/WoUAFABQB+X3ja0Sx8ZeK7ONQsVt4k1uGJR0EUepXKxAeg8sLx26V/rnwDjJ5hwNwbjqkueri+Fsgr1pXvetUyrCyrXfV+1ck/NeZ/cnDGIliuG8gxM3zTr5NllSo31qSwdF1H/4HzHMV9ae4FABQAUAFABQAUAFABQAUAf/U6Cv8fz/rACgAoAKACgAoAKACgAoAKAOx+H2qRaN438LalOwS3t9bsRcSE7Vjt55hbzyE5AxHDM7nJAIUgkda+H8S8oq57wBxflWHg6mJxWQZi8LTinKVXFYehLFYalFJN81WvRp042TacrpPY+c4uwM8y4Yz3BUouVWtlmKdGCV3OtSputSgkru86lOMVZbu+tj9N6/yXP4iCgAoAKAJYJpraaG4t5ZILi3ljmgmido5YZonDxSxupDJJG6h0dSGVlBBBANdGExWJwGKw2OwWIrYTGYPEUcVhMVh6k6OIw2Jw9SNahiKFWDU6VajVhGpSqQanCcYyi00mRVpU61OpRrQhVpVYTpVadSKnCpTqRcZwnGV4yhOLcZRas02ne5+s3wV+JMPxL8F2mpTSRjXtN8vTfEVuu1Ct/HH8l8kYPy2+pxAXUWAI45vtNqjObZ2X/o8+it46Ybx38LMtz3FVqK4wyL2WRcbYKmoU3HOKFFOlmtKhF/u8Fn2Hisww/LGNGliHjsvpSqvAVJn+fviZwXU4J4lxGCpwm8pxvNjcnrSvK+EnN82FlN3vWwVT9xUvJzlTVGvJR9vHm9dr+lD88CgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAOZ8Y+KtM8E+GtW8T6u+2z0q1aby1ZVlu7hiI7Sxt92Qbi8uXit4sjarSb32xq7L8H4m+IeQeFPAvEfH3EtXkyvh7ATxToRnGGIzDGTao5dlWD5vdeMzPHVMPgsPze5CpWVWq40YVJHt8OZDjuJ86y/I8ujzYnH11TU2m4YejFc+IxNW2qpYajGdapbVxhywUpyjE/H3xV4l1Txh4h1bxLrEvm6hq13Jcy4z5cKcJb2kAOStvZ26RWtupJKwxIGLMCa/5l/ETjzP/E7jXiPjvibEfWM54kzGrjsQouTo4SjZUsFl2EU25QwWW4Knh8Bg6bblDDYekpSnPmnL/RbIckwPDmT5fkuXU/Z4TL8PGhTvbnqy+KtiKtkk62JrSnXrNaOpUk1ZWUefr4s9cKACgAoA/MPx5cLd+N/F9wjbo5fE2uNGw6NF/ad0IiPrGFNf63eHWGlg/D/gjDVIuFSjwnw9GrB7xrf2VhHVi99VUcl8umx/cPClF0OF+HaMlyyhkmVqce03gqLmn5qTaOTr7I98KACgAoAKACgAoAKACgAoA//V6Cv8fz/rACgAoAKACgAoAKACgAoAKACgD9Cfg14+i8Z+F4Le6mU6/ocUNlqcTNmW4iRdlpqYB5ZbqNNs7AnbeJNnajw7v8zPHTw4rcB8XYjE4OhJcN8QVq+YZRVjH9zhqtSftMblTa0hLB1Z82Hg/iwNTDtSnUhXUP5C8R+E6nDWeVatCnJZTmc6mJwNRL3KU5PmxGCbWkZUJyvSi98POk7ykpqHr9fiR+eBQAUAFAHqPwj+Jd/8MPFltrEXmz6Rd7LLxBpyNxeaczgmWNGKp9tsWJubJyQd4ktmdILqfd/Qf0a/HfN/ALxHwPE1D2+L4azL2WVcZ5JSldZlklSrd4ihTlKNP+1cpnJ47K6knBupGtgp1qWEx2LU/hfELgnC8ccP18unyUsxw/Nicoxkl/u+MUbKnOSTksNiklRxMVGfuuFZQdWjSZ+tOmalYazp1lq2l3MV7p2o20N5ZXUJ3Rz21wiyRSLkAjcrDKsFdGyrqrqVr/o/yHPco4nyXKuIsgx+HzTJc7wGFzPK8wws+ehjMFjKUa2Hr027SXPTmuaE1GpTmnTqRjOMox/z7x2CxWW4zFZfjqE8NjMHXqYbE0KitOlWozcKkJbp2knZpuMlaUXKLTL1escoUAFABQAUAFABQAUAFABQAUAFABQAUABOOTwBySe1DaSbbslq29ku7229fuA/Mz9oz4u/8J5r/wDwjeh3W/wn4duHVJInzFrOroGin1HIwstrbAyWumn7ro1xdqzJdxon+C304PpKf8Rf4x/1F4Sx7qeHPBOOrQhXw9Tmw/FPElJVMNi875ov2dbLsApVsBkbi5wq0p4zMoVJQzGjCh/bvg14eLhTKf7azShy8QZxRi5QqR/eZbl8+WpSwdnFShiK7UK+NTacZqlh3FSw85T+aq/hA/awoAKACgDJ1/VodB0TVtauMeTpen3d86k43/ZoHlWIdCWldViQDlncAZJAr2uHMlr8R5/kuQ4a6r5xmeCy6Ekr+z+t4inRnWlvaFGE5VZt6RhCTdkmz0Mqy+rmuZ5fllG/tMfjMPhYtK/L7erGDm9vdpxbnJt2UYtuyufllNNJcTSzysXlnlkmkc9Wkkcu7H3LMTX+wNCjTw1Cjh6MeSlQpU6NKC+zTpQUIR+UYpH920qcKVOnSprlp0oQpwj/ACwhFRivkkkRVqWFABQAUAFABQAUAFABQAUAf//W6Cv8fz/rACgAoAKACgAoAKACgAoAKACgDoPDHibV/COsWuuaLcGC7tmwytloLq3YjzrS6iBHm28wADrlWVgssTJMkcifN8W8J5LxrkeM4fz7DfWMFi43jOLUMRg8TBS9hjcHWal7HFYeUm6c7ShKLnRrQqUKtWlV8jPMky/iHLq+V5lR9rh6yvGSsqtCrG/s8RQn/wAu61Nt8stVJOVOalTnOEv0C+H3xL0H4gWAezkWz1iCNW1DRZpAbmA8BprdsJ9rsixAS4jXKblW4jhkYI3+aniZ4UcReGuYyp46nLHZHiKrjlmfYenJYXExd5QoYqPvfUseop8+FqytPknPDVa9GLmfyPxdwVmvCWKcMTB4nLqs2sHmVKD9jWW6p1leX1fEpfFRnJ81pSozqwTnH0avy4+OCgAoAKAPq39nL41/8IhfReCfE91jwtqdx/xLL2d/k8P6lcPyHdsCLSr6Vs3GSY7S6b7WfKilvZG/0W+g79Kp+GubYfwo4+zHl8P8+xtuH81xlX91wdnmNq606tWpK2H4dzevNvFtuNDLMxmsxfsMPic0ry/AvGXwyXEOFqcT5Hh757gqP+3YWlH3s2wdGOjjFXc8fhKa/dWXPiaC+r+/UpYaB+jYOeRyDyCO9f7gpppNNNNXTWqaezT6po/jQKYBQAUAFABQAUAFABQAUAFABQAUAFAHxp+0r8a/7Jgufh34UvMapdRGLxPqVu/OnWkyc6PbyKQRfXcTf6c6t/otq/2cE3E8gtf8vPp2/Ss/1bwmYeCXh3mVuIcww7w/Hue4Kt72R5biqfvcNYKtTknDNsyoT/4VqsJJ5fl9T6nC+NxlaeX/ANJeCnhl/aFWhxjn+H/2ChUVTI8FWjpjMRTlpmNaEr3wuHnH/ZYtL29ePtnajRh9Y+Aq/wAaj+tgoAKACgAoA+Xf2jPHEVtp1v4HsZs3d+0F/rWw58iwhfzbO0kwTiS7uUjuip2skNtEWVkuUNf139F3w/q4vM8T4gZjQtgsuhiMuyH2kda+Y1oeyx2NpJ70sHhZ1MHGorwnXxVVQftMJOMf3Pwb4XnXxlbifFU7YfCKrhct51/FxdSPJiMRC+8MPRlKgpWSlVrTUXz0JKXxzX9yn9GhQAUAFABQAUAFABQAUAFABQB//9foK/x/P+sAKACgAoAKACgAoAKACgAoAKACgC3Y397pl3Bf6ddXFle2sglt7q1leGeGQfxJIhVhxkMM4ZSVbKkhuLMMuwGbYLE5bmmDw2YYDF03RxODxdGFfD16b3jUpVE4ys0pRe8ZKMotSScefFYTDY7D1cJjMPSxWGrxcK1CvTjUpVIvpKEk07PVPdNJppq8fqvwH+0Yu2DTfHcBVgFjXxDYQbg3bfqWnwrlT3afT0YE4Asxhnb+OvEX6L0+avmvh1iIuMnKpPhrMcRyuHXkyvMqz5ZR1Shh8ynFxScnj53hSj+C8V+Dkk6mM4Vq3XvTllGKqWa68uCxdSSUl0jSxcotav61K6gfUWmatpmtWceoaRf2mpWUw/d3NnPHPETgEoWQnZIuQHjcLJGfldVIO7+RM3ybNshxtXLc6y3G5Vj6LtUwuOw9TD1krtKcY1Ix56c7N06sOanUjaUJyi0z8Mx2AxuW4ieEzDC4jB4mm/foYmlKlUSvZSSko80HZ8s43hNaxbWstCvMOQKACgD7d/Z3+PfkGx+H/ja9/wBHOy18M69dy48gjCw6LqU0jH9wfli0y6dh5J2WUmYWtzB/rH9CL6YM6NTKPBXxTzPmw9R0su4B4szCuk8NO3JhOFM6xNZ+/QqPlw/D+NqT56VWVLJ6t6E8D9V/l/xj8KFNYri/hnDfvFz188yuhD+It6uZ4OnBaVI6zx1GKSnHmxUbTjX9r911/rqfyuFABQAUAFABQAUAFABQAUAFABQB86/Hv4xr4A0GbS9BnR/FOqLJaW8ykONIV0/fXhGCrXkMThreJtywyvBLcIyFI5f5L+mD4+/8QO8L8VUyTE04cc8Wyr5DworqVTL6k6F8zz9QvaTyTC1YVMPeNSms1xWVwxFKeHq1oS/VvCfgP/XLiCnPH05f2JlnJjMwT0WK5Z/uMFfdQxVSLVVpxbw9PEKnJTUXH8xZppriaW4uJZJ555HmnnmdpZpppWLySyyOWeSSR2Lu7szOzFmJJJr/AJ4sVisTjsTiMbjcRXxeMxdetisXisTVnXxOJxOIqSq18RiK9WUqtavWqzlUq1akpTqVJSnOTlJuX9306dOjTp0aNOFKlShGnSpU4xhTp04RUYU6cIpRhCEUoxjFKMYpJJJJEdYFhQAUAFAHkPxM+LejeBLWaztZIdS8TyxMLXTY2EkdkzqdlzqrI4MMScOttlbm5+VUWKJmuE/bfCfwWz3xExlDH4unXyrhKjWi8XmtSDp1cfCEv3mEyeM4tV607OnPF8ksJhPedSVatCGGn+hcE+H+ZcVYiniK0KmCySnUTr42cXGeIjF+9QwCkrVKkrckq/vUaGrlzziqE/gTU9Tv9Z1C71TU7mW8v76Z7i6uZTl5JHx6BVVEUBI40VY4o1WONFRVRf8ASLKcpy7IstwWT5ThKWBy3L6EMNhMLRTVOlSh5tylOc5N1KtWpKdWtVnOrVnOpOc5f1pgcDhctwmHwGBoww+EwtONKhRpq0YQj+MpSbcpzlec5ylObcpNlCvROoKACgAoAKACgAoAKACgAoAKAP/Q6Cv8fz/rACgAoAKACgAoAKACgAoAKACgAoAKACgD6E/Zvtbq48b3k0dzcQ2djotzcXMEc0iQXUss0FpbR3EKsEmEYuJ54/MVxHJErLtfa1fzP9KbGYPDcAYGhUwuGrY3MM+wmGwterQpVMRg6NGhiMZiquFrzi6mHlUeHw+HqulKEqlKtKnLmg5xPyHxmr4elwxhqc6NGpiMVmdClRqzpwlVoU6dOriK06NSScqbk6VOlPkcXKFRxd4uSPuSv89z+XQoAKACgD9Av2efjVNqWkDwz4ouXubjR0jhg1CQtJc/2ecR28lweZLiKEgW8smHmhIhZzKs6+R/vH9Bn6RVfxV4FrcG8W4+WL434DoYbD1cZiajqYzPeG5/uMszatObdXE4vByh/ZmbVpKc5VFgcbiatSvmcow/i/xl8PKfD+brOcooxo5XnE6lT2FNctLDY9e/iMPTSShShVTeIw8FaDXtqVOEY0EfYcckc0aSwyJLFIoeOSNg6OjDKsrLkMpByCOD146V/eiaaTTTT2a1T81v+f3n4Q04txkmmnZp6NNbp7ar0+4fTEFABQAUAFABQAUAFABQB5Z4w8di2SXTdBlWS7O6OfUEw8VrxhktjnEtx1Hmj91CfumWTPledisaop06LvPZ1Fqo/wCHo5eeiXS7b5fXwWX87VXELlhvGm/in5yXuuMfLeX91Nc35n/FHW31jxbfxiVpYNLd7BGZizSXEblr+ZyclpHvGlRnJYskUWSSPl/59PpteJtTxD8cs9y/D4mVbI+AU+Dssgp3pvHYGrKXEWK5U5R9tVzuWJwTqpt1cLluCu3yJR/ufwoyCOScI4KtOnyYrOEszru1mqNWKWBpLZqEcIqdXlaXLUr1d7ty86r+Qz9KCgDn/FPiSy8I6Df+IdRhvLiy04W7TxWEcMt0VuLqC0Uxxz3FtEwSS4RpN06bYw7DcyhG+m4P4Vx/GvEeXcMZXiMDhcfmjxMcPWzKrXo4OMsLg8RjZxq1MNhsXWi6lPDThS5MPPmrSpxfLFynH18iybE8Q5rhMnwdTD0cTjHWVKeLnUp0E6NCriJKc6VKvUi5QoyjDlpSvNxTsm5Hgd/+07oEaN/ZfhnWLt8fKL+5stOTP+01udTIH0U/h1b+jsu+iVxLVmlm3FmR4Knf3pZdhcfmc0vKGJp5RFvfeat53Z+r4TwQzecl9ezrLcPDq8JRxOMkvSNb6in85L56o8i8T/H3xzr6SW1hJbeG7N9yldKDm/eNv4ZNRnZ5UYdpLJLFvXrX7Zwl9G7w94bqU8VmNHFcVY6m4yUs5dP+zqdSP2qeV4eMKFSL60sfPHw6q1rH6HkfhNwvlMoV8XCtnWJhZ3x/IsJGS6wwVJqnJP8AkxM8VFdEzxOSR5XeWV3kkkZnkkkYu7u5LM7uxLMzMSWZiSSSSSTmv32nTp0qcKVKEKVKlCNOnTpxjCnTpwiowhCEUowhCKUYxilGMUkkkkj9NhCFOMadOMYQhFRhCEVGMIxVoxjFWUYxWiSVktFayGVZQUAFABQAUAFABQAUAFABQAUAFAH/0egr/H8/6wAoAKACgAoAKACgAoAKACgAoAKACgAoA+ov2YfL/tjxXn/W/wBm6ds/65/ap/M9/veV/XtX8ifS39p/YfBtv4P9q5nz/wDXz6nh/Zf+S+2Pwzxx5/7OyC3wfXcZzf4/YUuT8Oc+xq/ho/nIKACgAoA67wL4g/4RrxTpOpu5S0FwttqI52tp90RFcll43+QpF1GpOPOgjPGBX7b9HXxOq+Efi/wdxhLEToZRDMIZTxNGMmoVuGs3lDB5q6sF/FWCpzhmtCm7J4zL8LJtcqZ8nxxw/HiXhjNMsUFPEuhLE4Btaxx+FTq4ZRf2fbSTw85a/uq1RfavH9KNA1vUdE2pCwubBzva1kf938xyZLeRdxhZs7iVDRuMlo2YrJX/AEo4bEOEIzpSVWjNKcbNyhOMo3jKnNNrlkmmnF8stHomfwHisNTrt8y9nVjePN1TTtyzi+W9rW11T0VrOMvXNM1mx1WMNbybZQMyW0mFnT1O3OHQf89I9yc87WJVPWp1YVFeOj6xekl8ru/y083oeLVoVKLtJXXSUdYv59H5PXzd7R1q0MQoAKACgAoAKAKd7f2mnxGa7mSFedoJy8hH8McYBaRuei9OrEAZWJ1I01eTt2XV+SSu2/6dty4U51JcsIuT/Bebb0S9XH11PK/EHia+1VZLS0D2Vi2VbawFxcJyMTONwjRu8MeQVOJJJEOyvOr4idROMbwg9HvzSW7u+ie2nb1PXw2EhSanPlqVO32YPyV3d36v5JXueb6uItJ0nU9UmAMWm6feX8inPKWltLOy5AH3hGV9STkYyAvx/GOf4fg/hHini3FQUsNwxw7nXEGIi5aTo5NluJzKpDSzvOGGcVbVt2V20j38qws80zTLsspu1TMMdhMDB3TtLFYiFBPZbSqX10stbWtH845pZJ5ZZ5WLyzSPLK56vJIxd2PTlmYk8d+1f8u2PxuJzLHYzMcbVlXxmYYvEY3F15fFWxOKrTr16sv71SrUnN+cj/QujSp0KVKhSioUqNOFKnBbQp04qEIryjFJL0I65DQKAPOvi3s/4Vv4u8wAr/ZTYB6bxPB5Z+qybWHuK/UPBbnXinwV7OTjL+2I3a35HhsQqseukqfPF+Te259j4f8AN/rnw9ytp/X47b8rpVedejjdPyPzcr/VA/s8KACgAoAKACgAoAKACgAoAKACgAoAKACgD//S6Cv8fz/rACgAoAKACgAoAKACgAoAKACgAoAKACgD3z9nTV1sPHkmnyMFTW9HvLSMEgZurV4r+LBOMnyLa6UL339yFFfzh9KHJZ5l4c08ypQlKeQZ5gcbVcU3y4TFwr5ZVulsvrGLwknKzsoW0Tkz8n8Y8veL4UhjIRbllmY4evNrW1CvGphJ3Wunta1B36cvS9z7sr/O4/lcKACgAoAKAP0o+F9yfEHw/wDCupSFpJH0uO1mkO4l59Nkk0ud2PQs8to7tjHzMTgDIr/pM+jJxTV438AvCziGvU9tianCuFynGV5Xc62N4arYjhvGVqjs26lbFZRVrVHZXqTbSd0j+BPEPL1k/G3EeBhFQpxzGpiqUFZKFHMI08fShG6fuxp4mMI9kldyfxd+ti8bK8ZdHU7ldMqykcAqwZSDjuDnvx1r93UHe97ea5vX+5/WmmqPjHO6s0rPe9nf5csV57/cvi6ex13UbcBLlVu4x/Ex2TgdPvrlWx/toWY8Fxn5emFacdJe+u7sn/6Vr31W22vunJPD05axfI/vjt2umu+/yX2ejg1qymA3M8Df3ZYyB6ffTcn5kfQ53LuqsH1s+z/pr/Py2OaVCpHa0l/da/K7f4SX3mitxbvyk8Lf7siH+T/56fNgldFKL6p/MzcZLeMl6p/r/X4CtPAgy00Sj1aRAPzLY/T+W2jmj3X3/wCYuWT6N/L+v69UUptXsIQf3wkI/hhBkzxnhgDH09XH44JqHVgut32Wv6pfj95pGhVl9hrzl7v56/8Aksv0OfvPEN3ICllCsAP/AC1kxJL16qgzGpx/e83J4HODWMq8mmox5fN2b+XvtX9V950xwsVrOV/JaL7+a7/8l21393lJ7ee6kMty8s0jdXkLs2OmATwAMnCgKB24JrllGUneTu+7V33/AL35el7KMeqMlFWiopdo8vf0fe33PXaUJ089Ap/75/4D6jt/jxklUqb7/n6/3f6001LdR+nq1/8AIL1/yTvHzf4uRPY/DfxbOvB/swQHnB23d1b2j9AeqTMp5Gfu8jLN/On0tsZUyz6OPi1iaTalU4Z+oNr3X7PNcywGV1VdNu0qeMmmtpJtO93I+78MYLE8e8M05WaWYOt0fvYbDV8THoteakpLXTpe1z84q/5xz+8goAKAPD/2gtZTTfh7dWPmBJ9dv7GwiQffaKGddQuGA4IQJaLFI3T9+qHO8Cv6C+jTkVTNfE3CZg6Tnh+HstzHMqs2v3catehLLMLFt6Oo6mOlWpRV5P2E5qypyZ+n+EeWyxvF9DFcjlSyvC4rFzk17qnUpPCUU+nNz4h1ILf905L4WfA9f6PH9YhQAUAFABQAUAFABQAUAFABQAUAFABQAUAf/9PoK/x/P+sAKACgAoAKACgAoAKACgAoAKACgAoAKANDSdTu9F1TT9XsJPLvNNu4L22fnHm28iyKrgEbo327JEJw8bMhyGNeZnOU4LPspzLJcxp+1wOa4LE4DFQ0u6OJpSpTlBtPkqwUuelUSvTqRhUjaUTjzDA4fM8Di8vxUOfDY3D1cNWj15K0HBuL6TjfmhLeM0pLVI/Tjwv4j0/xZoOna/prhra/gDtGSDJa3C/Jc2k2Ok1tMrxPwA20SJujdHb/ACX4v4XzLgziLNOHM1puOKy7ESpxqqLjSxeGn7+FxtC970cVQcK0NeaHM6dTlqwnGP8AEOeZNi8gzXGZTjYuNbCVXBTs1CvRfvUcRTvvTrU3GpHdx5uSVpxkjoK+aPJCgAoAKAP0i/Zvt5Lj4U6QWB2pqOtpGTz8n9ozMdvytgCSRz2+YHjJzX+/v0A51av0aeFo1ebkoZ7xdSoX29k+IMZXly6q0fbVq2lvi5nrex/EHje4Q8Qsx5fingsrlO2nvfUqUVfR3fJCDvfay0sme7fYD02j68Dtj/nn/wAC/wAmv7QcP6tf/wBvX9a6bR/I/aev/gX/ANo+uv8Ana8l+wH0/MZ9uxH8unIx9xVyf1/Uvnv5f3g9p3T/APAv/ufr/TD7A3QL+mfbpg/X6fLzyGfIv6Vuv+N9P89dpHtF2f3/AP3PsH2BuhX+nt6D/wCsOOMEKOC8/uv/AO3r+tdNontF5/f/APaL+u28T7CR0UfkD/Q9x/XngMezXd/d/wDdA9p6/f5/4H/w/feS/YW/uj8APr/s9+frxwaPZru/u/8AunYPaev3+X+H5bbf+AifYG9B+II9/U9/155HLHs49393/wB0D2i7P7//ALmBsGP8I+vB9v7h7/N/ieWORf0rdf8AG+n+eu0j2i8/v/8AtF/XbeKfYD02j68Dtj/nn/wL/JocP6tf/wBvX9a6bRPaev8A4F/9o+uv+dry8x+M+kPcfC3xoiKSYtIa8I/2bC4t7xzx/djt2bp0GcrnbX86fS1yupmn0cPFzDUo80qXC08ya1f7vJsfgc3rSsm/go4GpO+y5dbpOR974X4uOH4/4XqTdlPMlh0+b7WLo1sLFfAvilWS31v1uflrX/N6f38FAATjk8AckntQlfRat6JLqB8A/HDx3F4w8UCz06US6L4dE9jZzI++O8vJHX+0L2Mj5Wid4YreB13LJDbLOjbZ8V/pN9H7w7rcD8ISx2Z0ZUc+4nlh8wx1CpHkq4HBUoT/ALMwFSLSnGvCnXrYnEwnyypV8VLDTgpYdyl/WvhfwtU4dyJ4nGU3TzLOHSxOIpyjyzw+HhGX1PDTT95VIxqTrVU+VwqV3SlG9JyPFa/ej9LCgAoAKACgAoAKACgAoAKACgAoAKACgAoA/9ToK/x/P+sAKACgAoAKACgAoAKACgAoAKACgAoAKACgD2X4Q/FCXwFqbWOol5vDOqTIb6NQzyafckCNdTtkAYthAqXkKAtPAiFA0sMa1+F+NvhFR8RspjmOWKnQ4tyjDzWXVJNQp5nhU5VZZTiqjajDmqSnUwNebUMPiJzjUlChiK04/m/iHwNT4rwSxeDUaed4GnJYWTtGOMopubwVaTaSbk3LDVHpSqykpWp1Zzh99Wd5aahawXtjcw3lndRLNb3NvIksE8TjKyRyIWV1I7g+xwRhf83cdgcZlmMxOX5hha+Cx2ErToYrCYqlOjiMPWpu06dWlNKUJxe6a7NXTR/JuIw9fCV6uGxVGrh8RQnKnWoVoSp1aVSLtKE4SSlGSfRrzV0yzXKYhQAUAfrF8ANGOkfCLwZDNHtmu7G51Z93V01fULvUrV/obO5ttuOq4Pev+jj6GnDNThj6NXhbg8TSlTxOY5RjuI6nNpKdLibOcyzzAVLdFLLMdgeTa8FFu7bZ/AHi5mSzHxD4lq0581PD4qjl8bO6jLLsJh8HXj6rE0K3N2d49j2MxJ6flX9Pckf6d/1X9aabx/OOeX9K36P+tddpAiT0/Ojlj/St0t3f/D667yOaX9O/W/Zf8NpptE8tPT9B/n/OetHKv6Sf/tvy389/eByb/p//ACXnfby2XKHlp/dFHJH+lbrf+b5bba/3Rcz7/wBWt/X39A8tPQf5/wA/5yaORf07/o/6011UnzPrr6/d3XTT8dLpxPLT0H+f8/5wKORf07fov6000UTma20+X/BfTT/O7cjy0/uijkj/AEr9b/zfLbbX+6Lmf9JL+u/rruHlp/dFHJHt+Nv6/pBzS7v77/1/SAxJ6flRyR/p3/Vf1ppvF88v6Vv0f9a67Sytc0a31vRNY0WcDydX0vUNLmJ5Aiv7SW0kJGDnCyk9Pyr5/i3hzC8WcKcTcK4zl+qcS8P5zkGKco3Sw+cZbiMurNr3rpU8RKVu+17c0e7K8xq5XmeXZnSv7XL8dhMdTSe9TCYiniIK9lb3qaV+29to/izfWVzp17eafeRmG7sLq4srqJusVzazPBPGfdJY2U+4r/lazfKsdkWbZpkmZ0XhsyybMcblWYYeXxUMdl+Jq4TF0ZXSd6VejUg7pax2Wx/pjhcTRxuFw2Mw01Uw+LoUcTQqLadGvTjVpTXlKE1L5mZeXlpp9tNe31zBZ2lshluLq5lSCCGNerySyMqIo9WYc8ckgVhgsDjcyxdDAZfhMTjsbiqkaWGwmEo1MRia9WXw06VGlGVSpN/yxi3a7dlqduHw+IxdanhsLRq4jEVpKFKhQpyq1ak3tGFOClKTfZJ9+h8f/Fj45rrEF14a8GySx6bMrQalre14Zr6I8SWuno3lyw2ki5Se4kVZrlC0McaQFnn/ALf8Gfo9SyPEYTivjqlSqZrh5wxGVcPqVOvQy+rH3qWMzOcHUpYjG05Wnh8NSlKhhZxjWqVKuIUaeH/ongDwteXVaGdcSU4SxlNxq4LLLwqU8NNawr4yScoVcRB+9Sowfs6Mkqk5TqcsKHzBX9bn7iFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAf/V6Cv8fz/rACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPTfAHxU8R+AJDDZsuoaNNJ5lxo927+SGJ+eaymG9rG4cZ3OkckMhwZ7eZljKflHiP4PcK+JEI4jMKc8uzyhT9nhs7wMYLEOCXuUcdSfLHH4aD1hCpOFalrGhiaMJzjP4ji3gLJuLYKriIyweZU4clHMcPGPtGkvcp4qDssTRi9YxlKFSGqpVYKU1L6m0P4+eCdXjQXd7Lod0R89vqduwjDD72y8t1ltWTP3Wle3kYc+UOVX+Us6+jVxZlVWf1WjSzrCxb5MRl+Ij7Rx+zz4OvKliY1GvijShiIRaaVV3jKX4RmnhPxPl85fV8NTzOgm+Wvgq0eZrpzYaq4V1J9VCFWC6VHdKfYD4m+DCu/8A4S3w5jrg6xp4b/v2ZlcH2xn6YxXyr8EuK1Ll/wBXM+una6yzHuOn99UuR+qlZ7rsfOvgjiVS5f7Azi/dZdjXHT+8sO4/Pm16X3l0Pw/8VeHfiL4+8LfD7w/rdvf614o1aHTraKwgur0RQ4e4v72SWC2kgS307ToLu/uJJJFRbe1kY9ML9vwR9FzjbjLiXIshp5TisDRzXM8JhcVjMRVw9F4HBTqxeOx0qFWuq9SOCwir4qVOnSqTlGk1FSbUTx+Lshzjg3hPPeL83yyrhMtyPL6uMrTxVWjhueppSwmGjTrVYVZVsZjatDCUYQhzyq14Kz+z+8VjZW2m2Vnp1nGIbSwtbeytYV+7FbWsKQQRr04jijVRx0Hav+h/KcrwOSZVlmS5ZQjhctyjL8HleX4aHwYfA5fhqeEwlCP92lQo06cfKJ/lNisTWxuJxOMxM3UxGLr1sTXqPepWr1JVas3vrOc5SevXqWq9AwCgAoAKACgAoAKACgAoAKAPxe/4KBX/AIm+C/jyw8RaBoNnPoHxGgub6HV7ppZLax8S2PlR61p0lnAkJE1xHLa6zBPNegXb3t9HHbstjOzf5S/ST+iNw3jvFjNvECvmOYYTJOOKyzWvlmW0aND2WfQpUoZy3jqv1iKWZV0s1nF4RVJ18bi1TqpU7w/0r+iNhMk8SuFMXk+bZtiaWbcG1aOFqZdQjThXxWS4r2k8sxkMTVlUTp0Z08Rl1WlTwzdCGHw051YvFU1L8m/E3jfxT4wmEviDWLq9RGLw2gKwWFuTnmGygEdsrgfL5vlecygB5H61wcJ+H/B/A9F0uGsjwmX1JwUK+NtPEZjiI6Nxr4/Eyq4ucHJc/sfaqhCTbp0oaKX9/ZHwvkXDlNwyjLqOGlJctTEO9bF1VvapiqrnWlFvX2akqcX8MY6KXKV9ie+FABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAH//W6Cv8fz/rACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAP3P8A+Caf7NVz4S0O5+PPjHT2ttc8W6e2neArG7h2z2HhS4aOW88QlJPmhn8RvFFFpr7IpBokL3Mcktrru1f6x8DeBp5dhJ8XZnRcMXmNF0copVI2lRy+bUqmM5ZaqeOcYxoO0WsLBzTlTxa5f8tPpreNdHiDNKPhRw3i1Wyvh/GLGcWYrD1L0sXn1FThhsnU4WVSlk0Z1KmNjzSg80qxozjDEZU3P9Ya/oc/gIKACgAoAKACgAoAKACgAoAKAPC/2i/gdoX7Qfwt1z4fau6Wd9Jt1XwtrTIZG0HxRYxTLpmolF+aS1cTz2Gpwr88+l3t5HCYrhoZ4vk+NeFMJxlkGKybEtUqsrYjAYpq7wmPoxkqFbRNum1OVGvFJuVCrVjHlm4Tj+p+DfijmnhDx3lfF+XxnicLDmwGe5ZGSgs1yPFTpPG4NSekK8XSpYvBVH7tLHYXDTqKdFVKdX+Wnxl4Q8Q+APFWveC/FenTaV4i8N6lcaVqthNyYbm3bG+KQAJPa3EZS5sruLdBeWk0N1bu8MyO38BZnluNyfMMXleY0ZYfG4GvPD4ilL7M4PeL2nTnFqpSqRvCpTlCpBuMkz/drhviLJ+LchyriXIMZTzDJ86wVHH4DFU9qlGsvhqQ+KlXozU6GJw9Tlq4bEUqtCtGNWnOEeZrgPbCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD//X6Cv8fz/rACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAHxRSTSRwwxvLLK6RRRRI0kkskjBUjjRQWd3YhURQWZiAASQKcYylJRinKUmlGMU3Jt6JJLVtvRJa9tyZzhShOpUnGnTpxlOpUnJQhCEFzSnOUrRjGMU5SlJ2SV3ZI+u/hh+ytq2uxRax8QZrvw9p0iq9vodr5Sa7cq3KveyTJcQ6VGRj/R3hnvmy6TR2Tqjt9xlHBtbERjXzSU8LSavHDQt9Zkns6jlGUaK/uNSqbqSg9I/zxxz485flVSpl3CFLD5xjIScK2aV+eWVUWtHHDRp1KVTHzTuvaxnRwqspU6mJjJxj+gnwC/YX+CfibVf+Eh1vS5dU0vw7fW7Pol7rl9O+p3agXEC6nZwzQINJYr+9jlUx6iY5rQxmFbiv2XgXwr4czbEvH42l7fCYCtC+Cnias54iqlzwVenGUUsK/tKStXcZ0rKCm5fyL4s/Sm8TskwH9j5Zj6eBx+cYWtGOZ4bK8LSjgsPJulVeCxFSnVl/aEU1yThLnwanSxCmqjpM/WqKKKCKKCCKOGCGNIoYYkWOKKKNQkcUUaAJHHGihERQFVQFUADFf0zGMYRjGEVGMUoxjFJRjFKyjFKySSVkkrJaK1j/AD9qVKlWpOrVnOpVqzlUqVKknOpUqTfNOc5yvKc5yblKUneTd3dskpkBQAUAFABQAUAFABQAUAFABQAUAfFn7Wv7OHwb+J2kjx54x0yGz8XaNbxadY6xaXV5YXeuW7Oxt9EvFsZ4vt8kZMsthcTxTSWCCcF0smnKfk/idwZw1nWCec5jThh8zwkI0aOJhOpTnjYtvkwdVUrOrJe9KhUkpyopSTcaLmf0v9H3xm8R+B8wfCvDmNqYnh7Mq08ZisuxFDD4vD5XWUUquZ4Z4qnU+qRqLkhi6VKdKGLl7JpSxKpn5deKP2SfA9/YTf8ACLahqug6qqk2zXd1/aemSuASI7qGWIXaK5wvnQXOYR+8MFxjy6/nPGcE5dVpS+p1K2GrJNwc5+2pN20jOMo86TenNGd478stIn90ZF9IPijC4un/AG9hMBmuXyklXjh6H1LGwi9OfD1YTeHlKOsvZ1aFqnwqrRvznw1428AeKvh9qZ0vxPpctm7F/sl4mZtN1GND/rrC9VRFOuCrPGdlzBvVbmCCQ7K/O8wyzG5XW9jjKLg38FSPvUaq/mp1EkpdLxdpxv78YvQ/qXhni7IeL8CsdkeOhiYxUfrGGlanjcHOS/h4vDP95SldSUZ+/Rq8rlRq1YLnOMrzz6QKACgAoAKACgAoAKACgAoAKACgAoAKACgD/9DoK/x/P+sAKACgAoAKACgAoAKACgAoAKACgAoAKACgD0T4ffC7xf8AEq/+y+HdPJs4ZFS/1q73waTp4ODie52P5k+0hks7VJ7t1O8QiJXevVyzJsdm1TkwtL93FpVMRUvGhTv/ADTs7yS1UIKc3vypXlH47i7jrh3grCe3zjGJYmpBywmWYflq5hjGtP3VDmjyUuZNSxFeVLDxd4uo5uMJfox8LvgV4Q+GkcV5HENc8TbP32v38Kb4GZcOmk2h8yPTYiCyl1klvJFZ0lumiYRL+p5Pw7gcpiqij9YxdvexNWKvFvdUI7Uo20uv3jV1Kck+WP8AG3HXipxFxrOphpTeV5Hzfu8pwlSXLVineMswxCUJ42onZ8koww0JKMqdCM1KcvbK+gPzE63wX4y1fwNrcGs6VJnGIr6ykZhbajZswMtrOBnGcB4ZQC8EypImcMretkuc4vI8dDGYWV/sV6Mm/Z4ii2nKlOz07wnZunNKST96Mvn+JeG8v4oyurluPja/7zC4mCTrYPEpNQr0m97X5alNuMatNyhJq6lH9EfB/jHRfG2jw6xo04dW2pd2khUXen3W3L2t1GD8rjrHIB5U0eJImZCNv9DZRnGCzrCQxeDqcy0jVpSa9rh6lrunVim7SX2ZfDOPvRbTR/HvEXDmZ8MZjUy7MqXLJXlh8RBN4fGUL2jXw838UXopwfv0p+5UjGSsdVXqHghQAUAFABQAUAFABQAUAFABQBheI/Emj+FNJuNZ1u7W0srcYHRprmYgmO1tYchp7mUqRHGpHAaSQrEjunDmOZYPKsLUxmNqqlRp/OdSb+GnShdOdSX2YrzbtFSnD1cmyXMc/wAfRy3LMPKviaru91So007Tr4iptSo07rmnLq1CCnOUYS/Pb4i/EPVPiDrBvbrda6Zal49J0pXLR2cDH5pJTwst7cbVa4n2jokUe2GKNa/n3iLiHFcQYx1qt6WFpNxwmFUrxpQe8pdJ1qlk6k9OkYpQikf15wdwhgeEctWGoWr46uoTzDHuPLPEVUnaEF7zp4ajzSVGlzaXdSfNUnNx89r58+vMXX/Duh+KdLuNG8Q6Za6tplyP3trdx71DAELNDIpWW2uI9xMNzbvHcQsd0UisM1hicLh8ZRlQxVGFajP4oTV11V4u6lCSv7s4NTjumrXPTyjOc0yHHUcyyfHYjAY2g/cr4efK3FtOVOpFqUK1GdkqlGrGdKolacGlaXwN8Vf2Xta8O/adb8BG58Q6Iu6abRnAk13To+rC3WNVGsW6dvJVNQRSqm2utktxX5rnPB9fDc2IyznxOHWssO9cTSX9y0V7eK/u2qK/wTtKR/WfAPjpluc+wyzixUcozOXLTpZlH3Mqxs9l7ZybeXVpaX9o5YOTTarUeaFA+TGVkZkdWR0YqyMCrKynDKynBDAjBBGQeDjBr4lpptNNNOzT3T7PbVen3H9AxkpJSi1KMkpRlFpqSaummtGmtU1o1qhtIYUAFABQAUAFABQAUAFABQAUAFABQB//0egr/H8/6wAoAKACgAoAKACgAoAKACgAoAKACgCa3t57ueG2tYJrm5uJEhgt7eN5p55ZG2xxQxRhpJJHYhURFZmY4AJOKqEJVJRhCMpzm1GMIJylKT0UYxjdtt6JJXe2pnVq0sPSqV69WnQo0YSqVa1WcadKlTguadSpUm4xhCMU3KUmoxWr0Psr4Vfsr3d/9m1z4lGWwszsmg8LW0uzULlT8y/2vdRsTYRsMbrO1kN8QxWa4sJozG33uTcGzqcmIza9OGko4OEv3k1v+/nG3s0+tOD9pZtOdNpo/m3j3x5w+F9tlfBShi8SuanUz2tDmwlGWz/s/D1E1i5xfw4mvF4W8b06OJpz54/dGlaTpmh2FtpWj2FrpmnWcYitrKyhSC3hQc4WOMKNzHLSOdzyOzSSMzszN+i0aNLD04UaFOFKlTXLCnTiowivJKy1ere7d27u7P5Zx+YY3NMXWx+Y4vEY3GYibnXxOJqzrVqkv705tuySUYRXuwilCKUVFR0K0OMKACgDp/Cfi/XPBeqx6toV0YJhhLi3ky9nfW+7LW15BuUSxHqpBWWJv3kEkUgDr6eU5vjsmxUcVgarhLRVKcrujXprX2daneKnHs01OD96EoSV5eHn/D2V8S4CeX5pQVWm7yo1oWjiMLWtZV8NVs3TqLqmnTqR9yrCcHKMvu74e/Fjw749gjt0kXTNfWPNzotzIN7soy8unTEIt9AMFsIBcxKCZ4I0CyP+68P8V5dn0I04yWFx6jepg6k1zNpe9LDzdlXp7vRRqQXx00rTl/K3F/AGccKVZ1ZQljsplO1HMqNN8sE3aNPGU1KbwtV6JNylRqNpU6spc0Iep19QfCBQAUAFABQAUAFABQAUAebePfij4b8BWzreTi+1l491rodpIpu5Cw/dyXT4dbG1JwTNMu913G2hnZWSvm8+4ny3IaclWqKvjHG9LBUpJ1ZNr3ZVXqqFJu3vzXNJX9lCbTPtOE+Bc64srReHpPC5bGdq+aYiEvYQSfvQw8bwliq6Wns6UuWLt7arRTjOXwj408da9471M6jrVx+7jLLY6dAWWx0+Fj/q7eIk5kfA864kLzTFV3ybERE/C86zzH57iXiMZU92N1Qw8Lqhh4PpTg2/eenPUlzTnpdpKMI/1Tw1wtlPCuBWDy2j78+V4rGVUpYrF1FtOtUWnLG7VOjBRpUk3yxcpTnLjq8c+jCgAoAKAPBvin8AfCXxHWfUrdU8O+KmVmXWbKBTDfSAfKus2YMaXYPA+1xmK+QbM3E0US27fOZzw1gc1UqsUsLjGtMRTj7tR9Pb01pU7c65Ki6zkoqMv1fgPxb4h4MlSwVaUs4yFNReW4mo/aYSDery3FPmlh7b/V5xqYWXvWpUqk3Xj+dfjv4ceLfh1qR0/wATaa8CSO4stTt90+laki877K8CqrMFwz20yw3kKspnt4ty7vyzMsqxuVVvZYuk4pt+zrQvKhWS606nLG7tZuElGcdOaEbrm/sfhXjPh/jLBfXMkxsasoKLxWBq8tPH4KT+zicNfmim7qFam6mHqtP2VWfLLl4SvNPqgoAKACgAoAKACgAoAKACgAoAKAP/0ugr/H8/6wAoAKACgAoAKACgAoAKACgAoAKAPTfhz8JfGHxMvPK0Ky8jS4ZQl/r18Hh0uz6F0Eu3deXYUgiztFmmG5HmEMJMy+xlWSY7NqlsPT5KKdqmJqXVGHdJ2vUnr8EOaXV8sW5R+H4y8QeHOCMNz5pifa46pBywuU4VxqY/EbqMnT5lHD0G074jESpU/dkqftqiVKX6NfDH4J+D/hlAk9jB/aviJo9lz4i1CJDdneuJItPhy8WmWrZYeXAWuJEOy6urnahT9UyjIMDlEVKnD22KatPFVUnUd1rGmrWpQeqtC0mtJznb3f41448TuI+N6sqWKq/UMnjPmoZNg5yWH913hPGVPdnjq60fPVSowknKhQoc0lL2GvcPzkKACgAoAKACgB8UskMkc0MjwzROskUsTtHJHIh3I8bqQyOrAMrKQVIyCMA1UJypyjOEpQnBqUZwbjKMlqpRlGzTT1TTut9CZ04VYTp1IRqU6kXCdOcVOE4SVpRnGV4yjJNpxas1o73PofwV+0N4g0RYrHxTA3iLT0Cot6rJDrUKDjLytiDUNqjgXHlXDsS0t63Ar9ByXxBx+CUKGaQeY4eKUVWTUMZBLvJtU8RZf8/OSpJ6yrPc/H+JvCDKczlUxWRVVk2Lk3KWGcZVctqyeto00/a4O7erourRitIYVacv1B4Z+J3gnxasS6Vrlql5Jj/iWX7Cw1EOf+Wa29wU+0sOMtZvcx88OcHd+n5ZxNkubKKwuOpKtL/mGrv2GIT/AJVTqP8AePzoyqx132Ufw3O+COJuH3Ulj8rryw0G/wDbsIni8G4r7cqtFN0YvosSqM/7qO+r3j5MKACgAoAKAOF8TfEnwX4SEi6xrlot2gP/ABLrNvt2olh0RrW2EjwFuivdGCInrKuCV8PMuJMlylNYzHUlVX/MPRft8Q32dKlzOF+jqunD+8tXH6nJOCuJeIHCWXZXiHh5tf7biF9VwaXWSr1uVVbX1jQVWp/cldOPzD40/aK1zV1msfCdqfD9k+5DqM5jn1iVD3j2h7XTyy8N5X2qdTh4bqJhhvzLOvEPG4pToZTSeAovT6xNqeLlH+7ZypUL/wB32k1vCrB6n7jw14O5Xl8qeK4grrNsTG0lhKSlSy6nLf37v2+Ms9vaKhRkrxqUGmz51nuJ7qaW5upprm4ndpZp55Hmmmkc5aSWWQl5HYklnclieST1r87qVKlWcqlWc6lScnKdSpJznOT3lKUm5Sk+rbbfVvc/YqVKlQp06NClTo0aUVClSpQjTp04RVowpwglGEYrRRikktElqiGoNAoAKACgAoAKAMrW9C0fxJptzo+u6daarpl2u2ezvIllibrtdc/NFNGTuhniaOaFwJIpEdVascRh6GKpToYmlCtRmrSp1FeL811UlupK0ovVNNXO/LM0zHJsbRzHKsZiMBjcPLmpYjDVHTqR7xlbSpTmly1KVRTpVY3hUhKDlGXwb8Vf2WtU0X7Trnw7+0a3pS7pZvDsrGXWrJOWYafJgf2tAg4SAgakFCIovpN8lfm+dcHVqHPiMr5sRRV5Swsver01u/ZStD20V0i/3q0S9q7s/q7gLx2wOZ+wyvjFUssx75adPOKaUMtxUtl9cjf/AIT6snZyqq+CbcpOWCgowl8gyRyQySRSxvFLE7RyxSKySRyIxV45EYBkdGBVlYBlYEEAgivhmnFuMk4yi2pRas01o007NNPRprTyP6JhOFSEKlOcalOpGM4ThJShOE1zRnCUbxlGUWnGSdmndXuMpFBQAUAFABQAUAFABQAUAFAH/9PoK/x/P+sAKACgAoAKACgAoAKACgAoAs2dnd6hdQWNha3F7e3UqQ21paQyXFzcTOcJFDBCrSyyOeFRFZieg/vXTpzqzjTpwlUqTajCEIuU5SeyjGN22+yV/UxxGJw+EoVcVi69HC4ahCVSviMRUhRo0acVeVSrVqOMIQitXKTSR9q/Cr9laST7NrnxMJij+SaDwnazYlccMv8AbV7A+YVI+9Y2Mplwy+ddwustrX6BkvBt+TEZvdLSUcFCWv8A3MVI2t/17pzv/NUj78D+ZePfHqEPbZXwRac/ep1c/r0vci9n/ZuFrRftGtlisVT5NH7LDVIuFc+3tP0+x0qzt9O0yzttPsLSNYbWzs4I7e2t4l6RxQxKsaKDk4VRknJyTmv0KnTp0YRpUqcKVOC5YU6cVCEV2jFWSXp+OrP5gxeMxWPxNbGY7E18Xi8RN1K+JxNWdavWqS3nUq1JSnKWiV5SemiskkXKs5goAKACgAoAKACgAoAKACgDsNG+IHjXw+qx6T4m1e1hTGy2a6a6tEx/ds7vz7ZewOI+QADgCvYwfEGdZelHCZni6UI7U3UdWkvSjW9pSXyi/NPQ+dzLhHhnNpSnmGSZfXqS+KsqEaGIlf8AmxGH9lXfzqO17rc9Bs/2hviPbBRNcaRqBXqbzSo0L47sNPexGT/s7PYDqv0FHxB4ipW56mDxFv8An9hVG/r9Xq0Fr5Jekdj5HEeEHBtdv2dHMMHfZYfHzmo37fW1iXp/eb876GqP2lvHYBB0rwmff7Bq+R/5XAOPp+ddS8Sc964XKn5+wxen/l8ee/BThX/oPz//AMK8uf8A7y1b7n+hmXf7Q/xGuVYQzaNYE9HtNLV2T/dF/LeqT2+dWHrnOV5aviFxFUTUJ4PD32dLCqTj6e3q1l/4Fzej0O/D+D/BtFp1KeY4tLdYjHSipev1WGGku/uyj92h5/rHxE8ca+jRar4n1a4hfO+2juTZ2smf79rZC2t2HoGjYDtj+LwMXxDneOTjis0xdSD+KnGq6NKV+9Kj7Om12vCy7L7X1uW8H8L5TJVMBkeX0asfhrTorEV426xxGJdatF9+WWu+m0uMrxj6QKACgAoAKACgAoAKACgAoAKAPBvjB8F/AfjfT77XtTntfCes2du88vipPJgt9kS/e12KR4be+t1AVfOklhvI1WNI7tYgYZfnM8yDLsxp1MRWlHB4iEeZ4xcsY2S/5iE7RqRSVrtxmtLTt7kv1fw68S+K+GMZhcqwNKvn+W4itGlDIJ+1q1eapLbK6kI1KuFrN3fs4wrYabc51MM5vnj+XV9bxWl7d2sF5b6hDb3E0MV/aLcJbXkccjIlzbrdQ29ysMygSRrPBFKFYB41YEV+O1IKFSpCNSNWMJyjGrDmUKii7KcOeMZcslquaMZW3inpH+6sLWqYjDYevVw1bB1K1GnVqYXEOk6+GnOClKhWdCrXoupSbcJulWqw5l7s5KzKtQbhQAUAFABQAUAFABQAUAf/1Ogr/H8/6wAoAKACgAoAKACgAoAKACgD0r4W/Eu/+F/iL+3LLTNN1WOeIWt7bXsEYuWtS2ZBp+pCN7nTZ2GVZ4t8Ew2i7tbkRxKvrZPm1XJ8V9Yp0aVZSXJUjUiufk6+yq/HSk+rT5ZbTjKyPiuO+CcJx1k39l4nHY3ATpVPb4Wthqs3RWIUbQeMwXPGhjaUXqo1OWrSfM8PWoudTn/Tb4e/FXwf8SrEXHh+/CahFGHvtCvSkOrWB4DGS33EXFuGIC3lq09sdyo8iTFo1/XcsznA5tT5sLV/eRV6mHqWjXp/4oXalG7S9pTc4apOSl7sf4g4w4C4j4KxTpZvhHLCTm44XNMMpVcvxS3SjWtF0azSu8PXjTrK0pKEqaU5ekV6p8WFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAHmXxG+LXg/4Z2Rl1y+FxqkkZex0CxaObVbwkHY7RbttnaFgd15dmKHCuIfPmUQN5Ga53gcop82Iqc1aSvSw1Np1qnZ22hC+jnPljvy80lyS+44N8PuI+N8SqeV4V0sDTmo4rNsUp08Bh19qKqWbxOISd1hsOp1NYur7Gk5Vo/m/8TvjL4t+J91t1KYaboMMvmWPh2xkf7FCR9ya8kO19SvVXj7ROqJES/2S3tVldG/Ks4z/ABubztVl7HDRlenhabfIuzqPR1ai/mlon8FOCbP7P4H8NuH+BqHNgqf13NqlPkxWcYqEPrVRNLnpYaC5o4LDN6+xpSc5rk+sVa8oQnHySvDP0EKACgAoAKACgAoAKACgAoA//9XoK/x/P+sAKACgAoAKACgAoAKACgAoAKALmn6jf6Te2+o6Xe3WnX9pIJbW9sp5La5t5BnDxTxMsiNgkEqwypKnIJFaUqtWhUjVo1J0qsHeFSnKUJxfdSi019/3nNjMHhMww1bB47DUMZhMRB06+GxNKFehVg941KVRShJXs9U7OzWx9nfDX9rGe3FvpPxJtGuohsiXxRpkAFyoHHmarpkQCTgZzJc6cscoVQBp9zKzSV97lPGko8tHNoOUdEsZRj7y6XrUYtc3dzpKL/6dSvzH818a+AFKq62YcFV1Qm+acsjx1V+wk9+XAY6pzTpPpCjjXODbu8XRglCP2toXiHQ/E2nxar4f1Wx1jT5vuXVjOk6BsAmKUKd8E6Bh5kE6xTRn5ZIlYEL+gYfE4fF0o1sNWp16Utp05KS72dtYyX2oytJbNL4Y/wAzZrk+aZHi54DN8BisuxdP4qGLoypTcb2U6bklGrSl9irSc6U1rCclqbFbnmhQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAGH4g8S6B4V06TVfEerWWj6fFnNxezLGHcAnyreLma6uGA+S3to5Z5OkcbEYrnxOKw2DpOtiq9OhSjvOpJRTfaK+Kcn0jFSk+kXdKXqZRkubZ9jIYDJsvxWY4uptRw1JzcY3t7SrPSnQpRb96tWnClDeckkfEvxL/awvL0XGk/De1fTrdt8T+JdSiQ38q/dL6Zp7+ZDZq2Mx3N6J7go+RaWU6h1/Ps241nPnoZVTdOL9363VS9o11dGi21DynVc5219nCXw/07wT4A4bDOjmHGleOMrLlqRyTBVJLCQluo47GR5amJavadDDOlR5o2eJxFKTifG97fXupXdxf6jd3N9fXcrTXV5eTyXNzcSv8AekmnlZpJHPdnZj2zwN3wdSpUrVJ1as51KlSTlOc5OU5Se7lJ3bfr+GiP6QwuFw2Cw9HCYPD0cLhcPBU6GHw9KFGhRpx+GFOlTUYQiuiikuvUq1BuFABQAUAFABQAUAFABQAUAFAH/9boK/x/P+sAKACgAoAKACgAoAKACgAoAKACgAoA6Pwz4u8S+DtQXVPDOs32j3g272tZcQ3CIciK8tZA9rewZ58i7hmizzsBHzdeDx2LwFX22DxFShPS/I/dmlryzg7wnG62nGS/FHjZ3w9kvEeDeBzzLcLmOGd+WNenepRlJWdTD14uFfDVbK3taFSnUtpzJfF9jeA/2u428mw+IejmJvlQ6/oMZaM9vMvdIlkMiYxulmsLiXcSRFp6AAV93lvG8Xy080ocr0X1nDJtetSg5trvKVOcu0aSP5x4r+jzOPtMVwfmPOvel/ZObTUZrryYXMIQUZb8tOniqULJXqYxtykfXPhnxl4W8ZWn23wxrunazAADILSdTcW+77ou7OQR3lm5yMR3dvC/OdvPzfb4THYPHQ9pg8TSrx6+zl70f8cG1OD8pwi/I/nnO+G894cxH1XPMqxmW1W2oPEUmqNa27w+Ji54fERVvjoVq0f76+101dZ4gUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAHLeKPG/hPwXa/a/FGv6do8bKzxR3M4N3chev2SwiEt7eEd1treUjqRwa48ZmGCwEPaYzE0qEbXSnL352/wCfdNKVSo/KEZP0t73vZFwxxBxLX+r5HlOMzGaaU50KT+r0b7fWMVUlTw2HTvo61aCfS58h+PP2uyfPsPh5o2PvINf16Pn0MllpEUpA/vwzX9wewm04/MlfD5jxx8VPK8P5fWcSvlenQjN37xlUkv71J7H9D8KfR5S9li+MMyvtN5TlMnbvyYnMZwTf8tSnhaMba+zxjupHx34j8U+IvF2oPqniXWL7WL592JbyYusKMcmK1gXbb2cAPIt7WKGFT0jGct8Li8bisdVdbF16leo9nUk2op68sI6RhG/2YKMeyWvN/RuTZDk/D2DjgMly7C5dhY2vTw1JQlVklb2leq71cRVto6tepUqNaOb2MCuU9YKACgAoAKACgAoAKACgAoAKACgAoA//1+gr/H8/6wAoAKACgAoAKACgAoAKACgAoAKACgAoAKALun6jqGk3cV/pd9eabfQHdBeWF1NZ3ULesVxbvHLGfdW/PGK0pVatCaqUatSjUj8NSlOUJr0lGUWvv+69zmxeCweYYephMfhcNjcLVXLVw2LoU8RQqLtOlVjOnJf4kfRPhD9qb4jeHRFb62bLxfYR4XGpx/ZNUVB/DHqtmF8xjzulv7S/lb+8AMV9VgeMs0w1o4j2eOpr/n6vZ1kl0VanZP1qU6kn/M7H45xF4EcG5w51ssWK4dxUru+Bl9YwLk+s8DiXaKXSnhMRhILzu+b6Z8LftVfDfXBHFrY1LwneNgML+3e/04uf4Yr/AE5JpNoPBku7KyQdSQMlfrcHxllOItHEe2wU3o/awdSlfyq0nN2850oJX1bteP4jn3gLxplbnUyz6lxBh1dr6pWjhMYorrPCYyVOHNbVQw+JxEnsk3ZS9+0TxL4e8SQfafD+uaTrUAAZpNM1C1vRGD2lFvK7QuD8rJKEdW+VlVsrX0uHxeFxcefDYijiI7t0asKlr/zcrbi9dpJNbPqfkuZ5JnGS1fYZvleYZZVu0oY7CV8Nz2603VpwjUi1qpU3KLWqbTUjbroPLCgAoAKACgAoAKACgAoAKACgAoAwdc8U+G/DMPn+Ide0jRYipZDqeoW1m0oHaGOaRJJ2JBASFWdjwATxXNiMZhMJHmxWJoYdbp1qsKd/8KlrJ76Ru307x9bK8izrO6nscnyrMMzqJ2ksFhK+IUL/APPydKnOFJW1cqkoxS1bV7ngHin9q34c6J5kOhRan4su1yFNnA2m6bvHVZL7UUiuMZ4Eltp93GeSGI2lvmsZxnlWHvHDqtjZrZ04+ypX7OpVtLyvClNPfXRn63kPgHxlmfJUzWpgeH8PKzaxNRY3G8r6xwuElKje28K2MoTWzV0+X5l8X/tRfEjxH5tvo8tn4QsHyoTSU87UmjPaXVbsSSK47S2FvpzfrXyOO4xzbFc0aDp4Gk9lRXPVt2depdp/3qcKTW3W5+38O+BXBeTezrZjTxHEOLhZueYT9lglNdaeAoOMJRfWni62Mj5PTl+eb6/vtTupr7Ury71C9uG3z3d7cTXV1O5/ilnneSWRvd3Y+5/h+WqValacqlWpOrUk7ynUlKc5Pu5Su39/3n7BhcLhcFQp4XBYahhMNRjy0sPhqNOhQpx/lp0qUIU4LyjFIqVB0BQAUAFABQAUAFABQAUAFABQAUAFABQAUAf/0Ogr/H8/6wAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAJ7e5ubOZLi0uJ7W4iO6Oe3leGaM+qSxsrofdTn6daqE505KcJShKLupQk4yT7pqzT9H92hlWoUcRTlRxFGlXozVp0q1OFWnNdpQmnGS8mvuPVNC+OvxY8PBEs/GeqXUKYHkaz5GuIVHSMSarFd3EaAcAQywlRwrADDe1huJM6w1lDH1ZxVvdxHLiE0ul60ZTS/wzT6K58HmvhXwBnDlLE8NYGhVld+1y322VyUn9vkwFShRnLq/a0qib1km1Y9d0f9sDxtahU1rw54d1dV6yWpvtJuXHq7m4vrfd15jtEX/ZGK9uhxzj4WWIwmFrpdabqUJNebc6sb/wCGEe1na5+eZj9HXhiu3LLM5zjLpP7FdYXMKMe3LH2ODrWXadebf8z0R6Tpv7Y/hqUL/bHg3XbFjjcNNvrDVQPXabr+xi2O2VTPtwa9alx3g3/HwOJpv/p1UpVvxm8P+X32fL8Vjfo4Z3Tb/s7iTKsVH7LxuFxeAb7XVD+0lH5OXzO2sv2qvhNdAGe51/TicZW90V3K59f7Pnv1474Le2cZb0KfGWST1lPE0vKph5P/ANNTqr+vnL5jE+AviBQbVKjlONt1w2ZQin5L65SwjV/NetvtdLB+0X8GrgAr4zijJ6rPo3iGAj2Jl0pFP/AWI/2jgGuuHFOQz2zCK/x0cTD/ANKoJfj9x4tbwb8SKLalw1Umv5qOY5RVT9FTzCUvvSfkr80dFfjv8InGR460jH+0t6h/75e1Uj8c/h1bZcR5I/8AmZUPnzr8HTucUvCnxDi7PhbMbr+V4aa++OKt+f6RH+O/wijGW8daQR/sJfSH8o7SQ/p+eMUnxHki1eZUPlzv8FTuEfCnxDm7LhbMf+3nhYL75YiC/D79eXNuP2jPg1bDLeMo5T2W30bxDOT+MelMg/4E6j3bOFynxTkMN8wi/wDBQxU/xjQVvn+N0juo+DXiRXenDc6a6yrZllFFL5Tx/M/lF/P4jmr39qv4T2gPkT+INTIzgWWimMtj0/tG508c9txXHccVyVOMslh8M8TV8qeHa+X72dLX8PW94+1hfATj/ENKrSyjBX64rMlNL1+pUcW9PJPyjqcRqf7Y/hyIH+xvBmt3x52/2nf2GlD2J+yrrOPcD8zjNefW47wi/gYDE1H/ANPqlKj/AOkPEfl92nN9Rgfo4ZzUa/tLiTLMKvtfUcJise13S9u8tT9Xb0PNdY/a/wDHN2GTRvD/AId0dGziS4F9qt0noUdrmytsjvvtHB/2eQ3kV+OcxndYfC4Wgn1n7SvNej9pSh99N9+x9rl30duFsO1LMs3znMZL7FH6rgKEu/NBUsTWs/7mJi13dve8i1745fFbxEHS+8aatbQvkGDR2h0OLYesbHSIrSWVCOCJ5JCwOHLAfN4mJ4izrFXVTH1oRf2aHLh1bt+55JNf4pS/Cx+h5V4W8A5NyywvDWX1qkdVWzGNTNJ8386WYTxNOEluvZxpqL1jZ6nls9xcXUz3F1PNczytuknnkeaaRv7zySFndvckmvGlOU5OU5SnJ6uUpOUn6t6v5/5n3dKjRw9ONGhSp0aUFaFKlCNOnBdowgoxivJJENSaBQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAf//Z"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("image", {
                        id: "image2",
                        width: "400",
                        height: "400",
                        xlinkHref: "data:image/jpeg;base64,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"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("image", {
                        id: "image3",
                        width: "400",
                        height: "400",
                        xlinkHref: "data:image/jpeg;base64,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"
                    })
                ]
            })
        ]
    });
};
var $a0efbc9ff5a6ae53$export$2e2bcd8739ae039 = $a0efbc9ff5a6ae53$var$Meeple;





const $4b5125767abe228a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    AdminEmptyStateMessage: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.empty-state.admin-empty-state-message",
        defaultMessage: "Add manager information in your identity provider, and show a tree of manager and direct reports on profiles"
    },
    UserEmptyStateMessage: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.empty-state.user-empty-state-message",
        defaultMessage: "Ask your admin to connect manager information to Atlassian, and see manager and direct reports on profiles"
    },
    EmptyStateHeading: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.empty-state.heading",
        defaultMessage: "See manager and direct reports"
    },
    infoButton: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.empty-state.info-button",
        defaultMessage: "Learn more"
    }
});











parcelRequire("cozmU");




const $9e5d55acf324d0f7$var$styles = {
    reportingLinesEmptyStateContainer: "_3iDTPbQ4SZ _0aFT5v1qpb _3TGfC9HnLE _37wbyuxEoi _39xV02N91d _0Of8r2p0Oa _1ZnuxbkG2W _1wydGWp0Oa _2Zuz6QkG2W",
    reportingLinesEmptyStateContent: "_3138428HPE _1DCdHi8HPE",
    reportingLinesEmptyStateImage: "_3138428HPE _1DCdHi8HPE",
    reportingLinesEmptyStateHeading: "_2sNsIgWSk4",
    infoMessage: "_1DCdHikG2W"
};
const $9e5d55acf324d0f7$export$a0818fc67d4dc53a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $9e5d55acf324d0f7$var$styles.reportingLinesEmptyStateContainer,
            testId: testId,
            children: children
        });
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $9e5d55acf324d0f7$var$styles.reportingLinesEmptyStateContainer,
        testId: testId,
        children: children
    });
};
const $9e5d55acf324d0f7$export$51e90905745eccda = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $9e5d55acf324d0f7$var$styles.reportingLinesEmptyStateContent,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $9e5d55acf324d0f7$var$styles.reportingLinesEmptyStateContent,
        children: children
    });
};
const $9e5d55acf324d0f7$export$4bf8682ab34d3383 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $9e5d55acf324d0f7$var$styles.infoMessage,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $9e5d55acf324d0f7$var$styles.infoMessage,
        children: children
    });
};


const $6a212d8c614923e3$var$ATLAS_CCP_ID = (0, $6AG3B.SURFACE_ANALYTICS_PRODUCT_MAP).products.townsquare;
const $6a212d8c614923e3$var$MeepleOrgChartSvg = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a0efbc9ff5a6ae53$export$2e2bcd8739ae039), {});
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a0efbc9ff5a6ae53$export$2e2bcd8739ae039), {});
};
const $6a212d8c614923e3$var$getInfoMessage = (isAdmin)=>isAdmin ? (0, $4b5125767abe228a$export$defe85febe8b728c).AdminEmptyStateMessage : (0, $4b5125767abe228a$export$defe85febe8b728c).UserEmptyStateMessage;
const $6a212d8c614923e3$export$9c6fadd3e9548a03 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(16);
    const [t0] = (0, $4MoGw.usePrincipalUser)();
    const { isSiteAdmin: isSiteAdmin } = t0;
    const { fireViewedUIEvent: fireViewedUIEvent } = (0, $b5YqG.useFireCrossFlowAnalyticsEvents)();
    const analytics = (0, $p4wJt.default)();
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const [teamCentralStore] = (0, $65ENq.useTeamCentralStore)();
    const { getActiveWorkspaceId: getActiveWorkspaceId } = teamCentralStore.teamCentralHandlers;
    const { product: t1 } = (0, $344277174d1dbd8f$export$f1dff4eb3ba8d70b)();
    const product = t1 === undefined ? "" : t1;
    let t2;
    if ($[0] !== getActiveWorkspaceId) {
        t2 = getActiveWorkspaceId ? getActiveWorkspaceId() : null;
        $[0] = getActiveWorkspaceId;
        $[1] = t2;
    } else t2 = $[1];
    const workspaceUuid = t2;
    let t3;
    let t4;
    if ($[2] !== analytics || $[3] !== fireEvent || $[4] !== fireViewedUIEvent || $[5] !== isSiteAdmin || $[6] !== product || $[7] !== workspaceUuid) {
        t3 = ()=>{
            if ((0, $iDrrr.fg)("ptc-enable-ptc-common-analytics-refactor")) fireEvent("ui.ReportingLinesEmptyState.viewed", {
                isAdmin: isSiteAdmin,
                product: product,
                workspaceUuid: workspaceUuid
            });
            else analytics.pushUIEvent({
                source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
                actionSubject: "ReportingLinesEmptyState",
                action: (0, $56jml.AnalyticsEventActions).VIEWED,
                tags: [
                    "watermelon"
                ],
                attributes: {
                    isAdmin: isSiteAdmin,
                    product: product,
                    workspaceUuid: workspaceUuid
                }
            });
            fireViewedUIEvent({
                action: "viewed",
                actionSubject: "section",
                actionSubjectId: "reportingLinesEmptyState"
            }, {
                source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
                recommendedProductIds: [
                    $6a212d8c614923e3$var$ATLAS_CCP_ID
                ]
            });
        };
        t4 = [
            analytics,
            isSiteAdmin,
            product,
            workspaceUuid,
            fireViewedUIEvent,
            fireEvent
        ];
        $[2] = analytics;
        $[3] = fireEvent;
        $[4] = fireViewedUIEvent;
        $[5] = isSiteAdmin;
        $[6] = product;
        $[7] = workspaceUuid;
        $[8] = t3;
        $[9] = t4;
    } else {
        t3 = $[8];
        t4 = $[9];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($6a212d8c614923e3$var$MeepleOrgChartSvg, {});
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
            size: "small",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $4b5125767abe228a$export$defe85febe8b728c).EmptyStateHeading
            })
        });
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== isSiteAdmin) {
        t7 = $6a212d8c614923e3$var$getInfoMessage(isSiteAdmin);
        $[12] = isSiteAdmin;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)($9e5d55acf324d0f7$export$a0818fc67d4dc53a, {
            testId: "reporting-lines-empty-state",
            children: [
                t5,
                /*#__PURE__*/ (0, $8aG6j.jsxs)($9e5d55acf324d0f7$export$51e90905745eccda, {
                    children: [
                        t6,
                        /*#__PURE__*/ (0, $8aG6j.jsx)($9e5d55acf324d0f7$export$4bf8682ab34d3383, {
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                as: "p",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                    ...t7
                                })
                            })
                        })
                    ]
                })
            ]
        });
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ()=>{
    const [{ isSiteAdmin: isSiteAdmin }] = (0, $4MoGw.usePrincipalUser)();
    const { fireViewedUIEvent: fireViewedUIEvent } = (0, $b5YqG.useFireCrossFlowAnalyticsEvents)();
    const analytics = (0, $p4wJt.default)();
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const [teamCentralStore] = (0, $65ENq.useTeamCentralStore)();
    const { getActiveWorkspaceId: getActiveWorkspaceId } = teamCentralStore.teamCentralHandlers;
    const { product: product = '' } = (0, $344277174d1dbd8f$export$f1dff4eb3ba8d70b)();
    const workspaceUuid = getActiveWorkspaceId ? getActiveWorkspaceId() : null;
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('ptc-enable-ptc-common-analytics-refactor')) fireEvent('ui.ReportingLinesEmptyState.viewed', {
            isAdmin: isSiteAdmin,
            product: product,
            workspaceUuid: workspaceUuid
        });
        else analytics.pushUIEvent({
            source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'ReportingLinesEmptyState',
            action: (0, $56jml.AnalyticsEventActions).VIEWED,
            tags: [
                'watermelon'
            ],
            attributes: {
                isAdmin: isSiteAdmin,
                product: product,
                workspaceUuid: workspaceUuid
            }
        });
        // UCIA viewed event
        fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'reportingLinesEmptyState'
        }, {
            source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
            recommendedProductIds: [
                $6a212d8c614923e3$var$ATLAS_CCP_ID
            ]
        });
    }, [
        analytics,
        isSiteAdmin,
        product,
        workspaceUuid,
        fireViewedUIEvent,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)($9e5d55acf324d0f7$export$a0818fc67d4dc53a, {
        testId: "reporting-lines-empty-state",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)($6a212d8c614923e3$var$MeepleOrgChartSvg, {}),
            /*#__PURE__*/ (0, $8aG6j.jsxs)($9e5d55acf324d0f7$export$51e90905745eccda, {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                        size: "small",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...(0, $4b5125767abe228a$export$defe85febe8b728c).EmptyStateHeading
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)($9e5d55acf324d0f7$export$4bf8682ab34d3383, {
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                            as: "p",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                                ...$6a212d8c614923e3$var$getInfoMessage(isSiteAdmin)
                            })
                        })
                    })
                ]
            })
        ]
    });
};











parcelRequire("cozmU");








var $RfroO = parcelRequire("RfroO");

var $626698413d05aef4$exports = {};
$626698413d05aef4$exports = new URL("error-state-image.823f6961.png", import.meta.url).toString();





const $cbb1f901421e46c8$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ErrorStateHeading: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.error-state.heading",
        defaultMessage: "We couldn't load hierarchy"
    },
    ErrorStateMessage: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.error-state.message",
        defaultMessage: "We are having some trouble loading the hierarchy chart. Wait a few moments, then try again."
    },
    RefreshButton: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.error-state.retry-button",
        defaultMessage: "Refresh Page"
    }
});











parcelRequire("cozmU");




const $8c370146a801dbe4$var$styles = {
    errorStateContainer: "_2mHwu8NHnM _39xV02z1uA _0jFU0VKcgA _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _1YKVNs7dHp _0Of8r2p0Oa _1Znuxbp0Oa _1wydGWp0Oa _2Zuz6Qp0Oa"
};
const $8c370146a801dbe4$export$3c552bcab5076086 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $8c370146a801dbe4$var$styles.errorStateContainer,
            testId: testId,
            children: children
        });
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $8c370146a801dbe4$var$styles.errorStateContainer,
        testId: testId,
        children: children
    });
};


const $c7e1da51e229a2be$export$3ba0415b75d5e3a9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($8c370146a801dbe4$export$3c552bcab5076086, {
            testId: "reporting-lines-error-state",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $RfroO.default), {
                header: (0, $cbb1f901421e46c8$export$defe85febe8b728c).ErrorStateHeading.defaultMessage,
                description: (0, $cbb1f901421e46c8$export$defe85febe8b728c).ErrorStateMessage.defaultMessage,
                headingLevel: 2,
                primaryAction: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                    appearance: "primary",
                    onClick: $c7e1da51e229a2be$var$_temp,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $cbb1f901421e46c8$export$defe85febe8b728c).RefreshButton
                    })
                }),
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($626698413d05aef4$exports)))
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($8c370146a801dbe4$export$3c552bcab5076086, {
        testId: "reporting-lines-error-state",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $RfroO.default), {
            header: (0, $cbb1f901421e46c8$export$defe85febe8b728c).ErrorStateHeading.defaultMessage,
            description: (0, $cbb1f901421e46c8$export$defe85febe8b728c).ErrorStateMessage.defaultMessage,
            headingLevel: 2,
            primaryAction: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                appearance: "primary",
                onClick: ()=>window.location.reload(),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $cbb1f901421e46c8$export$defe85febe8b728c).RefreshButton
                })
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($626698413d05aef4$exports)))
        })
    });
};
function $c7e1da51e229a2be$var$_temp() {
    return window.location.reload();
}


















var $jAG9k = parcelRequire("jAG9k");

























parcelRequire("cozmU");

















var $bcDqz = parcelRequire("bcDqz");













const $4b431c7d7a808e8b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    MissingProfileName: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.missing-profile-name",
        defaultMessage: "{numMissingProfiles, plural, one {Missing profile} other {{numMissingProfiles} missing profiles}}"
    },
    MissingProfileTooltip: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.missing-profile-name-tooltip",
        defaultMessage: "{name} (Looks like {numMissingProfiles, plural, one {that person doesn\u2019t} other {these people don\u2019t}} have an Atlassian account. Ask an admin to add them.)"
    },
    OverflowAvatarStackMore: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.overflow-avatar-stack-more",
        defaultMessage: "{numUsers} more"
    },
    OverflowAvatarStackShowMore: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.overflow-avatar-stack-show-more",
        defaultMessage: "Show {numUsers} more"
    },
    MissingProfileTooltipGuide: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.missing-profile-name-tooltip-guide",
        defaultMessage: "Read our guide to fixing this"
    },
    DirectReportCountBadgeTooltip: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.direct-report-count-badge-tooltip",
        defaultMessage: "{directReportCount, plural, one {{directReportCount} direct report} other {{directReportCount} direct reports}}"
    },
    TotalReportCountBadgeTooltip: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.total-report-count-badge-tooltip-1",
        defaultMessage: "{totalReportCount, plural, one {{totalReportCount} report} other {{totalReportCount} reports}}, {directReportBreakdownText}"
    },
    DirectReportBreakdownText: {
        id: "ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.total-report-count-badge-tooltip-2",
        defaultMessage: "{directReportCount, plural, one {{directReportCount} direct} other {{directReportCount} direct}}"
    },
    userSyncInfo: {
        id: "atlas.profile.reportring-lines.sync-time-info",
        defaultMessage: "Last updated {timestamp} ago"
    },
    userSyncDescription: {
        id: "atlas.profile.reportring-lines.sync-time-description-1",
        defaultMessage: "Looks like this information has not been updated since {timestamp}"
    },
    userSyncGuide: {
        id: "atlas.profile.reportring-lines.sync-guide",
        defaultMessage: "Read our guide to fixing this"
    }
});























var $hBYtq = parcelRequire("hBYtq");

const $4cfe77388eba4163$var$styles = {
    verticalChartLine: "_0bjKvDS5Zs _4f9mo4ogpp _3iDTPbvLZJ _39xV024Jdh _4kiQYASPN1 _1DCdHi2ADO",
    avatarItemContainer: "_1EqgXlGtpf _39xV02N91d",
    avatarItemText: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    subleText: "_1UtDYzZpcK",
    missingProfileText: "_2sNsIgmnOE _1UtDYzKGUX",
    managerAvatarStackWrapper: "_1EqgXlaVF6",
    reportsStackContainer: "_39xV02yt6F _0GwItXDIqT",
    tooltipContainer: "_1EqgXlQjzx",
    tooltipWrapper: "_0Of8r25zaO _1ZnuxbNHnM _1wydGW5zaO _2Zuz6QNHnM",
    reportingLinesChartCard: "_0bjKvDKTcp _1kk5Tku7m9 _3iDTPbQ4SZ _3TGfC9LRg7 _0hPCNLDIqT _37wbyuI7V3 _39xV02yt6F _1Znuxb5zaO _1DCdHi2ADO _1eOmH6KcZT",
    reportingLinesChartCardSelectedDEPRECATED: "_3hxITi6wH8 _3vBAKHnXvL _2V7sgO2M4S _0KLXruDMqu",
    reportingLinesChartCardSelected: "_3hxITi6wH8 _3vBAKHrzt2 _2V7sgO2M4S _0KLXruDMqu",
    reportingLinesChartCardDisabled: "_1YKVNsVx3j _0wOv4Qsyl5 _1pp6NdYbGa",
    reportingLinesChartCardHovered: "_0KLXruKcZT",
    reportsList: "_3iDTPbgBM8 _2iEGP2pjsQ _17lj8p5zaO _0pI6nMDIqT _39xV02N91d",
    reportsListReset: "_1LMyvKYbGa _2Zuz6QPgdg _313842Pgdg _1DCdHiPgdg",
    listItemReset: "_1LMyvKYbGa _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT",
    managerListReset: "_1LMyvKYbGa _2Zuz6QPgdg _313842Pgdg _1DCdHiPgdg _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT",
    missingProfileCardStyle: "_2sNsIgmnOE",
    avatarOverflowItem: "_1EqgXle9dk",
    overflowStackCard: "_0bjKvDKTcp _3iDTPbQ4SZ _3TGfC9LRg7 _0hPCNLDIqT _37wbyuchRC _0Of8r2gVvo _1ZnuxbgVvo _1wydGWgVvo _2Zuz6QgVvo _39xV02N91d _1DCdHi2ADO",
    overflowStackCardHovered: "_0wOv4Q7zJH",
    overflowStackMoreText: "_2XsHFM2ADO _0adFHs2ADO _4ouGXIdnbC _3iDTPbQ4SZ _3TGfC9LRg7 _0hPCNLDIqT",
    overflowStackUserName: "_4bt5LAnQyn _2WAcuGnQyn _1EqgXlaQBb _39HuIbz8Lp _1ANEUSLRg7",
    collapseButton: "_39xV02N91d _1wydGW1Y8M"
};
const $4cfe77388eba4163$export$64fc853735f5807c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4cfe77388eba4163$var$styles.verticalChartLine,
            backgroundColor: "color.background.neutral.hovered"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $4cfe77388eba4163$var$styles.verticalChartLine,
        backgroundColor: "color.background.neutral.hovered"
    });
};
const $4cfe77388eba4163$export$f130524a2351fcc4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4cfe77388eba4163$var$styles.avatarItemContainer,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $4cfe77388eba4163$var$styles.avatarItemContainer,
        children: children
    });
};
const $4cfe77388eba4163$export$8b24dcef5c218b28 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AvatarItemText(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { children: children, isSubtle: isSubtle } = t0;
    let t1;
    if ($[0] !== isSubtle) {
        t1 = isSubtle && (0, $iDrrr.fg)("ptc-fix-a11y-reporting-lines-title-contrast") && $4cfe77388eba4163$var$styles.subleText;
        $[0] = isSubtle;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = (0, $w6R6I.cx)($4cfe77388eba4163$var$styles.avatarItemText, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== children || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t2,
            children: children
        });
        $[4] = children;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : function AvatarItemText({ children: children, isSubtle: isSubtle }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($4cfe77388eba4163$var$styles.avatarItemText, isSubtle && (0, $iDrrr.fg)('ptc-fix-a11y-reporting-lines-title-contrast') && $4cfe77388eba4163$var$styles.subleText),
        children: children
    });
};
const $4cfe77388eba4163$export$d1ff5a3f04d2a60c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4cfe77388eba4163$var$styles.missingProfileText,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $4cfe77388eba4163$var$styles.missingProfileText,
        children: children
    });
};
const $4cfe77388eba4163$export$4146f747f0017611 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4cfe77388eba4163$var$styles.managerAvatarStackWrapper,
            testId: testId,
            children: children
        });
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $4cfe77388eba4163$var$styles.managerAvatarStackWrapper,
        testId: testId,
        children: children
    });
};
const $4cfe77388eba4163$export$57d2503ddb05403d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4cfe77388eba4163$var$styles.reportsStackContainer,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $4cfe77388eba4163$var$styles.reportsStackContainer,
        children: children
    });
};
const $4cfe77388eba4163$export$44ec04c6081e3a25 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur } = t0;
    let t1;
    if ($[0] !== children || $[1] !== onBlur || $[2] !== onFocus || $[3] !== onMouseEnter || $[4] !== onMouseLeave) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4cfe77388eba4163$var$styles.tooltipContainer,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onFocus: onFocus,
            onBlur: onBlur,
            children: children
        });
        $[0] = children;
        $[1] = onBlur;
        $[2] = onFocus;
        $[3] = onMouseEnter;
        $[4] = onMouseLeave;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ children: children, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $4cfe77388eba4163$var$styles.tooltipContainer,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        children: children
    });
};
const $4cfe77388eba4163$export$57a09c4864b20b90 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4cfe77388eba4163$var$styles.tooltipWrapper,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $4cfe77388eba4163$var$styles.tooltipWrapper,
        children: children
    });
};
const $4cfe77388eba4163$export$683f3dd0a3fb1df5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children, selected: selected, disabled: disabled, testId: testId, onClick: onClick, ariaLabel: ariaLabel } = t0;
    const [hovered, setHovered] = (0, $cozmU.useState)(false);
    const t1 = selected && ((0, $iDrrr.fg)("enable_teams_t26_design_drop_core_experiences") ? $4cfe77388eba4163$var$styles.reportingLinesChartCardSelected : $4cfe77388eba4163$var$styles.reportingLinesChartCardSelectedDEPRECATED);
    const t2 = disabled && $4cfe77388eba4163$var$styles.reportingLinesChartCardDisabled;
    const t3 = hovered && $4cfe77388eba4163$var$styles.reportingLinesChartCardHovered;
    let t4;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3) {
        t4 = (0, $w6R6I.cx)($4cfe77388eba4163$var$styles.reportingLinesChartCard, t1, t2, t3);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>setHovered(true);
        t6 = ()=>setHovered(false);
        $[4] = t5;
        $[5] = t6;
    } else {
        t5 = $[4];
        t6 = $[5];
    }
    let t7;
    if ($[6] !== ariaLabel || $[7] !== children || $[8] !== onClick || $[9] !== t4 || $[10] !== testId) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            xcss: t4,
            onMouseEnter: t5,
            onMouseLeave: t6,
            testId: testId,
            onClick: onClick,
            "aria-label": ariaLabel,
            children: children
        });
        $[6] = ariaLabel;
        $[7] = children;
        $[8] = onClick;
        $[9] = t4;
        $[10] = testId;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : ({ children: children, selected: selected, disabled: disabled, testId: testId, onClick: onClick, ariaLabel: ariaLabel })=>{
    const [hovered, setHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($4cfe77388eba4163$var$styles.reportingLinesChartCard, selected && ((0, $iDrrr.fg)('enable_teams_t26_design_drop_core_experiences') ? $4cfe77388eba4163$var$styles.reportingLinesChartCardSelected : $4cfe77388eba4163$var$styles.reportingLinesChartCardSelectedDEPRECATED), disabled && $4cfe77388eba4163$var$styles.reportingLinesChartCardDisabled, hovered && $4cfe77388eba4163$var$styles.reportingLinesChartCardHovered),
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        testId: testId,
        onClick: onClick,
        "aria-label": ariaLabel,
        children: children
    });
};
const $4cfe77388eba4163$export$f834f589d68e6a22 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, testId: testId } = t0;
    let T0;
    let t1;
    let useUl;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        useUl = (0, $iDrrr.fg)("ptc-fix-a11y-reporting-lines-unordered-list");
        T0 = (0, $iMnC5.Box);
        t1 = (0, $w6R6I.cx)($4cfe77388eba4163$var$styles.reportsList, useUl && $4cfe77388eba4163$var$styles.reportsListReset);
        $[0] = T0;
        $[1] = t1;
        $[2] = useUl;
    } else {
        T0 = $[0];
        t1 = $[1];
        useUl = $[2];
    }
    let t2;
    if ($[3] !== children || $[4] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)(T0, {
            xcss: t1,
            testId: testId,
            as: useUl ? "ul" : undefined,
            children: children
        });
        $[3] = children;
        $[4] = testId;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children, testId: testId })=>{
    const useUl = (0, $iDrrr.fg)('ptc-fix-a11y-reporting-lines-unordered-list');
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($4cfe77388eba4163$var$styles.reportsList, useUl && $4cfe77388eba4163$var$styles.reportsListReset),
        testId: testId,
        as: useUl ? 'ul' : undefined,
        children: children
    });
};
const $4cfe77388eba4163$export$19f41810b733bcb3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if (!(0, $iDrrr.fg)("ptc-fix-a11y-reporting-lines-unordered-list")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "li",
            xcss: $4cfe77388eba4163$var$styles.listItemReset,
            children: children
        });
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    if (!(0, $iDrrr.fg)('ptc-fix-a11y-reporting-lines-unordered-list')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "li",
        xcss: $4cfe77388eba4163$var$styles.listItemReset,
        children: children
    });
};
const $4cfe77388eba4163$export$292f5f8a1eddcae4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, testId: testId } = t0;
    if (!(0, $iDrrr.fg)("ptc-fix-a11y-reporting-lines-unordered-list")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children || $[3] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "ul",
            xcss: $4cfe77388eba4163$var$styles.managerListReset,
            testId: testId,
            children: children
        });
        $[2] = children;
        $[3] = testId;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children, testId: testId })=>{
    if (!(0, $iDrrr.fg)('ptc-fix-a11y-reporting-lines-unordered-list')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "ul",
        xcss: $4cfe77388eba4163$var$styles.managerListReset,
        testId: testId,
        children: children
    });
};
const $4cfe77388eba4163$export$5e7f2a862da97156 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4cfe77388eba4163$var$styles.missingProfileCardStyle,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $4cfe77388eba4163$var$styles.missingProfileCardStyle,
        children: children
    });
};
const $4cfe77388eba4163$export$e847974cabc7c868 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4cfe77388eba4163$var$styles.avatarOverflowItem,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $4cfe77388eba4163$var$styles.avatarOverflowItem,
        children: children
    });
};
const $4cfe77388eba4163$export$ded15394ccf5df7b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, onClick: onClick, onKeyDown: onKeyDown } = t0;
    const [hovered, setHovered] = (0, $cozmU.useState)(false);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setHovered(true);
        t2 = ()=>setHovered(false);
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    const t3 = hovered && $4cfe77388eba4163$var$styles.overflowStackCardHovered;
    let t4;
    if ($[2] !== t3) {
        t4 = (0, $w6R6I.cx)($4cfe77388eba4163$var$styles.overflowStackCard, t3);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== children || $[5] !== onClick || $[6] !== onKeyDown || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            role: "button",
            tabIndex: 0,
            onMouseEnter: t1,
            onMouseLeave: t2,
            xcss: t4,
            onClick: onClick,
            onKeyDown: onKeyDown,
            testId: "reporting-lines-overflow-stack-card",
            children: children
        });
        $[4] = children;
        $[5] = onClick;
        $[6] = onKeyDown;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ children: children, onClick: onClick, onKeyDown: onKeyDown })=>{
    const [hovered, setHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
        role: "button",
        tabIndex: 0,
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        xcss: (0, $w6R6I.cx)($4cfe77388eba4163$var$styles.overflowStackCard, hovered && $4cfe77388eba4163$var$styles.overflowStackCardHovered),
        onClick: onClick,
        onKeyDown: onKeyDown,
        testId: "reporting-lines-overflow-stack-card",
        children: children
    });
};
const $4cfe77388eba4163$export$c3ed9442ee4da190 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4cfe77388eba4163$var$styles.overflowStackMoreText,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $4cfe77388eba4163$var$styles.overflowStackMoreText,
        children: children
    });
};
const $4cfe77388eba4163$export$69071a5a8ad74d06 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4cfe77388eba4163$var$styles.overflowStackUserName,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $4cfe77388eba4163$var$styles.overflowStackUserName,
        children: children
    });
};
const $4cfe77388eba4163$export$deb7c4cf28fc4ed6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4cfe77388eba4163$var$styles.collapseButton,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $4cfe77388eba4163$var$styles.collapseButton,
        children: children
    });
};


/**
 * These are partial types for the reportingLines GQL request from Team Central.
 * Not all data that could be returned is defined here, just what we need.
 */ var $1f063063471d0b3c$export$18ad592781c19221 = /*#__PURE__*/ function(AccountIdentifierType) {
    AccountIdentifierType["ATLASSIAN_ID"] = "ATLASSIAN_ID";
    AccountIdentifierType["BASE64_HASH"] = "BASE64_HASH";
    AccountIdentifierType["UNKNOWN"] = "UNKNOWN";
    return AccountIdentifierType;
}({});


const $07730ec4880ef60f$var$styles = {
    avatarGroupContainer: "_1DCdHi2ADO"
};
const $07730ec4880ef60f$var$appendMissingProfileStackItemData = (avatarData, numMissingProfiles, intl)=>{
    if (numMissingProfiles === 0) return avatarData;
    const name = intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).MissingProfileName, {
        numMissingProfiles: numMissingProfiles
    });
    const label = intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).MissingProfileTooltip, {
        name: name,
        numMissingProfiles: numMissingProfiles
    });
    return avatarData.concat([
        {
            name: name,
            label: label,
            href: '#',
            // Required otherwise tooltip doesn't render
            isDisabled: true
        }
    ]);
};
const $07730ec4880ef60f$var$AVATAR_LIMIT = 6;
const $07730ec4880ef60f$var$AvatarGroupWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { allUserAvatarData: allUserAvatarData, avatarSize: avatarSize, onAvatarClick: onAvatarClick } = t0;
    let t1;
    if ($[0] !== onAvatarClick) {
        t1 = {
            Avatar: {
                render: (Component, props, index)=>props.isDisabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                        content: props.label,
                        children: /*#__PURE__*/ (0, $cozmU.createElement)(Component, {
                            ...props,
                            key: props.name,
                            isDisabled: false,
                            href: undefined,
                            onClick: (e)=>onAvatarClick(e, index)
                        })
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                        ...props,
                        href: undefined,
                        onClick: (e_0)=>onAvatarClick(e_0, index)
                    })
            }
        };
        $[0] = onAvatarClick;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== allUserAvatarData || $[3] !== avatarSize || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $07730ec4880ef60f$var$styles.avatarGroupContainer,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bcDqz.default), {
                appearance: "stack",
                data: allUserAvatarData,
                maxCount: $07730ec4880ef60f$var$AVATAR_LIMIT,
                size: avatarSize,
                overrides: t1
            })
        });
        $[2] = allUserAvatarData;
        $[3] = avatarSize;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ allUserAvatarData: allUserAvatarData, avatarSize: avatarSize, onAvatarClick: onAvatarClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $07730ec4880ef60f$var$styles.avatarGroupContainer,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bcDqz.default), {
            appearance: "stack",
            data: allUserAvatarData,
            maxCount: $07730ec4880ef60f$var$AVATAR_LIMIT,
            size: avatarSize,
            overrides: {
                Avatar: {
                    // Adds tooltips on missing profile icon, ensures it shows up (by saying its not disabled)
                    render: (Component, props, index)=>{
                        return props.isDisabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                            content: props.label,
                            children: /*#__PURE__*/ (0, $cozmU.createElement)(Component, {
                                ...props,
                                key: props.name,
                                isDisabled: false,
                                href: undefined,
                                onClick: (e)=>onAvatarClick(e, index)
                            })
                        }) : /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                            ...props,
                            href: undefined,
                            onClick: (e_0)=>onAvatarClick(e_0, index)
                        });
                    }
                }
            }
        })
    });
const $07730ec4880ef60f$export$ba929152c036bdb5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { atlassianUsers: atlassianUsers, numFilteredMissingProfiles: numFilteredMissingProfiles, avatarSize: avatarSize, includeNameInMoreText: t1, onClick: onStackClick } = t0;
    const includeNameInMoreText = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const [, t2] = (0, $aeecbceb6b802fef$export$fa989b0eaa9784de)();
    const { selectUser: selectUser } = t2;
    let t3;
    if ($[0] !== atlassianUsers || $[1] !== intl || $[2] !== numFilteredMissingProfiles) {
        const avatarsToShow = atlassianUsers.slice(0, $07730ec4880ef60f$var$AVATAR_LIMIT);
        let t4;
        if ($[4] !== intl) {
            t4 = (user)=>{
                const isNotMissingProfile = !!user.pii?.name;
                const name = user.pii?.name ?? intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).MissingProfileName, {
                    numMissingProfiles: 1
                });
                const jobTitle = user.pii?.extendedProfile?.jobTitle ?? undefined;
                const label = isNotMissingProfile ? `${name}${jobTitle ? ` (${jobTitle})` : ""}` : intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).MissingProfileTooltip, {
                    name: name,
                    numMissingProfiles: 1
                });
                return {
                    name: name,
                    src: user.pii?.picture ?? undefined,
                    href: user.identifierType === (0, $1f063063471d0b3c$export$18ad592781c19221).ATLASSIAN_ID && user.accountIdentifier || undefined,
                    label: label
                };
            };
            $[4] = intl;
            $[5] = t4;
        } else t4 = $[5];
        const atlassianUsersAvatarGroupData = avatarsToShow.map(t4);
        t3 = atlassianUsersAvatarGroupData.length < $07730ec4880ef60f$var$AVATAR_LIMIT ? $07730ec4880ef60f$var$appendMissingProfileStackItemData(atlassianUsersAvatarGroupData, numFilteredMissingProfiles, intl) : atlassianUsersAvatarGroupData;
        $[0] = atlassianUsers;
        $[1] = intl;
        $[2] = numFilteredMissingProfiles;
        $[3] = t3;
    } else t3 = $[3];
    const allUserAvatarData = t3;
    let t4;
    if ($[6] !== atlassianUsers || $[7] !== selectUser) {
        t4 = (e, index)=>{
            e.stopPropagation();
            e.preventDefault();
            const identifier = atlassianUsers[index]?.accountIdentifier;
            if (identifier) selectUser(identifier);
        };
        $[6] = atlassianUsers;
        $[7] = selectUser;
        $[8] = t4;
    } else t4 = $[8];
    const onAvatarClick = t4;
    const numUsers = atlassianUsers.length + numFilteredMissingProfiles;
    let t5;
    if ($[9] !== allUserAvatarData || $[10] !== avatarSize || $[11] !== onAvatarClick) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($07730ec4880ef60f$var$AvatarGroupWrapper, {
            allUserAvatarData: allUserAvatarData,
            avatarSize: avatarSize,
            onAvatarClick: onAvatarClick
        });
        $[9] = allUserAvatarData;
        $[10] = avatarSize;
        $[11] = onAvatarClick;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== onStackClick) {
        t6 = (t7)=>{
            const { key: key } = t7;
            if (key === "Enter" || key === " ") onStackClick();
        };
        $[13] = onStackClick;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== includeNameInMoreText || $[16] !== intl || $[17] !== numUsers) {
        t7 = intl.formatMessage(includeNameInMoreText ? (0, $4b431c7d7a808e8b$export$defe85febe8b728c).OverflowAvatarStackShowMore : (0, $4b431c7d7a808e8b$export$defe85febe8b728c).OverflowAvatarStackMore, {
            numUsers: numUsers
        });
        $[15] = includeNameInMoreText;
        $[16] = intl;
        $[17] = numUsers;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$c3ed9442ee4da190, {
            children: t7
        });
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== onStackClick || $[22] !== t6 || $[23] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$ded15394ccf5df7b, {
            onClick: onStackClick,
            onKeyDown: t6,
            children: t8
        });
        $[21] = onStackClick;
        $[22] = t6;
        $[23] = t8;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== t5 || $[26] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "center",
            children: [
                t5,
                t9
            ]
        });
        $[25] = t5;
        $[26] = t9;
        $[27] = t10;
    } else t10 = $[27];
    return t10;
} : ({ atlassianUsers: atlassianUsers, numFilteredMissingProfiles: numFilteredMissingProfiles, avatarSize: avatarSize, includeNameInMoreText: includeNameInMoreText = false, onClick: onStackClick })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [, { selectUser: selectUser }] = (0, $aeecbceb6b802fef$export$fa989b0eaa9784de)();
    const avatarsToShow = atlassianUsers.slice(0, $07730ec4880ef60f$var$AVATAR_LIMIT);
    const atlassianUsersAvatarGroupData = avatarsToShow.map((user)=>{
        const isNotMissingProfile = !!user.pii?.name;
        const name = user.pii?.name ?? intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).MissingProfileName, {
            numMissingProfiles: 1
        });
        const jobTitle = user.pii?.extendedProfile?.jobTitle ?? undefined;
        const label = isNotMissingProfile ? `${name}${jobTitle ? ` (${jobTitle})` : ''}` : intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).MissingProfileTooltip, {
            name: name,
            numMissingProfiles: 1
        });
        return {
            name: name,
            src: user.pii?.picture ?? undefined,
            href: user.identifierType === (0, $1f063063471d0b3c$export$18ad592781c19221).ATLASSIAN_ID && user.accountIdentifier || undefined,
            label: label
        };
    }); // Append an avatar as a placeholder for missing profiles when there is space to show it
    const allUserAvatarData = atlassianUsersAvatarGroupData.length < $07730ec4880ef60f$var$AVATAR_LIMIT ? $07730ec4880ef60f$var$appendMissingProfileStackItemData(atlassianUsersAvatarGroupData, numFilteredMissingProfiles, intl) : atlassianUsersAvatarGroupData;
    const onAvatarClick = (e, index)=>{
        e.stopPropagation();
        e.preventDefault();
        const identifier = atlassianUsers[index]?.accountIdentifier;
        if (identifier) selectUser(identifier);
    };
    const numUsers = atlassianUsers.length + numFilteredMissingProfiles;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "center",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)($07730ec4880ef60f$var$AvatarGroupWrapper, {
                allUserAvatarData: allUserAvatarData,
                avatarSize: avatarSize,
                onAvatarClick: onAvatarClick
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$ded15394ccf5df7b, {
                onClick: onStackClick,
                onKeyDown: ({ key: key })=>{
                    if (key === 'Enter' || key === ' ') onStackClick();
                },
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$c3ed9442ee4da190, {
                    children: intl.formatMessage(includeNameInMoreText ? (0, $4b431c7d7a808e8b$export$defe85febe8b728c).OverflowAvatarStackShowMore : (0, $4b431c7d7a808e8b$export$defe85febe8b728c).OverflowAvatarStackMore, {
                        numUsers: numUsers
                    })
                })
            })
        ]
    });
};

























var $jLnA6 = parcelRequire("jLnA6");


var $4bg4c = parcelRequire("4bg4c");


var $kyJuy = parcelRequire("kyJuy");





var $4n1IT = parcelRequire("4n1IT");








var $iXXww = parcelRequire("iXXww");
















const $ea34ae79f50bee81$var$textWithTooltip = (text)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: text,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$8b24dcef5c218b28, {
            children: text
        })
    });
};
const $ea34ae79f50bee81$var$AvatarItemContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$f130524a2351fcc4, {
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$f130524a2351fcc4, {
        children: children
    });
const $ea34ae79f50bee81$var$TotalReportsBadge = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl || $[1] !== props.isSelected || $[2] !== props.numberOfDirectReports || $[3] !== props.numberOfTotalReports) {
        t0 = props.numberOfTotalReports > 0 && props.numberOfDirectReports > 0 ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: props.numberOfTotalReports <= props.numberOfDirectReports ? intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).DirectReportCountBadgeTooltip, {
                directReportCount: intl.formatNumber(props.numberOfDirectReports)
            }) : intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).TotalReportCountBadgeTooltip, {
                totalReportCount: intl.formatNumber(props.numberOfTotalReports),
                directReportBreakdownText: intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).DirectReportBreakdownText, {
                    directReportCount: intl.formatNumber(props.numberOfDirectReports)
                })
            }),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jLnA6.default), {
                appearance: props.isSelected ? "informationBold" : "neutral",
                max: 99999,
                children: props.numberOfTotalReports
            })
        }) : null;
        $[0] = intl;
        $[1] = props.isSelected;
        $[2] = props.numberOfDirectReports;
        $[3] = props.numberOfTotalReports;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : (props)=>{
    const intl = (0, $kSwu1.useIntl)();
    return props.numberOfTotalReports > 0 && props.numberOfDirectReports > 0 ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: props.numberOfTotalReports <= props.numberOfDirectReports ? intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).DirectReportCountBadgeTooltip, {
            directReportCount: intl.formatNumber(props.numberOfDirectReports)
        }) : intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).TotalReportCountBadgeTooltip, {
            totalReportCount: intl.formatNumber(props.numberOfTotalReports),
            directReportBreakdownText: intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).DirectReportBreakdownText, {
                directReportCount: intl.formatNumber(props.numberOfDirectReports)
            })
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jLnA6.default), {
            appearance: props.isSelected ? 'informationBold' : 'neutral',
            max: 99999,
            children: props.numberOfTotalReports
        })
    }) : null;
};
const $ea34ae79f50bee81$export$4780341a98005419 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(7);
    const { WrappedWithProfilecard: WrappedWithProfilecard, selectedCardRef: selectedCardRef } = (0, $344277174d1dbd8f$export$f1dff4eb3ba8d70b)();
    const userAaid = props?.user?.accountIdentifier;
    let t0;
    if ($[0] !== WrappedWithProfilecard || $[1] !== props || $[2] !== userAaid) {
        t0 = userAaid && WrappedWithProfilecard ? /*#__PURE__*/ (0, $8aG6j.jsx)(WrappedWithProfilecard, {
            userId: userAaid,
            position: "right",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($ea34ae79f50bee81$var$ReportingLinesUserContent, {
                ...props
            })
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": props.testId,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($ea34ae79f50bee81$var$ReportingLinesUserContent, {
                ...props
            })
        });
        $[0] = WrappedWithProfilecard;
        $[1] = props;
        $[2] = userAaid;
        $[3] = t0;
    } else t0 = $[3];
    const content = t0;
    if (props.selected && selectedCardRef) {
        let t1;
        if ($[4] !== content || $[5] !== selectedCardRef) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                ref: selectedCardRef,
                children: content
            });
            $[4] = content;
            $[5] = selectedCardRef;
            $[6] = t1;
        } else t1 = $[6];
        return t1;
    }
    return content;
} : (props)=>{
    const { WrappedWithProfilecard: WrappedWithProfilecard, selectedCardRef: selectedCardRef } = (0, $344277174d1dbd8f$export$f1dff4eb3ba8d70b)();
    const userAaid = props?.user?.accountIdentifier;
    const content = userAaid && WrappedWithProfilecard ? /*#__PURE__*/ (0, $8aG6j.jsx)(WrappedWithProfilecard, {
        userId: userAaid,
        position: "right",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($ea34ae79f50bee81$var$ReportingLinesUserContent, {
            ...props
        })
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": props.testId,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($ea34ae79f50bee81$var$ReportingLinesUserContent, {
            ...props
        })
    });
    if (props.selected && selectedCardRef) return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: selectedCardRef,
        children: content
    });
    return content;
};
const $ea34ae79f50bee81$var$ReportingLinesUserContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { user: user, selected: t1 } = t0;
    const selected = t1 === undefined ? false : t1;
    const analytics = (0, $p4wJt.default)();
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { product: t2 } = (0, $344277174d1dbd8f$export$f1dff4eb3ba8d70b)();
    const product = t2 === undefined ? "" : t2;
    const [teamCentralStore] = (0, $65ENq.useTeamCentralStore)();
    const [, t3] = (0, $aeecbceb6b802fef$export$fa989b0eaa9784de)();
    const { selectUser: selectUser } = t3;
    if (user.identifierType !== (0, $1f063063471d0b3c$export$18ad592781c19221).ATLASSIAN_ID || !user.pii?.name) {
        let t4;
        if ($[0] !== selected) {
            t4 = /*#__PURE__*/ (0, $8aG6j.jsx)($ea34ae79f50bee81$export$e7897f9670d3dd6e, {
                numMissingProfiles: 1,
                selected: selected,
                "data-testid": "missing-user-card"
            });
            $[0] = selected;
            $[1] = t4;
        } else t4 = $[1];
        return t4;
    }
    const { getActiveWorkspaceId: getActiveWorkspaceId } = teamCentralStore.teamCentralHandlers;
    let t4;
    if ($[2] !== getActiveWorkspaceId) {
        t4 = getActiveWorkspaceId ? getActiveWorkspaceId() : null;
        $[2] = getActiveWorkspaceId;
        $[3] = t4;
    } else t4 = $[3];
    const workspaceUuid = t4;
    const name = user.pii?.name ?? undefined;
    const picture = user.pii?.picture ?? undefined;
    const jobTitle = user.pii?.extendedProfile?.jobTitle;
    const label = `${name}${jobTitle ? ` (${jobTitle})` : ""}`;
    let t5;
    if ($[4] !== analytics || $[5] !== fireEvent || $[6] !== product || $[7] !== selectUser || $[8] !== user.accountIdentifier || $[9] !== workspaceUuid) {
        t5 = (e)=>{
            if ((0, $iDrrr.fg)("ptc-enable-ptc-common-analytics-refactor")) fireEvent("ui.ReportingLinesUserCard.clicked", {
                product: product,
                workspaceUuid: workspaceUuid
            });
            else analytics.pushUIEvent({
                source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
                actionSubject: "ReportingLinesUserCard",
                action: (0, $56jml.AnalyticsEventActions).CLICKED,
                tags: [
                    "watermelon"
                ],
                attributes: {
                    product: product,
                    workspaceUuid: workspaceUuid
                }
            });
            e.preventDefault();
            if (user.accountIdentifier) selectUser(user.accountIdentifier);
            return false;
        };
        $[4] = analytics;
        $[5] = fireEvent;
        $[6] = product;
        $[7] = selectUser;
        $[8] = user.accountIdentifier;
        $[9] = workspaceUuid;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== label || $[12] !== name || $[13] !== picture) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
            name: name,
            src: picture,
            label: label
        });
        $[11] = label;
        $[12] = name;
        $[13] = picture;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== name) {
        t7 = name && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$8b24dcef5c218b28, {
            children: name
        });
        $[15] = name;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== jobTitle) {
        t8 = jobTitle && ((0, $iDrrr.fg)("ptc-fix-a11y-reporting-lines-title-contrast") ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: jobTitle,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$8b24dcef5c218b28, {
                isSubtle: true,
                children: jobTitle
            })
        }) : $ea34ae79f50bee81$var$textWithTooltip(jobTitle));
        $[17] = jobTitle;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== label || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)($ea34ae79f50bee81$var$AvatarItemContainer, {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2QrXF.default), {
                avatar: t6,
                primaryText: t7,
                secondaryText: t8,
                label: label
            })
        });
        $[19] = label;
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== selected || $[25] !== user.numberOfDirectReports || $[26] !== user.numberOfTotalReports) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)($ea34ae79f50bee81$var$TotalReportsBadge, {
            numberOfDirectReports: user.numberOfDirectReports,
            numberOfTotalReports: user.numberOfTotalReports,
            isSelected: selected
        });
        $[24] = selected;
        $[25] = user.numberOfDirectReports;
        $[26] = user.numberOfTotalReports;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== selected || $[29] !== t10 || $[30] !== t5 || $[31] !== t9) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsxs)($4cfe77388eba4163$export$683f3dd0a3fb1df5, {
            selected: selected,
            onClick: t5,
            testId: "user-card",
            children: [
                t9,
                t10
            ]
        });
        $[28] = selected;
        $[29] = t10;
        $[30] = t5;
        $[31] = t9;
        $[32] = t11;
    } else t11 = $[32];
    return t11;
} : ({ user: user, selected: selected = false })=>{
    const analytics = (0, $p4wJt.default)();
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { product: product = '' } = (0, $344277174d1dbd8f$export$f1dff4eb3ba8d70b)();
    const [teamCentralStore] = (0, $65ENq.useTeamCentralStore)();
    const [, { selectUser: selectUser }] = (0, $aeecbceb6b802fef$export$fa989b0eaa9784de)();
    if (user.identifierType !== (0, $1f063063471d0b3c$export$18ad592781c19221).ATLASSIAN_ID || !user.pii?.name) return /*#__PURE__*/ (0, $8aG6j.jsx)($ea34ae79f50bee81$export$e7897f9670d3dd6e, {
        numMissingProfiles: 1,
        selected: selected,
        "data-testid": "missing-user-card"
    });
    const { getActiveWorkspaceId: getActiveWorkspaceId } = teamCentralStore.teamCentralHandlers;
    const workspaceUuid = getActiveWorkspaceId ? getActiveWorkspaceId() : null;
    const name = user.pii?.name ?? undefined;
    const picture = user.pii?.picture ?? undefined;
    const jobTitle = user.pii?.extendedProfile?.jobTitle;
    const label = `${name}${jobTitle ? ` (${jobTitle})` : ''}`;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)($4cfe77388eba4163$export$683f3dd0a3fb1df5, {
        selected: selected,
        onClick: (e)=>{
            if ((0, $iDrrr.fg)('ptc-enable-ptc-common-analytics-refactor')) fireEvent('ui.ReportingLinesUserCard.clicked', {
                product: product,
                workspaceUuid: workspaceUuid
            });
            else analytics.pushUIEvent({
                source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
                actionSubject: 'ReportingLinesUserCard',
                action: (0, $56jml.AnalyticsEventActions).CLICKED,
                tags: [
                    'watermelon'
                ],
                attributes: {
                    product: product,
                    workspaceUuid: workspaceUuid
                }
            });
            e.preventDefault();
            if (user.accountIdentifier) selectUser(user.accountIdentifier);
            return false;
        },
        testId: "user-card",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)($ea34ae79f50bee81$var$AvatarItemContainer, {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2QrXF.default), {
                    avatar: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                        name: name,
                        src: picture,
                        label: label
                    }),
                    primaryText: name && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$8b24dcef5c218b28, {
                        children: name
                    }),
                    secondaryText: jobTitle && ((0, $iDrrr.fg)('ptc-fix-a11y-reporting-lines-title-contrast') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                        content: jobTitle,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$8b24dcef5c218b28, {
                            isSubtle: true,
                            children: jobTitle
                        })
                    }) : $ea34ae79f50bee81$var$textWithTooltip(jobTitle)),
                    label: label
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($ea34ae79f50bee81$var$TotalReportsBadge, {
                numberOfDirectReports: user.numberOfDirectReports,
                numberOfTotalReports: user.numberOfTotalReports,
                isSelected: selected
            })
        ]
    });
};
const $ea34ae79f50bee81$export$e7897f9670d3dd6e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { numMissingProfiles: numMissingProfiles, selected: t1, testId: testId } = t0;
    const selected = t1 === undefined ? false : t1;
    const [isHoveringCard, setIsHoveringCard] = (0, $cozmU.useState)(false);
    const [isHoveringTooltip, setIsHoveringTooltip] = (0, $cozmU.useState)(false);
    const intl = (0, $kSwu1.useIntl)();
    let name;
    let t2;
    if ($[0] !== intl || $[1] !== numMissingProfiles) {
        name = intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).MissingProfileName, {
            numMissingProfiles: numMissingProfiles
        });
        t2 = intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).MissingProfileTooltip, {
            name: name,
            numMissingProfiles: numMissingProfiles
        });
        $[0] = intl;
        $[1] = numMissingProfiles;
        $[2] = name;
        $[3] = t2;
    } else {
        name = $[2];
        t2 = $[3];
    }
    const helpText = t2;
    let t3;
    if ($[4] !== intl) {
        t3 = intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).MissingProfileTooltipGuide);
        $[4] = intl;
        $[5] = t3;
    } else t3 = $[5];
    const helpLink = t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setIsHoveringTooltip(true);
        t5 = ()=>setIsHoveringTooltip(false);
        t6 = ()=>setIsHoveringTooltip(true);
        t7 = ()=>setIsHoveringTooltip(false);
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
        $[9] = t7;
    } else {
        t4 = $[6];
        t5 = $[7];
        t6 = $[8];
        t7 = $[9];
    }
    let t8;
    if ($[10] !== helpText) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            as: "p",
            children: helpText
        });
        $[10] = helpText;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== helpLink) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4bg4c))), {
            spacing: "spacious",
            color: "currentColor",
            label: helpLink
        });
        $[12] = helpLink;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== helpLink || $[15] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            as: "p",
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iXXww.TeamsLink), {
                href: "https://intercom.help/atlas-by-atlassian/en/articles/5572925-how-to-sync-the-manager-attribute-into-atlas#h_2e7f6754d1",
                intent: "reference",
                children: [
                    helpLink,
                    t9
                ]
            })
        });
        $[14] = helpLink;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== t10 || $[18] !== t8) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$57a09c4864b20b90, {
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)($4cfe77388eba4163$export$44ec04c6081e3a25, {
                onMouseEnter: t4,
                onMouseLeave: t5,
                onFocus: t6,
                onBlur: t7,
                children: [
                    t8,
                    t10
                ]
            })
        });
        $[17] = t10;
        $[18] = t8;
        $[19] = t11;
    } else t11 = $[19];
    const tooltipContent = t11;
    let t12;
    if ($[20] !== tooltipContent) {
        t12 = ()=>tooltipContent;
        $[20] = tooltipContent;
        $[21] = t12;
    } else t12 = $[21];
    const t13 = isHoveringCard || isHoveringTooltip;
    let t14;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = ()=>{
            setIsHoveringCard(false);
            setIsHoveringTooltip(false);
        };
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== helpText || $[24] !== name || $[25] !== selected) {
        t15 = (triggerProps)=>{
            const { ref: ref, ...innerProps } = triggerProps;
            return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                ref: ref,
                ...innerProps,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)($4cfe77388eba4163$export$683f3dd0a3fb1df5, {
                    selected: selected,
                    disabled: true,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)($ea34ae79f50bee81$var$AvatarItemContainer, {
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2QrXF.default), {
                                avatar: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {}),
                                secondaryText: /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$5e7f2a862da97156, {
                                    children: name
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                            onMouseEnter: ()=>setIsHoveringCard(true),
                            onMouseLeave: ()=>setTimeout(()=>setIsHoveringCard(false), 500),
                            onFocus: ()=>{
                                setIsHoveringCard(true);
                            },
                            onBlur: ()=>{
                                setTimeout(()=>setIsHoveringCard(false), 500);
                            },
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))), {
                                label: helpText,
                                color: "var(--ds-icon-subtle, #505258)"
                            })
                        })
                    ]
                })
            });
        };
        $[23] = helpText;
        $[24] = name;
        $[25] = selected;
        $[26] = t15;
    } else t15 = $[26];
    let t16;
    if ($[27] !== t12 || $[28] !== t13 || $[29] !== t15 || $[30] !== testId) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
            testId: testId,
            content: t12,
            isOpen: t13,
            placement: "bottom",
            onClose: t14,
            autoFocus: false,
            trigger: t15
        });
        $[27] = t12;
        $[28] = t13;
        $[29] = t15;
        $[30] = testId;
        $[31] = t16;
    } else t16 = $[31];
    return t16;
} : ({ numMissingProfiles: numMissingProfiles, selected: selected = false, testId: testId })=>{
    const [isHoveringCard, setIsHoveringCard] = (0, $cozmU.useState)(false);
    const [isHoveringTooltip, setIsHoveringTooltip] = (0, $cozmU.useState)(false);
    const intl = (0, $kSwu1.useIntl)();
    const name = intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).MissingProfileName, {
        numMissingProfiles: numMissingProfiles
    });
    const helpText = intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).MissingProfileTooltip, {
        name: name,
        numMissingProfiles: numMissingProfiles
    });
    const helpLink = intl.formatMessage((0, $4b431c7d7a808e8b$export$defe85febe8b728c).MissingProfileTooltipGuide);
    const tooltipContent = /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$57a09c4864b20b90, {
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)($4cfe77388eba4163$export$44ec04c6081e3a25, {
            onMouseEnter: ()=>setIsHoveringTooltip(true),
            onMouseLeave: ()=>setIsHoveringTooltip(false),
            onFocus: ()=>setIsHoveringTooltip(true),
            onBlur: ()=>setIsHoveringTooltip(false),
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    as: "p",
                    children: helpText
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    as: "p",
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iXXww.TeamsLink), {
                        href: "https://intercom.help/atlas-by-atlassian/en/articles/5572925-how-to-sync-the-manager-attribute-into-atlas#h_2e7f6754d1",
                        intent: "reference",
                        children: [
                            helpLink,
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4bg4c))), {
                                spacing: "spacious",
                                color: "currentColor",
                                label: helpLink
                            })
                        ]
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
        testId: testId,
        content: ()=>tooltipContent,
        isOpen: isHoveringCard || isHoveringTooltip,
        placement: "bottom",
        onClose: ()=>{
            setIsHoveringCard(false);
            setIsHoveringTooltip(false);
        },
        autoFocus: false,
        trigger: (triggerProps)=>{
            const { ref: ref, ...innerProps } = triggerProps;
            return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                ref: ref,
                ...innerProps,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)($4cfe77388eba4163$export$683f3dd0a3fb1df5, {
                    selected: selected,
                    disabled: true,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)($ea34ae79f50bee81$var$AvatarItemContainer, {
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2QrXF.default), {
                                avatar: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {}),
                                secondaryText: /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$5e7f2a862da97156, {
                                    children: name
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                            onMouseEnter: ()=>setIsHoveringCard(true),
                            onMouseLeave: ()=>setTimeout(()=>setIsHoveringCard(false), 500),
                            onFocus: ()=>{
                                setIsHoveringCard(true);
                            },
                            onBlur: ()=>{
                                setTimeout(()=>setIsHoveringCard(false), 500);
                            },
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))), {
                                label: helpText,
                                color: "var(--ds-icon-subtle, #505258)"
                            })
                        })
                    ]
                })
            });
        }
    });
};












parcelRequire("cozmU");



const $83edb761a189e14f$export$dd0d1e3398e34d39 = (user, testId)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ea34ae79f50bee81$export$4780341a98005419), {
        user: user,
        // this testid helps to query all different profile-cards and verify its order easily in test.
        testId: `profile-card${testId ? `-${testId}` : ''}`
    });
};
const $83edb761a189e14f$export$d32d64b5c85992da = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    const t0 = `profile-card${props.testId ? `-${props.testId}` : ""}`;
    let t1;
    if ($[0] !== props || $[1] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ea34ae79f50bee81$export$4780341a98005419), {
            ...props,
            testId: t0
        });
        $[0] = props;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$64fc853735f5807c, {});
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t1,
                t2
            ]
        });
        $[4] = t1;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ea34ae79f50bee81$export$4780341a98005419), {
                ...props,
                // this testid helps to query all different profile-cards and verify its order easily in test.
                testId: `profile-card${props.testId ? `-${props.testId}` : ''}`
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$64fc853735f5807c, {})
        ]
    });
};



const $7966fb0a15fc0c37$var$filterAtlassianProfiles = (accountList)=>{
    const atlassianUsers = accountList.filter((user)=>user.identifierType === (0, $1f063063471d0b3c$export$18ad592781c19221).ATLASSIAN_ID);
    return {
        atlassianUsers: atlassianUsers,
        numMissingProfiles: accountList.length - atlassianUsers.length
    };
};
const $7966fb0a15fc0c37$export$5f1b49a43933909d = (users, userCardSlotLimit)=>{
    const { atlassianUsers: atlassianUsers, numMissingProfiles: numMissingProfiles } = $7966fb0a15fc0c37$var$filterAtlassianProfiles(users);
    if (!userCardSlotLimit) return {
        usersForCards: atlassianUsers,
        numMissingProfiles: numMissingProfiles
    };
    const showAvatarStack = atlassianUsers.length + (numMissingProfiles > 0 ? 1 : 0) > userCardSlotLimit;
    const usersForCards = showAvatarStack ? atlassianUsers.slice(0, userCardSlotLimit - 1) : atlassianUsers;
    const usersForAvatarStack = showAvatarStack ? atlassianUsers.slice(userCardSlotLimit - 1) : undefined;
    return {
        usersForCards: usersForCards,
        usersForAvatarStack: usersForAvatarStack,
        numMissingProfiles: numMissingProfiles
    };
};


const $3103b06cdaca8fca$export$1e4a0ff7dd119586 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { selectedUser: selectedUser, directReports: directReports, showAvatarStack: showAvatarStack, toggleAvatarStack: toggleAvatarStack } = t0;
    let T0;
    let numMissingProfiles;
    let t1;
    let t2;
    let t3;
    let usersForAvatarStack;
    if ($[0] !== directReports || $[1] !== selectedUser || $[2] !== showAvatarStack) {
        const { usersForCards: usersForCards, usersForAvatarStack: t4, numMissingProfiles: t5 } = (0, $7966fb0a15fc0c37$export$5f1b49a43933909d)(directReports, showAvatarStack ? (0, $7b5437fb537dc20f$export$7eaed9d2dcd47ca2) : undefined);
        usersForAvatarStack = t4;
        numMissingProfiles = t5;
        if ($[9] !== selectedUser) {
            t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83edb761a189e14f$export$d32d64b5c85992da), {
                user: selectedUser,
                selected: true,
                testId: "selected-user-card"
            });
            $[9] = selectedUser;
            $[10] = t3;
        } else t3 = $[10];
        T0 = $4cfe77388eba4163$export$f834f589d68e6a22;
        t1 = "direct-reports-section";
        t2 = usersForCards.map($3103b06cdaca8fca$var$_temp);
        $[0] = directReports;
        $[1] = selectedUser;
        $[2] = showAvatarStack;
        $[3] = T0;
        $[4] = numMissingProfiles;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
        $[8] = usersForAvatarStack;
    } else {
        T0 = $[3];
        numMissingProfiles = $[4];
        t1 = $[5];
        t2 = $[6];
        t3 = $[7];
        usersForAvatarStack = $[8];
    }
    let t4;
    if ($[11] !== numMissingProfiles || $[12] !== usersForAvatarStack) {
        t4 = !usersForAvatarStack && numMissingProfiles > 0 && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ea34ae79f50bee81$export$e7897f9670d3dd6e), {
                numMissingProfiles: numMissingProfiles,
                testId: "missing-reports-card"
            })
        });
        $[11] = numMissingProfiles;
        $[12] = usersForAvatarStack;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== numMissingProfiles || $[15] !== toggleAvatarStack || $[16] !== usersForAvatarStack) {
        t5 = usersForAvatarStack && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$57d2503ddb05403d, {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $07730ec4880ef60f$export$ba929152c036bdb5), {
                    atlassianUsers: usersForAvatarStack,
                    numFilteredMissingProfiles: numMissingProfiles,
                    onClick: toggleAvatarStack
                })
            })
        });
        $[14] = numMissingProfiles;
        $[15] = toggleAvatarStack;
        $[16] = usersForAvatarStack;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== T0 || $[19] !== t1 || $[20] !== t2 || $[21] !== t4 || $[22] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsxs)(T0, {
            testId: t1,
            children: [
                t2,
                t4,
                t5
            ]
        });
        $[18] = T0;
        $[19] = t1;
        $[20] = t2;
        $[21] = t4;
        $[22] = t5;
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== t3 || $[25] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t3,
                t6
            ]
        });
        $[24] = t3;
        $[25] = t6;
        $[26] = t7;
    } else t7 = $[26];
    return t7;
} : ({ selectedUser: selectedUser, directReports: directReports, showAvatarStack: showAvatarStack, toggleAvatarStack: toggleAvatarStack })=>{
    const { usersForCards: usersForCards, usersForAvatarStack: usersForAvatarStack, numMissingProfiles: numMissingProfiles } = (0, $7966fb0a15fc0c37$export$5f1b49a43933909d)(directReports, showAvatarStack ? (0, $7b5437fb537dc20f$export$7eaed9d2dcd47ca2) : undefined);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83edb761a189e14f$export$d32d64b5c85992da), {
                user: selectedUser,
                selected: true,
                testId: "selected-user-card"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)($4cfe77388eba4163$export$f834f589d68e6a22, {
                testId: "direct-reports-section",
                children: [
                    usersForCards.map((user, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
                            children: (0, $83edb761a189e14f$export$dd0d1e3398e34d39)(user, `direct-report-${index}`)
                        }, user.accountIdentifier || `direct-report-${index}`)),
                    !usersForAvatarStack && numMissingProfiles > 0 && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ea34ae79f50bee81$export$e7897f9670d3dd6e), {
                            numMissingProfiles: numMissingProfiles,
                            testId: "missing-reports-card"
                        })
                    }),
                    usersForAvatarStack && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$57d2503ddb05403d, {
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $07730ec4880ef60f$export$ba929152c036bdb5), {
                                atlassianUsers: usersForAvatarStack,
                                numFilteredMissingProfiles: numMissingProfiles,
                                onClick: toggleAvatarStack
                            })
                        })
                    })
                ]
            })
        ]
    });
};
function $3103b06cdaca8fca$var$_temp(user, index) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
        children: (0, $83edb761a189e14f$export$dd0d1e3398e34d39)(user, `direct-report-${index}`)
    }, user.accountIdentifier || `direct-report-${index}`);
}











parcelRequire("cozmU");







const $9064b08a50938853$export$2992b481dad9fb03 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { orderedManagerList: orderedManagerList, showAvatarStack: showAvatarStack, toggleAvatarStack: toggleAvatarStack, isSelectedUserManager: isSelectedUserManager } = t0;
    const unstackedManagerLimit = isSelectedUserManager ? 1 : 2;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("enable_teams_t26_design_drop_core_experiences");
        $[0] = t1;
    } else t1 = $[0];
    const isT26DesignDropCoreExperiences = t1;
    let t2;
    if ($[1] !== orderedManagerList) {
        t2 = orderedManagerList.at(-1);
        $[1] = orderedManagerList;
        $[2] = t2;
    } else t2 = $[2];
    const firstManager = t2;
    let T0;
    let t3;
    let t4;
    if ($[3] !== firstManager || $[4] !== orderedManagerList || $[5] !== showAvatarStack || $[6] !== toggleAvatarStack || $[7] !== unstackedManagerLimit) {
        const orderedMiddleManagers = orderedManagerList.slice(unstackedManagerLimit, -1);
        const hasManagersForAvatarStack = isT26DesignDropCoreExperiences ? orderedMiddleManagers.length > 0 : orderedManagerList.length > unstackedManagerLimit + 1;
        T0 = $4cfe77388eba4163$export$292f5f8a1eddcae4;
        t3 = "manager-section";
        t4 = hasManagersForAvatarStack && showAvatarStack ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                firstManager && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83edb761a189e14f$export$d32d64b5c85992da), {
                        user: firstManager,
                        testId: "manager-stack-top-card"
                    })
                }),
                /*#__PURE__*/ (0, $8aG6j.jsxs)($4cfe77388eba4163$export$19f41810b733bcb3, {
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$4146f747f0017611, {
                            testId: "manager-avatars",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $07730ec4880ef60f$export$ba929152c036bdb5), {
                                atlassianUsers: isT26DesignDropCoreExperiences ? orderedMiddleManagers.reverse() : orderedManagerList.slice(unstackedManagerLimit + 1).reverse(),
                                numFilteredMissingProfiles: 0,
                                avatarSize: "small",
                                onClick: toggleAvatarStack,
                                includeNameInMoreText: true
                            })
                        }, "manager-avatars"),
                        /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$64fc853735f5807c, {})
                    ]
                })
            ]
        }) : orderedManagerList.slice(unstackedManagerLimit).map($9064b08a50938853$var$_temp).reverse();
        $[3] = firstManager;
        $[4] = orderedManagerList;
        $[5] = showAvatarStack;
        $[6] = toggleAvatarStack;
        $[7] = unstackedManagerLimit;
        $[8] = T0;
        $[9] = t3;
        $[10] = t4;
    } else {
        T0 = $[8];
        t3 = $[9];
        t4 = $[10];
    }
    let t5;
    if ($[11] !== isSelectedUserManager || $[12] !== orderedManagerList[1]) {
        t5 = isSelectedUserManager ? null : orderedManagerList[1] && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83edb761a189e14f$export$d32d64b5c85992da), {
                user: orderedManagerList[1],
                testId: "skip-manager-card"
            })
        });
        $[11] = isSelectedUserManager;
        $[12] = orderedManagerList[1];
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== orderedManagerList[0]) {
        t6 = orderedManagerList[0] && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83edb761a189e14f$export$d32d64b5c85992da), {
                user: orderedManagerList[0],
                testId: "direct-manager-card"
            })
        });
        $[14] = orderedManagerList[0];
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== T0 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)(T0, {
            testId: t3,
            children: [
                t4,
                t5,
                t6
            ]
        });
        $[16] = T0;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    return t7;
} : ({ orderedManagerList: orderedManagerList, showAvatarStack: showAvatarStack, toggleAvatarStack: toggleAvatarStack, isSelectedUserManager: isSelectedUserManager })=>{
    const unstackedManagerLimit = isSelectedUserManager ? 1 : 2;
    const isT26DesignDropCoreExperiences = (0, $iDrrr.fg)('enable_teams_t26_design_drop_core_experiences');
    const firstManager = orderedManagerList.at(-1);
    const orderedMiddleManagers = orderedManagerList.slice(unstackedManagerLimit, -1);
    const hasManagersForAvatarStack = isT26DesignDropCoreExperiences ? orderedMiddleManagers.length > 0 : orderedManagerList.length > unstackedManagerLimit + 1;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)($4cfe77388eba4163$export$292f5f8a1eddcae4, {
        testId: "manager-section",
        children: [
            hasManagersForAvatarStack && showAvatarStack ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    firstManager && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83edb761a189e14f$export$d32d64b5c85992da), {
                            user: firstManager,
                            testId: "manager-stack-top-card"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)($4cfe77388eba4163$export$19f41810b733bcb3, {
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$4146f747f0017611, {
                                testId: "manager-avatars",
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $07730ec4880ef60f$export$ba929152c036bdb5), {
                                    atlassianUsers: isT26DesignDropCoreExperiences ? orderedMiddleManagers.reverse() : orderedManagerList.slice(unstackedManagerLimit + 1).reverse(),
                                    numFilteredMissingProfiles: 0,
                                    avatarSize: "small",
                                    onClick: toggleAvatarStack,
                                    includeNameInMoreText: true
                                })
                            }, "manager-avatars"),
                            /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$64fc853735f5807c, {})
                        ]
                    })
                ]
            }) : orderedManagerList.slice(unstackedManagerLimit).map((manager)=>/*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83edb761a189e14f$export$d32d64b5c85992da), {
                        user: manager
                    })
                }, manager.accountIdentifier ?? undefined)).reverse(),
            isSelectedUserManager ? null : orderedManagerList[1] && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83edb761a189e14f$export$d32d64b5c85992da), {
                    user: orderedManagerList[1],
                    testId: "skip-manager-card"
                })
            }),
            orderedManagerList[0] && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83edb761a189e14f$export$d32d64b5c85992da), {
                    user: orderedManagerList[0],
                    testId: "direct-manager-card"
                })
            })
        ]
    });
};
function $9064b08a50938853$var$_temp(manager) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83edb761a189e14f$export$d32d64b5c85992da), {
            user: manager
        })
    }, manager.accountIdentifier ?? undefined);
}











parcelRequire("cozmU");







const $7cc2cc00c096b7f0$export$8bde47df8015375b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { selectedUser: selectedUser, peers: peers, showAvatarStack: showAvatarStack, toggleAvatarStack: toggleAvatarStack } = t0;
    let T0;
    let numMissingProfiles;
    let t1;
    let t2;
    let t3;
    let usersForAvatarStack;
    if ($[0] !== peers || $[1] !== selectedUser || $[2] !== showAvatarStack) {
        const { usersForCards: usersForCards, usersForAvatarStack: t4, numMissingProfiles: t5 } = (0, $7966fb0a15fc0c37$export$5f1b49a43933909d)(peers, showAvatarStack ? (0, $7b5437fb537dc20f$export$7eaed9d2dcd47ca2) - 1 : undefined);
        usersForAvatarStack = t4;
        numMissingProfiles = t5;
        T0 = $4cfe77388eba4163$export$f834f589d68e6a22;
        t1 = "peers-section";
        if ($[9] !== selectedUser) {
            t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ea34ae79f50bee81$export$4780341a98005419), {
                    user: selectedUser,
                    selected: true,
                    testId: "selected-user-card"
                })
            });
            $[9] = selectedUser;
            $[10] = t2;
        } else t2 = $[10];
        t3 = usersForCards.map($7cc2cc00c096b7f0$var$_temp);
        $[0] = peers;
        $[1] = selectedUser;
        $[2] = showAvatarStack;
        $[3] = T0;
        $[4] = numMissingProfiles;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
        $[8] = usersForAvatarStack;
    } else {
        T0 = $[3];
        numMissingProfiles = $[4];
        t1 = $[5];
        t2 = $[6];
        t3 = $[7];
        usersForAvatarStack = $[8];
    }
    let t4;
    if ($[11] !== numMissingProfiles || $[12] !== usersForAvatarStack) {
        t4 = !usersForAvatarStack && numMissingProfiles > 0 && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ea34ae79f50bee81$export$e7897f9670d3dd6e), {
                numMissingProfiles: numMissingProfiles,
                testId: "missing-peers-card"
            })
        });
        $[11] = numMissingProfiles;
        $[12] = usersForAvatarStack;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== numMissingProfiles || $[15] !== toggleAvatarStack || $[16] !== usersForAvatarStack) {
        t5 = usersForAvatarStack && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$57d2503ddb05403d, {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $07730ec4880ef60f$export$ba929152c036bdb5), {
                    atlassianUsers: usersForAvatarStack,
                    numFilteredMissingProfiles: numMissingProfiles,
                    onClick: toggleAvatarStack
                })
            })
        });
        $[14] = numMissingProfiles;
        $[15] = toggleAvatarStack;
        $[16] = usersForAvatarStack;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== T0 || $[19] !== t1 || $[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsxs)(T0, {
            testId: t1,
            children: [
                t2,
                t3,
                t4,
                t5
            ]
        });
        $[18] = T0;
        $[19] = t1;
        $[20] = t2;
        $[21] = t3;
        $[22] = t4;
        $[23] = t5;
        $[24] = t6;
    } else t6 = $[24];
    return t6;
} : ({ selectedUser: selectedUser, peers: peers, showAvatarStack: showAvatarStack, toggleAvatarStack: toggleAvatarStack })=>{
    const { usersForCards: usersForCards, usersForAvatarStack: usersForAvatarStack, numMissingProfiles: numMissingProfiles } = (0, $7966fb0a15fc0c37$export$5f1b49a43933909d)(peers, showAvatarStack ? (0, $7b5437fb537dc20f$export$7eaed9d2dcd47ca2) - 1 : undefined);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)($4cfe77388eba4163$export$f834f589d68e6a22, {
        testId: "peers-section",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ea34ae79f50bee81$export$4780341a98005419), {
                    user: selectedUser,
                    selected: true,
                    testId: "selected-user-card"
                })
            }),
            usersForCards.map((user, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
                    children: (0, $83edb761a189e14f$export$dd0d1e3398e34d39)(user, `peer-${index}`)
                }, user.accountIdentifier || `peer-${index}`)),
            !usersForAvatarStack && numMissingProfiles > 0 && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ea34ae79f50bee81$export$e7897f9670d3dd6e), {
                    numMissingProfiles: numMissingProfiles,
                    testId: "missing-peers-card"
                })
            }),
            usersForAvatarStack && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$57d2503ddb05403d, {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $07730ec4880ef60f$export$ba929152c036bdb5), {
                        atlassianUsers: usersForAvatarStack,
                        numFilteredMissingProfiles: numMissingProfiles,
                        onClick: toggleAvatarStack
                    })
                })
            })
        ]
    });
};
function $7cc2cc00c096b7f0$var$_temp(user, index) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$19f41810b733bcb3, {
        children: (0, $83edb761a189e14f$export$dd0d1e3398e34d39)(user, `peer-${index}`)
    }, user.accountIdentifier || `peer-${index}`);
}











parcelRequire("cozmU");


var $eFbDl = parcelRequire("eFbDl");





const $48563e8f513cca38$var$styles = {
    wrapper: "_0jFU0VHMkp _3iDTPbQ4SZ _0hPCNLDIqT _2Zuz6Q1Y8M"
};
const $48563e8f513cca38$export$a51b447e2e91f097 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ReportingLinesSkeleton() {
    const $ = (0, $bDgLe.c)(7);
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($48563e8f513cca38$export$86cb745842e61035, {});
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cfe77388eba4163$export$64fc853735f5807c), {});
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($48563e8f513cca38$export$86cb745842e61035, {});
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cfe77388eba4163$export$64fc853735f5807c), {});
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)($48563e8f513cca38$export$86cb745842e61035, {});
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cfe77388eba4163$export$64fc853735f5807c), {});
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t0,
                t1,
                t2,
                t3,
                t4,
                t5,
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cfe77388eba4163$export$f834f589d68e6a22), {
                    children: Array.from({
                        length: 8
                    }, $48563e8f513cca38$var$_temp)
                })
            ]
        });
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : function ReportingLinesSkeleton() {
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)($48563e8f513cca38$export$86cb745842e61035, {}),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cfe77388eba4163$export$64fc853735f5807c), {}),
            /*#__PURE__*/ (0, $8aG6j.jsx)($48563e8f513cca38$export$86cb745842e61035, {}),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cfe77388eba4163$export$64fc853735f5807c), {}),
            /*#__PURE__*/ (0, $8aG6j.jsx)($48563e8f513cca38$export$86cb745842e61035, {}),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cfe77388eba4163$export$64fc853735f5807c), {}),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cfe77388eba4163$export$f834f589d68e6a22), {
                children: Array.from({
                    length: 8
                }, (_, i)=>/*#__PURE__*/ (0, $8aG6j.jsx)($48563e8f513cca38$export$86cb745842e61035, {}, i))
            })
        ]
    });
};
function $48563e8f513cca38$var$_temp(_, i) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)($48563e8f513cca38$export$86cb745842e61035, {}, i);
}
const $48563e8f513cca38$export$86cb745842e61035 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UserCardSkeleton() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cfe77388eba4163$export$683f3dd0a3fb1df5), {
            selected: false,
            ariaLabel: "Loading user",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $48563e8f513cca38$var$styles.wrapper,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cfe77388eba4163$export$f130524a2351fcc4), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eFbDl.default), {})
                })
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function UserCardSkeleton() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cfe77388eba4163$export$683f3dd0a3fb1df5), {
        selected: false,
        ariaLabel: "Loading user",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $48563e8f513cca38$var$styles.wrapper,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cfe77388eba4163$export$f130524a2351fcc4), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eFbDl.default), {})
            })
        })
    });
};



const $7b5437fb537dc20f$export$7eaed9d2dcd47ca2 = 8;
const $7b5437fb537dc20f$export$ea0671ec29c3e157 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { reportingLines: reportingLines } = t0;
    const analytics = (0, $p4wJt.default)();
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { managers: orderedManagerList, user: selectedUser, reports: directReports, peers: peers } = reportingLines;
    const [showAvatarStack, setShowAvatarStack] = (0, $cozmU.useState)(true);
    const [teamCentralStore] = (0, $65ENq.useTeamCentralStore)();
    const { getActiveWorkspaceId: getActiveWorkspaceId } = teamCentralStore.teamCentralHandlers;
    const { product: t1, viewedEventAttributes: viewedEventAttributes } = (0, $344277174d1dbd8f$export$f1dff4eb3ba8d70b)();
    const product = t1 === undefined ? "" : t1;
    let t2;
    if ($[0] !== getActiveWorkspaceId) {
        t2 = getActiveWorkspaceId ? getActiveWorkspaceId() : null;
        $[0] = getActiveWorkspaceId;
        $[1] = t2;
    } else t2 = $[1];
    const workspaceUuid = t2;
    let t3;
    if ($[2] !== analytics || $[3] !== fireEvent || $[4] !== product || $[5] !== workspaceUuid) {
        t3 = ()=>{
            if ((0, $iDrrr.fg)("ptc-enable-ptc-common-analytics-refactor")) {
                fireEvent("ui.ReportingLinesChart.expanded", {
                    product: product,
                    workspaceUuid: workspaceUuid
                });
                fireEvent("ui.ui.viewed", {
                    product: product,
                    workspaceUuid: workspaceUuid
                });
            } else {
                analytics.pushUIEvent({
                    source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
                    actionSubject: "ReportingLinesChart",
                    action: (0, $56jml.AnalyticsEventActions).EXPANDED,
                    tags: [
                        "watermelon"
                    ],
                    attributes: {
                        product: product,
                        workspaceUuid: workspaceUuid
                    }
                });
                analytics.pushUIEvent({
                    source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
                    actionSubject: "ui",
                    action: (0, $56jml.AnalyticsEventActions).VIEWED,
                    tags: [
                        "watermelon"
                    ],
                    attributes: {
                        product: product,
                        workspaceUuid: workspaceUuid
                    }
                });
            }
            setShowAvatarStack($7b5437fb537dc20f$var$_temp);
        };
        $[2] = analytics;
        $[3] = fireEvent;
        $[4] = product;
        $[5] = workspaceUuid;
        $[6] = t3;
    } else t3 = $[6];
    const toggleAvatarStack = t3;
    let t4;
    let t5;
    if ($[7] !== analytics || $[8] !== fireEvent || $[9] !== product || $[10] !== viewedEventAttributes || $[11] !== workspaceUuid) {
        t4 = ()=>{
            if ((0, $iDrrr.fg)("ptc-enable-ptc-common-analytics-refactor")) fireEvent("ui.ReportingLinesChart.viewed", {
                product: product,
                workspaceUuid: workspaceUuid,
                isNewUserProfile: null,
                tab: null,
                ...viewedEventAttributes
            });
            else analytics.pushUIEvent({
                source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
                actionSubject: "ReportingLinesChart",
                action: (0, $56jml.AnalyticsEventActions).VIEWED,
                tags: [
                    "watermelon"
                ],
                attributes: {
                    product: product,
                    workspaceUuid: workspaceUuid
                }
            });
        };
        t5 = [
            analytics,
            product,
            workspaceUuid,
            fireEvent,
            viewedEventAttributes
        ];
        $[7] = analytics;
        $[8] = fireEvent;
        $[9] = product;
        $[10] = viewedEventAttributes;
        $[11] = workspaceUuid;
        $[12] = t4;
        $[13] = t5;
    } else {
        t4 = $[12];
        t5 = $[13];
    }
    (0, $cozmU.useEffect)(t4, t5);
    if (!selectedUser || !orderedManagerList || !directReports || !peers || orderedManagerList.length === 0 && directReports.length === 0 && peers.length === 0) {
        let t6;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6a212d8c614923e3$export$9c6fadd3e9548a03), {});
            $[14] = t6;
        } else t6 = $[14];
        return t6;
    }
    const isManager = selectedUser.numberOfDirectReports !== 0;
    let t6;
    if ($[15] !== analytics || $[16] !== fireEvent || $[17] !== product || $[18] !== showAvatarStack || $[19] !== workspaceUuid) {
        t6 = !showAvatarStack && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$deb7c4cf28fc4ed6, {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($jAG9k))),
                label: "Collapse",
                onClick: ()=>{
                    if ((0, $iDrrr.fg)("ptc-enable-ptc-common-analytics-refactor")) {
                        fireEvent("ui.ReportingLinesChart.collapsed", {
                            product: product,
                            workspaceUuid: workspaceUuid
                        });
                        fireEvent("ui.ui.viewed", {
                            product: product,
                            workspaceUuid: workspaceUuid
                        });
                    } else {
                        analytics.pushUIEvent({
                            source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
                            actionSubject: "ReportingLinesChart",
                            action: (0, $56jml.AnalyticsEventActions).COLLAPSED,
                            tags: [
                                "watermelon"
                            ],
                            attributes: {
                                product: product,
                                workspaceUuid: workspaceUuid
                            }
                        });
                        analytics.pushUIEvent({
                            source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
                            actionSubject: "ui",
                            action: (0, $56jml.AnalyticsEventActions).VIEWED,
                            tags: [
                                "watermelon"
                            ],
                            attributes: {
                                product: product,
                                workspaceUuid: workspaceUuid
                            }
                        });
                    }
                    setShowAvatarStack(true);
                },
                testId: "reporting-lines-collapse-button"
            })
        });
        $[15] = analytics;
        $[16] = fireEvent;
        $[17] = product;
        $[18] = showAvatarStack;
        $[19] = workspaceUuid;
        $[20] = t6;
    } else t6 = $[20];
    let t7;
    if ($[21] !== isManager || $[22] !== orderedManagerList || $[23] !== showAvatarStack || $[24] !== toggleAvatarStack) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9064b08a50938853$export$2992b481dad9fb03), {
            orderedManagerList: orderedManagerList,
            showAvatarStack: showAvatarStack,
            toggleAvatarStack: toggleAvatarStack,
            isSelectedUserManager: isManager
        });
        $[21] = isManager;
        $[22] = orderedManagerList;
        $[23] = showAvatarStack;
        $[24] = toggleAvatarStack;
        $[25] = t7;
    } else t7 = $[25];
    let t8;
    if ($[26] !== directReports || $[27] !== isManager || $[28] !== peers || $[29] !== selectedUser || $[30] !== showAvatarStack || $[31] !== toggleAvatarStack) {
        t8 = isManager ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3103b06cdaca8fca$export$1e4a0ff7dd119586), {
            selectedUser: selectedUser,
            directReports: directReports,
            showAvatarStack: showAvatarStack,
            toggleAvatarStack: toggleAvatarStack
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7cc2cc00c096b7f0$export$8bde47df8015375b), {
            selectedUser: selectedUser,
            peers: peers,
            showAvatarStack: showAvatarStack,
            toggleAvatarStack: toggleAvatarStack
        });
        $[26] = directReports;
        $[27] = isManager;
        $[28] = peers;
        $[29] = selectedUser;
        $[30] = showAvatarStack;
        $[31] = toggleAvatarStack;
        $[32] = t8;
    } else t8 = $[32];
    let t9;
    if ($[33] !== t6 || $[34] !== t7 || $[35] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t6,
                t7,
                t8
            ]
        });
        $[33] = t6;
        $[34] = t7;
        $[35] = t8;
        $[36] = t9;
    } else t9 = $[36];
    return t9;
} : ({ reportingLines: reportingLines })=>{
    const analytics = (0, $p4wJt.default)();
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { managers: orderedManagerList, user: selectedUser, reports: directReports, peers: peers } = reportingLines;
    const [showAvatarStack, setShowAvatarStack] = (0, $cozmU.useState)(true);
    const [teamCentralStore] = (0, $65ENq.useTeamCentralStore)();
    const { getActiveWorkspaceId: getActiveWorkspaceId } = teamCentralStore.teamCentralHandlers;
    const { product: product = '', viewedEventAttributes: viewedEventAttributes } = (0, $344277174d1dbd8f$export$f1dff4eb3ba8d70b)();
    const workspaceUuid = getActiveWorkspaceId ? getActiveWorkspaceId() : null;
    const toggleAvatarStack = ()=>{
        if ((0, $iDrrr.fg)('ptc-enable-ptc-common-analytics-refactor')) {
            fireEvent('ui.ReportingLinesChart.expanded', {
                product: product,
                workspaceUuid: workspaceUuid
            });
            // used to count towards Atlas MAU
            fireEvent('ui.ui.viewed', {
                product: product,
                workspaceUuid: workspaceUuid
            });
        } else {
            analytics.pushUIEvent({
                source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
                actionSubject: 'ReportingLinesChart',
                action: (0, $56jml.AnalyticsEventActions).EXPANDED,
                tags: [
                    'watermelon'
                ],
                attributes: {
                    product: product,
                    workspaceUuid: workspaceUuid
                }
            });
            // used to count towards Atlas MAU
            analytics.pushUIEvent({
                source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
                actionSubject: 'ui',
                action: (0, $56jml.AnalyticsEventActions).VIEWED,
                tags: [
                    'watermelon'
                ],
                attributes: {
                    product: product,
                    workspaceUuid: workspaceUuid
                }
            });
        }
        setShowAvatarStack((prev)=>!prev);
    };
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('ptc-enable-ptc-common-analytics-refactor')) fireEvent('ui.ReportingLinesChart.viewed', {
            product: product,
            workspaceUuid: workspaceUuid,
            isNewUserProfile: null,
            tab: null,
            ...viewedEventAttributes
        });
        else analytics.pushUIEvent({
            source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'ReportingLinesChart',
            action: (0, $56jml.AnalyticsEventActions).VIEWED,
            tags: [
                'watermelon'
            ],
            attributes: {
                product: product,
                workspaceUuid: workspaceUuid
            }
        });
    }, [
        analytics,
        product,
        workspaceUuid,
        fireEvent,
        viewedEventAttributes
    ]);
    // Extracting these into constants breaks typechecking
    // Checks if any response data is missing (undefined/null) or if no IdP data exists (empty arrays)
    if (!selectedUser || !orderedManagerList || !directReports || !peers || orderedManagerList.length === 0 && directReports.length === 0 && peers.length === 0) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6a212d8c614923e3$export$9c6fadd3e9548a03), {});
    const isManager = selectedUser.numberOfDirectReports !== 0;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            !showAvatarStack && /*#__PURE__*/ (0, $8aG6j.jsx)($4cfe77388eba4163$export$deb7c4cf28fc4ed6, {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jAG9k))),
                    label: "Collapse",
                    onClick: ()=>{
                        if ((0, $iDrrr.fg)('ptc-enable-ptc-common-analytics-refactor')) {
                            fireEvent('ui.ReportingLinesChart.collapsed', {
                                product: product,
                                workspaceUuid: workspaceUuid
                            });
                            // used to count towards Atlas MAU
                            fireEvent('ui.ui.viewed', {
                                product: product,
                                workspaceUuid: workspaceUuid
                            });
                        } else {
                            analytics.pushUIEvent({
                                source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
                                actionSubject: 'ReportingLinesChart',
                                action: (0, $56jml.AnalyticsEventActions).COLLAPSED,
                                tags: [
                                    'watermelon'
                                ],
                                attributes: {
                                    product: product,
                                    workspaceUuid: workspaceUuid
                                }
                            });
                            // used to count towards Atlas MAU
                            analytics.pushUIEvent({
                                source: (0, $56jml.AnalyticsEventSource).USER_PROFILE_SCREEN,
                                actionSubject: 'ui',
                                action: (0, $56jml.AnalyticsEventActions).VIEWED,
                                tags: [
                                    'watermelon'
                                ],
                                attributes: {
                                    product: product,
                                    workspaceUuid: workspaceUuid
                                }
                            });
                        }
                        setShowAvatarStack(true);
                    },
                    testId: "reporting-lines-collapse-button"
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9064b08a50938853$export$2992b481dad9fb03), {
                orderedManagerList: orderedManagerList,
                showAvatarStack: showAvatarStack,
                toggleAvatarStack: toggleAvatarStack,
                isSelectedUserManager: isManager
            }),
            isManager ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3103b06cdaca8fca$export$1e4a0ff7dd119586), {
                selectedUser: selectedUser,
                directReports: directReports,
                showAvatarStack: showAvatarStack,
                toggleAvatarStack: toggleAvatarStack
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7cc2cc00c096b7f0$export$8bde47df8015375b), {
                selectedUser: selectedUser,
                peers: peers,
                showAvatarStack: showAvatarStack,
                toggleAvatarStack: toggleAvatarStack
            })
        ]
    });
};
const $7b5437fb537dc20f$export$de6b90b2478211ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { reportingLinesResponse: t1, isResponseEmpty: isResponseEmpty } = t0;
    const { isLoading: isLoading, reportingLines: reportingLines } = t1;
    if (isLoading) {
        let t2;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $48563e8f513cca38$export$a51b447e2e91f097), {});
            $[0] = t2;
        } else t2 = $[0];
        return t2;
    }
    if (!isResponseEmpty && !!reportingLines) {
        let t2;
        if ($[1] !== reportingLines) {
            t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($7b5437fb537dc20f$export$ea0671ec29c3e157, {
                reportingLines: reportingLines
            });
            $[1] = reportingLines;
            $[2] = t2;
        } else t2 = $[2];
        return t2;
    }
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6a212d8c614923e3$export$9c6fadd3e9548a03), {});
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ reportingLinesResponse: { isLoading: isLoading, reportingLines: reportingLines }, isResponseEmpty: isResponseEmpty })=>{
    if (isLoading) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $48563e8f513cca38$export$a51b447e2e91f097), {});
    if (!isResponseEmpty && !!reportingLines) return /*#__PURE__*/ (0, $8aG6j.jsx)($7b5437fb537dc20f$export$ea0671ec29c3e157, {
        reportingLines: reportingLines
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6a212d8c614923e3$export$9c6fadd3e9548a03), {});
};
function $7b5437fb537dc20f$var$_temp(prev) {
    return !prev;
}


const $3680d14dc5642f83$var$hasNoReportingLinesData = ({ user: user, managers: managers, peers: peers, reports: reports })=>{
    return !user || !managers || !reports || !peers || managers.length === 0 && reports.length === 0 && peers.length === 0;
};
const $3680d14dc5642f83$export$c708a0e8b977d737 = (reportingLinesResponse)=>{
    return reportingLinesResponse.reportingLines && !reportingLinesResponse.error && !$3680d14dc5642f83$var$hasNoReportingLinesData(reportingLinesResponse.reportingLines);
};


const $b8e070ef3d195a85$var$styles = {
    container: "_0bjKvDKxmn _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO"
};
const $b8e070ef3d195a85$var$ChartContainer = (0, $iMnC5.Box);
const $b8e070ef3d195a85$export$17417f287f1373ce = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(7);
    const { reportingLinesResponse: reportingLinesResponse } = props;
    let t0;
    if ($[0] !== reportingLinesResponse) {
        t0 = (0, $3680d14dc5642f83$export$c708a0e8b977d737)(reportingLinesResponse);
        $[0] = reportingLinesResponse;
        $[1] = t0;
    } else t0 = $[1];
    const hasReportingLinesData = t0;
    const { isLoading: isLoading, error: error } = reportingLinesResponse;
    if (error && !isLoading) {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c7e1da51e229a2be$export$3ba0415b75d5e3a9), {});
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    if (!hasReportingLinesData && !isLoading) {
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6a212d8c614923e3$export$9c6fadd3e9548a03), {});
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    const t1 = !hasReportingLinesData;
    let t2;
    if ($[4] !== reportingLinesResponse || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b8e070ef3d195a85$var$ChartContainer, {
            xcss: $b8e070ef3d195a85$var$styles.container,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7b5437fb537dc20f$export$de6b90b2478211ab), {
                reportingLinesResponse: reportingLinesResponse,
                isResponseEmpty: t1
            })
        });
        $[4] = reportingLinesResponse;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (props)=>{
    const { reportingLinesResponse: reportingLinesResponse } = props;
    const hasReportingLinesData = (0, $3680d14dc5642f83$export$c708a0e8b977d737)(reportingLinesResponse);
    const { isLoading: isLoading, error: error } = reportingLinesResponse;
    if (error && !isLoading) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c7e1da51e229a2be$export$3ba0415b75d5e3a9), {});
    if (!hasReportingLinesData && !isLoading) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6a212d8c614923e3$export$9c6fadd3e9548a03), {});
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b8e070ef3d195a85$var$ChartContainer, {
        xcss: $b8e070ef3d195a85$var$styles.container,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7b5437fb537dc20f$export$de6b90b2478211ab), {
            reportingLinesResponse: reportingLinesResponse,
            isResponseEmpty: !hasReportingLinesData
        })
    });
};
var $b8e070ef3d195a85$export$2e2bcd8739ae039 = $b8e070ef3d195a85$export$17417f287f1373ce;


const $8da9d6c1479724bc$export$11816c4ab1cec6da = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    const { userId: userId, cloudId: cloudId, orgId: orgId } = props;
    const [t0, t1] = (0, $aeecbceb6b802fef$export$fa989b0eaa9784de)();
    const { selectedUserId: selectedUserId } = t0;
    const { selectUser: selectUser } = t1;
    const userToMakeRequestFor = selectedUserId ?? userId;
    let t2;
    if ($[0] !== cloudId || $[1] !== orgId) {
        t2 = {
            cloudId: cloudId,
            orgId: orgId
        };
        $[0] = cloudId;
        $[1] = orgId;
        $[2] = t2;
    } else t2 = $[2];
    const reportingLinesResponse = (0, $4be671d2cf26d734$export$bc3f9f082175bfd1)(userToMakeRequestFor, t2);
    let t3;
    let t4;
    if ($[3] !== selectUser || $[4] !== userId) {
        t3 = ()=>{
            selectUser(userId);
        };
        t4 = [
            userId,
            selectUser
        ];
        $[3] = selectUser;
        $[4] = userId;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] !== props || $[8] !== reportingLinesResponse) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b8e070ef3d195a85$export$2e2bcd8739ae039), {
            ...props,
            reportingLinesResponse: reportingLinesResponse
        });
        $[7] = props;
        $[8] = reportingLinesResponse;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : (props)=>{
    const { userId: userId, cloudId: cloudId, orgId: orgId } = props;
    const [{ selectedUserId: selectedUserId }, { selectUser: selectUser }] = (0, $aeecbceb6b802fef$export$fa989b0eaa9784de)();
    const userToMakeRequestFor = selectedUserId ?? userId;
    const reportingLinesResponse = (0, $4be671d2cf26d734$export$bc3f9f082175bfd1)(userToMakeRequestFor, {
        cloudId: cloudId,
        orgId: orgId
    });
    (0, $cozmU.useEffect)(()=>{
        selectUser(userId);
    }, [
        userId,
        selectUser
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b8e070ef3d195a85$export$2e2bcd8739ae039), {
        ...props,
        reportingLinesResponse: reportingLinesResponse
    });
};


const $d35e4656a31ee157$export$17417f287f1373ce = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { product: product, userId: userId, WrappedWithProfilecard: WrappedWithProfilecard, viewedEventAttributes: viewedEventAttributes, selectedCardRef: selectedCardRef, cloudId: cloudId, orgId: orgId } = t0;
    if ((0, $iDrrr.fg)("ptc-enable-ptc-common-analytics-refactor")) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                source: "userProfileScreen"
            };
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] !== cloudId || $[2] !== orgId || $[3] !== product || $[4] !== userId) {
            t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8da9d6c1479724bc$export$11816c4ab1cec6da), {
                userId: userId,
                product: product,
                cloudId: cloudId,
                orgId: orgId
            });
            $[1] = cloudId;
            $[2] = orgId;
            $[3] = product;
            $[4] = userId;
            $[5] = t2;
        } else t2 = $[5];
        let t3;
        if ($[6] !== WrappedWithProfilecard || $[7] !== product || $[8] !== selectedCardRef || $[9] !== t2 || $[10] !== viewedEventAttributes) {
            t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2tuSz.TeamsAppAnalyticsContext), {
                data: t1,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $344277174d1dbd8f$export$ec53f07922eb01bd), {
                    product: product,
                    WrappedWithProfilecard: WrappedWithProfilecard,
                    viewedEventAttributes: viewedEventAttributes,
                    selectedCardRef: selectedCardRef,
                    children: t2
                })
            });
            $[6] = WrappedWithProfilecard;
            $[7] = product;
            $[8] = selectedCardRef;
            $[9] = t2;
            $[10] = viewedEventAttributes;
            $[11] = t3;
        } else t3 = $[11];
        return t3;
    }
    let t1;
    if ($[12] !== cloudId || $[13] !== orgId || $[14] !== product || $[15] !== userId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8da9d6c1479724bc$export$11816c4ab1cec6da), {
            userId: userId,
            product: product,
            cloudId: cloudId,
            orgId: orgId
        });
        $[12] = cloudId;
        $[13] = orgId;
        $[14] = product;
        $[15] = userId;
        $[16] = t1;
    } else t1 = $[16];
    let t2;
    if ($[17] !== WrappedWithProfilecard || $[18] !== product || $[19] !== selectedCardRef || $[20] !== t1 || $[21] !== viewedEventAttributes) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $344277174d1dbd8f$export$ec53f07922eb01bd), {
            product: product,
            WrappedWithProfilecard: WrappedWithProfilecard,
            viewedEventAttributes: viewedEventAttributes,
            selectedCardRef: selectedCardRef,
            children: t1
        });
        $[17] = WrappedWithProfilecard;
        $[18] = product;
        $[19] = selectedCardRef;
        $[20] = t1;
        $[21] = viewedEventAttributes;
        $[22] = t2;
    } else t2 = $[22];
    return t2;
} : ({ product: product, userId: userId, WrappedWithProfilecard: WrappedWithProfilecard, viewedEventAttributes: viewedEventAttributes, selectedCardRef: selectedCardRef, cloudId: cloudId, orgId: orgId })=>{
    if ((0, $iDrrr.fg)('ptc-enable-ptc-common-analytics-refactor')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2tuSz.TeamsAppAnalyticsContext), {
        data: {
            source: 'userProfileScreen'
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $344277174d1dbd8f$export$ec53f07922eb01bd), {
            product: product,
            WrappedWithProfilecard: WrappedWithProfilecard,
            viewedEventAttributes: viewedEventAttributes,
            selectedCardRef: selectedCardRef,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8da9d6c1479724bc$export$11816c4ab1cec6da), {
                userId: userId,
                product: product,
                cloudId: cloudId,
                orgId: orgId
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $344277174d1dbd8f$export$ec53f07922eb01bd), {
        product: product,
        WrappedWithProfilecard: WrappedWithProfilecard,
        viewedEventAttributes: viewedEventAttributes,
        selectedCardRef: selectedCardRef,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8da9d6c1479724bc$export$11816c4ab1cec6da), {
            userId: userId,
            product: product,
            cloudId: cloudId,
            orgId: orgId
        })
    });
};



var $c966fff235fbed6e$export$2e2bcd8739ae039 = (0, $d35e4656a31ee157$export$17417f287f1373ce);















/* knowledge-cards-picture.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $c8bcd61e8797d6ff$export$7f0e56320ea6e6ee = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _39xV02JgOI _0jFU0VJgOI",
            __cmplp.className
        ])
    });
});



var $hgyck = parcelRequire("hgyck");




const $2a40d322081356a1$export$3014182e23d6ae90 = (props)=>{
    const { source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'personCardOrgChartCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        }
    };
};





const $3872290fc8ee5c0c$export$c275ac680f034541 = (props)=>{
    const { source: source } = props;
    return {
        action: 'dwelled',
        actionSubject: 'personCardOrgChartModal',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        }
    };
};





const $7da0ee0a7cbf02fe$export$4dea9d9ba0f4fd15 = (props)=>{
    const { source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'personCardOrgChartModal',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        }
    };
};





const $46d8c915edc11e65$var$ORG_CHART_DWELL_THRESHOLD = 3000;
const $46d8c915edc11e65$var$IconPaddingStyles = {
    default: "_1Znuxb1Y8M _2Zuz6Q1Y8M"
};
const $46d8c915edc11e65$export$d1ac32de8e31f333 = ({ name: name, accountId: accountId, email: email, avatarUrl: avatarUrl, profileUrl: profileUrl, jobTitle: jobTitle, department: department, location: location, time: time })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { cloudId: cloudId, orgId: orgId, isHello: isHello, sessionId: sessionId } = commonAttributes;
    const showAITopics = (0, $iDrrr.fg)('kd_topics_in_person_card');
    const { profileHref: profileHref, profileOnNavigate: profileOnNavigate } = (0, $66eSg.useTeamsAppLinks)({
        type: (0, $9T3jg.KnowledgeCardsIntentType).PERSON,
        currentUserId: accountId ?? '',
        cloudId: cloudId
    });
    const [isOrgChartModalOpen, setIsOrgChartModalOpen] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        let dwellTimeout;
        if (isOrgChartModalOpen) dwellTimeout = setTimeout(()=>{
            fireAnalyticsEvent((0, $3872290fc8ee5c0c$export$c275ac680f034541)(commonAttributes));
        }, $46d8c915edc11e65$var$ORG_CHART_DWELL_THRESHOLD);
        return ()=>{
            clearTimeout(dwellTimeout);
        };
    }, [
        isOrgChartModalOpen,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    const subText = [
        jobTitle,
        department
    ].filter((text)=>!!text).join(', ');
    const trimmedSubText = subText.length > 250 ? `${subText.slice(0, 250)}...` : subText;
    const orgText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, trimmedSubText);
    const timeAndLocationComponent = (location || time) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $46d8c915edc11e65$var$IconPaddingStyles.default
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hS5Ee))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050"
    }, location && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, location), time && location && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, "\u2022"), time && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, time))));
    const additionalInfo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, timeAndLocationComponent, showAITopics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgyck.KnowledgeCardsTopics), {
        cloudId: cloudId,
        userId: accountId ?? '',
        userName: name,
        sessionId: sessionId,
        v2styles: true
    }));
    const media = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bcd61e8797d6ff$export$7f0e56320ea6e6ee), {
        src: avatarUrl || '',
        alt: ""
    });
    const handleLinkClick = (e)=>{
        if ((0, $iDrrr.fg)('platform-adopt-teams-nav-config')) profileOnNavigate(e);
    };
    const openOrgChartModal = ()=>{
        setIsOrgChartModalOpen(true);
        fireAnalyticsEvent((0, $7da0ee0a7cbf02fe$export$4dea9d9ba0f4fd15)(commonAttributes));
    };
    const closeOrgChartModal = ()=>setIsOrgChartModalOpen(false);
    const orgChartButton = (isHello || (0, $iDrrr.fg)('kd_person_card_org_chart_button')) && accountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eleTd))),
        label: formatMessage((0, $cb86z.messages).knowledge_cards_person_org_chart_label),
        isTooltipDisabled: false,
        onClick: openOrgChartModal,
        testId: "person-card-org-chart-button"
    }) : null;
    const ClickWrapper = ({ children: children, userId: userId })=>// eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: `${userId}-org-chart-card`,
            onClick: ()=>{
                fireAnalyticsEvent((0, $2a40d322081356a1$export$3014182e23d6ae90)(commonAttributes));
            }
        }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff2c12cd5348c884$export$c7c90b1402552129), {
        name: name,
        email: email,
        profileUrl: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : profileUrl || '',
        profileLinkText: formatMessage((0, $cb86z.messages).ai_answer_who_questions_view_profile),
        media: media,
        orgText: orgText,
        additionalInfo: additionalInfo,
        onLinkClick: handleLinkClick,
        headerActions: orgChartButton,
        testId: "person-knowledge-card-header"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, accountId && isOrgChartModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: closeOrgChartModal,
        testId: "person-card-org-chart-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, formatMessage((0, $cb86z.messages).knowledge_cards_person_org_chart_modal_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c966fff235fbed6e$export$2e2bcd8739ae039), {
        userId: accountId,
        product: "personKnowledgeCardOrgChart",
        cloudId: cloudId,
        orgId: orgId,
        WrappedWithProfilecard: ClickWrapper
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null))));
};


/**
 * @generated SignedSource<<35c2bcb8915a946cd54acd300e703750>>
 * @relayHash cee8aef42c4809bf7b8650e7551b3954
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 181cde876f75df92feb4611c6fe60fe79917211ed1f2052dda73533c7ff2635e
const $be09551daefe9379$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "recommendationsQuery"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "reportingLinesAaid"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "reportingLinesOrgId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "reportingLinesSiteId"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "singleUserAccountId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "singleUserRequestingUserId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "singleUserTenantId"
    }, v9 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v10 = [
        {
            "kind": "Variable",
            "name": "recommendationsQuery",
            "variableName": "recommendationsQuery"
        }
    ], v11 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "singleUserAccountId"
        },
        {
            "kind": "Variable",
            "name": "requestingUserId",
            "variableName": "singleUserRequestingUserId"
        },
        {
            "kind": "Variable",
            "name": "tenantId",
            "variableName": "singleUserTenantId"
        }
    ], v12 = [
        {
            "kind": "Variable",
            "name": "aaid",
            "variableName": "reportingLinesAaid"
        },
        {
            "kind": "Variable",
            "name": "orgId",
            "variableName": "reportingLinesOrgId"
        },
        {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "reportingLinesSiteId"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v14 /*: any*/ 
            }
        ],
        "type": "ConfluencePage"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v14 /*: any*/ 
            }
        ],
        "type": "ConfluenceBlogPost"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v14 /*: any*/ 
            }
        ],
        "type": "ConfluenceWhiteboard"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            v18 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v20 = [
        {
            "concreteType": "ConfluenceCommentLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": v14 /*: any*/ 
        },
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v13 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v19 /*: any*/ 
            ]
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "url"
    }, v22 = [
        v21 /*: any*/ 
    ], v23 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v24 = [
        v23 /*: any*/ ,
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
                v23 /*: any*/ ,
                v18 /*: any*/ 
            ]
        }
    ], v25 = [
        {
            "alias": "trelloUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v26 = [
        {
            "alias": "webUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v27 = [
        v21 /*: any*/ ,
        v18 /*: any*/ 
    ], v28 = [
        {
            "concreteType": "AssetsLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "web"
                }
            ]
        }
    ], v29 = {
        "kind": "ScalarField",
        "name": "name"
    }, v30 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v31 = {
        "kind": "ScalarField",
        "name": "email"
    }, v32 = {
        "kind": "ScalarField",
        "name": "jobTitle"
    }, v33 = [
        v32 /*: any*/ 
    ], v34 = [
        {
            "kind": "ScalarField",
            "name": "accountIdentifier"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfDirectReports"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfTotalReports"
        },
        {
            "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
            "kind": "LinkedField",
            "name": "pii",
            "plural": false,
            "selections": [
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
                    "kind": "LinkedField",
                    "name": "extendedProfile",
                    "plural": false,
                    "selections": v33 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "singlePersonKnowledgeCardRelayQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "ActivityConnection",
                            "kind": "LinkedField",
                            "name": "workedOn",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "singlePersonKnowledgeCardRelay_workedOn"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "SmartsQueryApi",
                    "kind": "LinkedField",
                    "name": "smarts",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "singlePersonKnowledgeCardRelay_smarts"
                        }
                    ]
                },
                {
                    "concreteType": "KnowledgeDiscoveryQueryApi",
                    "kind": "LinkedField",
                    "name": "knowledgeDiscovery",
                    "plural": false,
                    "selections": [
                        {
                            "args": v11 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "singlePersonKnowledgeCardRelay_user"
                        },
                        {
                            "args": v12 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "singlePersonKnowledgeCardRelay_reportingLines"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "singlePersonKnowledgeCardRelayQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "ActivityConnection",
                            "kind": "LinkedField",
                            "name": "workedOn",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ActivityItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ActivityObject",
                                                    "kind": "LinkedField",
                                                    "name": "object",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v16 /*: any*/ ,
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ConfluenceDatabaseLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": v14 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ConfluenceDatabase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ConfluenceEmbedLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": v14 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ConfluenceEmbed"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v20 /*: any*/ ,
                                                                    "type": "ConfluenceFooterComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v20 /*: any*/ ,
                                                                    "type": "ConfluenceInlineComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "TownsquareGoal"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "TownsquareProject"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "TownsquareComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v23 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraIssue"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v24 /*: any*/ ,
                                                                    "type": "JiraPlatformComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v24 /*: any*/ ,
                                                                    "type": "JiraServiceManagementComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v25 /*: any*/ ,
                                                                    "type": "TrelloBoard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v25 /*: any*/ ,
                                                                    "type": "TrelloCard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v26 /*: any*/ ,
                                                                    "type": "DevOpsDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "ExternalDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v27 /*: any*/ ,
                                                                    "type": "DevOpsPullRequestDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "ExternalPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v26 /*: any*/ ,
                                                                    "type": "DevOpsDesign"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "ExternalRemoteLink"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "MercuryFocusArea"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v27 /*: any*/ ,
                                                                    "type": "MercuryPortfolio"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "RadarPosition"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "RadarView"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "CompassComponent"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "href"
                                                                        }
                                                                    ],
                                                                    "type": "BitbucketPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": "loomUrl",
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "LoomVideo"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v28 /*: any*/ ,
                                                                    "type": "AssetsObject"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v28 /*: any*/ ,
                                                                    "type": "AssetsObjectType"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v28 /*: any*/ ,
                                                                    "type": "AssetsSchema"
                                                                },
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        v18 /*: any*/ 
                                                    ]
                                                },
                                                v18 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "SmartsQueryApi",
                    "kind": "LinkedField",
                    "name": "smarts",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "SmartsRecommendedUser",
                            "kind": "LinkedField",
                            "name": "recommendedUser",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "accountId"
                                        },
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v31 /*: any*/ ,
                                                {
                                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                                    "kind": "LinkedField",
                                                    "name": "extendedProfile",
                                                    "plural": false,
                                                    "selections": v33 /*: any*/ 
                                                }
                                            ],
                                            "type": "AtlassianAccountUser"
                                        },
                                        v18 /*: any*/ 
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "KnowledgeDiscoveryQueryApi",
                    "kind": "LinkedField",
                    "name": "knowledgeDiscovery",
                    "plural": false,
                    "selections": [
                        {
                            "args": v11 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "singleUser",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "KnowledgeDiscoveryUserProfile",
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "department"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "location"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "organization"
                                                },
                                                {
                                                    "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                                                    "kind": "LinkedField",
                                                    "name": "thirdPartyIntegrations",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "externalId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "integrationId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "product"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "KnowledgeDiscoverySingleUser"
                                }
                            ]
                        },
                        {
                            "args": v12 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "reportingLines",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": v34 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                            "kind": "LinkedField",
                                            "name": "managers",
                                            "plural": true,
                                            "selections": v34 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                            "kind": "LinkedField",
                                            "name": "reports",
                                            "plural": true,
                                            "selections": v34 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                            "kind": "LinkedField",
                                            "name": "peers",
                                            "plural": true,
                                            "selections": v34 /*: any*/ 
                                        }
                                    ],
                                    "type": "KnowledgeDiscoveryReportingLines"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "181cde876f75df92feb4611c6fe60fe79917211ed1f2052dda73533c7ff2635e",
            "metadata": {},
            "name": "singlePersonKnowledgeCardRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$be09551daefe9379$var$node.hash = "3b96d2345c405f05720744ecd857cd6a";
var $be09551daefe9379$export$2e2bcd8739ae039 = $be09551daefe9379$var$node;














/**
 * @generated SignedSource<<942a6fcca9c99ab8b7c4808afef95d2a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $eee0f08de115290a$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "accountIdentifier"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfDirectReports"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfTotalReports"
        },
        {
            "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
            "kind": "LinkedField",
            "name": "pii",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
                    "kind": "LinkedField",
                    "name": "extendedProfile",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "jobTitle"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "aaid"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "orgId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "siteId"
            }
        ],
        "kind": "Fragment",
        "name": "singlePersonKnowledgeCardRelay_reportingLines",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "aaid",
                        "variableName": "aaid"
                    },
                    {
                        "kind": "Variable",
                        "name": "orgId",
                        "variableName": "orgId"
                    },
                    {
                        "kind": "Variable",
                        "name": "siteId",
                        "variableName": "siteId"
                    }
                ],
                "kind": "LinkedField",
                "name": "reportingLines",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            },
                            {
                                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                "kind": "LinkedField",
                                "name": "managers",
                                "plural": true,
                                "selections": v0 /*: any*/ 
                            },
                            {
                                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                "kind": "LinkedField",
                                "name": "reports",
                                "plural": true,
                                "selections": v0 /*: any*/ 
                            },
                            {
                                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                "kind": "LinkedField",
                                "name": "peers",
                                "plural": true,
                                "selections": v0 /*: any*/ 
                            }
                        ],
                        "type": "KnowledgeDiscoveryReportingLines"
                    }
                ]
            }
        ],
        "type": "KnowledgeDiscoveryQueryApi"
    };
}();
$eee0f08de115290a$var$node.hash = "39f148778c4afeaf5cb148a80dda3216";
var $eee0f08de115290a$export$2e2bcd8739ae039 = $eee0f08de115290a$var$node;


/**
 * @generated SignedSource<<add60e1b72821839e1e75acab7f1460b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ba33f4e727d0804$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "recommendationsQuery"
        }
    ],
    "kind": "Fragment",
    "name": "singlePersonKnowledgeCardRelay_smarts",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "recommendationsQuery",
                    "variableName": "recommendationsQuery"
                }
            ],
            "concreteType": "SmartsRecommendedUser",
            "kind": "LinkedField",
            "name": "recommendedUser",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                },
                                {
                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                    "kind": "LinkedField",
                                    "name": "extendedProfile",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "jobTitle"
                                        }
                                    ]
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SmartsQueryApi"
};
$6ba33f4e727d0804$var$node.hash = "28c563bfe5ced2c4dbd6c2c333de65db";
var $6ba33f4e727d0804$export$2e2bcd8739ae039 = $6ba33f4e727d0804$var$node;


/**
 * @generated SignedSource<<329ebe2174b6fc6e11dfc526241ea5c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $727e3fba3b87bad8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v1 /*: any*/ 
            }
        ],
        "type": "ConfluencePage"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v1 /*: any*/ 
            }
        ],
        "type": "ConfluenceBlogPost"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v1 /*: any*/ 
            }
        ],
        "type": "ConfluenceWhiteboard"
    }, v5 = [
        {
            "concreteType": "ConfluenceCommentLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": v1 /*: any*/ 
        },
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ]
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v8 = [
        v7 /*: any*/ 
    ], v9 = [
        v7 /*: any*/ ,
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": v8 /*: any*/ 
        }
    ], v10 = [
        {
            "alias": "trelloUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v11 = [
        {
            "alias": "webUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v12 = [
        {
            "concreteType": "AssetsLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "web"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "singlePersonKnowledgeCardRelay_workedOn",
        "selections": [
            {
                "concreteType": "ActivityItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "ActivityNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ActivityObject",
                                "kind": "LinkedField",
                                "name": "object",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "data",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            v2 /*: any*/ ,
                                            v3 /*: any*/ ,
                                            v4 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "concreteType": "ConfluenceDatabaseLinks",
                                                        "kind": "LinkedField",
                                                        "name": "links",
                                                        "plural": false,
                                                        "selections": v1 /*: any*/ 
                                                    }
                                                ],
                                                "type": "ConfluenceDatabase"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "concreteType": "ConfluenceEmbedLinks",
                                                        "kind": "LinkedField",
                                                        "name": "links",
                                                        "plural": false,
                                                        "selections": v1 /*: any*/ 
                                                    }
                                                ],
                                                "type": "ConfluenceEmbed"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v5 /*: any*/ ,
                                                "type": "ConfluenceFooterComment"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v5 /*: any*/ ,
                                                "type": "ConfluenceInlineComment"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "TownsquareGoal"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "TownsquareProject"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "TownsquareComment"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v8 /*: any*/ ,
                                                "type": "JiraIssue"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v9 /*: any*/ ,
                                                "type": "JiraPlatformComment"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v9 /*: any*/ ,
                                                "type": "JiraServiceManagementComment"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v10 /*: any*/ ,
                                                "type": "TrelloBoard"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v10 /*: any*/ ,
                                                "type": "TrelloCard"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v11 /*: any*/ ,
                                                "type": "DevOpsDocument"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "ExternalDocument"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "DevOpsPullRequestDetails"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "ExternalPullRequest"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v11 /*: any*/ ,
                                                "type": "DevOpsDesign"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "ExternalRemoteLink"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "MercuryFocusArea"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "MercuryPortfolio"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "RadarPosition"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "RadarView"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "CompassComponent"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "href"
                                                    }
                                                ],
                                                "type": "BitbucketPullRequest"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": "loomUrl",
                                                        "kind": "ScalarField",
                                                        "name": "url"
                                                    }
                                                ],
                                                "type": "LoomVideo"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v12 /*: any*/ ,
                                                "type": "AssetsObject"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v12 /*: any*/ ,
                                                "type": "AssetsObjectType"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v12 /*: any*/ ,
                                                "type": "AssetsSchema"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "ActivityConnection"
    };
}();
$727e3fba3b87bad8$var$node.hash = "6cdfa05c014885d351d287fd9d7b82fd";
var $727e3fba3b87bad8$export$2e2bcd8739ae039 = $727e3fba3b87bad8$var$node;


/**
 * @generated SignedSource<<22dafd04d97ca73d62d23d3cc4ccedb7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e46448ac261f2dd1$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "requestingUserId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tenantId"
        }
    ],
    "kind": "Fragment",
    "name": "singlePersonKnowledgeCardRelay_user",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                },
                {
                    "kind": "Variable",
                    "name": "requestingUserId",
                    "variableName": "requestingUserId"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "tenantId"
                }
            ],
            "kind": "LinkedField",
            "name": "singleUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "KnowledgeDiscoveryUserProfile",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "jobTitle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "department"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "location"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "organization"
                                },
                                {
                                    "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                                    "kind": "LinkedField",
                                    "name": "thirdPartyIntegrations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "externalId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "integrationId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "product"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "KnowledgeDiscoverySingleUser"
                }
            ]
        }
    ],
    "type": "KnowledgeDiscoveryQueryApi"
};
$e46448ac261f2dd1$var$node.hash = "6ce4ebed91636a0266cbdadf5eac8632";
var $e46448ac261f2dd1$export$2e2bcd8739ae039 = $e46448ac261f2dd1$var$node;









var $kvxgH = parcelRequire("kvxgH");








/**
 * Same as recent-work-client Flight Deck hydrator: `url: ['links.base', 'links.webUi']`
 * resolved with `hydratedValueToString` → `join('')` (plain concat, not `new URL`).
 */ function $b61a377fe745300a$export$4f8728684e01b4ef(base, webUi) {
    return `${base ?? ''}${webUi ?? ''}`;
}


/**
 * Derives a canonical URL for a recent-activity object, covering every
 * URL-bearing activity type returned by the full profile-page query. Returns
 * an empty string when the object type has no resolvable URL.
 */ function $930b2ed464e2fa0e$var$extractActivityUrl(objectData) {
    if (!objectData) return '';
    switch(objectData.__typename){
        case 'ConfluencePage':
        case 'ConfluenceBlogPost':
        case 'ConfluenceWhiteboard':
        case 'ConfluenceDatabase':
        case 'ConfluenceEmbed':
        case 'ConfluenceFooterComment':
        case 'ConfluenceInlineComment':
            return objectData.links?.base && objectData.links?.webUi ? (0, $b61a377fe745300a$export$4f8728684e01b4ef)(objectData.links.base, objectData.links.webUi) : '';
        case 'JiraIssue':
        case 'JiraPlatformComment':
        case 'JiraServiceManagementComment':
        case 'DevOpsDocument':
        case 'DevOpsDesign':
            return objectData.webUrl ?? '';
        case 'TrelloBoard':
        case 'TrelloCard':
            return objectData.trelloUrl ?? '';
        case 'TownsquareGoal':
        case 'TownsquareProject':
        case 'TownsquareComment':
        case 'ExternalDocument':
        case 'DevOpsPullRequestDetails':
        case 'ExternalPullRequest':
        case 'ExternalRemoteLink':
        case 'MercuryFocusArea':
        case 'MercuryPortfolio':
        case 'RadarPosition':
        case 'RadarView':
        case 'CompassComponent':
            return objectData.url ?? '';
        case 'BitbucketPullRequest':
            return objectData.href ?? '';
        case 'LoomVideo':
            return objectData.loomUrl ?? '';
        case 'AssetsObject':
        case 'AssetsObjectType':
        case 'AssetsSchema':
            return objectData.links?.web ?? '';
        default:
            return '';
    }
}
/**
 * Computes the de-duplication key for a recent-activity object, mirroring the
 * full profile page's `deduplicateId` behaviour:
 * - Confluence comments de-duplicate on their container (page/blog/whiteboard),
 *   so multiple comments on the same page collapse to a single entry
 *   (equivalent to `deduplicateId: ['container.id']`).
 * - Jira comments de-duplicate on their parent issue
 *   (equivalent to `deduplicateId: ['issue.id']`).
 * - Everything else de-duplicates on its own URL
 *   (equivalent to `deduplicateId: ['objectId']`).
 *
 * Falls back to the object's own URL when the container/issue is unavailable.
 */ function $930b2ed464e2fa0e$var$getActivityDedupeKey(objectData) {
    const ownUrl = $930b2ed464e2fa0e$var$extractActivityUrl(objectData);
    if (!objectData) return ownUrl;
    switch(objectData.__typename){
        case 'ConfluenceFooterComment':
        case 'ConfluenceInlineComment':
            {
                const container = objectData.container;
                const containerUrl = container && 'links' in container && container.links?.base && container.links?.webUi ? (0, $b61a377fe745300a$export$4f8728684e01b4ef)(container.links.base, container.links.webUi) : '';
                return containerUrl || ownUrl;
            }
        case 'JiraPlatformComment':
        case 'JiraServiceManagementComment':
            return objectData.issue?.webUrl || ownUrl;
        default:
            return ownUrl;
    }
}
function $930b2ed464e2fa0e$export$1b2f203bdf0d1ed4(data) {
    // De-duplicate by the profile page's `deduplicateId` key (comments collapse
    // onto their container/issue), keeping the first occurrence, then resolve
    // each survivor to its display URL.
    const seenKeys = new Set();
    const result = [];
    for (const edge of data.edges){
        const objectData = edge?.node?.object?.data;
        const url = $930b2ed464e2fa0e$var$extractActivityUrl(objectData);
        if (!url) continue;
        const dedupeKey = $930b2ed464e2fa0e$var$getActivityDedupeKey(objectData);
        if (seenKeys.has(dedupeKey)) continue;
        seenKeys.add(dedupeKey);
        result.push(url);
    }
    return result;
}
/** `user` / `managers` / `reports` rows — same shape as `singlePersonKnowledgeCardRelay_reportingLines` fragment data. */ function $930b2ed464e2fa0e$var$mapKdReportingLinesUser(u) {
    if (!u?.accountIdentifier) return null;
    return {
        accountId: u.accountIdentifier,
        name: u.pii?.name ?? '',
        avatarUrl: u.pii?.picture ?? null,
        jobTitle: u.pii?.extendedProfile?.jobTitle ?? null,
        numberOfDirectReports: u.numberOfDirectReports ?? undefined,
        numberOfTotalReports: u.numberOfTotalReports ?? undefined
    };
}
function $930b2ed464e2fa0e$export$c698f9fc75f3cde8(data) {
    if (!data?.reportingLines) return undefined;
    const rl = data.reportingLines;
    if (rl.__typename !== 'KnowledgeDiscoveryReportingLines') return undefined;
    const user = $930b2ed464e2fa0e$var$mapKdReportingLinesUser(rl.user);
    if (!user) return undefined;
    const managers = (rl.managers ?? []).map((manager)=>$930b2ed464e2fa0e$var$mapKdReportingLinesUser(manager)).filter((manager)=>manager != null);
    const reports = rl.reports?.map((report)=>$930b2ed464e2fa0e$var$mapKdReportingLinesUser(report)).filter((report)=>report != null) ?? [];
    const peers = rl.peers?.map((peer)=>$930b2ed464e2fa0e$var$mapKdReportingLinesUser(peer)).filter((peer)=>peer != null) ?? [];
    return {
        managers: managers.length ? managers : undefined,
        user: user,
        reports: reports.length ? reports : undefined,
        peers: peers.length ? peers : undefined
    };
}
function $930b2ed464e2fa0e$export$2161bdc2400ab463(data, accountId) {
    const recommended = data.recommendedUser ?? [];
    if (!recommended.length) return [];
    return recommended.reduce((acc, node)=>{
        const user = node?.user;
        if (!user) return acc;
        const id = user.accountId;
        if (!id || accountId && id === accountId) return acc;
        acc.push({
            accountId: id ?? null,
            name: user.name ?? null,
            avatarUrl: user.picture ?? null,
            email: user.email ?? null,
            jobTitle: user.extendedProfile?.jobTitle ?? null
        });
        return acc;
    }, []);
}
function $930b2ed464e2fa0e$export$2a6e620fcada89b7({ userFragment: userFragment, workedOnFragment: workedOnFragment, smartsFragment: smartsFragment, reportingLinesFragment: reportingLinesFragment, ...props }) {
    const userProfileData = (0, $6SsN4.useFragment)((0, $e46448ac261f2dd1$export$2e2bcd8739ae039), userFragment ?? null);
    const workedOnData = (0, $6SsN4.useFragment)((0, $727e3fba3b87bad8$export$2e2bcd8739ae039), workedOnFragment ?? null);
    const smartsData = (0, $6SsN4.useFragment)((0, $6ba33f4e727d0804$export$2e2bcd8739ae039), smartsFragment ?? null);
    const reportingLinesData = (0, $6SsN4.useFragment)((0, $eee0f08de115290a$export$2e2bcd8739ae039), reportingLinesFragment ?? null);
    const relayHierarchyData = (0, $cozmU.useMemo)(()=>$930b2ed464e2fa0e$export$c698f9fc75f3cde8(reportingLinesData), [
        reportingLinesData
    ]);
    const recentWorkData = (0, $cozmU.useMemo)(()=>{
        if (!workedOnData) return undefined;
        const mapped = $930b2ed464e2fa0e$export$1b2f203bdf0d1ed4(workedOnData);
        return mapped.length ? mapped : undefined;
    }, [
        workedOnData
    ]);
    const relayProfileData = (0, $cozmU.useMemo)(()=>{
        const result = userProfileData?.singleUser;
        if (!result || result.__typename !== 'KnowledgeDiscoverySingleUser') return undefined;
        const user = result.user;
        if (!user?.id) return undefined;
        return {
            accountId: user.id,
            name: user.name ?? '',
            avatarUrl: user.picture ?? null,
            email: user.email ?? null,
            jobTitle: user.jobTitle ?? null,
            department: user.department ?? null,
            location: user.location ?? null,
            organization: user.organization ?? null,
            thirdPartyIntegrations: user.thirdPartyIntegrations?.map((integration)=>({
                    externalId: integration.externalId,
                    integrationId: integration.integrationId,
                    product: integration.product
                })) ?? null
        };
    }, [
        userProfileData
    ]);
    const relayCollaborators = (0, $cozmU.useMemo)(()=>{
        if (!smartsData) return undefined;
        const mapped = $930b2ed464e2fa0e$export$2161bdc2400ab463(smartsData, relayProfileData?.accountId);
        return mapped.length ? mapped : undefined;
    }, [
        smartsData,
        relayProfileData?.accountId
    ]);
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const hasFiredLoadedEventRef = (0, $cozmU.useRef)(false);
    const resolvedProfileData = relayProfileData ?? props.profileData;
    const hasResolvedProfile = Boolean(resolvedProfileData?.name || resolvedProfileData?.accountId);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredLoadedEventRef.current || !hasResolvedProfile) return;
        hasFiredLoadedEventRef.current = true;
        fireAnalyticsEvent((0, $2c764823b2ef4dc8$export$c59cd1b0c182839c)({
            ...commonAttributes,
            personCardVariant: 'singlePerson'
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasResolvedProfile
    ]);
    if (!hasResolvedProfile) throw new Error('SAIN SinglePersonKnowledgeCard: no user profile data resolved');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvxgH.UserProfilePreview), {
        ...props,
        profileData: resolvedProfileData,
        hierarchyData: relayHierarchyData ?? props.hierarchyData,
        recentWorkData: recentWorkData,
        collaborators: relayCollaborators ?? props.collaborators
    });
}


function $70ed9c87fe720217$var$buildSiteAri(cloudId, sourceProduct) {
    if (sourceProduct) return `ari:cloud:${sourceProduct}::site/${cloudId}`;
    return cloudId;
}
/**
 * Builds the collaboration-context ARI used to scope the recent-work (`workedOn`)
 * query to the origin site, so activity from other sites the person belongs to is
 * not returned. Returns `null` when the site ID is missing or invalid so the query
 * safely falls back to unscoped behaviour.
 */ function $70ed9c87fe720217$var$buildCollabContextId(cloudId) {
    if (!cloudId) return null;
    try {
        return (0, $kTGj5.PlatformSiteAri).create({
            siteId: cloudId
        }).toString();
    } catch  {
        return null;
    }
}
function $70ed9c87fe720217$export$2e495c58d0c267e2(props) {
    const { accountId: accountId, cloudId: cloudId, orgId: orgId, requestingUserId: requestingUserId, sourceProduct: sourceProduct, onLinkClick: onLinkClick } = props;
    const accountIdARI = `ari:cloud:identity::user/${accountId}`;
    const featureServiceModel = (0, $7DMz5.SAINFeatureControl).getCollabGraphExperimentModel();
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $be09551daefe9379$export$2e2bcd8739ae039), {
        first: 50,
        singleUserAccountId: accountId,
        singleUserRequestingUserId: requestingUserId,
        singleUserTenantId: cloudId,
        filter: {
            actors: [
                accountIdARI
            ],
            collabContextId: $70ed9c87fe720217$var$buildCollabContextId(cloudId)
        },
        recommendationsQuery: {
            context: {
                userId: accountId,
                tenantId: cloudId
            },
            modelRequestParams: {
                caller: 'search-ai',
                experience: 'CgUserNearbyUser',
                featureServiceModel: featureServiceModel
            },
            requestingUserId: requestingUserId,
            maxNumberOfResults: 8
        },
        reportingLinesAaid: accountId,
        reportingLinesOrgId: orgId,
        reportingLinesSiteId: $70ed9c87fe720217$var$buildSiteAri(cloudId, sourceProduct)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $930b2ed464e2fa0e$export$2a6e620fcada89b7), {
        userFragment: data.knowledgeDiscovery ?? undefined,
        workedOnFragment: data.activity?.workedOn ?? undefined,
        smartsFragment: data.smarts ?? undefined,
        reportingLinesFragment: data.knowledgeDiscovery ?? undefined,
        cloudId: cloudId,
        orgId: orgId,
        siteId: $70ed9c87fe720217$var$buildSiteAri(cloudId, sourceProduct),
        requestingUserId: requestingUserId,
        testId: "individual-person-knowledge-card",
        onLinkClick: onLinkClick
    });
}


const $da688014b5e1873c$var$CardContainerStyles = {
    refresh: "_0bjKvDKxmn _2mHwu85zaO _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0Of8r25zaO _1wydGW5zaO",
    disclaimer: "_2Zuz6Q5zaO _1Znuxb5zaO"
};
const $da688014b5e1873c$var$PersonCardWrapperStyles = {
    default: "_39xV02WD6W _39HuIbz8Lp _1ANEUSzUZr",
    flex: "_1bHrqEWD6W _2O5VijdnbC _3YEZNOdnbC",
    inlineWrapper: "_39xV02N91d _0wOv4Q7zJH"
};
const $da688014b5e1873c$var$USERS_SCROLL_OFFSET = 392;
const $da688014b5e1873c$var$messages = (0, $kSwu1.defineMessages)({
    multiple_people_matches_header: {
        id: "search_ai.knowledge_cards.multiple_people_matches_header",
        defaultMessage: "People matches"
    },
    ai_answer_component_topics_not_relevant_checkbox_label: {
        id: "search_ai.ai_answer_component_topics_not_relevant_checkbox_label",
        defaultMessage: "The topics are not relevant to this person."
    }
});
const $da688014b5e1873c$var$IndividualPersonKnowledgeCard = ({ primaryUser: primaryUser })=>{
    if (!primaryUser) return null;
    const showKnowledgeCardBody = (primaryUser?.recentActivity?.length || 0) > 0 || (primaryUser?.collaborators?.length || 0) > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $da688014b5e1873c$var$CardContainerStyles.refresh,
        testId: "individual-person-knowledge-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $46d8c915edc11e65$export$d1ac32de8e31f333), {
        accountId: primaryUser.account_id,
        name: primaryUser.name,
        email: primaryUser.email,
        avatarUrl: primaryUser.avatar_url,
        profileUrl: primaryUser.profile_url,
        jobTitle: primaryUser.job_title,
        department: primaryUser.department,
        location: primaryUser.location,
        time: primaryUser.time
    }), showKnowledgeCardBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8ba51f29bf3689a9$export$4fb305a2fc986af3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, showKnowledgeCardBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3ffa4c5e2a30b7df$export$2460aa15a0a1d61e), {
        currentUserId: primaryUser.account_id ?? '',
        recommendedUsers: primaryUser.collaborators || [],
        recentActivity: primaryUser.recentActivity || [],
        profileUrl: primaryUser.profile_url || ''
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $da688014b5e1873c$var$CardContainerStyles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true
    })))));
};
const $da688014b5e1873c$export$8cdcd522f66fdfa8 = ({ onFMPReached: onFMPReached })=>{
    const { commonAttributes: commonAttributes, userDetails: { id: requestingUserId }, setData: setData, sourceProduct: sourceProduct, loading: loading, traceHeaders: traceHeaders } = (0, $3hVWe.useAIAnswerContext)();
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const activityClient = (0, $k8VpS.useActivityClient)('v3', 'people');
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [selectedUser, setSelectedUser] = (0, $cozmU.useState)();
    const [primaryUser, setPrimaryUser] = (0, $cozmU.useState)();
    const { answerString: answerString, cloudId: cloudId, orgId: orgId, workspaceId: workspaceId } = commonAttributes;
    const [isPersonCardLoading, setIsPersonCardLoading] = (0, $cozmU.useState)(false);
    const shouldRenderPTPersonUX = (0, $7DMz5.SAINFeatureControl).isPeopleConnectorUXEnabled();
    const userResults = (0, $d325f5b9eeee6e40$export$d905ae2a714518e8)({
        answerString: answerString
    }).parsedResult;
    const getHandleSelectUser = (0, $cozmU.useCallback)((index)=>()=>{
            setSelectedUser(index);
            if ((0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).PERSON_SELECTED,
                commonAttributes: commonAttributes
            });
        }, [
        commonAttributes,
        fireSAINUsageEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (userResults.length === 1) setSelectedUser(0);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userResults
    ]);
    (0, $cozmU.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!shouldRenderPTPersonUX && selectedUser !== undefined) {
                setIsPersonCardLoading(true);
                return (0, $634e333e90210143$export$3e632a26e137d79e)({
                    accountId: userResults[selectedUser].id,
                    tenantId: cloudId,
                    requestingUserId: requestingUserId || '',
                    activityClient: activityClient,
                    locale: locale,
                    workspaceId: workspaceId,
                    product: sourceProduct ?? '',
                    traceHeaders: traceHeaders
                }).then((data)=>{
                    setPrimaryUser(data);
                }).catch((error)=>{
                    setData({
                        errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                        disclaimer: null,
                        format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                        nlpResults: [],
                        uniqueSources: [],
                        nlpFollowUpResults: null
                    });
                    if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
                        error: error,
                        functionName: 'fetchPrimaryUserData: PersonKnowledgeCard'
                    });
                }).finally(()=>{
                    setIsPersonCardLoading(false);
                });
            }
        };
        fetchData(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedUser,
        shouldRenderPTPersonUX
    ]);
    (0, $cozmU.useEffect)(()=>{
        onFMPReached?.();
        fireAnalyticsEvent((0, $19a6060145576e12$export$44d9aa4134474084)({
            ...commonAttributes,
            cardType: (0, $9T3jg.KnowledgeCardsIntentType).PERSON
        })); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Fire a one-shot `aiAnswerPersonKnowledgeCard loaded` track event when the multi-person
    // `UserInlinePreviewList` variant is rendered. `success` reflects whether non-empty rows
    // were returned. Mirrors the `singlePerson` variant event fired from
    // `SinglePersonKnowledgeCardRelay`, and the `userInlinePreview` operational request events
    // fired by `@atlassian/user-inline-preview` itself.
    const hasFiredMultiPersonLoadedEventRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldRenderPTPersonUX) return;
         // Single-person branch fires its own event from `SinglePersonKnowledgeCardRelay`.
        if (selectedUser !== undefined || userResults.length <= 1) return;
        if (hasFiredMultiPersonLoadedEventRef.current) return;
        hasFiredMultiPersonLoadedEventRef.current = true; // The multi-person list only renders when `userResults.length > 1`, so reaching here
        // always means a successful load — fire `success: true`.
        fireAnalyticsEvent((0, $2c764823b2ef4dc8$export$c59cd1b0c182839c)({
            ...commonAttributes,
            personCardVariant: 'multiPerson'
        }));
    }, [
        shouldRenderPTPersonUX,
        selectedUser,
        userResults,
        fireAnalyticsEvent,
        commonAttributes
    ]); // Handle recent work link clicks from the LinkList component inside UserProfilePreview.
    // Fires `aiAnswerDialog clicked` with `location: 'recent-work-item'` and `answerCardType: 'people'`
    // to match the old person card instrumentation and feed SSRv5 `aiPeopleCardClicks`.
    const handleRecentWorkLinkClick = (0, $cozmU.useCallback)((url, index, opts)=>{
        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: 'recent-work-item',
            position: index,
            answerCardType: (0, $zzZbq.AnswerCardType).PERSON,
            isAuxClick: opts?.isAuxClick,
            isContextMenu: opts?.isContextMenu
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).RECENT_WORK_CLICKED,
            commonAttributes: commonAttributes
        });
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent
    ]);
    if (loading || !shouldRenderPTPersonUX && isPersonCardLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fd6fa5a10eca60c$export$a08238eb59773648), null);
    if (userResults.length === 0) return null;
    if (selectedUser !== undefined || userResults.length === 1) {
        if (shouldRenderPTPersonUX) {
            const index = selectedUser ?? 0;
            const accountId = userResults[index]?.id;
            if (!accountId) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $016c76767add6663$export$3d5fec32962921db), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.150"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
                onError: ()=>{
                    fireAnalyticsEvent((0, $9815e23bc9044028$export$5ee3eeb70eb524d1)({
                        ...commonAttributes,
                        personCardVariant: 'singlePerson'
                    }));
                    fireAnalyticsEvent((0, $189f541bd063b636$export$bd496fce1657ba31)({
                        ...commonAttributes,
                        isStreamed: false,
                        errorState: (0, $htnqN.NLPSearchErrorState).RenderError
                    }));
                },
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kjetH.ErrorCard), null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kEVoQ.LoadingSkeleton), null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70ed9c87fe720217$export$2e495c58d0c267e2), {
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId,
                requestingUserId: requestingUserId || '',
                sourceProduct: sourceProduct,
                onLinkClick: handleRecentWorkLinkClick
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
                showFeedbackButtons: true
            })))));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da688014b5e1873c$var$IndividualPersonKnowledgeCard, {
            primaryUser: primaryUser
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, shouldRenderPTPersonUX ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $016c76767add6663$export$3d5fec32962921db), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "large",
        weight: "semibold"
    }, formatMessage($da688014b5e1873c$var$messages.multiple_people_matches_header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Uv0v.UserInlinePreviewList), {
        layout: "grid",
        testId: "person-knowledge-card-user-inline-list"
    }, userResults.map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: user.id,
            onClick: getHandleSelectUser(index),
            xcss: $da688014b5e1873c$var$PersonCardWrapperStyles.inlineWrapper,
            testId: `person-knowledge-card-wrapper-${user.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b5HfQ.UserInlinePreview), {
            data: {
                accountId: user.id,
                name: user.name,
                avatarUrl: user.avatarUrl ?? null,
                jobTitle: user.title ?? null
            },
            cloudId: cloudId,
            requestingUserId: requestingUserId || undefined,
            testId: `person-knowledge-card-user-inline-${user.id}`
        })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ec82c8c1e1d8eeb1$export$61c045a5252abd1d), {
        heading: formatMessage($da688014b5e1873c$var$messages.multiple_people_matches_header),
        scrollOffset: $da688014b5e1873c$var$USERS_SCROLL_OFFSET
    }, userResults.map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onClick: getHandleSelectUser(index),
            xcss: (0, $w6R6I.cx)($da688014b5e1873c$var$PersonCardWrapperStyles.default, $da688014b5e1873c$var$PersonCardWrapperStyles.flex),
            testId: "person-knowledge-card-wrapper",
            key: user.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67cd5bff95eb1aaf$export$4c094c8f61edecb4), {
            data: {
                id: user.id,
                name: user.name,
                jobTitle: user.title ?? '',
                avatarUrl: user.avatarUrl,
                localTime: (0, $df52b12138df743d$export$b8d37f4ee3cee5b6)({
                    locale: locale,
                    zoneInfo: user.zoneInfo
                }),
                location: user.location ?? ''
            }
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true
    })));
};


/* team-knowledge-card.tsx generated by @compiled/babel-plugin v3.0.1 */ 

















var $1VhsF = parcelRequire("1VhsF");

















// Taken from https://gist.github.com/keesey/e09d0af833476385b9ee13b6d26a2b84 to avoid adding a package dependency for a single static function
function $f535bbbe86185acd$var$getEditDistance(a, b) {
    const an = a ? a.length : 0;
    const bn = b ? b.length : 0;
    if (an === 0) return bn;
    if (bn === 0) return an;
    const matrix = new Array(bn + 1);
    for(let i = 0; i <= bn; ++i){
        let row = matrix[i] = new Array(an + 1);
        row[0] = i;
    }
    const firstRow = matrix[0];
    for(let j = 1; j <= an; ++j)firstRow[j] = j;
    for(let i = 1; i <= bn; ++i){
        for(let j = 1; j <= an; ++j)if (b.charAt(i - 1) === a.charAt(j - 1)) matrix[i][j] = matrix[i - 1][j - 1];
        else matrix[i][j] = Math.min(matrix[i - 1][j - 1], matrix[i][j - 1], matrix[i - 1][j]) + 1;
    }
    return matrix[bn][an];
}
const $f535bbbe86185acd$export$ebacab8290144e11 = (query, teamName)=>{
    return $f535bbbe86185acd$var$getEditDistance(query, teamName) / query.length;
};

















































const $3676c19248632e27$export$21ff1f39b993b08e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ currentUserId: currentUserId, recommendedUsers: recommendedUsers, recentActivity: recentActivity, profileUrl: profileUrl, viewAllUrl: viewAllUrl, teamId: teamId })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { viewAllLink: viewAllLink, viewAllOnNavigate: viewAllOnNavigate, profileHref: profileHref } = (0, $66eSg.useTeamsAppLinks)({
        type: (0, $9T3jg.KnowledgeCardsIntentType).TEAM,
        currentUserId: currentUserId,
        viewAllUrl: viewAllUrl,
        cloudId: commonAttributes.cloudId,
        teamId: teamId
    });
    const handleRecentWorkViewAllClick = (e)=>{
        const isAuxClick = 'button' in e && e.button === 1;
        const isContextMenu = 'button' in e && e.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: 'recent-work-view-all',
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).RECENT_WORK_CLICKED,
            commonAttributes: commonAttributes
        });
        if (!isAuxClick && !isContextMenu && (0, $iDrrr.fg)('platform-adopt-teams-nav-config')) viewAllOnNavigate(e);
    };
    const handleTeamMembersViewAllClick = (e)=>{
        const isAuxClick = 'button' in e && e.button === 1;
        const isContextMenu = 'button' in e && e.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: 'team-members-view-all',
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).TEAM_MEMBER_CLICKED,
            commonAttributes: commonAttributes
        });
        if (!isAuxClick && !isContextMenu && (0, $iDrrr.fg)('platform-adopt-teams-nav-config')) viewAllOnNavigate(e);
    };
    // Determine which columns to render
    const hasRecentActivity = recentActivity.length > 0;
    const hasTeamMembers = recommendedUsers.length > 0;
    const columnsConfig = [
        // Recent Activity Column
        ...hasRecentActivity ? [
            {
                viewAllLinkOnClick: handleRecentWorkViewAllClick,
                viewAllLinkHref: viewAllLink,
                data: recentActivity,
                component: (0, $cce772d1072e95eb$export$65943680306d629),
                header: formatMessage((0, $cb86z.messages).knowledge_cards_recent_work_subheader),
                onClickCallback: (position, shownAfterCardBodyExpanded, opts)=>{
                    if ((opts?.isAuxClick || opts?.isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
                    fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                        ...commonAttributes,
                        location: 'recent-work-item',
                        position: position,
                        shownAfterCardBodyExpanded: shownAfterCardBodyExpanded,
                        isAuxClick: opts?.isAuxClick,
                        isContextMenu: opts?.isContextMenu
                    }));
                    fireSAINUsageEvent({
                        metCriteria: (0, $bZMnB.SainAction).RECENT_WORK_CLICKED,
                        commonAttributes: commonAttributes
                    });
                },
                searchAIAnalyticsContextLocation: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_TEAM_CARD
            }
        ] : [],
        // Team Members Column
        ...hasTeamMembers ? [
            {
                viewAllLinkOnClick: handleTeamMembersViewAllClick,
                viewAllLinkHref: viewAllLink,
                data: recommendedUsers,
                component: (0, $17582a7702efaf6e$export$87f3c1fc8ab2e681),
                onClickCallback: (position, shownAfterCardBodyExpanded, opts)=>{
                    if ((opts?.isAuxClick || opts?.isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
                    fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                        ...commonAttributes,
                        location: 'user-list-item',
                        position: position,
                        shownAfterCardBodyExpanded: shownAfterCardBodyExpanded,
                        isAuxClick: opts?.isAuxClick,
                        isContextMenu: opts?.isContextMenu
                    }));
                    fireSAINUsageEvent({
                        metCriteria: (0, $bZMnB.SainAction).TEAM_MEMBER_CLICKED,
                        commonAttributes: commonAttributes
                    });
                },
                header: formatMessage((0, $cb86z.messages).knowledge_cards_team_members_subheader)
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acbcdb4ca700ade0$export$ef08b123bd77f721), {
        columnsConfig: columnsConfig,
        profileUrl: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : profileUrl,
        footerButtonText: formatMessage((0, $cb86z.messages).knowledge_cards_view_team),
        footerButtonAction: (0, $bZMnB.SainAction).VIEW_TEAM_PAGE_CLICKED,
        testId: 'team-knowledge-card-body'
    });
});


/* team-card-header.tsx generated by @compiled/babel-plugin v3.0.1 */ 



















var $2c3Eq = parcelRequire("2c3Eq");














const $22e3062f2f0456b9$var$styles = {
    orgIcon: "_1Znuxb1Y8M _2Zuz6Q1Y8M"
};
const $22e3062f2f0456b9$export$972f15901814fb3d = ({ name: name, accountId: accountId, email: email, avatarUrl: avatarUrl, teamId: teamId, profileUrl: profileUrl })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = commonAttributes;
    const { profileHref: profileHref, profileOnNavigate: profileOnNavigate } = (0, $66eSg.useTeamsAppLinks)({
        type: (0, $9T3jg.KnowledgeCardsIntentType).TEAM,
        currentUserId: accountId ?? '',
        cloudId: cloudId,
        teamId: teamId
    });
    const media = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c3Eq.default), {
        size: "xlarge",
        src: avatarUrl || undefined,
        name: name
    }));
    const orgText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $22e3062f2f0456b9$var$styles.orgIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eleTd))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage((0, $cb86z.messages).knowledge_cards_team_subheader)));
    const handleLinkClick = (e)=>{
        if ((0, $iDrrr.fg)('platform-adopt-teams-nav-config')) profileOnNavigate(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff2c12cd5348c884$export$c7c90b1402552129), {
        name: name,
        email: email,
        profileUrl: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : profileUrl || '',
        profileLinkText: formatMessage((0, $cb86z.messages).knowledge_cards_view_team),
        media: media,
        orgText: orgText,
        onLinkClick: handleLinkClick,
        testId: 'team-knowledge-card-header'
    });
};


const $39464719bc90ad90$var$CardContainerStyles = {
    default: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    refresh: "_0bjKvDKxmn _2mHwu85zaO _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0Of8r25zaO _1wydGW5zaO",
    disclaimer: "_2Zuz6Q5zaO _1Znuxb5zaO"
};
const $39464719bc90ad90$export$224d36db19d00a29 = /*#__PURE__*/ (0, $cozmU.memo)(({ onFMPReached: onFMPReached })=>{
    const { commonAttributes: commonAttributes, userDetails: { id: currentUserId } } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { answerString: answerString, query: query } = commonAttributes;
    const data = (0, $d325f5b9eeee6e40$export$d905ae2a714518e8)({
        answerString: answerString
    }).parsedResult;
    const editDistanceRatio = (0, $f535bbbe86185acd$export$ebacab8290144e11)(query, data.name);
    (0, $cozmU.useEffect)(()=>{
        if (data.id) {
            onFMPReached?.();
            fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
            fireAnalyticsEvent((0, $19a6060145576e12$export$44d9aa4134474084)({
                ...commonAttributes,
                cardType: (0, $9T3jg.KnowledgeCardsIntentType).TEAM,
                extraAttributes: {
                    editDistance: editDistanceRatio
                }
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const showKnowledgeCardBody = (data.recentActivity?.length || 0) > 0 || (data.members?.length || 0) > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, (0, $iDrrr.fg)('enable_team_site_assignment') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $cb86z.messages).ai_answer_dialog_teams_not_found_message), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: "https://support.atlassian.com/platform-experiences/docs/understanding-team-visibility/"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $cb86z.messages).ai_answer_dialog_teams_not_found_message_link))), data.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $39464719bc90ad90$var$CardContainerStyles.refresh,
        testId: "team-knowledge-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22e3062f2f0456b9$export$972f15901814fb3d), {
        name: data.name,
        avatarUrl: data.avatarUrl,
        profileUrl: data.url,
        teamId: data.id
    }), showKnowledgeCardBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8ba51f29bf3689a9$export$4fb305a2fc986af3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, showKnowledgeCardBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3676c19248632e27$export$21ff1f39b993b08e), {
        currentUserId: currentUserId || '',
        recentActivity: data.recentActivity,
        recommendedUsers: data.members,
        viewAllUrl: data.url || '',
        teamId: data.id
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $39464719bc90ad90$var$CardContainerStyles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true
    })))) : null);
});


const $0d6d5a5257f57329$export$ab2444a256fc8a9b = ({ onFMPReached: onFMPReached })=>{
    const { isAnswered: isAnswered, hasError: hasError, smartAnswersRoute: smartAnswersRoute, loading: loading, commonAttributes: commonAttributes, baseQuery: baseQuery, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, brand: brand, searchSessionId: searchSessionId, workspaceId: workspaceId, query: query } = commonAttributes;
    // Visual Knowledge Card fetches its own data, so it doesn't rely on isAnswered/hasError from the AI answer flow
    if (smartAnswersRoute === (0, $zzZbq.QueryIntent).VISUAL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $472bcf0ba3d83c5e$export$cf8f12b9d9c373ce), {
        onFMPReached: onFMPReached
    });
    // Jira NL to JQL Card doesn't populate the context with hasError, isAnswered so we use a separate condition.
    // JIRA_NLQ_KEYWORD renders the same Jira SAIN card but bypasses the agentic NL→JQL flow
    // and instead issues a deterministic keyword JQL of the form `textfields ~ "<query>*"`.
    if (smartAnswersRoute === (0, $zzZbq.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY || smartAnswersRoute === (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD) {
        const bypassWithKeywordJql = smartAnswersRoute === (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD;
        const showJiraSAINCardSmartlink = sourceProduct === 'jira';
        if (showJiraSAINCardSmartlink) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51159ee7c0863918$export$68d51edc6150de19), {
            query: baseQuery ?? '',
            cloudId: cloudId,
            aiBrand: brand,
            searchSessionId: searchSessionId,
            workspaceId: workspaceId,
            product: sourceProduct ?? '',
            onFMPReached: onFMPReached,
            bypassWithKeywordJql: bypassWithKeywordJql
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0bc144b7e8592f4$export$ba6b7dafd54d334), {
            title: query,
            query: baseQuery ?? '',
            cloudId: cloudId,
            aiBrand: brand,
            searchSessionId: searchSessionId,
            workspaceId: workspaceId,
            product: sourceProduct ?? '',
            onFMPReached: onFMPReached,
            bypassWithKeywordJql: bypassWithKeywordJql
        });
    }
    if (loading) switch(smartAnswersRoute){
        case (0, $zzZbq.QueryIntent).PERSON:
            if ((0, $7DMz5.SAINFeatureControl).isPeopleConnectorUXEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70CUF.LoadingSkeleton), {
                columnCount: 2,
                itemCount: 10
            });
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fd6fa5a10eca60c$export$a08238eb59773648), {
                queryIntent: smartAnswersRoute
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fd6fa5a10eca60c$export$a08238eb59773648), {
                queryIntent: smartAnswersRoute
            });
    }
    if (isAnswered && !hasError) switch(smartAnswersRoute){
        case (0, $zzZbq.QueryIntent).TEAM:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39464719bc90ad90$export$224d36db19d00a29), {
                onFMPReached: onFMPReached
            });
        case (0, $zzZbq.QueryIntent).PERSON:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $da688014b5e1873c$export$8cdcd522f66fdfa8), {
                onFMPReached: onFMPReached
            });
        case (0, $zzZbq.QueryIntent).TOPIC:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dsm4u.TopicKnowledgeCard), {
                onFMPReached: onFMPReached
            });
        case (0, $zzZbq.QueryIntent).AGENT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6a88c586e988f54$export$f3d65ac3e9ec58cd), {
                onFMPReached: onFMPReached
            });
        case (0, $zzZbq.QueryIntent).ORG_CHART:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $da688014b5e1873c$export$8cdcd522f66fdfa8), {
                onFMPReached: onFMPReached
            });
        default:
            return null;
    }
    return null;
};





/* smart-answer-card-minimized.tsx generated by @compiled/babel-plugin v3.0.1 */ 



var $9kbTQ = parcelRequire("9kbTQ");




















var $d2UzA = parcelRequire("d2UzA");























var $b8pma = parcelRequire("b8pma");





var $2Zool = parcelRequire("2Zool");


var $fhQlP = parcelRequire("fhQlP");


var $1V59x = parcelRequire("1V59x");


var $7zn5c = parcelRequire("7zn5c");


var $3Luzz = parcelRequire("3Luzz");





























/* streaming-early-stop-card.tsx generated by @compiled/babel-plugin v3.0.1 */ 
































const $bdb16ab7e4fe1cd4$export$d0aa7585daee6b3c = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'dismissed',
        actionSubject: 'aiAnswerStreamingEarlyStopCard',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $523511d140ea25e9$export$efbf193d50ae9f9b = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerStreamingEarlyStopCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};









var $i3wdq = parcelRequire("i3wdq");





var $5OgwG = parcelRequire("5OgwG");

const $7af86847637791a4$var$styles = {
    root: "_39xV02N91d",
    onlineDebuggerButtonContainer: "_2XsHFMIZbP _39xV02E6Kk"
};
const $7af86847637791a4$export$97b52c363fbe053e = ()=>{
    const [dismissed, setDismissed] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { baseQuery: baseQuery, commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        const cachedAnswer = (0, $6JEx2.getSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY)); // Only fire analytics event once per cached answer
        if (cachedAnswer) {
            (0, $6JEx2.deleteSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY));
            fireAnalyticsEvent((0, $523511d140ea25e9$export$efbf193d50ae9f9b)(commonAttributes));
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const dismissCard = (0, $cozmU.useCallback)(()=>{
        setDismissed(true);
        fireAnalyticsEvent((0, $bdb16ab7e4fe1cd4$export$d0aa7585daee6b3c)(commonAttributes));
    }, [
        fireAnalyticsEvent,
        commonAttributes
    ]);
    const showOnlineDebuggerButton = (0, $iDrrr.fg)('kd_sain_online_debugger');
    if (dismissed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i3wdq.KnowledgeCard), {
        name: "sain-streaming-early-stop-card",
        size: "full",
        testId: "sain-streaming-early-stop-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $7af86847637791a4$var$styles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, formatMessage((0, $5OgwG.messages).ai_answer_card_early_stop_text, {
        searchQuery: baseQuery
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $5OgwG.messages).ai_answer_card_early_stop_close_button_label),
        onClick: dismissCard,
        appearance: "subtle",
        spacing: "compact",
        testId: "sain-early-stop-error-card-dismiss-button"
    })), showOnlineDebuggerButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $7af86847637791a4$var$styles.onlineDebuggerButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j9bgP.OnlineDebuggerButton), null))));
};


/* definition-error.tsx generated by @compiled/babel-plugin v3.0.1 */ 

















var $4ez2K = parcelRequire("4ez2K");










const $15c17b140b3e21b2$export$59da2b3b71a076c7 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $15c17b140b3e21b2$export$96cc4126cdc27248 = 'https://www.atlassian.com/legal/acceptable-use-policy';
const $15c17b140b3e21b2$export$50e6b843de210064 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $15c17b140b3e21b2$export$2c1028e1e7bf5557 = 'https://www.atlassian.com/software/rovo';
const $15c17b140b3e21b2$export$dd87179defae3659 = 'https://support.atlassian.com/organization-administration/docs/the-hipaa-implementation-guide/';
const $15c17b140b3e21b2$export$d04cd98bb7625919 = 'customfield_10047';
const $15c17b140b3e21b2$export$dd6343c56092a345 = '3655ce1d-16b8-4630-9e93-6c39069625fa';









var $a2foB = parcelRequire("a2foB");


var $lqtHz = parcelRequire("lqtHz");


var $chu6R = parcelRequire("chu6R");




const $92e081508525c627$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    edit_definition_modal_header_edit: {
        id: "search_ai.edit_definition_modal_header_edit",
        defaultMessage: "Edit definition"
    },
    edit_definition_modal_header_create: {
        id: "search_ai.edit_definition_modal_header_create",
        defaultMessage: "Add a definition"
    },
    edit_definition_modal_subheader_text: {
        id: "search_ai.edit_definition_modal_subheader_text",
        defaultMessage: "You can edit definitions to help teammates better understand terms."
    },
    edit_definition_modal_subheader_link_text: {
        id: "search_ai.edit_definition_modal_subheader_link_text",
        defaultMessage: "More on editing definitions"
    },
    edit_definition_text_box_label: {
        id: "search_ai.edit_definition_text_box_label",
        defaultMessage: "Definition"
    },
    edit_definition_text_box_label_with_count: {
        id: "search_ai.edit_definition_text_box_label_with_count",
        defaultMessage: "Edit definition, {count} of {max} characters used. Start typing to enter text."
    },
    edit_definition_no_definition: {
        id: "search_ai.edit_definition_no_definition",
        defaultMessage: "Enter definition"
    },
    edit_definition_over_max_length: {
        id: "search_ai.edit_definition_over_max_length",
        defaultMessage: "Definition must be {max} characters or fewer."
    },
    edit_definition_source_label: {
        id: "search_ai.edit_definition_source_label",
        defaultMessage: "Source"
    },
    edit_definition_add_source_label: {
        id: "search_ai.edit_definition_add_source_label",
        defaultMessage: "Add a source (optional)"
    },
    edit_definition_restricted_to_label: {
        id: "search_ai.edit_definition_restricted_to_label",
        defaultMessage: "Show this definition"
    },
    edit_definition_restricted_to_space_subline: {
        id: "search_ai.edit_definition_restricted_to_space_subline",
        defaultMessage: "Previous definition will still show in other spaces."
    },
    edit_definition_restricted_to_site_subline: {
        id: "search_ai.edit_definition_restricted_to_site_subline",
        defaultMessage: "Previous definition will still show on other sites."
    },
    edit_definition_restricted_to_project_subline: {
        id: "search_ai.edit_definition_restricted_to_project_subline",
        defaultMessage: "Previous definition will still show in other projects."
    },
    edit_definition_restricted_to_page_subline: {
        id: "search_ai.edit_definition_restricted_to_page_subline",
        defaultMessage: "Previous definition will still show on other pages."
    },
    edit_definition_restricted_to_blogpost_subline: {
        id: "search_ai.edit_definition_restricted_to_blogpost_subline",
        defaultMessage: "Previous definition will still show on other blogposts."
    },
    edit_definition_source_search_box_placeholder: {
        id: "search_ai.edit_definition_source_search_box_placeholder",
        defaultMessage: "Search or paste a Confluence link"
    },
    edit_definition_back_button: {
        id: "search_ai.edit_definition_back_button",
        defaultMessage: "Back"
    },
    edit_definition_update_button: {
        id: "search_ai.edit_definition_update_button",
        defaultMessage: "Update"
    },
    edit_definition_source_option_metadata_updated_text: {
        id: "search_ai.edit_definition_source_option_metadata_updated_text",
        defaultMessage: "Updated"
    },
    edit_definition_update_confirmation_title: {
        id: "search_ai.edit_definition_update_confirmation_title",
        defaultMessage: "Definition updated \uD83C\uDF89"
    },
    edit_definition_update_confirmation_description: {
        id: "search_ai.edit_definition_update_confirmation_description",
        defaultMessage: "You've made work clearer for your teammates."
    },
    edit_definition_restricted_to_project_subline_galaxia: {
        id: "search_ai.edit_definition_restricted_to_project_subline-galaxia",
        defaultMessage: "Previous definition will still show in other spaces."
    }
});


const $6cecfbe2a7b0bbf1$export$7475d9ffda76c69b = ({ onDismissed: onDismissed, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.FlagGroup), {
        onDismissed: ()=>onDismissed()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2foB.default), {
        id: "definition-update-success-adflag",
        title: formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_update_confirmation_title),
        description: formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_update_confirmation_description),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            label: "Success",
            color: "var(--ds-icon-success, #6A9A23)"
        }),
        testId: testId
    }));
};


/* edit-definition-modal.tsx generated by @compiled/babel-plugin v3.0.1 */ 



var $eiLi2 = parcelRequire("eiLi2");











var $kB5K2 = parcelRequire("kB5K2");


var $24dy7 = parcelRequire("24dy7");





























var $6wGOF = parcelRequire("6wGOF");


var $47D8u = parcelRequire("47D8u");


var $ieeJu = parcelRequire("ieeJu");










const $cd19353ea4c45398$export$ae4ae603f16dcf42 = ({ commonAttributes: commonAttributes, newDefinition: newDefinition, restrictedScope: restrictedScope, sourceSelected: sourceSelected, aiDefinitionEdited: aiDefinitionEdited })=>{
    const { query: keyPhrase, answerString: oldDefinition, extraAttributes: extraAttributes, source: source } = commonAttributes;
    const { contentId: contentId, readingAidsSessionId: readingAidsSessionId } = extraAttributes || {};
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionUpdateButton',
        source: source,
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: readingAidsSessionId,
            restrictedScope: restrictedScope,
            sourceSelected: sourceSelected,
            newDefinitionLength: newDefinition.length,
            aiDefinitionEdited: // whether the user is editing an AI answer or already edited definition
            aiDefinitionEdited
        },
        nonPrivacySafeAttributes: {
            keyPhrase: keyPhrase,
            oldDefinition: oldDefinition,
            newDefinition: newDefinition
        }
    };
};





const $e8986d45874ae352$export$ef8b7cdd9a33efb4 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiCuratedDefinitionUpdate',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};



var $jkdKe = parcelRequire("jkdKe");





var $jlRK6 = parcelRequire("jlRK6");


var $d7j1D = parcelRequire("d7j1D");


var $4nt1R = parcelRequire("4nt1R");


var $dVPAB = parcelRequire("dVPAB");


var $c9zHD = parcelRequire("c9zHD");


var $HGu9Y = parcelRequire("HGu9Y");


var $hFvHs = parcelRequire("hFvHs");


var $1171P = parcelRequire("1171P");





var $6FNab = parcelRequire("6FNab");


var $9DPMp = parcelRequire("9DPMp");

// throwing up the validation that an empty definition was valid CCSEARCH-4472
const $7e4b253a4704aa2d$export$7f32babab6e8c339 = (str)=>{
    return str.replace(/[\u200c]/g, '');
};


const $2858a64524f41982$export$18a9461578883ec4 = ({ value: value, setValue: setValue, setCharCount: setCharCount, assistiveLabel: assistiveLabel, assistiveDescribedBy: assistiveDescribedBy })=>{
    const { preset: preset } = (0, $dVPAB.usePreset)(()=>(0, $4nt1R.createDefaultPreset)({
            allowUndoRedoButtons: true,
            textFormatting: {
                responsiveToolbarMenu: true
            }
        }).add((0, $HGu9Y.indentationPlugin)).add((0, $hFvHs.listPlugin)).add([
            (0, $1171P.toolbarListsIndentationPlugin),
            {
                showIndentationButtons: true,
                allowHeadingAndParagraphIndentation: false
            }
        ]), []);
    const adfEncoder = (0, $cozmU.useMemo)(()=>new (0, $6FNab.ADFEncoder)((schema)=>new (0, $c9zHD.MarkdownTransformer)(schema)), []);
    const initializeEditor = (0, $cozmU.useCallback)((actions)=>{
        const encodedValue = adfEncoder.encode(value);
        actions.replaceDocument(encodedValue);
    }, [
        value,
        adfEncoder
    ]);
    const onEditorChange = (0, $cozmU.useCallback)((editorView)=>{
        const { markdown: markdown } = (0, $9DPMp.convertProsemirrorToMarkdown)({
            editorView: editorView,
            fragment: editorView.state.doc.content
        });
        // ? Editor component seems to add invisible characters in certain cases. Using this function to remove them and set back to the definition state.
        const markdownWithoutInvisibleChars = (0, $7e4b253a4704aa2d$export$7f32babab6e8c339)(markdown);
        setValue(markdownWithoutInvisibleChars);
        setCharCount?.(markdownWithoutInvisibleChars.length);
    }, [
        setValue,
        setCharCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
        appearance: "comment",
        preset: preset,
        shouldFocus: true,
        quickInsert: false,
        minHeight: 170,
        maxHeight: 90,
        onEditorReady: initializeEditor,
        onChange: onEditorChange,
        assistiveLabel: assistiveLabel,
        assistiveDescribedBy: assistiveDescribedBy
    }))));
};



/* radial-progress-bar.tsx generated by @compiled/babel-plugin v3.0.1 */ 





// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5db288be4e514131$var$Wrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _39xV02SPN1 _0jFU0VSPN1",
            __cmplp.className
        ])
    });
});
const $5db288be4e514131$var$CanvasWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _39xV02gZxp _0jFU0VgZxp _2IhTonZnY9 _3OE6xYZnY9 _1VJPcaHI3g",
            __cmplp.className
        ])
    });
});
const $5db288be4e514131$export$a4badf890ec26dc0 = ({ current: current, max: max })=>{
    const canvasRef = (0, $cozmU.useRef)(null);
    // Draw the current circle progress bar
    (0, $cozmU.useEffect)(()=>{
        const ctx = canvasRef.current?.getContext('2d');
        if (ctx) {
            if (current >= max) {
                ctx.beginPath();
                ctx.strokeStyle = '#E91618';
                ctx.lineWidth = 20;
                ctx.arc(100, 100, 80, 0, 2 * Math.PI);
                ctx.stroke();
            } else {
                ctx.beginPath();
                ctx.strokeStyle = '#DCDFE4';
                ctx.lineWidth = 20;
                ctx.arc(100, 100, 80, 0, 2 * Math.PI);
                ctx.stroke();
                ctx.beginPath();
                ctx.strokeStyle = '#22A06B';
                ctx.lineWidth = 20;
                ctx.arc(100, 100, 80, -0.5 * Math.PI, 2 * Math.PI * (current / max) - 0.5 * Math.PI);
                ctx.stroke();
            }
        }
    }, [
        current,
        max
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5db288be4e514131$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5db288be4e514131$var$CanvasWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("canvas", {
        ref: canvasRef,
        height: 200,
        width: 200
    })));
};


/* restriction-option-formatter.tsx generated by @compiled/babel-plugin v3.0.1 */ 







const $661e00bd00ca3cb9$var$styles = {
    optionWrapper: "_2sNsIgmnOE _1UtDYzy7kJ"
};
const $661e00bd00ca3cb9$export$66608c4e05327916 = (option)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $661e00bd00ca3cb9$var$styles.optionWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, option.icon, option.label));
};


/* source-option-formatter.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $lSQgn = parcelRequire("lSQgn");





var $9zxkL = parcelRequire("9zxkL");





var $ai0Ge = parcelRequire("ai0Ge");


var $6LZT4 = parcelRequire("6LZT4");












const $54d4d093910d9874$var$styles = {
    sourceOptionWrapper: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _24h04i2Njc _0wOv4Q7zJH _1eOmH6d1Zr _0ReiIH7zJH",
    sourceOptionTitle: "_2sNsIgmnOE _1UtDYzy7kJ",
    sourceOptionMetadata: "_2sNsIg7NXe _3iDTPbQ4SZ _1UtDYzKGUX",
    sourceOptionMetatadataSeparator: "_2XsHFM1Y8M _0adFHs1Y8M",
    sourceImageContainer: "_0jFU0VoWWg _39xV02oWWg"
};
const $54d4d093910d9874$var$SourceSpaceImage = ({ source: source })=>{
    return source.iconUrl ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $54d4d093910d9874$var$styles.sourceImageContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
        src: source.iconUrl,
        alt: ""
    })) : /*#__PURE__*/ $cozmU.createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zxkL))),
        label: "",
        appearance: "blueBold",
        size: "small"
    });
};
const $54d4d093910d9874$export$bd0bc6e060a5a86f = ({ source: source, canClear: canClear, onClickSource: onClickSource, onRemoveSource: onRemoveSource })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let sourceIcon = /*#__PURE__*/ $cozmU.createElement((0, $6LZT4.default), {
        size: "small",
        label: ""
    });
    if (source.type === 'space') sourceIcon = /*#__PURE__*/ $cozmU.createElement($54d4d093910d9874$var$SourceSpaceImage, {
        source: source
    });
    else if (source.type === 'blogpost') sourceIcon = /*#__PURE__*/ $cozmU.createElement((0, $ai0Ge.default), {
        size: "small",
        label: ""
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $54d4d093910d9874$var$styles.sourceOptionWrapper,
        onClick: onClickSource
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.150"
    }, sourceIcon, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $54d4d093910d9874$var$styles.sourceOptionTitle
    }, source.title), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $54d4d093910d9874$var$styles.sourceOptionMetadata
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, source.container), source.lastModified && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $54d4d093910d9874$var$styles.sourceOptionMetatadataSeparator
    }, `\u{2022}`), source.lastModified && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, `${formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_source_option_metadata_updated_text)} ${formatDate(source.lastModified, {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
    })}`)))), canClear ? /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        testId: `remove-source-${source.id}`,
        appearance: "subtle",
        onClick: onRemoveSource,
        label: (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? 'Remove source option' : 'remove-source-option-button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH)))
    }) : /*#__PURE__*/ $cozmU.createElement("div", null));
};

















const $64ff2c3c45ef8800$export$41f2c817c42b2303 = `
	mutation CreateDefinitionMutation(
		$workspaceId: String!
		$keyPhrase: String!
		$editedDefinition: String!
		$scope: KnowledgeDiscoveryDefinitionScope!
		$entityIdInScope: String!
		$referenceContentId: String
		$referenceUrl: String
		) {
		knowledgeDiscovery {
			createDefinition(
				input: {
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				definition: $editedDefinition
				scope: $scope
				entityIdInScope: $entityIdInScope
				referenceContentId: $referenceContentId
				referenceUrl: $referenceUrl
				}
			) @optIn(to: "KnowledgeDiscovery Create definition") {
			success
			errors {
				message
			}
			definitionDetails {
				keyPhrase
				definition
				editor {
					... on User {
						name
						accountId
					}
				}
				referenceUrl
				confluenceEntity {
					... on ConfluencePage {
					id
					type
					title
					space {
						name
					}
					}
					... on ConfluenceBlogPost {
					id
					type
					title
					space {
						name
					}
					}
				}
			}
		}
	}
  }
`;





const $571acb4b4ef932b1$export$248ff3a730ef0924 = ({ selectedScope: selectedScope, productScopes: productScopes, cloudId: cloudId })=>{
    let contentARI = '';
    let spaceARI = '';
    let projectARI = '';
    if ('contentARI' in productScopes) {
        contentARI = productScopes.contentARI;
        spaceARI = productScopes.spaceARI;
    }
    if ('projectARI' in productScopes) projectARI = productScopes.projectARI;
    switch(selectedScope){
        case (0, $jkdKe.EditedDefinitionScope).PAGE:
        case (0, $jkdKe.EditedDefinitionScope).BLOGPOST:
            return contentARI;
        case (0, $jkdKe.EditedDefinitionScope).SPACE:
            return spaceARI;
        case (0, $jkdKe.EditedDefinitionScope).PROJECT:
            return projectARI;
        default:
            return cloudId;
    }
};





const $9420450cf7eee89d$export$40e11c80593ec8d4 = (definitionDetails)=>{
    const definitionReferenceDetails = definitionDetails.confluenceEntity;
    return {
        nlpResult: definitionDetails.definition,
        uniqueSources: definitionDetails.confluenceEntity ? [
            {
                id: definitionReferenceDetails?.id || '',
                title: definitionReferenceDetails?.title || '',
                url: definitionDetails.referenceUrl || '',
                type: definitionReferenceDetails?.type || '',
                // for now we only allow users to add a source from Confluence
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: definitionReferenceDetails?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: {
            name: definitionDetails.editor?.name || '',
            id: definitionDetails.editor?.accountId || ''
        },
        disclaimer: null,
        errorState: null,
        format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN
    };
};


const $6a77ceaa0d40bc29$export$4c5c8822f1a42b9f = ({ curatedDefinitionScopeConfig: curatedDefinitionScopeConfig })=>{
    const { commonAttributes: commonAttributes, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const createDefinition = (0, $cozmU.useCallback)(async ({ keyPhrase: keyPhrase, editedDefinition: editedDefinition, scope: scope, referenceContentId: referenceContentId, referenceUrl: referenceUrl })=>{
        const { cloudId: cloudId } = commonAttributes;
        const { workspaceId: workspaceId, productScopes: productScopes } = curatedDefinitionScopeConfig;
        const entityIdInScope = (0, $571acb4b4ef932b1$export$248ff3a730ef0924)({
            selectedScope: scope,
            cloudId: cloudId,
            productScopes: productScopes
        });
        // check needed to account for Spaces being added as sources and submitted
        const contentId = 'contentARI' in productScopes && referenceContentId === entityIdInScope ? productScopes.contentARI : referenceContentId;
        return (0, $i5c0A.fetchAggResponse)({
            graphQuery: (0, $64ff2c3c45ef8800$export$41f2c817c42b2303),
            variables: {
                workspaceId: workspaceId || '',
                keyPhrase: keyPhrase,
                editedDefinition: editedDefinition,
                scope: scope,
                entityIdInScope: entityIdInScope,
                referenceContentId: contentId,
                referenceUrl: referenceUrl
            },
            headers: (0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: sourceProduct ?? ''
            })
        }).then((response)=>{
            if (response?.data?.knowledgeDiscovery.createDefinition?.success) {
                const definitionDetails = response.data.knowledgeDiscovery.createDefinition.definitionDetails;
                return definitionDetails && (0, $9420450cf7eee89d$export$40e11c80593ec8d4)(definitionDetails) || {
                    nlpResult: '',
                    format: (0, $hpFQM.NLPSearchResultFormat).PLAINTEXT,
                    uniqueSources: [],
                    errorState: null,
                    disclaimer: null
                };
            } else throw new Error('createDefinition mutation unsuccessful');
        });
    }, [
        commonAttributes,
        curatedDefinitionScopeConfig,
        sourceProduct
    ]);
    return {
        createDefinition: createDefinition
    };
};















var $jDZkE = parcelRequire("jDZkE");

const $4cc1094b17bfa51f$export$beaccb66a6ac7cc5 = `
	query ReadingAidsReferenceSearchQuery(
			$experience: String!
			$analytics: SearchAnalyticsInput
			$query: String!
			$filters: SearchFilterInput!
			$first: Int
		) {
		search {
			results: search(
				experience: $experience
				analytics: $analytics
				query: $query
				filters: $filters
				first: $first
			) {
				edges {
					node {
						type
						id
						title
						url
						iconUrl
						... on SearchConfluencePageBlogAttachment {
							lastModified
							space {
								name
							}
						}
						... on SearchConfluenceSpace {
							id
							title
							url
						}
					}
				}
			}
		}
	}
`;


const $8635b0acf53038fc$export$3b4150834edadf59 = (query)=>{
    const pageOrBlogRegex = /spaces\/.*\/(pages|blog)/;
    const spaceRegex = /https:\/\/[^\/]+\/wiki\/spaces\/(?!.*\/(pages|blog)).*/;
    const confluenceTinyRegex = RegExp("\\/wiki\\/x\\/(?<resourceId>[^\\/(?)]+)$");
    const queryParts = query.split('/');
    const queryParamsRemoved = query.split('?')[0];
    if (query.match(pageOrBlogRegex)) // e.g. https://hello.atlassian.net/wiki/spaces/AAI/pages/3665fakeId/Test+Page+Title
    return {
        searchQuery: queryParts[queryParts.length - 1],
        entities: [
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost'
        ],
        spacesFilter: undefined
    };
    else if (query.match(spaceRegex)) {
        // e.g. https://hello.atlassian.net/wiki/spaces/SK1/overview
        const spacesIndex = queryParts.indexOf('spaces');
        return {
            searchQuery: '',
            entities: [
                'ati:cloud:confluence:space'
            ],
            spacesFilter: [
                spacesIndex > -1 ? queryParts[spacesIndex + 1] : ''
            ]
        };
    } else if (queryParamsRemoved.match(confluenceTinyRegex)) // e.g. https://hello.atlassian.net/wiki/x/4c942w
    return {
        searchQuery: '',
        entities: [
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost'
        ],
        spacesFilter: undefined,
        needsLinkResolution: true
    };
    return {
        searchQuery: query,
        entities: [
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost',
            'ati:cloud:confluence:space'
        ],
        spacesFilter: undefined
    };
};


const $4cd3e1a874bd33ba$var$OBJECT_RESOLVE_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $4cd3e1a874bd33ba$export$11c4e3b6769b440d = ()=>{
    const { commonAttributes: commonAttributes, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, extraAttributes: extraAttributes, workspaceId: workspaceId } = commonAttributes;
    const { readingAidsSessionId: readingAidsSessionId } = extraAttributes;
    const searchSources = (0, $cozmU.useCallback)(async (query)=>{
        const { searchQuery: searchQuery, entities: entities, spacesFilter: spacesFilter, needsLinkResolution: needsLinkResolution } = (0, $8635b0acf53038fc$export$3b4150834edadf59)(query);
        let details;
        if (needsLinkResolution) details = await (0, $jDZkE.fetchRestResponse)({
            url: $4cd3e1a874bd33ba$var$OBJECT_RESOLVE_ENDPOINT,
            body: [
                {
                    resourceUrl: query.split('?')[0]
                }
            ]
        });
        return (0, $i5c0A.fetchAggResponse)({
            graphQuery: (0, $4cc1094b17bfa51f$export$beaccb66a6ac7cc5),
            variables: {
                experience: 'curated-definition-source-search',
                analytics: {
                    searchSessionId: readingAidsSessionId
                },
                query: details?.[0]?.body?.data?.name ?? searchQuery,
                filters: {
                    entities: entities,
                    locations: [
                        cloudId ? `ari:cloud:confluence::site/${cloudId}` : ''
                    ],
                    confluenceFilters: {
                        titleMatchOnly: true,
                        spacesFilter: spacesFilter
                    }
                },
                first: 5
            },
            headers: (0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: sourceProduct ?? ''
            })
        }).then((response)=>{
            if (response.data) return response.data.search.results.edges.map((edge)=>({
                    id: edge.node?.id || '',
                    type: edge.node?.type || '',
                    title: edge.node?.title || '',
                    container: edge.node?.space?.name || '',
                    url: edge.node?.url || '',
                    iconUrl: edge.node?.iconUrl || '',
                    lastModified: edge.node?.lastModified || ''
                }));
            return [];
        });
    }, [
        cloudId,
        readingAidsSessionId,
        workspaceId,
        sourceProduct
    ]);
    return {
        searchSources: searchSources
    };
};


const $46b3319f0a259942$var$MAX_DEFINITION_LENGTH = 500;
const $46b3319f0a259942$var$editDefintionModalStyles = {
    editDefinitionTextboxLabelContainer: "_0xmtko1Y8M",
    editDefinitionTextboxErrorMessageContainer: "_46hvQm1Y8M",
    radialProgressBarContainer: "_0xmtkoFQfX",
    restrictionSelectSublineContainer: "_46hvQm1Y8M"
};
const $46b3319f0a259942$export$ea8c8594ad1f3bf3 = ({ curatedDefinitionScopeConfig: curatedDefinitionScopeConfig, closeEditModal: closeEditModal, openFeedbackOptionsModal: openFeedbackOptionsModal, isCreateDefinition: isCreateDefinition, onSaveEditModal: onSaveEditModal })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, setData: setData, answerEditor: answerEditor, additionalQueryContext: additionalQueryContext } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString, query: keyPhrase } = commonAttributes;
    const [editedDefinition, setEditedDefinition] = (0, $cozmU.useState)(answerString);
    const [charCount, setCharCount] = (0, $cozmU.useState)(0);
    const emptyDefinition = editedDefinition.trim() === '';
    const definitionOverMaxLength = charCount > $46b3319f0a259942$var$MAX_DEFINITION_LENGTH;
    const updateDefinitionDisabled = emptyDefinition || definitionOverMaxLength;
    const [sourceSearchInput, setSourceSearchInput] = (0, $cozmU.useState)('');
    const [source, setSource] = (0, $cozmU.useState)(null);
    const sourceSelectRef = (0, $cozmU.useRef)(null);
    const [sourceJustRemoved, setSourceJustRemoved] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (sourceJustRemoved && sourceSelectRef.current && (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true)) {
            sourceSelectRef.current.focus();
            setSourceJustRemoved(false);
        }
    }, [
        sourceJustRemoved
    ]);
    const { definitionRestrictionOptions: definitionRestrictionOptions } = curatedDefinitionScopeConfig;
    const defaultRestrictionOption = definitionRestrictionOptions[0];
    const [audienceRestriction, setAudienceRestriction] = (0, $cozmU.useState)(defaultRestrictionOption.value);
    const [updateDefinitionLoading, setUpdateDefinitionLoading] = (0, $cozmU.useState)(false);
    const setDefinition = (0, $cozmU.useCallback)((value)=>{
        setEditedDefinition(value);
    }, [
        setEditedDefinition
    ]);
    const { searchSources: searchSources } = (0, $4cd3e1a874bd33ba$export$11c4e3b6769b440d)();
    const onSourceSearchInputChange = (input, actionMeta)=>{
        if (actionMeta.action === 'input-change') setSourceSearchInput(input);
    };
    const onSelectSource = (newValue, actionMeta)=>{
        if (actionMeta.action === 'select-option') setSource(newValue);
    };
    const onSelectRestrictionOption = (newValue, actionMeta)=>{
        if (actionMeta.action === 'select-option') setAudienceRestriction(newValue?.value || (0, $jkdKe.EditedDefinitionScope).ORGANIZATION);
    };
    const { createDefinition: createDefinition } = (0, $6a77ceaa0d40bc29$export$4c5c8822f1a42b9f)({
        curatedDefinitionScopeConfig: curatedDefinitionScopeConfig
    });
    const onUpdateDefinition = async ()=>{
        setUpdateDefinitionLoading(true);
        try {
            const updatedDefinition = await createDefinition({
                keyPhrase: keyPhrase,
                editedDefinition: editedDefinition,
                scope: audienceRestriction,
                referenceContentId: source ? source.id : null,
                referenceUrl: source ? source.url : null
            });
            setUpdateDefinitionLoading(false);
            setSource(null);
            fireAnalyticsEvent((0, $cd19353ea4c45398$export$ae4ae603f16dcf42)({
                commonAttributes: commonAttributes,
                newDefinition: editedDefinition,
                restrictedScope: audienceRestriction,
                sourceSelected: !!source,
                aiDefinitionEdited: !!!answerEditor
            }));
            setData(updatedDefinition);
            (0, $6JEx2.setSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
                query: keyPhrase,
                additionalContext: additionalQueryContext || '',
                data: updatedDefinition
            }));
            closeEditModal();
            onSaveEditModal?.();
        } catch (error) {
            fireAnalyticsEvent((0, $e8986d45874ae352$export$ef8b7cdd9a33efb4)(error, commonAttributes));
            setUpdateDefinitionLoading(false);
        }
    };
    let conditionalSublineMessage;
    switch(audienceRestriction){
        case (0, $jkdKe.EditedDefinitionScope).SPACE:
            conditionalSublineMessage = (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_space_subline;
            break;
        case (0, $jkdKe.EditedDefinitionScope).PROJECT:
            conditionalSublineMessage = (0, $cXtTj.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_project_subline_galaxia : (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_project_subline;
            break;
        case (0, $jkdKe.EditedDefinitionScope).PAGE:
            conditionalSublineMessage = (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_page_subline;
            break;
        case (0, $jkdKe.EditedDefinitionScope).BLOGPOST:
            conditionalSublineMessage = (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_space_subline;
            break;
        case (0, $jkdKe.EditedDefinitionScope).ORGANIZATION:
            conditionalSublineMessage = (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_site_subline;
            break;
        default:
            conditionalSublineMessage = (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_site_subline;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: closeEditModal,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, formatMessage(isCreateDefinition ? (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_modal_header_create : (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_modal_header_edit))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text.subtle"
    }, formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_modal_subheader_text), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: "https://support.atlassian.com/rovo/docs/add-or-edit-a-definition/"
    }, formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_modal_subheader_link_text))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        grow: "fill",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $46b3319f0a259942$var$editDefintionModalStyles.editDefinitionTextboxLabelContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        weight: "bold",
        size: "small"
    }, formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_text_box_label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        size: "small",
        color: "color.text.subtle"
    }, charCount, "/", $46b3319f0a259942$var$MAX_DEFINITION_LENGTH), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $46b3319f0a259942$var$editDefintionModalStyles.radialProgressBarContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5db288be4e514131$export$a4badf890ec26dc0), {
        current: charCount,
        max: $46b3319f0a259942$var$MAX_DEFINITION_LENGTH
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2858a64524f41982$export$18a9461578883ec4), {
        value: editedDefinition,
        setValue: setDefinition,
        setCharCount: setCharCount,
        assistiveLabel: formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_text_box_label_with_count, {
            count: charCount,
            max: $46b3319f0a259942$var$MAX_DEFINITION_LENGTH
        }),
        assistiveDescribedBy: "edit-definition-text-box-error-message"
    }), updateDefinitionDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050",
        xcss: $46b3319f0a259942$var$editDefintionModalStyles.editDefinitionTextboxErrorMessageContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-text-danger, #AE2E24)",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.danger",
        size: "small",
        id: "edit-definition-text-box-error-message"
    }, emptyDefinition ? formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_no_definition) : formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_over_max_length, {
        max: $46b3319f0a259942$var$MAX_DEFINITION_LENGTH
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "edit-definition-source-select"
    }, formatMessage(source ? (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_source_label : (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_add_source_label)), source ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $54d4d093910d9874$export$bd0bc6e060a5a86f), {
        source: source,
        onClickSource: ()=>{
            window.open(source.url, '_blank')?.focus();
        },
        canClear: true,
        onRemoveSource: (e)=>{
            e.stopPropagation();
            setSource(null);
            if ((0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true)) setSourceJustRemoved(true);
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47D8u.default), {
        ref: sourceSelectRef,
        components: {
            DropdownIndicator: ()=>null
        },
        loadOptions: (0, (/*@__PURE__*/$parcel$interopDefault($eiLi2)))((input)=>searchSources(input), 500),
        formatOptionLabel: (sourceOption)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $54d4d093910d9874$export$bd0bc6e060a5a86f), {
                source: sourceOption,
                canClear: false
            }),
        onChange: onSelectSource,
        inputValue: sourceSearchInput,
        onInputChange: onSourceSearchInputChange,
        placeholder: formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_source_search_box_placeholder),
        menuPosition: "fixed",
        inputId: "edit-definition-source-select"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "edit-definition-restriction-select"
    }, formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        options: definitionRestrictionOptions,
        defaultValue: defaultRestrictionOption,
        onChange: onSelectRestrictionOption,
        formatOptionLabel: (0, $661e00bd00ca3cb9$export$66608c4e05327916),
        isSearchable: false,
        menuPosition: "fixed",
        inputId: "edit-definition-restriction-select",
        descriptionId: "edit-definition-restriction-subline"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $46b3319f0a259942$var$editDefintionModalStyles.restrictionSelectSublineContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage(conditionalSublineMessage)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, openFeedbackOptionsModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: ()=>{
            closeEditModal();
            openFeedbackOptionsModal();
        }
    }, formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_back_button)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: updateDefinitionDisabled ? 'default' : 'primary',
        isLoading: updateDefinitionLoading,
        onClick: onUpdateDefinition,
        isDisabled: updateDefinitionDisabled
    }, formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_update_button))));
};





const $5e3b152f98329dbd$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    definition_no_answer_error: {
        id: "search_ai.definition_no_answer_error",
        defaultMessage: "{brand} doesn\u2019t have enough data to provide a definition right now. It\u2019s possible that we couldn\u2019t find the relevant information in your company\u2019s knowledge base."
    },
    definition_no_answer_acceptable_use_error: {
        id: "search_ai.definition_no_answer_acceptable_use_error",
        defaultMessage: "{brand} can\u2019t provide you with a definition, as it might go against {acceptableUseLink}"
    },
    definition_no_answer_acceptable_use_link: {
        id: "search_ai.definition_no_answer_acceptable_use_link",
        defaultMessage: "Atlassian's acceptable use policy"
    },
    definition_no_answer_network_error: {
        id: "search_ai.definition_no_answer_network_error",
        defaultMessage: "{brand} can't provide a definition right now. Read more in our {supportLink}"
    },
    definitions_support_link_text: {
        id: "search_ai.definitions_support_link_text",
        defaultMessage: "support documentation"
    },
    definition_no_answer_add_definition_button: {
        id: "search_ai.definition_no_answer_add_definition_button",
        defaultMessage: "Add definition"
    },
    definitions_no_answer_error_state_hipaa: {
        id: "search_ai.definitions_no_answer_error_state_hipaa",
        defaultMessage: "Due to HIPAA compliance, we can\u2019t provide an answer. {supportLink}."
    },
    definitions_no_answer_hipaa_compliance_link: {
        id: "search_ai.definitions_no_answer_hipaa_compliance_link",
        defaultMessage: "Find out more about HIPAA"
    }
});


const $9aa0fbefc962e4d5$var$styles = {
    errorPadding: "_1wydGW2ADO",
    errorMessage: "_2sNsIgmnOE _1UtDYzy7kJ"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9aa0fbefc962e4d5$var$InfoLink = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYz66Yw",
            __cmplp.className
        ])
    });
});
const $9aa0fbefc962e4d5$export$f874592093e19f27 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { brand: brand, commonAttributes: { errorState: errorState }, readingAidsOptions: readingAidsOptions } = (0, $3hVWe.useAIAnswerContext)();
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const createDefinitionEnabled = !!definitionCurationOptions;
    const [showEditDefinitionModal, setShowEditDefinitionModal] = (0, $cozmU.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $cozmU.useState)(false);
    const showAddDefinitionButton = createDefinitionEnabled && (errorState === (0, $htnqN.NLPSearchErrorState).NoAnswer || errorState === (0, $htnqN.NLPSearchErrorState).NoAnswerKeywords || errorState === (0, $htnqN.NLPSearchErrorState).NoAnswerSearchResults || errorState === (0, $htnqN.NLPSearchErrorState).NoAnswerHydration || errorState === (0, $htnqN.NLPSearchErrorState).NoAnswerRelevantContent || errorState === (0, $htnqN.NLPSearchErrorState).Default);
    const errorMessage = (0, $cozmU.useMemo)(()=>{
        switch(errorState){
            case (0, $htnqN.NLPSearchErrorState).AcceptableUseViolation:
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $5e3b152f98329dbd$export$defe85febe8b728c).definition_no_answer_acceptable_use_error,
                    values: {
                        acceptableUseLink: /*#__PURE__*/ $cozmU.createElement($9aa0fbefc962e4d5$var$InfoLink, {
                            href: (0, $15c17b140b3e21b2$export$96cc4126cdc27248),
                            target: '_blank'
                        }, formatMessage((0, $5e3b152f98329dbd$export$defe85febe8b728c).definition_no_answer_acceptable_use_link)),
                        brand: brand === (0, $zzZbq.AiBrand).AI ? 'Atlassian Intelligence' : 'Rovo'
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).NetworkError:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerOpenAIResponseError:
            case (0, $htnqN.NLPSearchErrorState).AIDisabled:
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $5e3b152f98329dbd$export$defe85febe8b728c).definition_no_answer_network_error,
                    values: {
                        brand: brand === (0, $zzZbq.AiBrand).AI ? 'Atlassian Intelligence' : 'Rovo',
                        supportLink: /*#__PURE__*/ $cozmU.createElement($9aa0fbefc962e4d5$var$InfoLink, {
                            href: (0, $15c17b140b3e21b2$export$50e6b843de210064),
                            target: '_blank'
                        }, formatMessage((0, $5e3b152f98329dbd$export$defe85febe8b728c).definitions_support_link_text))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).HIPAAError:
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $5e3b152f98329dbd$export$defe85febe8b728c).definitions_no_answer_error_state_hipaa,
                    values: {
                        supportLink: /*#__PURE__*/ $cozmU.createElement($9aa0fbefc962e4d5$var$InfoLink, {
                            href: (0, $15c17b140b3e21b2$export$dd87179defae3659),
                            target: '_blank'
                        }, formatMessage((0, $5e3b152f98329dbd$export$defe85febe8b728c).definitions_no_answer_hipaa_compliance_link))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).NoAnswer:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerKeywords:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerSearchResults:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerHydration:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerRelevantContent:
            case (0, $htnqN.NLPSearchErrorState).Default:
            default:
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $5e3b152f98329dbd$export$defe85febe8b728c).definition_no_answer_error,
                    values: {
                        brand: brand === (0, $zzZbq.AiBrand).AI ? 'Atlassian Intelligence' : 'Rovo'
                    }
                });
        }
    }, [
        errorState,
        formatMessage,
        brand
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9aa0fbefc962e4d5$var$styles.errorPadding
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9aa0fbefc962e4d5$var$styles.errorMessage
    }, errorMessage), showAddDefinitionButton && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        justifyContent: "end",
        alignItems: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: ()=>setShowEditDefinitionModal(true)
    }, formatMessage((0, $5e3b152f98329dbd$export$defe85febe8b728c).definition_no_answer_add_definition_button)))), /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, showEditDefinitionModal && showAddDefinitionButton && /*#__PURE__*/ $cozmU.createElement((0, $46b3319f0a259942$export$ea8c8594ad1f3bf3), {
        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
        closeEditModal: ()=>setShowEditDefinitionModal(false),
        isCreateDefinition: true,
        onSaveEditModal: ()=>setDisplaySuccessFlag(true)
    })), displaySuccessFlag && /*#__PURE__*/ $cozmU.createElement((0, $6cecfbe2a7b0bbf1$export$7475d9ffda76c69b), {
        onDismissed: ()=>setDisplaySuccessFlag(false)
    }));
};








/* ai-answer-result-section.tsx generated by @compiled/babel-plugin v3.0.1 */ 










const $dc507febe9bd909d$export$d74b491f1ba95e72 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReadingAids: isReadingAids, serveDefinitionUXExp: serveDefinitionUXExp, isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_17h6egw": (0, $9aYkv.default)(__cmplp.serveDefinitionUXExp ? "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"),
            "--_4xki78": (0, $9aYkv.default)(__cmplp.serveDefinitionUXExp ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $zzZbq.READING_AIDS_DIALOG_WIDTH) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(${0, $zzZbq.READING_AIDS_DIALOG_WIDTH} - 40px)`),
            "--_1wfhr4q": (0, $9aYkv.default)(__cmplp.isExpanded ? 'fit-content' : '120px')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.isReadingAids ? "_2sNsIgLMcr _1UtDYzyXux _1EqgXlX4J4 _0NUa3rm0pH _2WAcuGnQyn _1AiXLTxAvX" : "_2sNsIgmnOE _1UtDYzUktF _2WAcuGIZbP _39xV02N91d",
            __cmplp.className
        ])
    });
});


/* info-link.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $99356d7abc78c115$export$aef3857145d55f98 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYz66Yw",
            __cmplp.className
        ])
    });
});


const $f366b75433df2895$export$ffa24cd7196ce1b0 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { advancedSearchUrl: advancedSearchUrl, commonAttributes: commonAttributes, isReadingAids: isReadingAids, brand: brand, smartAnswersRoute: smartAnswersRoute, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const { errorState: errorState, errorCode: errorCode, answerCardType: answerCardType, source: source, apiSource: apiSource, searchSessionId: searchSessionId, sessionId: sessionId, queryHash: queryHash } = commonAttributes;
    const { trackAIResultError: trackAIResultError } = (0, $cFVPs.useAIEventsInstrumentation)();
    (0, $cozmU.useEffect)(()=>{
        if (errorState !== (0, $htnqN.NLPSearchErrorState).Default) {
            trackAIResultError({
                aiErrorMessage: errorState || '',
                aiErrorCode: errorCode ?? 0
            }, {
                attributes: {
                    aiExperienceName: (0, $b8dde4ad487d9f98$export$38439c13a4683ecf)(smartAnswersRoute),
                    aiFeatureName: isReadingAids ? `Definitions ${sourceProduct ? `(${sourceProduct})` : ''}` : 'smartAnswers',
                    aiInteractionId: isReadingAids ? undefined : searchSessionId,
                    aiInteractionType: isReadingAids ? undefined : 'searchSessionId'
                }
            });
            if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
                error: {
                    errorState: errorState,
                    errorCode: errorCode,
                    answerCardType: answerCardType,
                    source: source,
                    apiSource: apiSource,
                    sessionId: sessionId,
                    queryHash: queryHash
                },
                functionName: 'AIAnswerError'
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const brandName = brand === (0, $zzZbq.AiBrand).ROVO ? 'Rovo' : 'Atlassian Intelligence';
    const errorMessage = (0, $cozmU.useMemo)(()=>{
        switch(errorState){
            case (0, $htnqN.NLPSearchErrorState).NoAnswer:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerSearchResults:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerHydration:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerRelevantContent:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_error_state_no_answer,
                    values: {
                        brandName: brandName,
                        learnMoreLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99356d7abc78c115$export$aef3857145d55f98), {
                            href: (0, $zzZbq.ATLASSIAN_INTELLIGENCE_SEARCH_INFO_LINK),
                            target: '_blank'
                        }, formatMessage((0, $cb86z.messages).ai_answer_onboarding_banner_tooltip_link))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).NoAnswerKeywords:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_error_state_keyword,
                    values: {
                        brandName: brandName,
                        learnMoreLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99356d7abc78c115$export$aef3857145d55f98), {
                            href: (0, $zzZbq.ATLASSIAN_INTELLIGENCE_SEARCH_INFO_LINK),
                            target: '_blank'
                        }, formatMessage((0, $cb86z.messages).ai_answer_onboarding_banner_tooltip_link))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).AcceptableUseViolation:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_error_state_acceptable_use,
                    values: {
                        brandName: brandName,
                        acceptableUseLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99356d7abc78c115$export$aef3857145d55f98), {
                            href: (0, $zzZbq.ATLASSIAN_ACCEPTABLE_USE_POLICY_LINK),
                            target: '_blank'
                        }, formatMessage((0, $cb86z.messages).ai_answer_component_error_state_acceptable_use_link))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).SubjectiveQuery:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_error_state_subjective_query,
                    values: {
                        brandName: brandName
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_open_ai_rate_limit_error,
                    values: {
                        brandName: brandName,
                        supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99356d7abc78c115$export$aef3857145d55f98), {
                            href: (0, $zzZbq.ATLASSIAN_AI_USAGE_LIMITS_LINK),
                            target: '_blank'
                        }, formatMessage((0, $cb86z.messages).ai_answer_component_support_link))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).NoAnswerWhoQuestion:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_error_state_no_who_is_answer,
                    values: {
                        brandName: brandName
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).NetworkError:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerOpenAIResponseError:
            case (0, $htnqN.NLPSearchErrorState).AIDisabled:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_error_state_network,
                    values: {
                        brandName: brandName,
                        supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99356d7abc78c115$export$aef3857145d55f98), {
                            href: (0, $zzZbq.ATLASSIAN_AI_TROUBLESHOOT_LINK),
                            target: '_blank'
                        }, formatMessage((0, $cb86z.messages).ai_answer_component_support_link))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).HIPAAError:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_error_state_hipaa,
                    values: {
                        supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99356d7abc78c115$export$aef3857145d55f98), {
                            href: (0, $zzZbq.ATLASSIAN_HIPAA_COMPLICANCE_LINK),
                            target: '_blank'
                        }, formatMessage((0, $cb86z.messages).ai_answer_component_hipaa_compliance_link))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).EarlyStop:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7af86847637791a4$export$97b52c363fbe053e), null);
            case (0, $htnqN.NLPSearchErrorState).Default:
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_result_error_text,
                    values: {
                        brandName: brandName,
                        advancedSearchLink: !!advancedSearchUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: advancedSearchUrl
                        }, formatMessage((0, $cb86z.messages).ai_answer_component_result_error_advanced_search_link)) : formatMessage((0, $cb86z.messages).ai_answer_component_result_error_advanced_search_link)
                    }
                });
        }
    }, [
        advancedSearchUrl,
        errorState,
        formatMessage,
        brandName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "ai-answer-error-container"
    }, isReadingAids ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9aa0fbefc962e4d5$export$f874592093e19f27), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc507febe9bd909d$export$d74b491f1ba95e72), {
        isReadingAids: isReadingAids,
        isExpanded: true
    }, errorMessage)));
};














var $2uDbg = parcelRequire("2uDbg");










/* open-chat-button.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $bLfHG = parcelRequire("bLfHG");








var $jPaq9 = parcelRequire("jPaq9");











var $dDQsD = parcelRequire("dDQsD");



















const $17ec11618fdbd65e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ai_answer_component_ai_answer_open_chat: {
        id: "search_ai.ai_answer_open_chat",
        defaultMessage: "Open chat"
    },
    ai_answer_component_ai_answer_ask_more_chat: {
        id: "search_ai.ai_answer_ask_more_chat",
        defaultMessage: "Ask more in Chat"
    },
    ai_answer_component_ai_answer_ask_more_chat_submit: {
        id: "search_ai.ai_answer_ask_more_chat_submit",
        defaultMessage: "Submit"
    }
});


const $1781bd9c74b8683a$var$styles = {
    chatButtonContainer: "_39xV02E6Kk"
};
const $1781bd9c74b8683a$export$dc40dedc9df6e59f = ({ prompt: prompt, answerString: answerString, query: query, source: source })=>{
    const { commonAttributes: commonAttributes, isReadingAids: isReadingAids, onClose: onClose, readingAidsOptions: readingAidsOptions } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const onOpenChatClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $dDQsD.onOpenChatButtonClick)({
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).OPEN_CHAT_CLICKED,
            commonAttributes: commonAttributes
        });
        // callback is shared with followups
        // used in the issue model view to open up chat in a new tab
        // this is because we don't have access to dismiss the issue view modal
        if (readingAidsOptions?.onFollowUpCallback) {
            readingAidsOptions.onFollowUpCallback(prompt);
            return;
        }
        publish({
            type: 'chat-new',
            source: source,
            data: {
                name: query.substring(0, 30),
                dialogues: [
                    {
                        human_message: {
                            content: prompt
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ],
                sourceId: commonAttributes.searchSessionId
            }
        });
        onClose?.();
    }, [
        query,
        answerString,
        publish,
        onClose,
        commonAttributes,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        prompt,
        source,
        readingAidsOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, serveDefinitionUXUpdates && isReadingAids || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1781bd9c74b8683a$var$styles.chatButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))),
        spacing: (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? 'default' : 'compact',
        shouldFitContainer: false,
        onClick: onOpenChatClick,
        testId: "definition-open-chat-button"
    }, formatMessage((0, $17ec11618fdbd65e$export$defe85febe8b728c).ai_answer_component_ai_answer_open_chat))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jPaq9.ChatPill), {
        onClick: onOpenChatClick
    }, formatMessage((0, $17ec11618fdbd65e$export$defe85febe8b728c).ai_answer_component_ai_answer_open_chat)));
};











/* definition-footer.tsx generated by @compiled/babel-plugin v3.0.1 */ 

































/* edit-history-modal.tsx generated by @compiled/babel-plugin v3.0.1 */ 















var $kkFbH = parcelRequire("kkFbH");


var $7A1BE = parcelRequire("7A1BE");


var $kpuvJ = parcelRequire("kpuvJ");


var $ds2zu = parcelRequire("ds2zu");


var $d4GYd = parcelRequire("d4GYd");




















var $iW3KC = parcelRequire("iW3KC");


var $2qJQZ = parcelRequire("2qJQZ");












var $lfoFx = parcelRequire("lfoFx");

























const $c9690aea5fb0b0a7$export$4d25b49b6dc1b540 = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        // when country code is missed, let it empty and we will use language/locale to find language file
        country: country ? country.toUpperCase() : ''
    };
};


function $4a1753bc458304c7$export$5ac26fa9b941854e(locale, fetchLanguageFile) {
    const [messages, setMessages] = (0, $cozmU.useState)({});
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const { language: language, country: country } = (0, $c9690aea5fb0b0a7$export$4d25b49b6dc1b540)(locale);
            // don't load English messages
            if (language === 'en') return;
            try {
                setIsLoading(true);
                const finalLocale = country ? `${language}-${country}` : language;
                const languageFile = await fetchLanguageFile(finalLocale);
                const newMessages = languageFile.default || languageFile;
                setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
    }, [
        fetchLanguageFile,
        locale
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}
const $4a1753bc458304c7$var$WithMessages = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, fetchLanguageFile: fetchLanguageFile } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { messages: messages } = $4a1753bc458304c7$export$5ac26fa9b941854e(intl.locale, fetchLanguageFile);
    let t1;
    if ($[0] !== children || $[1] !== intl.locale || $[2] !== messages) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            messages: messages,
            locale: intl.locale
        }, children);
        $[0] = children;
        $[1] = intl.locale;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children, fetchLanguageFile: fetchLanguageFile })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { messages: messages } = $4a1753bc458304c7$export$5ac26fa9b941854e(intl.locale, fetchLanguageFile);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        messages: messages,
        locale: intl.locale
    }, children);
};
function $4a1753bc458304c7$export$45d3ca664b6e3027(Component, fetchLanguageFile) {
    return (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4a1753bc458304c7$var$WithMessages, {
            fetchLanguageFile: fetchLanguageFile
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props));
    };
}



























function $7a8fa43e2e417c08$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("8cQty"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("7Ktzp"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("3OvSI"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("3KmhA"));
        case 'et-EE':
        case 'et':
            return (parcelRequire("1AEVX"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("gQR0I"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("fZZNg"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("85e4s"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("5aiwI"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("d0yG9"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("566HE"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("7hJxV"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("8Yv6U"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("6KeUd"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("Xhn9f"));
        case 'pt-PT':
            return (parcelRequire("lKGOU"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("51a3b"));
        case 'sk-SK':
        case 'sk':
            return (parcelRequire("drfHK"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("i8A0w"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("bYxqJ"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("fMBja"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("lFCIm"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("3OZQe"));
        case 'zh-TW':
        case 'zh-HK':
        case 'zh':
            return (parcelRequire("iytmX"));
        case 'zh-ZH':
        case 'zh-CN':
            return (parcelRequire("1sS5a"));
    }
    return Promise.resolve({
        default: {}
    });
}





const $6871b3025cf26e91$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    justNow: {
        id: "com.atlassian.migrations-platform.mpt-timeago.ui.just-now",
        defaultMessage: "just now"
    }
});


const $742565d3da98c155$var$SECOND = 1;
const $742565d3da98c155$var$MINUTE = 60;
const $742565d3da98c155$var$HOUR = $742565d3da98c155$var$MINUTE * 60;
const $742565d3da98c155$var$DAY = $742565d3da98c155$var$HOUR * 24;
const $742565d3da98c155$var$WEEK = $742565d3da98c155$var$DAY * 7;
const $742565d3da98c155$var$MONTH = $742565d3da98c155$var$WEEK * 4.345;
const $742565d3da98c155$var$YEAR = $742565d3da98c155$var$MONTH * 12;
const $742565d3da98c155$var$units = [
    [
        'year',
        $742565d3da98c155$var$YEAR
    ],
    [
        'month',
        $742565d3da98c155$var$MONTH
    ],
    [
        'week',
        $742565d3da98c155$var$WEEK
    ],
    [
        'day',
        $742565d3da98c155$var$DAY
    ],
    [
        'hour',
        $742565d3da98c155$var$HOUR
    ],
    [
        'minute',
        $742565d3da98c155$var$MINUTE
    ],
    [
        'second',
        $742565d3da98c155$var$SECOND
    ]
];
const $742565d3da98c155$var$getRelativeTimeProps = (timeDifferenceInSeconds)=>{
    const relevantUnit = $742565d3da98c155$var$units.find((unit)=>{
        return timeDifferenceInSeconds >= unit[1];
    }) || $742565d3da98c155$var$units[0];
    let props = {
        value: -Math.floor(timeDifferenceInSeconds / relevantUnit[1]),
        unit: relevantUnit[0]
    };
    // Only create the update interval if time difference in seconds, minutes or hours
    // FormattedRelativeTime no longer supports higher than 'hour' for interval update
    // read "Limitation" on https://formatjs.io/docs/react-intl/components/#formattedrelativetime
    if ([
        'second',
        'minute',
        'hour'
    ].includes(relevantUnit[0])) return {
        ...props,
        updateIntervalInSeconds: 60
    };
    return props;
};
const $742565d3da98c155$var$TimeAgo = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { date: date } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Date().getTime();
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== date) {
        t2 = new Date(date).getTime();
        $[1] = date;
        $[2] = t2;
    } else t2 = $[2];
    const differenceInSeconds = Math.floor((t1 - t2) / 1000);
    const isLessThanOneMinuteAgo = differenceInSeconds < 60;
    const [showJustNow, setShowJustNow] = (0, $cozmU.useState)(isLessThanOneMinuteAgo);
    let t3;
    let t4;
    if ($[3] !== differenceInSeconds || $[4] !== isLessThanOneMinuteAgo) {
        t3 = ()=>{
            let timeout;
            if (isLessThanOneMinuteAgo) {
                setShowJustNow(true);
                const refreshTime = (60 - differenceInSeconds) * 1000;
                timeout = setTimeout(()=>{
                    setShowJustNow(false);
                }, refreshTime);
            }
            return ()=>{
                if (timeout) clearTimeout(timeout);
            };
        };
        t4 = [
            differenceInSeconds,
            isLessThanOneMinuteAgo
        ];
        $[3] = differenceInSeconds;
        $[4] = isLessThanOneMinuteAgo;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (showJustNow) {
        let t5;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6871b3025cf26e91$export$defe85febe8b728c).justNow);
            $[7] = t5;
        } else t5 = $[7];
        return t5;
    }
    let t5;
    if ($[8] !== differenceInSeconds) {
        t5 = $742565d3da98c155$var$getRelativeTimeProps(differenceInSeconds);
        $[8] = differenceInSeconds;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedRelativeTime), {
            numeric: "always",
            ...t5
        });
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ date: date })=>{
    const differenceInSeconds = Math.floor((new Date().getTime() - new Date(date).getTime()) / 1000);
    const isLessThanOneMinuteAgo = differenceInSeconds < 60;
    const [showJustNow, setShowJustNow] = (0, $cozmU.useState)(isLessThanOneMinuteAgo);
    (0, $cozmU.useEffect)(()=>{
        let timeout;
        if (isLessThanOneMinuteAgo) {
            setShowJustNow(true);
            // gonna refresh only once after difference time has passed
            const refreshTime = (60 - differenceInSeconds) * 1000;
            timeout = setTimeout(()=>{
                setShowJustNow(false);
            }, refreshTime);
        }
        return ()=>{
            if (timeout) clearTimeout(timeout);
        };
    }, [
        differenceInSeconds,
        isLessThanOneMinuteAgo
    ]);
    if (showJustNow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6871b3025cf26e91$export$defe85febe8b728c).justNow);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedRelativeTime), {
        numeric: "always",
        ...$742565d3da98c155$var$getRelativeTimeProps(differenceInSeconds)
    });
};
const $742565d3da98c155$var$_default_1 = (0, $4a1753bc458304c7$export$45d3ca664b6e3027)($742565d3da98c155$var$TimeAgo, (0, $7a8fa43e2e417c08$export$c08b58fa4727b0d2));
var $742565d3da98c155$export$2e2bcd8739ae039 = $742565d3da98c155$var$_default_1;











const $4db956e6a63d7d59$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    readingAidsEditHistoryHeader: {
        id: "contextual-reading-aids.edit-history.header.text",
        defaultMessage: "Edit History"
    },
    readingAidsEditHistoryDescription: {
        id: "contextual-reading-aids.edit-history.description.text",
        defaultMessage: "See all the edits for {queryText}"
    },
    readingAidsEditHistoryCardEdited: {
        id: "contextual-reading-aids.edit-history.card.edited",
        defaultMessage: "{editorName} edited"
    },
    readingAidsEditHistoryCardErrorText: {
        id: "contextual-reading-aids.edit-history.card.error-text",
        defaultMessage: "An error has occurred. Please try again later."
    },
    readingAidsEditHistoryVisibilityTextOrg: {
        id: "contextual-reading-aids.edit-history.visibility.text.org",
        defaultMessage: "This definition is visible to anyone in the entire organization"
    },
    readingAidsEditHistoryVisibilitySpace: {
        id: "contextual-reading-aids.edit-history.visibility.text.space",
        defaultMessage: "This definition is visible to anyone in this space"
    },
    readingAidsEditHistoryVisibilityPage: {
        id: "contextual-reading-aids.edit-history.visibility.text.page",
        defaultMessage: "This definition is visible to anyone viewing this page"
    },
    readingAidsEditHistoryVisibilityBlog: {
        id: "contextual-reading-aids.edit-history.visibility.text.blog",
        defaultMessage: "This definition is visible to anyone viewing this blog"
    },
    readingAidsEditHistoryVisibilityProject: {
        id: "contextual-reading-aids.edit-history.visibility.text.Project",
        defaultMessage: "This definition is visible to anyone viewing this project"
    },
    readingAidsEditHistoryVisibilityProjectGalaxia: {
        id: "contextual-reading-aids.edit-history.visibility.text.Project-galaxia",
        defaultMessage: "This definition is visible to anyone viewing this space"
    }
});











const $f5827dc44319185b$var$DefinitionEditHistoryQuery = `
query DefinitionEditHistoryQuery(
  $workspaceId: String!
  $keyPhrase: String!
	$confluenceScopeId: KnowledgeDiscoveryDefinitionScopeIdConfluence
	$jiraScopeId: KnowledgeDiscoveryDefinitionScopeIdJira
) {
  knowledgeDiscovery {
    definitionHistory(
      workspaceId: $workspaceId
      keyPhrase: $keyPhrase
      confluenceScopeId: $confluenceScopeId
			jiraScopeId: $jiraScopeId
    ) @optIn(to: "KnowledgeDiscovery Get definition history") {
      __typename
      ... on KnowledgeDiscoveryDefinitionList {
        definitions {
          keyPhrase
          definition
          createdAt
          scope
          editor {
            name
            accountId
            picture
          }
          referenceUrl
          confluenceEntity {
            ... on ConfluencePage {
              id
              type
              title
            }
            ... on ConfluenceBlogPost {
              id
              type
              title
            }
          }
        }
      }
      ... on QueryError {
        message
      }
    }
  }
}
`;
const $f5827dc44319185b$export$9ad350b72fa486e = {
    operationName: 'DefinitionEditHistoryQuery',
    query: $f5827dc44319185b$var$DefinitionEditHistoryQuery
};


const $4bf56896f978fce8$export$fd57168bc668244 = (productScopes)=>{
    if ('contentARI' in productScopes) return {
        confluenceScopeId: {
            contentId: productScopes.contentARI,
            spaceId: productScopes.spaceARI
        }
    };
    else return {
        jiraScopeId: {
            projectId: productScopes.projectARI
        }
    };
};


const $bb81ba0ae582511f$export$584199b95393a773 = ({ query: query, curatedDefinitionScopeConfig: curatedDefinitionScopeConfig })=>{
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const loading = data === undefined && error === undefined;
    const scopeIds = (0, $4bf56896f978fce8$export$fd57168bc668244)(curatedDefinitionScopeConfig.productScopes);
    (0, $cozmU.useEffect)(()=>{
        const fireRequest = async ()=>{
            try {
                const res = await (0, $i5c0A.fetchAggResponse)({
                    graphQuery: (0, $f5827dc44319185b$export$9ad350b72fa486e).query,
                    operationName: (0, $f5827dc44319185b$export$9ad350b72fa486e).operationName,
                    variables: {
                        workspaceId: curatedDefinitionScopeConfig.workspaceId,
                        keyPhrase: query,
                        ...scopeIds
                    },
                    headers: (0, $7AtIp.createAtlAttributionHeader)({
                        atlWorkspaceId: curatedDefinitionScopeConfig.workspaceId,
                        tenantId: curatedDefinitionScopeConfig.cloudId,
                        product: curatedDefinitionScopeConfig.product
                    })
                });
                const { data: data, errors: errors } = res;
                if (!errors && !!data) setData(data);
                else throw new Error(errors?.map((e)=>e.message).join(', '));
            } catch (e) {
                setError(e);
            }
        };
        fireRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const definitions = !error && !data?.knowledgeDiscovery?.definitionHistory?.message ? data?.knowledgeDiscovery?.definitionHistory?.definitions || [] : [];
    return {
        definitions: definitions,
        loading: loading
    };
};


const $e1f862b35321d870$var$styles = {
    loadingSpinner: "_3iDTPbQ4SZ _37wbyuDIqT _0jFU0VN91d _39xV02N91d",
    editHistoryWrapper: "_2mHwu85zaO _2sNsIgmnOE _3iDTPbQ4SZ _0aFT5vbt8w _1wydGWkG2W",
    editHistoryDescription: "_2mHwu81Y8M _1UtDYzy7kJ",
    editedDefinitionCardContainer: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vbt8w",
    editedDefinitionScopeText: "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _1UtDYzKGUX",
    editedDefinitionCard: "_0bjKvDaOBN _2mHwu85zaO _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLchRC _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    editedDefinitionAvatar: "_0bjKvDh73D",
    editedDefinitionCardBody: "_2sNsIgmnOE _2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d _1UtDYzy7kJ",
    editedDefinitionCardHeaderWrapper: "_2mHwu8Pgdg _3iDTPbQ4SZ _0aFT5vbt8w",
    editedDefinitionCardHeader: "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _1UtDYzZpcK _1DCdHi2ADO",
    editedDefinitionCardEditor: "_1kk5Tk7GSX _1UtDYzy7kJ",
    editedDefinitionCardReference: "_3iDTPbQ4SZ _0hPCNLDIqT",
    editedDefinitionCardReferenceTitle: "_2XsHFM1Y8M",
    editedDefinitionCardHeaderSpacer: "_39xV02N91d _1UtDYzot27 _313842FQfX _1DCdHidnbC"
};

const $e1f862b35321d870$var$MarkdownRenderer = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("039lM")).then(({ default: ReactMarkdown })=>{
        return {
            default: ReactMarkdown
        };
    }));
const $e1f862b35321d870$var$ScopeDescription = ({ scope: scope })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let scopeDescription = '';
    let ScopeIcon;
    switch(scope){
        case (0, $jkdKe.EditedDefinitionScope).ORGANIZATION:
            scopeDescription = formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryVisibilityTextOrg);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($kpuvJ)));
            break;
        case (0, $jkdKe.EditedDefinitionScope).SPACE:
            scopeDescription = formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryVisibilitySpace);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($ds2zu)));
            break;
        case (0, $jkdKe.EditedDefinitionScope).PAGE:
            scopeDescription = formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryVisibilityPage);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($kkFbH)));
            break;
        case (0, $jkdKe.EditedDefinitionScope).BLOGPOST:
            scopeDescription = formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryVisibilityBlog);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd)));
            break;
        case (0, $jkdKe.EditedDefinitionScope).PROJECT:
            scopeDescription = formatMessage((0, $cXtTj.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryVisibilityProjectGalaxia : (0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryVisibilityProject);
            ScopeIcon = ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7A1BE))), {
                    color: "var(--ds-icon, #292A2E)",
                    label: ""
                });
            break;
        default:
            return null;
    }
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $e1f862b35321d870$var$styles.editedDefinitionScopeText,
        space: "space.050"
    }, scopeDescription, " ", /*#__PURE__*/ $cozmU.createElement(ScopeIcon, {
        label: ""
    }));
};
const $e1f862b35321d870$export$6c43ad171ca78b4f = ({ curatedDefinitionScopeConfig: curatedDefinitionScopeConfig, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: { query: query } } = (0, $3hVWe.useAIAnswerContext)();
    const { definitions: definitions, loading: loading } = (0, $bb81ba0ae582511f$export$584199b95393a773)({
        query: query,
        curatedDefinitionScopeConfig: curatedDefinitionScopeConfig
    });
    const hasError = definitions.length === 0 && !loading;
    return /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: onClose,
        height: 600
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryHeader))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $e1f862b35321d870$var$styles.editHistoryWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $e1f862b35321d870$var$styles.editHistoryDescription
    }, formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryDescription, {
        queryText: /*#__PURE__*/ $cozmU.createElement("b", null, query)
    })), hasError || loading ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $e1f862b35321d870$var$styles.loadingSpinner
    }, loading && /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "large",
        testId: "definition-history-loading-spinner"
    }), hasError && /*#__PURE__*/ $cozmU.createElement((0, $RfroO.default), {
        header: formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryCardErrorText)
    })) : definitions.map((item, index)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionCardContainer,
            key: `edited-definition-history-card-${index}`
        }, /*#__PURE__*/ $cozmU.createElement($e1f862b35321d870$var$ScopeDescription, {
            scope: item.scope
        }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionCard
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionAvatar
        }, /*#__PURE__*/ $cozmU.createElement("img", {
            src: item.editor?.picture || '',
            width: "32px",
            height: "32px"
        })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionCardBody
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionCardHeaderWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionCardHeader
        }, formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryCardEdited, {
            editorName: /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                xcss: $e1f862b35321d870$var$styles.editedDefinitionCardEditor
            }, item.editor?.name || '')
        }), " \u2219 ", /*#__PURE__*/ $cozmU.createElement((0, $742565d3da98c155$export$2e2bcd8739ae039), {
            date: Number(item.createdAt) * 1000
        })), /*#__PURE__*/ $cozmU.createElement("hr", {
            role: "presentation",
            className: (0, $hekY6.default)([
                $e1f862b35321d870$var$styles.editedDefinitionCardHeaderSpacer
            ])
        })), /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": `rendered-markdown-definition-${index}`
        }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
        }, /*#__PURE__*/ $cozmU.createElement($e1f862b35321d870$var$MarkdownRenderer, {
            disallowedElements: (0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search') ? undefined : [
                'img'
            ]
        }, item.definition))), item.referenceUrl && item.confluenceEntity?.title && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionCardReference
        }, /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            appearance: "subtle",
            target: "_blank",
            href: item.referenceUrl
        }, item.confluenceEntity.type === 'BLOG_POST' ? /*#__PURE__*/ $cozmU.createElement((0, $iW3KC.default), {
            label: ""
        }) : /*#__PURE__*/ $cozmU.createElement((0, $2qJQZ.default), {
            label: ""
        }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionCardReferenceTitle
        }, item.confluenceEntity.title || ''))))))))), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null));
};





const $bc9bd53230eb9105$export$bfe6deae035e3ea7 = (props)=>({
        action: 'clicked',
        actionSubject: 'aiDefinitionsDisableDefinition',
        source: 'viewPageScreen',
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        }
    });





const $7abdbf6c5e9a205a$export$48200d71a3e25afe = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiDefinitionToggle',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};









var $7ZB0A = parcelRequire("7ZB0A");


var $93fnf = parcelRequire("93fnf");


var $c8bBH = parcelRequire("c8bBH");






















const $034e96ea26fdac56$export$c4c8b81ee90e6af2 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDislikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};





const $b74522729de50e18$export$5b155f527aff26b9 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerLikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};


/* feedback-button-icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 







const $d21263489499d51e$export$5d384d799a8fb604 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_169wk05": (0, $9aYkv.default)(__cmplp.active ? "var(--ds-text-accent-blue, #1558BC)" : "var(--ds-text-subtlest, #6B6E76)"),
            "--_hohrgu": (0, $9aYkv.default)(__cmplp.isDisabled ? 'not-allowed' : 'default')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0wOv4Qb84s _3VB8wb5uWe",
            __cmplp.className
        ])
    });
});





const $260c725c14a7c456$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    definition_footer_defined_by_text: {
        id: "search_ai.definition_footer_defined_by_text",
        defaultMessage: "Defined by"
    },
    definition_footer_see_edit_history: {
        id: "search_ai.definition_footer_see_edit_history",
        defaultMessage: "See all edit history"
    },
    definition_footer_like_button_tooltip: {
        id: "search_ai.definition_footer_like_button_tooltip",
        defaultMessage: "Good response"
    },
    definition_footer_dislike_button_tooltip: {
        id: "search_ai.definition_footer_dislike_button_tooltip",
        defaultMessage: "Bad response"
    },
    definition_footer_hide_term_definition_message: {
        id: "search_ai.definition_footer_hide_term_definition_message",
        defaultMessage: "Don't define this again"
    },
    definition_footer_beta_status_label: {
        id: "search_ai.definition_footer.beta_status_label",
        defaultMessage: "Beta"
    },
    definition_footer_disclaimer: {
        id: "search_ai.definition_footer_disclaimer",
        defaultMessage: "Uses AI. Verify results."
    },
    definition_footer_powered_by_AI: {
        id: "search_ai.definition_footer_powered_by_AI",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    definition_footer_rovo_label: {
        id: "search_ai.definition_footer_rovo_label",
        defaultMessage: "Rovo"
    },
    definition_footer_editor_handle: {
        id: "search_ai.definition_footer_editor_handle",
        defaultMessage: "@{name}"
    },
    definition_footer_feedback_options_modal_header_feedback_only: {
        id: "search_ai.definition_footer_feedback_options_modal_header_feedback_only",
        defaultMessage: "Leave feedback"
    },
    definition_footer_feedback_options_modal_header: {
        id: "search_ai.definition_footer_feedback_options_modal_header",
        defaultMessage: "Correct definition or leave feedback"
    },
    definition_footer_feedback_options_edit_definition_option: {
        id: "search_ai.definition_footer_feedback_options_edit_definition_option",
        defaultMessage: "I want to edit this definition"
    },
    definition_footer_feedback_options_edit_definition_option_subtext: {
        id: "search_ai.definition_footer_feedback_options_edit_definition_option_subtext",
        defaultMessage: "Update the definition."
    },
    definition_footer_feedback_options_leave_feedback_option: {
        id: "search_ai.definition_footer_feedback_options_leave_feedback_option",
        defaultMessage: "I want to leave feedback about this feature"
    },
    definition_footer_feedback_options_leave_feedback_option_subtext: {
        id: "search_ai.definition_footer_feedback_options_leave_feedback_option_subtext",
        defaultMessage: "Share your feedback so we can improve these experiences."
    },
    definition_footer_feedback_modal_header: {
        id: "search_ai.definition_footer_feedback_modal_header",
        defaultMessage: "Help us improve Definitions"
    },
    definition_footer_feedback_consent_checkbox_label: {
        id: "search_ai.definition_footer_feedback_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    definition_footer_feedback_report_label: {
        id: "search_ai.definition_footer_feedback_report_label",
        defaultMessage: "Was there a problem with this definition? Let us know what happened."
    },
    definition_footer_feedback_report_details_label: {
        id: "search_ai.definition_footer_feedback_report_details_label",
        defaultMessage: "Describe the issue"
    },
    definition_footer_feedback_report_empty_option_share_label: {
        id: "search_ai.definition_footer_feedback_report_empty_option_share_label",
        defaultMessage: "I want to share..."
    },
    definition_footer_feedback_report_relevance_option_label: {
        id: "search_ai.definition_footer_feedback_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t what I expected"
    },
    definition_footer_feedback_report_inaccurate_option_label: {
        id: "search_ai.definition_footer_feedback_report_inaccurate_option_label",
        defaultMessage: "This is inaccurate or misleading"
    },
    definition_footer_feedback_report_offensive_option_label: {
        id: "search_ai.definition_footer_feedback_report_offensive_option_label",
        defaultMessage: "This is offensive or harmful"
    },
    definition_footer_feedback_report_other_option_label: {
        id: "search_ai.definition_footer_feedback_report_other_option_label",
        defaultMessage: "Something else"
    },
    definition_footer_feedback_summary_placeholder_label: {
        id: "search_ai.definition_footer_feedback_summary_placeholder_label",
        defaultMessage: "Explain the problem you experienced"
    },
    definition_footer_feedback_flag_description: {
        id: "search_ai.definition_footer_feedback_flag_descriptionl",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    }
});


/* rotate180-icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $6da3784cdd7e473f$export$8b5c58bc12f52d53 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2xvoozl236",
            __cmplp.className
        ])
    });
});


const $48778ee853c2cfa9$var$FeedbackButton = ({ active: active, isDisabled: isDisabled, onClick: onClickHandler, tooltipContent: tooltipContent, testId: testId, icon: icon })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: 'top',
        content: tooltipContent
    }, ({ onClick: _onClick, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            "aria-label": tooltipContent,
            spacing: 'none',
            appearance: isDisabled ? 'subtle-link' : 'subtle',
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d21263489499d51e$export$5d384d799a8fb604), {
                active: active,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    cursor: 'pointer'
                },
                ...testId && {
                    'data-testid': testId
                },
                isDisabled: isDisabled || false
            }, icon),
            ...!isDisabled && {
                onClick: onClickHandler
            },
            ...tooltipProps
        }));
};
const $48778ee853c2cfa9$export$c633fc044a8b8981 = ({ setShowFeedbackOptionsModal: setShowFeedbackOptionsModal, setDisplayFlag: setDisplayFlag })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, updateContextCache: updateContextCache, liked: liked, setLiked: setLiked, likesDisabled: likesDisabled, setLikesDisabled: setLikesDisabled } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setDisplayFlag(true);
        setLiked(true);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: true
        });
        fireAnalyticsEvent((0, $b74522729de50e18$export$5b155f527aff26b9)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).POSITIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setDisplayFlag,
        fireSAINUsageEvent
    ]);
    const dislikeButtonCallback = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setShowFeedbackOptionsModal(true);
        setLiked(false);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: false
        });
        fireAnalyticsEvent((0, $034e96ea26fdac56$export$c4c8b81ee90e6af2)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).NEGATIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setShowFeedbackOptionsModal,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($48778ee853c2cfa9$var$FeedbackButton, {
        active: liked === true,
        onClick: likeButtonCallback,
        tooltipContent: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_like_button_tooltip),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)",
            size: serveDefinitionUXUpdates ? 'small' : 'medium'
        }),
        isDisabled: liked && likesDisabled,
        testId: "definition-footer-like-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($48778ee853c2cfa9$var$FeedbackButton, {
        active: liked === false,
        onClick: dislikeButtonCallback,
        tooltipContent: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_dislike_button_tooltip),
        icon: serveDefinitionUXUpdates ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
            label: "",
            spacing: "spacious",
            size: "small",
            color: "var(--ds-icon, #292A2E)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6da3784cdd7e473f$export$8b5c58bc12f52d53), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)"
        })),
        isDisabled: !liked && likesDisabled,
        testId: "definition-footer-dislike-button"
    }));
};


/* feedback-modal.tsx generated by @compiled/babel-plugin v3.0.1 */ 
















const $e66bc4e4b70c4191$var$styles = {
    root: "_1wydGW5zaO"
};

const $e66bc4e4b70c4191$var$AkFeedbackCollector = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lavoB")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $e66bc4e4b70c4191$export$5efdacda4e928df9 = ({ setFeedbackModal: setFeedbackModal, isCuratedDefinition: isCuratedDefinition, setDisplayFlag: setDisplayFlag })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, readingAidsOptions: readingAidsOptions, userDetails: { name: name, id: id } } = (0, $3hVWe.useAIAnswerContext)();
    const { errorState: errorState } = commonAttributes;
    const [hasConsent, setConsent] = (0, $cozmU.useState)(false);
    const feedbackContextObject = {
        source: commonAttributes.source,
        queryHash: commonAttributes.queryHash,
        cloudId: commonAttributes.cloudId,
        prompt: hasConsent ? commonAttributes.query : undefined,
        answer: hasConsent ? commonAttributes.answerString : undefined,
        documentId: readingAidsOptions?.contentARI,
        errorState: errorState,
        isCuratedDefinition: isCuratedDefinition
    };
    const feedbackContext = Object.entries(feedbackContextObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $cozmU.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement($e66bc4e4b70c4191$var$AkFeedbackCollector, {
        locale: locale,
        onClose: ()=>setFeedbackModal(false),
        onSubmit: ()=>{
            setDisplayFlag(true);
        },
        customContent: isCuratedDefinition ? undefined : /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
            label: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_consent_checkbox_label),
            onChange: toggleConsentCheckbox,
            isChecked: hasConsent
        }),
        atlassianAccountId: id,
        name: name,
        entrypointId: (0, $15c17b140b3e21b2$export$dd6343c56092a345),
        additionalFields: [
            {
                id: (0, $15c17b140b3e21b2$export$d04cd98bb7625919),
                value: feedbackContext
            }
        ],
        feedbackTitle: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_modal_header),
        feedbackTitleDetails: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e66bc4e4b70c4191$var$styles.root
        }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_label)),
        feedbackGroupLabels: {
            empty: {
                fieldLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                selectOptionLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_empty_option_share_label)
            },
            question: {
                fieldLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                selectOptionLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_relevance_option_label)
            },
            comment: {
                fieldLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                selectOptionLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_inaccurate_option_label)
            },
            bug: {
                fieldLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                selectOptionLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_offensive_option_label)
            },
            suggestion: {
                fieldLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                selectOptionLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_other_option_label)
            }
        },
        summaryPlaceholder: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_summary_placeholder_label)
    })));
};


/* feedback-options-modal.tsx generated by @compiled/babel-plugin v3.0.1 */ 






var $gC2EJ = parcelRequire("gC2EJ");


var $gVrmv = parcelRequire("gVrmv");














var $4o0zT = parcelRequire("4o0zT");









const $4f71e91a4b682fe6$var$styles = {
    feedbackOptionsWrapper: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _1wydGWNHnM",
    feedbackOption: "_0bjKvDKxmn _23rrnHyKLB _39xV02N91d _0jFU0VmdCj _0KLXru66of _1eOmH6o126",
    feedbackOptionIconWrapper: "_0bjKvDcjp5 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VUofl _39xV02Uofl",
    feedbackOptionText: "_2sNsIgmnOE _1UtDYzy7kJ",
    feedbackOptionSubText: "_2sNsIg7NXe _1UtDYzKGUX"
};
const $4f71e91a4b682fe6$export$dc5d3996368c6525 = ({ setShowFeedbackOptionsModal: setShowFeedbackOptionsModal, setShowEditDefinitionModal: setShowEditDefinitionModal, setShowFeedbackModal: setShowFeedbackModal, editDefinitionEnabled: editDefinitionEnabled })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: ()=>setShowFeedbackOptionsModal(false),
        shouldReturnFocus: (0, $4o0zT.isExperimentEnabled)('a11y-fixes-week1-june-2026')
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, formatMessage(editDefinitionEnabled ? (0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_options_modal_header : (0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_options_modal_header_feedback_only))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOptionsWrapper
    }, editDefinitionEnabled && /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOption,
        onClick: ()=>{
            setShowFeedbackOptionsModal(false);
            setShowEditDefinitionModal(true);
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        backgroundColor: "color.background.accent.blue.subtle",
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOptionIconWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    })), /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column",
        gap: "space.025",
        alignItems: "start"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOptionText
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_options_edit_definition_option)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOptionSubText
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_options_edit_definition_option_subtext))))), /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOption,
        onClick: ()=>{
            setShowFeedbackOptionsModal(false);
            setShowFeedbackModal(true);
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        backgroundColor: "color.background.accent.blue.subtle",
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOptionIconWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gVrmv))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    })), /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column",
        gap: "space.025",
        alignItems: "start"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOptionText
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_options_leave_feedback_option)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOptionSubText
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_options_leave_feedback_option_subtext))))))));
};


/* footer-section.tsx generated by @compiled/babel-plugin v3.0.1 */ 















var $gC0KQ = parcelRequire("gC0KQ");


var $1NXxl = parcelRequire("1NXxl");


var $fodiz = parcelRequire("fodiz");


















var $5hJlu = parcelRequire("5hJlu");





var $IOtUu = parcelRequire("IOtUu");














/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // want color of icon to be the same for regular/light/dark modes



const $3f9ffb3b57d400e5$export$eaf821108be3620b = ({ size: size = 'small', greyed: greyed = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        height: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.5 15.3L17.5 18.3",
        stroke: "#626F86",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M9.5 15.3L6.5 18.3",
        stroke: "#626F86",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M9.5 10.3L6.5 7.30002",
        stroke: "#626F86",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.5 10.3L17.5 7.30002",
        stroke: "#626F86",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.0001 16.8V19.8",
        stroke: "#626F86",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.00012 12.8L5.00012 12.8",
        stroke: "#626F86",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.0001 8.80003L12.0001 5.8",
        stroke: "#626F86",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.0002 12.8L19.0002 12.8",
        stroke: "#626F86",
        strokeWidth: "1.5"
    }));




const $28f26dee3ae80794$export$d80f83cdfda72179 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    const { contentId: contentId, readingAidsSessionId: readingAidsSessionId } = extraAttributes || {};
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionSeeEditHistoryButton',
        source: source,
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: readingAidsSessionId
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};






const $6fa35d25205670c8$var$styles = {
    aiFooter: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0Of8r21Y8M _1wydGW1Y8M _2Zuz6QkG2W _1ZnuxbkG2W _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _39xV02N91d",
    aiFooterUpdates: "_2Zuz6Q5zaO _1Znuxb5zaO",
    rovoWrapper: "_0Of8r21Y8M _1wydGW1Y8M",
    contentMayVaryWrapper: "_2mHwu81Y8M _2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYzKGUX",
    brandWrapper: "_2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYzKGUX",
    editedByFooter: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0Of8r28HPE _1wydGW8HPE _2Zuz6QkG2W _1ZnuxbkG2W _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    editedByWrapper: "_0bjKvDS5Zs _3iDTPbQ4SZ _0KLXruDMqu _2Zuz6Q1Y8M _1Znuxb1Y8M _2XsHFM1Y8M _0wOv4Q7zJH _1eOmH6KcZT",
    definedByWrapper: "_2XsHFM2ADO",
    activeEditedByWrapper: "_0bjKvDS5Zs _3iDTPbQ4SZ _0KLXruKcZT _2Zuz6Q1Y8M _1Znuxb1Y8M _2XsHFM1Y8M _0wOv4Q7zJH",
    editHistoryWrapper: "_2sNsIg7NXe _3iDTPbQ4SZ _1UtDYzM7Tp _2Zuz6QNHnM _0wOv4Q7zJH _0KLXru66of _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8"
};

const $6fa35d25205670c8$var$AkFeedbackFlag = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lavoB")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $6fa35d25205670c8$export$8c09939f07ae58e2 = ()=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const { answerEditor: answerEditor, brand: brand, readingAidsOptions: readingAidsOptions } = (0, $3hVWe.useAIAnswerContext)();
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editDefinitionEnabled = !!definitionCurationOptions;
    const [showFeedbackOptionsModal, setShowFeedbackOptionsModal] = (0, $cozmU.useState)(false);
    const [showEditDefinitionModal, setShowEditDefinitionModal] = (0, $cozmU.useState)(false);
    const [showFeedbackModal, setShowFeedbackModal] = (0, $cozmU.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $cozmU.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $cozmU.useState)(false);
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($6fa35d25205670c8$var$styles.aiFooter, serveDefinitionUXUpdates && $6fa35d25205670c8$var$styles.aiFooterUpdates)
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6fa35d25205670c8$var$styles.contentMayVaryWrapper
    }, brand === (0, $zzZbq.AiBrand).ROVO ? null : /*#__PURE__*/ $cozmU.createElement((0, $IOtUu.default), {
        text: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_beta_status_label),
        isRemovable: false,
        migration_fallback: "lozenge"
    }), /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        size: "small"
    }), /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
        rel: "noopener noreferrer",
        appearance: "subtle",
        href: (0, $15c17b140b3e21b2$export$59da2b3b71a076c7)
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_disclaimer))), !serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6fa35d25205670c8$var$styles.brandWrapper
    }, brand === (0, $zzZbq.AiBrand).ROVO ? /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), null, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.025"
    }, /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
        rel: "noopener noreferrer",
        appearance: "subtle",
        href: (0, $15c17b140b3e21b2$export$2c1028e1e7bf5557)
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_rovo_label)), /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC0KQ))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        spacing: "spacious"
    }))) : /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.025"
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_powered_by_AI), /*#__PURE__*/ $cozmU.createElement((0, $3f9ffb3b57d400e5$export$eaf821108be3620b), {
        greyed: true,
        size: "large"
    }))), serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $48778ee853c2cfa9$export$c633fc044a8b8981), {
        setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
        setDisplayFlag: setDisplayFlag
    }))), /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, showFeedbackOptionsModal && /*#__PURE__*/ $cozmU.createElement((0, $4f71e91a4b682fe6$export$dc5d3996368c6525), {
        setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
        setShowEditDefinitionModal: setShowEditDefinitionModal,
        setShowFeedbackModal: setShowFeedbackModal,
        editDefinitionEnabled: editDefinitionEnabled
    }), showFeedbackModal && /*#__PURE__*/ $cozmU.createElement((0, $e66bc4e4b70c4191$export$5efdacda4e928df9), {
        setFeedbackModal: setShowFeedbackModal,
        isCuratedDefinition: !!answerEditor,
        setDisplayFlag: setDisplayFlag
    }), showEditDefinitionModal && editDefinitionEnabled && /*#__PURE__*/ $cozmU.createElement((0, $46b3319f0a259942$export$ea8c8594ad1f3bf3), {
        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
        closeEditModal: ()=>setShowEditDefinitionModal(false),
        openFeedbackOptionsModal: ()=>setShowFeedbackOptionsModal(true),
        onSaveEditModal: ()=>setDisplaySuccessFlag(true)
    })), displayFlag && /*#__PURE__*/ $cozmU.createElement((0, $lqtHz.FlagGroup), {
        onDismissed: ()=>setDisplayFlag(false)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement($6fa35d25205670c8$var$AkFeedbackFlag, {
        locale: locale,
        description: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_flag_description)
    }))), displaySuccessFlag && /*#__PURE__*/ $cozmU.createElement((0, $6cecfbe2a7b0bbf1$export$7475d9ffda76c69b), {
        onDismissed: ()=>setDisplaySuccessFlag(false)
    }));
};
const $6fa35d25205670c8$var$DEFAULT_GRAPHQL_DIRECTORY_ENDPOINT = '/gateway/api/directory/graphql';
const $6fa35d25205670c8$var$profileClient = new (0, $5hJlu.default)({
    url: $6fa35d25205670c8$var$DEFAULT_GRAPHQL_DIRECTORY_ENDPOINT
}); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $6fa35d25205670c8$export$686a5e20bce13f8f = ({ setShowEditHistoryModal: setShowEditHistoryModal })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [editorActive, setEditorActive] = (0, $cozmU.useState)(false);
    const { answerEditor: answerEditor, commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, userDetails: userDetails } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, orgId: orgId } = commonAttributes;
    if (!answerEditor) return null; // This line should not be reachable since the component is only rendered when answerEditor is defined
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const editedByLabel = formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_editor_handle, {
        name: answerEditor.name
    });
    const editedByChip = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: editorActive ? $6fa35d25205670c8$var$styles.activeEditedByWrapper : $6fa35d25205670c8$var$styles.editedByWrapper
    }, editedByLabel);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6fa35d25205670c8$var$styles.editedByFooter
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.100",
        alignItems: "start",
        direction: "column"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NXxl))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6fa35d25205670c8$var$styles.definedByWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_defined_by_text))), (0, $iDrrr.fg)('people-teams_migrate-user-profile-card') || (0, $cXtTj.default).getExperimentValue('pt_user_profile_card_migration_exp', 'isEnabled', false) ? /*#__PURE__*/ $cozmU.createElement((0, $9zU5G.UserProfileCardWithTrigger), {
        userId: answerEditor.id,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: userDetails.id,
        trigger: "click"
    }, editedByChip) : /*#__PURE__*/ $cozmU.createElement((0, $hSs5g.default), {
        userId: answerEditor.id,
        cloudId: cloudId,
        resourceClient: $6fa35d25205670c8$var$profileClient,
        trigger: "click",
        onVisibilityChange: setEditorActive
    }, editedByChip)), !serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6fa35d25205670c8$var$styles.editHistoryWrapper,
        onClick: ()=>{
            fireAnalyticsEvent((0, $28f26dee3ae80794$export$d80f83cdfda72179)(commonAttributes));
            setShowEditHistoryModal(true);
        }
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_see_edit_history))));
};












const $32db7c8b5692d4b1$export$8a69382ce91c952a = `
	mutation ToggleDefinitionMutation(
		$workspaceId: String!
		$keyPhrase: String!
		$isDisabled: Boolean
		) {
		knowledgeDiscovery {
			updateUserKeyPhraseInteraction(
				input: {
					workspaceId: $workspaceId
					keyPhrase: $keyPhrase
					isDisabled: $isDisabled
				}
			) @optIn(to: "KnowledgeDiscovery Update User KeyPhrase Interaction") {
				success
				errors {
					message
				}
			}
		}
	}
`;


const $8ed7fc4a26d403e8$export$6e73bcf8826d31a5 = ()=>{
    const toggleDefinition = (0, $cozmU.useCallback)(async ({ workspaceId: workspaceId, keyPhrase: keyPhrase, isDisabled: isDisabled, cloudId: cloudId, product: product })=>{
        return (0, $i5c0A.fetchAggResponse)({
            graphQuery: (0, $32db7c8b5692d4b1$export$8a69382ce91c952a),
            variables: {
                workspaceId: workspaceId,
                keyPhrase: keyPhrase,
                isDisabled: isDisabled
            },
            headers: (0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        }).then((response)=>{
            if (response?.data?.knowledgeDiscovery.updateUserKeyPhraseInteraction?.success) return {
                toggleDefinitionSuccess: true
            };
            else throw new Error('toggleDefinition mutation unsuccessful');
        });
    }, []);
    return {
        toggleDefinition: toggleDefinition
    };
};


const $bd504f15d238fab3$var$styles = {
    root: "_2sNsIgmnOE _3iDTPbQ4SZ _0hPCNLDIqT _1DCdHi1Y8M _1UtDYzUktF _2Zuz6QNHnM _1ZnuxbNHnM"
};

const $bd504f15d238fab3$var$AkFeedbackFlag = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lavoB")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $bd504f15d238fab3$var$AI_DEFINITION_TOGGLE_CACHE_KEY = 'atlassian.search-ai.ai-definition-toggle';
const $bd504f15d238fab3$export$9de8ba80314e4213 = ()=>{
    const { answerEditor: answerEditor, fireAnalyticsEvent: fireAnalyticsEvent, readingAidsOptions: readingAidsOptions, isAnswered: isAnswered, hasError: hasError, commonAttributes: commonAttributes, definitionToggleEnabled: definitionToggleEnabled, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const { query: keyPhrase, workspaceId: workspaceId, cloudId: cloudId } = commonAttributes;
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const [showFeedbackOptionsModal, setShowFeedbackOptionsModal] = (0, $cozmU.useState)(false);
    const [showEditDefinitionModal, setShowEditDefinitionModal] = (0, $cozmU.useState)(false);
    const [showFeedbackModal, setShowFeedbackModal] = (0, $cozmU.useState)(false);
    const [showEditHistoryModal, setShowEditHistoryModal] = (0, $cozmU.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $cozmU.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $cozmU.useState)(false);
    const cachedTermDefinitionDisabled = JSON.parse((0, $6JEx2.getSessionItem)($bd504f15d238fab3$var$AI_DEFINITION_TOGGLE_CACHE_KEY) || '{}');
    const [termDefinitionDisabled, setTermDefinitionDisabled] = (0, $cozmU.useState)(cachedTermDefinitionDisabled.keyPhrase === keyPhrase);
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editDefinitionEnabled = !!definitionCurationOptions;
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const { toggleDefinition: toggleDefinition } = (0, $8ed7fc4a26d403e8$export$6e73bcf8826d31a5)();
    const onToggleDefinitionDisable = async ()=>{
        try {
            setTermDefinitionDisabled((current)=>!current);
            await toggleDefinition({
                workspaceId: workspaceId,
                keyPhrase: keyPhrase,
                isDisabled: !termDefinitionDisabled,
                cloudId: cloudId,
                product: sourceProduct ?? ''
            });
            if (termDefinitionDisabled) (0, $6JEx2.deleteSessionItem)($bd504f15d238fab3$var$AI_DEFINITION_TOGGLE_CACHE_KEY);
            else {
                fireAnalyticsEvent((0, $bc9bd53230eb9105$export$bfe6deae035e3ea7)(commonAttributes));
                (0, $6JEx2.setSessionItem)($bd504f15d238fab3$var$AI_DEFINITION_TOGGLE_CACHE_KEY, JSON.stringify({
                    keyPhrase: keyPhrase
                }));
            }
        } catch (error) {
            setTermDefinitionDisabled((current)=>!current);
            fireAnalyticsEvent((0, $7abdbf6c5e9a205a$export$48200d71a3e25afe)(error, commonAttributes));
        }
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, !hasError && isAnswered && !serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        xcss: $bd504f15d238fab3$var$styles.root,
        testId: "definition-answer-card-footer"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $48778ee853c2cfa9$export$c633fc044a8b8981), {
        setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
        setDisplayFlag: setDisplayFlag
    })), definitionToggleEnabled && /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
        isChecked: termDefinitionDisabled,
        label: (0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_hide_term_definition_message.defaultMessage,
        value: (0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_hide_term_definition_message.defaultMessage,
        onChange: onToggleDefinitionDisable
    })), answerEditor ? /*#__PURE__*/ $cozmU.createElement((0, $6fa35d25205670c8$export$686a5e20bce13f8f), {
        setShowEditHistoryModal: setShowEditHistoryModal
    }) : /*#__PURE__*/ $cozmU.createElement((0, $6fa35d25205670c8$export$8c09939f07ae58e2), null), /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, showEditHistoryModal && editDefinitionEnabled && /*#__PURE__*/ $cozmU.createElement((0, $e1f862b35321d870$export$6c43ad171ca78b4f), {
        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
        onClose: ()=>setShowEditHistoryModal(false)
    }), showFeedbackOptionsModal && /*#__PURE__*/ $cozmU.createElement((0, $4f71e91a4b682fe6$export$dc5d3996368c6525), {
        setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
        setShowEditDefinitionModal: setShowEditDefinitionModal,
        setShowFeedbackModal: setShowFeedbackModal,
        editDefinitionEnabled: editDefinitionEnabled
    }), showFeedbackModal && /*#__PURE__*/ $cozmU.createElement((0, $e66bc4e4b70c4191$export$5efdacda4e928df9), {
        setFeedbackModal: setShowFeedbackModal,
        isCuratedDefinition: !!answerEditor,
        setDisplayFlag: setDisplayFlag
    }), showEditDefinitionModal && editDefinitionEnabled && /*#__PURE__*/ $cozmU.createElement((0, $46b3319f0a259942$export$ea8c8594ad1f3bf3), {
        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
        closeEditModal: ()=>setShowEditDefinitionModal(false),
        openFeedbackOptionsModal: ()=>setShowFeedbackOptionsModal(true),
        onSaveEditModal: ()=>setDisplaySuccessFlag(true)
    })), displayFlag && /*#__PURE__*/ $cozmU.createElement((0, $lqtHz.FlagGroup), {
        onDismissed: ()=>setDisplayFlag(false)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement($bd504f15d238fab3$var$AkFeedbackFlag, {
        locale: locale,
        description: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_flag_description)
    }))), displaySuccessFlag && /*#__PURE__*/ $cozmU.createElement((0, $6cecfbe2a7b0bbf1$export$7475d9ffda76c69b), {
        onDismissed: ()=>setDisplaySuccessFlag(false)
    }));
};




















const $e286cb72bb7ab9cd$export$4bb2ae9dc67cd713 = ({ additionalMatchUserName: additionalMatchUserName, additionalMatchTitle: additionalMatchTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerWhoAdditionalMatchViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            additionalMatchUserName: additionalMatchUserName,
            additionalMatchTitle: additionalMatchTitle
        }
    };
};





const $47fbc20224d5557b$export$caffb77a39b6cd1 = ({ additionalMatchUserName: additionalMatchUserName, additionalMatchTitle: additionalMatchTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerWhoAdditionalMatchViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            additionalMatchUserName: additionalMatchUserName,
            additionalMatchTitle: additionalMatchTitle
        }
    };
};



const $17e86b4a203450c0$var$mapRecentActivity = (activity)=>({
        title: activity.title,
        url: activity.url,
        containerName: activity.containerName,
        event: activity.event,
        timestamp: activity.timestamp,
        iconUrl: activity.iconUrl,
        contributors: activity.contributors.slice(0, $17e86b4a203450c0$var$MAX_OTHERS_TO_SHOW).map((contributor)=>({
                name: contributor.name,
                id: contributor.accountId
            })),
        othersCount: activity.othersCount
    });
const $17e86b4a203450c0$var$mapTeam = (team)=>({
        name: team.displayName,
        avatarUrl: team.smallAvatarImageUrl,
        url: `/wiki/people/team/${team.id}`,
        memberCount: team.memberCount
    });
const $17e86b4a203450c0$var$mapAdditionalMatch = (match)=>{
    return {
        name: match.name,
        avatar_url: match.avatar_url,
        profile_url: match.profile_url,
        job_title: match.title,
        email: match.email ?? ''
    };
};
// Collaborators, contributors and additional matches are expected to be at most 3
const $17e86b4a203450c0$var$MAX_OTHERS_TO_SHOW = 3;
const $17e86b4a203450c0$export$b273f870e024eb5d = (answerString)=>{
    const parsed = JSON.parse(answerString);
    if ('enriched_activity_output' in parsed) {
        const { main_user_profile: main_user_profile, additional_matches: additional_matches } = parsed.enriched_activity_output;
        return {
            parsedResult: [
                {
                    name: main_user_profile.user_base_data.name,
                    email: main_user_profile.user_base_data.email,
                    time: main_user_profile.time,
                    profile_url: main_user_profile.user_base_data.profile_url,
                    avatar_url: main_user_profile.user_base_data.avatar_url,
                    recentActivity: main_user_profile.recent_activity.map($17e86b4a203450c0$var$mapRecentActivity),
                    department: main_user_profile.user_base_data.extended_profile?.department,
                    job_title: main_user_profile.user_base_data.extended_profile?.job_title,
                    location: main_user_profile.user_base_data.extended_profile?.location,
                    organization: main_user_profile.user_base_data.extended_profile?.organization,
                    viewAllLink: main_user_profile.view_all_activity_url
                },
                ...additional_matches.slice(0, $17e86b4a203450c0$var$MAX_OTHERS_TO_SHOW).map((x)=>({
                        ...$17e86b4a203450c0$var$mapAdditionalMatch(x),
                        recentActivity: [],
                        viewAllLink: ''
                    }))
            ],
            parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).WORK
        };
    } else if ('enriched_profile_output' in parsed) {
        const { main_user_profile: main_user_profile, additional_matches: additional_matches } = parsed.enriched_profile_output;
        return {
            parsedResult: [
                {
                    account_id: main_user_profile.user_base_data.account_id,
                    name: main_user_profile.user_base_data.name,
                    email: main_user_profile.user_base_data.email,
                    profile_url: main_user_profile.user_base_data.profile_url,
                    avatar_url: main_user_profile.user_base_data.avatar_url,
                    job_title: main_user_profile.user_base_data.extended_profile?.job_title,
                    location: main_user_profile.user_base_data.extended_profile?.location,
                    department: main_user_profile.user_base_data.extended_profile?.department,
                    organization: main_user_profile.user_base_data.extended_profile?.organization,
                    time: main_user_profile.time,
                    collaborators: main_user_profile.collaborators.slice(0, 6).map((user)=>({
                            name: user.name,
                            picture: user.avatar_url,
                            title: user.extended_profile?.job_title ?? null,
                            url: user.profile_url,
                            accountId: user.account_id,
                            department: user.extended_profile?.department ?? null,
                            email: user.email
                        })),
                    containers: main_user_profile.collaboration_spaces.map((container)=>({
                            name: container.name,
                            containerType: container.container_type,
                            url: container.url,
                            iconUrl: container.icon_url
                        })),
                    recentActivity: main_user_profile.recent_activity?.map($17e86b4a203450c0$var$mapRecentActivity),
                    viewAllLink: main_user_profile.view_all_activity_url,
                    teams: main_user_profile.teams?.map($17e86b4a203450c0$var$mapTeam)
                },
                ...additional_matches.slice(0, $17e86b4a203450c0$var$MAX_OTHERS_TO_SHOW).map($17e86b4a203450c0$var$mapAdditionalMatch)
            ],
            parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).WHO
        };
    } else if ('team_metadata' in parsed) return {
        parsedResult: parsed.team_metadata,
        parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).TEAM
    };
    else // This line should never be reached, this means that an unsupported type was in the JSON result
    return {
        parsedResult: {},
        parsedType: undefined
    };
};


/* ai-who-answer-footer.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $ac0808825763ce07$export$8aac4e350897fa7 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2bqfgdOeNX _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _24h04i2Njc",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-footer-header.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $438e3836aeef8420$export$12179e87966a5f65 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgd8bj _1UtDYzKGUX",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-footer-result.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $aad6fd04426facc3$export$e2651635b6d243b0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDKkzjp _0bjKvDKTcp _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _24h04i2Njc _0KLXru7Cj1 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _3fSdSTGk8v",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-footer-result-info-header.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $c655fbb849c7fe62$export$a9060ca8bb68e9b6 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgEqul _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _39xV02N91d _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-footer-result-info-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $cfe7fa596079821c$export$da4b6fad053f23b9 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuZHm0 _0hPCNLchRC _0jFU0VN91d _39xV02N91d _2XsHFM2ADO _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-footer-result-metadata.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $bb6fa724382b9d9c$export$eadd90c494f8440c = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzKGUX _39xV02N91d _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-footer-results-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $2667d2ef32797259$export$ca13badcf6359d46 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _3iDTPbgBM8 _2iEGP2byVk _39xV02N91d _0jFU0VmdCj _3138422ADO",
            __cmplp.className
        ])
    });
});


const $f831fa9e697ed056$export$b03d109098afe32f = ()=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, onNavigate: onNavigate } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    // answerString should have at least one result or else <AIAnswerError /> will be rendered
    const { parsedResult: parsedResult } = (0, $17e86b4a203450c0$export$b273f870e024eb5d)(answerString);
    const additionalUserResults = parsedResult.slice(1);
    const numAdditionalUserResults = additionalUserResults.length;
    return numAdditionalUserResults ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ac0808825763ce07$export$8aac4e350897fa7), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $438e3836aeef8420$export$12179e87966a5f65), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $cb86z.messages).ai_answer_who_questions_footer_header,
        values: {
            numMatches: numAdditionalUserResults
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2667d2ef32797259$export$ca13badcf6359d46), null, additionalUserResults.map((userResult)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aad6fd04426facc3$export$e2651635b6d243b0), {
            key: userResult.name,
            href: userResult.profile_url || undefined,
            onClick: (event)=>{
                onNavigate(event);
                fireAnalyticsEvent((0, $e286cb72bb7ab9cd$export$4bb2ae9dc67cd713)({
                    ...commonAttributes,
                    additionalMatchUserName: userResult.name,
                    additionalMatchTitle: userResult.job_title || ''
                }));
            },
            onContextMenu: (event)=>{
                onNavigate(event);
                fireAnalyticsEvent((0, $47fbc20224d5557b$export$caffb77a39b6cd1)({
                    ...commonAttributes,
                    additionalMatchUserName: userResult.name,
                    additionalMatchTitle: userResult.job_title || ''
                }));
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: userResult.avatar_url || undefined,
            size: "medium",
            testId: userResult.name
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfe7fa596079821c$export$da4b6fad053f23b9), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c655fbb849c7fe62$export$a9060ca8bb68e9b6), null, userResult.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bb6fa724382b9d9c$export$eadd90c494f8440c), null, userResult.job_title)))))) : null;
};



























var $f9PMs = parcelRequire("f9PMs");










/* ai-answer-footer-content-warning-link.tsx generated by @compiled/babel-plugin v3.0.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $872be9e531212fbd$export$6f442c0ed7b594b3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _1UtDYzKGUX _3TGfC9HnLE _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMKGUX",
            __cmplp.className
        ])
    });
});


/* ai-answer-footer-information-content-vary.tsx generated by @compiled/babel-plugin v3.0.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $ea67ca1f91728569$export$573f5509d5798c1e = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _2sNsIg7NXe _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _1UtDYzKGUX",
            __cmplp.className
        ])
    });
});


/* ai-answer-footer-information-content-vary-link-text.tsx generated by @compiled/babel-plugin v3.0.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $4031c559faf0cf84$export$bc95f3ac1425888f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe",
            __cmplp.className
        ])
    });
});


/* ai-answer-footer-powered-by.tsx generated by @compiled/babel-plugin v3.0.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $f2b402d9d55ae121$export$2b5d58c880974a8a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _1UtDYzKGUX _3TGfC9HnLE",
            __cmplp.className
        ])
    });
});


/* ai-answer-footer-powered-by-ai-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $251708df5e70ad5b$export$ef38e90ca3d2a41d = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu8FQfX _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});


/* ai-answer-footer-powered-by-link.tsx generated by @compiled/babel-plugin v3.0.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $13cc1ad6061a0b53$export$7c69b4b5db21f97c = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _1UtDYzKGUX _3TGfC9HnLE _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMKGUX",
            __cmplp.className
        ])
    });
});


/* styled.tsx generated by @compiled/babel-plugin v3.0.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f21780de4c6eb211$var$AIAnswerContentBrandBase = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0Of8r21Y8M _1ZnuxbNHnM _1wydGW1Y8M _2Zuz6QNHnM",
            __cmplp.className
        ])
    });
});
const $f21780de4c6eb211$export$f32f097f63664c4b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $f21780de4c6eb211$var$AIAnswerContentBrandBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_37wbyuI7V3",
            __cmplp.className
        ])
    });
});
const $f21780de4c6eb211$export$5d9a293726695cdb = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $f21780de4c6eb211$var$AIAnswerContentBrandBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_37wbyuDIqT",
            __cmplp.className
        ])
    });
});


const $78943e0b983101cb$export$9e8b51119c9a7742 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { brand: brand, cardTemplate: cardTemplate, sourceProduct: sourceProduct, showGenericFooter: showGenericFooter } = (0, $3hVWe.useAIAnswerContext)();
    const isSacWithCenteredFooter = sourceProduct === 'sac';
    const BrandWrapper = isSacWithCenteredFooter ? (0, $f21780de4c6eb211$export$5d9a293726695cdb) : (0, $f21780de4c6eb211$export$f32f097f63664c4b);
    if (showGenericFooter) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f21780de4c6eb211$export$f32f097f63664c4b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea67ca1f91728569$export$573f5509d5798c1e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
        text: formatMessage((0, $cb86z.messages).ai_answer_dialog_footer_beta_tag),
        isRemovable: false,
        migration_fallback: "lozenge"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4031c559faf0cf84$export$bc95f3ac1425888f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $872be9e531212fbd$export$6f442c0ed7b594b3), {
        rel: "noopener noreferrer",
        href: (0, $zzZbq.SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK),
        target: "_blank"
    }, formatMessage((0, $cb86z.messages).ai_answer_dialog_footer_content_quality_short)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2b402d9d55ae121$export$2b5d58c880974a8a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $251708df5e70ad5b$export$ef38e90ca3d2a41d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13cc1ad6061a0b53$export$7c69b4b5db21f97c), {
        rel: "noopener noreferrer",
        href: (0, $zzZbq.SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK),
        target: "_blank"
    }, formatMessage((0, $cb86z.messages).ai_answer_dialog_loaded_footer_sac)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BrandWrapper, {
        "data-testid": isSacWithCenteredFooter ? 'ai-answer-brand-wrapper-centered' : 'ai-answer-brand-wrapper'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea67ca1f91728569$export$573f5509d5798c1e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4031c559faf0cf84$export$bc95f3ac1425888f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        rel: "noopener noreferrer",
        appearance: "subtle",
        href: sourceProduct === 'sac' ? (0, $zzZbq.SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK) : (0, $zzZbq.ATLASSIAN_INTELLIGENCE_TRUST_LINK)
    }, formatMessage(cardTemplate === (0, $zzZbq.CardTemplate).RIGHT_PANEL ? (0, $cb86z.messages).ai_answer_dialog_footer_content_quality_short : (0, $cb86z.messages).ai_answer_dialog_footer_content_quality_long)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2b402d9d55ae121$export$2b5d58c880974a8a), null, brand === (0, $zzZbq.AiBrand).ROVO ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        rel: "noopener noreferrer",
        appearance: "subtle",
        href: (0, $zzZbq.ATLASSIAN_ROVO_LINK)
    }, "Rovo"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC0KQ))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        spacing: "spacious"
    })) : sourceProduct !== 'sac' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $251708df5e70ad5b$export$ef38e90ca3d2a41d), null, formatMessage((0, $cb86z.messages).ai_answer_dialog_loaded_footer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f9PMs.default), {
        greyed: true,
        size: 'large'
    }))));
};


/* ai-answer-feedback-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides








const $6b6108766d435190$export$71c5dacfc0533c82 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hm6gxd": (0, $9aYkv.default)(__cmplp.isCompact ? `0px ${"var(--ds-space-300, 24px)"}` : 'unset')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _4FKVYEvN50 _3iDTPbQ4SZ _0hPCNLDIqT _3138422ADO _1DCdHi2ADO _1UtDYzUktF",
            __cmplp.className
        ])
    });
});


/* ai-answer-footer-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $a108aa903244750b$export$89b1508f9c43b29e = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _2bqfgdOeNX _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0Of8r28HPE _1ZnuxbNHnM _1wydGW8HPE _2Zuz6QNHnM _3TGfC9HnLE",
            __cmplp.className
        ])
    });
});


/* ai-answer-report-description-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $b4f59c2c581899e2$export$8b91051e793e6316 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1wydGW5zaO",
            __cmplp.className
        ])
    });
});






























var $bIZaC = parcelRequire("bIZaC");


var $7z5N5 = parcelRequire("7z5N5");

/* feedback-button-icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides








const $530f7caa273f1db1$export$5d384d799a8fb604 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_169wk05": (0, $9aYkv.default)(__cmplp.active ? "var(--ds-text-accent-blue, #1558BC)" : "var(--ds-text-subtlest, #6B6E76)"),
            "--_hohrgu": (0, $9aYkv.default)(__cmplp.isDisabled ? 'not-allowed' : 'default')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0wOv4Qb84s _3VB8wb5uWe",
            __cmplp.className
        ])
    });
});


/* rotate180-icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $438b714a832405b9$export$8b5c58bc12f52d53 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2xvoozl236",
            __cmplp.className
        ])
    });
});


const $004bf88ef698cf7f$var$FeedbackButton = ({ active: active, isDisabled: isDisabled, onClick: onClickHandler, tooltipContent: tooltipContent, testId: testId, icon: icon, isReadingAids: isReadingAids })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: 'top',
        content: tooltipContent
    }, ({ onClick: _onClick, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            "aria-label": tooltipContent,
            spacing: 'none',
            appearance: isDisabled ? 'subtle-link' : 'subtle',
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $530f7caa273f1db1$export$5d384d799a8fb604), {
                active: active,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    cursor: 'pointer'
                },
                ...testId && {
                    'data-testid': testId
                },
                isDisabled: isDisabled || false,
                isReadingAids: isReadingAids || false
            }, icon),
            ...!isDisabled && {
                onClick: onClickHandler
            },
            ...tooltipProps
        }));
};
const $004bf88ef698cf7f$export$c633fc044a8b8981 = ({ setDisplayFlag: setDisplayFlag, setFeedbackModal: setFeedbackModal })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, updateContextCache: updateContextCache, liked: liked, setLiked: setLiked, likesDisabled: likesDisabled, setLikesDisabled: setLikesDisabled, isReadingAids: isReadingAids } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setDisplayFlag(true);
        setLiked(true);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: true
        });
        fireAnalyticsEvent((0, $7z5N5.onLikeButtonClick)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).POSITIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setDisplayFlag,
        fireSAINUsageEvent
    ]);
    const dislikeButtonCallback = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setFeedbackModal(true);
        setLiked(false);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: false
        });
        fireAnalyticsEvent((0, $bIZaC.onDislikeButtonClick)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).NEGATIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setFeedbackModal,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($004bf88ef698cf7f$var$FeedbackButton, {
        active: liked === true,
        onClick: likeButtonCallback,
        tooltipContent: formatMessage((0, $cb86z.messages).ai_answer_component_like_button_tooltip),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)"
        }),
        isDisabled: liked && likesDisabled,
        testId: "ai-answer-like-button",
        isReadingAids: isReadingAids
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($004bf88ef698cf7f$var$FeedbackButton, {
        active: liked === false,
        onClick: dislikeButtonCallback,
        tooltipContent: formatMessage((0, $cb86z.messages).ai_answer_component_dislike_button_tooltip),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $438b714a832405b9$export$8b5c58bc12f52d53), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)"
        })),
        isDisabled: !liked && likesDisabled,
        testId: "ai-answer-dislike-button",
        isReadingAids: isReadingAids
    }));
};


/* followup-suggestion-footer.tsx generated by @compiled/babel-plugin v3.0.1 */ 


















var $hAgam = parcelRequire("hAgam");







































const $ee9ece46b1b323f4$export$c1460cbf6075b68 = ({ showErrorStateSuggestedQueries: showErrorStateSuggestedQueries, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiErrorStateSuggestedQueries',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            showErrorStateSuggestedQueries: showErrorStateSuggestedQueries
        }
    };
};








const $8450870f643523fa$export$97c5ff7b106e0023 = ({ errorStateSuggestedQuery: errorStateSuggestedQuery, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiErrorStateSuggestedQuery',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            errorStateSuggestedQueryHash: (0, $9oghv.sha256Hash)(errorStateSuggestedQuery)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            errorStateSuggestedQuery: errorStateSuggestedQuery
        }
    };
};





const $728210eecf84aa8d$export$e6174e7fdfd73609 = ({ expandButtonSource: expandButtonSource, ...props })=>{
    const { query: query } = props;
    return {
        action: 'clicked',
        actionSubject: 'expandButton',
        actionSubjectId: expandButtonSource,
        source: props.source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};








const $234e19cc92be917b$export$f1956b3bd380b51e = ({ followUpString: followUpString, destination: destination, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiFollowUpSuggestion',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            followUpHash: (0, $9oghv.sha256Hash)(followUpString),
            destination: destination
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            followUpString: followUpString
        }
    };
};


/* ai-answer-follow-up-pill.tsx generated by @compiled/babel-plugin v3.0.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $998a72255fc1cd90$export$ff0eb486c968b1bb = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _0bjKvDS5Zs _30huDKS6k6 _3iDTPbQ4SZ _0Of8r2FQfX _1Znuxb2ADO _1wydGWFQfX _2Zuz6Q2ADO _1UtDYzZpcK _0KLXru7Cj1 _37wbyuchRC _0hPCNLDIqT _0KOPe2S6k6 _0ReiIH7zJH _1eOmH6qWX3",
            __cmplp.className
        ])
    });
});


/* ai-answer-follow-up-pill-text.tsx generated by @compiled/babel-plugin v3.0.1 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $41bfb9aa0fe17bb9$export$5d787e808dded622 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XsHFM1Y8M",
            __cmplp.className
        ])
    });
});





const $75504fd7fe2b8992$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ai_answer_followup_see_more: {
        id: "search_ai.followup_see_more",
        defaultMessage: "See more"
    }
});





const $ca576dd46a8697bd$export$2160f22747f80da3 = ()=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const [isOverflowing, setIsOverflowing] = (0, $cozmU.useState)(false);
    // Stores the total natural (uncollapsed) width of all pills + gaps
    const naturalWidthRef = (0, $cozmU.useRef)(0);
    const measureNaturalWidth = (0, $cozmU.useCallback)(()=>{
        const el = containerRef.current;
        if (!el) return;
        const pills = Array.from(el.querySelectorAll('[data-pill]'));
        if (pills.length === 0) {
            naturalWidthRef.current = 0;
            return;
        }
        // Temporarily override display on all pills so scrollWidth reflects the full
        // natural width. We use 'inline-flex' so pills maintain their row layout
        // during measurement (using 'block' would stack them vertically, giving an
        // incorrect scrollWidth). After reading scrollWidth, we restore the original
        // inline style value ('' for pills that had no prior inline style, which lets
        // the CSS class re-assert display:none correctly).
        const prevDisplays = pills.map((p)=>p.style.display);
        pills.forEach((p)=>{
            p.style.display = 'inline-flex';
        });
        naturalWidthRef.current = el.scrollWidth;
        pills.forEach((p, i)=>{
            p.style.display = prevDisplays[i];
        });
    }, []);
    const checkOverflow = (0, $cozmU.useCallback)(()=>{
        const el = containerRef.current;
        if (!el) return;
        setIsOverflowing(naturalWidthRef.current > el.clientWidth);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const el = containerRef.current;
        if (!el) return;
        // MutationObserver re-measures natural widths when pill content changes
        const mutationObserver = new MutationObserver(()=>{
            measureNaturalWidth();
            checkOverflow();
        });
        mutationObserver.observe(el, {
            childList: true,
            subtree: true
        });
        // ResizeObserver re-measures AND re-checks on every container resize.
        // Re-measurement is required (not just re-checking) because the hidden pills
        // are excluded from scrollWidth — so naturalWidthRef must be refreshed against
        // the current DOM state each time the container changes size.
        const resizeObserver = new ResizeObserver(()=>{
            measureNaturalWidth();
            checkOverflow();
        });
        resizeObserver.observe(el);
        // Defer initial measurement until after layout has settled.
        // Running synchronously risks measuring against a temporarily narrow
        // clientWidth (e.g. while a dialog is animating open), which would
        // produce a false-positive overflow that never self-corrects.
        const rafId = requestAnimationFrame(()=>{
            measureNaturalWidth();
            checkOverflow();
        });
        return ()=>{
            cancelAnimationFrame(rafId);
            mutationObserver.disconnect();
            resizeObserver.disconnect();
        };
    }, [
        measureNaturalWidth,
        checkOverflow
    ]);
    return {
        containerRef: containerRef,
        isOverflowing: isOverflowing
    };
};


const $a921764ae1a692a7$var$stylesCompiled = {
    pillLineHeight: "_26BoRwey7F"
};
const $a921764ae1a692a7$var$styles = {
    button: "_0bjKvDKxmn _2sNsIgmnOE _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1UtDYzZpcK _0Of8r2gVvo _1Znuxb8HPE _1wydGWgVvo _2Zuz6Q8HPE _1kk5Tkf7mX _39HuIbz8Lp _1ANEUSLRg7 _3YEZNO7dHp _0KLXru66of _1eOmH6o126 _3gzVzLN4oS",
    queryText: "_3W2Oc8wPeg _2fwxA5ecOK _09eJsYMRGa",
    whiteSpacePreWrap: "_1ANEUSlpBW",
    luminaFollowUpButtonStyleOverrides: "_0bjKvDKxmn _2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _0KLXrunmFW _4ouGXIdnbC",
    luminaFollowUpButtonStyleOverridesImproved: "_0KLXrulfZc",
    luminaFollowUpButtonNoShrink: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP",
    pillHidden: "_3iDTPbYbGa",
    pillContainer: "_2mHwu82ADO _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _3TGfC9LRg7",
    pillContainerExpanded: "_4bt5LAYvD1 _2WAcuGYvD1 _3TGfC9HnLE",
    pillContainerInner: "_2mHwu82ADO _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _3YEZNO7dHp _4ouGXIdnbC",
    upliftWrapper: "_39xV02N91d"
};
// Stable reference: this feeds a useMemo dependency array.
const $a921764ae1a692a7$var$NO_FOLLOW_UPS = [];
const $a921764ae1a692a7$var$motionStyles = {
    button: "_23rrnHyKLB _3sFUREiSCN"
};
const $a921764ae1a692a7$export$f087ce3403d54eb5 = ({ omitDialogues: omitDialogues = false })=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, setQuery: setQuery, updateContextCache: updateContextCache, onClose: onClose, closeParentDialog: closeParentDialog, callbacks: callbacks, showChatFollowUps: showChatFollowUps } = (0, $3hVWe.useAIAnswerContext)();
    const { followUps: backendFollowUps, query: query, answerString: answerString, searchSessionId: searchSessionId, errorStateSuggestedQueries: errorStateSuggestedQueries } = commonAttributes; // Pills only. Do not move this onto commonAttributes.followUps: AIAnswerFooter mounts the
    // section holding Open chat off its length.
    const followUps = (0, $iDrrr.fg)('kd_sain_disable_llm_follow_ups') ? $a921764ae1a692a7$var$NO_FOLLOW_UPS : backendFollowUps;
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isUXUplift = (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled();
    const isImprovedChatOptions = (0, $7DMz5.SAINFeatureControl).isImprovedChatOptionsEnabled();
    const [showMore, setShowMore] = (0, $cozmU.useState)(false);
    const { containerRef: containerRef, isOverflowing: isOverflowing } = (0, $ca576dd46a8697bd$export$2160f22747f80da3)(); // Reset expanded state when follow-ups change (e.g. new query).
    // Use a stable string comparison instead of the array reference to avoid resetting
    // on every render when commonAttributes produces a new array object each time.
    const followUpsKey = followUps.join('\x00');
    (0, $cozmU.useEffect)(()=>{
        setShowMore(false); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        followUpsKey
    ]);
    const showNLPFollowUps = followUps.length > 0;
    const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    });
    const visibleFollowUps = (0, $cozmU.useMemo)(()=>{
        return showNLPFollowUps ? followUps.slice(0, 2) : serveErrorStateSuggestedQueriesExp ? errorStateSuggestedQueries.slice(0, 2) : [];
    }, [
        showNLPFollowUps,
        followUps,
        errorStateSuggestedQueries,
        serveErrorStateSuggestedQueriesExp
    ]);
    const showErrorStateSuggestedQueries = visibleFollowUps.length > 0 && !showNLPFollowUps;
    const onPillClick = (0, $cozmU.useCallback)((followUp)=>{
        if (showChatFollowUps) publish({
            type: 'chat-new',
            source: 'sain',
            data: {
                name: followUp.substring(0, 30),
                dialogues: omitDialogues ? [] : [
                    {
                        human_message: {
                            content: query
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ],
                prompt: followUp,
                sourceId: searchSessionId
            }
        });
        else {
            setQuery(followUp);
            updateContextCache({
                fromFollowUp: true
            });
        }
        fireAnalyticsEvent((0, $234e19cc92be917b$export$f1956b3bd380b51e)({
            ...commonAttributes,
            followUpString: followUp,
            destination: 'chat'
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).FOLLOWUP_CLICKED,
            commonAttributes: commonAttributes
        });
        onClose?.();
        closeParentDialog?.();
        callbacks?.onFollowUpSuggestionClick?.();
    }, [
        fireSAINUsageEvent,
        fireAnalyticsEvent,
        commonAttributes,
        onClose,
        closeParentDialog,
        callbacks,
        publish,
        query,
        answerString,
        searchSessionId,
        setQuery,
        updateContextCache,
        showChatFollowUps,
        omitDialogues
    ]);
    const onSuggestedQueryClick = (0, $cozmU.useCallback)((e, suggestedQuery)=>{
        e.preventDefault();
        e.stopPropagation();
        setQuery(suggestedQuery);
        fireAnalyticsEvent((0, $8450870f643523fa$export$97c5ff7b106e0023)({
            ...commonAttributes,
            errorStateSuggestedQuery: suggestedQuery
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).ERROR_STATE_SUGGESTED_QUERY_CLICKED,
            commonAttributes: commonAttributes
        });
        onClose?.();
        closeParentDialog?.();
    }, [
        setQuery,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        onClose,
        closeParentDialog,
        commonAttributes
    ]);
    const onSeeMoreClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $728210eecf84aa8d$export$e6174e7fdfd73609)({
            ...commonAttributes,
            expandButtonSource: 'followupSeeMore'
        }));
        setShowMore(true);
    }, [
        fireAnalyticsEvent,
        commonAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (showErrorStateSuggestedQueries) fireAnalyticsEvent((0, $ee9ece46b1b323f4$export$c1460cbf6075b68)({
            ...commonAttributes,
            showErrorStateSuggestedQueries: visibleFollowUps
        }));
    }, [
        showErrorStateSuggestedQueries,
        fireAnalyticsEvent,
        commonAttributes,
        visibleFollowUps
    ]);
    if (isUXUplift && showChatFollowUps) {
        const allFollowUps = isImprovedChatOptions ? followUps.slice(0, 2) : followUps.slice(0, 1); // Collapse only when gate is on, there are multiple follow-ups, and they overflow
        const isCollapsed = isImprovedChatOptions && isOverflowing && allFollowUps.length > 1;
        const pillBox = (followUp, hidden)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                "data-pill": true,
                xcss: (0, $w6R6I.cx)(hidden && $a921764ae1a692a7$var$styles.pillHidden, $a921764ae1a692a7$var$styles.luminaFollowUpButtonNoShrink, $a921764ae1a692a7$var$styles.luminaFollowUpButtonStyleOverrides, isImprovedChatOptions && $a921764ae1a692a7$var$styles.luminaFollowUpButtonStyleOverridesImproved),
                key: followUp
            }, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                content: followUp,
                position: "top"
            }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))),
                onClick: ()=>onPillClick(followUp),
                testId: "smart-answer-follow-up-button"
            }, followUp)));
        if (isImprovedChatOptions) return [
            /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $a921764ae1a692a7$var$styles.upliftWrapper,
                key: "uplift-wrapper"
            }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $a921764ae1a692a7$var$styles.pillContainer
            }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                ref: containerRef,
                xcss: (0, $w6R6I.cx)($a921764ae1a692a7$var$styles.pillContainerInner, showMore && $a921764ae1a692a7$var$styles.pillContainerExpanded)
            }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                "data-pill": true,
                xcss: (0, $w6R6I.cx)($a921764ae1a692a7$var$styles.luminaFollowUpButtonStyleOverrides, $a921764ae1a692a7$var$styles.luminaFollowUpButtonNoShrink, $a921764ae1a692a7$var$styles.luminaFollowUpButtonStyleOverridesImproved)
            }, /*#__PURE__*/ $cozmU.createElement((0, $1781bd9c74b8683a$export$dc40dedc9df6e59f), {
                prompt: query,
                query: query,
                answerString: answerString,
                source: "sain"
            })), allFollowUps.map((followUp, i)=>pillBox(followUp, isCollapsed && i > 0 && !showMore))), isCollapsed && !showMore && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($a921764ae1a692a7$var$styles.luminaFollowUpButtonStyleOverrides, $a921764ae1a692a7$var$styles.luminaFollowUpButtonStyleOverridesImproved)
            }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                appearance: "default",
                onClick: onSeeMoreClick,
                testId: "smart-answer-follow-up-expand-button"
            }, formatMessage((0, $75504fd7fe2b8992$export$defe85febe8b728c).ai_answer_followup_see_more)))))
        ];
        return [
            /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($a921764ae1a692a7$var$styles.luminaFollowUpButtonStyleOverrides, $a921764ae1a692a7$var$styles.luminaFollowUpButtonNoShrink),
                key: "open-chat"
            }, /*#__PURE__*/ $cozmU.createElement((0, $1781bd9c74b8683a$export$dc40dedc9df6e59f), {
                prompt: query,
                query: query,
                answerString: answerString,
                source: "sain"
            })),
            ...allFollowUps.map((followUp)=>pillBox(followUp, false))
        ];
    }
    return visibleFollowUps.length > 0 ? visibleFollowUps.map((followUp, index)=>{
        if (showChatFollowUps && !showErrorStateSuggestedQueries) return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            key: followUp
        }, /*#__PURE__*/ $cozmU.createElement((0, $eHdk6.FollowUpButton), {
            onClick: ()=>onPillClick(followUp),
            followUpText: followUp,
            followUpIndex: index,
            followUpType: "UNAVAILABLE",
            experienceId: "sain"
        }));
        if (showErrorStateSuggestedQueries) return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            key: followUp
        }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            xcss: (0, $w6R6I.cx)($a921764ae1a692a7$var$styles.button, (0, $iDrrr.fg)('platform-dst-motion-uplift-custom-button') && $a921764ae1a692a7$var$motionStyles.button),
            onClick: (e)=>onSuggestedQueryClick(e, followUp)
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $a921764ae1a692a7$var$stylesCompiled.pillLineHeight
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "baseline"
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            color: "currentColor",
            label: ""
        }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($a921764ae1a692a7$var$styles.queryText, $a921764ae1a692a7$var$styles.whiteSpacePreWrap)
        }, followUp)))));
        return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            key: followUp
        }, /*#__PURE__*/ $cozmU.createElement((0, $998a72255fc1cd90$export$ff0eb486c968b1bb), {
            onClick: ()=>onPillClick(followUp)
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            label: "",
            color: "var(--ds-icon, #292A2E)"
        }), /*#__PURE__*/ $cozmU.createElement((0, $41bfb9aa0fe17bb9$export$5d787e808dded622), null, followUp)));
    }) : null;
};



const $34e9b06075b84401$var$AkFeedbackCollector = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lavoB")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $34e9b06075b84401$var$AkFeedbackFlag = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lavoB")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $34e9b06075b84401$export$3553ee90c7edebc9 = ({ showOpenChat: showOpenChat })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { query: query, answerString: answerString } = commonAttributes;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a108aa903244750b$export$89b1508f9c43b29e), null, showOpenChat && !(0, $iDrrr.fg)('rovo_ai_mode_entrypoints_enabled') && !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1781bd9c74b8683a$export$dc40dedc9df6e59f), {
        prompt: query,
        query: query,
        answerString: answerString,
        source: 'sain'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a921764ae1a692a7$export$f087ce3403d54eb5), null));
};
const $34e9b06075b84401$var$AIAnswerBaseFooter = ({ showWhoAnswer: showWhoAnswer, showOpenChat: showOpenChat })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, userDetails: { name: name, id: id }, readingAidsOptions: readingAidsOptions, loading: loading, brand: brand, isAnswered: isAnswered, showChatFollowUps: showChatFollowUps, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const { errorState: errorState, answerFormat: answerFormat, followUps: followUps } = commonAttributes;
    const [showFeedbackModal, setFeedbackModal] = (0, $cozmU.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $cozmU.useState)(false);
    const [hasConsent, setConsent] = (0, $cozmU.useState)(false);
    const [topicsNotRelevant, setTopicsNotRelevant] = (0, $cozmU.useState)(false);
    const feedbackContextObject = {
        searchSessionId: commonAttributes.searchSessionId,
        source: commonAttributes.source,
        queryHash: commonAttributes.queryHash,
        cloudId: commonAttributes.cloudId,
        prompt: hasConsent ? commonAttributes.query : undefined,
        answer: hasConsent ? commonAttributes.answerString : undefined,
        documentId: readingAidsOptions?.contentARI,
        errorState: errorState,
        topicsNotRelevant: topicsNotRelevant ? true : undefined
    };
    const feedbackContext = Object.entries(feedbackContextObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $cozmU.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    const toggleTopicsNotRelevantCheckbox = (0, $cozmU.useCallback)(()=>{
        setTopicsNotRelevant(!topicsNotRelevant);
    }, [
        topicsNotRelevant
    ]);
    const topicsEnabled = (0, $iDrrr.fg)('kd_topics_in_person_card');
    const brandName = brand === (0, $zzZbq.AiBrand).ROVO ? 'Rovo' : sourceProduct === 'sac' ? '' : 'Atlassian Intelligence';
    const renderOpenChatButton = showOpenChat && showChatFollowUps && !loading && isAnswered && (0, $iDrrr.fg)('kd_smart_answers_open_chat');
    // Custom feedback options
    const SAC_CUSTOM_FEEDBACK_OPTIONS = [
        {
            label: formatMessage((0, $cb86z.messages).ai_answer_sac_feedback_option_not_relevant),
            value: 'not_relevant'
        },
        {
            label: formatMessage((0, $cb86z.messages).ai_answer_sac_feedback_option_not_accurate),
            value: 'not_accurate'
        },
        {
            label: formatMessage((0, $cb86z.messages).ai_answer_sac_feedback_option_too_slow),
            value: 'too_slow'
        },
        {
            label: formatMessage((0, $cb86z.messages).ai_answer_sac_feedback_option_unhelpful),
            value: 'unuseful_links'
        },
        {
            label: formatMessage((0, $cb86z.messages).ai_answer_sac_feedback_option_other),
            value: 'other'
        }
    ];
    const GENERIC_FEEDBACK_GROUPS_LABELS = {
        empty: {
            fieldLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_empty_option_share_label)
        },
        question: {
            fieldLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_relevance_option_label)
        },
        comment: {
            fieldLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_inaccurate_option_label)
        },
        bug: {
            fieldLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_offensive_option_label)
        },
        suggestion: {
            fieldLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_other_option_label)
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, showWhoAnswer && answerFormat === (0, $hpFQM.NLPSearchResultFormat).JSON && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f831fa9e697ed056$export$b03d109098afe32f), null), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6b6108766d435190$export$71c5dacfc0533c82), {
        isCompact: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $004bf88ef698cf7f$export$c633fc044a8b8981), {
        setDisplayFlag: setDisplayFlag,
        setFeedbackModal: setFeedbackModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null), (renderOpenChatButton || followUps.length > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$export$3553ee90c7edebc9, {
        showOpenChat: renderOpenChatButton
    }), showFeedbackModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, sourceProduct === 'sac' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$var$AkFeedbackCollector, {
        locale: locale,
        onClose: ()=>setFeedbackModal(false),
        onSubmit: ()=>{
            setDisplayFlag(true);
        },
        customContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, sourceProduct !== 'sac' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            label: formatMessage((0, $cb86z.messages).ai_answer_component_report_consent_checkbox_label),
            onChange: toggleConsentCheckbox,
            isChecked: hasConsent
        }), topicsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            label: formatMessage((0, $cb86z.messages).ai_answer_component_topics_not_relevant_checkbox_label),
            onChange: toggleTopicsNotRelevantCheckbox,
            isChecked: topicsNotRelevant
        })),
        atlassianAccountId: id,
        name: name,
        entrypointId: (0, $zzZbq.FEEDBACK_ENTRYPOINT_ID_SAIN),
        additionalFields: [
            {
                id: (0, $zzZbq.FEEDBACK_CONTEXT_CF),
                value: feedbackContext
            }
        ],
        feedbackTitle: formatMessage((0, $cb86z.messages).ai_answer_component_report_modal_title, {
            brandName: brandName
        }),
        feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b4f59c2c581899e2$export$8b91051e793e6316), null, formatMessage((0, $cb86z.messages).ai_answer_component_report_summary_label)),
        customFeedbackOptions: SAC_CUSTOM_FEEDBACK_OPTIONS,
        showDefaultTextFields: sourceProduct !== 'sac',
        descriptionDefaultValue: sourceProduct === 'sac' ? 'sac feedback' : '',
        summaryPlaceholder: formatMessage((0, $cb86z.messages).ai_answer_component_summary_placeholder_label)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$var$AkFeedbackCollector, {
        locale: locale,
        onClose: ()=>setFeedbackModal(false),
        onSubmit: ()=>{
            setDisplayFlag(true);
        },
        customContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, sourceProduct !== 'sac' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            label: formatMessage((0, $cb86z.messages).ai_answer_component_report_consent_checkbox_label),
            onChange: toggleConsentCheckbox,
            isChecked: hasConsent
        }), topicsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            label: formatMessage((0, $cb86z.messages).ai_answer_component_topics_not_relevant_checkbox_label),
            onChange: toggleTopicsNotRelevantCheckbox,
            isChecked: topicsNotRelevant
        })),
        atlassianAccountId: id,
        name: name,
        entrypointId: (0, $zzZbq.FEEDBACK_ENTRYPOINT_ID_SAIN),
        additionalFields: [
            {
                id: (0, $zzZbq.FEEDBACK_CONTEXT_CF),
                value: feedbackContext
            }
        ],
        feedbackTitle: formatMessage((0, $cb86z.messages).ai_answer_component_report_modal_title, {
            brandName: brandName
        }),
        feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b4f59c2c581899e2$export$8b91051e793e6316), null, formatMessage((0, $cb86z.messages).ai_answer_component_report_summary_label)),
        feedbackGroupLabels: GENERIC_FEEDBACK_GROUPS_LABELS,
        summaryPlaceholder: formatMessage((0, $cb86z.messages).ai_answer_component_summary_placeholder_label)
    })) : null, displayFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.FlagGroup), {
        onDismissed: ()=>setDisplayFlag(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$var$AkFeedbackFlag, {
        locale: locale,
        description: formatMessage((0, $cb86z.messages).ai_answer_component_feedback_flag_description)
    }))));
};
const $34e9b06075b84401$export$74b8b3463af67a4d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$var$AIAnswerBaseFooter, {
        showOpenChat: true
    });
};
const $34e9b06075b84401$var$AIAnswerDialogFooter = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$var$AIAnswerBaseFooter, {
        showWhoAnswer: true
    });
};
const $34e9b06075b84401$export$37858bd8fa3d5915 = ()=>{
    const { isReadingAids: isReadingAids, cardTemplate: cardTemplate } = (0, $3hVWe.useAIAnswerContext)();
    switch(cardTemplate){
        case (0, $zzZbq.CardTemplate).SMART_ANSWER:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$export$74b8b3463af67a4d, null);
        default:
            return isReadingAids ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd504f15d238fab3$export$9de8ba80314e4213), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$var$AIAnswerDialogFooter, null);
    }
};







const $d58a262274d16c7a$export$f3109245f09f7746 = (props)=>{
    const { query: query, answerString: answerString, source: source, answerHeight: answerHeight, containerHeight: containerHeight, whitespaceHeight: whitespaceHeight, queryIntent: queryIntent } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerResultComplete',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            answerHeight: answerHeight,
            containerHeight: containerHeight,
            whitespaceHeight: whitespaceHeight,
            queryIntent: queryIntent
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};





const $bd6e42147a6848a8$export$c68095583a3c17cc = (props)=>{
    const { query: query, answerString: answerString, source: source, timeToFirstByte: timeToFirstByte } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerResultFirstByte',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            timeToFirstByte: timeToFirstByte
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};








const $a7fd7127c63cb2fc$export$5671a2e254c14222 = ({ linkType: linkType, authorityUiMetadata: authorityUiMetadata, ...props })=>{
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerSourceLink',
        source: props.source,
        eventType: 'ui',
        // Intentionally non-UGC only: no query/answerString nonPrivacySafeAttributes.
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            clickOrigin: 'authoritativeAnswerPanel',
            linkType: linkType,
            ...(0, $fhQlP.getAuthorityAttributes)(authorityUiMetadata)
        }
    };
};

















/* index.tsx generated by @compiled/babel-plugin v3.0.1 */ 


















var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");




















var $aUgOE = parcelRequire("aUgOE");



















/* knowledge-smart-card.tsx generated by @compiled/babel-plugin v3.0.1 */ 















var $krxYo = parcelRequire("krxYo");


var $V3JOP = parcelRequire("V3JOP");
















var $4yYAm = parcelRequire("4yYAm");

var $l8wPz = parcelRequire("l8wPz");

var $aKJEB = parcelRequire("aKJEB");

var $i1503 = parcelRequire("i1503");

var $es2gJ = parcelRequire("es2gJ");

var $jdA6O = parcelRequire("jdA6O");


var $QXwxo = parcelRequire("QXwxo");

const $736ac3075308471f$export$a3b7216c107a7a1 = (sourceUrl)=>{
    let url;
    try {
        url = new URL(sourceUrl);
    } catch  {
        return undefined;
    }
    return url.hostname;
};






var $1xWgP = parcelRequire("1xWgP");




var $c7e955c1204bae2f$export$c32f46c9d34bc809 = /*#__PURE__*/ function(CardVariant) {
    CardVariant["COMPACT"] = "COMPACT";
    CardVariant["FULL"] = "FULL";
    CardVariant["DROPDOWN_SOURCE"] = "DROPDOWN_SOURCE";
    CardVariant["ACTION_CARD"] = "ACTION_CARD";
    return CardVariant;
}({});


const $9fdd133452866a73$export$61d53a7e0f2f3df1 = {
    'Google Drive': 'Google Drive',
    Loom: 'Loom',
    Google: 'Google',
    GoogleDrive: 'GoogleDrive'
};


const $688ab9534bb3cc83$var$messages = (0, $kSwu1.defineMessages)({
    navigate_button: {
        id: "search_ai.action_card_navigate_button",
        defaultMessage: "Navigate"
    }
});
const $688ab9534bb3cc83$var$unboundStyles = {
    compactContainer: "_0bjKvD8fU6 _313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _0KLXru66of _0wOv4Q7zJH _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _1EqgXlwBC3 _4kiQYAL04q _0noGBPN91d _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126",
    actionCardContainer: "_0bjKvD8fU6 _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _0KLXru66of _3iDTPbQ4SZ _0hPCNLDIqT _1EqgXlwBC3 _39xV02N91d _0Of8r28HPE _1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO",
    actionCardButton: "_2fwxA50dzo",
    fallbackContainer: "_0Of8r28HPE _1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO",
    embeddedCardContainer: "_39xV02N91d _21jNvKdnbC _0ED33gdnbC _00uLJWdnbC _0rVPxUdnbC _1a8zX6NCjk _3IuyDD8fU6 _2Qfy9J2Njc _0DHSz398eZ _2gOGE7YbGa _2dHj5OT6kp _2grDAeN91d",
    richSourceCardContainer: "_39xV02N91d _2z0KhOdnbC _3q4PvXdnbC _0wmW9LdnbC _3tAKcndnbC _4udW8o8fU6 _1h9OOm2Njc _2grDAeN91d _3cqaQkIZbP",
    titleBlockCss: "_2mHwu82ADO _2C9dkJ7GSX _0c6yoiM7Tp",
    compactTitleBlockCss: "_3wKy9BEqul _2AsftyFQfX",
    footerBlockCss: "_0jFU0V9DVM _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLz9WS _4xdlr0FlnN"
};
function $688ab9534bb3cc83$var$constructSourceUrl({ source: source, searchSessionId: searchSessionId }) {
    if (source.product === 'Confluence' && !!searchSessionId) {
        const url = new URL(source.url);
        url.searchParams.append('search_id', searchSessionId);
        return url.toString();
    }
    return source.url;
}
const $688ab9534bb3cc83$var$createCardClickHandler = (source, index, searchSessionId, onClickHandler, sourceCardType)=>(e)=>{
        onClickHandler?.({
            index: index,
            source: source,
            hostname: (0, $736ac3075308471f$export$a3b7216c107a7a1)(source.url),
            sourceCardType: sourceCardType
        });
        e.preventDefault();
        window.open($688ab9534bb3cc83$var$constructSourceUrl({
            source: source,
            searchSessionId: searchSessionId
        }), '_blank', 'noopener, noreferrer');
    };
const $688ab9534bb3cc83$var$createCardErrorHandler = (componentName)=>()=>{
        (0, $cuvLu.logger).error({
            error: new Error(`Error rendering ${componentName}`),
            functionName: componentName
        });
    };
function $688ab9534bb3cc83$var$SimpleFallbackCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    const handleClick = (e)=>{
        onClickHandler?.({
            index: index,
            source: source,
            hostname: (0, $736ac3075308471f$export$a3b7216c107a7a1)(source.url),
            sourceCardType: 'compact'
        });
        e.preventDefault();
        window.open($688ab9534bb3cc83$var$constructSourceUrl({
            source: source,
            searchSessionId: searchSessionId
        }), '_blank', 'noopener, noreferrer');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: source.url,
        xcss: $688ab9534bb3cc83$var$unboundStyles.compactContainer,
        onClick: handleClick,
        testId: "knowledge-smart-card-fallback"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $688ab9534bb3cc83$var$unboundStyles.fallbackContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1xWgP.AppIcon), {
        app: source.product,
        size: "large"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium",
        maxLines: 1
    }, source.title || source.url), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1
    }, source.product || '')))));
}
function $688ab9534bb3cc83$var$ActionCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $688ab9534bb3cc83$var$unboundStyles.actionCardContainer,
        testId: "knowledge-smart-card-action-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        label: "",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($krxYo))),
        appearance: "gray",
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "medium",
        maxLines: 1
    }, source.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: source.url,
        target: "_blank",
        rel: "noopener noreferrer",
        appearance: "subtle"
    }, source.url)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $688ab9534bb3cc83$var$unboundStyles.actionCardButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        href: source.url,
        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        onClick: $688ab9534bb3cc83$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'action-card')
    }, formatMessage($688ab9534bb3cc83$var$messages.navigate_button)))));
}
function $688ab9534bb3cc83$var$CompactKnowledgeSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $688ab9534bb3cc83$var$unboundStyles.compactContainer,
        testId: "knowledge-smart-card-compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QXwxo.CardSSR), {
        appearance: "block",
        url: source.url,
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            size: (0, $4yYAm.SmartLinkSize).Medium,
            removeBlockRestriction: true
        },
        fallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$SimpleFallbackCard, {
                source: source,
                index: index,
                searchSessionId: searchSessionId,
                onClickHandler: onClickHandler
            }),
        onClick: $688ab9534bb3cc83$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'compact'),
        onError: $688ab9534bb3cc83$var$createCardErrorHandler('CompactKnowledgeSmartCard')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        maxLines: 1,
        size: (0, $4yYAm.SmartLinkSize).Small,
        subtitle: [
            {
                name: (0, $4yYAm.ElementName).Provider
            }
        ],
        position: (0, $4yYAm.SmartLinkPosition).Center,
        hideIcon: true,
        className: (0, $hekY6.default)([
            $688ab9534bb3cc83$var$unboundStyles.compactTitleBlockCss
        ])
    }))));
}
function $688ab9534bb3cc83$var$StandardKnowledgeSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    const footerActions = (0, $cozmU.useMemo)(()=>[
            {
                name: (0, $4yYAm.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $4yYAm.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $4yYAm.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const topMetadata = [
        {
            name: (0, $4yYAm.ElementName).AuthorGroup
        },
        {
            name: (0, $4yYAm.ElementName).AssignedTo
        },
        {
            name: (0, $4yYAm.ElementName).CreatedBy
        },
        {
            name: (0, $4yYAm.ElementName).ModifiedOn
        }
    ];
    const titleMetadata = [
        {
            name: (0, $4yYAm.ElementName).State
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $688ab9534bb3cc83$var$unboundStyles.richSourceCardContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "block",
        url: source.url,
        fallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$SimpleFallbackCard, {
                source: source,
                index: index,
                searchSessionId: searchSessionId,
                onClickHandler: onClickHandler
            }),
        ui: {
            removeBlockRestriction: true
        },
        onClick: $688ab9534bb3cc83$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'rich-flexible'),
        onError: $688ab9534bb3cc83$var$createCardErrorHandler('StandardKnowledgeSmartCard')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        maxLines: 1,
        metadata: titleMetadata,
        className: (0, $hekY6.default)([
            $688ab9534bb3cc83$var$unboundStyles.titleBlockCss
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
        primary: topMetadata,
        maxLines: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKJEB.default), {
        actions: footerActions,
        className: (0, $hekY6.default)([
            $688ab9534bb3cc83$var$unboundStyles.footerBlockCss
        ])
    }))));
}
function $688ab9534bb3cc83$var$EmbeddedKnowledgeSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $688ab9534bb3cc83$var$unboundStyles.embeddedCardContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "embed",
        fallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$SimpleFallbackCard, {
                source: source,
                index: index,
                searchSessionId: searchSessionId,
                onClickHandler: onClickHandler
            }),
        inheritDimensions: true,
        frameStyle: "show",
        url: source.url,
        onClick: $688ab9534bb3cc83$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'embedded'),
        onError: $688ab9534bb3cc83$var$createCardErrorHandler('EmbeddedKnowledgeSmartCard')
    })));
}
function $688ab9534bb3cc83$var$DropdownSourceSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "block",
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            size: (0, $4yYAm.SmartLinkSize).Medium,
            removeBlockRestriction: true
        },
        url: source.url,
        onClick: $688ab9534bb3cc83$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'dropdown-source'),
        onError: $688ab9534bb3cc83$var$createCardErrorHandler('DropdownSourceSmartCard')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        maxLines: 1,
        size: (0, $4yYAm.SmartLinkSize).Medium
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), {
        maxLines: 2
    })));
} /**
   * @deprecated Use KnowledgeSmartCard from @atlassian/lumina instead.
   *
   * @example
   * import { KnowledgeSmartCard } from '@atlassian/lumina';
   */ 
const $688ab9534bb3cc83$export$dfe41ae7345cd34b = ({ source: source, variant: variant, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler })=>{
    // Apply defaults for internal components
    const internalProps = {
        source: source,
        index: index || 0,
        searchSessionId: searchSessionId || '',
        onClickHandler: onClickHandler || (()=>{})
    };
    if (variant === (0, $c7e955c1204bae2f$export$c32f46c9d34bc809).COMPACT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$CompactKnowledgeSmartCard, internalProps);
    if (variant === (0, $c7e955c1204bae2f$export$c32f46c9d34bc809).DROPDOWN_SOURCE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$DropdownSourceSmartCard, internalProps);
    if (variant === (0, $c7e955c1204bae2f$export$c32f46c9d34bc809).ACTION_CARD) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$ActionCard, internalProps);
    const shouldUseEmbedded = source.product && source.product in (0, $9fdd133452866a73$export$61d53a7e0f2f3df1);
    if (shouldUseEmbedded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$EmbeddedKnowledgeSmartCard, internalProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$StandardKnowledgeSmartCard, internalProps);
};





const $59f8e361f9553c0b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    sources_title: {
        id: "search_ai.sources_label",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numSources, plural, =1 {Source} other {Sources}}"
    },
    related_links_title: {
        id: "search_ai.related_links_label",
        defaultMessage: "Related links"
    }
});


/* source-card.tsx generated by @compiled/babel-plugin v3.0.1 */ 










const $1b1a8e20e360a5ba$var$Card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("bE9h1")).then(({ Card: Card })=>({
            default: Card
        })));
const $1b1a8e20e360a5ba$var$resolveUrlPlaceholder = (url)=>{
    const textFragmentRegex = new RegExp('#:~:text=.*$', 'g');
    const urlWithoutTextFragment = url?.replace(textFragmentRegex, '');
    const maxLength = 30;
    const truncatedUrl = urlWithoutTextFragment.length > maxLength ? urlWithoutTextFragment.slice(0, maxLength) + '...' : urlWithoutTextFragment;
    return truncatedUrl;
};
const $1b1a8e20e360a5ba$var$constructSourceUrl = ({ source: source, searchSessionId: searchSessionId })=>{
    if (source.product === 'Confluence') {
        const url = new URL(source.url);
        url.searchParams.append('search_id', searchSessionId);
        return url.toString();
    } else return source.url;
};
const $1b1a8e20e360a5ba$var$fallbackComponent = ({ index: index, source: source, searchSessionId: searchSessionId, onClickHandler: onClickHandler })=>()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: $1b1a8e20e360a5ba$var$constructSourceUrl({
                source: source,
                searchSessionId: searchSessionId
            }),
            onClick: ()=>onClickHandler(index, source, (0, $736ac3075308471f$export$a3b7216c107a7a1)(source.url)),
            rel: "noopener noreferrer",
            target: "_blank"
        }, source.title ?? source.url);
    };
const $1b1a8e20e360a5ba$export$c74cbf75d6285884 = ({ index: index, source: source, searchSessionId: searchSessionId, onClickHandler: onClickHandler, enableSmartLinkSources: enableSmartLinkSources })=>{
    const SmartLinkSource = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1b1a8e20e360a5ba$var$Card, {
        appearance: "inline",
        url: source.url,
        removeTextHighlightingFromTitle: true,
        showHoverPreview: true,
        fallbackComponent: $1b1a8e20e360a5ba$var$fallbackComponent({
            index: index,
            source: source,
            searchSessionId: searchSessionId,
            onClickHandler: onClickHandler
        }),
        onClick: (e)=>{
            onClickHandler(index, source, (0, $736ac3075308471f$export$a3b7216c107a7a1)(source.url));
            e.preventDefault();
            window.open($1b1a8e20e360a5ba$var$constructSourceUrl({
                source: source,
                searchSessionId: searchSessionId
            }), '_blank', 'noopener, noreferrer');
        },
        onError: ()=>{},
        resolvingPlaceholder: $1b1a8e20e360a5ba$var$resolveUrlPlaceholder(source.url),
        placeholder: $1b1a8e20e360a5ba$var$resolveUrlPlaceholder(source.url)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, enableSmartLinkSources ? SmartLinkSource : $1b1a8e20e360a5ba$var$fallbackComponent({
        index: index,
        source: source,
        searchSessionId: searchSessionId,
        onClickHandler: onClickHandler
    })());
};


const $ce789c5dd436d96e$var$CAROUSEL_SOURCE_CARD_WIDTH = 350;
const $ce789c5dd436d96e$var$CAROUSEL_SOURCE_OFFSET = $ce789c5dd436d96e$var$CAROUSEL_SOURCE_CARD_WIDTH + 16; // width + gap
const $ce789c5dd436d96e$var$styles = {
    cardTitle: "_3138428HPE _1DCdHi5zaO",
    container: "_39xV02N91d _313842gVvo",
    carouselSourceCardContainer: "_4bt5LAnQyn _2WAcuGnQyn _1bHrqEaQBb _2O5VijdnbC _3YEZNOdnbC _1ANEUSJfqQ _39xV02aQBb _1EqgXlaQBb"
};
const $ce789c5dd436d96e$var$unboundStyles = {
    smartCard: "_0jFU0V6Aep _2opLeZ6Aep _0ZwTMg6Aep"
};
const $ce789c5dd436d96e$var$sourcesContainerStyles = null;
const $ce789c5dd436d96e$var$freeFlowLinksStyles = null;
const $ce789c5dd436d96e$var$Sources = ({ sources: sources, searchSessionId: searchSessionId, onClickHandler: onClickHandler, allowFreeflowLayout: allowFreeflowLayout, verticalLayout: verticalLayout, enableSmartLinkSources: enableSmartLinkSources = true })=>{
    const [showAllSources, setShowAllSources] = (0, $cozmU.useState)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const canExpand = sources.length > 1 && verticalLayout;
    const visibleSources = showAllSources || !verticalLayout ? sources : sources.slice(0, 1);
    const onExpandButtonClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $728210eecf84aa8d$export$e6174e7fdfd73609)({
            ...commonAttributes,
            expandButtonSource: 'sources'
        }));
        setShowAllSources(!showAllSources);
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        showAllSources
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, visibleSources.map((source, index)=>/*#__PURE__*/ $cozmU.createElement("div", {
            key: `ai-answer-source-${index}`,
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0aFT5v1qpb _0GwItXDIqT _17lj8p1Y8M",
                allowFreeflowLayout && "_3iDTPbS8kF _26BoRwiZR3 _0adFHsgVvo"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $1b1a8e20e360a5ba$export$c74cbf75d6285884), {
            index: index,
            key: `search-ai-answer-source-${index}`,
            source: source,
            searchSessionId: searchSessionId,
            onClickHandler: onClickHandler,
            enableSmartLinkSources: enableSmartLinkSources
        }), index === 0 && canExpand && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            onClick: onExpandButtonClick,
            icon: (iconProps)=>showAllSources ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    color: "currentColor",
                    testId: "collapse-sources-icon",
                    size: "small"
                }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    ...iconProps,
                    color: "currentColor",
                    testId: "expand-sources-icon",
                    size: "small"
                }),
            label: showAllSources ? (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? 'Collapse sources' : 'Collapse sources button' : (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? 'Expand sources' : 'Expand sources button',
            spacing: "compact",
            appearance: "subtle"
        }))));
};
const $ce789c5dd436d96e$var$LayoutWrapper = (props)=>{
    if (props.allowFreeflowLayout) return /*#__PURE__*/ $cozmU.createElement("div", null, props.children);
    else if (props.verticalLayout) return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, props.children);
    else return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.075",
        shouldWrap: true
    }, props.children);
};
const $ce789c5dd436d96e$export$bbbfd63fa7f32357 = (props)=>{
    const { sources: ogSources, searchSessionId: searchSessionId, title: title, onClickHandler: onClickHandler = ()=>{}, allowFreeflowLayout: allowFreeflowLayout = false, verticalLayout: verticalLayout = false, limit: limit, enableSmartLinkSources: enableSmartLinkSources, isReadingAids: isReadingAids = false } = props;
    const sourcesTitle = title ?? (0, $59f8e361f9553c0b$export$defe85febe8b728c).sources_title;
    const sources = limit ? ogSources.slice(0, limit) : ogSources;
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const MaybeSmartCardProvider = enableSmartLinkSources !== false ? (0, $c2Doe.SmartCardProvider) : (0, $cozmU.Fragment);
    if (!sources.length) return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null);
    return /*#__PURE__*/ $cozmU.createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $ce789c5dd436d96e$var$styles.cardTitle
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xxsmall"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small",
        weight: "bold"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...sourcesTitle,
        values: {
            numSources: sources.length
        }
    })))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $ce789c5dd436d96e$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement($ce789c5dd436d96e$var$LayoutWrapper, {
        allowFreeflowLayout: allowFreeflowLayout,
        verticalLayout: verticalLayout
    }, /*#__PURE__*/ $cozmU.createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: isReadingAids ? (0, $uY2pq.SearchAIAnalyticsContextLocation).AI_DEFINITION : (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ $cozmU.createElement(MaybeSmartCardProvider, null, /*#__PURE__*/ $cozmU.createElement($ce789c5dd436d96e$var$Sources, {
        sources: sources,
        searchSessionId: searchSessionId,
        onClickHandler: onClickHandler,
        allowFreeflowLayout: allowFreeflowLayout,
        verticalLayout: verticalLayout,
        enableSmartLinkSources: enableSmartLinkSources
    })))))));
};
function $ce789c5dd436d96e$var$AISourcesCarouselHeading({ numSources: numSources }) {
    const headingMessage = (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? (0, $59f8e361f9553c0b$export$defe85febe8b728c).related_links_title : (0, $59f8e361f9553c0b$export$defe85febe8b728c).sources_title;
    return /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...headingMessage,
        values: {
            numSources: numSources
        }
    }));
}
function $ce789c5dd436d96e$export$919320f9832aec1d(props) {
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { sources: sources, searchSessionId: searchSessionId, onClickHandler: onClickHandler, isReadingAids: isReadingAids = false } = props;
    return /*#__PURE__*/ $cozmU.createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $ce789c5dd436d96e$var$styles.container,
        testId: "ai-sources-carousel"
    }, /*#__PURE__*/ $cozmU.createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: isReadingAids ? (0, $uY2pq.SearchAIAnalyticsContextLocation).AI_DEFINITION : (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ $cozmU.createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $ec82c8c1e1d8eeb1$export$61c045a5252abd1d), {
        heading: /*#__PURE__*/ $cozmU.createElement($ce789c5dd436d96e$var$AISourcesCarouselHeading, {
            numSources: sources.length
        }),
        scrollOffset: $ce789c5dd436d96e$var$CAROUSEL_SOURCE_OFFSET
    }, sources.map((source, index)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: `search-ai-answer-source-${index}`,
            xcss: (0, $w6R6I.cx)($ce789c5dd436d96e$var$styles.carouselSourceCardContainer, $ce789c5dd436d96e$var$unboundStyles.smartCard)
        }, (0, $iDrrr.fg)('kd_use_common_knowledge_card') ? /*#__PURE__*/ $cozmU.createElement((0, $aUgOE.KnowledgeSmartCard), {
            index: index,
            source: source,
            searchSessionId: searchSessionId,
            onClickHandler: onClickHandler
        }) : /*#__PURE__*/ $cozmU.createElement((0, $688ab9534bb3cc83$export$dfe41ae7345cd34b), {
            index: index,
            source: source,
            searchSessionId: searchSessionId,
            onClickHandler: onClickHandler
        })))))))));
}











const $c581527c64231606$export$aef55698754fc321 = ({ sourceIndex: sourceIndex, isCitation: isCitation, isAuxClick: isAuxClick, isContextMenu: isContextMenu, hostname: hostname, sourceCardType: sourceCardType, sourceProduct: sourceProduct, is3PSource: is3PSource, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerSourceLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            sourceIndex: sourceIndex,
            isCitation: isCitation,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu,
            sourceCardType: sourceCardType,
            sourceProduct: sourceProduct,
            is3PSource: is3PSource,
            ...hostname ? {
                metadata: {
                    hostname: hostname
                }
            } : {}
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};














const $280875adc8c5626f$export$6be22f9840eb8748 = ({ aiAnswerDialogContext: aiAnswerDialogContext, isCitation: isCitation = false })=>{
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    // Validate context
    if (!aiAnswerDialogContext || !aiAnswerDialogContext.commonAttributes) throw new Error("useKnowledgeSmartCardAnalytics requires a valid AIAnswerContext. Ensure you pass the context from useAIAnswerContext().");
    const { commonAttributes: commonAttributes, callbacks: callbacks } = aiAnswerDialogContext;
    const handleSmartCardClick = (0, $cozmU.useCallback)(({ index: index, source: source, hostname: hostname, sourceCardType: sourceCardType, isAuxClick: isAuxClick, isContextMenu: isContextMenu })=>{
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu,
            sourceCardType: sourceCardType,
            sourceProduct: source?.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source?.product),
            isCitation: !!isCitation,
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source?.product || '',
            source: source
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks,
        isCitation
    ]);
    return {
        handleSmartCardClick: handleSmartCardClick,
        searchSessionId: commonAttributes.searchSessionId
    };
};


/* sources-bar.tsx generated by @compiled/babel-plugin v3.0.1 */ 












var $kUFQ0 = parcelRequire("kUFQ0");




















var $dmWtJ = parcelRequire("dmWtJ");

function $1885669c9a19ffc2$export$fb422644050f6872(product, url) {
    if (product === 'Microsoft') {
        if (url.includes('sharepoint.com')) return 'sharepoint';
        if (url.includes('powerbi.com')) return 'power-bi';
        if (url.includes('teams.microsoft.com')) return 'teams';
    }
    return product ?? '';
}


const $f0122fe4f75fa739$var$DEFAULT_MAX_SOURCES_IN_STACK = 3;
function $f0122fe4f75fa739$export$ebff7094edd1bb81({ maxSourcesInStack: maxSourcesInStack, sources: sources, showNumAddtlSources: showNumAddtlSources, testId: testId, addEditorStyleOverrides: addEditorStyleOverrides, shuffled: shuffled = false }) {
    if (sources.length === 0) return null;
    const sourcesForIconStack = [];
    const sourceProductsMap = {};
    maxSourcesInStack = maxSourcesInStack ?? $f0122fe4f75fa739$var$DEFAULT_MAX_SOURCES_IN_STACK;
    for(let i = 0; i < sources.length; i++){
        const source = sources[i];
        const appKey = (0, $1885669c9a19ffc2$export$fb422644050f6872)(source.product, source.url) || 'Unknown';
        if (!sourceProductsMap[appKey]) {
            sourcesForIconStack.push(source);
            sourceProductsMap[appKey] = true;
        }
        if (sourcesForIconStack.length === maxSourcesInStack) break;
    }
    const appIcons = sourcesForIconStack.map((source)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1xWgP.AppIcon), {
            // still need to convert product to correct subproduct e.g. for Microsoft
            app: (0, $1885669c9a19ffc2$export$fb422644050f6872)(source.product, source.url),
            "data-testid": `app-icon-${source.ari}`,
            key: source.ari,
            size: "xxsmall"
        }));
    // want to display the number of additional sources that are not included in the appIcons stack
    const numAddtlSources = sources.length - appIcons.length;
    return appIcons.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dmWtJ.IconStack), {
        testId: testId,
        addEditorStyleOverrides: addEditorStyleOverrides,
        shuffled: shuffled
    }, appIcons), showNumAddtlSources && numAddtlSources > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, "+", numAddtlSources)) : null;
}


const $7fd6a1524e779285$var$messages = (0, $kSwu1.defineMessages)({
    referencing: {
        id: "search_ai.sources_bar_referencing",
        defaultMessage: "Referencing"
    },
    sources_count: {
        id: "search_ai.sources_bar_sources_count",
        defaultMessage: "{numSources} {numSources, plural, one {source} other {sources}}"
    }
});
const $7fd6a1524e779285$var$styles = {
    button: "_0bjKvDKTcp _4c065U2ADO _2Y7lL42ADO _1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _39xV02N91d _0KLXrunmFW _3CkH9oww0T _3OqcjTZYp7 _1DJ2rV2jUH",
    flippedIcon: "_1VJPcal236 _3iDTPbccYA"
};
const $7fd6a1524e779285$export$e754cddb4d3a7903 = ({ sources: sources, numSources: numSources, onClick: onClick, triggerRef: triggerRef })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $7fd6a1524e779285$var$styles.button,
        onClick: onClick,
        testId: "sources-bar-button",
        ref: triggerRef
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            $7fd6a1524e779285$var$styles.flippedIcon
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kUFQ0))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small"
    }, formatMessage($7fd6a1524e779285$var$messages.referencing)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small",
        weight: "medium"
    }, formatMessage($7fd6a1524e779285$var$messages.sources_count, {
        numSources: numSources
    })))), /*#__PURE__*/ $cozmU.createElement((0, $f0122fe4f75fa739$export$ebff7094edd1bb81), {
        sources: sources,
        maxSourcesInStack: 4,
        shuffled: true
    })), /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }));
};


/* sources-side-panel.tsx generated by @compiled/babel-plugin v3.0.1 */ 































var $bGNkz = parcelRequire("bGNkz");




























var $1WRnE = parcelRequire("1WRnE");

const $f76c30d78079e3b2$var$styles = {
    container: ""
};
const $f76c30d78079e3b2$var$unboundStyles = {
    titleBlockCss: "_3wKy9BmnOE _2C9dkJ7GSX _0c6yoiy7kJ _31SDeSy7kJ",
    metadataBlockCss: "_4keetJKGUX",
    snippetBlockCss: "_4keetJZpcK"
};
const $f76c30d78079e3b2$export$554b5f10e8e833c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { source: source, index: index, onClickHandler: onClickHandler, onError: onError, searchSessionId: searchSessionId } = t0;
    let t1;
    if ($[0] !== index || $[1] !== onClickHandler || $[2] !== searchSessionId || $[3] !== source) {
        t1 = (e)=>{
            const isAuxClick = e.button === 1;
            const isContextMenu = e.button === 2;
            onClickHandler?.({
                index: index,
                source: source,
                sourceCardType: "side-panel-source",
                isAuxClick: isAuxClick,
                isContextMenu: isContextMenu
            });
            if (!isContextMenu) {
                e.preventDefault();
                const url = (0, $1WRnE.constructSourceUrl)({
                    source: source,
                    searchSessionId: searchSessionId
                });
                window.open(url, "_blank", "noopener, noreferrer");
            }
        };
        $[0] = index;
        $[1] = onClickHandler;
        $[2] = searchSessionId;
        $[3] = source;
        $[4] = t1;
    } else t1 = $[4];
    const handleClick = t1;
    let t2;
    if ($[5] !== handleClick) {
        t2 = (e_0)=>{
            if (e_0.button !== 1) return;
            handleClick(e_0);
        };
        $[5] = handleClick;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true
        };
        $[7] = t3;
    } else t3 = $[7];
    const t4 = onError || $f76c30d78079e3b2$var$_temp;
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [
            {
                name: (0, $4yYAm.ActionName).CopyLinkAction,
                hideContent: true
            },
            {
                name: (0, $4yYAm.ActionName).PreviewAction,
                hideContent: true
            }
        ];
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
            maxLines: 1,
            actions: t5,
            showActionOnHover: true,
            position: (0, $4yYAm.SmartLinkPosition).Center,
            className: (0, $hekY6.default)([
                $f76c30d78079e3b2$var$unboundStyles.titleBlockCss
            ])
        });
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = [
            {
                name: (0, $4yYAm.ElementName).ModifiedOn
            },
            {
                name: (0, $4yYAm.ElementName).ModifiedBy
            },
            {
                name: (0, $4yYAm.ElementName).OwnedBy
            }
        ];
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
            primary: t7,
            maxLines: 1,
            className: (0, $hekY6.default)([
                $f76c30d78079e3b2$var$unboundStyles.metadataBlockCss
            ])
        });
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), {
            maxLines: 2,
            className: (0, $hekY6.default)([
                $f76c30d78079e3b2$var$unboundStyles.snippetBlockCss
            ])
        });
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== handleClick || $[14] !== source.url || $[15] !== t4) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
            appearance: "block",
            showHoverPreview: false,
            ui: t3,
            url: source.url,
            onClick: handleClick,
            onError: t4
        }, t6, t8, t9);
        $[13] = handleClick;
        $[14] = source.url;
        $[15] = t4;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== handleClick || $[18] !== t10 || $[19] !== t2) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f76c30d78079e3b2$var$styles.container,
            onAuxClick: t2,
            onContextMenu: handleClick
        }, t10);
        $[17] = handleClick;
        $[18] = t10;
        $[19] = t2;
        $[20] = t11;
    } else t11 = $[20];
    return t11;
} : ({ source: source, index: index, onClickHandler: onClickHandler, onError: onError, searchSessionId: searchSessionId })=>{
    const handleClick = (e)=>{
        const isAuxClick = e.button === 1;
        const isContextMenu = e.button === 2;
        onClickHandler?.({
            index: index,
            source: source,
            sourceCardType: 'side-panel-source',
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        });
        if (!isContextMenu) {
            e.preventDefault();
            const url = (0, $1WRnE.constructSourceUrl)({
                source: source,
                searchSessionId: searchSessionId
            });
            window.open(url, '_blank', 'noopener, noreferrer');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f76c30d78079e3b2$var$styles.container,
        onAuxClick: (e_0)=>{
            if (e_0.button !== 1) return;
            handleClick(e_0);
        },
        onContextMenu: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "block",
        showHoverPreview: false,
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true
        },
        url: source.url,
        onClick: handleClick,
        onError: onError || (()=>{})
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        maxLines: 1,
        actions: [
            {
                name: (0, $4yYAm.ActionName).CopyLinkAction,
                hideContent: true
            },
            {
                name: (0, $4yYAm.ActionName).PreviewAction,
                hideContent: true
            }
        ],
        showActionOnHover: true,
        position: (0, $4yYAm.SmartLinkPosition).Center,
        className: (0, $hekY6.default)([
            $f76c30d78079e3b2$var$unboundStyles.titleBlockCss
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
        primary: [
            {
                name: (0, $4yYAm.ElementName).ModifiedOn
            },
            {
                name: (0, $4yYAm.ElementName).ModifiedBy
            },
            {
                name: (0, $4yYAm.ElementName).OwnedBy
            }
        ],
        maxLines: 1,
        className: (0, $hekY6.default)([
            $f76c30d78079e3b2$var$unboundStyles.metadataBlockCss
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), {
        maxLines: 2,
        className: (0, $hekY6.default)([
            $f76c30d78079e3b2$var$unboundStyles.snippetBlockCss
        ])
    })));
};
function $f76c30d78079e3b2$var$_temp() {}

















const $fe4d4049968826dc$var$messages = (0, $kSwu1.defineMessages)({
    sources_button_text: {
        id: "search_ai.sources_side_panel_button_text",
        defaultMessage: "{numSources, plural, one {Source} other {Sources}}"
    },
    sources_panel_title: {
        id: "search_ai.sources_side_panel_title",
        defaultMessage: "{numSources, plural, one {{numSources, number} Source} other {{numSources, number} Sources}}"
    },
    close_panel: {
        id: "search_ai.sources_side_panel_close",
        defaultMessage: "Close sources panel"
    }
});
const $fe4d4049968826dc$var$styles = {
    panel: "_1mT5xdy1CL _2IhTonp0Oa _4ApkO2Pgdg _0Bm75GPgdg _39xV02N6MY _0KLXruoI2d _1Vs123NvrM _421I1o6wH8 _0obpEh9r67 _3iDTPbQ4SZ _0aFT5vbt8w",
    panelHeader: "_37wbyuI7V3 _0hPCNLDIqT _0jFU0VStgI _3YEZNOdnbC _1Znuxb5zaO _2Zuz6Q5zaO _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67",
    panelContent: "_2mHwu88HPE _2WAcuGIZbP _2O5Vij7dHp _0Of8r22ADO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    sourceItem: "_0Of8r22ADO _1wydGW2ADO"
};
const $fe4d4049968826dc$export$7552c1f78575b57c = ({ renderTrigger: renderTrigger } = {})=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { commonAttributes: commonAttributes } = context;
    const { sources: sources } = commonAttributes;
    const { handleSmartCardClick: handleSmartCardClick, searchSessionId: searchSessionId } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context
    });
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const panelRef = (0, $cozmU.useRef)(null);
    const triggerRef = (0, $cozmU.useRef)(null);
    const { mounted: isChatMounted } = (0, $bGNkz.useUIStore)();
    const prevChatMounted = (0, $cozmU.useRef)(isChatMounted);
    (0, $cozmU.useEffect)(()=>{
        if (isChatMounted && !prevChatMounted.current) setIsOpen(false);
        prevChatMounted.current = isChatMounted;
    }, [
        isChatMounted
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isOpen && panelRef.current) panelRef.current.focus();
    }, [
        isOpen
    ]);
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const handleToggle = (0, $cozmU.useCallback)(()=>{
        setIsOpen((prev)=>{
            if (!prev) {
                fireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
                    ...commonAttributes,
                    elementInteracted: 'sources-side-panel-button'
                }));
                fireSAINUsageEvent({
                    metCriteria: (0, $bZMnB.SainAction).VIEW_ALL_SOURCES,
                    commonAttributes: commonAttributes
                });
                if (isChatMounted) publish({
                    type: 'chat-close',
                    source: 'sain',
                    data: {}
                });
            }
            return !prev;
        });
    }, [
        isChatMounted,
        publish,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        commonAttributes
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        triggerRef.current?.focus();
    }, []);
    if (!sources || sources.length === 0) return null;
    const numSources = sources.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderTrigger ? renderTrigger(handleToggle, triggerRef) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handleToggle,
        testId: "sources-side-panel-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0122fe4f75fa739$export$ebff7094edd1bb81), {
        sources: sources
    }), formatMessage($fe4d4049968826dc$var$messages.sources_button_text, {
        numSources: numSources
    }))), isOpen && /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fe4d4049968826dc$var$styles.panel,
        testId: "sources-side-panel",
        ref: panelRef,
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $fe4d4049968826dc$var$styles.panelHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage($fe4d4049968826dc$var$messages.sources_panel_title, {
        numSources: numSources
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($fe4d4049968826dc$var$messages.close_panel),
        onClick: handleClose
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $fe4d4049968826dc$var$styles.panelContent
    }, sources.map((source, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: source.url || index,
            xcss: $fe4d4049968826dc$var$styles.sourceItem,
            testId: `sources-side-panel-item-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f76c30d78079e3b2$export$554b5f10e8e833c8), {
            source: source,
            index: index,
            searchSessionId: searchSessionId,
            onClickHandler: handleSmartCardClick
        }))))), document.body));
};












function $d3e29575f8ad4c54$export$8f4f0a9c358684c2(streamedTextToDisplay, isStreamComplete = false) {
    const [bufferedContent, setBufferedContent] = (0, $cozmU.useState)('');
    (0, $cozmU.useEffect)(()=>{
        // When streamed text is cleared reset buffered content
        if (!streamedTextToDisplay && bufferedContent && (0, $iDrrr.fg)('kd_fix_abort_errors')) {
            setBufferedContent('');
            return;
        }
        // Split by newlines to handle various line endings
        const lines = streamedTextToDisplay.split(/\r?\n|\r/);
        // If stream is complete, include all content including the last line
        if (isStreamComplete) {
            const allContent = lines.join('\n');
            if (allContent !== bufferedContent) {
                const delay = bufferedContent === '' ? 0 : 250;
                setTimeout(()=>{
                    setBufferedContent(allContent);
                }, delay);
            }
            return;
        }
        // Only update if we have more than one line (complete sections)
        if (lines.length > 1) {
            // Take everything except the last line (incomplete section)
            const completeSections = lines.slice(0, -1).join('\n');
            // Only update if the complete sections are different from what we already have
            if (completeSections !== bufferedContent) {
                // First section appears immediately, subsequent sections have delay
                const delay = bufferedContent === '' ? 0 : 250;
                setTimeout(()=>{
                    setBufferedContent(completeSections);
                }, delay);
            }
        }
    }, [
        streamedTextToDisplay,
        bufferedContent,
        isStreamComplete
    ]);
    return bufferedContent;
}








function $1dee242400437624$export$fd29db098e42c3fc(observeTargetRef, resizeObserverCallback, pollInterval = 100, additionalDeps = []) {
    const resizeObserverRef = (0, $cozmU.useRef)(null);
    const pollIntervalRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const observeDelayedTarget = ()=>{
            if (!observeTargetRef.current) return;
            // clear polling once target is ready
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
            resizeObserverRef.current = new ResizeObserver(resizeObserverCallback);
            resizeObserverRef.current.observe(observeTargetRef.current);
        };
        // start polling for the target
        observeDelayedTarget(); // check immediately
        pollIntervalRef.current = setInterval(observeDelayedTarget, pollInterval);
        return ()=>{
            if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
            if (resizeObserverRef.current) resizeObserverRef.current.disconnect();
        };
    }, [
        ...additionalDeps
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}


function $6df3d09e09b61b24$export$d112da4490f261ea(contentRef, containerRef, collapsed, additionalDeps = []) {
    const [isContentTruncated, setIsContentTruncated] = (0, $cozmU.useState)(false);
    // Only measure when collapsed is true
    const measureTruncation = (0, $cozmU.useCallback)(()=>{
        if (!collapsed) return;
        if (contentRef.current && containerRef.current) {
            const contentHeight = contentRef.current.getBoundingClientRect().height;
            const containerHeight = containerRef.current.getBoundingClientRect().height;
            setIsContentTruncated(contentHeight > containerHeight);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collapsed,
        contentRef,
        containerRef,
        ...additionalDeps
    ]);
    // Measure truncation and reset state when collapsed state changes
    (0, $cozmU.useEffect)(()=>{
        if (!collapsed) {
            setIsContentTruncated(false);
            return;
        }
        measureTruncation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collapsed,
        contentRef,
        containerRef,
        ...additionalDeps
    ]);
    (0, $1dee242400437624$export$fd29db098e42c3fc)(contentRef, measureTruncation);
    return isContentTruncated;
}



/* ai-collapse.tsx generated by @compiled/babel-plugin v3.0.1 */ 















var $j6vyT = parcelRequire("j6vyT");


























const $4217877a0025dc35$var$styles = {
    collapsableContainer: "_4bt5LAnQyn _2WAcuGnQyn _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r22ADO",
    header: "_2Zuz6Q5zaO _1Znuxb5zaO _0Of8r28HPE",
    pointer: "_0wOv4Q7zJH",
    rootCollapsed: "_0jFU0Vv6H3 _3X9j4qyIAw",
    rootCollapsedWithReadMore: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VaXQy _39HuIbz8Lp _3X9j4qyIAw",
    rootExpanded: "_4kiQYAJK6w",
    pressable: "_0KLXru66of _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0wOv4Q18ZR _39xV02N91d",
    luminaContainerOverrides: "_2Zuz6QPgdg _1ZnuxbPgdg _0Of8r2Pgdg",
    luminaHeaderOverrides: "_2Zuz6QPgdg _1ZnuxbPgdg _0Of8r2Pgdg",
    luminaFullHeightOverrides: "_4kiQYAheo5",
    luminaOverrides: "_4kiQYAaG3x",
    luminaTextAnswerOverrides: "_0jFU0Voaux",
    headerWithButton: "_4kiQYAUF4f"
};
const $4217877a0025dc35$export$127e64693c41156a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, isCollapsed: isCollapsed, onExpandCollapse: onExpandCollapse, title: title, showReadMoreButton: showReadMoreButton, luminaAnswerType: luminaAnswerType }, forwardedRef)=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onExpand = ()=>{
        fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
    };
    const onCollapse = ()=>fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes));
    const handleExpandCollapse = ()=>{
        if (isCollapsed) onExpand();
        else onCollapse();
        onExpandCollapse?.();
    };
    const handleExpandCollapseButtonClick = (event)=>{
        event.stopPropagation();
        handleExpandCollapse?.();
    };
    const onContainerClick = (event)=>{
        const selection = window.getSelection()?.toString() ?? ''; // Highlighting text should not expand the card
        const hasHighlightedText = selection.length > 0; // Clicking in a feedback modal or flag should not expand the card
        const isClickingOnContainer = containerRef.current?.contains(event.target) ?? false;
        if (isCollapsed && !hasHighlightedText && isClickingOnContainer) handleExpandCollapse?.();
    };
    return(// This Box click handler is just a convenience for mouse users; there's a keyboard-accessible button that supports the same functionality
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onClick: onContainerClick,
        ref: containerRef,
        xcss: (0, $w6R6I.cx)($4217877a0025dc35$var$styles.pressable, isCollapsed && $4217877a0025dc35$var$styles.pointer),
        role: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        xcss: (0, $w6R6I.cx)($4217877a0025dc35$var$styles.header, luminaAnswerType && $4217877a0025dc35$var$styles.luminaHeaderOverrides, (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && $4217877a0025dc35$var$styles.headerWithButton)
    }, title ? title : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null), luminaAnswerType || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: isCollapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
        label: formatMessage(isCollapsed ? (0, $5OgwG.messages).ai_answer_card_expand_button : (0, $5OgwG.messages).ai_answer_card_collapse_button),
        spacing: "compact",
        onClick: handleExpandCollapseButtonClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: forwardedRef,
        xcss: (0, $w6R6I.cx)($4217877a0025dc35$var$styles.collapsableContainer, isCollapsed ? showReadMoreButton ? $4217877a0025dc35$var$styles.rootCollapsedWithReadMore : $4217877a0025dc35$var$styles.rootCollapsed : $4217877a0025dc35$var$styles.rootExpanded, luminaAnswerType && $4217877a0025dc35$var$styles.luminaContainerOverrides, luminaAnswerType === 'LUMINA' && ((0, $7DMz5.SAINFeatureControl).isFullHeightLuminaEnabled() ? $4217877a0025dc35$var$styles.luminaFullHeightOverrides : $4217877a0025dc35$var$styles.luminaOverrides), isCollapsed && luminaAnswerType === 'STANDARD' && $4217877a0025dc35$var$styles.luminaTextAnswerOverrides),
        testId: "ai-collapse-container"
    }, children))));
});





/* animated-single-line-show-more.tsx generated by @compiled/babel-plugin v3.0.1 */ 






















var $IQ4Dz = parcelRequire("IQ4Dz");







const $bb4a8344422431c3$export$f0624d0c866f1dff = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerReadMoreButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $ad1269dfeb562305$export$8aac675f87e67286 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerReadMoreButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};














var $f420039341622608$var$UpdatedDarkThemeStops = /*#__PURE__*/ function(UpdatedDarkThemeStops) {
    UpdatedDarkThemeStops["ORANGE"] = "#FCA700";
    UpdatedDarkThemeStops["GREEN"] = "#82B536";
    UpdatedDarkThemeStops["BLUE"] = "#357DE8";
    UpdatedDarkThemeStops["PURPLE"] = "#BF63F3";
    return UpdatedDarkThemeStops;
}($f420039341622608$var$UpdatedDarkThemeStops || {});
var $f420039341622608$var$UpdatedLightThemeStops = /*#__PURE__*/ function(UpdatedLightThemeStops) {
    UpdatedLightThemeStops["ORANGE"] = "#FCA700";
    UpdatedLightThemeStops["GREEN"] = "#6A9A23";
    UpdatedLightThemeStops["BLUE"] = "#1868DB";
    UpdatedLightThemeStops["PURPLE"] = "#AF59E0";
    return UpdatedLightThemeStops;
}($f420039341622608$var$UpdatedLightThemeStops || {})// Helper function to convert hex color to rgba with alpha
;
const $f420039341622608$var$hexToRgba = (hex, alpha)=>{
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}; // This injects a CSS property into the document for the --gradient-angle variable.
// This is needed so the browser understands how to animate the gradient-angle as an angle
// value. This is done this way because compiled doesn't support CSS variables at this time.
let $f420039341622608$var$propertyInjected = false;
const $f420039341622608$var$useGradientAngleProperty = ()=>{
    (0, $cozmU.useEffect)(()=>{
        if ($f420039341622608$var$propertyInjected) return;
        $f420039341622608$var$propertyInjected = true;
        try {
            const style = document.createElement('style');
            style.innerHTML = `
				@property --gradient-angle {
					syntax: '<angle>';
					initial-value: 0deg;
					inherits: false;
				}
			`;
            document.head.appendChild(style); // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {}
    }, []);
};
const $f420039341622608$var$unboundedStyles = {
    root: "_1mT5xdRAKS",
    lineStyles: "_0jFU0VHZdu",
    lineNotStreamingStyles: "_0KLXru9r67",
    showMoreButtonWrapperStyles: "_49OCfRdnbC _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    showMoreButtonStyles: "_0bjKvDKTcp _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _0KLXrulfZc _24h04i2Njc _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _39xV02ymWf _0jFU0VUofl _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0ReiIH7zJH"
}; // Keyframes for rotating the gradient angle
// ts-ignore because jira build is failing, but this is legit
const $f420039341622608$var$rotateGradient = null;
const $f420039341622608$var$lineAnimation = null;
const $f420039341622608$var$lightModeAnimatedStyles = null;
const $f420039341622608$var$darkModeAnimatedStyles = null;
const $f420039341622608$export$8a1fad5d74d43878 = ({ isStreaming: isStreaming, showMoreButtonVisible: showMoreButtonVisible, fireShownEvent: fireShownEvent, onClickShowMoreButton: onClickShowMoreButton })=>{
    $f420039341622608$var$useGradientAngleProperty();
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)(); // Fire analytics event when button is shown
    // to keep in parity with old read more button - used for SSR
    (0, $cozmU.useEffect)(()=>{
        const shouldFire = fireShownEvent !== undefined ? fireShownEvent : showMoreButtonVisible;
        if (shouldFire) fireAnalyticsEvent((0, $ad1269dfeb562305$export$8aac675f87e67286)(commonAttributes));
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fireShownEvent,
        showMoreButtonVisible
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $bb4a8344422431c3$export$f0624d0c866f1dff)(commonAttributes));
        if (!(0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).READ_MORE_BUTTON_CLICKED,
            commonAttributes: commonAttributes
        });
        onClickShowMoreButton?.();
    }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        onClickShowMoreButton,
        commonAttributes
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $f420039341622608$var$unboundedStyles.root
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $f420039341622608$var$unboundedStyles.lineStyles,
            "_2fBhteAwyl",
            isStreaming ? colorMode === 'dark' ? "_2uo31fqVVN" : "_2uo31fazsC" : $f420039341622608$var$unboundedStyles.lineNotStreamingStyles
        ]),
        style: {
            "--_1i41aq5": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#1868DB", 1)),
            "--_ki6hwq": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#357DE8", 1)),
            "--_1vk81z2": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#82B536", 1)),
            "--_92idzx": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#FCA700", 1)),
            "--_9dqj5t": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#BF63F3", 1)),
            "--_t9jq7i": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#6A9A23", 1)),
            "--_1456abr": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#FCA700", 1)),
            "--_wnwy7": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#AF59E0", 1))
        }
    }), showMoreButtonVisible && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $f420039341622608$var$unboundedStyles.showMoreButtonWrapperStyles
        ])
    }, /*#__PURE__*/ $cozmU.createElement("button", {
        onClick: handleClick,
        className: (0, $hekY6.default)([
            $f420039341622608$var$unboundedStyles.showMoreButtonStyles
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: ''
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        weight: "medium"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $5OgwG.messages).ai_answer_card_show_more_button))))));
};



var $j8bJ5 = parcelRequire("j8bJ5");

/* react-renderer.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $eNbr2 = parcelRequire("eNbr2");














var $9GVkD = parcelRequire("9GVkD");


var $6rwn6 = parcelRequire("6rwn6");





var $7fxzU = parcelRequire("7fxzU");


var $b6fxF = parcelRequire("b6fxF");


var $lEgaq = parcelRequire("lEgaq");







/* inline-citation-group.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $3vgx3 = parcelRequire("3vgx3");

























const $1c582c9fdb181286$var$messages = (0, $kSwu1.defineMessages)({
    inline_citations_group_title: {
        id: "search_ai.inline_citations_group_title",
        defaultMessage: "{numCitations, plural, one {{numCitations, number} Source} other {{numCitations, number} Sources}}"
    },
    inline_citations_close_dropdown_label: {
        id: "search_ai.inline_citations_close_dropdown_label",
        defaultMessage: "Close the dropdown"
    }
});
const $1c582c9fdb181286$var$styles = {
    citationGroup: "_0bjKvDKTcp _0Of8r21Y8M _1ZnuxbgVvo _1wydGW1Y8M _2Zuz6QgVvo _0KLXruDMqu _1RrJLiYXK7 _3138425UaJ _1DCdHi5UaJ",
    citationDropdownContainer: "_39xV02Hakr _3WbItzf7mX _2TH8g8y7kJ",
    citationDropdownHeader: "_1x1D3gOeNX _0Of8r25zaO _1Znuxb5zaO _1wydGW8HPE _2Zuz6Q5zaO"
};
const $1c582c9fdb181286$export$94da02477787e5c = ({ parsedSources: parsedSources })=>{
    const [isCitationsOpen, setIsCitationsOpen] = (0, $cozmU.useState)(false); // ref to keep track of whether user opens dropdown by clicking
    const dropdownOpenByClick = (0, $cozmU.useRef)(false);
    const closeDropdownTimeoutRef = (0, $cozmU.useRef)(null);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (closeDropdownTimeoutRef.current) clearTimeout(closeDropdownTimeoutRef.current);
        };
    }, []);
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { handleSmartCardClick: handleSmartCardClick, searchSessionId: searchSessionId } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context,
        isCitation: true
    });
    const handlePressableClick = (e)=>{
        e.stopPropagation(); // only close if user had originally opened dropdown by clicking
        // without this, it causes unwanted behavior with the hover behavior
        if (isCitationsOpen && dropdownOpenByClick.current) setIsCitationsOpen(false);
        dropdownOpenByClick.current = !dropdownOpenByClick.current;
    }; // set timer to close to avoid closing when user is moving mouse
    // between pressable and dropdown (small space in between)
    const handlePressableMouseLeave = ()=>{
        closeDropdownTimeoutRef.current = setTimeout(()=>{
            if (!dropdownOpenByClick.current) setIsCitationsOpen(false);
        }, 150);
    }; // clear timer above once moving mouse to dropdown
    const handleDropdownMouseEnter = ()=>{
        if (closeDropdownTimeoutRef.current) clearTimeout(closeDropdownTimeoutRef.current);
    }; // prevent closing dropdown if user had originally opened dropdown by clicking
    const handleDropdownMouseLeave = ()=>{
        if (!dropdownOpenByClick.current) setIsCitationsOpen(false);
        return;
    }; // callback for when user clicks outside of trigger pressable component
    const handleDropdownOpenChange = (attrs)=>{
        if (!attrs.isOpen) dropdownOpenByClick.current = false;
        setIsCitationsOpen(attrs.isOpen);
    };
    const handleButtonClose = ()=>{
        dropdownOpenByClick.current = false;
        setIsCitationsOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ref: triggerRef,
                ...props,
                xcss: $1c582c9fdb181286$var$styles.citationGroup,
                onClick: handlePressableClick,
                onMouseEnter: ()=>setIsCitationsOpen(true),
                onMouseLeave: handlePressableMouseLeave,
                testId: "smart-answer-inline-citation-group",
                "aria-label": formatMessage($1c582c9fdb181286$var$messages.inline_citations_group_title, {
                    numCitations: parsedSources.length
                }),
                [(0, $lEgaq.SAIN_CITATION_ATTRIBUTE)]: 'true'
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0122fe4f75fa739$export$ebff7094edd1bb81), {
                sources: parsedSources,
                maxSourcesInStack: 2,
                showNumAddtlSources: true,
                addEditorStyleOverrides: true
            }))),
        shouldFlip: true,
        isOpen: isCitationsOpen,
        onOpenChange: handleDropdownOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onMouseEnter: handleDropdownMouseEnter,
        onMouseLeave: handleDropdownMouseLeave,
        xcss: $1c582c9fdb181286$var$styles.citationDropdownContainer,
        testId: "smart-answer-inline-citation-dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1c582c9fdb181286$var$styles.citationDropdownHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage($1c582c9fdb181286$var$messages.inline_citations_group_title, {
        numCitations: parsedSources.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($1c582c9fdb181286$var$messages.inline_citations_close_dropdown_label),
        onClick: handleButtonClose,
        spacing: "compact",
        testId: "smart-answer-inline-citation-dropdown-close-button"
    }))), parsedSources.map((source, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aUgOE.KnowledgeSmartCard), {
            source: source,
            variant: (0, $aUgOE.CardVariant).DROPDOWN_SOURCE,
            index: index,
            searchSessionId: searchSessionId,
            onClickHandler: handleSmartCardClick
        }))));
};


const $ba9b602d2037f879$export$e190835f8c06a181 = ({ localId: localId })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { sources: sources } = commonAttributes;
    const inlineCitationData = (0, $cozmU.useMemo)(()=>{
        if (!sources || sources.length === 0) return undefined;
        try {
            const parsedCitationIndices = JSON.parse(localId);
            const parsedSources = parsedCitationIndices.map((idx)=>sources[idx - 1]);
            const citationUrls = parsedSources.map((source)=>source.url);
            return {
                citationUrls: citationUrls,
                parsedSources: parsedSources
            };
        } catch  {
            return undefined;
        }
    }, [
        sources,
        localId
    ]);
    return !!inlineCitationData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1c582c9fdb181286$export$94da02477787e5c), {
        parsedSources: inlineCitationData.parsedSources
    }) : null;
};


/* status-citation.tsx generated by @compiled/babel-plugin v3.0.1 */ 































const $e2862f0d359af03a$var$styles = {
    root: "_30huDKYbGa _0KLXrujOvk _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0ReiIH7zJH"
};
const $e2862f0d359af03a$var$convertColorAppearance = (color)=>{
    switch(color){
        case 'blue':
            return 'information';
        case 'green':
            return 'success';
        case 'red':
            return 'danger';
        case 'yellow':
            return 'warning';
        case 'purple':
            return 'discovery';
        default:
            return 'neutral';
    }
};
const $e2862f0d359af03a$export$21553c57082a6434 = ({ localId: localId, text: text, color: color = 'blue' })=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3hVWe.useAIAnswerContext)();
    const sources = commonAttributes.sources;
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { source: source, idx: idx } = (0, $cozmU.useMemo)(()=>{
        if (!localId.includes('citation')) return {};
        const idx = parseInt(localId.split('-')?.[1]);
        return {
            source: sources[idx - 1],
            idx: idx
        };
    }, [
        localId,
        sources
    ]);
    const handleClick = (0, $cozmU.useCallback)((source, idx, e)=>{
        const isAuxClick = e?.button === 1;
        const isContextMenu = e?.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: idx,
            isCitation: true,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu,
            hostname: (0, $736ac3075308471f$export$a3b7216c107a7a1)(source.url),
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            source: source
        });
        if (!isContextMenu) window.open(source.url, '_blank', 'noopener, noreferrer');
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        fireSAINUsageEvent
    ]);
    if (!!source) return /*#__PURE__*/ $cozmU.createElement((0, $1YHM8.StandaloneHoverCard), {
        url: source.url
    }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        [(0, $lEgaq.SAIN_CITATION_ATTRIBUTE)]: 'true',
        xcss: $e2862f0d359af03a$var$styles.root,
        onClick: (e)=>{
            handleClick(source, idx, e);
        },
        onAuxClick: (e)=>{
            if (e.button !== 1) return;
            handleClick(source, idx, e);
        },
        onContextMenu: (e)=>{
            handleClick(source, idx, e);
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
        appearance: "information"
    }, idx)));
    // Standard lozenge for status nodes
    return /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
        appearance: $e2862f0d359af03a$var$convertColorAppearance(color)
    }, text);
};
























var $3d581288ec05f499$export$255ec938a30a2b3 = /*#__PURE__*/ function(StreamAnswerGenerationTypes) {
    StreamAnswerGenerationTypes["LUMINA"] = "LUMINA";
    StreamAnswerGenerationTypes["STANDARD"] = "STANDARD";
    return StreamAnswerGenerationTypes;
}({});



var $7s8U5 = parcelRequire("7s8U5");


var $hZTED = parcelRequire("hZTED");




const $f2af7a532cac1c29$var$getCorrelationAttributes = (context)=>{
    if (!context || !(0, $iDrrr.fg)('kd_granular_network_errors')) return {};
    return {
        ...context.searchSessionId && {
            searchSessionId: context.searchSessionId
        },
        ...context.queryHash && {
            queryHash: context.queryHash
        },
        ...context.sourceProduct && {
            sourceProduct: context.sourceProduct
        },
        ...context.isReadingAids !== undefined && {
            isReadingAids: context.isReadingAids
        },
        ...context.queryIntent && {
            queryIntent: context.queryIntent
        }
    };
};
const $f2af7a532cac1c29$export$ee4edf16a7c39598 = (error, source, correlationContext)=>{
    const correlationAttrs = $f2af7a532cac1c29$var$getCorrelationAttributes(correlationContext);
    if (error instanceof Error) return {
        action: 'failed',
        actionSubject: 'aiAnswerDialogStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack?.split('\n').at(1) || '',
            ...'details' in error && {
                details: error.details
            },
            ...'errorCode' in error && {
                errorCode: error.errorCode
            },
            // Surface the backend-derived fields (from StreamFailedError) so the
            // analytics event records what the backend actually returned rather
            // than only FE-synthesized values.
            ...'reason' in error && {
                reason: error.reason
            },
            ...'backendFailureType' in error && {
                backendFailureType: error.backendFailureType
            },
            ...(0, $iDrrr.fg)('kd_sain_stream_error_diagnostics') && {
                ...'diagnosticType' in error && {
                    diagnosticType: error.diagnosticType
                },
                ...'failureStage' in error && {
                    failureStage: error.failureStage
                },
                ...'responseContentType' in error && {
                    responseContentType: error.responseContentType
                }
            },
            ...'traceId' in error && error.traceId ? {
                traceId: error.traceId
            } : {},
            ...correlationAttrs
        }
    };
    if (error instanceof Object && 'error' in error) return {
        action: 'failed',
        actionSubject: 'aiAnswerDialogStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            errorName: error.error instanceof Error ? error.error.name : '',
            errorMessage: error.error instanceof Error ? error.error.message : typeof error === 'string' ? error : '',
            errorStack: error.error instanceof Error ? error.error.stack?.split('\n').at(1) : '',
            reason: 'reason' in error ? error.reason : '',
            details: 'details' in error ? error.details : '',
            ...(0, $iDrrr.fg)('kd_sain_stream_error_diagnostics') && {
                ...'diagnosticType' in error && {
                    diagnosticType: error.diagnosticType
                },
                ...'failureStage' in error && {
                    failureStage: error.failureStage
                },
                ...'responseContentType' in error && {
                    responseContentType: error.responseContentType
                },
                ...'traceId' in error && error.traceId ? {
                    traceId: error.traceId
                } : {}
            },
            ...correlationAttrs
        }
    };
    return {
        action: 'failed',
        actionSubject: 'aiAnswerDialogStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            reason: error instanceof Object && 'reason' in error ? error.reason : '',
            details: error instanceof Object && 'details' in error ? error.details : '',
            ...correlationAttrs
        }
    };
};
const $f2af7a532cac1c29$export$13b0ccf9f6015e4c = (error, source, correlationContext)=>{
    const correlationAttrs = $f2af7a532cac1c29$var$getCorrelationAttributes(correlationContext);
    return {
        action: 'failed',
        actionSubject: 'aiAnswerDialogNonStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : '',
            ...correlationAttrs
        }
    };
};



var $kqQyU = parcelRequire("kqQyU");







const $b6b6ac34f723c99f$export$80be2adf18435a80 = (prev, traceData)=>{
    const { messageTemplate: messageTemplate, stepId: stepId } = traceData;
    if (!messageTemplate || !stepId) return prev;
    // `existing` is the current state of this step (if it has arrived before,
    // e.g. TITLE arrived and now CONTENT is streaming in). `isNewStep` flags
    // that this is the very first message for this stepId.
    // `order` preserves the insertion sequence across all steps so the UI can
    // sort them chronologically — re-uses the existing order if already set,
    // otherwise takes the next available integer after the highest current order.
    // `baseStep` merges existing state with required defaults so every switch
    // branch below can safely spread it and only override what changed.
    const existing = prev[stepId];
    const isNewStep = !existing;
    const order = existing?.order ?? (Object.values(prev).length ? Math.max(...Object.values(prev).map((s)=>s.order)) + 1 : 1);
    const baseStep = {
        ...existing,
        stepId: stepId,
        roundId: existing?.roundId ?? traceData.roundId ?? 0,
        order: order,
        separatedContent: existing?.separatedContent ?? []
    };
    switch(messageTemplate){
        case 'RESEARCH_STEP_TITLE':
        case 'RESEARCH_STEP_TITLE_SHORT':
            return {
                ...prev,
                [stepId]: {
                    ...baseStep,
                    title: traceData.title,
                    roundId: traceData.roundId ?? baseStep.roundId,
                    toolIcon: traceData.toolIcon ?? undefined,
                    toolName: traceData.toolName ?? undefined,
                    completed: baseStep.completed ?? false
                }
            };
        case 'RESEARCH_STEP':
        case 'RESEARCH_STEP_CONTENT':
            {
                const chunk = traceData.content ?? '';
                const concatenated = (baseStep.content ?? '') + chunk;
                return {
                    ...prev,
                    [stepId]: {
                        ...baseStep,
                        roundId: traceData.roundId ?? baseStep.roundId,
                        content: concatenated,
                        separatedContent: [
                            ...baseStep.separatedContent ?? [],
                            chunk
                        ],
                        // Orphan content (content arriving for a step that has no title yet) is
                        // considered already-complete to avoid hanging in an unfinished state.
                        // Also preserve completed=true if RESEARCH_STEP_COMPLETE arrived out-of-order.
                        completed: baseStep.completed ?? (isNewStep && !baseStep.title)
                    }
                };
            }
        case 'RESEARCH_STEP_SOURCE':
            return {
                ...prev,
                [stepId]: {
                    ...baseStep,
                    sources: traceData.sources ?? baseStep.sources
                }
            };
        case 'RESEARCH_STEP_ICONS':
            {
                const ICON_BASE_URL = '/gateway/api/assist/rovo/v1/resources/icon/';
                const products = traceData.products ?? [];
                return {
                    ...prev,
                    [stepId]: {
                        ...baseStep,
                        sourceIcons: products.map((p)=>p.startsWith('/') || p.startsWith('data:') ? p : `${ICON_BASE_URL}${p}`)
                    }
                };
            }
        case 'RESEARCH_STEP_COMPLETE':
            return {
                ...prev,
                [stepId]: {
                    ...baseStep,
                    completed: true
                }
            };
        default:
            return prev;
    }
};








// Type guards for intent classification
const $117a17190f14c8c7$var$isPersonIntent = (data)=>data.classification === (0, $zzZbq.QueryIntent).PERSON;
/**
 * Registry mapping QueryIntent classification to skip handlers.
 * Add new handlers here to support additional intent types.
 */ const $117a17190f14c8c7$var$intentSkipHandlers = {
    /**
   * PERSON intent: Skip API call if persons array has data.
   * Transform Person[] from intent to NLPSearchPersonResultType format.
   */ [(0, $zzZbq.QueryIntent).PERSON]: (intentData)=>{
        if (!$117a17190f14c8c7$var$isPersonIntent(intentData) || intentData.persons === undefined || intentData.persons === null) return {
            skip: false
        };
        // Transform intent persons to the format expected by knowledge cards
        const mappedPersons = {
            user_metadata_only_cards: intentData.persons.map((person)=>({
                    id: person.accountId,
                    name: person.name,
                    title: person.jobTitle || undefined,
                    avatarUrl: person.picture || undefined,
                    location: person.location || undefined,
                    zoneInfo: person.zoneInfo || undefined
                }))
        };
        return {
            skip: true,
            data: {
                nlpResult: JSON.stringify(mappedPersons),
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                errorState: null,
                disclaimer: null,
                uniqueSources: [],
                extraAPIAnalyticsAttributes: {
                    skippedViaIntentClassification: true,
                    intentClassification: intentData.classification
                }
            }
        };
    }
};
const $117a17190f14c8c7$export$75cd51191584b8ce = (intentData)=>{
    if (!intentData) return {
        skip: false
    };
    const handler = $117a17190f14c8c7$var$intentSkipHandlers[intentData.classification];
    if (!handler) return {
        skip: false
    };
    return handler(intentData);
};


class $b9b2682ba0353829$export$fc5c9343c5342824 extends Error {
    constructor(message, opts){
        super(message);
        this.details = void 0;
        this.errorCode = void 0;
        this.reason = void 0;
        this.backendFailureType = void 0;
        this.diagnosticType = void 0;
        this.failureStage = void 0;
        this.responseContentType = void 0;
        this.traceId = void 0;
        this.name = 'StreamFailedError';
        this.details = opts?.details;
        this.errorCode = opts?.errorCode;
        this.reason = opts?.reason;
        this.backendFailureType = opts?.backendFailureType;
        this.diagnosticType = opts?.diagnosticType;
        this.failureStage = opts?.failureStage;
        this.responseContentType = opts?.responseContentType;
        this.traceId = opts?.traceId;
    }
}


const $b2270b423e154e70$export$84f2194b2008422 = "\u25D0";
const $b2270b423e154e70$export$192ba1edc601a546 = "\u25D1";
const $b2270b423e154e70$export$ea5ceaf3fa709ad4 = '\n\n[^lumina^]\n\n';
const $b2270b423e154e70$export$b2ac4f39739d467d = 'lumina-';
const $b2270b423e154e70$var$getLuminaComponents = ()=>[
        {
            key: 'lumina',
            startTag: $b2270b423e154e70$export$84f2194b2008422,
            endTag: $b2270b423e154e70$export$192ba1edc601a546,
            placeholderTag: $b2270b423e154e70$export$ea5ceaf3fa709ad4,
            isEnabled: (0, $iDrrr.fg)('kd_sain_enable_inline_lumina')
        }
    ];
const $b2270b423e154e70$export$6dbb893b575831e8 = async ({ cloudId: // eslint-disable-next-line @typescript-eslint/no-unused-vars
cloudId, locale: locale, query: query, additional_context: additional_context, source: source, followUpsEnabled: followUpsEnabled = false, getAIAnswer: getAIAnswer, setLoading: setLoading, partialResponse: partialResponse, partialResponseAbortControllerRef: partialResponseAbortControllerRef, setPartialResponse: setPartialResponse, setData: setData, setAnswerStreamed: setAnswerStreamed, parsedFilters: parsedFilters, selectedProduct: selectedProduct, isReadingAids: isReadingAids, fireAnalyticsEvent: fireAnalyticsEvent, setQueryReasoning: setQueryReasoning, setResearchSteps: setResearchSteps, setDynamicLayoutSubAgentMessages: setDynamicLayoutSubAgentMessages, setIsLuminaAnswer: setIsLuminaAnswer, setLuminaContentMap: setLuminaContentMap, experimentContext: experimentContext, queryIntentClassificationData: queryIntentClassificationData, referrer: referrer, searchSessionId: searchSessionId, sourceProduct: sourceProduct, queryIntent: queryIntent })=>{
    if (!getAIAnswer) return;
    if (partialResponse?.partialNlpResult) // clean up any old partial responses
    setPartialResponse(undefined);
    // end any old partial response streams
    partialResponseAbortControllerRef.current?.abort();
    const abortController = new AbortController();
    partialResponseAbortControllerRef.current = abortController;
    // Check if we can skip the AI answer call based on intent classification data.
    // If the intent already has the data we need (e.g., PersonIntent with persons[]),
    // use it directly instead of making another API call.
    if ((0, $iDrrr.fg)('kd_fe_persons_intent_detection_els')) {
        const skipResult = (0, $117a17190f14c8c7$export$75cd51191584b8ce)(queryIntentClassificationData);
        if (skipResult.skip) {
            setData(skipResult.data);
            (0, $6JEx2.setSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
                query: query,
                data: skipResult.data
            }));
            setAnswerStreamed(true);
            setLoading(false);
            return;
        }
    }
    // For graphQL getAIAnswer fns we expect each product to pass their own cloudIdARI in order for this component to be more product agnostic
    const aiAnswer = getAIAnswer({
        variables: {
            query: query,
            additional_context: additional_context,
            locale: locale,
            filters: parsedFilters,
            selectedProduct: selectedProduct,
            experience: isReadingAids ? 'readingAids' : source,
            followUpsEnabled: followUpsEnabled,
            experimentContext: experimentContext,
            ...(0, $7DMz5.SAINFeatureControl).isZeroQuerySuggestionsV1Enabled(sourceProduct) && referrer === 'zeroQuery' ? {
                isQuerySuggestion: true
            } : {}
        }
    });
    // Legacy version of processStreamResponse - used when feature gate is off
    const processStreamResponse = async (answer)=>{
        try {
            let next = await answer.stream.next();
            let answerFormat;
            // Local variable to track if answer is Lumina format (used for cache enablement)
            let isLuminaAnswerLocal = false;
            // Guard so the research-step failsafe only fires on the first AnswerPart
            let hasCompletedAllSteps = false;
            const processStreamMarkdownMultiTag = (0, $f3OgL.createMarkdownProcessorMultiTags)($b2270b423e154e70$var$getLuminaComponents);
            const luminaContentMap = {};
            while(!next.done){
                // setLoading needed here for instances where stream gets interrupted and restarts, ensuring loading state is set while stream is active
                setLoading(true);
                const streamEvent = next.value;
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerType) answerFormat = streamEvent.message.format;
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).GenerationType && (0, $7DMz5.SAINFeatureControl).canRenderLumina()) {
                    if (streamEvent.message.answer_generation_type === (0, $3d581288ec05f499$export$255ec938a30a2b3).LUMINA) {
                        isLuminaAnswerLocal = true;
                        setIsLuminaAnswer(true);
                    }
                }
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).Trace) {
                    if (answerFormat !== (0, $hpFQM.NLPSearchResultFormat).MARKDOWN) throw new Error(`Unexpected format: ${answerFormat}`);
                    setQueryReasoning(streamEvent.message);
                    // When the new FG is on and the BE sent a structured RESEARCH_STEP_*
                    // trace, merge it into the local research-step state.
                    if (streamEvent.traceData && setResearchSteps && ((0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() || (0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled())) {
                        const traceData = streamEvent.traceData;
                        setResearchSteps((prev)=>(0, $b6b6ac34f723c99f$export$80be2adf18435a80)(prev, traceData));
                    }
                }
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerPart) {
                    if (answerFormat !== (0, $hpFQM.NLPSearchResultFormat).MARKDOWN) throw new Error(`Unexpected format: ${answerFormat}`);
                    // Failsafe (mirrors Chat's `completeAllSteps`): when the answer
                    // starts streaming, mark every research step complete in case the
                    // BE skipped any `RESEARCH_STEP_COMPLETE` messages. Prevents the
                    // shimmer animation from getting stuck on incomplete steps.
                    if (!hasCompletedAllSteps && setResearchSteps && ((0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() || (0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled())) {
                        hasCompletedAllSteps = true;
                        setResearchSteps((prev)=>{
                            let mutated = false;
                            const next = {};
                            for (const [id, step] of Object.entries(prev))if (!step.completed) {
                                next[id] = {
                                    ...step,
                                    completed: true
                                };
                                mutated = true;
                            } else next[id] = step;
                            return mutated ? next : prev;
                        });
                    }
                    if ((0, $iDrrr.fg)('kd_sain_enable_inline_lumina')) {
                        const { processedText: processedText, markdownData: markdownData } = processStreamMarkdownMultiTag(streamEvent.message.nlpResult);
                        if (Object.keys(markdownData).length > 0) {
                            Object.entries(markdownData).forEach(([key, { content: content }])=>{
                                luminaContentMap[key] = (luminaContentMap[key] ?? '') + content;
                            });
                            setLuminaContentMap({
                                ...luminaContentMap
                            });
                        }
                        setPartialResponse((previousPartialResponse)=>({
                                format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
                                partialNlpResult: (previousPartialResponse?.partialNlpResult ?? '') + processedText
                            }));
                    } else setPartialResponse((previousPartialResponse)=>{
                        let previousPartialNlpResult = previousPartialResponse?.partialNlpResult || '';
                        return {
                            format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
                            partialNlpResult: previousPartialNlpResult + streamEvent.message.nlpResult
                        };
                    });
                }
                if ((0, $7DMz5.SAINFeatureControl).canRenderLumina()) {
                    if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) setDynamicLayoutSubAgentMessages((prevMessages)=>[
                            ...prevMessages,
                            streamEvent.message
                        ]);
                }
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse) {
                    const authorityUiMetadata = streamEvent.message.authority_ui_metadata ?? null;
                    if ((0, $iDrrr.fg)('kd_sain_enable_inline_lumina')) {
                        const { boundaryContents: boundaryContents } = (0, $f3OgL.extractMarkdownText)(streamEvent.message.nlpResult ?? '', $b2270b423e154e70$export$84f2194b2008422, $b2270b423e154e70$export$192ba1edc601a546, $b2270b423e154e70$export$ea5ceaf3fa709ad4);
                        const luminaContentMap = {};
                        boundaryContents.forEach((content, index)=>{
                            luminaContentMap[`${$b2270b423e154e70$export$b2ac4f39739d467d}${index}`] = content;
                        });
                        setLuminaContentMap(luminaContentMap);
                        setData({
                            ...streamEvent.message,
                            authority_ui_metadata: authorityUiMetadata
                        });
                    } else setData({
                        ...streamEvent.message,
                        authority_ui_metadata: authorityUiMetadata
                    });
                    setPartialResponse(undefined);
                    setLoading(false);
                }
                next = await answer.stream.next();
                if (abortController.signal.aborted) // eslint-disable-next-line no-throw-literal
                throw 'Aborted';
            }
            const streamEnd = next.value;
            if (abortController.signal.aborted) // eslint-disable-next-line no-throw-literal
            throw streamEnd;
            if (streamEnd.state === 'complete') {
                if ((0, $iDrrr.fg)('kd_sain_enable_inline_lumina')) {
                    const { boundaryContents: boundaryContents } = (0, $f3OgL.extractMarkdownText)(streamEnd.value.message.nlpResult ?? '', $b2270b423e154e70$export$84f2194b2008422, $b2270b423e154e70$export$192ba1edc601a546, $b2270b423e154e70$export$ea5ceaf3fa709ad4);
                    const luminaContentMap = {};
                    boundaryContents.forEach((content, index)=>{
                        luminaContentMap[`${$b2270b423e154e70$export$b2ac4f39739d467d}${index}`] = content;
                    });
                    setLuminaContentMap(luminaContentMap);
                    setData(streamEnd.value.message);
                } else setData(streamEnd.value.message);
                setPartialResponse(undefined);
                // Only store to cache if not a Lumina answer
                if (isReadingAids || !isLuminaAnswerLocal) (0, $6JEx2.setSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
                    query: query,
                    data: streamEnd.value.message
                }));
            } else {
                if (streamEnd.reason === 'timeout') {
                    setPartialResponse(undefined);
                    setData({
                        errorState: (0, $htnqN.NLPSearchErrorState).TimeoutError,
                        errorCode: 0,
                        format: null,
                        disclaimer: null,
                        nlpResults: [],
                        uniqueSources: [],
                        nlpFollowUpResults: null
                    });
                } else throw streamEnd;
            }
        } catch (error) {
            fireAnalyticsEvent((0, $f2af7a532cac1c29$export$ee4edf16a7c39598)(error, source));
            if (error === 'Aborted') return;
            setPartialResponse(undefined);
            setData({
                errorState: typeof error === 'object' && error !== null && 'details' in error && error?.details === (0, $kqQyU.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR ? (0, $htnqN.NLPSearchErrorState).HIPAAError : (0, $htnqN.NLPSearchErrorState).NetworkError,
                errorCode: error?.errorCode ? error.errorCode : 0,
                format: null,
                disclaimer: null,
                nlpResults: [],
                uniqueSources: [],
                nlpFollowUpResults: null,
                nlpSuggestedQueries: []
            });
        } finally{
            setAnswerStreamed(true);
            setLoading(false);
        }
    };
    // New version with improved error handling using standard JS Error objects
    const processStreamResponseImprovedErrorHandling = async (answer)=>{
        const fetchStartTime = Date.now();
        let streamEventsReceived = 0;
        try {
            let next = await answer.stream.next();
            let answerFormat;
            // Local variable to track if answer is Lumina format (used for cache enablement)
            let isLuminaAnswerLocal = false;
            // Guard so the research-step failsafe only fires on the first AnswerPart
            let hasCompletedAllSteps = false;
            const processStreamMarkdownMultiTag = (0, $f3OgL.createMarkdownProcessorMultiTags)($b2270b423e154e70$var$getLuminaComponents);
            const luminaContentMap = {};
            while(!next.done){
                // setLoading needed here for instances where stream gets interrupted and restarts, ensuring loading state is set while stream is active
                setLoading(true);
                streamEventsReceived++;
                const streamEvent = next.value;
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerType) answerFormat = streamEvent.message.format;
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).GenerationType && (0, $7DMz5.SAINFeatureControl).canRenderLumina()) {
                    if (streamEvent.message.answer_generation_type === (0, $3d581288ec05f499$export$255ec938a30a2b3).LUMINA) {
                        isLuminaAnswerLocal = true;
                        setIsLuminaAnswer(true);
                    }
                }
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).Trace) {
                    if (answerFormat !== (0, $hpFQM.NLPSearchResultFormat).MARKDOWN) throw new Error(`Unexpected format: ${answerFormat}`);
                    setQueryReasoning(streamEvent.message);
                    // When the new FG is on and the BE sent a structured RESEARCH_STEP_*
                    // trace, merge it into the local research-step state.
                    if (streamEvent.traceData && setResearchSteps && ((0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() || (0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled())) {
                        const traceData = streamEvent.traceData;
                        setResearchSteps((prev)=>(0, $b6b6ac34f723c99f$export$80be2adf18435a80)(prev, traceData));
                    }
                }
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerPart) {
                    if (answerFormat !== (0, $hpFQM.NLPSearchResultFormat).MARKDOWN) throw new Error(`Unexpected format: ${answerFormat}`);
                    // Failsafe (mirrors Chat's `completeAllSteps`): when the answer
                    // starts streaming, mark every research step complete in case the
                    // BE skipped any `RESEARCH_STEP_COMPLETE` messages. Prevents the
                    // shimmer animation from getting stuck on incomplete steps.
                    if (!hasCompletedAllSteps && setResearchSteps && ((0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() || (0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled())) {
                        hasCompletedAllSteps = true;
                        setResearchSteps((prev)=>{
                            let mutated = false;
                            const next = {};
                            for (const [id, step] of Object.entries(prev))if (!step.completed) {
                                next[id] = {
                                    ...step,
                                    completed: true
                                };
                                mutated = true;
                            } else next[id] = step;
                            return mutated ? next : prev;
                        });
                    }
                    if ((0, $iDrrr.fg)('kd_sain_enable_inline_lumina')) {
                        const { processedText: processedText, markdownData: markdownData } = processStreamMarkdownMultiTag(streamEvent.message.nlpResult);
                        if (Object.keys(markdownData).length > 0) {
                            Object.entries(markdownData).forEach(([key, { content: content }])=>{
                                luminaContentMap[key] = (luminaContentMap[key] ?? '') + content;
                            });
                            setLuminaContentMap({
                                ...luminaContentMap
                            });
                        }
                        setPartialResponse((previousPartialResponse)=>({
                                format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
                                partialNlpResult: (previousPartialResponse?.partialNlpResult ?? '') + processedText
                            }));
                    } else setPartialResponse((previousPartialResponse)=>{
                        let previousPartialNlpResult = previousPartialResponse?.partialNlpResult || '';
                        return {
                            format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
                            partialNlpResult: previousPartialNlpResult + streamEvent.message.nlpResult
                        };
                    });
                }
                if ((0, $7DMz5.SAINFeatureControl).canRenderLumina()) {
                    if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) setDynamicLayoutSubAgentMessages((prevMessages)=>[
                            ...prevMessages,
                            streamEvent.message
                        ]);
                }
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse) {
                    const msg = streamEvent.message;
                    const authorityUiMetadata = msg.authority_ui_metadata ?? null;
                    if ((0, $iDrrr.fg)('kd_sain_enable_inline_lumina')) {
                        const { boundaryContents: boundaryContents } = (0, $f3OgL.extractMarkdownText)(streamEvent.message.nlpResult ?? '', $b2270b423e154e70$export$84f2194b2008422, $b2270b423e154e70$export$192ba1edc601a546, $b2270b423e154e70$export$ea5ceaf3fa709ad4);
                        const luminaContentMap = {};
                        boundaryContents.forEach((content, index)=>{
                            luminaContentMap[`${$b2270b423e154e70$export$b2ac4f39739d467d}${index}`] = content;
                        });
                        setLuminaContentMap(luminaContentMap);
                        setData(msg.errorState && msg.errorState !== (0, $htnqN.NLPSearchErrorState).Default ? {
                            ...msg,
                            streamEventsReceived: streamEventsReceived,
                            networkErrorDuration: Date.now() - fetchStartTime,
                            authority_ui_metadata: authorityUiMetadata
                        } : {
                            ...msg,
                            authority_ui_metadata: authorityUiMetadata
                        });
                    } else setData(msg.errorState && msg.errorState !== (0, $htnqN.NLPSearchErrorState).Default ? {
                        ...msg,
                        streamEventsReceived: streamEventsReceived,
                        networkErrorDuration: Date.now() - fetchStartTime,
                        authority_ui_metadata: authorityUiMetadata
                    } : {
                        ...msg,
                        authority_ui_metadata: authorityUiMetadata
                    });
                    setPartialResponse(undefined);
                    setLoading(false);
                }
                next = await answer.stream.next();
                if (abortController.signal.aborted) throw new Error('Aborted');
            }
            const streamEnd = next.value;
            if (abortController.signal.aborted) throw new Error(streamEnd.state === 'failed' ? streamEnd.reason : 'Aborted');
            if (streamEnd.state === 'complete') {
                const streamEndFinalMessage = streamEnd.value.message;
                if ((0, $iDrrr.fg)('kd_sain_enable_inline_lumina')) {
                    const { boundaryContents: boundaryContents } = (0, $f3OgL.extractMarkdownText)(streamEnd.value.message.nlpResult ?? '', $b2270b423e154e70$export$84f2194b2008422, $b2270b423e154e70$export$192ba1edc601a546, $b2270b423e154e70$export$ea5ceaf3fa709ad4);
                    const luminaContentMap = {};
                    boundaryContents.forEach((content, index)=>{
                        luminaContentMap[`${$b2270b423e154e70$export$b2ac4f39739d467d}${index}`] = content;
                    });
                    setLuminaContentMap(luminaContentMap);
                    setData(streamEndFinalMessage);
                } else setData(streamEndFinalMessage);
                setPartialResponse(undefined);
                // Only store to cache if not a Lumina answer
                if (isReadingAids || !isLuminaAnswerLocal) (0, $6JEx2.setSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
                    query: query,
                    data: streamEndFinalMessage
                }));
            } else {
                if (streamEnd.reason === 'timeout') {
                    setPartialResponse(undefined);
                    setData({
                        errorState: (0, $htnqN.NLPSearchErrorState).TimeoutError,
                        errorCode: 0,
                        format: null,
                        disclaimer: null,
                        nlpResults: [],
                        uniqueSources: [],
                        nlpFollowUpResults: null
                    });
                } else throw new (0, $b9b2682ba0353829$export$fc5c9343c5342824)(`Stream failed: ${streamEnd.reason}`, {
                    details: 'details' in streamEnd ? streamEnd.details : undefined,
                    errorCode: 'errorCode' in streamEnd ? streamEnd.errorCode : undefined,
                    reason: streamEnd.reason,
                    backendFailureType: 'backendFailureType' in streamEnd ? streamEnd.backendFailureType : undefined,
                    diagnosticType: 'diagnosticType' in streamEnd ? streamEnd.diagnosticType : undefined,
                    failureStage: 'failureStage' in streamEnd ? streamEnd.failureStage : undefined,
                    responseContentType: 'responseContentType' in streamEnd ? streamEnd.responseContentType : undefined,
                    traceId: 'traceId' in streamEnd ? streamEnd.traceId : undefined
                });
            }
        } catch (error) {
            const networkErrorDuration = Date.now() - fetchStartTime;
            fireAnalyticsEvent((0, $f2af7a532cac1c29$export$ee4edf16a7c39598)(error, source, {
                searchSessionId: searchSessionId,
                queryHash: (0, $9oghv.sha256Hash)(query),
                sourceProduct: sourceProduct,
                isReadingAids: isReadingAids,
                queryIntent: queryIntent
            }));
            setPartialResponse(undefined);
            if (error instanceof Error && error.message === 'Aborted') {
                if ((0, $iDrrr.fg)('kd_fix_abort_errors')) // Don't  set error data on client-initiated abort
                return;
                setData({
                    errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                    networkErrorReason: 'client_aborted',
                    streamEventsReceived: streamEventsReceived,
                    networkErrorDuration: networkErrorDuration,
                    format: null,
                    disclaimer: null,
                    nlpResults: [],
                    uniqueSources: [],
                    nlpFollowUpResults: null,
                    nlpSuggestedQueries: []
                });
                return;
            }
            const details = error instanceof (0, $b9b2682ba0353829$export$fc5c9343c5342824) ? error.details : undefined;
            const errorCode = error instanceof (0, $b9b2682ba0353829$export$fc5c9343c5342824) ? error.errorCode ?? 0 : 0;
            const networkErrorReason = error instanceof (0, $b9b2682ba0353829$export$fc5c9343c5342824) ? error.reason : undefined;
            const networkErrorDetails = error instanceof (0, $b9b2682ba0353829$export$fc5c9343c5342824) ? error.details : undefined;
            const backendFailureType = error instanceof (0, $b9b2682ba0353829$export$fc5c9343c5342824) ? error.backendFailureType : undefined;
            const networkErrorDiagnosticType = error instanceof (0, $b9b2682ba0353829$export$fc5c9343c5342824) ? error.diagnosticType : undefined;
            const networkErrorFailureStage = error instanceof (0, $b9b2682ba0353829$export$fc5c9343c5342824) ? error.failureStage : undefined;
            const responseContentType = error instanceof (0, $b9b2682ba0353829$export$fc5c9343c5342824) ? error.responseContentType : undefined;
            const networkErrorTraceId = error instanceof (0, $b9b2682ba0353829$export$fc5c9343c5342824) ? error.traceId : undefined;
            setData({
                errorState: details === (0, $kqQyU.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR ? (0, $htnqN.NLPSearchErrorState).HIPAAError : (0, $htnqN.NLPSearchErrorState).NetworkError,
                errorCode: errorCode,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                backendFailureType: backendFailureType,
                networkErrorDiagnosticType: networkErrorDiagnosticType,
                networkErrorFailureStage: networkErrorFailureStage,
                responseContentType: responseContentType,
                networkErrorTraceId: networkErrorTraceId,
                streamEventsReceived: streamEventsReceived,
                networkErrorDuration: networkErrorDuration,
                format: null,
                disclaimer: null,
                nlpResults: [],
                uniqueSources: [],
                nlpFollowUpResults: null,
                nlpSuggestedQueries: []
            });
        } finally{
            // Don't update loading/streamed state for aborted streams
            if (!abortController.signal.aborted || !(0, $iDrrr.fg)('kd_fix_abort_errors')) {
                setAnswerStreamed(true);
                setLoading(false);
            }
        }
    };
    // If aiAnswer is an object with a type property -- it's a getAIAnswer
    // and we need to handle the new streaming response
    if ('type' in aiAnswer) {
        if ((0, $iDrrr.fg)('kd_sain_improved_fetch_errors')) processStreamResponseImprovedErrorHandling(aiAnswer);
        else processStreamResponse(aiAnswer);
        return;
    }
    await aiAnswer.then((data)=>{
        if ('type' in data) {
            processStreamResponse(data);
            return;
        }
        setData(data?.nlpSearch || (0, $hZTED.DEFAULT_EMPTY_NLP_SEARCH_STATE));
        // Only store to cache if Lumina is disabled
        if (isReadingAids || !(0, $7DMz5.SAINFeatureControl).canRenderLumina()) (0, $6JEx2.setSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
            query: query,
            data: data?.nlpSearch || (0, $hZTED.DEFAULT_EMPTY_NLP_SEARCH_STATE)
        }));
        setLoading(false);
    }).catch((error)=>{
        fireAnalyticsEvent((0, $f2af7a532cac1c29$export$13b0ccf9f6015e4c)(error, source, {
            searchSessionId: searchSessionId,
            queryHash: (0, $9oghv.sha256Hash)(query),
            sourceProduct: sourceProduct,
            isReadingAids: isReadingAids,
            queryIntent: queryIntent
        }));
        const isTimeout = error instanceof DOMException && error.name === 'TimeoutError';
        setData({
            errorState: isTimeout ? (0, $htnqN.NLPSearchErrorState).TimeoutError : (0, $htnqN.NLPSearchErrorState).NetworkError,
            ...!isTimeout && (0, $iDrrr.fg)('kd_granular_network_errors') && {
                networkErrorReason: 'fetch_error',
                networkErrorDetails: error instanceof Error ? error.message : undefined
            },
            format: null,
            disclaimer: null,
            nlpResults: [],
            uniqueSources: [],
            nlpFollowUpResults: null
        });
        setLoading(false);
    });
};


const $63458847df53b6c8$var$MARKDOWN_FENCED_CODE_BLOCK_REGEX = /```[\s\S]*?```/g;
const $63458847df53b6c8$var$MARKDOWN_INLINE_CODE_REGEX = /`[^`\n]*`/g;
const $63458847df53b6c8$var$MARKDOWN_BLUE_LINK_REGEX = RegExp("(?<!!)\\[([^\\]]+)\\]\\(([^)]+)\\)", "g");
const $63458847df53b6c8$export$9b73daf8fd4da40f = (markdown)=>(markdown.replace($63458847df53b6c8$var$MARKDOWN_FENCED_CODE_BLOCK_REGEX, '').replace($63458847df53b6c8$var$MARKDOWN_INLINE_CODE_REGEX, '').match($63458847df53b6c8$var$MARKDOWN_BLUE_LINK_REGEX) ?? []).length;


















var $1rNZu = parcelRequire("1rNZu");

















var $6O5Et = parcelRequire("6O5Et");














/**
 * Shared implementation for the inline-Lumina source click handler. Pulled out of
 * the hook so both the stable (ref-backed) and legacy (dependency-backed) variants
 * can reuse exactly the same behaviour.
 */ const $69db6f2ab6839786$var$runSourceClick = (event, deps)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, fireSAINUsageEvent: fireSAINUsageEvent, onAIAnswerSourceClickCallback: onAIAnswerSourceClickCallback } = deps;
    if (!commonAttributes) return;
    const { url: url, componentType: componentType, indexInContainer: indexInContainer, isAuxClick: isAuxClick, isContextMenu: isContextMenu, isCopy: isCopy } = event;
    if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
    // Copy interactions reuse the existing `aiAnswerCopy clicked` event.
    if (isCopy) {
        fireAnalyticsEvent((0, $6O5Et.onAIAnswerCopyButtonClicked)(commonAttributes, 'inline-lumina-link-embed'));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).COPY_CLICKED,
            commonAttributes: commonAttributes
        });
        onAIAnswerSourceClickCallback?.();
        return;
    }
    const sourceCardType = componentType === 'linkList' ? 'inline-lumina-link-list' : componentType === 'linkEmbed' ? 'inline-lumina-link-embed' : undefined;
    let hostname;
    try {
        hostname = new URL(url).hostname;
    } catch  {
        hostname = undefined;
    }
    const sourceProduct = commonAttributes.sourceProduct ?? '';
    fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
        // Spread first so per-click fields below override context values.
        ...commonAttributes,
        sourceIndex: indexInContainer,
        hostname: hostname,
        isAuxClick: isAuxClick,
        isContextMenu: isContextMenu,
        sourceCardType: sourceCardType,
        sourceProduct: sourceProduct,
        isCitation: false
    }));
    fireSAINUsageEvent({
        metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
        commonAttributes: commonAttributes,
        sourceProduct: sourceProduct
    });
    onAIAnswerSourceClickCallback?.();
};
const $69db6f2ab6839786$export$e2fbe4dcb5b88963 = ({ aiAnswerDialogContext: aiAnswerDialogContext })=>{
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const commonAttributes = aiAnswerDialogContext?.commonAttributes;
    const onAIAnswerSourceClickCallback = aiAnswerDialogContext?.callbacks?.onAIAnswerSourceClick;
    // `commonAttributes` gets a new reference on every streamed chunk (it depends on
    // the growing answer string). When this handler lists it as a `useCallback`
    // dependency, the handler identity changes every chunk and is passed as a new
    // `onSourceClick` prop into `LuminaLayout` / the inline link list, causing it to
    // re-render on every chunk while streaming. Keeping the volatile values in a ref
    // lets the handler stay stable while still reading fresh values at click time.
    const isStreamingFlickerFixEnabled = (0, $iDrrr.fg)('kd_link_list_streaming_flicker_fix');
    const latestDepsRef = (0, $cozmU.useRef)({
        fireAnalyticsEvent: fireAnalyticsEvent,
        commonAttributes: commonAttributes,
        fireSAINUsageEvent: fireSAINUsageEvent,
        onAIAnswerSourceClickCallback: onAIAnswerSourceClickCallback
    });
    latestDepsRef.current = {
        fireAnalyticsEvent: fireAnalyticsEvent,
        commonAttributes: commonAttributes,
        fireSAINUsageEvent: fireSAINUsageEvent,
        onAIAnswerSourceClickCallback: onAIAnswerSourceClickCallback
    };
    const stableHandler = (0, $cozmU.useCallback)((event)=>$69db6f2ab6839786$var$runSourceClick(event, latestDepsRef.current), // Intentionally stable: reads the latest values via `latestDepsRef`.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const legacyHandler = (0, $cozmU.useCallback)((event)=>$69db6f2ab6839786$var$runSourceClick(event, {
            fireAnalyticsEvent: fireAnalyticsEvent,
            commonAttributes: commonAttributes,
            fireSAINUsageEvent: fireSAINUsageEvent,
            onAIAnswerSourceClickCallback: onAIAnswerSourceClickCallback
        }), [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        onAIAnswerSourceClickCallback
    ]);
    return isStreamingFlickerFixEnabled ? stableHandler : legacyHandler;
};


const $df13fecb6fd21b0f$var$LUMINA_START_TAG = '<lumina>';
const $df13fecb6fd21b0f$var$LUMINA_END_TAG = '</lumina>';

const $df13fecb6fd21b0f$var$LuminaLayout = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("k8nNQ")).then((mod)=>({
            default: mod.LuminaLayout
        })));
const $df13fecb6fd21b0f$var$InlineLuminaLayout = ({ luminaContent: luminaContent, cloudId: cloudId, orgId: orgId, requestingUserId: requestingUserId, sourceProduct: sourceProduct })=>{
    const aiAnswerDialogContext = (0, $3hVWe.useAIAnswerContext)();
    const onSourceClick = (0, $69db6f2ab6839786$export$e2fbe4dcb5b88963)({
        aiAnswerDialogContext: aiAnswerDialogContext
    });
    const { sessionId: sessionId } = aiAnswerDialogContext.commonAttributes;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df13fecb6fd21b0f$var$LuminaLayout, {
        luminaTagResponse: `${$df13fecb6fd21b0f$var$LUMINA_START_TAG}${luminaContent}${$df13fecb6fd21b0f$var$LUMINA_END_TAG}`,
        source: "luminaSAIN",
        smartLinkRenderer: "embed",
        cloudId: cloudId,
        orgId: orgId,
        requestingUserId: requestingUserId,
        sourceProduct: sourceProduct,
        sessionId: sessionId,
        onSourceClick: onSourceClick
    });
};
const $df13fecb6fd21b0f$export$d182b2243055abe1 = (props, markdownData, appContext, userId)=>{
    if ((0, $1rNZu.isInlineLuminaStatus)(props.localId)) {
        // retrieve idx of status node created by extension
        const luminaIdx = parseInt(props.text.replace((0, $1rNZu.INLINE_LUMINA_STATUS_PREFIX), ''), 10);
        // map idx to content from markdownData created during streaming
        const luminaContent = markdownData?.[`${0, $b2270b423e154e70$export$b2ac4f39739d467d}${luminaIdx}`] ?? '';
        if (luminaContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df13fecb6fd21b0f$var$InlineLuminaLayout, {
            luminaContent: luminaContent,
            cloudId: appContext.cloudId,
            orgId: appContext.orgId,
            requestingUserId: userId,
            sourceProduct: appContext.sourceProduct
        });
    }
    if ((0, $7DMz5.SAINFeatureControl).isInlineCitationsUpdateEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ba9b602d2037f879$export$e190835f8c06a181), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2862f0d359af03a$export$21553c57082a6434), props);
};


const $6c5ac787bcb31d21$var$messages = (0, $kSwu1.defineMessages)({
    linksOpenInNewTab: {
        id: "search-ai.v2.common.react-renderer.linksOpenInNewTab",
        defaultMessage: "Links in this answer open in a new tab."
    }
});

const $6c5ac787bcb31d21$var$AkReactRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("7ydRw")).then(({ ReactRenderer: ReactRenderer })=>{
        return {
            default: ReactRenderer
        };
    }));
const $6c5ac787bcb31d21$var$fadeIn = null;
const $6c5ac787bcb31d21$var$animatedStyles = {
    container: "_2fBhteWDhd"
};
const $6c5ac787bcb31d21$var$unboundAnimatedStyles = {
    container: "_1YKVNsdnbC",
    listItem: "_08tqxzWDhd _0R6HAadnbC"
};
const $6c5ac787bcb31d21$var$StaggeredChild = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children, index: index })=>{
    // If children is a string longer than 10 characters, split it into 3 parts
    if (typeof children === 'string' && children.length > 10) {
        const chunkSize = Math.ceil(children.length / 3);
        const parts = [
            children.slice(0, chunkSize),
            children.slice(chunkSize, chunkSize * 2),
            children.slice(chunkSize * 2)
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, parts.map((part, partIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                key: partIndex,
                style: {
                    animationDelay: `${index * 200 + partIndex * 100}ms`
                },
                className: (0, $hekY6.default)([
                    $6c5ac787bcb31d21$var$animatedStyles.container,
                    $6c5ac787bcb31d21$var$unboundAnimatedStyles.container
                ])
            }, part)));
    } // For non-strings or short strings, render normally
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            animationDelay: `${index * 200}ms`
        },
        className: (0, $hekY6.default)([
            $6c5ac787bcb31d21$var$animatedStyles.container,
            $6c5ac787bcb31d21$var$unboundAnimatedStyles.container
        ])
    }, children);
});
$6c5ac787bcb31d21$var$StaggeredChild.displayName = 'StaggeredChild';
const $6c5ac787bcb31d21$var$StaggeredAnimatedParagraph = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children })=>{
    // Convert children to array to handle staggering
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, childrenArray.map((child, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c5ac787bcb31d21$var$StaggeredChild, {
            key: index,
            index: index
        }, child)));
});
$6c5ac787bcb31d21$var$StaggeredAnimatedParagraph.displayName = 'StaggeredAnimatedParagraph';
const $6c5ac787bcb31d21$var$AnimatedOrderedList = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ol", {
        ...props,
        className: (0, $hekY6.default)([
            $6c5ac787bcb31d21$var$animatedStyles.container,
            $6c5ac787bcb31d21$var$unboundAnimatedStyles.container,
            $6c5ac787bcb31d21$var$unboundAnimatedStyles.listItem
        ])
    }, children);
});
$6c5ac787bcb31d21$var$AnimatedOrderedList.displayName = 'AnimatedOrderedList';
const $6c5ac787bcb31d21$var$AnimatedBulletedList = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        ...props,
        className: (0, $hekY6.default)([
            $6c5ac787bcb31d21$var$animatedStyles.container,
            $6c5ac787bcb31d21$var$unboundAnimatedStyles.container,
            $6c5ac787bcb31d21$var$unboundAnimatedStyles.listItem
        ])
    }, children);
});
$6c5ac787bcb31d21$var$AnimatedBulletedList.displayName = 'AnimatedBulletedList';
const $6c5ac787bcb31d21$var$AnimatedHeading = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children, ...props })=>{
    // Extract heading level from props (h1, h2, h3, etc.)
    const headingLevel = props.level || 1;
    const HeadingTag = `h${headingLevel}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(HeadingTag, {
        ...props,
        className: (0, $hekY6.default)([
            $6c5ac787bcb31d21$var$animatedStyles.container,
            $6c5ac787bcb31d21$var$unboundAnimatedStyles.container
        ])
    }, children);
});
$6c5ac787bcb31d21$var$AnimatedHeading.displayName = 'AnimatedHeading'; // Create stable component references to prevent recreation
const $6c5ac787bcb31d21$var$StatusComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2862f0d359af03a$export$21553c57082a6434), props));
$6c5ac787bcb31d21$var$StatusComponent.displayName = 'StatusComponent';
const $6c5ac787bcb31d21$var$StatusComponentInlineCitation = /*#__PURE__*/ (0, $cozmU.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ba9b602d2037f879$export$e190835f8c06a181), props));
$6c5ac787bcb31d21$var$StatusComponentInlineCitation.displayName = 'StatusComponentInlineCitation';
const $6c5ac787bcb31d21$var$MediaComponent = /*#__PURE__*/ (0, $cozmU.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null));
$6c5ac787bcb31d21$var$MediaComponent.displayName = 'MediaComponent';
const $6c5ac787bcb31d21$var$MediaSingleComponent = /*#__PURE__*/ (0, $cozmU.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null));
$6c5ac787bcb31d21$var$MediaSingleComponent.displayName = 'MediaSingleComponent'; // Create stable component references
const $6c5ac787bcb31d21$var$StreamingParagraphComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c5ac787bcb31d21$var$StaggeredAnimatedParagraph, props));
$6c5ac787bcb31d21$var$StreamingParagraphComponent.displayName = 'StreamingParagraphComponent';
const $6c5ac787bcb31d21$var$StreamingOrderedListComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c5ac787bcb31d21$var$AnimatedOrderedList, props));
$6c5ac787bcb31d21$var$StreamingOrderedListComponent.displayName = 'StreamingOrderedListComponent';
const $6c5ac787bcb31d21$var$StreamingBulletedListComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c5ac787bcb31d21$var$AnimatedBulletedList, props));
$6c5ac787bcb31d21$var$StreamingBulletedListComponent.displayName = 'StreamingBulletedListComponent';
const $6c5ac787bcb31d21$var$StreamingHeadingComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c5ac787bcb31d21$var$AnimatedHeading, props));
$6c5ac787bcb31d21$var$StreamingHeadingComponent.displayName = 'StreamingHeadingComponent';
function $6c5ac787bcb31d21$export$687d546b0584d31b({ markdown: markdown, animateComponents: animateComponents = false }) {
    const { luminaContentMap: luminaContentMap, commonAttributes: commonAttributes, userDetails: userDetails } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const rendererContainerRef = (0, $cozmU.useRef)(null);
    const blueLinkAnalyticsContextRef = (0, $cozmU.useRef)({
        commonAttributes: commonAttributes,
        fireAnalyticsEvent: fireAnalyticsEvent,
        fireSAINUsageEvent: fireSAINUsageEvent
    });
    blueLinkAnalyticsContextRef.current = {
        commonAttributes: commonAttributes,
        fireAnalyticsEvent: fireAnalyticsEvent,
        fireSAINUsageEvent: fireSAINUsageEvent
    };
    const useInlineCitations = (0, $7DMz5.SAINFeatureControl).isInlineCitationsUpdateEnabled();
    const luminaInMarkdownDataRef = (0, $cozmU.useRef)(luminaContentMap);
    luminaInMarkdownDataRef.current = luminaContentMap; // Keep the latest app context / user id in refs so that the memoized `status`
    // node component below can read fresh values without changing its identity on
    // every streamed chunk. `commonAttributes` gets a new reference on every chunk
    // (it depends on the growing answer string), so depending on it directly would
    // recreate the `status` component type each chunk and force the ADF renderer to
    // unmount/remount every inline status node (including the inline Lumina link
    // list), causing a resolved <-> loading flicker while streaming.
    const statusAppContextRef = (0, $cozmU.useRef)({
        orgId: commonAttributes.orgId,
        cloudId: commonAttributes.cloudId,
        sourceProduct: commonAttributes.sourceProduct ?? '',
        userId: userDetails?.id ?? ''
    });
    statusAppContextRef.current = {
        orgId: commonAttributes.orgId,
        cloudId: commonAttributes.cloudId,
        sourceProduct: commonAttributes.sourceProduct ?? '',
        userId: userDetails?.id ?? ''
    };
    const enableImageSearch = (0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search');
    const isBlueLinkAnalyticsEnabled = (0, $iDrrr.fg)('kd_sain_blue_links_analytics');
    const hasBlueLinks = (0, $cozmU.useMemo)(()=>isBlueLinkAnalyticsEnabled && (0, $63458847df53b6c8$export$9b73daf8fd4da40f)(markdown) > 0, [
        isBlueLinkAnalyticsEnabled,
        markdown
    ]);
    const docContent = (0, $cozmU.useMemo)(()=>{
        const processedMarkdown = (0, $iDrrr.fg)('kd_sain_enable_inline_lumina') ? (0, $f3OgL.extractMarkdownText)(markdown, (0, $b2270b423e154e70$export$84f2194b2008422), (0, $b2270b423e154e70$export$192ba1edc601a546), (0, $b2270b423e154e70$export$ea5ceaf3fa709ad4)).processedText : markdown;
        return (0, $6rwn6.encodeAdf)(processedMarkdown, true, undefined, undefined, useInlineCitations || undefined);
    }, [
        markdown,
        useInlineCitations
    ]); // The inline Lumina `status` node component. We build BOTH variants below (each
    // with a constant-length dependency array, so React's hook book-keeping is never
    // disturbed) and select between them via the feature gate. This keeps the
    // behaviour change gated per experimentation policy without introducing a
    // variable-length `useMemo` dependency array.
    const isStreamingFlickerFixEnabled = (0, $iDrrr.fg)('kd_link_list_streaming_flicker_fix'); // Fix ON: stable component identity for the renderer's lifetime. It reads the
    // latest app context / user id from `statusAppContextRef` (synchronised every
    // render above), so it never needs to be recreated as the answer streams in. A
    // stable `status` component type lets the ADF renderer reconcile status nodes in
    // place instead of unmounting/remounting them (and the inline Lumina link list)
    // on every chunk, which is what causes the resolved <-> loading flicker.
    const stableStatusComponent = (0, $cozmU.useMemo)(()=>{
        return (props)=>{
            const { orgId: orgId, cloudId: cloudId, sourceProduct: sourceProduct, userId: userId } = statusAppContextRef.current;
            return (0, $df13fecb6fd21b0f$export$d182b2243055abe1)(props, luminaInMarkdownDataRef.current, {
                orgId: orgId,
                cloudId: cloudId,
                sourceProduct: sourceProduct
            }, userId);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Fix OFF: original behaviour — the component is recreated whenever
    // `commonAttributes` / user id change (which happens on every streamed chunk).
    const legacyStatusComponent = (0, $cozmU.useMemo)(()=>{
        return (props)=>{
            return (0, $df13fecb6fd21b0f$export$d182b2243055abe1)(props, luminaInMarkdownDataRef.current, {
                orgId: commonAttributes.orgId,
                cloudId: commonAttributes.cloudId,
                sourceProduct: commonAttributes.sourceProduct ?? ''
            }, userDetails?.id ?? '');
        };
    }, [
        commonAttributes,
        userDetails?.id
    ]);
    const StatusComponentMemoized = isStreamingFlickerFixEnabled ? stableStatusComponent : legacyStatusComponent;
    const config = (0, $cozmU.useMemo)(()=>{
        const statusComponent = (0, $iDrrr.fg)('kd_sain_enable_inline_lumina') ? StatusComponentMemoized : useInlineCitations ? $6c5ac787bcb31d21$var$StatusComponentInlineCitation : $6c5ac787bcb31d21$var$StatusComponent; // Create stable nodeComponents objects
        const staticNodeComponents = {
            status: statusComponent,
            media: $6c5ac787bcb31d21$var$MediaComponent,
            mediaSingle: $6c5ac787bcb31d21$var$MediaSingleComponent
        };
        const animatedNodeComponents = {
            status: statusComponent,
            media: $6c5ac787bcb31d21$var$MediaComponent,
            mediaSingle: $6c5ac787bcb31d21$var$MediaSingleComponent,
            paragraph: $6c5ac787bcb31d21$var$StreamingParagraphComponent,
            orderedList: $6c5ac787bcb31d21$var$StreamingOrderedListComponent,
            bulletList: $6c5ac787bcb31d21$var$StreamingBulletedListComponent,
            heading: $6c5ac787bcb31d21$var$StreamingHeadingComponent
        };
        const nodeComponents = animateComponents ? {
            ...animatedNodeComponents
        } : {
            ...staticNodeComponents
        }; // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { media: media, mediaSingle: mediaSingle, ...nodeComponentsWithoutMediaOverrides } = nodeComponents;
        return {
            document: docContent,
            nodeComponents: enableImageSearch ? nodeComponentsWithoutMediaOverrides : nodeComponents,
            smartLinks: {
                ssr: true
            }
        };
    }, [
        docContent,
        animateComponents,
        enableImageSearch,
        useInlineCitations,
        StatusComponentMemoized
    ]);
    const cloudId = commonAttributes.cloudId;
    const orgId = commonAttributes.orgId;
    const productKey = commonAttributes.sourceProduct;
    const viewerId = userDetails?.id;
    const dataProviders = (0, $cozmU.useMemo)(()=>{
        if (!(0, $iDrrr.fg)('kd_sain_clickable_user_mentions') || !cloudId || !productKey) return undefined;
        const mentionProvider = Promise.resolve(new (0, $7fxzU.default)({
            productKey: productKey,
            siteId: cloudId,
            orgId: orgId,
            includeTeams: true,
            includeUsers: true,
            shouldHighlightMention (mention) {
                return mention.id === viewerId;
            }
        }));
        const profilecardProvider = Promise.resolve({
            cloudId: cloudId,
            resourceClient: new (0, $5hJlu.default)({
                url: '/gateway/api/directory/graphql',
                cloudId: cloudId,
                productIdentifier: productKey
            }),
            getActions: ()=>[],
            ...(0, $iDrrr.fg)('people-teams_migrate-user-profile-card') || (0, $cXtTj.default).getExperimentValue('pt_user_profile_card_migration_exp', 'isEnabled', false) ? {
                renderUserMentionCard: ({ userId: userId, cloudId: mentionCloudId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6fxF.UserProfileCardForMention), {
                        userId: userId,
                        cloudId: mentionCloudId,
                        orgId: orgId ?? '',
                        viewerId: viewerId ?? ''
                    }, children)
            } : {}
        });
        return (0, $eNbr2.default).create({
            mentionProvider: mentionProvider,
            profilecardProvider: profilecardProvider
        });
    }, [
        cloudId,
        orgId,
        productKey,
        viewerId
    ]); // AkReactRenderer only exposes primary link clicks through eventHandlers.link.onClick.
    // Attach native listeners on the container to capture aux-click and context-menu
    // interactions that bypass the ADF link onClick path.
    (0, $cozmU.useEffect)(()=>{
        if (!isBlueLinkAnalyticsEnabled) return;
        const container = rendererContainerRef.current;
        if (!container) return;
        const fireBlueLinkClick = ({ url: url, isAuxClick: isAuxClick, isContextMenu: isContextMenu })=>{
            const { commonAttributes: latestCommonAttributes, fireAnalyticsEvent: latestFireAnalyticsEvent, fireSAINUsageEvent: latestFireSAINUsageEvent } = blueLinkAnalyticsContextRef.current;
            latestFireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
                ...latestCommonAttributes,
                elementInteracted: 'bluelink',
                isAuxClick: isAuxClick,
                isContextMenu: isContextMenu
            }));
            latestFireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).BLUE_LINK_CLICKED,
                commonAttributes: latestCommonAttributes
            });
        };
        const getContainedAnchorUrl = (event)=>{
            const target = event.target;
            if (!(target instanceof Element)) return;
            const anchor = target.closest('a[href]');
            if (!anchor || !container.contains(anchor)) return;
            const citationRoot = anchor.closest((0, $lEgaq.SAIN_CITATION_SELECTOR));
            if (citationRoot && container.contains(citationRoot)) return;
            return anchor.getAttribute('href') || undefined;
        };
        const onAuxClick = (event)=>{
            if (event.button !== 1) return;
            const url = getContainedAnchorUrl(event);
            if (!url) return;
            fireBlueLinkClick({
                url: url,
                isAuxClick: true,
                isContextMenu: false
            });
        };
        const onContextMenu = (event)=>{
            const url = getContainedAnchorUrl(event);
            if (!url) return;
            fireBlueLinkClick({
                url: url,
                isAuxClick: false,
                isContextMenu: true
            });
        }; // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        container.addEventListener('auxclick', onAuxClick); // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        container.addEventListener('contextmenu', onContextMenu);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            container.removeEventListener('auxclick', onAuxClick); // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            container.removeEventListener('contextmenu', onContextMenu);
        };
    }, [
        isBlueLinkAnalyticsEnabled
    ]);
    const eventHandlers = (0, $cozmU.useMemo)(()=>{
        if (!isBlueLinkAnalyticsEnabled) return undefined;
        return {
            link: {
                onClick: (event, url)=>{
                    if (!url) return;
                    const mouseEvent = event.nativeEvent; // Middle-clicks are handled by the native auxclick listener above;
                    // other non-primary buttons are intentionally ignored.
                    if (mouseEvent.button !== 0) return;
                    const isModifiedNavigation = mouseEvent.metaKey || mouseEvent.ctrlKey || mouseEvent.shiftKey;
                    const { commonAttributes: latestCommonAttributes, fireAnalyticsEvent: latestFireAnalyticsEvent, fireSAINUsageEvent: latestFireSAINUsageEvent } = blueLinkAnalyticsContextRef.current;
                    latestFireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
                        ...latestCommonAttributes,
                        elementInteracted: 'bluelink',
                        isAuxClick: false,
                        isContextMenu: false
                    }));
                    latestFireSAINUsageEvent({
                        metCriteria: (0, $bZMnB.SainAction).BLUE_LINK_CLICKED,
                        commonAttributes: latestCommonAttributes
                    }); // For unmodified left clicks, the page would normally navigate away before
                    // the analytics request can be dispatched, so we intercept and open the link
                    // manually in a new tab. Modifier-key clicks (cmd/ctrl/shift) are left to the
                    // browser to honour the user's intent (background tab, new window, etc.) —
                    // the analytics event still fires above.
                    if (!isModifiedNavigation) {
                        event.preventDefault();
                        window.open(url, '_blank', 'noopener,noreferrer');
                    }
                }
            }
        };
    }, [
        isBlueLinkAnalyticsEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: rendererContainerRef
    }, isBlueLinkAnalyticsEnabled && hasBlueLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6c5ac787bcb31d21$var$messages.linksOpenInNewTab)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c5ac787bcb31d21$var$AkReactRenderer, {
        ...config,
        eventHandlers: eventHandlers,
        dataProviders: dataProviders
    })));
}


/* read-more-button.tsx generated by @compiled/babel-plugin v3.0.1 */ 



































const $ed12dd693731600a$var$styles = {
    container: "_2Y7lL45zaO _3iDTPbQ4SZ _0Of8r2gVvo",
    readMoreButton: "_2Y7lL4Pgdg _1kk5Tkf7mX _1UtDYzM7Tp _0KLXru66of _1ANEUSLRg7 _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMAwSC _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _0CMRbkAwSC"
};
const $ed12dd693731600a$var$motionStyles = {
    readMoreButton: "_23rrnHyKLB _3sFUREiSCN"
};
function $ed12dd693731600a$export$e68719f9c8487320({ onClick: onClick }) {
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)(); // Fire analytics event when button is shown
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $ad1269dfeb562305$export$8aac675f87e67286)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Handle click with analytics
    const handleClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $bb4a8344422431c3$export$f0624d0c866f1dff)(commonAttributes));
        if (!(0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).READ_MORE_BUTTON_CLICKED,
            commonAttributes: commonAttributes
        });
        onClick();
    }, [
        fireAnalyticsEvent,
        onClick,
        commonAttributes,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ed12dd693731600a$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: handleClick,
        xcss: (0, $w6R6I.cx)($ed12dd693731600a$var$styles.readMoreButton, (0, $iDrrr.fg)('platform-dst-motion-uplift-custom-button') && $ed12dd693731600a$var$motionStyles.readMoreButton),
        testId: "read-more-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5OgwG.messages).ai_answer_card_read_more_button))));
}



var $24oKg = parcelRequire("24oKg");




const $619bd3e23d17df21$export$816a5214860a0c40 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerMinimizedCollapseButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $57db223fb661d84a$export$b19cbf041d35e6cc = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerMinimizedExpandButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $57ae65a71649f2c5$export$7f9024bb8c6bf2c3 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerMinimizedScrollUpButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};


/* smart-answer-card-minimized-loading.tsx generated by @compiled/babel-plugin v3.0.1 */ 




























var $kSORO = parcelRequire("kSORO");







const $e2d90c16cb0d52c9$export$db586d8c7b1541e0 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerMinimizedLoadingCollapseButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $7ad80c56fa109a71$export$95c4fee0614a7136 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerMinimizedLoadingExpandButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};






var $lvJXz = parcelRequire("lvJXz");

var $2976c97aa2bab989$exports = {};
$2976c97aa2bab989$exports = JSON.parse("{\"v\":\"5.7.1\",\"fr\":30,\"ip\":0,\"op\":108,\"w\":100,\"h\":100,\"nm\":\"Shape Morph\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Morph Shape\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[180],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[240],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[360],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[450]}]},\"p\":{\"a\":0,\"k\":[50,50,0]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":0,\"k\":[100,100,100]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[6.499999999999993,-49.6],[12.899999999999999,-48.3],[19.099999999999994,-46.2],[25,-43.3],[30.400000000000006,-39.7],[35.400000000000006,-35.4],[39.7,-30.4],[43.3,-25],[46.2,-19.1],[48.3,-12.899999999999999],[49.599999999999994,-6.5],[50,0],[49.599999999999994,6.499999999999993],[48.3,12.899999999999999],[46.2,19.099999999999994],[43.3,25],[39.7,30.400000000000006],[35.400000000000006,35.400000000000006],[30.400000000000006,39.7],[25,43.3],[19.099999999999994,46.2],[12.899999999999999,48.3],[6.499999999999993,49.599999999999994],[0,50],[-6.5,49.599999999999994],[-12.899999999999999,48.3],[-19.1,46.2],[-25,43.3],[-30.4,39.7],[-35.4,35.400000000000006],[-39.7,30.400000000000006],[-43.3,25],[-46.2,19.099999999999994],[-48.3,12.899999999999999],[-49.6,6.499999999999993],[-50,0],[-49.6,-6.5],[-48.3,-12.899999999999999],[-46.2,-19.1],[-43.3,-25],[-39.7,-30.4],[-35.4,-35.4],[-30.4,-39.7],[-25,-43.3],[-19.1,-46.2],[-12.899999999999999,-48.3],[-6.5,-49.6]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-50,-50],[-41.7,-50],[-33.3,-50],[-25,-50],[-16.700000000000003,-50],[-8.299999999999997,-50],[0,-50],[8.299999999999997,-50],[16.700000000000003,-50],[25,-50],[33.3,-50],[41.7,-50],[50,-50],[50,-41.7],[50,-33.3],[50,-25],[50,-16.700000000000003],[50,-8.299999999999997],[50,0],[50,8.299999999999997],[50,16.700000000000003],[50,25],[50,33.3],[50,41.7],[50,50],[41.7,50],[33.3,50],[25,50],[16.700000000000003,50],[8.299999999999997,50],[0,50],[-8.299999999999997,50],[-16.700000000000003,50],[-25,50],[-33.3,50],[-41.7,50],[-50,50],[-50,41.7],[-50,33.3],[-50,25],[-50,16.700000000000003],[-50,8.299999999999997],[-50,0],[-50,-8.299999999999997],[-50,-16.700000000000003],[-50,-25],[-50,-33.3],[-50,-41.7]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[5.3999999999999915,-46.9],[10.799999999999997,-43.7],[16.200000000000003,-40.6],[21.700000000000003,-37.5],[27.099999999999994,-34.4],[32.5,-31.2],[37.900000000000006,-28.1],[43.3,-25],[43.3,-18.7],[43.3,-12.5],[43.3,-6.200000000000003],[43.3,0],[43.3,6.299999999999997],[43.3,12.5],[43.3,18.799999999999997],[43.3,25],[37.900000000000006,28.099999999999994],[32.5,31.299999999999997],[27.099999999999994,34.400000000000006],[21.700000000000003,37.5],[16.200000000000003,40.599999999999994],[10.799999999999997,43.8],[5.3999999999999915,46.900000000000006],[0,50],[-5.399999999999999,46.900000000000006],[-10.799999999999997,43.8],[-16.200000000000003,40.599999999999994],[-21.699999999999996,37.5],[-27.1,34.400000000000006],[-32.5,31.299999999999997],[-37.9,28.099999999999994],[-43.3,25],[-43.3,18.799999999999997],[-43.3,12.5],[-43.3,6.299999999999997],[-43.3,0],[-43.3,-6.200000000000003],[-43.3,-12.5],[-43.3,-18.8],[-43.3,-25],[-37.9,-28.1],[-32.5,-31.3],[-27.1,-34.4],[-21.699999999999996,-37.5],[-16.200000000000003,-40.6],[-10.799999999999997,-43.7],[-5.399999999999999,-46.9]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[3.1000000000000014,-43.7],[6.299999999999997,-37.5],[9.399999999999999,-31.2],[12.5,-25],[15.599999999999994,-18.7],[18.799999999999997,-12.5],[21.900000000000006,-6.200000000000003],[25,0],[28.099999999999994,6.299999999999997],[31.299999999999997,12.5],[34.400000000000006,18.799999999999997],[37.5,25],[40.599999999999994,31.299999999999997],[43.8,37.5],[46.900000000000006,43.8],[50,50],[43.8,50],[37.5,50],[31.299999999999997,50],[25,50],[18.799999999999997,50],[12.5,50],[6.299999999999997,50],[0,50],[-6.200000000000003,50],[-12.5,50],[-18.7,50],[-25,50],[-31.2,50],[-37.5,50],[-43.7,50],[-50,50],[-46.9,43.8],[-43.7,37.5],[-40.6,31.299999999999997],[-37.5,25],[-34.4,18.799999999999997],[-31.2,12.5],[-28.1,6.299999999999997],[-25,0],[-21.9,-6.200000000000003],[-18.7,-12.5],[-15.600000000000001,-18.7],[-12.5,-25],[-9.399999999999999,-31.2],[-6.200000000000003,-37.5],[-3.1000000000000014,-43.7]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[6.499999999999993,-49.6],[12.899999999999999,-48.3],[19.099999999999994,-46.2],[25,-43.3],[30.400000000000006,-39.7],[35.400000000000006,-35.4],[39.7,-30.4],[43.3,-25],[46.2,-19.1],[48.3,-12.899999999999999],[49.599999999999994,-6.5],[50,0],[49.599999999999994,6.499999999999993],[48.3,12.899999999999999],[46.2,19.099999999999994],[43.3,25],[39.7,30.400000000000006],[35.400000000000006,35.400000000000006],[30.400000000000006,39.7],[25,43.3],[19.099999999999994,46.2],[12.899999999999999,48.3],[6.499999999999993,49.599999999999994],[0,50],[-6.5,49.599999999999994],[-12.899999999999999,48.3],[-19.1,46.2],[-25,43.3],[-30.4,39.7],[-35.4,35.400000000000006],[-39.7,30.400000000000006],[-43.3,25],[-46.2,19.099999999999994],[-48.3,12.899999999999999],[-49.6,6.499999999999993],[-50,0],[-49.6,-6.5],[-48.3,-12.899999999999999],[-46.2,-19.1],[-43.3,-25],[-39.7,-30.4],[-35.4,-35.4],[-30.4,-39.7],[-25,-43.3],[-19.1,-46.2],[-12.899999999999999,-48.3],[-6.5,-49.6]],\"c\":true}]}]},\"nm\":\"Path\",\"mn\":\"ADBE Vector Shape - Group\"},{\"ty\":\"fl\",\"c\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":5,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":11,\"s\":[0.5098039215686274,0.7098039215686275,0.21176470588235294],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":32,\"s\":[0.5098039215686274,0.7098039215686275,0.21176470588235294],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":37,\"s\":[0.09411764705882353,0.40784313725490196,0.8588235294117647],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":59,\"s\":[0.09411764705882353,0.40784313725490196,0.8588235294117647],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":64,\"s\":[0.7490196078431373,0.38823529411764707,0.9529411764705882],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":86,\"s\":[0.7490196078431373,0.38823529411764707,0.9529411764705882],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":91,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":107,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433]}]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100}}],\"nm\":\"Shape Group\",\"np\":3}],\"ip\":0,\"op\":108,\"st\":0,\"bm\":0}]}");


const $9e5f31f7d389abdf$var$CONTAINER_STYLE = {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'visible'
};
const $9e5f31f7d389abdf$var$LOTTIE_WRAPPER_STYLE = {
    width: 16,
    height: 16
};
const $9e5f31f7d389abdf$export$c07a397cf5c24cd8 = ({ testId: testId })=>{
    const containerRef = (0, $cozmU.useRef)(null);
    // Use refs instead of module-level variables so each component instance
    // maintains its own animation state, scoped to its own lifecycle.
    const savedFrameRef = (0, $cozmU.useRef)(0);
    const hasPlayedBeforeRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        const currentRef = containerRef.current;
        if (!currentRef) return;
        const baseAnimationConfig = {
            container: currentRef,
            animationData: (0, (/*@__PURE__*/$parcel$interopDefault($2976c97aa2bab989$exports))),
            renderer: 'svg',
            loop: true
        };
        let animationInstance;
        if (hasPlayedBeforeRef.current) {
            // Remount — resume from saved frame for smooth animation continuity
            animationInstance = (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation({
                ...baseAnimationConfig,
                autoplay: false
            });
            animationInstance.goToAndPlay(savedFrameRef.current, true);
        } else // First mount — start from scratch
        animationInstance = (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation({
            ...baseAnimationConfig,
            autoplay: true
        });
        hasPlayedBeforeRef.current = true;
        return ()=>{
            // Save current frame before destroying so we can resume on remount
            savedFrameRef.current = animationInstance.currentFrame;
            animationInstance.destroy();
        };
    }, []);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- static styles for lottie container
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: $9e5f31f7d389abdf$var$CONTAINER_STYLE,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: $9e5f31f7d389abdf$var$LOTTIE_WRAPPER_STYLE,
        ref: containerRef
    })));
};


/* research-step-row.tsx generated by @compiled/babel-plugin v3.0.1 */ 









/* shimmer-text.tsx generated by @compiled/babel-plugin v3.0.1 */ 








const $14633d638bf89cef$var$shimmerAnimation = null;
const $14633d638bf89cef$var$shimmerGradient = null; /** Single-line ellipsis + flex/grid-safe width. */ 
const $14633d638bf89cef$var$truncateSingleLine = null;
const $14633d638bf89cef$export$f35c7d979dec8662 = ({ children: children, size: size = 'medium', weight: weight = 'regular', truncate: truncate = false })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2uo31fSyNX _2fBhteTUTt _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL",
            truncate && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _39xV02N91d _1EqgXlN91d"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: size,
        weight: weight,
        color: "color.text.subtlest"
    }, children));
};


const $65efb4030898c062$var$styles = {
    stepRow: "_3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _17lj8p2ADO _0hPCNLFlnN _1mT5xdRAKS",
    iconColumn: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02oWWg _3YEZNOdnbC _4xdlr0FlnN",
    ruleSlot: "_2O5Vij7dHp _39xV02dnbC",
    ruleSlotWithLine: "_3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _2O5Vij7dHp _39xV02dnbC",
    stepContent: "_2O5Vij7dHp _4ouGXIdnbC _0Of8r22ADO _1wydGW2ADO"
};
const $65efb4030898c062$export$f22a8a5ea07141e0 = ({ step: step, showTopConnector: showTopConnector = false, showBottomConnector: showBottomConnector = false, hideIcon: hideIcon = false, testId: testId })=>{
    const [iconError, setIconError] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $65efb4030898c062$var$styles.stepRow,
        testId: testId
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $65efb4030898c062$var$styles.iconColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: showTopConnector ? $65efb4030898c062$var$styles.ruleSlotWithLine : $65efb4030898c062$var$styles.ruleSlot
    }), step.toolIcon && !iconError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: step.toolIcon,
        alt: "",
        width: 16,
        height: 16,
        onError: ()=>setIconError(true)
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: showBottomConnector ? $65efb4030898c062$var$styles.ruleSlotWithLine : $65efb4030898c062$var$styles.ruleSlot
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $65efb4030898c062$var$styles.stepContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, step.title ? step.completed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        color: "color.text.subtlest"
    }, step.title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14633d638bf89cef$export$f35c7d979dec8662), {
        size: "medium"
    }, step.title) : null, step.separatedContent && step.separatedContent.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, step.separatedContent[step.separatedContent.length - 1].trim()) : null)));
};



const $1175367593db581d$var$getRenderableSteps = (steps)=>{
    if (!steps) return [];
    return Object.values(steps).filter((s)=>!!s.title).sort((a, b)=>a.order - b.order);
};
const $1175367593db581d$var$styles = {
    shimmerWrapper: "_2O5Vij7dHp _4ouGXIdnbC",
    expandedContent: "_0Of8r2Pgdg _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE _0KLXrunmFW _1v9SsVKxmn _3XDz3BKxmn",
    buttonPlaceholder: "_1YKVNsdnbC _1pp6NdYbGa _3YEZNOdnbC",
    collapsedRow: "_0bjKvDKxmn _3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _17lj8p2ADO _0hPCNLDIqT _0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _24h04i2Njc _0jFU0V9LX5 _0KLXrunmFW",
    collapsedLoaderIconColumn: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _3YEZNOdnbC",
    expandedLoaderRow: "_3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _17lj8p2ADO _0hPCNLFlnN _0Of8r22ADO _1wydGWPgdg _2Zuz6Q8HPE _1Znuxb8HPE _24h04i2Njc _0jFU0V9LX5 _0KLXrunmFW _2C2kUQKxmn _1Lz9loKxmn",
    loaderIconColumn: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02oWWg _3YEZNOdnbC _4xdlr0FlnN",
    loaderRuleSlotTop: "_2O5Vij7dHp _39xV02dnbC",
    loaderRuleSlotWithLine: "_3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _2O5Vij7dHp _39xV02dnbC",
    loaderContent: "_2O5Vij7dHp _4ouGXIdnbC _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _17lj8p2ADO"
};
const $1175367593db581d$var$messages = (0, $kSwu1.defineMessages)({
    thinking_deeper: {
        id: "search-ai.smart-answer-card-minimized-loading.thinking-deeper",
        defaultMessage: "Thinking deeper and analyzing your question..."
    },
    expand_answer: {
        id: "search-ai.smart-answer-card-minimized-loading.expand-answer",
        defaultMessage: "Expand answer"
    },
    collapse_answer: {
        id: "search-ai.smart-answer-card-minimized-loading.collapse-answer",
        defaultMessage: "Hide answer"
    }
});
const $1175367593db581d$var$MAX_EXPANDED_STEPS = 2;
function $1175367593db581d$export$2cc326b559e5a3cf({ onExpandClick: onExpandClick, userExpandedDuringLoading: userExpandedDuringLoading = false, commonAttributes: commonAttributes, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { researchSteps: researchSteps } = (0, $3hVWe.useAIAnswerContext)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $kSORO.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleExpandClick = ()=>{
        fireAnalyticsEvent((0, $7ad80c56fa109a71$export$95c4fee0614a7136)(commonAttributes));
        onExpandClick?.();
    };
    const handleCollapseClick = ()=>{
        fireAnalyticsEvent((0, $e2d90c16cb0d52c9$export$db586d8c7b1541e0)(commonAttributes));
        onExpandClick?.();
    };
    const renderableSteps = $1175367593db581d$var$getRenderableSteps(researchSteps); // Expanded view: take the last MAX_EXPANDED_STEPS renderable steps in
    // oldest-first order so the most recent step appears at the bottom.
    const recentStepsForExpanded = renderableSteps.slice(-$1175367593db581d$var$MAX_EXPANDED_STEPS); // The header row contains the MorphingShapeLoader, the shimmer/step text,
    // and the expand/collapse toggle button. This row is rendered in both
    // collapsed and expanded states.
    const headerRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.collapsedRow,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.collapsedLoaderIconColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e5f31f7d389abdf$export$c07a397cf5c24cd8), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        grow: "fill",
        xcss: $1175367593db581d$var$styles.shimmerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14633d638bf89cef$export$f35c7d979dec8662), {
        size: "medium",
        truncate: true
    }, formatMessage($1175367593db581d$var$messages.thinking_deeper))), !userExpandedDuringLoading && renderableSteps.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.buttonPlaceholder,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        spacing: "compact",
        tabIndex: -1,
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
                ...iconProps,
                size: "small"
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($1175367593db581d$var$messages.expand_answer)))) : userExpandedDuringLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        spacing: "compact",
        onClick: handleCollapseClick,
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), {
                ...iconProps,
                size: "small"
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($1175367593db581d$var$messages.collapse_answer))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        spacing: "compact",
        onClick: handleExpandClick,
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
                ...iconProps,
                size: "small"
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($1175367593db581d$var$messages.expand_answer))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3ffN.AnimatedWrapper), null, userExpandedDuringLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, recentStepsForExpanded.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.expandedLoaderRow,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.loaderIconColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.loaderRuleSlotTop
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e5f31f7d389abdf$export$c07a397cf5c24cd8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.loaderRuleSlotWithLine
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.loaderContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.shimmerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14633d638bf89cef$export$f35c7d979dec8662), {
        size: "medium",
        truncate: true
    }, formatMessage($1175367593db581d$var$messages.thinking_deeper))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        spacing: "compact",
        onClick: handleCollapseClick,
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), {
                ...iconProps,
                size: "small"
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($1175367593db581d$var$messages.collapse_answer))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.collapsedRow,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.collapsedLoaderIconColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e5f31f7d389abdf$export$c07a397cf5c24cd8), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        grow: "fill",
        xcss: $1175367593db581d$var$styles.shimmerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14633d638bf89cef$export$f35c7d979dec8662), {
        size: "medium",
        truncate: true
    }, formatMessage($1175367593db581d$var$messages.thinking_deeper))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        spacing: "compact",
        onClick: handleCollapseClick,
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), {
                ...iconProps,
                size: "small"
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($1175367593db581d$var$messages.collapse_answer)))), recentStepsForExpanded.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.expandedContent
    }, recentStepsForExpanded.map((step, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65efb4030898c062$export$f22a8a5ea07141e0), {
            key: step.stepId,
            step: step,
            // loader); bottom connector on all but the last step.
            showTopConnector: true,
            showBottomConnector: index < recentStepsForExpanded.length - 1,
            testId: testId ? `${testId}-step-${step.stepId}` : undefined
        })))) : headerRow);
}


/* smart-answer-ready.tsx generated by @compiled/babel-plugin v3.0.1 */ 


















var $f6cdQ = parcelRequire("f6cdQ");














const $35b517b5dcf10511$var$styles = {
    container: "_0bjKvD8fU6 _0Of8r28HPE _1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _4kiQYAUF4f _24h04i2Njc _0KLXrunmFW",
    answerLabel: "_3YEZNOdnbC",
    containerWithShadow: "_2OUyjtGk8v"
}; // Optical nudge to vertically align the Lozenge text with adjacent body text.
const $35b517b5dcf10511$var$lozengeWrapperStyle = null;
const $35b517b5dcf10511$var$messages = (0, $kSwu1.defineMessages)({
    answer: {
        id: "search-ai.smart-answer-card-minimized-ready.answer",
        defaultMessage: "Answer"
    },
    ready: {
        id: "search-ai.smart-answer-card-minimized-ready.ready",
        defaultMessage: "Ready"
    },
    scroll_up: {
        id: "search-ai.smart-answer-card-minimized-ready.scroll-up",
        defaultMessage: "Scroll up"
    },
    expand_answer: {
        id: "search-ai.smart-answer-card-minimized-ready.expand-answer",
        defaultMessage: "Expand"
    }
});
function $35b517b5dcf10511$export$6219b6e404cffa4a({ onScrollUpClick: onScrollUpClick, onExpandClick: onExpandClick, appearance: appearance, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const resolvedAppearance = appearance ?? (onExpandClick ? 'expand' : 'scrollUp');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100",
        xcss: (0, $w6R6I.cx)($35b517b5dcf10511$var$styles.container, resolvedAppearance === 'scrollUp' && $35b517b5dcf10511$var$styles.containerWithShadow),
        grow: "fill",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $35b517b5dcf10511$var$styles.answerLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
        label: "",
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, formatMessage($35b517b5dcf10511$var$messages.answer)), resolvedAppearance !== 'expand' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _1mT5xdRAKS _2IhTonHZdu"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "success"
    }, formatMessage($35b517b5dcf10511$var$messages.ready)))), resolvedAppearance === 'expand' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onExpandClick,
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), iconProps),
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($35b517b5dcf10511$var$messages.expand_answer))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onScrollUpClick,
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), iconProps),
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($35b517b5dcf10511$var$messages.scroll_up))));
}


const $c6a21b3a2fe9d946$var$MemoizedRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(function MemoizedRenderer({ contentToRender: contentToRender, showAnimation: showAnimation }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c5ac787bcb31d21$export$687d546b0584d31b), {
        key: "stable-renderer",
        markdown: contentToRender,
        animateComponents: showAnimation
    });
});
const $c6a21b3a2fe9d946$var$styles = {
    fullWidth: "_39xV02qUim _1EqgXlN91d _1DCdHi8HPE",
    interactive: "_0wOv4Q7zJH",
    root: "_4kiQYAk3g7",
    fullHeight: "_0jFU0VN91d",
    disclaimer: "_1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r21Y8M",
    followUpChatInputSectionStyles: "_3138425zaO",
    followUpChatInputSectionWithBarStyles: "_3138422ADO",
    disclaimerWrapperStyles: "_1wydGW8HPE _2Zuz6Q5zaO _0Of8r21Y8M _2IVJ4M6wH8 _3zygPU9r67 _22sfPnNvrM",
    sectionContainer: "_1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r21Y8M",
    sourcesTopPadding: "_0Of8r21Y8M",
    linkListContainer: "_313842gVvo",
    nonInteractive: "_1pp6NdYbGa",
    loadingPaddingOverrides: "_2Zuz6Q8HPE _1Znuxb8HPE",
    standardSAINMarginOverrides: "_1DCdHi2ADO"
};
function $c6a21b3a2fe9d946$var$SmartAnswerCardMinimizedComponent({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, onAnswerMinimizedChange: onAnswerMinimizedChange, queryIntent: queryIntent, floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef }) {
    // Tracks whether the user clicked "Expand answer" while the answer was loading
    // Used to decide if the answer should appear in the collapsed or fully expanded state
    // when streaming begins, and is also kept in sync with isAnswerMinimized after loading so the
    // show-more button is hidden when the answer is intentionally expanded.
    // - false (default): user has NOT requested expansion during loading
    // - true: user clicked "Expand answer" during loading
    const [userExpandedDuringLoading, setUserExpandedDuringLoading] = (0, $cozmU.useState)(false); // Tracks whether the answer is currently "minimized" — i.e. the loaded answer is
    // hidden and the SmartAnswerReady component is shown.
    // This is distinct from `userExpandedDuringLoading` which is about the loading-state
    // expand/collapse toggle. While loading this is always false; it only flips to
    // true post-load when the user explicitly hides the answer.
    const [isAnswerMinimized, setIsAnswerMinimized] = (0, $cozmU.useState)(false); // state for whether loaded answer is fully expanded or collapsed
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(true);
    const containerRef = (0, $cozmU.useRef)(null);
    const [didUserTriggerCollapse, setDidUserTriggerCollapse] = (0, $cozmU.useState)(false);
    const [isVisibleTextComplete, setIsVisibleTextComplete] = (0, $cozmU.useState)(false);
    const [showAnimation, setShowAnimation] = (0, $cozmU.useState)(false);
    const componentRenderTimeRef = (0, $cozmU.useRef)(Date.now());
    const firstByteEventFiredRef = (0, $cozmU.useRef)(false);
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { commonAttributes: commonAttributes, hasError: hasError, isAnswered: isAnswered, loading: loading, partialResponse: partialResponse, luminaContentMap: luminaContentMap } = context;
    const { queryHash: queryHash, searchSessionId: searchSessionId, answerString: answerString, sources: sources, errorStateSuggestedQueries: errorStateSuggestedQueries } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const streamingText = partialResponse?.partialNlpResult ?? '';
    const [streamingTextToDisplay, setStreamingTextToDisplay] = (0, $cozmU.useState)(streamingText); // Refs for content truncation detection
    const isVisibleTextCompleteRef = (0, $cozmU.useRef)(false); // Measures only answer text height (excludes sources and chat input) so onReadMoreButtonShown
    // fires only when the text itself is truncated, not due to other content
    const textContentRef = (0, $cozmU.useRef)(null);
    const completeAnswerAnalyticsEventFiredRef = (0, $cozmU.useRef)(false);
    const renderedContentRef = (0, $cozmU.useRef)(null);
    const contentContainerRef = (0, $cozmU.useRef)(null);
    const hasLinksInAnswer = !!(luminaContentMap && Object.keys(luminaContentMap).length > 0) && (0, $iDrrr.fg)('kd_sain_enable_inline_lumina');
    (0, $cozmU.useEffect)(()=>{
        // If streaming stopped but buffered content still exists, clear it to reset the display
        if (!streamingText && streamingTextToDisplay && (0, $iDrrr.fg)('kd_fix_abort_errors')) {
            setStreamingTextToDisplay('');
            setIsVisibleTextComplete(false);
            return;
        }
        if (collapsed && !isVisibleTextComplete) setStreamingTextToDisplay(streamingText);
        else if (!collapsed) setStreamingTextToDisplay(streamingText);
    }, [
        collapsed,
        isVisibleTextComplete,
        streamingText,
        streamingTextToDisplay
    ]); // Notify context when collapsed state changes
    (0, $cozmU.useEffect)(()=>{
        onAnswerExpandedChange?.(!collapsed);
    }, [
        collapsed,
        onAnswerExpandedChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError && !isVisibleTextComplete) {
            setIsVisibleTextComplete(true);
            onFMPReached?.(); // Mark FMP as reached for cached answers
        }
    }, [
        loading,
        hasError,
        isVisibleTextComplete,
        onFMPReached
    ]); // Track if we should show animations (if loading or partialResponse are true)
    (0, $cozmU.useEffect)(()=>{
        if (!showAnimation && loading && partialResponse) setShowAnimation(true);
        if (loading && !partialResponse && showAnimation && (0, $iDrrr.fg)('kd_fix_abort_errors')) {
            setShowAnimation(false);
            firstByteEventFiredRef.current = false;
            completeAnswerAnalyticsEventFiredRef.current = false;
        }
    }, [
        loading,
        partialResponse,
        showAnimation
    ]); // use useEffect to trigger analytics event in order to avoid needing to
    // pass commonAttributes as a dependency to handleExpandCollapseButtonClick
    // and thus avoid re-rendering SmartAnswerCardBodyStreaming with every
    // update to commonAttributes (which gets updated with the streamed text)
    (0, $cozmU.useEffect)(()=>{
        if (didUserTriggerCollapse) fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes));
    }, [
        didUserTriggerCollapse,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Detect if content is truncated when collapsed
    const isContentTruncated = (0, $6df3d09e09b61b24$export$d112da4490f261ea)(renderedContentRef, contentContainerRef, collapsed, [
        streamingText
    ]);
    const isTextTruncated = (0, $6df3d09e09b61b24$export$d112da4490f261ea)(textContentRef, contentContainerRef, collapsed, [
        streamingText
    ]); // Complete answer analytics
    (0, $cozmU.useEffect)(()=>{
        // Only fire once and ensure DOM element is ready with meaningful content
        if (completeAnswerAnalyticsEventFiredRef.current || !renderedContentRef.current) return;
        const answerHeight = renderedContentRef.current.getBoundingClientRect().height;
        const containerHeight = contentContainerRef.current?.getBoundingClientRect().height ?? 0;
        const whitespaceHeight = Math.max(containerHeight - answerHeight, 0); // Only fire if we have meaningful height (content is rendered)
        if (answerHeight > 0 && containerHeight > 0) {
            fireAnalyticsEvent((0, $d58a262274d16c7a$export$f3109245f09f7746)({
                ...commonAttributes,
                answerHeight: answerHeight,
                containerHeight: containerHeight,
                whitespaceHeight: whitespaceHeight,
                queryIntent: queryIntent
            }));
            completeAnswerAnalyticsEventFiredRef.current = true;
        }
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        queryIntent,
        isContentTruncated
    ]); // SAIN usage event
    (0, $cozmU.useEffect)(()=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Callback bound to the expand/collapse buttons in SmartAnswerCardMinimizedLoading.
    // Only toggles `userExpandedDuringLoading`; never sets `isAnswerMinimized` (which is only
    // used for the post-load minimize flow). Tracks whether the user has requested expansion
    // during loading.
    const handleFoldAnswerButtonClick = (0, $cozmU.useCallback)(()=>{
        setUserExpandedDuringLoading((prev)=>!prev);
    }, []); // Tracks whether the answer card is currently within the viewport
    // Used to decide whether to render the SmartAnswerReady component at the top of the search
    // results when the user has scrolled the answer card out of view.
    const [isCardInViewport, setIsCardInViewport] = (0, $cozmU.useState)(true); // Scrolls the answer card back into view and expands it fully.
    // Resets isAnswerMinimized so the answer is un-minimized, and sets
    // userExpandedDuringLoading=true so the in-flow card renders fully expanded.
    const handleScrollUpClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $57ae65a71649f2c5$export$7f9024bb8c6bf2c3)(commonAttributes));
        setIsAnswerMinimized(false);
        setUserExpandedDuringLoading(true);
        setCollapsed(false);
        const node = containerRef.current;
        if (!node) return;
         // The "Scroll up" button only appears on the floating banner, which is only
        // rendered when the card is scrolled out of view (isCardInViewport === false).
        // So reaching this handler means the card is effectively out of view (or hidden
        // behind the fixed banner) and we should always scroll it back to the top.
        //
        // We intentionally avoid an isOutOfViewport short-circuit here: the previous
        // `rect.bottom <= 0` guard failed the edge case where the card's bottom edge
        // sits a few pixels below the viewport top (positive rect.bottom) but the card
        // is still visually hidden behind the fixed floating banner — in that case the
        // guard skipped the scroll and the user was never taken back to the answer.
        node.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }, [
        commonAttributes,
        fireAnalyticsEvent
    ]); // Notify parent (ai-answer-dialog) whenever the "answer minimized" state changes
    // so dwell tracking can be gated on whether the user can actually see the answer.
    (0, $cozmU.useEffect)(()=>{
        onAnswerMinimizedChange?.(isAnswerMinimized);
    }, [
        isAnswerMinimized,
        onAnswerMinimizedChange
    ]); // Toggles the answer minimized state for the "Hide answer" and in-flow "Expand"
    // buttons. `minimized=true` hides the answer behind the SmartAnswerReady component;
    // `minimized=false` re-shows the answer in fully expanded form. Also resets the
    // loading-time expand state so visual states stay in sync.
    const handleAnswerHiddenToggle = (0, $cozmU.useCallback)((minimized)=>{
        if (minimized) fireAnalyticsEvent((0, $619bd3e23d17df21$export$816a5214860a0c40)(commonAttributes));
        else fireAnalyticsEvent((0, $57db223fb661d84a$export$b19cbf041d35e6cc)(commonAttributes));
        setIsAnswerMinimized(minimized); // userExpandedDuringLoading mirrors the inverse — minimized=true means the user
        // has NOT expanded; minimized=false means they have explicitly expanded.
        setUserExpandedDuringLoading(!minimized);
        setCollapsed(minimized);
    }, [
        commonAttributes,
        fireAnalyticsEvent
    ]); // callback to expand/collapse loaded answer
    const handleExpandCollapseButtonClick = (0, $cozmU.useCallback)(()=>{
        if (collapsed) {
            setCollapsed(false);
            setDidUserTriggerCollapse(false);
        } else {
            setCollapsed(true);
            setDidUserTriggerCollapse(true);
        }
    }, [
        collapsed
    ]);
    const handleVisibleTextComplete = (0, $cozmU.useCallback)(()=>{
        setIsVisibleTextComplete(true);
        onFMPReached?.(); // Mark FMP as reached for streaming answers
    }, [
        onFMPReached
    ]);
    const handleContainerClick = (0, $cozmU.useCallback)((event)=>{
        const selection = window.getSelection()?.toString() ?? ''; // Highlighting text should not expand the card
        const hasHighlightedText = selection.length > 0; // Clicking in a feedback modal or flag should not expand the card
        const isClickingOnContainer = containerRef.current?.contains(event.target) ?? false;
        if (collapsed && !hasHighlightedText && isClickingOnContainer) {
            setCollapsed(false); // Clicking anywhere in the container while loading is treated the same as
            // clicking "Expand answer" — so the show more button hides for the rest of
            // the streaming session.
            setUserExpandedDuringLoading(true);
            fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
                commonAttributes: commonAttributes
            });
        }
    }, [
        collapsed,
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent
    ]);
    const { handleSmartCardClick: handleSmartCardClick } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context
    }); // UFO resize observer for streaming
    const resizeObserverCallback = (0, $cozmU.useCallback)(()=>{
        if (!isVisibleTextCompleteRef.current && renderedContentRef.current && contentContainerRef.current && !!streamingTextToDisplay) {
            const renderedContentRefHeight = renderedContentRef.current.getBoundingClientRect().height;
            const contentContainerRefHeight = contentContainerRef.current.getBoundingClientRect().height;
            const isVisibleTextComplete = renderedContentRefHeight > contentContainerRefHeight;
            if (isVisibleTextComplete) {
                handleVisibleTextComplete();
                isVisibleTextCompleteRef.current = true;
            }
        }
    }, [
        handleVisibleTextComplete,
        streamingTextToDisplay
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1dee242400437624$export$fd29db098e42c3fc)(renderedContentRef, resizeObserverCallback, 100, [
        streamingTextToDisplay
    ]);
    const bufferedContent = (0, $d3e29575f8ad4c54$export$8f4f0a9c358684c2)(streamingTextToDisplay, isAnswered && !loading); // If the user clicked "Expand answer" during loading, show the answer uncollapsed
    // as soon as streaming begins (bufferedContent has content) and keep it uncollapsed when done.
    (0, $cozmU.useEffect)(()=>{
        if (userExpandedDuringLoading && bufferedContent.length > 0) setCollapsed(false);
    }, [
        userExpandedDuringLoading,
        bufferedContent
    ]); // Track whether the answer is in the viewport so we can render
    // SmartAnswerReady when the user has scrolled past the answer card.
    // Do not show SmartAnswerReady if the user has already seen the answer
    // in expanded state.
    (0, $cozmU.useEffect)(()=>{
        if (!isAnswered || hasError || isAnswerMinimized) return;
        if (!containerRef.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setIsCardInViewport(entry.isIntersecting);
            });
        }, {
            threshold: 0
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isAnswered,
        hasError,
        isAnswerMinimized
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (bufferedContent.length > 0 && !firstByteEventFiredRef.current) {
            fireAnalyticsEvent((0, $bd6e42147a6848a8$export$c68095583a3c17cc)({
                ...commonAttributes,
                timeToFirstByte: Date.now() - componentRenderTimeRef.current
            }));
            firstByteEventFiredRef.current = true;
        }
    }, [
        bufferedContent,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Use answerString when complete, bufferedContent when streaming
    const contentToRender = isAnswered ? answerString : bufferedContent; // Experiments
    const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    });
    const showReadMoreButton = collapsed && isContentTruncated; // Single return statement with React component for main content
    const isStreaming = !isAnswered && (loading || loading === undefined); // Early return for error state
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c6a21b3a2fe9d946$var$styles.fullWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f366b75433df2895$export$ffa24cd7196ce1b0), null));
     // Early return for generating state
    if (!isAnswered && (loading || loading === undefined)) {
        if (!partialResponse || bufferedContent.length < 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "search-ai-dialog-all-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "search-ai-dialog-all-text-loading",
            hold: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "search-ai-dialog-visible-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "search-ai-dialog-visible-text-loading",
            hold: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1175367593db581d$export$2cc326b559e5a3cf), {
            onExpandClick: handleFoldAnswerButtonClick,
            userExpandedDuringLoading: userExpandedDuringLoading,
            commonAttributes: commonAttributes
        })));
    } // When the user has minimized the answer (clicked "Hide answer" on the loaded card),
    // render the SmartAnswerReady component in place of the full answer.
    if (isAnswerMinimized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35b517b5dcf10511$export$6219b6e404cffa4a), {
        onExpandClick: ()=>handleAnswerHiddenToggle(false)
    });
     // Render SmartAnswerReady at the top of the search results when:
    // - the answer has finished loading and is not in an error/no-answer state
    // - the answer card is currently scrolled out of the viewport
    // - the answer is currently in its collapsed state
    // - do not render if user expanded then collapsed answer
    const notifySmartAnswerReady = isAnswered && !hasError && !isCardInViewport && collapsed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($c6a21b3a2fe9d946$var$styles.fullWidth, ((0, $iDrrr.fg)('kd_team_26_sain_borderless_update') || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled()) && $c6a21b3a2fe9d946$var$styles.loadingPaddingOverrides),
        testId: "smart-answer-card-minimized"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog-all-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "search-ai-dialog-all-text-loading",
        hold: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog-visible-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "search-ai-dialog-visible-text-loading",
        hold: !isVisibleTextComplete
    }), (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "queryHash",
        value: queryHash
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "searchSessionId",
        value: searchSessionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "queryIntent",
        value: queryIntent
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            queryIntent: queryIntent
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c6a21b3a2fe9d946$var$SmartAnswerCardMinimizedContent, {
        isStreaming: isStreaming,
        collapsed: collapsed,
        showReadMoreButton: showReadMoreButton,
        handleExpandCollapseButtonClick: handleExpandCollapseButtonClick,
        onHideAnswer: ()=>handleAnswerHiddenToggle(true),
        contentContainerRef: contentContainerRef,
        renderedContentRef: renderedContentRef,
        textContentRef: textContentRef,
        isTextTruncated: isTextTruncated,
        sources: sources,
        searchSessionId: searchSessionId,
        sourceClickCallback: handleSmartCardClick,
        errorStateSuggestedQueries: errorStateSuggestedQueries,
        serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp,
        commonAttributes: commonAttributes,
        contentToRender: contentToRender,
        showAnimation: showAnimation,
        handleContainerClick: handleContainerClick,
        containerRef: containerRef,
        hasLinksInAnswer: hasLinksInAnswer,
        userExpandedDuringLoading: userExpandedDuringLoading
    })))), notifySmartAnswerReady && floatingSmartAnswerReadyPortalRef?.current && /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35b517b5dcf10511$export$6219b6e404cffa4a), {
        appearance: "scrollUp",
        onScrollUpClick: handleScrollUpClick,
        testId: "smart-answer-ready-floating"
    }), floatingSmartAnswerReadyPortalRef.current));
}
function $c6a21b3a2fe9d946$var$SmartAnswerCardMinimizedContent({ isStreaming: isStreaming, collapsed: collapsed, showReadMoreButton: showReadMoreButton, handleExpandCollapseButtonClick: handleExpandCollapseButtonClick, contentContainerRef: contentContainerRef, renderedContentRef: renderedContentRef, textContentRef: textContentRef, isTextTruncated: isTextTruncated, sources: sources, searchSessionId: searchSessionId, sourceClickCallback: sourceClickCallback, errorStateSuggestedQueries: errorStateSuggestedQueries, serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp, commonAttributes: commonAttributes, contentToRender: contentToRender, showAnimation: showAnimation, onHideAnswer: onHideAnswer, handleContainerClick: handleContainerClick, containerRef: containerRef, hasLinksInAnswer: hasLinksInAnswer, userExpandedDuringLoading: userExpandedDuringLoading }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { authorityUiMetadata: authorityUiMetadata } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, queryHash: queryHash, extraAttributes: extraAttributes, source: source } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const isHighlyAuthoritative = (0, $iDrrr.fg)('rovo_authoritative_answer_attribution') && !!authorityUiMetadata?.isHighlyAuthoritative;
    const handleAuthorityPanelShown = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $fhQlP.buildAuthoritativeAnswerPanelShownEvent)({
            product: 'sain',
            source: source,
            correlationAttributes: {
                cloudId: cloudId,
                searchSessionId: searchSessionId,
                queryHash: queryHash,
                traceId: extraAttributes?.requestId
            },
            authorityUiMetadata: authorityUiMetadata
        }));
    }, [
        fireAnalyticsEvent,
        source,
        cloudId,
        searchSessionId,
        queryHash,
        extraAttributes?.requestId,
        authorityUiMetadata
    ]);
    const fireAuthorityLinkClick = (0, $cozmU.useCallback)((linkType)=>{
        fireAnalyticsEvent((0, $a7fd7127c63cb2fc$export$5671a2e254c14222)({
            ...commonAttributes,
            linkType: linkType,
            authorityUiMetadata: authorityUiMetadata
        })); // Credits the click towards SAIN's success metric (SSRv5).
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes
        });
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        authorityUiMetadata,
        fireSAINUsageEvent
    ]);
    const isBorderlessUX = (0, $iDrrr.fg)('kd_team_26_sain_borderless_update') || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled(); // URL patterns for sources known not to resolve as rich smart cards.
    const UNRESOLVABLE_URL_PATTERNS = [
        'viewpageattachments.action'
    ];
    const isUnresolvableSource = (url)=>UNRESOLVABLE_URL_PATTERNS.some((pattern)=>url.includes(pattern)); // Filter sources whose URLs are known not to resolve as rich smart cards.
    // Uses URL pattern matching since the NlpSearchResultType enum does not include 'attachment'.
    // https://switcheroo.atlassian.com/ui/gates/f309f0ca-53a0-4c56-9767-fec898813e99/key/kd_sain_filter_attachment_sources
    const filteredSources = (0, $iDrrr.fg)('kd_sain_filter_attachment_sources') ? sources.filter((source)=>!isUnresolvableSource(source.url)) : sources;
    const sourcesSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, !isStreaming && filteredSources.length > 0 && (0, $7DMz5.SAINFeatureControl).isSourcesInShortSAINAnswersEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($c6a21b3a2fe9d946$var$styles.sourcesTopPadding, collapsed && $c6a21b3a2fe9d946$var$styles.nonInteractive)
    }, (0, $7DMz5.SAINFeatureControl).isLinkListSourcesEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $c6a21b3a2fe9d946$var$styles.linkListContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).related_links_title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Luzz.LinkList), {
        urls: filteredSources.map((source)=>source.url),
        maxSources: 5,
        showExpand: false,
        onLinkClick: (url, index, opts)=>{
            const source = filteredSources[index];
            if (source) sourceClickCallback({
                index: index,
                source: source,
                hostname: (0, $736ac3075308471f$export$a3b7216c107a7a1)(url),
                sourceCardType: 'link-list',
                isAuxClick: opts?.isAuxClick,
                isContextMenu: opts?.isContextMenu
            });
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ce789c5dd436d96e$export$919320f9832aec1d), {
        sources: filteredSources,
        searchSessionId: searchSessionId,
        onClickHandler: sourceClickCallback
    })));
    const handleContainerKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (collapsed && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            handleContainerClick(event);
        }
    }, [
        collapsed,
        handleContainerClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(collapsed ? $c6a21b3a2fe9d946$var$styles.interactive : undefined, isBorderlessUX && $c6a21b3a2fe9d946$var$styles.standardSAINMarginOverrides),
        onClick: handleContainerClick,
        onKeyDown: collapsed ? handleContainerKeyDown : undefined,
        tabIndex: collapsed ? 0 : undefined,
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: isStreaming && !isBorderlessUX ? $c6a21b3a2fe9d946$var$styles.root : $c6a21b3a2fe9d946$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: $c6a21b3a2fe9d946$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4217877a0025dc35$export$127e64693c41156a), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            spread: "space-between",
            alignBlock: "center",
            grow: "fill",
            xcss: (0, $w6R6I.cx)(((0, $iDrrr.fg)('kd_team_26_sain_borderless_update') || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled()) && $c6a21b3a2fe9d946$var$styles.standardSAINMarginOverrides)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050",
            shouldWrap: true
        }, isHighlyAuthoritative && authorityUiMetadata ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
            label: "",
            size: "medium",
            color: "var(--ds-icon-success, #6A9A23)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Zool.AuthoritativeAnswerAttribution), {
            sources: authorityUiMetadata.sources ?? [],
            domainExperts: authorityUiMetadata.domainExperts ?? [],
            overallReasoning: authorityUiMetadata.overallReasoning,
            labelVariant: "answer",
            cloudId: cloudId,
            surface: "sain",
            // use the taller panel to avoid cramping the feedback form.
            panelSize: "tall",
            onPanelOpen: handleAuthorityPanelShown,
            onSourceClick: ()=>fireAuthorityLinkClick('source'),
            onExpertClick: ()=>fireAuthorityLinkClick('expert'),
            onFeedbackSubmit: (submission)=>{
                // Submit authority-answer feedback to the Feedback Collector API
                // using SAIN's existing entrypoint (same destination as SAIN's
                // footer feedback). Analytics wiring is handled separately.
                (0, $1V59x.submitAuthorityFeedback)({
                    submission: submission,
                    entrypointId: (0, $1V59x.FEEDBACK_ENTRYPOINT_ID_SAIN),
                    origin: (0, $1V59x.AUTHORITY_FEEDBACK_ORIGIN_SAIN),
                    cloudId: cloudId,
                    debugAttributes: {
                        traceId: extraAttributes?.requestId,
                        searchSessionId: searchSessionId,
                        queryHash: queryHash
                    }
                });
            }
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
            label: "AI Content",
            size: "medium"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h1",
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).smart_answer_card_title)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, !collapsed && !isStreaming && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            spacing: "compact",
            appearance: "subtle",
            onClick: onHideAnswer,
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), {
                    ...iconProps,
                    size: "small"
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, formatMessage((0, $24oKg.messages).hide_answer))))),
        isCollapsed: collapsed,
        onExpandCollapse: handleExpandCollapseButtonClick,
        ref: contentContainerRef,
        showReadMoreButton: isBorderlessUX ? collapsed : showReadMoreButton,
        luminaAnswerType: (0, $iDrrr.fg)('kd_team_26_sain_borderless_update') || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? 'STANDARD' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: renderedContentRef,
        id: "ai-answer-result-section",
        testId: "sain-fmp-target"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: textContentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c6a21b3a2fe9d946$var$MemoizedRenderer, {
        contentToRender: contentToRender,
        showAnimation: showAnimation
    })))), !hasLinksInAnswer && sourcesSection)), showReadMoreButton && !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ed12dd693731600a$export$e68719f9c8487320), {
        onClick: handleExpandCollapseButtonClick
    }), (collapsed || showReadMoreButton || isStreaming) && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f420039341622608$export$8a1fad5d74d43878), {
        isStreaming: isStreaming,
        showMoreButtonVisible: collapsed || isStreaming && !userExpandedDuringLoading,
        fireShownEvent: isTextTruncated,
        onClickShowMoreButton: handleExpandCollapseButtonClick
    })), !isStreaming && !collapsed && sources.length > 0 && !(0, $7DMz5.SAINFeatureControl).isSourcesInShortSAINAnswersEnabled() && !hasLinksInAnswer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c6a21b3a2fe9d946$var$styles.sectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ce789c5dd436d96e$export$919320f9832aec1d), {
        sources: sources,
        searchSessionId: searchSessionId,
        onClickHandler: sourceClickCallback
    })), (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && !isStreaming && !collapsed && sources.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c6a21b3a2fe9d946$var$styles.followUpChatInputSectionWithBarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe4d4049968826dc$export$7552c1f78575b57c), {
        renderTrigger: (onToggle, triggerRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7fd6a1524e779285$export$e754cddb4d3a7903), {
                sources: sources,
                numSources: sources.length,
                onClick: onToggle,
                triggerRef: triggerRef
            })
    })), !collapsed && !showReadMoreButton && !isStreaming && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $c6a21b3a2fe9d946$var$styles.followUpChatInputSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a921764ae1a692a7$export$f087ce3403d54eb5), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j8bJ5.OpenChatInputBox), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c6a21b3a2fe9d946$var$styles.disclaimerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: !isStreaming,
        showCopyButton: false,
        renderedContentRef: renderedContentRef
    }))), !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c6a21b3a2fe9d946$var$styles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: !isStreaming,
        showCopyButton: !isStreaming,
        renderedContentRef: renderedContentRef
    }))), !isStreaming && !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && (!collapsed || errorStateSuggestedQueries.length > 0 && serveErrorStateSuggestedQueriesExp) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34e9b06075b84401$export$3553ee90c7edebc9), {
        showOpenChat: true
    }) : null));
}
function $c6a21b3a2fe9d946$export$2b53936d5706be63({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, onAnswerMinimizedChange: onAnswerMinimizedChange, queryIntent: queryIntent, floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "smart-answer-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c6a21b3a2fe9d946$var$SmartAnswerCardMinimizedComponent, {
        onFMPReached: onFMPReached,
        onAnswerExpandedChange: onAnswerExpandedChange,
        onAnswerMinimizedChange: onAnswerMinimizedChange,
        queryIntent: queryIntent,
        floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef
    }));
}


/* smart-answer-card-consolidated.tsx generated by @compiled/babel-plugin v3.0.1 */ 

































































































































/* smart-answer-card-minimized-loading-v2.tsx generated by @compiled/babel-plugin v3.0.1 */ 

































const $cb359678c785e7d4$var$getRenderableSteps = (steps)=>{
    if (!steps) return [];
    return Object.values(steps).filter((s)=>!!s.title).sort((a, b)=>a.order - b.order);
};
const $cb359678c785e7d4$var$styles = {
    container: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc _0KLXrunmFW _0jFU0VqfN2",
    shimmerWrapper: "_2O5Vij7dHp _4ouGXIdnbC",
    expandedContent: "_2O5Vij7dHp _4kiQYAdnbC _0Of8r2Pgdg _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE",
    skeletonPlaceholder: "_2O5Vij7dHp _4kiQYAdnbC _3iDTPbQ4SZ _0aFT5v1qpb _17lj8p2ADO _0Of8r2Pgdg _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE",
    skeletonLines: "_2O5Vij7dHp _4ouGXIdnbC",
    collapsedRow: "_3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _17lj8p2ADO _0hPCNLDIqT _0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _24h04i2Njc _0jFU0V9LX5 _3YEZNOdnbC",
    collapsedLoaderIconColumn: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _3YEZNOdnbC",
    expandedLoaderRow: "_3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _17lj8p2ADO _0hPCNLFlnN _0Of8r22ADO _1wydGWPgdg _2Zuz6Q8HPE _1Znuxb8HPE _24h04i2Njc _0jFU0V9LX5 _3YEZNOdnbC",
    loaderIconColumn: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02oWWg _3YEZNOdnbC _4xdlr0FlnN",
    loaderRuleSlotTop: "_2O5Vij7dHp _39xV02dnbC",
    loaderRuleSlotWithLine: "_3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _2O5Vij7dHp _39xV02dnbC _1bHrqE2ADO",
    loaderContent: "_2O5Vij7dHp _4ouGXIdnbC _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _17lj8p2ADO _1wydGW2ADO"
};
const $cb359678c785e7d4$var$messages = (0, $kSwu1.defineMessages)({
    thinking_deeper: {
        id: "search-ai.smart-answer-card-minimized-loading.thinking-deeper",
        defaultMessage: "Thinking deeper and analyzing your question..."
    }
});
const $cb359678c785e7d4$var$MAX_EXPANDED_STEPS = 2;
const $cb359678c785e7d4$var$SKELETON_HEIGHT_LINE = '16px';
const $cb359678c785e7d4$var$SKELETON_BORDER_RADIUS = "var(--ds-radius-medium, 6px)"; /**
                                                                * Placeholder skeleton lines shown beneath the header row while there are no
                                                                * research steps yet, so the (fixed-height) loading card doesn't read as a large
                                                                * empty box. Mirrors the borderless UX skeleton in `smart-answer-card-body-generating`
                                                                * (two full-width lines + one 75% line).
                                                                */ 
const $cb359678c785e7d4$var$skeletonLines = [
    {
        width: '100%',
        height: $cb359678c785e7d4$var$SKELETON_HEIGHT_LINE
    },
    {
        width: '100%',
        height: $cb359678c785e7d4$var$SKELETON_HEIGHT_LINE
    },
    {
        width: '75%',
        height: $cb359678c785e7d4$var$SKELETON_HEIGHT_LINE
    }
]; /**
     * Entrance animation for a research step. Fades in with a small upward slide.
     * Because each step row is keyed by `stepId`, only a newly-mounted step runs
     * this mount animation — a surviving step that merely shifts position in the
     * rolling window keeps its DOM node and does NOT re-animate.
     */ 
const $cb359678c785e7d4$var$stepEnterKeyframes = null;
const $cb359678c785e7d4$var$stepEnterStyles = null;
function $cb359678c785e7d4$export$89ba1a078457ae7b({ commonAttributes: commonAttributes, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { researchSteps: researchSteps } = (0, $3hVWe.useAIAnswerContext)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $kSORO.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderableSteps = $cb359678c785e7d4$var$getRenderableSteps(researchSteps); // Take the last MAX_EXPANDED_STEPS renderable steps in oldest-first order so
    // the most recent step appears at the bottom.
    const recentStepsForExpanded = renderableSteps.slice(-$cb359678c785e7d4$var$MAX_EXPANDED_STEPS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3ffN.AnimatedWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.container
    }, recentStepsForExpanded.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.expandedLoaderRow,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.loaderIconColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.loaderRuleSlotTop
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e5f31f7d389abdf$export$c07a397cf5c24cd8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.loaderRuleSlotWithLine
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.loaderContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.shimmerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14633d638bf89cef$export$f35c7d979dec8662), {
        size: "medium",
        truncate: true
    }, formatMessage($cb359678c785e7d4$var$messages.thinking_deeper))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.collapsedRow,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.collapsedLoaderIconColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e5f31f7d389abdf$export$c07a397cf5c24cd8), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        grow: "fill",
        xcss: $cb359678c785e7d4$var$styles.shimmerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14633d638bf89cef$export$f35c7d979dec8662), {
        size: "medium",
        truncate: true
    }, formatMessage($cb359678c785e7d4$var$messages.thinking_deeper)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.skeletonPlaceholder,
        testId: testId ? `${testId}-skeleton` : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.collapsedLoaderIconColumn
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $cb359678c785e7d4$var$styles.skeletonLines,
        space: "space.200"
    }, $cb359678c785e7d4$var$skeletonLines.map((line, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            key: index,
            width: line.width,
            height: line.height,
            color: "var(--ds-skeleton-subtle, #17171708)",
            borderRadius: $cb359678c785e7d4$var$SKELETON_BORDER_RADIUS
        }))))), recentStepsForExpanded.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.expandedContent
    }, recentStepsForExpanded.map((step, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: step.stepId,
            className: (0, $hekY6.default)([
                "_1gBibym8DQ _0nFVCGDsjo _43vdfT1fFG _3Y6bKpZSoF _39Ohv4YbGa"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65efb4030898c062$export$f22a8a5ea07141e0), {
            step: step,
            // loader); bottom connector on all but the last step.
            showTopConnector: true,
            showBottomConnector: index < recentStepsForExpanded.length - 1,
            testId: testId ? `${testId}-step-${step.stepId}` : undefined
        }))))));
}



const $fd49c31ba41c686c$var$MemoizedRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(function MemoizedRenderer({ contentToRender: contentToRender, showAnimation: showAnimation }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c5ac787bcb31d21$export$687d546b0584d31b), {
        key: "stable-renderer",
        markdown: contentToRender,
        animateComponents: showAnimation
    });
});
const $fd49c31ba41c686c$var$styles = {
    fullWidth: "_39xV02qUim _1EqgXlN91d _1DCdHi8HPE",
    interactive: "_0wOv4Q7zJH",
    root: "_4kiQYAk3g7",
    fullHeight: "_0jFU0VN91d",
    disclaimer: "_1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r21Y8M",
    followUpChatInputSectionStyles: "_3138425zaO",
    followUpChatInputSectionWithBarStyles: "_3138422ADO",
    disclaimerWrapperStyles: "_1wydGW8HPE _2Zuz6Q5zaO _0Of8r21Y8M _2IVJ4M6wH8 _3zygPU9r67 _22sfPnNvrM",
    sectionContainer: "_1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r21Y8M",
    sourcesTopPadding: "_0Of8r21Y8M",
    linkListContainer: "_313842gVvo",
    nonInteractive: "_1pp6NdYbGa",
    loadingPaddingOverrides: "_2Zuz6Q8HPE _1Znuxb8HPE",
    standardSAINMarginOverrides: "_1DCdHi2ADO"
};
function $fd49c31ba41c686c$var$SmartAnswerCardConsolidatedComponent({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent, onAnswerMinimizedChange: onAnswerMinimizedChange, floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef }) {
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(true); // Tracks whether the answer is currently "minimized" — i.e. the loaded answer
    // is hidden and the SmartAnswerReady component is shown in its place. Only
    // flips to true post-load when the user explicitly hides the answer.
    const [isAnswerMinimized, setIsAnswerMinimized] = (0, $cozmU.useState)(false);
    const containerRef = (0, $cozmU.useRef)(null);
    const [didUserTriggerCollapse, setDidUserTriggerCollapse] = (0, $cozmU.useState)(false);
    const [isVisibleTextComplete, setIsVisibleTextComplete] = (0, $cozmU.useState)(false);
    const [showAnimation, setShowAnimation] = (0, $cozmU.useState)(false); // Tracks whether the answer card is currently within the viewport.
    // Used to decide whether to render the SmartAnswerReady banner at the top of the
    // search results when the user has scrolled the answer card out of view.
    const [isCardInViewport, setIsCardInViewport] = (0, $cozmU.useState)(true);
    const componentRenderTimeRef = (0, $cozmU.useRef)(Date.now());
    const firstByteEventFiredRef = (0, $cozmU.useRef)(false);
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { commonAttributes: commonAttributes, hasError: hasError, isAnswered: isAnswered, loading: loading, partialResponse: partialResponse, luminaContentMap: luminaContentMap } = context;
    const { queryHash: queryHash, searchSessionId: searchSessionId, answerString: answerString, sources: sources, errorStateSuggestedQueries: errorStateSuggestedQueries } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const streamingText = partialResponse?.partialNlpResult ?? '';
    const [streamingTextToDisplay, setStreamingTextToDisplay] = (0, $cozmU.useState)(streamingText); // Refs for content truncation detection
    const isVisibleTextCompleteRef = (0, $cozmU.useRef)(false);
    const visibleTextCompletionRecordedRef = (0, $cozmU.useRef)(false);
    const [visibleTextCompletionData, setVisibleTextCompletionData] = (0, $cozmU.useState)(null);
    const contentToRenderRef = (0, $cozmU.useRef)('');
    const visibleTextEverStreamedRef = (0, $cozmU.useRef)(false); // Measures only answer text height (excludes sources and chat input) so onReadMoreButtonShown
    // fires only when the text itself is truncated, not due to other content
    const textContentRef = (0, $cozmU.useRef)(null);
    const completeAnswerAnalyticsEventFiredRef = (0, $cozmU.useRef)(false);
    const renderedContentRef = (0, $cozmU.useRef)(null);
    const contentContainerRef = (0, $cozmU.useRef)(null);
    const hasLinksInAnswer = !!(luminaContentMap && Object.keys(luminaContentMap).length > 0) && (0, $iDrrr.fg)('kd_sain_enable_inline_lumina');
    const recordVisibleTextCompletion = (0, $cozmU.useCallback)((source)=>{
        if (visibleTextCompletionRecordedRef.current) return;
        visibleTextCompletionRecordedRef.current = true;
        setVisibleTextCompletionData({
            visibleTextCompletionSource: source,
            visibleTextCompletionMs: Date.now() - componentRenderTimeRef.current,
            visibleTextDisplayedLength: contentToRenderRef.current.length,
            visibleTextEverStreamed: visibleTextEverStreamedRef.current
        });
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!visibleTextEverStreamedRef.current && (loading || partialResponse)) visibleTextEverStreamedRef.current = true;
    }, [
        loading,
        partialResponse
    ]);
    const bufferedContent = (0, $d3e29575f8ad4c54$export$8f4f0a9c358684c2)(streamingTextToDisplay, isAnswered && !loading);
    const contentToRender = isAnswered ? answerString : bufferedContent;
    (0, $cozmU.useEffect)(()=>{
        contentToRenderRef.current = contentToRender;
    }, [
        contentToRender
    ]);
    (0, $cozmU.useEffect)(()=>{
        // If streaming stopped but buffered content still exists, clear it to reset the display
        if (!streamingText && streamingTextToDisplay && (0, $iDrrr.fg)('kd_fix_abort_errors')) {
            setStreamingTextToDisplay('');
            setIsVisibleTextComplete(false);
            return;
        }
        if (collapsed && !isVisibleTextComplete) setStreamingTextToDisplay(streamingText);
        else if (!collapsed) setStreamingTextToDisplay(streamingText);
    }, [
        collapsed,
        isVisibleTextComplete,
        streamingText,
        streamingTextToDisplay
    ]); // Notify context when collapsed state changes
    (0, $cozmU.useEffect)(()=>{
        onAnswerExpandedChange?.(!collapsed);
    }, [
        collapsed,
        onAnswerExpandedChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError && !isVisibleTextComplete) {
            recordVisibleTextCompletion('loading-complete');
            setIsVisibleTextComplete(true);
            onFMPReached?.(); // Mark FMP as reached for cached answers
        }
    }, [
        loading,
        hasError,
        isVisibleTextComplete,
        onFMPReached,
        recordVisibleTextCompletion
    ]); // Track if we should show animations (if loading or partialResponse are true)
    (0, $cozmU.useEffect)(()=>{
        if (!showAnimation && loading && partialResponse) setShowAnimation(true);
        if (loading && !partialResponse && showAnimation && (0, $iDrrr.fg)('kd_fix_abort_errors')) {
            setShowAnimation(false);
            firstByteEventFiredRef.current = false;
            completeAnswerAnalyticsEventFiredRef.current = false;
        }
    }, [
        loading,
        partialResponse,
        showAnimation
    ]); // use useEffect to trigger analytics event in order to avoid needing to
    // pass commonAttributes as a dependency to handleExpandCollapseButtonClick
    // and thus avoid re-rendering SmartAnswerCardBodyStreaming with every
    // update to commonAttributes (which gets updated with the streamed text)
    (0, $cozmU.useEffect)(()=>{
        if (didUserTriggerCollapse) fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes));
    }, [
        didUserTriggerCollapse,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Detect if content is truncated when collapsed
    const isContentTruncated = (0, $6df3d09e09b61b24$export$d112da4490f261ea)(renderedContentRef, contentContainerRef, collapsed, [
        streamingText
    ]);
    const isTextTruncated = (0, $6df3d09e09b61b24$export$d112da4490f261ea)(textContentRef, contentContainerRef, collapsed, [
        streamingText
    ]); // Complete answer analytics
    (0, $cozmU.useEffect)(()=>{
        // Only fire once and ensure DOM element is ready with meaningful content
        if (completeAnswerAnalyticsEventFiredRef.current || !renderedContentRef.current) return;
        const answerHeight = renderedContentRef.current.getBoundingClientRect().height;
        const containerHeight = contentContainerRef.current?.getBoundingClientRect().height ?? 0;
        const whitespaceHeight = Math.max(containerHeight - answerHeight, 0); // Only fire if we have meaningful height (content is rendered)
        if (answerHeight > 0 && containerHeight > 0) {
            fireAnalyticsEvent((0, $d58a262274d16c7a$export$f3109245f09f7746)({
                ...commonAttributes,
                answerHeight: answerHeight,
                containerHeight: containerHeight,
                whitespaceHeight: whitespaceHeight,
                queryIntent: queryIntent
            }));
            completeAnswerAnalyticsEventFiredRef.current = true;
        }
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        queryIntent,
        isContentTruncated
    ]); // SAIN usage event
    (0, $cozmU.useEffect)(()=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Notify parent (ai-answer-dialog) whenever the "answer minimized" state
    // changes so dwell tracking can be gated on whether the user can actually see
    // the answer.
    (0, $cozmU.useEffect)(()=>{
        onAnswerMinimizedChange?.(isAnswerMinimized);
    }, [
        isAnswerMinimized,
        onAnswerMinimizedChange
    ]); // Toggles the answer minimized state for the "Hide answer" button and the
    // in-flow "Expand" (SmartAnswerReady) affordance. `minimized=true` hides the
    // answer behind the SmartAnswerReady component; `minimized=false` re-shows the
    // answer. Fires the corresponding analytics event and updates the state.
    // NOTE: unlike SmartAnswerCardMinimized, this intentionally does NOT touch
    // `userExpandedDuringLoading`/`collapsed` — those are loading-time concerns
    // that don't apply to the consolidated card's minimize flow.
    const handleAnswerHiddenToggle = (0, $cozmU.useCallback)((minimized)=>{
        if (minimized) fireAnalyticsEvent((0, $619bd3e23d17df21$export$816a5214860a0c40)(commonAttributes));
        else fireAnalyticsEvent((0, $57db223fb661d84a$export$b19cbf041d35e6cc)(commonAttributes));
        setIsAnswerMinimized(minimized);
    }, [
        commonAttributes,
        fireAnalyticsEvent
    ]);
    const handleExpandCollapseButtonClick = (0, $cozmU.useCallback)(()=>{
        if (collapsed) {
            setCollapsed(false);
            setDidUserTriggerCollapse(false);
        } else {
            setCollapsed(true);
            setDidUserTriggerCollapse(true);
        }
    }, [
        collapsed
    ]); // Scrolls the answer card back into view and expands it fully when the user
    // clicks "Scroll up" on the floating SmartAnswerReady banner.
    const handleScrollUpClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $57ae65a71649f2c5$export$7f9024bb8c6bf2c3)(commonAttributes));
        fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes));
        setCollapsed(false);
        setDidUserTriggerCollapse(false);
        const node = containerRef.current;
        if (!node) return;
         // The "Scroll up" button only appears on the floating banner, which is only
        // rendered when the card is scrolled out of view (isCardInViewport === false).
        // So reaching this handler means the card is effectively out of view (or hidden
        // behind the fixed banner) and we should always scroll it back to the top.
        //
        // We intentionally avoid an isOutOfViewport short-circuit here: the previous
        // `rect.bottom <= 0` guard failed the edge case where the card's bottom edge
        // sits a few pixels below the viewport top (positive rect.bottom) but the card
        // is still visually hidden behind the fixed floating banner — in that case the
        // guard skipped the scroll and the user was never taken back to the answer.
        node.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }, [
        commonAttributes,
        fireAnalyticsEvent
    ]); // Track whether the answer card is in the viewport so we can render
    // SmartAnswerReady at the top of the search results when the user has scrolled
    // past the answer card. Only observe once the answer has finished loading and
    // is not in an error/no-answer state. Gated on the scroll-up feature since this
    // observer only exists to drive the floating SmartAnswerReady banner. Mirrors the
    // OR gating in smart-answers/index.tsx so the observer runs whenever the floating
    // portal ref is provided (either the scroll-up gate OR the broader updated-flow
    // experiment is on).
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $7DMz5.SAINFeatureControl).isSAINScrollUpEnabled() && !(0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled()) return;
        if (!isAnswered || hasError) return;
        if (!containerRef.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setIsCardInViewport(entry.isIntersecting);
            });
        }, {
            threshold: 0
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isAnswered,
        hasError
    ]);
    const handleVisibleTextComplete = (0, $cozmU.useCallback)(()=>{
        setIsVisibleTextComplete(true);
        onFMPReached?.(); // Mark FMP as reached for streaming answers
    }, [
        onFMPReached
    ]);
    const handleContainerClick = (0, $cozmU.useCallback)((event)=>{
        const selection = window.getSelection()?.toString() ?? ''; // Highlighting text should not expand the card
        const hasHighlightedText = selection.length > 0; // Clicking in a feedback modal or flag should not expand the card
        const isClickingOnContainer = containerRef.current?.contains(event.target) ?? false;
        if (collapsed && !hasHighlightedText && isClickingOnContainer) {
            setCollapsed(false);
            fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
                commonAttributes: commonAttributes
            });
        }
    }, [
        collapsed,
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent
    ]);
    const { handleSmartCardClick: handleSmartCardClick } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context
    }); // UFO resize observer for streaming
    const resizeObserverCallback = (0, $cozmU.useCallback)(()=>{
        if (!isVisibleTextCompleteRef.current && renderedContentRef.current && contentContainerRef.current && !!streamingTextToDisplay) {
            const renderedContentRefHeight = renderedContentRef.current.getBoundingClientRect().height;
            const contentContainerRefHeight = contentContainerRef.current.getBoundingClientRect().height;
            const isVisibleTextComplete = renderedContentRefHeight > contentContainerRefHeight;
            if (isVisibleTextComplete) {
                recordVisibleTextCompletion('overflow');
                handleVisibleTextComplete();
                isVisibleTextCompleteRef.current = true;
            }
        }
    }, [
        handleVisibleTextComplete,
        recordVisibleTextCompletion,
        streamingTextToDisplay
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1dee242400437624$export$fd29db098e42c3fc)(renderedContentRef, resizeObserverCallback, 100, [
        streamingTextToDisplay
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (bufferedContent.length > 0 && !firstByteEventFiredRef.current) {
            fireAnalyticsEvent((0, $bd6e42147a6848a8$export$c68095583a3c17cc)({
                ...commonAttributes,
                timeToFirstByte: Date.now() - componentRenderTimeRef.current
            }));
            firstByteEventFiredRef.current = true;
        }
    }, [
        bufferedContent,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Experiments
    const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    });
    const showReadMoreButton = collapsed && isContentTruncated; // Single return statement with React component for main content
    const isStreaming = !isAnswered && (loading || loading === undefined); // Early return for error state
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fd49c31ba41c686c$var$styles.fullWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f366b75433df2895$export$ffa24cd7196ce1b0), null));
     // Keep one UFO segment shell across loading/done states to avoid duplicate `_1`
    // lifecycles in the parent `ufo-unified-search` payload.
    const isGenerating = !isAnswered && (loading || loading === undefined) && (!partialResponse || bufferedContent.length < 1);
    const isSainUxUpliftEnabled = (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled();
    const isSAINLoadingStateTracesUpdateEnabled = (0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled();
    const visibleTextCompletionSourceData = visibleTextCompletionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: visibleTextCompletionData
    }) : null; // Render SmartAnswerReady at the top of the search results when:
    // - the answer has finished loading and is not in an error/no-answer state
    // - the answer card is currently scrolled out of the viewport
    // - the answer is currently in its collapsed state (user hasn't expanded it)
    const notifySmartAnswerReady = isAnswered && !hasError && !isCardInViewport && collapsed;
    const floatingSmartAnswerReadyPortal = notifySmartAnswerReady && floatingSmartAnswerReadyPortalRef?.current ? /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35b517b5dcf10511$export$6219b6e404cffa4a), {
        appearance: "scrollUp",
        onScrollUpClick: handleScrollUpClick,
        testId: "smart-answer-ready-floating"
    }), floatingSmartAnswerReadyPortalRef.current) : null;
    const answerCardContent = isGenerating ? isSAINLoadingStateTracesUpdateEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cb359678c785e7d4$export$89ba1a078457ae7b), {
        commonAttributes: commonAttributes
    }) : isSainUxUpliftEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aiIBH.SmartAnswerCardBodyGenerating), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f420039341622608$export$8a1fad5d74d43878), {
        isStreaming: true,
        showMoreButtonVisible: false
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3ffN.AnimatedWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aiIBH.SmartAnswerCardBodyGenerating), null)) : isSainUxUpliftEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fd49c31ba41c686c$var$SmartAnswerCardContent, {
        isStreaming: isStreaming,
        collapsed: collapsed,
        showReadMoreButton: showReadMoreButton,
        handleExpandCollapseButtonClick: handleExpandCollapseButtonClick,
        contentContainerRef: contentContainerRef,
        renderedContentRef: renderedContentRef,
        textContentRef: textContentRef,
        isTextTruncated: isTextTruncated,
        sources: sources,
        searchSessionId: searchSessionId,
        sourceClickCallback: handleSmartCardClick,
        errorStateSuggestedQueries: errorStateSuggestedQueries,
        serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp,
        commonAttributes: commonAttributes,
        contentToRender: contentToRender,
        showAnimation: showAnimation,
        onHideAnswer: ()=>handleAnswerHiddenToggle(true),
        handleContainerClick: handleContainerClick,
        containerRef: containerRef,
        hasLinksInAnswer: hasLinksInAnswer
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3ffN.AnimatedWrapper), {
        isAnswerComplete: isAnswered && !loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fd49c31ba41c686c$var$SmartAnswerCardContent, {
        isStreaming: isStreaming,
        collapsed: collapsed,
        showReadMoreButton: showReadMoreButton,
        handleExpandCollapseButtonClick: handleExpandCollapseButtonClick,
        contentContainerRef: contentContainerRef,
        textContentRef: textContentRef,
        isTextTruncated: isTextTruncated,
        renderedContentRef: renderedContentRef,
        sources: sources,
        searchSessionId: searchSessionId,
        sourceClickCallback: handleSmartCardClick,
        errorStateSuggestedQueries: errorStateSuggestedQueries,
        serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp,
        commonAttributes: commonAttributes,
        contentToRender: contentToRender,
        showAnimation: showAnimation,
        onHideAnswer: ()=>handleAnswerHiddenToggle(true),
        handleContainerClick: handleContainerClick,
        containerRef: containerRef,
        hasLinksInAnswer: hasLinksInAnswer
    })); // When the user has minimized the answer (clicked "Hide answer" on the loaded
    // card), render the SmartAnswerReady component in place of the full answer.
    // Clicking it re-shows the answer via handleAnswerHiddenToggle(false).
    // No need to also guard on !isGenerating: `isAnswerMinimized` can only become
    // true via the Hide answer button, which is only shown when !collapsed &&
    // !isStreaming (i.e. the answer is already loaded).
    if (isAnswerMinimized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35b517b5dcf10511$export$6219b6e404cffa4a), {
        onExpandClick: ()=>handleAnswerHiddenToggle(false)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fd49c31ba41c686c$var$styles.fullWidth, isSainUxUpliftEnabled && $fd49c31ba41c686c$var$styles.loadingPaddingOverrides),
        testId: "smart-answer-card-consolidated"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog-all-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "search-ai-dialog-all-text-loading",
        hold: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog-visible-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "search-ai-dialog-visible-text-loading",
        hold: !isVisibleTextComplete
    }), (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "queryHash",
        value: queryHash
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "searchSessionId",
        value: searchSessionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "queryIntent",
        value: queryIntent
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            queryIntent: queryIntent
        }
    }), visibleTextCompletionSourceData, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $016c76767add6663$export$3d5fec32962921db), null, answerCardContent))), floatingSmartAnswerReadyPortal);
}
function $fd49c31ba41c686c$var$SmartAnswerCardContent({ isStreaming: isStreaming, collapsed: collapsed, showReadMoreButton: showReadMoreButton, handleExpandCollapseButtonClick: handleExpandCollapseButtonClick, contentContainerRef: contentContainerRef, renderedContentRef: renderedContentRef, textContentRef: textContentRef, isTextTruncated: isTextTruncated, sources: sources, searchSessionId: searchSessionId, sourceClickCallback: sourceClickCallback, errorStateSuggestedQueries: errorStateSuggestedQueries, serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp, commonAttributes: commonAttributes, contentToRender: contentToRender, showAnimation: showAnimation, onHideAnswer: onHideAnswer, handleContainerClick: handleContainerClick, containerRef: containerRef, hasLinksInAnswer: hasLinksInAnswer }) {
    const isBorderlessUX = (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled();
    const { authorityUiMetadata: authorityUiMetadata } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, queryHash: queryHash, extraAttributes: extraAttributes, source: source } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const isHighlyAuthoritative = (0, $iDrrr.fg)('rovo_authoritative_answer_attribution') && !!authorityUiMetadata?.isHighlyAuthoritative;
    const handleAuthorityPanelShown = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $fhQlP.buildAuthoritativeAnswerPanelShownEvent)({
            product: 'sain',
            source: source,
            correlationAttributes: {
                cloudId: cloudId,
                searchSessionId: searchSessionId,
                queryHash: queryHash,
                traceId: extraAttributes?.requestId
            },
            authorityUiMetadata: authorityUiMetadata
        }));
    }, [
        fireAnalyticsEvent,
        source,
        cloudId,
        searchSessionId,
        queryHash,
        extraAttributes?.requestId,
        authorityUiMetadata
    ]);
    const fireAuthorityLinkClick = (0, $cozmU.useCallback)((linkType)=>{
        fireAnalyticsEvent((0, $a7fd7127c63cb2fc$export$5671a2e254c14222)({
            ...commonAttributes,
            linkType: linkType,
            authorityUiMetadata: authorityUiMetadata
        })); // Credits the click towards SAIN's success metric (SSRv5).
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes
        });
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        authorityUiMetadata,
        fireSAINUsageEvent
    ]); // URL patterns for sources known not to resolve as rich smart cards.
    const UNRESOLVABLE_URL_PATTERNS = [
        'viewpageattachments.action'
    ];
    const isUnresolvableSource = (url)=>UNRESOLVABLE_URL_PATTERNS.some((pattern)=>url.includes(pattern)); // Filter sources whose URLs are known not to resolve as rich smart cards.
    // Uses URL pattern matching since the NlpSearchResultType enum does not include 'attachment'.
    // https://switcheroo.atlassian.com/ui/gates/f309f0ca-53a0-4c56-9767-fec898813e99/key/kd_sain_filter_attachment_sources
    const filteredSources = (0, $iDrrr.fg)('kd_sain_filter_attachment_sources') ? sources.filter((source)=>!isUnresolvableSource(source.url)) : sources;
    const sourcesSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, !isStreaming && filteredSources.length > 0 && (0, $7DMz5.SAINFeatureControl).isSourcesInShortSAINAnswersEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fd49c31ba41c686c$var$styles.sourcesTopPadding, collapsed && $fd49c31ba41c686c$var$styles.nonInteractive)
    }, (0, $7DMz5.SAINFeatureControl).isLinkListSourcesEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $fd49c31ba41c686c$var$styles.linkListContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).related_links_title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Luzz.LinkList), {
        urls: filteredSources.map((source)=>source.url),
        maxSources: 5,
        showExpand: false,
        onLinkClick: (url, index, opts)=>{
            const source = filteredSources[index];
            if (source) sourceClickCallback({
                index: index,
                source: source,
                hostname: (0, $736ac3075308471f$export$a3b7216c107a7a1)(url),
                sourceCardType: 'link-list',
                isAuxClick: opts?.isAuxClick,
                isContextMenu: opts?.isContextMenu
            });
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ce789c5dd436d96e$export$919320f9832aec1d), {
        sources: filteredSources,
        searchSessionId: searchSessionId,
        onClickHandler: sourceClickCallback
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(collapsed ? $fd49c31ba41c686c$var$styles.interactive : undefined, isBorderlessUX && $fd49c31ba41c686c$var$styles.standardSAINMarginOverrides),
        onClick: handleContainerClick,
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: isStreaming && !isBorderlessUX ? $fd49c31ba41c686c$var$styles.root : $fd49c31ba41c686c$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: $fd49c31ba41c686c$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4217877a0025dc35$export$127e64693c41156a), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            spread: "space-between",
            alignBlock: "center",
            grow: "fill",
            xcss: (0, $w6R6I.cx)((0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && $fd49c31ba41c686c$var$styles.standardSAINMarginOverrides)
        }, (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050",
            shouldWrap: true
        }, isHighlyAuthoritative && authorityUiMetadata ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
            label: "",
            size: "medium",
            color: "var(--ds-icon-success, #6A9A23)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Zool.AuthoritativeAnswerAttribution), {
            sources: authorityUiMetadata.sources ?? [],
            domainExperts: authorityUiMetadata.domainExperts ?? [],
            overallReasoning: authorityUiMetadata.overallReasoning,
            labelVariant: "answer",
            cloudId: cloudId,
            surface: "sain",
            // use the taller panel to avoid cramping the feedback form.
            panelSize: "tall",
            onPanelOpen: handleAuthorityPanelShown,
            onSourceClick: ()=>fireAuthorityLinkClick('source'),
            onExpertClick: ()=>fireAuthorityLinkClick('expert'),
            onFeedbackSubmit: (submission)=>{
                // Submit authority-answer feedback to the Feedback Collector API
                // using SAIN's existing entrypoint (same destination as SAIN's
                // footer feedback). Analytics wiring is handled separately.
                (0, $1V59x.submitAuthorityFeedback)({
                    submission: submission,
                    entrypointId: (0, $1V59x.FEEDBACK_ENTRYPOINT_ID_SAIN),
                    origin: (0, $1V59x.AUTHORITY_FEEDBACK_ORIGIN_SAIN),
                    cloudId: cloudId,
                    debugAttributes: {
                        traceId: extraAttributes?.requestId,
                        searchSessionId: searchSessionId,
                        queryHash: queryHash
                    }
                });
            }
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
            label: "AI Content",
            size: "medium"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h1",
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).smart_answer_card_dynamic_layout_title)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "xxsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small",
            weight: "bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).smart_answer_card_title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, (0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled() && !isStreaming && onHideAnswer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            spacing: "compact",
            appearance: "subtle",
            onClick: (e)=>{
                // The button lives inside the AICollapse header, which expands
                // the answer when clicked anywhere. Stop propagation so
                // clicking "Hide answer" only hides the answer (and shows
                // SmartAnswerReady) without also expanding it.
                e.stopPropagation();
                onHideAnswer();
            },
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), {
                    ...iconProps,
                    size: "small"
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).hide_answer))))),
        isCollapsed: collapsed,
        onExpandCollapse: handleExpandCollapseButtonClick,
        ref: contentContainerRef,
        showReadMoreButton: isBorderlessUX ? collapsed : showReadMoreButton,
        luminaAnswerType: (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? 'STANDARD' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: renderedContentRef,
        id: "ai-answer-result-section",
        testId: "sain-fmp-target"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: textContentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fd49c31ba41c686c$var$MemoizedRenderer, {
        contentToRender: contentToRender,
        showAnimation: showAnimation
    })))), !hasLinksInAnswer && sourcesSection)), showReadMoreButton && !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ed12dd693731600a$export$e68719f9c8487320), {
        onClick: handleExpandCollapseButtonClick
    }), (collapsed || showReadMoreButton || isStreaming) && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f420039341622608$export$8a1fad5d74d43878), {
        isStreaming: isStreaming,
        showMoreButtonVisible: collapsed,
        fireShownEvent: isTextTruncated,
        onClickShowMoreButton: handleExpandCollapseButtonClick
    })), !isStreaming && !collapsed && filteredSources.length > 0 && !(0, $7DMz5.SAINFeatureControl).isSourcesInShortSAINAnswersEnabled() && !hasLinksInAnswer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fd49c31ba41c686c$var$styles.sectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ce789c5dd436d96e$export$919320f9832aec1d), {
        sources: filteredSources,
        searchSessionId: searchSessionId,
        onClickHandler: sourceClickCallback
    })), (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && !isStreaming && !collapsed && filteredSources.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fd49c31ba41c686c$var$styles.followUpChatInputSectionWithBarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe4d4049968826dc$export$7552c1f78575b57c), {
        renderTrigger: (onToggle, triggerRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7fd6a1524e779285$export$e754cddb4d3a7903), {
                sources: filteredSources,
                numSources: filteredSources.length,
                onClick: onToggle,
                triggerRef: triggerRef
            })
    })), !collapsed && !showReadMoreButton && !isStreaming && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $fd49c31ba41c686c$var$styles.followUpChatInputSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a921764ae1a692a7$export$f087ce3403d54eb5), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j8bJ5.OpenChatInputBox), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fd49c31ba41c686c$var$styles.disclaimerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true,
        showCopyButton: !hasLinksInAnswer,
        renderedContentRef: textContentRef
    }))), !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fd49c31ba41c686c$var$styles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: !isStreaming,
        showCopyButton: !isStreaming && !hasLinksInAnswer,
        renderedContentRef: textContentRef
    }))), !isStreaming && !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && (!collapsed || errorStateSuggestedQueries.length > 0 && serveErrorStateSuggestedQueriesExp) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34e9b06075b84401$export$3553ee90c7edebc9), {
        showOpenChat: true
    }) : null));
}
function $fd49c31ba41c686c$export$3698d894d0a161e5({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent, onAnswerMinimizedChange: onAnswerMinimizedChange, floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "smart-answer-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fd49c31ba41c686c$var$SmartAnswerCardConsolidatedComponent, {
        onFMPReached: onFMPReached,
        onAnswerExpandedChange: onAnswerExpandedChange,
        queryIntent: queryIntent,
        onAnswerMinimizedChange: onAnswerMinimizedChange,
        floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef
    }));
}


/* smart-answer-card-dynamic-layout.tsx generated by @compiled/babel-plugin v3.0.1 */ 











































var $gmCV5 = parcelRequire("gmCV5");

var $kfIS7 = parcelRequire("kfIS7");



































/* dynamic-layout.tsx generated by @compiled/babel-plugin v3.0.1 */ 











var $bMS22 = parcelRequire("bMS22");

const $fb2afea4934d8744$var$CITATION_REGEX = /\[\^(\d+)\^\]/g;
function $fb2afea4934d8744$export$6fdccd51aa07b64f(modelOutput) {
    if (!modelOutput || typeof modelOutput !== 'string') return [];
    // Remove incomplete opening tags at the end (like "<section class="test" without closing >)
    let cleanedContent = modelOutput.replace(/<[^>]*$/, '');
    // Remove inline citation indicators from response for now
    // https://atlassian.slack.com/archives/C09KC9NV23W/p1769026048635919?thread_ts=1769020398.811119&cid=C09KC9NV23W
    cleanedContent = cleanedContent.replace($fb2afea4934d8744$var$CITATION_REGEX, '');
    // Remove unclosed carousel tags and their contents to prevent rendering children
    // before the carousel wrapper is complete (which causes visual flickering)
    const carouselOpenTags = cleanedContent.match(/<carousel[^>]*>/g);
    const carouselCloseTags = cleanedContent.match(/<\/carousel>/g);
    const hasUnclosedCarousel = (carouselOpenTags?.length || 0) > (carouselCloseTags?.length || 0);
    if (hasUnclosedCarousel) {
        // Find the last unclosed carousel and remove everything from that point onwards
        const lastCarouselIndex = cleanedContent.lastIndexOf('<carousel');
        if (lastCarouselIndex >= 0) cleanedContent = cleanedContent.substring(0, lastCarouselIndex);
    }
    try {
        const root = (0, $bMS22.parse)(cleanedContent);
        const body = root.querySelector('body') || root;
        const result = [];
        body.childNodes.forEach((element)=>{
            const jsonElement = $fb2afea4934d8744$var$elementToJson(element);
            if (jsonElement) result.push(jsonElement);
        });
        return result;
    } catch  {
        return [];
    }
}
function $fb2afea4934d8744$var$elementToJson(element) {
    // node types: https://dom.spec.whatwg.org/#dom-node-nodetype
    if (element.nodeType === 3) {
        // text node
        const text = element.text.trim();
        return text ? text : null;
    }
    // not an element node: https://dom.spec.whatwg.org/#dom-node-nodetype
    if (element.nodeType !== 1) return null;
    const htmlElement = element; // text node already processed
    const result = {
        tag: htmlElement.tagName.toLowerCase()
    };
    // Add attributes if they exist
    if (htmlElement.attributes && Object.keys(htmlElement.attributes).length > 0 && typeof result !== 'string') result.attributes = htmlElement.attributes;
    // Process children
    const children = [];
    htmlElement.childNodes.forEach((child)=>{
        // handles text + element nodes
        const childJson = $fb2afea4934d8744$var$elementToJson(child);
        if (childJson) children.push(childJson);
    });
    if (children.length > 0 && typeof result !== 'string') result.children = children;
    return result;
}


/* dynamic-layout-sections.tsx generated by @compiled/babel-plugin v3.0.1 */ 



var $k12R1 = parcelRequire("k12R1");








function $34b0857017e74170$export$52e6c7c72e88442f(element) {
    return typeof element !== 'string' && element.tag === 'h';
}


/* dynamic-layout-foldable-section.tsx generated by @compiled/babel-plugin v3.0.1 */ 



























/* dynamic-layout-carousel.tsx generated by @compiled/babel-plugin v3.0.1 */ 












var $03RpJ = parcelRequire("03RpJ");




















/* dynamic-layout-person-card.tsx generated by @compiled/babel-plugin v3.0.1 */ 




















const $336cb91c39b130b1$var$PersonCarouselCardStyles = {
    personCardContainer: "_0bjKvD8fU6 _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5vbt8w _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _1EqgXlHakr _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126",
    contactInfoSection: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _2XsHFM2ADO _4ouGXIdnbC _39HuIbz8Lp"
};
const $336cb91c39b130b1$export$da7d0a1972db5125 = ({ component: component })=>{
    const personAttributes = component.attributes;
    const { name: name, job_title: job_title, avatar_url: avatar_url, url: url } = personAttributes || {};
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { handleSmartCardClick: handleSmartCardClick } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context,
        isCitation: true
    });
    const handleClick = ()=>{
        handleSmartCardClick({
            sourceCardType: 'person-card',
            index: 0,
            source: null
        });
    };
    if (!url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: url,
        xcss: $336cb91c39b130b1$var$PersonCarouselCardStyles.personCardContainer,
        testId: "dynamic-layout-person-card",
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "circle",
        src: avatar_url || '',
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $336cb91c39b130b1$var$PersonCarouselCardStyles.contactInfoSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "medium",
        maxLines: 1
    }, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 1
    }, job_title)))));
};


/* dynamic-layout-smart-link.tsx generated by @compiled/babel-plugin v3.0.1 */ 












var $2vPXD = parcelRequire("2vPXD");


const $9ade015352caca2d$var$styles = {
    smartLink: "_39xV02ax1H"
};
/**
 * Convert SmartLinkElement to KnowledgeCardSource format
 */ function $9ade015352caca2d$var$convertToKnowledgeCardSource(component, resolvedData) {
    const url = component.attributes?.url || '';
    const title = component.attributes?.title;
    return {
        id: resolvedData?.['@id'] || url,
        title: title || resolvedData?.name || url,
        url: url,
        product: resolvedData?.generator?.name || null,
        type: resolvedData?.['@type'] || 'link',
        iconUrl: resolvedData?.generator?.icon?.url || null,
        lastModified: resolvedData?.dateModified || null,
        spaceName: null,
        spaceUrl: null,
        ari: resolvedData?.ari
    };
}
const $9ade015352caca2d$export$5c7864f9e8929faf = ({ component: component, variant: variant })=>{
    const url = component.attributes?.url || '';
    const isActionCard = component.attributes?.type === 'action';
    const effectiveVariant = isActionCard ? (0, $aUgOE.CardVariant).ACTION_CARD : variant;
    const { objectResolverData: objectResolverData } = (0, $2vPXD.useFetchSmartLinkData)({
        urls: [
            url
        ]
    });
    const resolvedData = objectResolverData?.[0];
    const source = $9ade015352caca2d$var$convertToKnowledgeCardSource(component, resolvedData);
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { handleSmartCardClick: handleSmartCardClick, searchSessionId: searchSessionId } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context,
        isCitation: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "dynamic-layout-smart-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aUgOE.KnowledgeSmartCard), {
        source: source,
        variant: effectiveVariant,
        searchSessionId: searchSessionId,
        onClickHandler: handleSmartCardClick
    }));
};
const $9ade015352caca2d$export$6615cf55452a9648 = ({ component: component, variant: variant })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9ade015352caca2d$var$styles.smartLink
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9ade015352caca2d$export$5c7864f9e8929faf, {
        component: component,
        variant: variant
    }));
};


/* dynamic-layout-project-highlight-card.tsx generated by @compiled/babel-plugin v3.0.1 */ 












const $f1a17e7e381eb12e$var$styles = {
    container: "_0bjKvD8fU6 _3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    summaryBox: "_1EqgXlPIoL"
};
const $f1a17e7e381eb12e$export$8c4de62228787a7c = ({ component: component })=>{
    const title = component?.attributes?.title || '';
    const text = component?.attributes?.content || '';
    return title || text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: (0, $w6R6I.cx)($f1a17e7e381eb12e$var$styles.container),
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050",
        xcss: $f1a17e7e381eb12e$var$styles.summaryBox
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "medium",
        maxLines: 1
    }, title), text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        maxLines: 1
    }, text))) : null;
};


const $006178f92ae20728$var$carouselCardWidth = 355; // card width (300px) + gap (space.200 = 16px)
const $006178f92ae20728$var$scrollWidth = ($006178f92ae20728$var$carouselCardWidth + 46) * 2;
const $006178f92ae20728$var$styles = {
    carouselStyles: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLchRC _1mT5xdRAKS _0aFT5vbt8w _39xV02N91d",
    carouselStylesSingleRow: "_3iDTPbQ4SZ _0hPCNLchRC _1mT5xdRAKS _0aFT5vbt8w _39xV02N91d _313842UgYP",
    scrollContainerStyles: "_4bt5LAIZbP _2WAcuGnQyn _3iDTPbvLZJ _39xV02N91d _3oUqlsYbGa _3h2tDz3EvU",
    scrollContainerNoScroll: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39xV02N91d",
    cardContainerOneItem: "_2mHwu85zaO _3iDTPbgBM8 _2iEGP2UfmU",
    cardContainerTwoItems: "_2mHwu85zaO _3iDTPbgBM8 _2iEGP2Lmr7",
    cardContainerThreePlusItems: "_2mHwu85zaO _3iDTPbgBM8 _2iEGP2LaoX _293iXKbt8w _3kOVpyUfmU",
    carouselItemStyles: "_4ouGXIGNMc _1EqgXlwBC3",
    carouselItemStylesFoldable: "_4ouGXI71Z1 _1EqgXlqy1Q"
};
const $006178f92ae20728$var$CarouselItemRenderer = ({ child: child, isFoldable: isFoldable })=>{
    const isPeopleCard = typeof child !== 'string' && child.tag === 'people-card';
    const isSmartLink = typeof child !== 'string' && child.tag === 'smart-link';
    const isProjectHighlight = typeof child !== 'string' && child.tag === 'project-highlight-card';
    if (isPeopleCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "carousel-item-people-card",
        xcss: isFoldable ? $006178f92ae20728$var$styles.carouselItemStylesFoldable : $006178f92ae20728$var$styles.carouselItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $336cb91c39b130b1$export$da7d0a1972db5125), {
        component: child
    }));
    if (isSmartLink) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "carousel-item-smart-link",
        xcss: isFoldable ? $006178f92ae20728$var$styles.carouselItemStylesFoldable : $006178f92ae20728$var$styles.carouselItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ade015352caca2d$export$5c7864f9e8929faf), {
        component: child,
        variant: (0, $aUgOE.CardVariant).COMPACT
    }));
    if (isProjectHighlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "carousel-item-project-highlight-card",
        xcss: isFoldable ? $006178f92ae20728$var$styles.carouselItemStylesFoldable : $006178f92ae20728$var$styles.carouselItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1a17e7e381eb12e$export$8c4de62228787a7c), {
        component: child
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null);
};
const $006178f92ae20728$var$isScrollAtLeft = (elem)=>elem?.scrollLeft === 0;
const $006178f92ae20728$var$isScrollAtRight = (elem)=>elem ? Math.abs(elem?.scrollWidth - elem?.scrollLeft - elem?.clientWidth) <= 1 : false;
const $006178f92ae20728$export$53535a62c6d2f77b = ({ component: component, position: position, showArrows: showArrows = true, isFoldable: isFoldable = false })=>{
    const scrollContainerRef = (0, $cozmU.useRef)(null);
    const [hideLeftScroll, setHideLeftScroll] = (0, $cozmU.useState)(true);
    const [hideRightScroll, setHideRightScroll] = (0, $cozmU.useState)(false); // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key_id = (0, $cozmU.useRef)((0, $03RpJ.default)());
    const carouselChildren = component.children || [];
    const shouldAlignHeader = position === 'single-column';
    const updateArrowVisibility = (0, $cozmU.useCallback)(()=>{
        if (scrollContainerRef.current) {
            setHideLeftScroll($006178f92ae20728$var$isScrollAtLeft(scrollContainerRef.current));
            setHideRightScroll($006178f92ae20728$var$isScrollAtRight(scrollContainerRef.current));
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer && carouselChildren.length) {
            updateArrowVisibility();
            const unbind = (0, $cbY7C.bind)(scrollContainer, {
                type: 'scroll',
                listener: updateArrowVisibility
            });
            return unbind;
        }
    }, [
        carouselChildren.length,
        updateArrowVisibility
    ]);
    const onScroll = (0, $5Sv3D.default)(()=>{
        updateArrowVisibility();
    }, 30);
    const scrollLeft = ()=>{
        if (scrollContainerRef.current) scrollContainerRef.current.scrollLeft -= $006178f92ae20728$var$scrollWidth;
    };
    const scrollRight = ()=>{
        if (scrollContainerRef.current) scrollContainerRef.current.scrollLeft += $006178f92ae20728$var$scrollWidth;
    };
    if (!carouselChildren || carouselChildren.length < 2) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $k12R1.cx)(shouldAlignHeader ? $006178f92ae20728$var$styles.carouselStylesSingleRow : $006178f92ae20728$var$styles.carouselStyles),
        testId: "dynamic-layout-carousel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        grow: "fill",
        alignBlock: "center"
    }, !shouldAlignHeader && component.attributes?.title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold",
        size: "small",
        color: "color.text.accent.gray",
        testId: "carousel-title"
    }, component.attributes?.title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null), showArrows && (!hideLeftScroll || !hideRightScroll) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: "scroll left",
        onClick: scrollLeft,
        shape: "circle",
        appearance: "subtle",
        spacing: "compact",
        isDisabled: hideLeftScroll
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
        label: "scroll right",
        onClick: scrollRight,
        shape: "circle",
        appearance: "subtle",
        spacing: "compact",
        isDisabled: hideRightScroll
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: carouselChildren.length <= 3 ? $006178f92ae20728$var$styles.scrollContainerNoScroll : $006178f92ae20728$var$styles.scrollContainerStyles,
        ref: scrollContainerRef,
        onScroll: onScroll,
        tabIndex: carouselChildren.length > 3 ? 0 : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: carouselChildren.length === 1 ? $006178f92ae20728$var$styles.cardContainerOneItem : carouselChildren.length === 2 ? $006178f92ae20728$var$styles.cardContainerTwoItems : $006178f92ae20728$var$styles.cardContainerThreePlusItems
    }, carouselChildren.map((child, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($006178f92ae20728$var$CarouselItemRenderer, {
            key: `${key_id}-${index}`,
            child: child,
            index: index,
            isFoldable: isFoldable
        })))));
};


/* dynamic-layout-list.tsx generated by @compiled/babel-plugin v3.0.1 */ 












var $hMaHH = parcelRequire("hMaHH");


var $hQhpy = parcelRequire("hQhpy");


var $60Yxm = parcelRequire("60Yxm");
























const $c44b5563d5e5dc2c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    dynamic_layout_list_project_status_merged: {
        id: "search_ai.dynamic_layout_list_project_status_merged",
        defaultMessage: "Merged"
    },
    dynamic_layout_list_see_more: {
        id: "search_ai.dynamic_layout_list_see_more",
        defaultMessage: "See more"
    },
    dynamic_layout_list_see_less: {
        id: "search_ai.dynamic_layout_list_see_less",
        defaultMessage: "See less"
    }
});


const $44de46e11ee5730b$var$styles = {
    documentWrapper: "_1mT5xdRAKS _0Am33zKxmn _1eOmH6qWX3",
    invisibleLinkWrapper: "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _39xV02N91d _0jFU0VN91d _3CkH9oYbGa _0KLXrujOvk _034jHtYbGa _42Yu6B7dHp",
    pageIconWrapper: "_0bjKvDKxmn _0jFU0VUofl _39xV02Uofl _24h04i2Njc _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0KLXruDMqu",
    documentMetadataIconWrapper: "_313842Ll21 _0jFU0VxpxF _39xV02xpxF",
    listDocumentWrapper: "_39xV02N91d",
    showMoreButtonWrapper: "_39xV02FFh0"
};
const $44de46e11ee5730b$var$MAX_VISIBLE_DOCS = 3;
const $44de46e11ee5730b$var$InvisibleLink = ({ name: name, url: url })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: url,
        xcss: $44de46e11ee5730b$var$styles.invisibleLinkWrapper,
        "aria-label": name,
        tabIndex: -1
    });
const $44de46e11ee5730b$var$getDocumentIcon = (itemData)=>{
    if (itemData.url && itemData.url.includes('docs.google.com')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: ""
    });
    if (itemData.url && itemData.url.includes('loom.com')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
        color: "var(--ds-icon-discovery, #AF59E1)",
        label: ""
    });
    if (itemData.url && (itemData.url.includes('bitbucket.org') || itemData.url.includes('github.com'))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))), {
        color: "var(--ds-icon-accent-green, #22A06B)",
        label: ""
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
        color: "var(--ds-icon-brand, #1868DB)",
        label: ""
    });
};
const $44de46e11ee5730b$var$DynamicLayoutListItem = ({ itemData: itemData })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $44de46e11ee5730b$var$styles.documentWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44de46e11ee5730b$var$InvisibleLink, {
        name: itemData.name,
        url: itemData.url
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $44de46e11ee5730b$var$styles.pageIconWrapper
    }, $44de46e11ee5730b$var$getDocumentIcon(itemData)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "large",
        maxLines: 1
    }, itemData.name), itemData['atlassian:state'] === 'MERGED' && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "success",
        isBold: true
    }, formatMessage((0, $c44b5563d5e5dc2c$export$defe85febe8b728c).dynamic_layout_list_project_status_merged))), itemData.generator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $44de46e11ee5730b$var$styles.documentMetadataIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: itemData.generator.icon?.url,
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small",
        maxLines: 1
    }, itemData.generator.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, itemData.attributedTo?.name)))));
};
const $44de46e11ee5730b$export$ad60ebd47efcfb81 = ({ component: component })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [listExpanded, setListExpanded] = (0, $cozmU.useState)(false);
    const listChildrenUrls = (0, $cozmU.useMemo)(()=>(component.children || []).map((listChild)=>listChild.attributes?.url || '').filter((url)=>!!url), [
        component.children
    ]);
    const { objectResolverData: objectResolverData } = (0, $2vPXD.useFetchSmartLinkData)({
        urls: listChildrenUrls
    });
    const showMoreButtonVisible = objectResolverData.length > $44de46e11ee5730b$var$MAX_VISIBLE_DOCS;
    const numVisibleDocs = listExpanded ? objectResolverData.length : $44de46e11ee5730b$var$MAX_VISIBLE_DOCS;
    return objectResolverData.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $44de46e11ee5730b$var$styles.listDocumentWrapper,
        testId: "dynamic-layout-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, objectResolverData.slice(0, numVisibleDocs).map((data, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44de46e11ee5730b$var$DynamicLayoutListItem, {
            itemData: data,
            key: idx
        })), showMoreButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $44de46e11ee5730b$var$styles.showMoreButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: ()=>setListExpanded(!listExpanded),
        spacing: "compact"
    }, listExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $c44b5563d5e5dc2c$export$defe85febe8b728c).dynamic_layout_list_see_less)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $c44b5563d5e5dc2c$export$defe85febe8b728c).dynamic_layout_list_see_more)))))) : null;
};









var $3BY7M = parcelRequire("3BY7M");




const $1c53213988b4b655$export$a75e4056105f395f = ({ component: component })=>{
    const markdown = component.children?.[0];
    const docContent = (0, $cozmU.useMemo)(()=>markdown ? (0, $6rwn6.encodeAdf)(markdown, false) : undefined, [
        markdown
    ]);
    return docContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "dynamic-layout-markdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        document: docContent
    })) : null;
};













const $19fb9eea97e4f476$var$PROJECT_HIGHLIGHTS_SUB_AGENT_NAME = 'PROJECT_HIGHLIGHTS';
const $19fb9eea97e4f476$export$86abf3cfc73e361f = ()=>{
    const { loading: loading, dynamicLayoutSubAgentMessages: dynamicLayoutSubAgentMessages } = (0, $3hVWe.useAIAnswerContext)();
    const projectHighlightsMessage = (0, $cozmU.useMemo)(()=>{
        return $19fb9eea97e4f476$var$getSubAgentMessage(dynamicLayoutSubAgentMessages, $19fb9eea97e4f476$var$PROJECT_HIGHLIGHTS_SUB_AGENT_NAME);
    }, [
        dynamicLayoutSubAgentMessages
    ]);
    const carouselData = (0, $cozmU.useMemo)(()=>{
        if (!projectHighlightsMessage?.data || projectHighlightsMessage?.data === 'No Data Found') return null;
        try {
            const projectData = JSON.parse(projectHighlightsMessage.data);
            const children = projectData.highlights.map((highlight)=>({
                    tag: 'project-highlight-card',
                    attributes: {
                        title: highlight.title,
                        content: highlight.content
                    }
                }));
            const carouselComponent = {
                tag: 'carousel',
                children: children
            };
            return carouselComponent;
        } catch (error) {
            return null;
        }
    }, [
        projectHighlightsMessage?.data
    ]);
    if (loading && !projectHighlightsMessage?.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "200px",
        height: "16px",
        isShimmering: true
    });
    if (!projectHighlightsMessage?.data || projectHighlightsMessage?.data === 'No Data Found') return null;
    if (!carouselData) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $006178f92ae20728$export$53535a62c6d2f77b), {
        component: carouselData,
        position: "two-rows-bottom",
        showArrows: false
    });
};
const $19fb9eea97e4f476$var$getSubAgentMessage = (messages, subAgentName)=>{
    return messages.find((message)=>message.sub_agent_name === subAgentName);
};















const $a65d0b6a1e8182d7$var$RELATED_PEOPLE_SUB_AGENT_NAME = 'ENTITY_RELATED_PEOPLE';
const $a65d0b6a1e8182d7$export$2f4dfd3f449abf1b = ()=>{
    const { loading: loading, dynamicLayoutSubAgentMessages: dynamicLayoutSubAgentMessages } = (0, $3hVWe.useAIAnswerContext)();
    const relatedPeopleMessage = (0, $cozmU.useMemo)(()=>{
        return $a65d0b6a1e8182d7$var$getSubAgentMessage(dynamicLayoutSubAgentMessages, $a65d0b6a1e8182d7$var$RELATED_PEOPLE_SUB_AGENT_NAME);
    }, [
        dynamicLayoutSubAgentMessages
    ]);
    const carouselData = (0, $cozmU.useMemo)(()=>{
        if (!relatedPeopleMessage?.data || relatedPeopleMessage?.data === 'No Data Found') return null;
        try {
            const peopleData = JSON.parse(relatedPeopleMessage.data);
            const children = peopleData.people.map((person)=>({
                    tag: 'people-card',
                    attributes: {
                        name: person.name,
                        job_title: person.jobTitle,
                        avatar_url: person.avatarUrl,
                        url: person.url
                    }
                }));
            const carouselComponent = {
                tag: 'carousel',
                attributes: {
                    title: 'Related People'
                },
                children: children
            };
            return carouselComponent;
        } catch (error) {
            (0, $cuvLu.logger).error({
                error: error,
                functionName: 'carouselData'
            });
            return null;
        }
    }, [
        relatedPeopleMessage?.data
    ]);
    if (loading && !relatedPeopleMessage?.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "200px",
        height: "16px",
        isShimmering: true
    });
    if (!relatedPeopleMessage?.data || relatedPeopleMessage?.data === 'No Data Found') return null;
    if (!carouselData) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $006178f92ae20728$export$53535a62c6d2f77b), {
        component: carouselData,
        position: "two-rows-bottom"
    });
};
const $a65d0b6a1e8182d7$var$getSubAgentMessage = (messages, subAgentName)=>{
    return messages.find((message)=>message.sub_agent_name === subAgentName);
};


const $cf9a43f0b0d93e55$export$84b484f69b67f84e = ({ component: component, position: position, isFoldable: isFoldable = false, variant: variant })=>{
    if (!component || typeof component !== 'string' && !component.tag) return null;
    if (typeof component !== 'string') switch(component.tag){
        case 'md':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1c53213988b4b655$export$a75e4056105f395f), {
                component: component
            });
        case 'list':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $44de46e11ee5730b$export$ad60ebd47efcfb81), {
                component: component
            });
        case 'smart-link':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ade015352caca2d$export$6615cf55452a9648), {
                component: component,
                variant: variant
            });
        case 'carousel':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $006178f92ae20728$export$53535a62c6d2f77b), {
                component: component,
                position: position,
                isFoldable: isFoldable
            });
        case 'action-card':
            {
                const actionCard = component;
                // Validate component has a url and convert to smart-link
                if (actionCard.attributes?.url) {
                    const smartLinkComponent = {
                        tag: 'smart-link',
                        attributes: {
                            url: actionCard.attributes.url,
                            title: actionCard.attributes?.title,
                            type: 'action',
                            pos: actionCard.attributes?.pos
                        }
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ade015352caca2d$export$6615cf55452a9648), {
                        component: smartLinkComponent,
                        variant: variant
                    });
                }
                return null;
            }
        case 'related-people':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a65d0b6a1e8182d7$export$2f4dfd3f449abf1b), null);
        case 'project-highlights':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $19fb9eea97e4f476$export$86abf3cfc73e361f), null);
        default:
            return null;
    }
    return null;
};


const $0741daaf14376927$var$REQUIRED_ELEMENTS_COUNT = 1;
const $0741daaf14376927$export$1a9cda7e8be08d8 = ({ elements: elements, isFoldable: isFoldable = false })=>{
    if (elements.length < $0741daaf14376927$var$REQUIRED_ELEMENTS_COUNT) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf9a43f0b0d93e55$export$84b484f69b67f84e), {
        component: elements[0],
        position: "single-column",
        isFoldable: isFoldable
    });
};


const $02d37fec4a3fe277$var$unboundedStyles = {
    root: "_3138425zaO _39xV02N91d",
    contentWrapper: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w",
    contentExpanded: "_0NUa3r4DOi",
    contentCollapsed: "_4bt5LAnQyn _2WAcuGnQyn _0NUa3r9LX5 _3iDTPbgJ9S _1U1ZhbbI28 _4Gn54R7dHp",
    pointer: "_0wOv4Q7zJH"
};
const $02d37fec4a3fe277$var$styles = {
    divider: "_2IVJ4M6wH8 _22sfPnNvrM _3zygPU9r67 _3138425zaO",
    headerWrapper: "_1DCdHi2ADO"
};
const $02d37fec4a3fe277$export$1f15b0b67d49b0f6 = ({ defaultFoldedState: defaultFoldedState, header: header, content: content, children: children })=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const [isFolded, setIsFolded] = (0, $cozmU.useState)(defaultFoldedState === 'collapsed');
    const sectionKey = `folded-section-${header?.children || ''}`;
    const handleKeyDown = (event)=>{
        if ((event.key === 'Enter' || event.key === ' ') && isFolded) {
            event.preventDefault();
            setIsFolded(false);
        }
    };
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "dynamic-layout-foldable-section",
        className: (0, $hekY6.default)([
            $02d37fec4a3fe277$var$unboundedStyles.root,
            isFolded && $02d37fec4a3fe277$var$unboundedStyles.pointer
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: isFolded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
        label: `${isFolded ? 'expand' : 'collapsed'} section`,
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setIsFolded(!isFolded),
        testId: isFolded ? 'expand-button' : 'collapse-button',
        "aria-expanded": !isFolded
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        ref: containerRef,
        onClick: ()=>setIsFolded(false),
        onKeyDown: handleKeyDown,
        tabIndex: 0,
        role: "button",
        "data-testid": "dynamic-layout-foldable-clickable-section",
        className: (0, $hekY6.default)([
            $02d37fec4a3fe277$var$unboundedStyles.contentWrapper,
            isFolded ? $02d37fec4a3fe277$var$unboundedStyles.contentCollapsed : $02d37fec4a3fe277$var$unboundedStyles.contentExpanded
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        xcss: $02d37fec4a3fe277$var$styles.headerWrapper
    }, header && header.attributes?.show !== 'false' && content && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "bold"
    }, header && header.children)), isFolded ? /*#__PURE__*/ $cozmU.createElement((0, $0741daaf14376927$export$1a9cda7e8be08d8), {
        key: `${sectionKey}-collapsed`,
        elements: content
    }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        key: `${sectionKey}-expanded`
    }, children))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $02d37fec4a3fe277$var$styles.divider
    }));
};



/* two-column-layout.tsx generated by @compiled/babel-plugin v3.0.1 */ 















const $4539e8c6f4231931$export$7cd3afc49691a77e = (elements, position, defaultIndex)=>{
    const result = [];
    for(let i = 0; i < elements.length; i++){
        const element = elements[i];
        if (typeof element === 'string') continue;
        if (element.attributes?.pos === position || i === defaultIndex && !element.attributes?.pos) result.push(element);
    }
    return result;
};


// Tags that represent text content
const $903a9b88cd0e7cbe$var$TEXT_CONTENT_TAGS = [
    'md',
    'list'
];
// Tags that represent smart links
const $903a9b88cd0e7cbe$var$SMART_LINK_TAGS = [
    'smart-link',
    'action-card'
];
// Max height of a full-size smart link card
const $903a9b88cd0e7cbe$var$FULL_SMART_LINK_CARD_MAX_HEIGHT = 174;
const $903a9b88cd0e7cbe$export$88261377d3b4456a = $903a9b88cd0e7cbe$var$FULL_SMART_LINK_CARD_MAX_HEIGHT * 0.75;
/**
 * Check if an element is text content (markdown or list)
 */ const $903a9b88cd0e7cbe$var$isTextContent = (element)=>typeof element !== 'string' && $903a9b88cd0e7cbe$var$TEXT_CONTENT_TAGS.includes(element.tag);
/**
 * Check if an element is a smart link
 */ const $903a9b88cd0e7cbe$var$isSmartLink = (element)=>typeof element !== 'string' && $903a9b88cd0e7cbe$var$SMART_LINK_TAGS.includes(element.tag);
function $903a9b88cd0e7cbe$export$e6011e70d0aef97f(elements) {
    const textContentRef = (0, $cozmU.useRef)(null);
    const [textHeight, setTextHeight] = (0, $cozmU.useState)(null);
    // Measure text content height after render
    const handleResize = (0, $cozmU.useCallback)((entries)=>{
        const entry = entries[0];
        if (entry) setTextHeight(entry.contentRect.height);
    }, []);
    (0, $1dee242400437624$export$fd29db098e42c3fc)(textContentRef, handleResize);
    // Separate elements by position
    const leftElements = (0, $4539e8c6f4231931$export$7cd3afc49691a77e)(elements, 'left', 0);
    const rightElements = (0, $4539e8c6f4231931$export$7cd3afc49691a77e)(elements, 'right', 1);
    // Determine which column has text content and which has smart links
    const leftHasText = leftElements.some($903a9b88cd0e7cbe$var$isTextContent);
    const rightHasSmartLink = rightElements.some($903a9b88cd0e7cbe$var$isSmartLink);
    const leftHasSmartLink = leftElements.some($903a9b88cd0e7cbe$var$isSmartLink);
    const rightHasText = rightElements.some($903a9b88cd0e7cbe$var$isTextContent);
    // Determine card variant based on measured text height
    // Default to compact card and when text content is shorter than 75% of the full-size smart card height
    const isTextMeasured = textHeight !== null;
    const useCompactCard = !isTextMeasured || isTextMeasured && textHeight <= $903a9b88cd0e7cbe$export$88261377d3b4456a;
    const cardVariant = useCompactCard ? (0, $aUgOE.CardVariant).COMPACT : (0, $aUgOE.CardVariant).FULL;
    // Determine which column should have the ref for measurement
    // Left column takes precedence when both columns would need measurement
    // (since only one ref can be attached at a time)
    const leftNeedsMeasurement = leftHasText && rightHasSmartLink;
    const rightNeedsMeasurement = rightHasText && leftHasSmartLink && !leftNeedsMeasurement;
    return {
        textContentRef: textContentRef,
        isTextMeasured: isTextMeasured,
        cardVariant: cardVariant,
        leftNeedsMeasurement: leftNeedsMeasurement,
        rightNeedsMeasurement: rightNeedsMeasurement,
        leftElements: leftElements,
        rightElements: rightElements
    };
}


const $6c6065832086e0f6$var$styles = {
    leftColumnStyles: "_2O5Vij7dHp _3YEZNO7dHp _4ouGXIdnbC",
    rightColumnStyles: "_3YEZNOdnbC _4ouGXIdnbC"
};
const $6c6065832086e0f6$var$REQUIRED_ELEMENTS_COUNT = 1;
const $6c6065832086e0f6$var$getElementKey = ({ key: key, pos: pos, index: index })=>{
    if (key && pos) return `${key}-${pos}-${index}`;
    if (key) return `${key}-${index}`;
    if (pos) return `${pos}-${index}`;
    return index;
};
const $6c6065832086e0f6$export$db5b24d9942615e8 = ({ elements: elements, key: key, isFoldable: isFoldable = false })=>{
    const { textContentRef: textContentRef, leftNeedsMeasurement: leftNeedsMeasurement, rightNeedsMeasurement: rightNeedsMeasurement, leftElements: leftElements, rightElements: rightElements, cardVariant: cardVariant } = (0, $903a9b88cd0e7cbe$export$e6011e70d0aef97f)(elements);
    if (elements.length < $6c6065832086e0f6$var$REQUIRED_ELEMENTS_COUNT) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6c6065832086e0f6$var$styles.leftColumnStyles,
        ref: leftNeedsMeasurement ? textContentRef : undefined,
        testId: "two-column-layout-left"
    }, leftElements.map((element, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf9a43f0b0d93e55$export$84b484f69b67f84e), {
            component: element,
            position: "two-columns-left",
            key: $6c6065832086e0f6$var$getElementKey({
                key: key,
                pos: element.attributes?.pos,
                index: index
            }),
            isFoldable: isFoldable,
            variant: cardVariant
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6c6065832086e0f6$var$styles.rightColumnStyles,
        ref: rightNeedsMeasurement ? textContentRef : undefined,
        testId: "two-column-layout-right"
    }, rightElements.map((element, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf9a43f0b0d93e55$export$84b484f69b67f84e), {
            component: element,
            position: "two-columns-right",
            key: $6c6065832086e0f6$var$getElementKey({
                key: key,
                pos: element.attributes?.pos,
                index: index
            }),
            isFoldable: isFoldable,
            variant: cardVariant
        }))));
};


/* two-row-layout.tsx generated by @compiled/babel-plugin v3.0.1 */ 









const $fec5cdbb37c3f18a$var$styles = {
    rowStyle: "_39xV02N91d"
};
const $fec5cdbb37c3f18a$var$REQUIRED_ELEMENTS_COUNT = 1;
const $fec5cdbb37c3f18a$var$getElementKey = ({ key: key, pos: pos, index: index })=>{
    if (key && pos) return `${key}-${pos}-${index}`;
    if (key) return `${key}-${index}`;
    if (pos) return `${pos}-${index}`;
    return index;
};
const $fec5cdbb37c3f18a$export$1d297c974620e1b5 = ({ elements: elements, key: key, isFoldable: isFoldable = false })=>{
    if (elements.length < $fec5cdbb37c3f18a$var$REQUIRED_ELEMENTS_COUNT) return null;
    const topElements = (0, $4539e8c6f4231931$export$7cd3afc49691a77e)(elements, 'top', 0);
    const bottomElements = (0, $4539e8c6f4231931$export$7cd3afc49691a77e)(elements, 'bottom', 1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $fec5cdbb37c3f18a$var$styles.rowStyle,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fec5cdbb37c3f18a$var$styles.rowStyle
    }, topElements.map((element, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf9a43f0b0d93e55$export$84b484f69b67f84e), {
            component: element,
            position: "two-rows-top",
            key: $fec5cdbb37c3f18a$var$getElementKey({
                key: key,
                pos: element.attributes?.pos,
                index: index
            }),
            isFoldable: isFoldable
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fec5cdbb37c3f18a$var$styles.rowStyle
    }, bottomElements.map((element, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf9a43f0b0d93e55$export$84b484f69b67f84e), {
            component: element,
            position: "two-rows-bottom",
            key: $fec5cdbb37c3f18a$var$getElementKey({
                key: key,
                pos: element.attributes?.pos,
                index: index
            }),
            isFoldable: isFoldable
        }))));
};


const $af65131e8441cafa$var$styles = {
    overviewStyle: "_0bjKvD8fU6 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXrunmFW _1DCdHi5zaO",
    sectionWrapperStyles: "_313842NHnM"
};
const $af65131e8441cafa$export$62abb2537ec99d20 = ({ section: section, defaultFoldedState: defaultFoldedState })=>{
    const layout = section.attributes?.layout || 'one-column';
    const isOverview = section.attributes?.overview === '1';
    const isFoldable = section.attributes?.hasOwnProperty('folded');
    let header;
    let content;
    if (Array.isArray(section.children)) {
        const headerElement = section.children.filter((element)=>(0, $34b0857017e74170$export$52e6c7c72e88442f)(element));
        if (headerElement.length) header = headerElement[0];
        content = section.children?.filter((element)=>!(0, $34b0857017e74170$export$52e6c7c72e88442f)(element));
    }
    if (!content || content && !content.length) return null;
    const renderContent = ()=>{
        switch(layout){
            case 'one-column':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0741daaf14376927$export$1a9cda7e8be08d8), {
                    elements: content,
                    isFoldable: isFoldable
                });
            case 'two-columns':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c6065832086e0f6$export$db5b24d9942615e8), {
                    elements: content,
                    key: section.attributes?.n,
                    isFoldable: isFoldable
                });
            case 'two-rows':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fec5cdbb37c3f18a$export$1d297c974620e1b5), {
                    elements: content,
                    key: section.attributes?.n,
                    isFoldable: isFoldable
                });
        }
    };
    if (defaultFoldedState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $02d37fec4a3fe277$export$1f15b0b67d49b0f6), {
        defaultFoldedState: defaultFoldedState,
        header: header,
        content: content
    }, renderContent());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "start",
        xcss: (0, $k12R1.cx)(isOverview && $af65131e8441cafa$var$styles.overviewStyle),
        testId: "dynamic-layout-section",
        "data-layout": layout,
        "data-overview": isOverview
    }, header && header.attributes?.show !== 'false' && content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: $af65131e8441cafa$var$styles.sectionWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, header && header.children)), renderContent());
};


const $1b9eacf08bc3ac89$export$8a161f487bc08d6e = (parsedAnswer)=>{
    let firstFoldableSectionIdx = -1;
    for(let i = 0; i < parsedAnswer.length; i++)if (parsedAnswer[i].attributes?.hasOwnProperty('folded')) {
        firstFoldableSectionIdx = i;
        break;
    }
    return firstFoldableSectionIdx;
};


const $d3a80726f3726740$var$styles = {
    containerStyles: "_2fwxA5ecOK"
};
const $d3a80726f3726740$export$21094bc4b0d39e4b = ({ contentToRender: contentToRender })=>{
    const parsedAnswer = (0, $fb2afea4934d8744$export$6fdccd51aa07b64f)(contentToRender);
    const firstFoldableIndex = (0, $1b9eacf08bc3ac89$export$8a161f487bc08d6e)(parsedAnswer);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d3a80726f3726740$var$styles.containerStyles,
        testId: "dynamic-layout-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, parsedAnswer && parsedAnswer.length && parsedAnswer.map((section, index)=>{
        const isFoldable = section.attributes?.hasOwnProperty('folded');
        const defaultFoldedState = isFoldable ? index === firstFoldableIndex ? 'expanded' : 'collapsed' : undefined;
        return(// TODO: rename this component to be singular
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af65131e8441cafa$export$62abb2537ec99d20), {
            key: index,
            section: section,
            defaultFoldedState: defaultFoldedState
        }));
    }))));
};


/* dynamic-layout-sources-dropdown.tsx generated by @compiled/babel-plugin v3.0.1 */ 












var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");














const $d67afebeb1603797$var$messages = (0, $kSwu1.defineMessages)({
    sources_text: {
        id: "search_ai.dynamic_layout_sources_text",
        defaultMessage: "{numSources, plural, one {Source} other {Sources}}"
    },
    sources_group_title: {
        id: "search_ai.dynamic_layout_sources_group_title",
        defaultMessage: "{numSources, plural, one {{numSources, number} Source} other {{numSources, number} Sources}}"
    }
});
const $d67afebeb1603797$var$styles = {
    dropdownContent: "_1EqgXlHakr"
};
const $d67afebeb1603797$export$befc5243628631e7 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { commonAttributes: commonAttributes } = context;
    const { sources: sources } = commonAttributes;
    const { handleSmartCardClick: handleSmartCardClick, searchSessionId: searchSessionId } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context
    });
    if (!sources || sources.length === 0) return null;
    const numSources = sources.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ref: triggerRef,
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0122fe4f75fa739$export$ebff7094edd1bb81), {
                sources: sources
            }), formatMessage($d67afebeb1603797$var$messages.sources_text, {
                numSources: numSources
            }))),
        isOpen: isOpen,
        onOpenChange: (attrs)=>setIsOpen(attrs.isOpen)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d67afebeb1603797$var$styles.dropdownContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), {
        title: formatMessage($d67afebeb1603797$var$messages.sources_group_title, {
            numSources: numSources
        })
    }, sources.map((source, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: source.url || index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aUgOE.KnowledgeSmartCard), {
            source: source,
            variant: (0, $aUgOE.CardVariant).DROPDOWN_SOURCE,
            index: index,
            searchSessionId: searchSessionId,
            onClickHandler: handleSmartCardClick
        }))))));
};



















const $12ca716b9376ab26$var$styles = {
    fullWidth: "_39xV02qUim _1EqgXlN91d _2Zuz6Q8HPE _1Znuxb8HPE",
    container: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    interactive: "_0wOv4Q7zJH _0KLXru66of _39xV02N91d",
    expanded: "_0KLXru66of _39xV02N91d",
    root: "_4kiQYAk3g7",
    fullHeight: "_0jFU0VN91d",
    followUpChatInputSectionStyles: "_313842Va5s",
    disclaimerWrapperStyles: "_1wydGW8HPE _2Zuz6Q5zaO _2IVJ4M6wH8 _3zygPU9r67 _22sfPnNvrM",
    headerContainer: "_4kiQYAUF4f _1wydGW2ADO",
    loadingSkeletonContainer: "_3138425zaO _1DCdHi5zaO"
};
function $12ca716b9376ab26$var$SmartAnswerCardDynamicLayoutComponent({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent }) {
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(true);
    const [didUserTriggerCollapse, setDidUserTriggerCollapse] = (0, $cozmU.useState)(false);
    const [isVisibleTextComplete, setIsVisibleTextComplete] = (0, $cozmU.useState)(false);
    const [showAnimation, setShowAnimation] = (0, $cozmU.useState)(false);
    const componentRenderTimeRef = (0, $cozmU.useRef)(Date.now());
    const firstByteEventFiredRef = (0, $cozmU.useRef)(false);
    const { commonAttributes: commonAttributes, hasError: hasError, isAnswered: isAnswered, loading: loading, partialResponse: partialResponse, traceHeaders: traceHeaders } = (0, $3hVWe.useAIAnswerContext)();
    const { queryHash: queryHash, searchSessionId: searchSessionId, answerString: answerString, sources: sources, errorStateSuggestedQueries: errorStateSuggestedQueries } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const streamingText = partialResponse?.partialNlpResult ?? '';
    const [streamingTextToDisplay, setStreamingTextToDisplay] = (0, $cozmU.useState)(streamingText); // Refs for content truncation detection
    const isVisibleTextCompleteRef = (0, $cozmU.useRef)(false);
    const completeAnswerAnalyticsEventFiredRef = (0, $cozmU.useRef)(false);
    const renderedContentRef = (0, $cozmU.useRef)(null);
    const contentContainerRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (collapsed && !isVisibleTextComplete) setStreamingTextToDisplay(streamingText);
        else if (!collapsed) setStreamingTextToDisplay(streamingText);
    }, [
        collapsed,
        isVisibleTextComplete,
        streamingText
    ]); // Notify context when collapsed state changes
    (0, $cozmU.useEffect)(()=>{
        onAnswerExpandedChange?.(!collapsed);
    }, [
        collapsed,
        onAnswerExpandedChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError && !isVisibleTextComplete) {
            setIsVisibleTextComplete(true);
            onFMPReached?.(); // Mark FMP as reached for cached answers
        }
    }, [
        loading,
        hasError,
        isVisibleTextComplete,
        onFMPReached
    ]); // Track if we should show animations (if loading or partialResponse are true)
    (0, $cozmU.useEffect)(()=>{
        if (!showAnimation && loading && partialResponse) setShowAnimation(true);
    }, [
        loading,
        partialResponse,
        showAnimation
    ]); // use useEffect to trigger analytics event in order to avoid needing to
    // pass commonAttributes as a dependency to handleExpandCollapseButtonClick
    // and thus avoid re-rendering SmartAnswerCardBodyStreaming with every
    // update to commonAttributes (which gets updated with the streamed text)
    (0, $cozmU.useEffect)(()=>{
        if (didUserTriggerCollapse) fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes));
    }, [
        didUserTriggerCollapse,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Detect if content is truncated when collapsed
    const isContentTruncated = (0, $6df3d09e09b61b24$export$d112da4490f261ea)(renderedContentRef, contentContainerRef, collapsed); // Complete answer analytics
    (0, $cozmU.useEffect)(()=>{
        // Only fire once and ensure DOM element is ready with meaningful content
        if (completeAnswerAnalyticsEventFiredRef.current || !renderedContentRef.current) return;
        const answerHeight = renderedContentRef.current.getBoundingClientRect().height;
        const containerHeight = contentContainerRef.current?.getBoundingClientRect().height ?? 0;
        const whitespaceHeight = Math.max(containerHeight - answerHeight, 0); // Only fire if we have meaningful height (content is rendered)
        if (answerHeight > 0 && containerHeight > 0) {
            fireAnalyticsEvent((0, $d58a262274d16c7a$export$f3109245f09f7746)({
                ...commonAttributes,
                answerHeight: answerHeight,
                containerHeight: containerHeight,
                whitespaceHeight: whitespaceHeight,
                queryIntent: queryIntent
            }));
            completeAnswerAnalyticsEventFiredRef.current = true;
        }
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        queryIntent,
        isContentTruncated
    ]); // SAIN usage event
    (0, $cozmU.useEffect)(()=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleExpandCollapseButtonClick = (0, $cozmU.useCallback)(()=>{
        if (collapsed) {
            setCollapsed(false);
            setDidUserTriggerCollapse(false);
        } else {
            setCollapsed(true);
            setDidUserTriggerCollapse(true);
        }
    }, [
        collapsed
    ]);
    const handleVisibleTextComplete = (0, $cozmU.useCallback)(()=>{
        setIsVisibleTextComplete(true);
        onFMPReached?.(); // Mark FMP as reached for streaming answers
    }, [
        onFMPReached
    ]);
    const sourceClickCallback = (0, $cozmU.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent
    ]); // UFO resize observer for streaming
    const resizeObserverCallback = (0, $cozmU.useCallback)(()=>{
        if (!isVisibleTextCompleteRef.current && renderedContentRef.current && contentContainerRef.current) {
            const renderedContentRefHeight = renderedContentRef.current.getBoundingClientRect().height;
            const contentContainerRefHeight = contentContainerRef.current.getBoundingClientRect().height;
            const isVisibleTextComplete = renderedContentRefHeight > contentContainerRefHeight;
            if (isVisibleTextComplete) {
                handleVisibleTextComplete();
                isVisibleTextCompleteRef.current = true;
            }
        }
    }, [
        handleVisibleTextComplete
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1dee242400437624$export$fd29db098e42c3fc)(renderedContentRef, resizeObserverCallback);
    const bufferedContent = (0, $d3e29575f8ad4c54$export$8f4f0a9c358684c2)(streamingTextToDisplay, isAnswered && !loading);
    (0, $cozmU.useEffect)(()=>{
        if (bufferedContent.length > 0 && !firstByteEventFiredRef.current) {
            fireAnalyticsEvent((0, $bd6e42147a6848a8$export$c68095583a3c17cc)({
                ...commonAttributes,
                timeToFirstByte: Date.now() - componentRenderTimeRef.current
            }));
            firstByteEventFiredRef.current = true;
        }
    }, [
        bufferedContent,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Use answerString when complete, bufferedContent when streaming
    const contentToRender = isAnswered ? answerString : bufferedContent; // Experiments
    const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    });
    const showReadMoreButton = collapsed && isContentTruncated; // Single return statement with React component for main content
    const isStreaming = !isAnswered && (loading || loading === undefined); // Early return for error state
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $12ca716b9376ab26$var$styles.fullWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f366b75433df2895$export$ffa24cd7196ce1b0), null));
     // Early return for generating state
    if (!isAnswered && (loading || loading === undefined)) {
        if (!partialResponse || bufferedContent.length < 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $12ca716b9376ab26$var$styles.fullWidth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aiIBH.SmartAnswerCardBodyGenerating), {
            heightOverride: (0, $7DMz5.SAINFeatureControl).isFullHeightLuminaEnabled() ? 'lumina' : undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f420039341622608$export$8a1fad5d74d43878), {
            isStreaming: true,
            showMoreButtonVisible: false
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $12ca716b9376ab26$var$styles.fullWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog-all-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog-visible-text"
    }, isVisibleTextComplete ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "search-ai-dialog-visible-text-loading"
    }), (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "queryHash",
        value: queryHash
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "searchSessionId",
        value: searchSessionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "queryIntent",
        value: queryIntent
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            queryIntent: queryIntent
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12ca716b9376ab26$export$3714848962bfb827, {
        isStreaming: isStreaming,
        collapsed: collapsed,
        isContentTruncated: isContentTruncated,
        showReadMoreButton: showReadMoreButton,
        handleExpandCollapseButtonClick: handleExpandCollapseButtonClick,
        contentContainerRef: contentContainerRef,
        renderedContentRef: renderedContentRef,
        sources: sources,
        searchSessionId: searchSessionId,
        sourceClickCallback: sourceClickCallback,
        errorStateSuggestedQueries: errorStateSuggestedQueries,
        serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp,
        commonAttributes: commonAttributes,
        contentToRender: contentToRender,
        showAnimation: showAnimation,
        traceHeaders: traceHeaders
    }))));
}
function $12ca716b9376ab26$export$3714848962bfb827({ isStreaming: isStreaming, collapsed: collapsed, isContentTruncated: isContentTruncated, showReadMoreButton: showReadMoreButton, handleExpandCollapseButtonClick: handleExpandCollapseButtonClick, contentContainerRef: contentContainerRef, renderedContentRef: renderedContentRef, errorStateSuggestedQueries: errorStateSuggestedQueries, serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp, commonAttributes: commonAttributes, contentToRender: contentToRender, traceHeaders: traceHeaders }) {
    const { dynamicLayoutSubAgentMessages: dynamicLayoutSubAgentMessages, userDetails: userDetails } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const handleLuminaEvent = (0, $cozmU.useCallback)((event)=>{
        if (event.payload.action === 'interacted' && event.payload.attributes.componentType === 'smartLink' && event.payload.attributes.interactionType === 'clicked') {
            const attributes = event.payload.attributes;
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
                commonAttributes: commonAttributes,
                sourceProduct: attributes.product ?? undefined
            });
        }
    }, [
        fireSAINUsageEvent,
        commonAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4217877a0025dc35$export$127e64693c41156a), {
        isCollapsed: collapsed && (isStreaming || isContentTruncated),
        onExpandCollapse: handleExpandCollapseButtonClick,
        ref: contentContainerRef,
        showReadMoreButton: showReadMoreButton,
        luminaAnswerType: "LUMINA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center",
        xcss: $12ca716b9376ab26$var$styles.headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
        label: "AI Content",
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h1",
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).smart_answer_card_dynamic_layout_title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d67afebeb1603797$export$befc5243628631e7), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: renderedContentRef,
        testId: "sain-fmp-target"
    }, (0, $iDrrr.fg)('kd_enable_lumina_package') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: (0, $gmCV5.EVENT_CHANNEL),
        onEvent: handleLuminaEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kfIS7.LuminaLayout), {
        luminaTagResponse: contentToRender,
        luminaSubAgentResponse: dynamicLayoutSubAgentMessages,
        isStreaming: isStreaming,
        source: "luminaSAIN",
        traceId: traceHeaders?.['X-B3-TraceId'],
        spanId: traceHeaders?.['X-B3-SpanId'],
        cloudId: commonAttributes.cloudId,
        orgId: commonAttributes.orgId,
        requestingUserId: userDetails.id ?? '',
        sourceProduct: commonAttributes.sourceProduct
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3a80726f3726740$export$21094bc4b0d39e4b), {
        contentToRender: contentToRender
    })), isStreaming && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200",
        xcss: $12ca716b9376ab26$var$styles.loadingSkeletonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "16px",
        color: "var(--ds-skeleton-subtle, #17171708)",
        borderRadius: "var(--ds-radius-medium, 6px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "16px",
        color: "var(--ds-skeleton-subtle, #17171708)",
        borderRadius: "var(--ds-radius-medium, 6px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "75%",
        height: "16px",
        color: "var(--ds-skeleton-subtle, #17171708)",
        borderRadius: "var(--ds-radius-medium, 6px)"
    })))))), (showReadMoreButton || isStreaming) && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f420039341622608$export$8a1fad5d74d43878), {
        isStreaming: isStreaming,
        showMoreButtonVisible: showReadMoreButton,
        onClickShowMoreButton: handleExpandCollapseButtonClick
    }), !isStreaming && (!collapsed || !showReadMoreButton || errorStateSuggestedQueries.length > 0 && serveErrorStateSuggestedQueriesExp) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $12ca716b9376ab26$var$styles.followUpChatInputSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a921764ae1a692a7$export$f087ce3403d54eb5), {
        omitDialogues: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j8bJ5.OpenChatInputBox), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $12ca716b9376ab26$var$styles.disclaimerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: !isStreaming,
        showCopyButton: false,
        renderedContentRef: renderedContentRef
    }))) : null);
} // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $12ca716b9376ab26$export$b547d87531f467be({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "smart-answer-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12ca716b9376ab26$var$SmartAnswerCardDynamicLayoutComponent, {
        onFMPReached: onFMPReached,
        onAnswerExpandedChange: onAnswerExpandedChange,
        queryIntent: queryIntent
    }));
}






var $iDdTC = parcelRequire("iDdTC");

const $a7513ed93542ee2f$export$a83a35d6598a5fb6 = (0, $iDdTC.metrics).pageSegmentLoad({
    key: 'ai-search-dialog'
});


/* ai-answer-default-loading-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 








var $6JxPX = parcelRequire("6JxPX");

const $28ffaa5aebbd61cc$export$476294a9cde8f045 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReadingAids: isReadingAids, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_90kafy": (0, $9aYkv.default)((0, $6JxPX.grid).px)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.isReadingAids ? "_4FKVYENHnM _39xV02N91d _0jFU0VaXQy _24h04i2Njc" : "_39xV02aS7z _313842knUo",
            __cmplp.className
        ])
    });
});





/* definition-answer-card.tsx generated by @compiled/babel-plugin v3.0.1 */ 






var $57p4j = parcelRequire("57p4j");




















var $kYeKA = parcelRequire("kYeKA");







var $hsCD1 = parcelRequire("hsCD1");

/* DefinitionSources.tsx generated by @compiled/babel-plugin v3.0.1 */ 







































const $71f7b5ea8cb696e0$export$960f61383b799882 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiSourceFetchSmartlinkData',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};





const $642b9c63e5969b23$var$OBJECT_RESOLVER_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $642b9c63e5969b23$export$6d6d0aa8067b2c97 = ({ urls: urls })=>{
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [objectResolverData, setObjectResolverData] = (0, $cozmU.useState)([]);
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const urlKeys = (0, $cozmU.useMemo)(()=>urls.join('|'), [
        urls
    ]);
    (0, $cozmU.useEffect)(()=>{
        const fetchObjectResolver = async ()=>{
            if (!urls.length) {
                setIsLoading(false);
                return;
            }
            try {
                const objectResolver = await (0, $jDZkE.fetchRestResponse)({
                    url: $642b9c63e5969b23$var$OBJECT_RESOLVER_ENDPOINT,
                    body: urls.map((url)=>({
                            resourceUrl: url
                        }))
                });
                if (!objectResolver) {
                    setIsLoading(false);
                    return;
                }
                const objectData = objectResolver.reduce((resolvedSources, resolverResponse, sourceIndex)=>{
                    if (resolverResponse.status === 200) resolvedSources.push({
                        sourceData: resolverResponse.body,
                        sourceIndex: sourceIndex
                    });
                    return resolvedSources;
                }, []);
                setObjectResolverData(objectData);
                setIsLoading(false);
            } catch (error) {
                if (error instanceof Object && 'message' in error) fireAnalyticsEvent((0, $71f7b5ea8cb696e0$export$960f61383b799882)(error, commonAttributes));
                setIsLoading(false);
            }
        };
        fetchObjectResolver();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        urlKeys
    ]);
    return {
        isLoading: isLoading,
        objectResolverData: objectResolverData
    };
};


/* DefinitionSource.tsx generated by @compiled/babel-plugin v3.0.1 */ 
































const $3f3c55779d6f62ac$var$toTitleCase = (sourceCategory)=>sourceCategory.split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
const $3f3c55779d6f62ac$var$styles = {
    root: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8",
    sourceIconWrapperStyles: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39xV02ey7F _0jFU0Vey7F"
};
const $3f3c55779d6f62ac$export$c7fb9dc39c758aa3 = ({ source: source, sourceData: sourceData, sourceIndex: sourceIndex })=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const is1PSource = sourceData.data.generator?.name === 'Confluence';
    const sourceMetadata = is1PSource ? sourceData.data.summary : sourceData.entityData?.type ? $3f3c55779d6f62ac$var$toTitleCase(sourceData.entityData.type.category) : undefined;
    const onClickSource = (0, $cozmU.useCallback)(()=>{
        const sourceProduct = sourceData.data.generator?.name.toLowerCase() || '';
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: sourceIndex,
            sourceProduct: sourceProduct,
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(sourceData.data.generator?.name),
            ...commonAttributes
        }));
        if ((0, $iDrrr.fg)('kd_definitions_source_product_clicked')) fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            source: source,
            sourceProduct: sourceProduct
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        commonAttributes
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
        href: sourceData.data.url,
        xcss: $3f3c55779d6f62ac$var$styles.root,
        target: "_blank",
        onClick: onClickSource
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, sourceData.data.generator && /*#__PURE__*/ $cozmU.createElement((0, $1xWgP.AppIcon), {
        app: sourceData.data.generator.name.toLowerCase(),
        size: "xxsmall"
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text",
        maxLines: 1,
        weight: "medium"
    }, sourceData.data.name))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: 2,
        color: "color.text.subtle",
        size: "small"
    }, sourceMetadata))));
};


const $0c874a49d33f2b0f$var$messages = (0, $kSwu1.defineMessages)({
    definition_sources_stack_text: {
        id: "search_ai.definition_sources_stack_text",
        defaultMessage: "{numResolvedSources, plural, =1 {{numResolvedSources, number} Source} other {{numResolvedSources, number} Sources}}"
    },
    definition_source_stack_text: {
        id: "search_ai.definition_source_stack_text",
        defaultMessage: "source"
    }
});
const $0c874a49d33f2b0f$var$styles = {
    root: "_0Of8r22ADO _1Znuxb5zaO _2Zuz6Q5zaO _1wydGW2ADO",
    sourcesStackContainerStyles: "_0bjKvDKTcp _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _39xV02E6Kk _2Zuz6Q8HPE _1Znuxb8HPE _0Of8r2gVvo _1wydGWgVvo",
    dividerStyles: "_2IVJ4M6wH8 _22sfPnNvrM _3zygPU9r67"
};
const $0c874a49d33f2b0f$var$DEFINITION_MAX_SOURCES = 3;
const $0c874a49d33f2b0f$export$63e4658af6ffde25 = ({ sources: sources })=>{
    const [sourcesExpanded, setSourcesExpanded] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const sourcesUrls = sources.map((source)=>source.url).slice(0, $0c874a49d33f2b0f$var$DEFINITION_MAX_SOURCES);
    const { objectResolverData: objectResolverData } = (0, $642b9c63e5969b23$export$6d6d0aa8067b2c97)({
        urls: sourcesUrls
    });
    const resolvedSources = objectResolverData.flatMap(({ sourceData: sourceData, sourceIndex: sourceIndex })=>{
        const source = sources[sourceIndex];
        return source ? [
            {
                source: source,
                sourceData: sourceData,
                sourceIndex: sourceIndex
            }
        ] : [];
    });
    const numResolvedSources = resolvedSources.length;
    return numResolvedSources === 0 ? null : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $0c874a49d33f2b0f$var$styles.root
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        onClick: ()=>setSourcesExpanded(!sourcesExpanded)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $f0122fe4f75fa739$export$ebff7094edd1bb81), {
        maxSourcesInStack: $0c874a49d33f2b0f$var$DEFINITION_MAX_SOURCES,
        sources: resolvedSources.map(({ source: source })=>source)
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, formatMessage($0c874a49d33f2b0f$var$messages.definition_sources_stack_text, {
        numResolvedSources: numResolvedSources
    })))), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        onClick: ()=>setSourcesExpanded(!sourcesExpanded),
        icon: (iconProps)=>sourcesExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps,
                size: "small"
            }),
        appearance: "subtle",
        label: sourcesExpanded ? (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? 'Collapse sources' : 'Collapse sources button' : (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? 'Expand sources' : 'Expand sources button',
        testId: "definitions-sources-expand"
    })), sourcesExpanded && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $0c874a49d33f2b0f$var$styles.dividerStyles
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, resolvedSources.map(({ source: source, sourceData: sourceData, sourceIndex: sourceIndex })=>/*#__PURE__*/ $cozmU.createElement((0, $3f3c55779d6f62ac$export$c7fb9dc39c758aa3), {
            source: source,
            sourceData: sourceData,
            sourceIndex: sourceIndex,
            key: `${sourceData.data.url}-${sourceIndex}`
        }))))));
};


/* loading-dot-wave.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $183b5c97f283e9b6$var$loadingDotWaveWrapperStyles = null;
const $183b5c97f283e9b6$export$c7f94e62a2f54f71 = ({ width: width, height: height = 15 })=>{
    const canvasRef = (0, $cozmU.useRef)(null);
    const dotsRef = (0, $cozmU.useRef)([]);
    const animationRef = (0, $cozmU.useRef)();
    const timeRef = (0, $cozmU.useRef)(0); // Calculate number of dots based on consistent spacing
    const dotRadius = 2;
    const idealSpacing = width < 18 ? 6 : 8.4;
    const availableWidth = width - dotRadius * 2;
    const maxDots = Math.floor(availableWidth / idealSpacing) + 1;
    const dotCount = Math.max(2, maxDots); // Initialize dots
    const initDots = (0, $cozmU.useCallback)(()=>{
        const dots = [];
        const centerY = height / 2; // Calculate available space for dots (subtract padding for dot radius on both sides)
        const availableWidth = width - 1 - dotRadius * 2;
        const spacing = dotCount > 1 ? availableWidth / (dotCount - 1) : 0;
        for(let i = 0; i < dotCount; i++)dots.push({
            x: dotRadius + i * spacing,
            // Start from dotRadius to avoid cutoff
            y: centerY,
            baseY: centerY,
            phase: i / dotCount * Math.PI * 2,
            size: dotRadius
        });
        return dots;
    }, [
        dotCount,
        height,
        width
    ]);
    // Gradient for dots
    const createGradient = (0, $cozmU.useCallback)((ctx, x)=>{
        const gradient = ctx.createRadialGradient(x, 0, 0, x, 0, dotRadius); // Calculate position along the available width for color interpolation
        const availableWidth = width - dotRadius * 2;
        const adjustedX = x - dotRadius;
        const position = availableWidth > 0 ? Math.max(0, Math.min(1, adjustedX / availableWidth)) : 0; // Create linear gradient with colors: #0065FF → #0267FF → #BF63F3 → #FFA900
        const colors = [
            {
                r: 0,
                g: 101,
                b: 255
            },
            // #0065FF
            {
                r: 2,
                g: 103,
                b: 255
            },
            // #0267FF
            {
                r: 191,
                g: 99,
                b: 243
            },
            // #BF63F3
            {
                r: 255,
                g: 169,
                b: 0
            }
        ];
        let color;
        if (position <= 0.33) {
            // Interpolate between #0065FF and #0267FF
            const localPos = position / 0.33;
            const color1 = colors[0];
            const color2 = colors[1];
            color = {
                r: Math.floor(color1.r + (color2.r - color1.r) * localPos),
                g: Math.floor(color1.g + (color2.g - color1.g) * localPos),
                b: Math.floor(color1.b + (color2.b - color1.b) * localPos)
            };
        } else if (position <= 0.66) {
            // Interpolate between #0267FF and #BF63F3
            const localPos = (position - 0.33) / 0.33;
            const color1 = colors[1];
            const color2 = colors[2];
            color = {
                r: Math.floor(color1.r + (color2.r - color1.r) * localPos),
                g: Math.floor(color1.g + (color2.g - color1.g) * localPos),
                b: Math.floor(color1.b + (color2.b - color1.b) * localPos)
            };
        } else {
            // Interpolate between #BF63F3 and #FFA900
            const localPos = (position - 0.66) / 0.34;
            const color1 = colors[2];
            const color2 = colors[3];
            color = {
                r: Math.floor(color1.r + (color2.r - color1.r) * localPos),
                g: Math.floor(color1.g + (color2.g - color1.g) * localPos),
                b: Math.floor(color1.b + (color2.b - color1.b) * localPos)
            };
        }
        gradient.addColorStop(0, `rgb(${color.r}, ${color.g}, ${color.b})`);
        gradient.addColorStop(1, `rgb(${Math.floor(color.r * 0.8)}, ${Math.floor(color.g * 0.8)}, ${Math.floor(color.b * 0.8)})`);
        return gradient;
    }, [
        width
    ]);
    // Animation loop
    const animate = (0, $cozmU.useCallback)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        // Clear canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height); // Update time
        timeRef.current += 0.08; // Update and draw dots
        dotsRef.current.forEach((dot)=>{
            // Calculate wave motion
            const waveOffset = Math.sin(timeRef.current + dot.phase);
            dot.y = dot.baseY + waveOffset; // Apply gradient to this dot
            const gradient = createGradient(ctx, dot.x); // Draw dot
            ctx.beginPath();
            ctx.arc(dot.x, dot.y, dot.size, 0, Math.PI * 2);
            ctx.fillStyle = gradient;
            ctx.fill(); // Add subtle shadow
            ctx.shadowColor = 'rgba(0, 0, 0, 0.1)';
            ctx.shadowBlur = 2;
            ctx.shadowOffsetY = 1;
        });
        // Continue animation
        animationRef.current = requestAnimationFrame(animate);
    }, [
        canvasRef,
        createGradient
    ]);
    // Initialize dots when width changes
    (0, $cozmU.useEffect)(()=>{
        dotsRef.current = initDots();
    }, [
        width,
        dotCount,
        height,
        initDots
    ]);
    // Set up canvas and start animation
    (0, $cozmU.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        // Set canvas dimensions
        canvas.width = width;
        canvas.height = height; // Start animation
        animationRef.current = requestAnimationFrame(animate); // Cleanup
        return ()=>{
            if (animationRef.current) cancelAnimationFrame(animationRef.current);
        };
    }, [
        animate,
        height,
        width
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTonUgYP"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("canvas", {
        ref: canvasRef,
        width: width,
        height: height
    }));
};























/* ai-answer-body-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 







const $98e3090d57b087a8$export$373eea644718ed14 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReadingAids: isReadingAids, serveDefinitionsUXExp: serveDefinitionsUXExp, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_9ebqy0": (0, $9aYkv.default)(__cmplp.serveDefinitionsUXExp ? `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-050, 4px)"}` : `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-050, 4px)"}`)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.isReadingAids ? "_2mHwu82ADO _4FKVYELb9f _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC" : "_2mHwu82ADO _4FKVYEdqw2 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC",
            __cmplp.className
        ])
    });
});


/* ai-answer-error-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $bc3521c1c358b703$export$106e8178ce804384 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1ZnuxbNHnM",
            __cmplp.className
        ])
    });
});
















var $br26d = parcelRequire("br26d");





























const $c19df9a6f96e2f1c$export$b22e9ed865dfbcfa = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerRecentWorkListLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};





const $9b5790cac325151c$export$3eb2378888745842 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerRecentWorkListLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};


/* empty-state-text-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $c9d631ae658deba5$export$73d0188d97126121 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _3138425zaO _1UtDYzUktF",
            __cmplp.className
        ])
    });
});


/* link-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $4b1015dd26cfab9c$export$ce4b6a469c26f53f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _2XsHFM2ADO _0XEZqI7NXe _2AV1rB7NXe _4fgkWA7NXe _0Ya391DqSm _3syKoKDqSm _3ZsYrqDqSm _0DU3KTDqSm _2h7MEPDqSm _0BXPwdDqSm _1004K3DqSm _3tOQhEDqSm _3PFkzMDqSm _1aQ935DqSm _04h2sEDqSm _0DtnpGDqSm _1dLpBwS2te _1iJnp6S2te _4ACwSfS2te",
            __cmplp.className
        ])
    });
});





const $2b74ffab90174614$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    recentWorkListTitle: {
        id: "search_ai.ai_answer_dialog.recent_work_list.title",
        defaultMessage: "Recently worked on"
    },
    viewAllLink: {
        id: "search_ai.ai_answer_dialog.recent_work_list.view_all_link",
        defaultMessage: "View all"
    },
    showMore: {
        id: "search_ai.ai_answer_dialog.recent_work_list.show_more",
        defaultMessage: "Show more"
    },
    no_activity_error_text: {
        id: "search_ai.ai_answer_dialog.recent_work_list.no_activity_error_text",
        defaultMessage: "Atlassian Intelligence doesn\u2019t have enough data to provide a response right now. This may be because {user} is new and they haven't interacted with Confluence yet. In the meantime, try asking a different question."
    }
});

















const $7654c2fc49f1bf0c$export$5c8be2d1a7dc557 = ({ index: index, url: url, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerRecentWorkItem',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            index: index
        },
        nonPrivacySafeAttributes: {
            query: query,
            url: url,
            answerString: answerString
        }
    };
};





const $4b3f5fef4ad78890$export$440c60ade2f202a9 = ({ index: index, url: url, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerRecentWorkItem',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            index: index
        },
        nonPrivacySafeAttributes: {
            query: query,
            url: url,
            answerString: answerString
        }
    };
};



/* recent-work-item-body.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $4810c34de5bfdc3a$export$37f6bd651093c20a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _2XsHFM5zaO _37wbyuDIqT _4ouGXIdnbC",
            __cmplp.className
        ])
    });
});


/* recent-work-item-byline.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $6bbf6c045161468d$export$6a9e1330548eac8 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _4bt5LAnQyn _2WAcuGnQyn _1UtDYzKGUX _39HuIbz8Lp _1ANEUSLRg7 _1Znuxb2ADO _4ouGXIdnbC",
            __cmplp.className
        ])
    });
});


/* recent-work-item-container.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $33371da52face204$export$6e18a3d821f78b73 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0GBAIr6Ttf _4bqSyP1Y8M _3Ico7N1Y8M",
            __cmplp.className
        ])
    });
});


/* recent-work-item-description.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $6c0c989a27a4f633$export$a644bde83ad79b45 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.className
        ])
    });
});


/* recent-work-item-icon.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $a18f12cc671a465a$export$c779e0225c7a4abb = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _3iDTPbQ4SZ _3YEZNOdnbC _39xV02NHnM _0jFU0VNHnM _3138422ADO _1DCdHi2ADO",
            __cmplp.className
        ])
    });
});


/* recent-work-item-link.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $273693369f6f0391$export$df8ab4b5e2ff1243 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _4bt5LAnQyn _2WAcuGnQyn _0bjKvDzXzM _1mT5xdRAKS _3iDTPbvLZJ _2Zuz6Q2ADO _1Znuxb2ADO _1zr6Dc98eZ _0htemXYbGa _067LcednbC _0ui43C5UpH _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126",
            __cmplp.className
        ])
    });
});


/* recent-work-item-title.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $ade312d40199de7f$export$398e991be65309e3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1Znuxb2ADO _1wydGWFQfX _3iDTPbQ4SZ _0hPCNLDIqT _3zRROkEqul _0PxwN5dnbC _2ukBsMdnbC _1IqrEmdnbC _0NvCJadnbC _21mr2AnQyn _2aHgeynQyn _3oVIv4vbI6 _2waFOoy7kJ _0nAUbcz8Lp _0ohm36LRg7",
            __cmplp.className
        ])
    });
});


/* recent-work-item-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $035d4343be96ae71$export$246596915c6a37b0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ",
            __cmplp.className
        ])
    });
});


const $ebb4db69cc755bd7$export$9adc0410c9970c44 = ({ index: index, title: title, iconUrl: iconUrl, url: url, container: container, event: event, contributors: contributors, timestamp: timestamp, othersCount: othersCount })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { userDetails: { id: currentUserId }, fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, onNavigate: onNavigate } = (0, $3hVWe.useAIAnswerContext)();
    const description = (0, $998049cf2dbeb756$export$4d98da88c6a5014a)({
        currentUserId: !!currentUserId ? currentUserId : '',
        event: event,
        contributors: contributors,
        othersCount: othersCount,
        formatMessage: formatMessage,
        formatDate: formatDate,
        timestamp: new Date(timestamp)
    });
    const onClick = (0, $cozmU.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $7654c2fc49f1bf0c$export$5c8be2d1a7dc557)({
            index: index,
            url: url,
            ...commonAttributes
        }));
    }, [
        onNavigate,
        fireAnalyticsEvent,
        index,
        url,
        commonAttributes
    ]);
    const onContextMenuClick = (0, $cozmU.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $4b3f5fef4ad78890$export$440c60ade2f202a9)({
            index: index,
            url: url,
            ...commonAttributes
        }));
    }, [
        onNavigate,
        fireAnalyticsEvent,
        index,
        url,
        commonAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $273693369f6f0391$export$df8ab4b5e2ff1243), {
        href: url,
        onClick: onClick,
        onContextMenu: onContextMenuClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $035d4343be96ae71$export$246596915c6a37b0), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a18f12cc671a465a$export$c779e0225c7a4abb), {
        src: iconUrl,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4810c34de5bfdc3a$export$37f6bd651093c20a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ade312d40199de7f$export$398e991be65309e3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6bbf6c045161468d$export$6a9e1330548eac8), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33371da52face204$export$6e18a3d821f78b73), null, container), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c0c989a27a4f633$export$a644bde83ad79b45), null, description)))));
};


/* recent-work-list-title.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $824b1f7e98cbde58$export$9a485269bf2c8987 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ",
            __cmplp.className
        ])
    });
});


/* recent-work-list-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $970b9d364788e4a8$export$3c95e3d61376d5b6 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1EqgXlN91d",
            __cmplp.className
        ])
    });
});


const $8aef00439b4d9f61$var$COLLAPSED_RECENT_WORK_ITEM_NUMBER = 5;
const $8aef00439b4d9f61$export$66aebd6b65f0e0cf = ({ name: name, activities: activities, viewAllUrl: viewAllUrl })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const cachedExpanded = JSON.parse((0, $6JEx2.getSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY)) || '{}').recentWorkListExpanded;
    const [expanded, setExpanded] = (0, $cozmU.useState)(cachedExpanded !== undefined ? cachedExpanded : false);
    const { updateContextCache: updateContextCache, fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, onNavigate: onNavigate } = (0, $3hVWe.useAIAnswerContext)();
    const expandRecentWorkList = (0, $cozmU.useCallback)(()=>{
        setExpanded(true);
        updateContextCache({
            recentWorkListExpanded: true
        });
    }, [
        updateContextCache
    ]);
    const onLinkClick = (0, $cozmU.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $c19df9a6f96e2f1c$export$b22e9ed865dfbcfa)(commonAttributes));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        onNavigate
    ]);
    const onLinkContextMenuClick = (0, $cozmU.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $9b5790cac325151c$export$3eb2378888745842)(commonAttributes));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        onNavigate
    ]);
    const showExpandedItems = activities.length > $8aef00439b4d9f61$var$COLLAPSED_RECENT_WORK_ITEM_NUMBER ? expanded : true;
    const shownActivities = showExpandedItems ? activities : activities.slice(0, $8aef00439b4d9f61$var$COLLAPSED_RECENT_WORK_ITEM_NUMBER);
    if (activities.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9d631ae658deba5$export$73d0188d97126121), null, formatMessage((0, $2b74ffab90174614$export$defe85febe8b728c).no_activity_error_text, {
        user: name
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $824b1f7e98cbde58$export$9a485269bf2c8987), null, formatMessage((0, $2b74ffab90174614$export$defe85febe8b728c).recentWorkListTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $970b9d364788e4a8$export$3c95e3d61376d5b6), null, shownActivities.map((activity, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ebb4db69cc755bd7$export$9adc0410c9970c44), {
            key: `recent-work-item-${index}`,
            index: index,
            title: activity.title,
            iconUrl: activity.iconUrl,
            url: activity.url,
            container: activity.containerName,
            event: activity.event,
            contributors: activity.contributors,
            timestamp: activity.timestamp,
            othersCount: activity.othersCount
        }))), showExpandedItems ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4b1015dd26cfab9c$export$ce4b6a469c26f53f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: 'link',
        href: viewAllUrl,
        onClick: onLinkClick,
        onContextMenu: onLinkContextMenuClick
    }, formatMessage((0, $2b74ffab90174614$export$defe85febe8b728c).viewAllLink))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, !!viewAllUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4b1015dd26cfab9c$export$ce4b6a469c26f53f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "link",
        onClick: expandRecentWorkList
    }, formatMessage((0, $2b74ffab90174614$export$defe85febe8b728c).showMore)))));
};


























const $ce080d9929f5b8dd$export$924cae8b31b3ec43 = ({ primaryUserName: primaryUserName, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerWhoPrimaryViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            primaryUserName: primaryUserName
        }
    };
};





const $2b50efc588696ab2$export$7bc7dfa120866cd2 = ({ primaryUserName: primaryUserName, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerWhoPrimaryViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            primaryUserName: primaryUserName
        }
    };
};


/* profile-section-primary-user-header.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $33ba4a2fa053dcce$export$255011ab851083fa = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuI7V3 _39xV02N91d",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-user-img.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $b24ca004614a1c9f$export$dbd921847e022785 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDyzSk _39xV02L04q _0jFU0VL04q",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-user-info-text-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $13b9dbadfbb66bc3$export$4748d4ea7eaeeee9 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842FQfX _3iDTPbQ4SZ _3TGfC9HnLE _0hPCNLDIqT _39xV02N91d",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-user-info-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $fcddc648b8552772$export$509293bf46c921a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuchRC _0hPCNLchRC _0jFU0VN91d _39xV02N91d _2XsHFM5zaO",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-user-name.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $8b6d894f3a58830a$export$2561140795d9b6bc = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgWSk4",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-user-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $086aedaf490ad910$export$455d3c20a8814267 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuchRC _0hPCNLDIqT _39xV02N91d",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-view-profile-link-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $e69c30bc58eb4b70$export$bb93002cdcc6fd86 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $43324dd00e75b059$export$32d100979bcc384a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT _39xV02N91d",
            __cmplp.className
        ])
    });
});









var $p6OqS = parcelRequire("p6OqS");


var $5ZtfK = parcelRequire("5ZtfK");



















/* profile-section-primary-user-addtl-icon-padding.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $71eda234bc5072eb$export$83dd167b9bbf48eb = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0VIeFR1Y8M",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-user-info.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $6134452c3bca165a$export$6703f231e80ecbdc = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _0adFHs2ADO",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-user-info-text.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $985cbbd10a93f98c$export$56b2c11ed41d99f1 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _1UtDYzKGUX _2XsHFMFQfX",
            __cmplp.className
        ])
    });
});


var $e4bc1cab82d36a1d$export$70291e6ea210ef9 = /*#__PURE__*/ function(UserInfoTypeFormat) {
    UserInfoTypeFormat["JOBTITLE"] = "JOB_TITLE";
    UserInfoTypeFormat["DEPARTMENT"] = "DEPARTMENT";
    UserInfoTypeFormat["LOCATION"] = "LOCATION";
    UserInfoTypeFormat["TIME"] = "TIME";
    UserInfoTypeFormat["EMAIL"] = "EMAIL";
    return UserInfoTypeFormat;
}({});


const $20a35d0143afbe93$var$userInfoTypeMapper = {
    [(0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).JOBTITLE]: {
        tooltipMessage: (0, $cb86z.messages).ai_answer_who_questions_hover_role_icon,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($p6OqS))), {
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)",
            testId: "primary-user-suitcase-icon"
        })
    },
    [(0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).DEPARTMENT]: {
        tooltipMessage: (0, $cb86z.messages).ai_answer_who_questions_hover_department_icon,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eleTd))), {
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)",
            testId: "primary-user-department-icon"
        })
    },
    [(0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).LOCATION]: {
        tooltipMessage: (0, $cb86z.messages).ai_answer_who_questions_hover_location_icon,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hS5Ee))), {
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)",
            testId: "primary-user-location-icon"
        })
    },
    [(0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).TIME]: {
        tooltipMessage: (0, $cb86z.messages).ai_answer_who_questions_hover_local_time_icon,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)",
            testId: "primary-user-emoji-frequent-icon"
        })
    },
    [(0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).EMAIL]: {
        tooltipMessage: (0, $cb86z.messages).ai_answer_who_questions_hover_email_icon,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ldb9Z))), {
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)",
            testId: "primary-user-email-icon"
        })
    }
};
const $20a35d0143afbe93$export$aaf1b21561a4fb8b = ({ userInfo: userInfo, userInfoType: userInfoType, applyAdditionalTopIconPadding: applyAdditionalTopIconPadding })=>{
    return userInfo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6134452c3bca165a$export$6703f231e80ecbdc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $20a35d0143afbe93$var$userInfoTypeMapper[userInfoType].tooltipMessage)
    }, applyAdditionalTopIconPadding ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $71eda234bc5072eb$export$83dd167b9bbf48eb), null, $20a35d0143afbe93$var$userInfoTypeMapper[userInfoType].icon) : $20a35d0143afbe93$var$userInfoTypeMapper[userInfoType].icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $985cbbd10a93f98c$export$56b2c11ed41d99f1), null, userInfo))) : null;
};



const $08aecb4802393fa3$export$cf8aeccda7668aa5 = ({ accountId: accountId, name: name, email: email, avatarUrl: avatarUrl, profileUrl: profileUrl, jobTitle: jobTitle, department: department, location: location, time: time })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, onNavigate: onNavigate } = (0, $3hVWe.useAIAnswerContext)();
    const profileLink = commonAttributes.brand === (0, $zzZbq.AiBrand).AI ? `/wiki/people/${accountId}` : profileUrl;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $43324dd00e75b059$export$32d100979bcc384a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $086aedaf490ad910$export$455d3c20a8814267), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b24ca004614a1c9f$export$dbd921847e022785), {
        src: avatarUrl || '',
        alt: name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fcddc648b8552772$export$509293bf46c921a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33ba4a2fa053dcce$export$255011ab851083fa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b6d894f3a58830a$export$2561140795d9b6bc), null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e69c30bc58eb4b70$export$bb93002cdcc6fd86), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4bg4c))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-text-accent-blue, #1558BC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: profileLink || '',
        onClick: (event)=>{
            onNavigate(event);
            fireAnalyticsEvent((0, $ce080d9929f5b8dd$export$924cae8b31b3ec43)({
                ...commonAttributes,
                primaryUserName: name
            }));
        },
        onContextMenu: (event)=>{
            onNavigate(event);
            fireAnalyticsEvent((0, $2b50efc588696ab2$export$7bc7dfa120866cd2)({
                ...commonAttributes,
                primaryUserName: name
            }));
        }
    }, formatMessage((0, $cb86z.messages).ai_answer_who_questions_view_profile)))), (jobTitle || department) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13b9dbadfbb66bc3$export$4748d4ea7eaeeee9), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20a35d0143afbe93$export$aaf1b21561a4fb8b), {
        userInfo: jobTitle || '',
        userInfoType: (0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).JOBTITLE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20a35d0143afbe93$export$aaf1b21561a4fb8b), {
        userInfo: department || '',
        userInfoType: (0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).DEPARTMENT
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13b9dbadfbb66bc3$export$4748d4ea7eaeeee9), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20a35d0143afbe93$export$aaf1b21561a4fb8b), {
        userInfo: location || '',
        userInfoType: (0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).LOCATION
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20a35d0143afbe93$export$aaf1b21561a4fb8b), {
        userInfo: time || '',
        userInfoType: (0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).TIME,
        applyAdditionalTopIconPadding: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20a35d0143afbe93$export$aaf1b21561a4fb8b), {
        userInfo: email || '',
        userInfoType: (0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).EMAIL,
        applyAdditionalTopIconPadding: true
    })))));
};

















var $722fc5d84170c752$export$7c6c2f9c68de2e45 = /*#__PURE__*/ function(NLPSearchResultContainerDataTypeContainerType) {
    NLPSearchResultContainerDataTypeContainerType["ConfluenceSpace"] = "confluenceSpace";
    NLPSearchResultContainerDataTypeContainerType["JiraProject"] = "jiraProject";
    return NLPSearchResultContainerDataTypeContainerType;
}({});





const $c7d907edb584f358$export$da5ff760e0ba649b = ({ resultSection: resultSection, resultTitle: resultTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerWhoPrimaryCoordinationPill',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            resultSection: resultSection
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            resultTitle: resultTitle
        }
    };
};





const $ed389fe51a6e2620$export$305f2a0f7fa9a25f = ({ resultSection: resultSection, resultTitle: resultTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerWhoPrimaryCoordinationPill',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            resultSection: resultSection
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            resultTitle: resultTitle
        }
    };
};


/* ai-who-answer-section-header.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $940369cd7573c555$export$8d7f456736fee90f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgd8bj",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-section-result.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $3e59976130394a04$export$d0be8a9d033ca7b8 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDKkzjp _0bjKvDKTcp _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _24h04i2Njc _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _3fSdSTGk8v",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-section-result-info-header.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $baf12dda6b49bc9f$export$790f6d80b0f65f30 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgEqul _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _39xV02N91d _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-section-result-info-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $dd1ef2556613b2d0$export$e739e9e96a0d2dd9 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuZHm0 _0hPCNLchRC _0jFU0VN91d _39xV02N91d _2XsHFM2ADO _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-section-result-metadata.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $73505f4b12efc097$export$7b9fc87d1d9e8ecd = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzKGUX _39xV02N91d _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-section-results-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $39598a14d533d2a8$export$39edbe3e7f6a9ca1 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _3iDTPbgBM8 _2iEGP2byVk _39xV02N91d _0jFU0VmdCj _3138422ADO",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-section-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $51abcd58c12c68a4$export$cc8053471b180c28 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _3138425zaO _39xV02N91d",
            __cmplp.className
        ])
    });
});


const $38dd5d534a3b496e$var$WHO_SECTION_MAX_ITEMS = 3;
const $38dd5d534a3b496e$export$2fdd09f06ec66b1 = ({ sectionId: sectionId, sectionHeader: sectionHeader, sectionResults: sectionResults, avatarAppearance: avatarAppearance })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, onNavigate: onNavigate } = (0, $3hVWe.useAIAnswerContext)();
    const getSectionResultMetadata = (sectionResult)=>{
        if ('containerType' in sectionResult) switch(sectionResult.containerType){
            case (0, $722fc5d84170c752$export$7c6c2f9c68de2e45).ConfluenceSpace:
                return 'Confluence';
            case (0, $722fc5d84170c752$export$7c6c2f9c68de2e45).JiraProject:
                return 'Jira Software';
            default:
                return '';
        }
        if ('title' in sectionResult) return sectionResult.title || '';
        if ('memberCount' in sectionResult) return formatMessage((0, $cb86z.messages).ai_answer_who_question_team_section_member_count, {
            count: sectionResult.memberCount
        });
        return '';
    };
    return sectionResults && sectionResults.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51abcd58c12c68a4$export$cc8053471b180c28), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $940369cd7573c555$export$8d7f456736fee90f), null, formatMessage(sectionHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39598a14d533d2a8$export$39edbe3e7f6a9ca1), null, sectionResults.slice(0, $38dd5d534a3b496e$var$WHO_SECTION_MAX_ITEMS).map((sectionResult)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3e59976130394a04$export$d0be8a9d033ca7b8), {
            key: sectionResult.name,
            href: sectionResult.url || undefined,
            onClick: (event)=>{
                onNavigate(event);
                fireAnalyticsEvent((0, $c7d907edb584f358$export$da5ff760e0ba649b)({
                    ...commonAttributes,
                    resultSection: sectionId,
                    resultTitle: sectionResult.name
                }));
            },
            onContextMenu: ()=>{
                fireAnalyticsEvent((0, $ed389fe51a6e2620$export$305f2a0f7fa9a25f)({
                    ...commonAttributes,
                    resultSection: sectionId,
                    resultTitle: sectionResult.name
                }));
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: avatarAppearance,
            src: sectionResult.iconUrl || sectionResult.picture || sectionResult.avatarUrl || undefined,
            size: "medium"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dd1ef2556613b2d0$export$e739e9e96a0d2dd9), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $baf12dda6b49bc9f$export$790f6d80b0f65f30), null, sectionResult.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73505f4b12efc097$export$7b9fc87d1d9e8ecd), null, getSectionResultMetadata(sectionResult))))))) : null;
};


const $2490bd4988410e64$export$f11b3e733b5a589b = ()=>{
    const { commonAttributes: commonAttributes, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString, cloudId: cloudId, sessionId: sessionId } = commonAttributes;
    // answerString should have at least one result or else <AIAnswerError /> will be rendered
    const whoResult = {
        user_metadata: (0, $17e86b4a203450c0$export$b273f870e024eb5d)(answerString).parsedResult
    };
    const userResults = whoResult.user_metadata;
    // BE will always return first object as the primary user result
    const primaryUser = userResults[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $08aecb4802393fa3$export$cf8aeccda7668aa5), {
        accountId: primaryUser.account_id,
        name: primaryUser.name,
        email: primaryUser.email,
        avatarUrl: primaryUser.avatar_url,
        profileUrl: primaryUser.profile_url,
        jobTitle: primaryUser.job_title,
        department: primaryUser.department,
        location: primaryUser.location,
        time: primaryUser.time
    }), isAdminHubAIEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $br26d.AITopicsByPerson), {
        cloudId: cloudId,
        userId: primaryUser.account_id ?? '',
        userName: primaryUser.name,
        sessionId: sessionId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38dd5d534a3b496e$export$2fdd09f06ec66b1), {
        sectionId: "frequent_locations",
        sectionHeader: (0, $cb86z.messages).ai_answer_who_questions_frequent_locations_header,
        sectionResults: primaryUser.containers,
        avatarAppearance: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38dd5d534a3b496e$export$2fdd09f06ec66b1), {
        sectionId: "frequent_collaborators",
        sectionHeader: (0, $cb86z.messages).ai_answer_who_questions_frequent_collaborators_header,
        sectionResults: primaryUser.collaborators?.slice(0, 3),
        avatarAppearance: "circle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38dd5d534a3b496e$export$2fdd09f06ec66b1), {
        sectionId: "teams",
        sectionHeader: (0, $cb86z.messages).ai_answer_who_questions_teams_header,
        sectionResults: primaryUser.teams,
        avatarAppearance: "square"
    }), primaryUser.recentActivity && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8aef00439b4d9f61$export$66aebd6b65f0e0cf), {
        name: primaryUser.name,
        activities: primaryUser.recentActivity,
        viewAllUrl: primaryUser.viewAllLink
    }));
};











const $f2d360744ad6d7ea$export$ff8068fc50f478b4 = ()=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    const workResult = {
        user_metadata_with_activity: (0, $17e86b4a203450c0$export$b273f870e024eb5d)(answerString).parsedResult
    };
    const userWorkResult = workResult.user_metadata_with_activity[0];
    const activities = userWorkResult.recentActivity;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $08aecb4802393fa3$export$cf8aeccda7668aa5), {
        name: userWorkResult.name,
        email: userWorkResult.email,
        avatarUrl: userWorkResult.avatar_url,
        profileUrl: userWorkResult.profile_url,
        jobTitle: userWorkResult.job_title,
        department: userWorkResult.department,
        location: userWorkResult.location,
        time: userWorkResult.time
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8aef00439b4d9f61$export$66aebd6b65f0e0cf), {
        name: userWorkResult.name,
        activities: activities,
        viewAllUrl: userWorkResult.viewAllLink
    }));
};


const $b7321ed56d8ec1e0$export$135cee1a1b919871 = ()=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    const { parsedType: parsedType } = (0, $17e86b4a203450c0$export$b273f870e024eb5d)(answerString);
    switch(parsedType){
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).WHO:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2490bd4988410e64$export$f11b3e733b5a589b), null);
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).WORK:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2d360744ad6d7ea$export$ff8068fc50f478b4), null);
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).TEAM:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39464719bc90ad90$export$224d36db19d00a29), null);
        default:
            return null;
    }
};




















const $5ef0f30ecddd4119$export$e7233899affc4477 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerReturnLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};


/* ai-answer-close-label-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $203fd6bdee3cef4d$export$855079ed5415eeab = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _2sNsIg7NXe _3iDTPbQ4SZ _1UtDYzKGUX _0mTZRh7zJH",
            __cmplp.className
        ])
    });
});


/* ai-answer-result-blur-section.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $ae7e2b66522f56ed$export$95fe272adfa518ad = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31fEoDO _39xV02npmf _3iDTPbQ4SZ _37wbyuF05b _1mT5xdWVPG _2IhTonDQNZ _0wOv4Q7zJH _1wydGW1Y8M _0Of8r25zaO _1UtDYzy7kJ _02i86wdnbC",
            __cmplp.className
        ])
    });
});


/* ai-answer-result-blur-section-text.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $96acacb119695a8c$export$b67ed19cd3a08e2a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31fspMb _2sNsIg20Hp _3iDTPbQ4SZ _37wbyuF05b _39xV02DC6J _1Znuxb1Y8M",
            __cmplp.className
        ])
    });
});



const $c61152461d70d823$export$f8279a5be196ce2f = ()=>{
    const [isResultOverflow, setResultOverflow] = (0, $cozmU.useState)(false);
    const [isResultExpanded, setResultExpanded] = (0, $cozmU.useState)(false);
    const wrapperRef = (0, $cozmU.useRef)(null);
    const contentRef = (0, $cozmU.useRef)(null);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, isReadingAids: isReadingAids, cardTemplate: cardTemplate, onClose: onClose } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    const onCloseDialog = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $5ef0f30ecddd4119$export$e7233899affc4477)(commonAttributes));
        onClose?.();
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        onClose
    ]);
    const enableShowMoreBlur = cardTemplate === (0, $zzZbq.CardTemplate).DEFAULT && isReadingAids;
    (0, $cozmU.useEffect)(()=>{
        if (!wrapperRef.current || !contentRef.current) return;
        const resizeObserver = new ResizeObserver(()=>{
            if ((wrapperRef.current?.offsetHeight ?? 0) < (contentRef.current?.offsetHeight ?? 0)) setResultOverflow(true);
            else setResultOverflow(false);
        });
        resizeObserver.observe(contentRef.current);
        return ()=>resizeObserver.disconnect();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc507febe9bd909d$export$d74b491f1ba95e72), {
        isReadingAids: isReadingAids && cardTemplate === (0, $zzZbq.CardTemplate).DEFAULT,
        ref: wrapperRef,
        isExpanded: isResultExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: contentRef
    }, answerString), enableShowMoreBlur && isResultOverflow && !isResultExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ae7e2b66522f56ed$export$95fe272adfa518ad), {
        onClick: ()=>setResultExpanded(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96acacb119695a8c$export$b67ed19cd3a08e2a), null, formatMessage((0, $cb86z.messages).ai_answer_expand_button_label)))), !isReadingAids && onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $203fd6bdee3cef4d$export$855079ed5415eeab), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $cb86z.messages).ai_answer_dialog_cancel_label,
        values: {
            searchResultsLink: // eslint-disable-next-line @atlassian/a11y/anchor-is-valid, @atlassian/a11y/click-events-have-key-events, @atlaskit/design-system/no-html-anchor, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
                onClick: onCloseDialog
            }, formatMessage((0, $cb86z.messages).ai_answer_dialog_search_results_label))
        }
    })));
};














































const $4126f49942e8f651$var$ReactRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("7ydRw")).then(({ ReactRenderer: ReactRenderer })=>{
        return {
            default: ReactRenderer
        };
    }));

const $4126f49942e8f651$var$MarkdownRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("039lM")).then(({ default: ReactMarkdown })=>{
        return {
            default: ReactMarkdown
        };
    }));
const $4126f49942e8f651$export$b6ab675c6c26c40f = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isResultOverflow, setResultOverflow] = (0, $cozmU.useState)(false);
    const [isResultExpanded, setResultExpanded] = (0, $cozmU.useState)(false);
    const wrapperRef = (0, $cozmU.useRef)(null);
    const contentRef = (0, $cozmU.useRef)(null);
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, isReadingAids: isReadingAids, cardTemplate: cardTemplate, onClose: onClose } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString, answerFormat: answerFormat } = commonAttributes;
    const onCloseDialog = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $5ef0f30ecddd4119$export$e7233899affc4477)(commonAttributes));
        onClose?.();
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        onClose
    ]);
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const enableShowMoreBlur = cardTemplate === (0, $zzZbq.CardTemplate).DEFAULT && isReadingAids && !serveDefinitionUXUpdates;
    (0, $cozmU.useEffect)(()=>{
        if (!wrapperRef.current || !contentRef.current) return;
        if (serveDefinitionUXUpdates) return;
        const resizeObserver = new ResizeObserver(()=>{
            if ((wrapperRef.current?.offsetHeight ?? 0) < (contentRef.current?.offsetHeight ?? 0)) setResultOverflow(true);
            else setResultOverflow(false);
        });
        resizeObserver.observe(contentRef.current);
        return ()=>resizeObserver.disconnect();
    }, [
        serveDefinitionUXUpdates
    ]);
    const docContent = (0, $cozmU.useMemo)(()=>(0, $6rwn6.encodeAdf)(answerString, false), [
        answerString
    ]);
    const FormattedResult = (0, $cozmU.useMemo)(()=>{
        let content;
        switch(answerFormat){
            case (0, $hpFQM.NLPSearchResultFormat).ADF:
                content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4126f49942e8f651$var$ReactRenderer, {
                    document: JSON.parse(answerString),
                    nodeComponents: (0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search') ? undefined : {
                        // Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
                        // Followup ticket to re-enable image rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
                        media: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null),
                        mediaSingle: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
                    }
                });
                break;
            case (0, $hpFQM.NLPSearchResultFormat).MARKDOWN:
                if (!isReadingAids) {
                    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4126f49942e8f651$var$ReactRenderer, {
                        document: docContent,
                        nodeComponents: {
                            status: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2862f0d359af03a$export$21553c57082a6434), props),
                            // Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
                            // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
                            ...!(0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search') ? {
                                media: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null),
                                mediaSingle: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
                            } : undefined
                        }
                    });
                    break;
                }
                // Preventing img elements from rendering due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
                // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
                content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4126f49942e8f651$var$MarkdownRenderer, {
                    disallowedElements: (0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search') ? undefined : [
                        'img'
                    ]
                }, answerString);
                break;
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null);
        }
        return content;
    }, [
        answerFormat,
        answerString,
        docContent,
        isReadingAids
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc507febe9bd909d$export$d74b491f1ba95e72), {
        id: "ai-answer-result-section",
        ref: wrapperRef,
        isReadingAids: isReadingAids && cardTemplate === (0, $zzZbq.CardTemplate).DEFAULT,
        isExpanded: isResultExpanded || serveDefinitionUXUpdates,
        serveDefinitionUXExp: serveDefinitionUXUpdates
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: contentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), null, FormattedResult))))), enableShowMoreBlur && isResultOverflow && !isResultExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ae7e2b66522f56ed$export$95fe272adfa518ad), {
        onClick: ()=>setResultExpanded(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96acacb119695a8c$export$b67ed19cd3a08e2a), null, formatMessage((0, $cb86z.messages).ai_answer_expand_button_label))), !isReadingAids && onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $203fd6bdee3cef4d$export$855079ed5415eeab), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $cb86z.messages).ai_answer_dialog_cancel_label,
        values: {
            searchResultsLink: // eslint-disable-next-line @atlaskit/design-system/no-html-anchor, @atlassian/a11y/anchor-is-valid, @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
                onClick: onCloseDialog
            }, formatMessage((0, $cb86z.messages).ai_answer_dialog_search_results_label))
        }
    })));
};


const $47d8550a555006e1$var$AIAnswerResult = ()=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { answerFormat: answerFormat } = commonAttributes;
    (0, $cozmU.useEffect)(()=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const AIAnswerResultComponent = (0, $cozmU.useMemo)(()=>{
        switch(answerFormat){
            case (0, $hpFQM.NLPSearchResultFormat).ADF:
            case (0, $hpFQM.NLPSearchResultFormat).MARKDOWN:
                return 0, $4126f49942e8f651$export$b6ab675c6c26c40f;
            case (0, $hpFQM.NLPSearchResultFormat).JSON:
                return 0, $b7321ed56d8ec1e0$export$135cee1a1b919871;
            case (0, $hpFQM.NLPSearchResultFormat).PLAINTEXT:
            default:
                return 0, $c61152461d70d823$export$f8279a5be196ce2f;
        }
    }, [
        answerFormat
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AIAnswerResultComponent, null);
};
const $47d8550a555006e1$export$e2b54fc495614d59 = ()=>{
    const { isAnswered: isAnswered, hasError: hasError, isReadingAids: isReadingAids, cardTemplate: cardTemplate } = (0, $3hVWe.useAIAnswerContext)();
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $98e3090d57b087a8$export$373eea644718ed14), {
        isReadingAids: isReadingAids && cardTemplate === (0, $zzZbq.CardTemplate).DEFAULT,
        serveDefinitionsUXExp: serveDefinitionUXUpdates
    }, isAnswered && !hasError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($47d8550a555006e1$var$AIAnswerResult, null) : hasError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bc3521c1c358b703$export$106e8178ce804384), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f366b75433df2895$export$ffa24cd7196ce1b0), null)) : null);
};






/* ai-answer-title.tsx generated by @compiled/babel-plugin v3.0.1 */ 































/* DisableDefinitionMenu.tsx generated by @compiled/babel-plugin v3.0.1 */ 















var $6TaGl = parcelRequire("6TaGl");





var $c0A7H = parcelRequire("c0A7H");







const $f93224bfed589820$var$messages = (0, $kSwu1.defineMessages)({
    disable_definitions_more_icon_tooltip: {
        id: "search_ai.disable_definitions_more_icon_tooltip",
        defaultMessage: "See more actions"
    },
    see_more_actions_button_label: {
        id: "search_ai.definitions_see_more_actions_label",
        defaultMessage: "See more actions"
    },
    disable_definitions_header: {
        id: "search_ai.disable_definitions_header",
        defaultMessage: "Don\u2019t recommend definitions at all"
    },
    disable_definitions_description: {
        id: "search_ai.disable_definitions_description",
        defaultMessage: "When this is on, we\u2019ll no longer automatically highlight terms and acronyms on any page. Only you will see these changes."
    }
});
const $f93224bfed589820$var$DisableDefinitionMenuWrapper = null;
const $f93224bfed589820$var$DisableDefinitionMenuTextWrapper = null;
const $f93224bfed589820$var$DisableDefinitionMenuHeaderStyles = null;
const $f93224bfed589820$var$DisableDefinitionMenuDescriptionStyles = null;
const $f93224bfed589820$var$DisableDefinitionMenuToggleWrapper = null;
const $f93224bfed589820$var$MoreIconStyled = ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: (0, $4o0zT.isExperimentEnabled)('a11y-fixes-week1-june-2026') ? '' : 'reading-aids-menu-button-icon',
        color: "var(--ds-icon-subtle, #505258)"
    });
const $f93224bfed589820$export$a025edc19ca0650a = ()=>{
    const { readingAidsOptions: readingAidsOptions } = (0, $3hVWe.useAIAnswerContext)();
    const [menuOpen, setMenuOpen] = (0, $cozmU.useState)(false);
    const [disableDefinitions, setDisableDefinitions] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const definitionsDisabled = !!readingAidsOptions?.disableDefinitionsCallbacks?.getDefinitionsDisabled();
        setDisableDefinitions(definitionsDisabled); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disableDefinitionsCallbacks = readingAidsOptions?.disableDefinitionsCallbacks;
    return disableDefinitionsCallbacks ? /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        position: "bottom",
        content: formatMessage($f93224bfed589820$var$messages.disable_definitions_more_icon_tooltip)
    }, /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        isOpen: menuOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...props,
                appearance: "subtle",
                icon: $f93224bfed589820$var$MoreIconStyled,
                ref: triggerRef,
                onClick: ()=>{
                    setMenuOpen(!menuOpen);
                },
                testId: "definitions-menu-button",
                label: (0, $4o0zT.isExperimentEnabled)('a11y-fixes-week1-june-2026') ? formatMessage($f93224bfed589820$var$messages.see_more_actions_button_label) : 'definitions-menu-button'
            })
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu8kG2W _3iDTPbQ4SZ _39xV02sz7G _0aFT5v1qpb _37wbyuI7V3 _42Yu6B7dHp _3138425zaO _1wydGW5zaO _2Zuz6Q8HPE _0adFHsgVvo"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _39xV02dl5A"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _1UtDYzy7kJ"
        ])
    }, formatMessage($f93224bfed589820$var$messages.disable_definitions_header)), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _1UtDYzKGUX"
        ])
    }, formatMessage($f93224bfed589820$var$messages.disable_definitions_description))), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _39xV02E6Kk"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $c0A7H.default), {
        onChange: ()=>{
            if (disableDefinitions) disableDefinitionsCallbacks.onEnableDefinitions();
            else disableDefinitionsCallbacks.onDisableDefinitions();
            setDisableDefinitions(!disableDefinitions);
        },
        isChecked: disableDefinitions,
        testId: "definitions-toggle-disable"
    }))))) : null;
};


/* DefinitionsDropdownMenu.tsx generated by @compiled/babel-plugin v3.0.1 */ 










































var $kYmM6 = parcelRequire("kYmM6");

var $38ARq = parcelRequire("38ARq");

var $bw8s0 = parcelRequire("bw8s0");



























/* edit-definition-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $ac773248b4c6e67e$export$92161330b4f919c7 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0Of8r2dnbC _1Znuxb8HPE _1wydGWdnbC _2Zuz6Q8HPE _0RxVZVKGUX",
            __cmplp.className
        ])
    });
});


const $b69531bb99313eff$export$f32beb894f554d19 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionEditButton',
        source: source,
        eventType: 'ui',
        attributes: {
            // contentId and readingAidsSessionId passed in from Confluence readingAids
            ...extraAttributes
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};


const $7d46aa3d987b242a$export$9dee3cc92d823001 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiCuratedDefinitionEditButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...extraAttributes
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};


const $83873e2ed2341e7f$var$messages = (0, $kSwu1.defineMessages)({
    edit_definition_icon_tooltip: {
        id: "search_ai.curated-definition-edit-def-icon-tooltip",
        defaultMessage: "Edit definition"
    },
    edit_definition_prompt_text: {
        id: "search_ai.edit_definition_prompt_text",
        defaultMessage: "Not quite right? Edit this definition"
    },
    edit_definition_prompt_text_updated: {
        id: "search_ai.edit_definition_prompt_text_updated",
        defaultMessage: "Edit this definition"
    }
});
const $83873e2ed2341e7f$var$EditIconStyled = ()=>{
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: "",
        size: serveDefinitionUXUpdates ? 'small' : 'medium'
    });
};
const $83873e2ed2341e7f$export$86ebf34eb079ac26 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent, isAnswered: isAnswered, hasError: hasError, readingAidsOptions: readingAidsOptions, commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editButtonSpotlightId = 'ai-definitions-edit-button';
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const [showEditModal, setShowEditModal] = (0, $cozmU.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $cozmU.useState)(false);
    const closeEditModal = (0, $cozmU.useCallback)(()=>{
        setShowEditModal(false);
        onClose?.();
    }, [
        setShowEditModal,
        onClose
    ]);
    const openEditModal = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $b69531bb99313eff$export$f32beb894f554d19)(commonAttributes));
        setShowEditModal(true);
    }, [
        commonAttributes,
        fireAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isAnswered) fireAnalyticsEvent((0, $7d46aa3d987b242a$export$9dee3cc92d823001)(commonAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, !hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38ARq.SpotlightManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bw8s0.SpotlightTarget), {
        name: editButtonSpotlightId
    }, serveDefinitionUXUpdates ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: $83873e2ed2341e7f$var$EditIconStyled,
        onClick: openEditModal,
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage($83873e2ed2341e7f$var$messages.edit_definition_prompt_text_updated))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ac773248b4c6e67e$export$92161330b4f919c7), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: $83873e2ed2341e7f$var$EditIconStyled,
        onClick: openEditModal
    }, formatMessage($83873e2ed2341e7f$var$messages.edit_definition_prompt_text)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kYmM6.EngagementSpotlight), {
        isMigrated: true,
        engagementId: editButtonSpotlightId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, showEditModal && definitionCurationOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $46b3319f0a259942$export$ea8c8594ad1f3bf3), {
        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
        closeEditModal: closeEditModal,
        onSaveEditModal: ()=>setDisplaySuccessFlag(true)
    })), displaySuccessFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cecfbe2a7b0bbf1$export$7475d9ffda76c69b), {
        onDismissed: ()=>setDisplaySuccessFlag(false)
    }));
};





const $2e40819cb273d646$var$AI_DEFINITION_TOGGLE_CACHE_KEY = 'atlassian.search-ai.ai-definition-toggle';
const $2e40819cb273d646$var$messages = (0, $kSwu1.defineMessages)({
    // messages to disable ALL definitions
    disable_definitions_more_icon_tooltip: {
        id: "search_ai.disable_definitions_more_icon_tooltip",
        defaultMessage: "See more actions"
    },
    disable_definitions_header: {
        id: "search_ai.disable_definitions_header",
        defaultMessage: "Don\u2019t recommend definitions at all"
    },
    disable_definitions_description: {
        id: "search_ai.disable_definitions_description",
        defaultMessage: "When this is on, we\u2019ll no longer automatically highlight terms and acronyms on any page. Only you will see these changes."
    },
    // accessible label for the See More actions button
    see_more_actions_button_label: {
        id: "search_ai.definitions_see_more_actions_label",
        defaultMessage: "See more actions"
    },
    // messages to disable SINGLE definition
    disable_definition_term_header: {
        id: "search_ai.disable_definition_term_header",
        defaultMessage: "Don\u2019t recommend this term"
    },
    disable_definition_term_description: {
        id: "search_ai.disable_definition_term_description",
        defaultMessage: "When this is on, we\u2019ll no longer automatically highlight this specific term on any page. Only you will see these changes."
    }
});
const $2e40819cb273d646$var$MoreIconStyled = ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: (0, $4o0zT.isExperimentEnabled)('a11y-fixes-week1-june-2026') ? '' : 'definitions-disable-menu-button-icon',
        color: "var(--ds-icon-subtle, #505258)"
    });
const $2e40819cb273d646$var$styles = {
    root: "_39xV025R67 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    dividerStyles: "_2IVJ4M6wH8 _22sfPnNvrM _3zygPU9r67"
};
const $2e40819cb273d646$export$6a23f0e401dcf4d9 = ()=>{
    const { commonAttributes: commonAttributes, definitionToggleEnabled: definitionToggleEnabled, fireAnalyticsEvent: fireAnalyticsEvent, readingAidsOptions: readingAidsOptions, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const [definitionsDropdownMenuOpen, setDefinitionsDropdownMenuOpen] = (0, $cozmU.useState)(false);
    const [disableDefinitions, setDisableDefinitions] = (0, $cozmU.useState)(false); // the localStorage method to track whether all Definitions are disabled is different
    // between products so we need to get from the product whether Definitions have already been disabled by user
    (0, $cozmU.useEffect)(()=>{
        const definitionsDisabled = !!readingAidsOptions?.disableDefinitionsCallbacks?.getDefinitionsDisabled();
        setDisableDefinitions(definitionsDisabled); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disableDefinitionsCallbacks = readingAidsOptions?.disableDefinitionsCallbacks; // need to account for non-platformized version
    const { menuOptions: readingAidsMenuOptions } = readingAidsOptions || {};
    const { cloudId: cloudId, query: keyPhrase, workspaceId: workspaceId } = commonAttributes;
    const cachedDefinitionTermDisabled = JSON.parse((0, $6JEx2.getSessionItem)($2e40819cb273d646$var$AI_DEFINITION_TOGGLE_CACHE_KEY) || '{}');
    const [disableDefinitionTerm, setDisableDefinitionTerm] = (0, $cozmU.useState)(cachedDefinitionTermDisabled.keyPhrase === keyPhrase);
    const { toggleDefinition: toggleDefinition } = (0, $8ed7fc4a26d403e8$export$6e73bcf8826d31a5)();
    const onToggleDefinitionTermDisable = async ()=>{
        try {
            setDisableDefinitionTerm((current)=>!current);
            await toggleDefinition({
                workspaceId: workspaceId,
                keyPhrase: keyPhrase,
                isDisabled: !disableDefinitionTerm,
                cloudId: cloudId,
                product: sourceProduct ?? ''
            });
            if (disableDefinitionTerm) (0, $6JEx2.deleteSessionItem)($2e40819cb273d646$var$AI_DEFINITION_TOGGLE_CACHE_KEY);
            else {
                fireAnalyticsEvent((0, $bc9bd53230eb9105$export$bfe6deae035e3ea7)(commonAttributes));
                (0, $6JEx2.setSessionItem)($2e40819cb273d646$var$AI_DEFINITION_TOGGLE_CACHE_KEY, JSON.stringify({
                    keyPhrase: keyPhrase
                }));
            }
        } catch (error) {
            setDisableDefinitionTerm((current)=>!current);
            fireAnalyticsEvent((0, $7abdbf6c5e9a205a$export$48200d71a3e25afe)(error, commonAttributes));
        }
    };
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editDefinitionEnabled = !!definitionCurationOptions;
    return /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        isOpen: definitionsDropdownMenuOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...props,
                appearance: "subtle",
                icon: $2e40819cb273d646$var$MoreIconStyled,
                ref: triggerRef,
                onClick: ()=>{
                    setDefinitionsDropdownMenuOpen(!definitionsDropdownMenuOpen);
                },
                testId: "definitions-menu-button",
                label: (0, $4o0zT.isExperimentEnabled)('a11y-fixes-week1-june-2026') ? formatMessage($2e40819cb273d646$var$messages.see_more_actions_button_label) : 'definitions-menu-button'
            }),
        shouldRenderToParent: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $2e40819cb273d646$var$styles.root,
        space: "space.100"
    }, disableDefinitionsCallbacks && /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xxsmall"
    }, formatMessage($2e40819cb273d646$var$messages.disable_definitions_header)), /*#__PURE__*/ $cozmU.createElement((0, $c0A7H.default), {
        onChange: ()=>{
            if (disableDefinitions) disableDefinitionsCallbacks.onEnableDefinitions();
            else disableDefinitionsCallbacks.onDisableDefinitions();
            setDisableDefinitions(!disableDefinitions);
        },
        isChecked: disableDefinitions,
        testId: "definitions-toggle-disable"
    })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage($2e40819cb273d646$var$messages.disable_definitions_description))), readingAidsMenuOptions && readingAidsMenuOptions.length > 0 && readingAidsMenuOptions.map((option)=>/*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "xxsmall"
        }, formatMessage($2e40819cb273d646$var$messages.disable_definitions_header)), /*#__PURE__*/ $cozmU.createElement((0, $c0A7H.default), {
            onChange: option.onChange,
            isChecked: option.toggleState,
            testId: "definitions-toggle-disable"
        })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            size: "small"
        }, formatMessage($2e40819cb273d646$var$messages.disable_definitions_description)))), definitionToggleEnabled && /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2e40819cb273d646$var$styles.dividerStyles
    }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xxsmall"
    }, formatMessage($2e40819cb273d646$var$messages.disable_definition_term_header)), /*#__PURE__*/ $cozmU.createElement((0, $c0A7H.default), {
        onChange: onToggleDefinitionTermDisable,
        isChecked: disableDefinitionTerm,
        testId: "definition-term-toggle-disable"
    })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage($2e40819cb273d646$var$messages.disable_definition_term_description))), editDefinitionEnabled && /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2e40819cb273d646$var$styles.dividerStyles
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $83873e2ed2341e7f$export$86ebf34eb079ac26), {
        onClose: ()=>setDefinitionsDropdownMenuOpen(false)
    })))));
};


























/* ai-options-menu-option-description.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $cf40e4c79dbf8b12$export$db2baac4fa175461 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _1UtDYzKGUX",
            __cmplp.className
        ])
    });
});


/* ai-options-menu-option-header.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $cfc0d4d5bed71987$export$9a3438b6f4e139e4 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _1UtDYzy7kJ",
            __cmplp.className
        ])
    });
});


/* ai-options-menu-option-text.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $4a54a9104e3371a1$export$7f1bcad9bf8084f8 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _39xV02dl5A",
            __cmplp.className
        ])
    });
});


/* ai-options-menu-option-toggle-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $65cb69414b015acd$export$832fe7bd333fb9fe = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _39xV02E6Kk",
            __cmplp.className
        ])
    });
});


/* ai-options-menu-option-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $228e66312c3bbf34$export$fb2fc14fe9185637 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu8kG2W _2Zuz6Q8HPE _1ZnuxbgVvo _39xV02sz7G _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuI7V3",
            __cmplp.className
        ])
    });
});


/* ai-options-menu-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $0c13ad963d830321$export$e20ae3fbb1f307c3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu8kG2W _3iDTPbQ4SZ _0Of8r25zaO _1wydGW5zaO",
            __cmplp.className
        ])
    });
});


const $dc65f6c7d761f529$var$messages = (0, $kSwu1.defineMessages)({
    definition_more_icon_tooltip: {
        id: "search_ai.definition_more_icon_tooltip",
        defaultMessage: "See more actions"
    }
});
const $dc65f6c7d761f529$var$renderOptionsMenuControl = ({ onChange: onChange, type: type, isChecked: isChecked })=>{
    switch(type){
        case 'toggle':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
                onChange: onChange,
                isChecked: isChecked,
                testId: "ai-answer-options-menu-toggle"
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    }
};
const $dc65f6c7d761f529$var$MoreIconStyled = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: "reading-aids-menu-button-icon",
        color: "var(--ds-icon-subtle, #505258)"
    });
const $dc65f6c7d761f529$var$AIOptionsMenuOption = ({ header: header, description: description, onChange: onChange, type: type, isChecked: isChecked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $228e66312c3bbf34$export$fb2fc14fe9185637), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a54a9104e3371a1$export$7f1bcad9bf8084f8), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfc0d4d5bed71987$export$9a3438b6f4e139e4), null, header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf40e4c79dbf8b12$export$db2baac4fa175461), null, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65cb69414b015acd$export$832fe7bd333fb9fe), null, $dc65f6c7d761f529$var$renderOptionsMenuControl({
        onChange: onChange,
        type: type,
        isChecked: isChecked
    })));
};
const $dc65f6c7d761f529$export$77d203904974193c = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isMenuOpen, setMenuOpen] = (0, $cozmU.useState)(false);
    const { readingAidsOptions: readingAidsOptions } = (0, $3hVWe.useAIAnswerContext)();
    const { menuOptions: menuOptions } = readingAidsOptions || {};
    const toggleMenuOpen = (0, $cozmU.useCallback)(()=>{
        setMenuOpen(!isMenuOpen);
    }, [
        isMenuOpen
    ]);
    return !!menuOptions?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "bottom",
        content: formatMessage($dc65f6c7d761f529$var$messages.definition_more_icon_tooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        isOpen: isMenuOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...props,
                appearance: "subtle",
                icon: $dc65f6c7d761f529$var$MoreIconStyled,
                ref: triggerRef,
                onClick: toggleMenuOpen,
                testId: "reading-aids-menu-button",
                label: "reading-aids-menu-button"
            }),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0c13ad963d830321$export$e20ae3fbb1f307c3), {
        onClick: (e)=>e.stopPropagation()
    }, menuOptions?.length && menuOptions.map((menuOption, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc65f6c7d761f529$var$AIOptionsMenuOption, {
            header: formatMessage(menuOption.label),
            description: menuOption.description && formatMessage(menuOption.description),
            onChange: menuOption.onChange,
            isChecked: menuOption.toggleState,
            type: menuOption.type,
            key: index
        });
    })))) : null;
};


/* reading-aids-options-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $e24321bc9300cc4c$export$206d383e26348657 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_42Yu6B7dHp _4ApkO2dnbC _3iDTPbQ4SZ _4kiQYAVa5s",
            __cmplp.className
        ])
    });
});


const $abc4eda07ab786ae$export$77d2212db482996b = ()=>{
    const platformDisableOn = (0, $iDrrr.fg)('kd_definitions_confluence_enable_platform');
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e24321bc9300cc4c$export$206d383e26348657), null, serveDefinitionUXUpdates ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e40819cb273d646$export$6a23f0e401dcf4d9), null) : platformDisableOn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f93224bfed589820$export$a025edc19ca0650a), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc65f6c7d761f529$export$77d203904974193c), null));
};


const $9d2aaa34bd0047e7$var$DEFINITION_DIALOG_TITLE_ID = 'definition-dialog-title';
const $9d2aaa34bd0047e7$var$styles = {
    titleWrapper: "_37wbyuI7V3 _0hPCNLDIqT _313842kG2W _0adFHsNHnM _2XsHFMNHnM",
    titleWrapperUpdateStyles: "_3138428HPE _0adFHs5zaO _2XsHFM5zaO",
    definitionTitle: "_2sNsIg1kXk _1UtDYzy7kJ"
};
const $9d2aaa34bd0047e7$export$20a48ed23bb601ed = ()=>{
    const { commonAttributes: commonAttributes, baseQuery: baseQuery } = (0, $3hVWe.useAIAnswerContext)();
    const { query: query } = commonAttributes;
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const isA11yDefinitionDialogRoleFixEnabled = (0, $4o0zT.isExperimentEnabled)('a11y-fixes-week1-june-2026');
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($9d2aaa34bd0047e7$var$styles.titleWrapper, serveDefinitionUXUpdates && $9d2aaa34bd0047e7$var$styles.titleWrapperUpdateStyles)
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9d2aaa34bd0047e7$var$styles.definitionTitle,
        testId: "definition-answer-card-title",
        as: "h2",
        id: isA11yDefinitionDialogRoleFixEnabled ? $9d2aaa34bd0047e7$var$DEFINITION_DIALOG_TITLE_ID : undefined
    }, baseQuery ? baseQuery : query), /*#__PURE__*/ $cozmU.createElement((0, $abc4eda07ab786ae$export$77d2212db482996b), null));
};










/* reading-aids-follow-ups.tsx generated by @compiled/babel-plugin v3.0.1 */ 

























































const $da2203828d03b963$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    definition_open_chat_user_initial_query: {
        id: "search_ai.definitions_open_chat_initial_query",
        defaultMessage: "Define {term}"
    }
});







const $f634449b63e81159$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    reading_aids_follow_ups_user_initial_query: {
        id: "search_ai.reading_aids_follow_ups_initial_query",
        defaultMessage: "Define {term}"
    }
});


const $0fe3d8897fd30c46$var$styles = {
    followUpWrapperStyles: "_2Zuz6QNHnM _1ZnuxbNHnM _1wydGW2ADO",
    followUpWrapperUpdateStyles: "_2Zuz6Q5zaO _1Znuxb5zaO",
    dividerStyles: "_2IVJ4M6wH8 _22sfPnNvrM _3zygPU9r67"
};
const $0fe3d8897fd30c46$export$b5da368bdedbbfc7 = ()=>{
    const { isAnswered: isAnswered, commonAttributes: commonAttributes, onClose: onClose, readingAidsOptions: readingAidsOptions } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { query: query, answerString: answerString, followUps: followUps } = commonAttributes;
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [showAllFollowUps, setShowAllFollowups] = (0, $cozmU.useState)(false);
    const canExpand = followUps.length > 1;
    const visibleFollowUps = showAllFollowUps ? followUps : followUps.slice(0, 1);
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const onFollowupsExpand = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $728210eecf84aa8d$export$e6174e7fdfd73609)({
            ...commonAttributes,
            expandButtonSource: 'follow-ups'
        }));
        setShowAllFollowups(!showAllFollowUps);
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        showAllFollowUps
    ]);
    const onFollowUpClick = (0, $cozmU.useCallback)((followUp)=>{
        if (readingAidsOptions?.onFollowUpCallback) {
            readingAidsOptions.onFollowUpCallback(followUp);
            return;
        }
        fireAnalyticsEvent((0, $234e19cc92be917b$export$f1956b3bd380b51e)({
            ...commonAttributes,
            followUpString: followUp
        }));
        publish({
            type: 'chat-new',
            source: 'reading-aids',
            data: {
                name: followUp.substring(0, 30),
                dialogues: [
                    {
                        human_message: {
                            content: formatMessage((0, $f634449b63e81159$export$defe85febe8b728c).reading_aids_follow_ups_user_initial_query, {
                                // query only contains the word that user asked
                                // we want to add the word "define" before it so it makes sense
                                // when this is moved to the chat
                                term: query
                            })
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ],
                prompt: followUp
            }
        });
        onClose?.();
    }, [
        query,
        answerString,
        publish,
        formatMessage,
        onClose,
        readingAidsOptions,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    if (!followUps?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($0fe3d8897fd30c46$var$styles.followUpWrapperStyles, serveDefinitionUXUpdates && $0fe3d8897fd30c46$var$styles.followUpWrapperUpdateStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, serveDefinitionUXUpdates && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0fe3d8897fd30c46$var$styles.dividerStyles
    }), visibleFollowUps.map((followUp, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            spread: serveDefinitionUXUpdates ? 'space-between' : undefined
        }, serveDefinitionUXUpdates ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            key: followUp,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))),
            spacing: "compact",
            onClick: ()=>onFollowUpClick(followUp),
            testId: "definition-follow-up-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1,
            color: "color.text.subtle",
            weight: "medium"
        }, followUp)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eHdk6.FollowUpButton), {
            key: followUp,
            followUpIndex: index,
            followUpText: followUp,
            followUpType: "UNAVAILABLE",
            experienceId: "reading-aids",
            onClick: ()=>onFollowUpClick(followUp)
        }), index === 0 && canExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            onClick: onFollowupsExpand,
            icon: (iconProps)=>showAllFollowUps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    color: "currentColor",
                    testId: "collapse-follow-ups-icon",
                    size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    ...iconProps,
                    color: "currentColor",
                    testId: "expand-follow-ups-icon",
                    size: "small"
                }),
            appearance: "subtle",
            label: showAllFollowUps ? (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? 'Collapse follow ups' : 'Collapse follow ups button' : (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? 'Expand follow ups' : 'Expand follow ups button'
        }))), isAnswered && serveDefinitionUXUpdates && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1781bd9c74b8683a$export$dc40dedc9df6e59f), {
        prompt: formatMessage((0, $da2203828d03b963$export$defe85febe8b728c).definition_open_chat_user_initial_query, {
            // query only contains the highlighted word
            // we want to prefix the word "define" before
            // when a user's context is moved to chat
            term: query
        }),
        answerString: answerString,
        query: query,
        source: 'reading-aids'
    })));
};



/* reading-aids-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $7ab2fdf45d8a2d57$export$e0e6dbd6257adb05 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.className
        ])
    });
});


var $aa616b6d75a0c7e9$export$c13e418beaf43d1c = /*#__PURE__*/ function(DefinitionAnswerState) {
    DefinitionAnswerState["LOADING"] = "loading";
    DefinitionAnswerState["ANSWERED"] = "answered";
    DefinitionAnswerState["ERRORED"] = "errored";
    return DefinitionAnswerState;
}({});




const $7220d3f091bca8d4$var$styles = {
    sourcesContainer: "_0Of8r2dnbC _1ZnuxbNHnM _1wydGW2ADO _2Zuz6QNHnM",
    openChatContainer: "_2Y7lL4NHnM _0xmtko2ADO"
};
const $7220d3f091bca8d4$var$MAX_SOURCES = 4;
const $7220d3f091bca8d4$var$noop = ()=>{};
const $7220d3f091bca8d4$var$OpenChat = ({ answerString: answerString, query: query })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!(0, $iDrrr.fg)('kd_definitions_open_chat')) return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $7220d3f091bca8d4$var$styles.openChatContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $1781bd9c74b8683a$export$dc40dedc9df6e59f), {
        prompt: formatMessage((0, $da2203828d03b963$export$defe85febe8b728c).definition_open_chat_user_initial_query, {
            // query only contains the highlighted word
            // we want to prefix the word "define" before
            // when a user's context is moved to chat
            term: query
        }),
        query: query,
        answerString: answerString,
        source: 'reading-aids'
    }));
};
const $7220d3f091bca8d4$export$9d3e24a5ad9e38ea = ()=>{
    const { commonAttributes: commonAttributes, callbacks: callbacks, fireAnalyticsEvent: fireAnalyticsEvent, readingAidsOptions: readingAidsOptions, isAnswered: isAnswered, showChatFollowUps: showChatFollowUps } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const enableSmartLinkSources = readingAidsOptions?.enableSmartLinkSources;
    const { searchSessionId: searchSessionId, sources: sources, answerString: answerString, query: query } = commonAttributes;
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editDefinitionEnabled = !!definitionCurationOptions;
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const sourceClickCallback = (0, $cozmU.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            source: (0, $iDrrr.fg)('kd_definitions_source_product_clicked') ? source : undefined,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), null, (props)=>/*#__PURE__*/ $cozmU.createElement((0, $7ab2fdf45d8a2d57$export$e0e6dbd6257adb05), {
            onClick: (e)=>e.stopPropagation(),
            ...props,
            "data-testId": "definition-answer-card"
        }, /*#__PURE__*/ $cozmU.createElement((0, $9d2aaa34bd0047e7$export$20a48ed23bb601ed), null), /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null), editDefinitionEnabled && !serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement((0, $83873e2ed2341e7f$export$86ebf34eb079ac26), null), !serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $7220d3f091bca8d4$var$styles.sourcesContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $ce789c5dd436d96e$export$bbbfd63fa7f32357), {
            sources: sources,
            searchSessionId: searchSessionId,
            onClickHandler: sourceClickCallback,
            limit: $7220d3f091bca8d4$var$MAX_SOURCES,
            verticalLayout: true,
            enableSmartLinkSources: enableSmartLinkSources,
            isReadingAids: true
        })), serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement((0, $0c874a49d33f2b0f$export$63e4658af6ffde25), {
            sources: sources
        }), showChatFollowUps && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $lPcf8.ErrorBoundary), null, /*#__PURE__*/ $cozmU.createElement((0, $0fe3d8897fd30c46$export$b5da368bdedbbfc7), null)), isAnswered && !serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement($7220d3f091bca8d4$var$OpenChat, {
            answerString: answerString,
            query: query
        })), /*#__PURE__*/ $cozmU.createElement((0, $34e9b06075b84401$export$37858bd8fa3d5915), null)));
};
const $7220d3f091bca8d4$export$d1b852cfff73cbe8 = ()=>{
    const previousAnswerState = (0, $cozmU.useRef)();
    const { commonAttributes: commonAttributes, loading: loading, partialResponse: partialResponse, isAnswered: isAnswered, hasError: hasError, readingAidsOptions: readingAidsOptions } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const [continueLoadingAnimation, setContinueLoadingAnimation] = (0, $cozmU.useState)(true);
    const { source: source } = commonAttributes;
    const isStreaming = !!partialResponse;
    const { onAnswerStateChange: onAnswerStateChange = $7220d3f091bca8d4$var$noop, definitionLoadingConfig: definitionLoadingConfig } = readingAidsOptions || {};
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!loading) {
            const countdownRemainingAnimation = setTimeout(()=>{
                setContinueLoadingAnimation(false);
            }, 3000);
            return ()=>clearTimeout(countdownRemainingAnimation);
        }
    }, [
        loading
    ]);
    (0, $cozmU.useEffect)(()=>{
        // update answer state for external consumers
        // using a previous answer state to prevent multiple duplicate calls,
        // especially in the case of loading && streaming
        if ((0, $iDrrr.fg)('kd_definitions_answer_state_signal')) {
            if (hasError && previousAnswerState.current !== (0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).ERRORED) {
                onAnswerStateChange((0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).ERRORED);
                previousAnswerState.current = (0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).ERRORED;
                (0, $hsCD1.aiDefinitionsLoadUFOExperience).failure();
            } else if (isAnswered && previousAnswerState.current !== (0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).ANSWERED) {
                onAnswerStateChange((0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).ANSWERED);
                previousAnswerState.current = (0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).ANSWERED;
                (0, $hsCD1.aiDefinitionsLoadUFOExperience).success();
            } else if ((loading || isStreaming) && previousAnswerState.current !== (0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).LOADING) {
                onAnswerStateChange((0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).LOADING);
                previousAnswerState.current = (0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).LOADING;
            }
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        loading,
        isStreaming,
        isAnswered,
        hasError
    ]);
    const onLoadingAnimationShown = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $kSORO.onAIAnswerLoadingDialogShown)(commonAttributes, true)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fireAnalyticsEvent
    ]);
    if (loading || isStreaming) {
        if (definitionLoadingConfig) return /*#__PURE__*/ $cozmU.createElement((0, $183b5c97f283e9b6$export$c7f94e62a2f54f71), {
            width: definitionLoadingConfig.width
        });
         // will keep this old animation as a fallback in case definitionLoadingConfig is not passed in
        return /*#__PURE__*/ $cozmU.createElement((0, $kYeKA.DotAnimationLoader), {
            onAnimationShown: onLoadingAnimationShown,
            source: source,
            "data-testid": "ai-answer-animated-loader"
        });
    }
    return /*#__PURE__*/ $cozmU.createElement((0, $74af3b3d0be03000$export$f79f209cc21596d), {
        continueAnimation: continueLoadingAnimation
    }, /*#__PURE__*/ $cozmU.createElement((0, $43c2452d73591196$export$a9f6f8fd5598a12e), null, /*#__PURE__*/ $cozmU.createElement($7220d3f091bca8d4$export$9d3e24a5ad9e38ea, null)));
};









const $a393edda7edb3fe8$export$6220c1b7224eb2a2 = ()=>{
    const { isReadingAids: isReadingAids, commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { source: source } = commonAttributes;
    (0, $cozmU.useEffect)(()=>{
        (0, $a7513ed93542ee2f$export$a83a35d6598a5fb6).stop({
            customData: {
                isReadingAids: !!isReadingAids,
                source: source
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null);
};



var $9u8Y2 = parcelRequire("9u8Y2");







const $597405ac0b3b2570$export$cae33476d80498a = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'dropoff',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $c64593c9127399aa$export$e1c446b3b8b22ff = (props, dwellTime)=>{
    const { query: query, source: source } = props;
    return {
        action: 'hidden',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            dwellTime: dwellTime
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $68497448a8541103$export$835458994fc126e4 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'hidden',
        actionSubject: 'aiAnswerLoadingDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $3010e3f8742304a1$export$17e25c724e0ebb55 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'surfaced',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'queryIntent',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $4eab0bf5f1608099$export$c075b0a4ec670c87 = ({ isReadingAids: isReadingAids, sourceProduct: sourceProduct, dwellTime: dwellTime, loadTime: loadTime, fmpLoadTime: fmpLoadTime, ...props })=>{
    const { query: query, source: source, searchSessionId: searchSessionId } = props;
    return {
        action: 'unmounted',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            aiFeatureName: isReadingAids ? `Definitions ${sourceProduct ? `(${sourceProduct})` : ''}` : 'smartAnswers',
            aiInteractionId: isReadingAids ? undefined : searchSessionId,
            aiInteractionType: isReadingAids ? undefined : 'searchSessionId',
            dwellTime: dwellTime,
            loadTime: loadTime,
            fmpLoadTime: fmpLoadTime
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $0f9647babe97feca$export$e9cccbc780a694f3 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'viewed',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};




var $h0U7J = parcelRequire("h0U7J");




const $a92ce6609ffd286a$export$67b8bcd639e29c44 = (props, smartAnswersRoute)=>{
    const { query: query, source: source } = props;
    return {
        action: 'classified',
        actionSubject: 'aiAnswerRoute',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            smartAnswersRoute: smartAnswersRoute
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};


/* legacy-smart-answer-card.tsx generated by @compiled/babel-plugin v3.0.1 */ 
























const $63c93f29914d2a48$export$9402fab525dc0906 = ({ ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerExpand',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};



/* ai-answer-loading-dialog.tsx generated by @compiled/babel-plugin v3.0.1 */ 



























/* collapse.tsx generated by @compiled/babel-plugin v3.0.1 */ 



var $55fM8 = parcelRequire("55fM8");








var $dLFT2 = parcelRequire("dLFT2");


var $99F21 = parcelRequire("99F21");









/* blur.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 





const $c6d2a8016b60f18c$export$975a268f2c733e4 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31fEoDO _313842dnbC _0adFHsHZdu _1DCdHidnbC _2XsHFMHZdu _0Bm75GdnbC _3iDTPbvLZJ _0jFU0VS40j _1mT5xdHE3j",
            __cmplp.className
        ])
    });
});


/* button-icon.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 





const $2e5a59e941d0fe31$export$e1c22a2ee2645e36 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _1VJPcacqvQ",
            __cmplp.className
        ])
    });
});





const $be25ea10e9db0496$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title_label: {
        id: "search_ai.smart_answer_card_title",
        defaultMessage: "Answer"
    },
    expand_label: {
        id: "search_ai.smart_answer_expand_label",
        defaultMessage: "Expand"
    },
    collapse_label: {
        id: "search_ai.smart_answer_collapse_label",
        defaultMessage: "Collapse"
    },
    ai_answer_generating_rovo: {
        id: "ai_answer_generating_rovo",
        defaultMessage: "Generating"
    },
    ai_answer_expand_tooltip: {
        id: "search_ai.ai_answer_expand_tooltip",
        defaultMessage: "Expand"
    },
    ai_answer_collapse_tooltip: {
        id: "search_ai.ai_answer_collapse_tooltip",
        defaultMessage: "Collapse"
    }
});


/* toggle-button.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 





const $5a0cb5fb375d30f7$export$d2b052e7b4be1756 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0wOv4Q7zJH _3iDTPbvLZJ",
            __cmplp.className
        ])
    });
});


const $70cd1a3bbfd7e400$var$styles = {
    container: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS",
    expanded: "_0jFU0VIZbP",
    collapsed: "_0jFU0Vb1xp",
    pointerCursor: "_0wOv4Q7zJH",
    titleContainer: "_2sNsIg7NXe _1UtDYzKGUX _1kk5Tk7GSX _0Of8r25zaO _1ZnuxbNHnM _1wydGWPgdg _2Zuz6QNHnM",
    title: "_0GwItXDIqT _0jFU0VXjOh"
};
var $70cd1a3bbfd7e400$var$EXPANSION_STATE = /*#__PURE__*/ function(EXPANSION_STATE) {
    EXPANSION_STATE[EXPANSION_STATE["LOADING"] = 1] = "LOADING";
    // still computing if the threshold is crossed
    EXPANSION_STATE[EXPANSION_STATE["COLLAPSED"] = 2] = "COLLAPSED";
    // threshold crossed, render component collapsed
    EXPANSION_STATE[EXPANSION_STATE["EXPANDED"] = 3] = "EXPANDED";
    return EXPANSION_STATE;
}($70cd1a3bbfd7e400$var$EXPANSION_STATE || {});
const $70cd1a3bbfd7e400$export$78768a9af065a7b = ({ children: children, collapsed: collapsed, isLoading: isLoading, toggleCollapsedState: toggleCollapsedState = ()=>{}, expandWhenClickedAnywhere: expandWhenClickedAnywhere = false, isStreaming: isStreaming = false, disableCollapse: disableCollapse = false, callbacks: callbacks })=>{
    const [initialExpansionState, setInitialExpansionState] = (0, $cozmU.useState)(1);
    const threshold = 150;
    const collapseableContainerRef = (0, $cozmU.useCallback)((node)=>{
        if (!node || disableCollapse) return;
        const resizeObserver = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            // delay computation to ensure the observed node has rendered and the height reported is accurate
            setTimeout(()=>{
                const childHeight = node.getBoundingClientRect().height;
                if (isStreaming || isLoading || !Boolean(childHeight)) return;
                 // checking if the length of the answer is smaller than the collapse threshold
                if (childHeight <= threshold && initialExpansionState !== 3) setInitialExpansionState(3);
                else setInitialExpansionState(2);
            }, 100);
        }, 100));
        resizeObserver.observe(node);
    }, // make sure the dependancy array is empty,
    // this is to ensure the resizeObserver is registered just once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $cozmU.useEffect)(()=>{
        /**
     * if the answer has finished isLoading and the container is too small to collapse,
     * toggle collapsed state to false
     * this helps external components watching the boolean to know the actual state
     */ if (initialExpansionState === 3 && !isLoading && !isStreaming && collapsed || disableCollapse) {
            toggleCollapsedState();
            callbacks?.onExpandedByDefault?.();
        }
    }, [
        initialExpansionState,
        isLoading,
        isStreaming,
        collapsed,
        callbacks,
        toggleCollapsedState,
        disableCollapse
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tooltipText = formatMessage(collapsed ? (0, $be25ea10e9db0496$export$defe85febe8b728c).ai_answer_expand_tooltip : (0, $be25ea10e9db0496$export$defe85febe8b728c).ai_answer_collapse_tooltip); // allow whole container clicks to expand when enabled
    const onContainerClickHandler = ()=>{
        if (expandWhenClickedAnywhere && collapsed) {
            callbacks?.onExpandClicked?.();
            toggleCollapsedState();
        }
    };
    const onClickHandler = (e)=>{
        // stop container click from being called
        e.stopPropagation();
        if (collapsed) callbacks?.onExpandClicked?.();
        else callbacks?.onCollapseClicked?.();
        toggleCollapsedState();
    }; /**
      * render the non collapsable version
      * - child container's height is lesser than the threshold
      * - collapsed card is externally disabled, ex: for a person card
      */ 
    if (initialExpansionState === 3 || disableCollapse) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($70cd1a3bbfd7e400$var$styles.container, $70cd1a3bbfd7e400$var$styles.expanded)
    }, /*#__PURE__*/ $cozmU.createElement("div", null, !isLoading && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        xcss: $70cd1a3bbfd7e400$var$styles.titleContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $70cd1a3bbfd7e400$var$styles.title
    }, formatMessage((0, $be25ea10e9db0496$export$defe85febe8b728c).title_label))), children));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($70cd1a3bbfd7e400$var$styles.container, collapsed ? $70cd1a3bbfd7e400$var$styles.collapsed : $70cd1a3bbfd7e400$var$styles.expanded, expandWhenClickedAnywhere && collapsed && $70cd1a3bbfd7e400$var$styles.pointerCursor),
        onClick: onContainerClickHandler
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: 'space-between',
        xcss: $70cd1a3bbfd7e400$var$styles.titleContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $70cd1a3bbfd7e400$var$styles.title
    }, formatMessage((0, $be25ea10e9db0496$export$defe85febe8b728c).title_label)), initialExpansionState === 2 && /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        position: 'bottom',
        content: tooltipText
    }, /*#__PURE__*/ $cozmU.createElement((0, $5a0cb5fb375d30f7$export$d2b052e7b4be1756), {
        onClick: onClickHandler,
        "data-testid": "expand-collapse-toggle"
    }, /*#__PURE__*/ $cozmU.createElement((0, $2e5a59e941d0fe31$export$e1c22a2ee2645e36), null, collapsed ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dLFT2))), {
        color: "currentColor",
        spacing: "spacious",
        label: formatMessage((0, $be25ea10e9db0496$export$defe85febe8b728c).expand_label)
    }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($99F21))), {
        color: "currentColor",
        spacing: "spacious",
        label: formatMessage((0, $be25ea10e9db0496$export$defe85febe8b728c).collapse_label)
    }))))), /*#__PURE__*/ $cozmU.createElement("div", {
        ref: collapseableContainerRef
    }, children), initialExpansionState === 2 && collapsed && /*#__PURE__*/ $cozmU.createElement((0, $c6d2a8016b60f18c$export$975a268f2c733e4), null));
};


/* ai-answer-loading-stream.tsx generated by @compiled/babel-plugin v3.0.1 */ // vendored from packages/editor/editor-plugin-ai/src/experience-application/screens-with-logic/LoadingScreenWithLogic.tsx
// similar logic also exists in packages/editor/renderer/src/ui/Renderer/index.tsx
















const $0a9d8cb2ea1f3c14$var$styles = {
    container: "_4kiQYAMw9m _0Of8r22ADO _1ZnuxbNHnM _1wydGW2ADO _2Zuz6QNHnM",
    containerStylesWithoutStreamingExpand: "_4bt5LAnQyn _2WAcuGnQyn _0NUa3roaux"
};

const $0a9d8cb2ea1f3c14$var$ReactRenderer = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("7ydRw")).then(({ ReactRenderer: ReactRenderer })=>{
        return {
            default: ReactRenderer
        };
    }));
const $0a9d8cb2ea1f3c14$export$9799dac43580176f = ({ markdown: markdown })=>{
    const docContent = (0, $cozmU.useMemo)(()=>(0, $6rwn6.encodeAdf)(markdown, false), [
        markdown
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($0a9d8cb2ea1f3c14$var$styles.container, !(0, $iDrrr.fg)('kd_sain_enable_expand_when_streaming') && $0a9d8cb2ea1f3c14$var$styles.containerStylesWithoutStreamingExpand)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement($0a9d8cb2ea1f3c14$var$ReactRenderer, {
        document: docContent,
        nodeComponents: {
            status: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $e2862f0d359af03a$export$21553c57082a6434), props),
            // Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
            // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
            ...!(0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search') ? {
                media: ()=>/*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null),
                mediaSingle: ()=>/*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
            } : undefined
        }
    })));
};


/* ai-answer-search-loading-border.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 







const $a933b5b48b93d085$export$1be966180e49de50 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isStreaming: isStreaming, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1sx4jwu": (0, $9aYkv.default)(__cmplp.isStreaming ? `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-100, 8px)"} 0` : '0px')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvD1Y8M _4FKVYES3mC _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _1mT5xdRAKS _24h04i2Njc _42Yu6B7LI7 _2OUyjtGk8v _1Oimfu1Y8M _4eDJc6wnwD _2OUbymzqbc _3Ku51Iogpp _3ScelF7Iub _1lBcDcUtRB _1L3m71eHuj _35I30Bgews _3dCYwDWVPG _3qT6l0RMbu _3fRV4Cdssy _0EnhYgHZdu _2Gfj6i1Y8M _0GBAIrogpp _2jfUf9yTPQ _47eTBtyTPQ _2WYcYGWVPG _39mJBjvQQr _3wEj0XoI2d",
            __cmplp.className
        ])
    });
});


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


// vendored from packages/editor/editor-plugin-ai/src/ui/modal/styles.tsx
const $a4d43c012dcfdf53$var$GeneratingAnimation = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "var(--ds-text-brand, #1868DB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "var(--ds-text-brand, #1868DB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "var(--ds-text-brand, #1868DB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
};
var $a4d43c012dcfdf53$export$2e2bcd8739ae039 = $a4d43c012dcfdf53$var$GeneratingAnimation;


/* generating-container.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 





const $8737e9a3ac95e059$export$b6aef1fd050b8edc = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0jFU0VaXQy _24h04i2Njc _0Of8r2NHnM _1ZnuxbNHnM _1wydGWdnbC _2Zuz6QNHnM",
            __cmplp.className
        ])
    });
});


/* generating-text.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 





const $196cb4b3d52f30e4$export$636ea4c09615ceed = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _2XsHFMFQfX _1UtDYzKGUX",
            __cmplp.className
        ])
    });
});


const $1045f8dfe3504936$var$styles = {
    scroll: "_0NUa3rb1xp _0Of8r25zaO _2WAcuGIZbP _4bt5LAnQyn _0Fz5g59IY0"
};
const $1045f8dfe3504936$export$73cae3a70b740900 = ({ collapsed: collapsed, toggleCollapsedState: toggleCollapsedState, callbacks: callbacks })=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3hVWe.useAIAnswerContext)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $kSORO.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1045f8dfe3504936$var$LegacySmartAnswerLoadingDialog, {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        callbacks: callbacks
    });
};
const $1045f8dfe3504936$var$LegacySmartAnswerLoadingDialog = ({ collapsed: collapsed = true, toggleCollapsedState: toggleCollapsedState, callbacks: callbacks })=>{
    const { partialResponse: partialResponse, queryReasoning: queryReasoning, isReadingAids: isReadingAids, onClose: onClose } = (0, $3hVWe.useAIAnswerContext)();
    const { serveExperiment: serveSAINReasoningExperiment } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_reasoning_exp'
    });
    const isQuickSearch = Boolean(!isReadingAids && onClose);
    if (!partialResponse || partialResponse?.format !== (0, $hpFQM.NLPSearchResultFormat).MARKDOWN) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a933b5b48b93d085$export$1be966180e49de50), {
        isStreaming: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8737e9a3ac95e059$export$b6aef1fd050b8edc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4d43c012dcfdf53$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $196cb4b3d52f30e4$export$636ea4c09615ceed), null, serveSAINReasoningExperiment && queryReasoning ? queryReasoning : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $cb86z.messages).ai_answer_generating_rovo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null));
    if (isQuickSearch) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a933b5b48b93d085$export$1be966180e49de50), {
        isStreaming: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1045f8dfe3504936$var$styles.scroll
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0a9d8cb2ea1f3c14$export$9799dac43580176f), {
        markdown: partialResponse.partialNlpResult
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a933b5b48b93d085$export$1be966180e49de50), {
        isStreaming: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70cd1a3bbfd7e400$export$78768a9af065a7b), {
        collapsed: collapsed,
        isLoading: true,
        isStreaming: true,
        expandWhenClickedAnywhere: true,
        toggleCollapsedState: toggleCollapsedState,
        callbacks: callbacks
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0a9d8cb2ea1f3c14$export$9799dac43580176f), {
        markdown: partialResponse.partialNlpResult
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null))));
};









/* ai-answer-search-border.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 







const $af4c4d6333fdd634$export$f2207ab910ac3fa8 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, isStreaming: isStreaming, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ibnsxm": (0, $9aYkv.default)(__cmplp.isLoading || __cmplp.isStreaming ? 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)' : "var(--ds-surface-overlay, #FFFFFF)"),
            "--_10yp470": (0, $9aYkv.default)(__cmplp.isLoading || __cmplp.isStreaming ? 'rotate 3s infinite linear' : 'rotate-end 3s 1 linear')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _30huDKOeNX _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _1mT5xdRAKS _24h04i2Njc _42Yu6B7LI7 _1OimfuKxmn _4eDJc6iSDY _2OUbym3Aaw _3Ku51Iogpp _3ScelF7Iub _1lBcDcUtRB _1L3m71eHuj _35I30Bgews _3dCYwDWVPG _3qT6l0RMbu _3fRV4Cdssy _0EnhYgHZdu _2Gfj6iKxmn _0GBAIrogpp _2jfUf9yTPQ _47eTBtyTPQ _2WYcYGWVPG _39mJBjvQQr _3wEj0XoI2d",
            __cmplp.className
        ])
    });
});



const $4405991c63379ccf$var$styles = {
    spacer: "_0jFU0VEbN9 _0Of8r2kG2W",
    errorContainer: "_3138422ADO _1DCdHi5zaO",
    sourcesContainer: "_0Of8r2dnbC _1ZnuxbNHnM _1wydGW2ADO _2Zuz6QNHnM",
    scroll: "_0NUa3rzY1C _4bt5LAnQyn _2WAcuGIZbP _0Fz5g59IY0"
};
const $4405991c63379ccf$var$MAX_SOURCES = 4;
const $4405991c63379ccf$export$cf72ef8498afcbc2 = ({ LoadingWrapper: LoadingWrapper, DialogWrapper: DialogWrapper, onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { commonAttributes: commonAttributes, callbacks: callbacks, loading: loading, isReadingAids: isReadingAids, onClose: onClose, hasError: hasError, initiallyExpanded: initiallyExpanded } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { query: query } = commonAttributes;
    const { answerFormat: answerFormat } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(true);
    const isQuickSearch = Boolean(!isReadingAids && onClose); // reset on each new query
    (0, $cozmU.useEffect)(()=>{
        setCollapsed(!initiallyExpanded); // Notify parent context of initial state
        onAnswerExpandedChange?.(!initiallyExpanded);
    }, [
        query,
        initiallyExpanded,
        onAnswerExpandedChange
    ]); // Call onFMPReached when answer is loaded
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError) onFMPReached?.();
    }, [
        loading,
        hasError,
        onFMPReached
    ]);
    const toggleCollapsedState = ()=>{
        if (collapsed) fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
        setCollapsed(!collapsed); // Notify parent context of state change
        onAnswerExpandedChange?.(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $63c93f29914d2a48$export$9402fab525dc0906)(commonAttributes)),
        onExpandClicked: ()=>fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes)),
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes))
    };
    const sourceClickCallback = (0, $cozmU.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    if (loading) return /*#__PURE__*/ $cozmU.createElement(LoadingWrapper, null, // disable collapse/expand when streaming for quick search
    isQuickSearch ? /*#__PURE__*/ $cozmU.createElement((0, $1045f8dfe3504936$export$73cae3a70b740900), null) : /*#__PURE__*/ $cozmU.createElement((0, $1045f8dfe3504936$export$73cae3a70b740900), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        callbacks: analyticsCallbacks
    }));
    let aiAnswerContent = /*#__PURE__*/ $cozmU.createElement((0, $70cd1a3bbfd7e400$export$78768a9af065a7b), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    if (hasError) aiAnswerContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4405991c63379ccf$var$styles.errorContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    else if (isQuickSearch || answerFormat === (0, $hpFQM.NLPSearchResultFormat).JSON) aiAnswerContent = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4405991c63379ccf$var$styles.spacer
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: isQuickSearch ? $4405991c63379ccf$var$styles.scroll : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null)));
    return /*#__PURE__*/ $cozmU.createElement(DialogWrapper, null, /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: false,
        isStreaming: false
    }, aiAnswerContent, !hasError && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4405991c63379ccf$var$styles.sourcesContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $ce789c5dd436d96e$export$bbbfd63fa7f32357), {
        sources: commonAttributes.sources,
        searchSessionId: commonAttributes.searchSessionId,
        onClickHandler: sourceClickCallback,
        limit: $4405991c63379ccf$var$MAX_SOURCES,
        enableSmartLinkSources: true
    })), /*#__PURE__*/ $cozmU.createElement((0, $34e9b06075b84401$export$37858bd8fa3d5915), null)));
};


/* legacy-smart-answer-card-without-streaming-expand.tsx generated by @compiled/babel-plugin v3.0.1 */ 

































const $d365ffe2a496da37$var$styles = {
    spacer: "_0jFU0VEbN9 _0Of8r2kG2W",
    errorContainer: "_3138422ADO _1DCdHi5zaO",
    sourcesContainer: "_0Of8r2dnbC _1ZnuxbNHnM _1wydGW2ADO _2Zuz6QNHnM"
};
const $d365ffe2a496da37$var$MAX_SOURCES = 4;
const $d365ffe2a496da37$export$b054d5cce3d1302d = ({ LoadingWrapper: LoadingWrapper, DialogWrapper: DialogWrapper, onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { commonAttributes: commonAttributes, callbacks: callbacks, loading: loading, isReadingAids: isReadingAids, onClose: onClose, hasError: hasError, initiallyExpanded: initiallyExpanded } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { answerFormat: answerFormat, query: query } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(true);
    const isQuickSearch = Boolean(!isReadingAids && onClose); // reset on each new query
    (0, $cozmU.useEffect)(()=>{
        setCollapsed(!initiallyExpanded); // Notify parent context of initial state
        onAnswerExpandedChange?.(!initiallyExpanded);
    }, [
        query,
        initiallyExpanded,
        onAnswerExpandedChange
    ]); // Call onFMPReached when answer is loaded
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError) onFMPReached?.();
    }, [
        loading,
        hasError,
        onFMPReached
    ]);
    const toggleCollapsedState = ()=>{
        if (collapsed) fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
        setCollapsed(!collapsed); // Notify parent context of state change
        onAnswerExpandedChange?.(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $63c93f29914d2a48$export$9402fab525dc0906)(commonAttributes)),
        onExpandClicked: ()=>fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes)),
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes))
    };
    const sourceClickCallback = (0, $cozmU.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    if (loading) return /*#__PURE__*/ $cozmU.createElement(LoadingWrapper, null, /*#__PURE__*/ $cozmU.createElement((0, $1045f8dfe3504936$export$73cae3a70b740900), null));
    let aiAnswerContent = /*#__PURE__*/ $cozmU.createElement((0, $70cd1a3bbfd7e400$export$78768a9af065a7b), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    if (hasError) aiAnswerContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d365ffe2a496da37$var$styles.errorContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    else if (isQuickSearch || answerFormat === (0, $hpFQM.NLPSearchResultFormat).JSON) aiAnswerContent = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d365ffe2a496da37$var$styles.spacer
    }), /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    return /*#__PURE__*/ $cozmU.createElement(DialogWrapper, null, /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: false,
        isStreaming: false
    }, aiAnswerContent, !hasError && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d365ffe2a496da37$var$styles.sourcesContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $ce789c5dd436d96e$export$bbbfd63fa7f32357), {
        sources: commonAttributes.sources,
        searchSessionId: commonAttributes.searchSessionId,
        onClickHandler: sourceClickCallback,
        limit: $d365ffe2a496da37$var$MAX_SOURCES,
        enableSmartLinkSources: true
    })), /*#__PURE__*/ $cozmU.createElement((0, $34e9b06075b84401$export$37858bd8fa3d5915), null)));
};


/* smart-answer-card.tsx generated by @compiled/babel-plugin v3.0.1 */ 
























const $fdc9836a17fb59bc$export$22fa983d82ded8f8 = (text)=>{
    if (!text || typeof text !== 'string') return null;
    // Normalize the text by trimming extra whitespace
    const normalizedText = text.trim();
    // Regular expressions to match various date formats, including day of the week
    const datePatterns = [
        // Date ranges (e.g., "May 5th to May 7th, 2025")
        /\b(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)?,?\s*(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\s+to\s+(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)?,?\s*(?:January|February|March|April|May|June|July|August|September|October|November|December)?\s*\d{1,2}(?:st|nd|rd|th)?,?\s+\d{4}\b/i,
        // Day of the week with full date (e.g., "Monday, May 26th")
        /\b(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday),?\s+(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\b/i,
        // Full dates with year (e.g., "May 26, 2025")
        /\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2},\s+\d{4}\b/i,
        // Dates with ordinals (e.g., "June 30th")
        /\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\b/i,
        // Month and year formats (e.g., "March 2025")
        /\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{4}\b/i
    ];
    // Loop through patterns and try to find a match
    for (const pattern of datePatterns){
        const match = normalizedText.match(pattern);
        if (match) return match[0]; // Return the matched date or date range
    }
    // If no date is found, return null
    return null;
};


const $d32a7f1947667167$export$9df94c77b0746c3c = (answerStr)=>{
    if (!answerStr || typeof answerStr !== 'string') return null;
    // Remove extra whitespace and normalize
    const normalizedText = answerStr.trim().replace(/\s+/g, ' ');
    // Too short to be an address
    if (normalizedText.length < 5) return null;
    // Comprehensive address pattern
    // This pattern supports:
    // - Street numbers and names
    // - Unit numbers (e.g., #123, Apt 123, Suite 123)
    // - City/region/state names
    // - Optional state abbreviations (e.g., CA, TX, NSW)
    // - Optional postal/ZIP codes
    // - Optional country names
    const addressPattern = /\b\d{1,5}\s+[\w\s\.,\-#]+(?:#\d+|,\s*(?:Apt|Suite|Unit|Room|Fl|Floor)?\s*\d+)?\s*,\s*[\w\s]+,\s*[A-Z]{2,3}(?:\s*\d{4,5}(?:-\d{4})?)?(?:,\s*[A-Za-z\s]+)?\b/i;
    // Match the address in the text
    const match = normalizedText.match(addressPattern);
    if (match) return match[0]; // Return the matched address
    // If no match is found, return null
    return null;
};





/* DateCard.tsx generated by @compiled/babel-plugin v3.0.1 */ 



















const $52b306ea8d9fa88f$export$732cac0318736348 = (props)=>{
    const { query: query, answerString: answerString, source: source, selectedTab: selectedTab } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerTab',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            selectedTab: selectedTab
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};















var $hMjUh = parcelRequire("hMjUh");

const $bf094e7523adfeb4$export$1aa02cade2c95a15 = ({ children: children, selectedTabIndex: selectedTabIndex, onChange: onChange })=>{
    const handleChange = (0, $cozmU.useCallback)((index)=>{
        onChange?.(index);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMjUh.default), {
        onChange: handleChange,
        selected: selectedTabIndex ?? 0,
        id: "ai-answer-tabs"
    }, children);
};


/* ai-tabs-header.tsx generated by @compiled/babel-plugin v3.0.1 */ 


















var $bxtKM = parcelRequire("bxtKM");


var $dkVNA = parcelRequire("dkVNA");





const $e6b6c44db5d7c309$var$styles = {
    fullHeight: "_0jFU0VN91d",
    tabListAndButtonInline: "_2Zuz6Q5zaO _1Znuxb5zaO _0Of8r2gVvo _3X5xyYjOvk"
};
const $e6b6c44db5d7c309$export$29246287a2faf86e = ({ collapsed: collapsed, onExpandCollapseButtonClick: onExpandCollapseButtonClick, showSourcesTab: showSourcesTab })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        testId: "ai-tabs-header",
        xcss: $e6b6c44db5d7c309$var$styles.tabListAndButtonInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dkVNA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5OgwG.messages).ai_answer_card_tab_ai_answer)), showSourcesTab ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5OgwG.messages).ai_answer_card_tab_sources)) : null), typeof collapsed === 'boolean' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: collapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
        label: formatMessage(collapsed ? (0, $5OgwG.messages).ai_answer_card_expand_button : (0, $5OgwG.messages).ai_answer_card_collapse_button),
        spacing: "compact",
        onClick: onExpandCollapseButtonClick
    }) : null);
};
const $e6b6c44db5d7c309$export$fe213eac7ac2fc44 = ({ collapsed: collapsed, onExpandCollapseButtonClick: onExpandCollapseButtonClick, sources: sources })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        testId: "ai-tabs-header-with-sources-stack",
        xcss: $e6b6c44db5d7c309$var$styles.tabListAndButtonInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dkVNA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5OgwG.messages).ai_answer_card_tab_ai_answer)), sources && sources.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0122fe4f75fa739$export$ebff7094edd1bb81), {
        sources: sources
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $5OgwG.messages).ai_answer_card_tab_sources_with_pluralization,
        values: {
            sourcesCount: sources.length
        }
    })))) : null), typeof collapsed === 'boolean' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: collapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
        label: formatMessage(collapsed ? (0, $5OgwG.messages).ai_answer_card_expand_button : (0, $5OgwG.messages).ai_answer_card_collapse_button),
        spacing: "compact",
        onClick: onExpandCollapseButtonClick
    }) : null);
};


/* ai-tabs-panel.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $22LbG = parcelRequire("22LbG");

const $5de67d1ea6e1b326$var$styles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _1wydGWgVvo _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r28HPE",
    rootCollapsed: "_0jFU0Vv6H3 _3X9j4qyIAw",
    rootCollapsedWithReadMore: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VaXQy _39HuIbz8Lp _1ANEUSLRg7 _3X9j4qyIAw",
    rootExpanded: "_4kiQYAJK6w",
    fullWidth: "_39xV02N91d"
};
const $5de67d1ea6e1b326$export$43f4112a26740715 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, collapsed: collapsed, showReadMoreButton: showReadMoreButton = false, xcss: xcss }, ref)=>{
    const tabPanelAttributes = (0, $22LbG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ...tabPanelAttributes,
        ref: ref,
        xcss: xcss ?? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $w6R6I.cx)($5de67d1ea6e1b326$var$styles.root, collapsed ? showReadMoreButton ? $5de67d1ea6e1b326$var$styles.rootCollapsedWithReadMore : $5de67d1ea6e1b326$var$styles.rootCollapsed : $5de67d1ea6e1b326$var$styles.rootExpanded)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5de67d1ea6e1b326$var$styles.fullWidth
    }, children));
});
































function $f708b07cf4208d3d$export$257180ca8df15f46() {
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { callbacks: callbacks, commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3hVWe.useAIAnswerContext)();
    const { searchSessionId: searchSessionId, sources: sources } = commonAttributes;
    const sourceClickCallback = (0, $cozmU.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        callbacks,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        rowSpace: "space.100",
        shouldWrap: true,
        space: "space.050"
    }, sources.map((source, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1b1a8e20e360a5ba$export$c74cbf75d6285884), {
            index: index,
            key: `search-ai-answer-source-${index}`,
            source: source,
            searchSessionId: searchSessionId,
            onClickHandler: sourceClickCallback,
            enableSmartLinkSources: true
        }))))));
}


var $c944907a7c3cf04d$exports = {};
$c944907a7c3cf04d$exports = new URL("calendar-dark.a0ed3c18.svg", import.meta.url).toString();


var $b023a6dd3172b3f3$exports = {};
$b023a6dd3172b3f3$exports = new URL("calendar-light.caa4677f.svg", import.meta.url).toString();














const $66672200df25afcb$var$defaultKnowledgeCardActionsProps = {
    alignBlock: 'center',
    grow: 'fill',
    space: 'space.100'
};
const $66672200df25afcb$export$cb4f4efd621b33bb = (props)=>{
    const knowledgeCardActionsProps = {
        ...$66672200df25afcb$var$defaultKnowledgeCardActionsProps,
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), knowledgeCardActionsProps);
};








const $3ed1a970e5fbfe5a$export$d7852a48c1d6ef5b = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, children);
};








const $73ede9aab4e60fda$export$ea5f007cec623a83 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), props);
};


/* KnowledgeCardMedia.tsx generated by @compiled/babel-plugin v3.0.1 */ 








const $92faf9abea946b60$var$knowledgeCardMediaStyles = {
    default: "_0bjKvDKxmn _2V7sgOdnbC _3iDTPbQ4SZ _0hPCNLDIqT",
    compact: "_0jFU0VUofl _39xV02Uofl",
    full: "_0jFU0VljYU _39xV02ljYU"
};
const $92faf9abea946b60$export$71b41532401d47f7 = ({ children: children, size: size })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($92faf9abea946b60$var$knowledgeCardMediaStyles.default, size === 'compact' ? $92faf9abea946b60$var$knowledgeCardMediaStyles.compact : $92faf9abea946b60$var$knowledgeCardMediaStyles.full)
    }, children);
};











const $e88096a7a02ac9fb$export$74276a28ff67aa9f = ({ children: children, size: size, color: color = 'color.text.brand' })=>{
    return size === 'compact' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: color,
        weight: "medium"
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, children);
};








const $56831a9193164adc$export$663c4a200ce34343 = ({ children: children, color: color = 'color.text.subtle', ...textProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: color,
        ...textProps
    }, children);
};


const $6187e3537f7d74da$export$ecbf022f1f5d6f16 = ({ name: name, actions: actions, category: category, media: media, primaryDescription: primaryDescription, secondaryDescription: secondaryDescription, size: size, primaryDescriptionColor: primaryDescriptionColor, containerStyles: containerStyles })=>{
    const isCardCompact = size === 'compact';
    const actionsToDisplay = isCardCompact && actions && actions.length > 1 ? [
        actions[0]
    ] : actions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i3wdq.KnowledgeCard), {
        name: name,
        space: isCardCompact ? 'space.150' : 'space.250',
        size: size,
        containerStyles: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92faf9abea946b60$export$71b41532401d47f7), {
        size: size
    }, media), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73ede9aab4e60fda$export$ea5f007cec623a83), {
        space: isCardCompact ? 'space.100' : 'space.200'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73ede9aab4e60fda$export$ea5f007cec623a83), {
        space: 'space.100'
    }, size === 'full' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3ed1a970e5fbfe5a$export$d7852a48c1d6ef5b), null, category) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73ede9aab4e60fda$export$ea5f007cec623a83), {
        space: isCardCompact ? 'space.0' : 'space.050'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e88096a7a02ac9fb$export$74276a28ff67aa9f), {
        size: size,
        color: primaryDescriptionColor
    }, primaryDescription), secondaryDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $56831a9193164adc$export$663c4a200ce34343), {
        color: isCardCompact ? 'color.text.subtlest' : 'color.text.subtle'
    }, secondaryDescription) : null)), actionsToDisplay && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $66672200df25afcb$export$cb4f4efd621b33bb), null, actionsToDisplay.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: `displayed-action-${index}`
        }, action)))));
};


const $2fce1c23afe6a7a0$var$messages = (0, $kSwu1.defineMessages)({
    knowledge_card_date_category: {
        id: "search_ai_knowledge_card_date_category",
        defaultMessage: "Date"
    }
});
const $2fce1c23afe6a7a0$var$styles = {
    fullHeight: "_0jFU0VN91d",
    containerStyles: "_0Of8r2Pgdg _1ZnuxbPgdg _2Zuz6QPgdg _1wydGWPgdg",
    disclaimer: "_1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r21Y8M"
};
const $2fce1c23afe6a7a0$export$94bf83cfe2387066 = ({ date: date })=>{
    const [selectedTab, setSelectedTab] = (0, $cozmU.useState)((0, $zzZbq.AIAnswerTab).AI_ANSWER);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { sources: sources } = commonAttributes;
    const handleTabChange = (0, $cozmU.useCallback)((selectedTabIndex)=>{
        const selectedTab = (0, $zzZbq.aiAnswerTabsOrder)[selectedTabIndex];
        setSelectedTab(selectedTab);
        fireAnalyticsEvent((0, $52b306ea8d9fa88f$export$732cac0318736348)({
            ...commonAttributes,
            selectedTab: selectedTab
        }));
    }, [
        setSelectedTab,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: $2fce1c23afe6a7a0$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf094e7523adfeb4$export$1aa02cade2c95a15), {
        onChange: handleTabChange,
        selectedTabIndex: (0, $zzZbq.aiAnswerTabsOrder).indexOf(selectedTab)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6b6c44db5d7c309$export$29246287a2faf86e), {
        showSourcesTab: sources.length > 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5de67d1ea6e1b326$export$43f4112a26740715), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6187e3537f7d74da$export$ecbf022f1f5d6f16), {
        name: "smart-answer-date-knowledge-card",
        category: formatMessage($2fce1c23afe6a7a0$var$messages.knowledge_card_date_category),
        primaryDescription: date,
        media: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($b023a6dd3172b3f3$exports))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($c944907a7c3cf04d$exports))),
            alt: ""
        }),
        size: "full",
        containerStyles: $2fce1c23afe6a7a0$var$styles.containerStyles
    })), sources.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5de67d1ea6e1b326$export$43f4112a26740715), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f708b07cf4208d3d$export$257180ca8df15f46), null)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2fce1c23afe6a7a0$var$styles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true,
        showCopyButton: true,
        copyText: date
    })));
};


/* LocationCard.tsx generated by @compiled/babel-plugin v3.0.1 */ 












var $fHs3z = parcelRequire("fHs3z");






































var $5121c4e1ddce602c$exports = {};
$5121c4e1ddce602c$exports = new URL("location-dark.395fc7dc.svg", import.meta.url).toString();


var $c35562e84e0660f8$exports = {};
$c35562e84e0660f8$exports = new URL("location-light.9d9cfd0a.svg", import.meta.url).toString();



const $3ebc882f10955e5e$var$messages = (0, $kSwu1.defineMessages)({
    knowledge_card_location_category: {
        id: "search_ai_knowledge_card_location_category",
        defaultMessage: "Location"
    },
    knowledge_card_location_google_maps_action: {
        id: "search_ai_knowledge_card_location_google_maps_action",
        defaultMessage: "Show on Google Maps"
    }
});
const $3ebc882f10955e5e$var$styles = {
    fullHeight: "_0jFU0VN91d",
    containerStyles: "_0Of8r2Pgdg _1ZnuxbPgdg _2Zuz6QPgdg _1wydGWPgdg",
    disclaimer: "_1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r21Y8M"
};
const $3ebc882f10955e5e$var$generateGoogleMapsLink = (location)=>{
    const encodedAddress = encodeURIComponent(location);
    return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
};
const $3ebc882f10955e5e$export$52cbb82455de8553 = ({ location: location })=>{
    const [selectedTab, setSelectedTab] = (0, $cozmU.useState)((0, $zzZbq.AIAnswerTab).AI_ANSWER);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { brand: brand, commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString, query: query, queryHash: queryHash, searchSessionId: searchSessionId, sources: sources } = commonAttributes;
    const handleTabChange = (0, $cozmU.useCallback)((selectedTabIndex)=>{
        const selectedTab = (0, $zzZbq.aiAnswerTabsOrder)[selectedTabIndex];
        setSelectedTab(selectedTab);
        fireAnalyticsEvent((0, $52b306ea8d9fa88f$export$732cac0318736348)({
            ...commonAttributes,
            selectedTab: selectedTab
        }));
    }, [
        setSelectedTab,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    const copyLocation = async (location)=>{
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).COPY_CLICKED,
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $6O5Et.onAIAnswerCopyButtonClicked)(commonAttributes));
        await navigator.clipboard.writeText(location);
    };
    const onClickGoogleMaps = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $1mpi6.onNonGenerativeAIAnswerResultShown)({
            answerString: answerString,
            brand: brand,
            query: query,
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            source: 'location_knowledge_card',
            answerCardType: (0, $zzZbq.AnswerCardType).LOCATION
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SHOW_ON_GOOGLE_MAPS_CLICKED,
            commonAttributes: commonAttributes
        });
    }, [
        answerString,
        brand,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        query,
        queryHash,
        searchSessionId,
        commonAttributes
    ]);
    const googleMapsLink = $3ebc882f10955e5e$var$generateGoogleMapsLink(location);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: $3ebc882f10955e5e$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf094e7523adfeb4$export$1aa02cade2c95a15), {
        onChange: handleTabChange,
        selectedTabIndex: (0, $zzZbq.aiAnswerTabsOrder).indexOf(selectedTab)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6b6c44db5d7c309$export$29246287a2faf86e), {
        showSourcesTab: sources.length > 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5de67d1ea6e1b326$export$43f4112a26740715), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6187e3537f7d74da$export$ecbf022f1f5d6f16), {
        name: "smart-answer-location-knowledge-card",
        category: formatMessage($3ebc882f10955e5e$var$messages.knowledge_card_location_category),
        primaryDescription: location,
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
                href: googleMapsLink,
                onClick: onClickGoogleMaps
            }, formatMessage($3ebc882f10955e5e$var$messages.knowledge_card_location_google_maps_action)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
                label: "copy",
                onClick: ()=>copyLocation(location)
            })
        ],
        media: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($c35562e84e0660f8$exports))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($5121c4e1ddce602c$exports))),
            alt: ''
        }),
        size: "full",
        containerStyles: $3ebc882f10955e5e$var$styles.containerStyles
    })), sources.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5de67d1ea6e1b326$export$43f4112a26740715), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f708b07cf4208d3d$export$257180ca8df15f46), null)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $3ebc882f10955e5e$var$styles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true,
        showCopyButton: true,
        copyText: location
    })));
};
































/* generating-container.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 





const $1bf3cc99cff7b950$export$b6aef1fd050b8edc = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0jFU0VaXQy _24h04i2Njc _0Of8r2NHnM _1ZnuxbNHnM _1wydGWdnbC _2Zuz6QNHnM",
            __cmplp.className
        ])
    });
});


/* generating-text.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 





const $81ee304817c850e7$export$636ea4c09615ceed = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _2XsHFMFQfX _1UtDYzKGUX",
            __cmplp.className
        ])
    });
});



const $005c7db905c9053b$var$styles = {
    spacer: "_0jFU0VEbN9 _0Of8r2kG2W",
    errorContainer: "_0Of8r22ADO",
    sourcesContainer: "_0Of8r2dnbC _1ZnuxbNHnM _1wydGW8HPE _2Zuz6QNHnM"
};
const $005c7db905c9053b$var$MAX_SOURCES = 4;
const $005c7db905c9053b$var$SmartAnswerLoadingDialog = ({ collapsed: collapsed, toggleCollapsedState: toggleCollapsedState, callbacks: callbacks })=>{
    const { commonAttributes: commonAttributes, partialResponse: partialResponse, queryReasoning: queryReasoning, smartAnswersRoute: smartAnswersRoute } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $kSORO.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { serveExperiment: serveSAINReasoningExperiment } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_reasoning_exp'
    }); // no need for the Collapse component when showing the ... generating animation
    if (!partialResponse || partialResponse?.format !== (0, $hpFQM.NLPSearchResultFormat).MARKDOWN || smartAnswersRoute === (0, $zzZbq.QueryIntent).DATE || smartAnswersRoute === (0, $zzZbq.QueryIntent).LOCATION) return /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: true,
        isStreaming: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $1bf3cc99cff7b950$export$b6aef1fd050b8edc), null, /*#__PURE__*/ $cozmU.createElement((0, $a4d43c012dcfdf53$export$2e2bcd8739ae039), null), /*#__PURE__*/ $cozmU.createElement((0, $81ee304817c850e7$export$636ea4c09615ceed), null, serveSAINReasoningExperiment && queryReasoning ? queryReasoning : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $be25ea10e9db0496$export$defe85febe8b728c).ai_answer_generating_rovo))), /*#__PURE__*/ $cozmU.createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null));
    return /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: true,
        isStreaming: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ $cozmU.createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $70cd1a3bbfd7e400$export$78768a9af065a7b), {
        collapsed: collapsed,
        isLoading: true,
        isStreaming: true,
        expandWhenClickedAnywhere: true,
        toggleCollapsedState: toggleCollapsedState,
        callbacks: callbacks
    }, /*#__PURE__*/ $cozmU.createElement((0, $0a9d8cb2ea1f3c14$export$9799dac43580176f), {
        markdown: partialResponse.partialNlpResult
    })), /*#__PURE__*/ $cozmU.createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null)))));
};
const $005c7db905c9053b$export$827de04ba3667da0 = ({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { isAnswered: isAnswered, hasError: hasError, commonAttributes: commonAttributes, callbacks: callbacks, smartAnswersRoute: smartAnswersRoute, loading: loading, initiallyExpanded: initiallyExpanded } = (0, $3hVWe.useAIAnswerContext)();
    const { answerFormat: answerFormat, answerString: answerString, query: query } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(false); // reset on each new query
    (0, $cozmU.useEffect)(()=>{
        setCollapsed(!initiallyExpanded); // Notify parent context of initial state
        onAnswerExpandedChange?.(!initiallyExpanded);
    }, [
        query,
        initiallyExpanded,
        onAnswerExpandedChange
    ]); // Call onFMPReached when answer is loaded
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError) onFMPReached?.();
    }, [
        loading,
        hasError,
        onFMPReached
    ]);
    const toggleCollapsedState = ()=>{
        setCollapsed(!collapsed); // Notify parent context of state change
        onAnswerExpandedChange?.(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $63c93f29914d2a48$export$9402fab525dc0906)(commonAttributes)),
        onExpandClicked: ()=>{
            fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
                commonAttributes: commonAttributes
            });
        },
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes))
    };
    const sourceClickCallback = (0, $cozmU.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    if (loading) return /*#__PURE__*/ $cozmU.createElement($005c7db905c9053b$var$SmartAnswerLoadingDialog, {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        callbacks: analyticsCallbacks
    });
    let answerContent = /*#__PURE__*/ $cozmU.createElement((0, $70cd1a3bbfd7e400$export$78768a9af065a7b), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    if (hasError) answerContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $005c7db905c9053b$var$styles.errorContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    else if (answerFormat === (0, $hpFQM.NLPSearchResultFormat).JSON) answerContent = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $005c7db905c9053b$var$styles.spacer
    }), /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    const dateInAnswer = (0, $fdc9836a17fb59bc$export$22fa983d82ded8f8)(answerString);
    if (isAnswered && smartAnswersRoute === (0, $zzZbq.QueryIntent).DATE && dateInAnswer) return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: false,
        isStreaming: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $2fce1c23afe6a7a0$export$94bf83cfe2387066), {
        date: dateInAnswer
    })));
    const locationInAnswer = (0, $d32a7f1947667167$export$9df94c77b0746c3c)(answerString);
    if (isAnswered && smartAnswersRoute === (0, $zzZbq.QueryIntent).LOCATION && locationInAnswer) return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: false,
        isStreaming: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $3ebc882f10955e5e$export$52cbb82455de8553), {
        location: locationInAnswer
    })));
    return /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: false,
        isStreaming: false
    }, answerContent, !hasError && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $005c7db905c9053b$var$styles.sourcesContainer,
        testId: "ai-answer-sources"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ce789c5dd436d96e$export$bbbfd63fa7f32357), {
        sources: commonAttributes.sources,
        searchSessionId: commonAttributes.searchSessionId,
        onClickHandler: sourceClickCallback,
        allowFreeflowLayout: true,
        limit: $005c7db905c9053b$var$MAX_SOURCES
    })), /*#__PURE__*/ $cozmU.createElement((0, $34e9b06075b84401$export$74b8b3463af67a4d), null));
};


/* smart-answer-card-without-streaming-expand.tsx generated by @compiled/babel-plugin v3.0.1 */ 

























































const $243c0d4568578f49$var$styles = {
    spacer: "_0jFU0VEbN9 _0Of8r2kG2W",
    errorContainer: "_0Of8r22ADO",
    sourcesContainer: "_0Of8r2dnbC _1ZnuxbNHnM _1wydGW8HPE _2Zuz6QNHnM"
};
const $243c0d4568578f49$var$MAX_SOURCES = 4;
const $243c0d4568578f49$var$SmartAnswerLoadingDialog = ()=>{
    const { commonAttributes: commonAttributes, partialResponse: partialResponse, queryReasoning: queryReasoning } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $kSORO.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { serveExperiment: serveSAINReasoningExperiment } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_reasoning_exp'
    }); // no need for the Collapse component when showing the ... generating animation
    if (!partialResponse || partialResponse?.format !== (0, $hpFQM.NLPSearchResultFormat).MARKDOWN) return /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: true,
        isStreaming: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $1bf3cc99cff7b950$export$b6aef1fd050b8edc), null, /*#__PURE__*/ $cozmU.createElement((0, $a4d43c012dcfdf53$export$2e2bcd8739ae039), null), /*#__PURE__*/ $cozmU.createElement((0, $81ee304817c850e7$export$636ea4c09615ceed), null, serveSAINReasoningExperiment && queryReasoning ? queryReasoning : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $be25ea10e9db0496$export$defe85febe8b728c).ai_answer_generating_rovo))), /*#__PURE__*/ $cozmU.createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null));
    return /*#__PURE__*/ $cozmU.createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ $cozmU.createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: true,
        isStreaming: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement((0, $70cd1a3bbfd7e400$export$78768a9af065a7b), {
        collapsed: true,
        isLoading: true,
        isStreaming: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $0a9d8cb2ea1f3c14$export$9799dac43580176f), {
        markdown: partialResponse.partialNlpResult
    })), /*#__PURE__*/ $cozmU.createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null)))));
};
const $243c0d4568578f49$var$AnswerCard = ({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { hasError: hasError, commonAttributes: commonAttributes, callbacks: callbacks, initiallyExpanded: initiallyExpanded, loading: loading } = (0, $3hVWe.useAIAnswerContext)();
    const { answerFormat: answerFormat, query: query } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(true); // reset on each new query
    (0, $cozmU.useEffect)(()=>{
        setCollapsed(!initiallyExpanded); // Notify parent context of initial state
        onAnswerExpandedChange?.(!initiallyExpanded);
    }, [
        query,
        initiallyExpanded,
        onAnswerExpandedChange
    ]); // Call onFMPReached when answer is loaded
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError) onFMPReached?.();
    }, [
        loading,
        hasError,
        onFMPReached
    ]);
    const toggleCollapsedState = ()=>{
        if (collapsed) fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
        setCollapsed(!collapsed); // Notify parent context of state change
        onAnswerExpandedChange?.(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $63c93f29914d2a48$export$9402fab525dc0906)(commonAttributes)),
        onExpandClicked: ()=>fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes)),
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes))
    };
    const sourceClickCallback = (0, $cozmU.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            sourceProduct: source.product || '',
            commonAttributes: commonAttributes
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    let answerContent = /*#__PURE__*/ $cozmU.createElement((0, $70cd1a3bbfd7e400$export$78768a9af065a7b), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    if (hasError) answerContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $243c0d4568578f49$var$styles.errorContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    else if (answerFormat === (0, $hpFQM.NLPSearchResultFormat).JSON) answerContent = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $243c0d4568578f49$var$styles.spacer
    }), /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    return /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: false,
        isStreaming: false
    }, answerContent, !hasError && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $243c0d4568578f49$var$styles.sourcesContainer,
        testId: "ai-answer-sources"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ce789c5dd436d96e$export$bbbfd63fa7f32357), {
        sources: commonAttributes.sources,
        searchSessionId: commonAttributes.searchSessionId,
        onClickHandler: sourceClickCallback,
        allowFreeflowLayout: true,
        limit: $243c0d4568578f49$var$MAX_SOURCES
    })), /*#__PURE__*/ $cozmU.createElement((0, $34e9b06075b84401$export$74b8b3463af67a4d), null));
};
const $243c0d4568578f49$export$7d8a07a50ae14953 = ({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { loading: loading } = (0, $3hVWe.useAIAnswerContext)();
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, loading ? /*#__PURE__*/ $cozmU.createElement($243c0d4568578f49$var$SmartAnswerLoadingDialog, null) : /*#__PURE__*/ $cozmU.createElement($243c0d4568578f49$var$AnswerCard, {
        onFMPReached: onFMPReached,
        onAnswerExpandedChange: onAnswerExpandedChange
    }));
};




// These are the element tags Lumina can render inside a <lumina>…</lumina> block. They mirror the
// ElementTag union in @atlassian/lumina (src/layout/element/types.ts), which we can't import
// directly since it isn't on a public subpath — so if Lumina adds or renames a tag, add it here too.
const $b47b63f9e1c9c8da$var$KNOWN_LUMINA_ELEMENT_TAGS = [
    'action-card',
    'carousel',
    'md',
    'people-entity',
    'people-entity-list',
    'project-highlights',
    'related-people',
    'smart-link',
    'smart-link-list'
];
const $b47b63f9e1c9c8da$var$TAG_MATCHERS = $b47b63f9e1c9c8da$var$KNOWN_LUMINA_ELEMENT_TAGS.map((tag)=>[
        tag,
        new RegExp(`<${tag}(?=[\\s/>]|$)`)
    ]);
const $b47b63f9e1c9c8da$export$4e3a85aba66b9a32 = (luminaBlockContents)=>{
    const found = new Set();
    for (const content of luminaBlockContents){
        if (!content) continue;
        for (const [tag, matcher] of $b47b63f9e1c9c8da$var$TAG_MATCHERS)if (matcher.test(content)) found.add(tag);
    }
    return Array.from(found).sort();
};




const $a52d76eb98115dba$export$e25821f3420be6ad = ({ answerString: answerString, smartAnswersRoute: smartAnswersRoute })=>{
    if (!answerString) return 0;
    const { parsedResult: parsedResult, parsedType: parsedType } = (0, $d325f5b9eeee6e40$export$d905ae2a714518e8)({
        answerString: answerString,
        smartAnswersRoute: smartAnswersRoute
    });
    switch(parsedType){
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).TEAM:
            return 'id' in parsedResult && parsedResult.id ? 1 : 0;
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).WHO:
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).PERSON:
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).AGENT:
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).WORK:
            return Array.isArray(parsedResult) ? parsedResult.length : 0;
        default:
            return 0;
    }
};








/**
 * Maps product filter key names to the display string to append to the query.
 * "google_drive" is mapped to "google" per product requirement.
 */ const $273cb466e56a9a66$var$PRODUCT_DISPLAY_NAME_MAP = {
    confluence: 'confluence',
    jira: 'jira',
    github: 'github',
    teams: 'teams',
    drive: 'google'
};
function $273cb466e56a9a66$export$90c8c71ce0c72494(query, selectedProduct, queryIntent) {
    if (!(0, $iDrrr.fg)('kd_team_26_sain_rewrite_query') || queryIntent !== (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY) return query;
    if (!selectedProduct || !(selectedProduct in $273cb466e56a9a66$var$PRODUCT_DISPLAY_NAME_MAP)) return query;
    return `${query} from ${$273cb466e56a9a66$var$PRODUCT_DISPLAY_NAME_MAP[selectedProduct]}`;
}


const $86daeed37675c499$var$styles = {
    root: "_1mT5xdRAKS"
};
const $86daeed37675c499$var$SearchAIDialogComponent = ({ query: query, setQuery: setQuery, additionalQueryContext: additionalQueryContext, cloudId: cloudId, orgId: orgId, getAIAnswer: getAIAnswer, onNavigate: onNavigate, onClose: onClose, advancedSearchUrl: advancedSearchUrl, searchSessionId: searchSessionId, rovoJourneyId: rovoJourneyId, userDetails: userDetails, wrapper: wrapper, loadingWrapper: loadingWrapper, source: source = 'unknown', isReadingAids: isReadingAids = false, readingAidsOptions: readingAidsOptions, extraAnalyticsAttributes: extraAnalyticsAttributes = {}, cardProviderProps: cardProviderProps, baseQuery: baseQuery = '', onLoad: onLoad, followUpsEnabled: followUpsEnabled, selectedFilters: selectedFilters, parsedFilters: parsedFilters, selectedProduct: selectedProduct, mappedProductFilter: mappedProductFilter, answerLoadingRef: answerLoadingRef, smartAnswersRoute: smartAnswersRoute, cardTemplate: cardTemplate = (0, $zzZbq.CardTemplate).DEFAULT, sourceProduct: sourceProduct, workspaceId: workspaceId, brand: brand = (0, $zzZbq.AiBrand).AI, closeParentDialog: closeParentDialog, callbacks: callbacks, isAdminHubAIEnabled: isAdminHubAIEnabled, definitionToggleEnabled: definitionToggleEnabled, showChatFollowUps: showChatFollowUps, showGenericFooter: showGenericFooter = false, initiallyExpanded: initiallyExpanded = false, experimentContext: experimentContext, queryIntentClassificationData: queryIntentClassificationData, queryIntentDetectionMetadata: queryIntentDetectionMetadata, queryIntentDetectionTraceId: queryIntentDetectionTraceId, referrer: referrer, traceHeaders: traceHeaders, floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef, onAnswerExpandedStateChange: onAnswerExpandedStateChange })=>{
    const intl = (0, $kSwu1.useIntl)();
    const locale = intl.locale;
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [dwellTracked, setDwellTracked] = (0, $cozmU.useState)(false);
    const dwellTrackedRef = (0, $cozmU.useRef)(false); // Guards onAIAnswerLoadingDialogHidden so it fires at most once per load. Reset
    // when a new query starts so a subsequent load can fire it again.
    const loadingHiddenTrackedRef = (0, $cozmU.useRef)(false);
    const partialResponseAbortControllerRef = (0, $cozmU.useRef)();
    const [isLuminaAnswer, setIsLuminaAnswer] = (0, $cozmU.useState)(false);
    const [luminaContentMap, setLuminaContentMap] = (0, $cozmU.useState)({});
    const [partialResponse, setPartialResponse] = (0, $cozmU.useState)();
    const [queryReasoning, setQueryReasoning] = (0, $cozmU.useState)(); // Structured research steps from rich `RESEARCH_STEP_*` traces
    const [researchSteps, setResearchSteps] = (0, $cozmU.useState)({});
    const [dynamicLayoutSubAgentMessages, setDynamicLayoutSubAgentMessages] = (0, $cozmU.useState)([]);
    const [tabHasFocus, setTabHasFocus] = (0, $cozmU.useState)(true);
    const [dwellTimer, setDwellTimer] = (0, $cozmU.useState)(null);
    const dwellTimerRef = (0, $cozmU.useRef)(null);
    const definitionDwellTimeRef = (0, $cozmU.useRef)(null);
    const definitionDwellTimeTrackedRef = (0, $cozmU.useRef)(false);
    const [answerStreamed, setAnswerStreamed] = (0, $cozmU.useState)(false);
    const isBlueLinkAnalyticsEnabled = (0, $iDrrr.fg)('kd_sain_blue_links_analytics');
    const [isFMPReached, setIsFMPReached] = (0, $cozmU.useState)(false);
    const [isFmpInViewport, setIsFmpInViewport] = (0, $cozmU.useState)(false);
    const [isAnswerExpanded, setIsAnswerExpanded] = (0, $cozmU.useState)(initiallyExpanded); // Tracks whether the user has minimized the answer card (via SmartAnswerCardMinimized's
    // "Hide answer" button). When minimized the answer is not visible to the user, so
    // we should not count this time toward FMP dwell metrics.
    const [isAnswerMinimized, setIsAnswerMinimized] = (0, $cozmU.useState)(false); // FMP-based dwell timer for analytics sizing
    if ((0, $iDrrr.fg)('kd_fmp_dwell_observer')) // fg check is stable between renders and won't cause issues with hook calls
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $06f67127312b8dc5$export$6dde22325042712e)({
        isEnabled: isFMPReached,
        // Treat a minimized answer the same as out-of-viewport — the user can't see
        // it so we shouldn't count it toward dwell.
        isInViewport: isFmpInViewport && !isAnswerMinimized,
        tabHasFocus: tabHasFocus,
        thresholdMs: (0, $eySxZ.SAIN_USAGE_DWELL_THRESHOLD),
        onDwellStart: ()=>{
            fireSAINUsageEvent({
                metCriteria: isAnswerExpanded ? (0, $bZMnB.SainAction).FMP_DWELL_START_EXPANDED : (0, $bZMnB.SainAction).FMP_DWELL_START,
                dwellTime: 0,
                commonAttributes: commonAttributes
            });
        },
        onDwellThreshold: (dwellTime)=>{
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).FMP_DWELL_REACHED,
                dwellTime: dwellTime,
                commonAttributes: commonAttributes,
                sourceProduct: sourceProduct
            });
        },
        onDwellEnd: (dwellTime)=>{
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).FMP_RESULT_EXITED,
                dwellTime: dwellTime,
                commonAttributes: commonAttributes,
                sourceProduct: sourceProduct
            });
        }
    });
    const [liked, setLiked] = (0, $cozmU.useState)(undefined);
    const [likesDisabled, setLikesDisabled] = (0, $cozmU.useState)(false);
    const [initialReported, setInitialReported] = (0, $cozmU.useState)(undefined);
    const [nlpSearch, setData] = (0, $cozmU.useState)((0, $hZTED.DEFAULT_EMPTY_NLP_SEARCH_STATE));
    const filtersRef = (0, $cozmU.useRef)(selectedFilters);
    const selectedProductRef = (0, $cozmU.useRef)(selectedProduct);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const resultRef = (0, $cozmU.useRef)(null);
    const initialLoadTs = (0, $cozmU.useRef)(Date.now()).current;
    const loadedTsRef = (0, $cozmU.useRef)();
    const fmpLoadedTsRef = (0, $cozmU.useRef)();
    const dwellTimeRef = (0, $cozmU.useRef)();
    const sainReverAllExperiment = (0, $cXtTj.default).getExperimentValue('sain_revert_all_experiment', 'enable', false);
    const kdSainTabsExperienceRevert = (0, $cXtTj.default).getExperimentValue('kd_sain_tabs_experience_revert', 'enable', false);
    const shouldServeTabsExperiment = sainReverAllExperiment || kdSainTabsExperienceRevert;
    const markLoadedTs = ()=>{
        loadedTsRef.current = Date.now();
        return loadedTsRef.current - initialLoadTs;
    };
    const fmpMarkLoadedTs = ()=>{
        if (fmpLoadedTsRef.current) return fmpLoadedTsRef.current - initialLoadTs;
    };
    const startViewportDwell = ()=>{
        dwellTimeRef.current = Date.now();
    };
    const markViewportDwell = ()=>{
        if (dwellTimeRef.current) return Date.now() - dwellTimeRef.current;
        return 0;
    };
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cFVPs.useAIEventsInstrumentation)();
    const sessionId = (0, $f557ddd0ea926672$export$baca5c7d93c77000)({
        userId: userDetails.id || '',
        cloudId: cloudId,
        source: source
    });
    const activityClient = (0, $k8VpS.useActivityClient)('v3', 'people');
    const isAnswered = !loading && nlpSearch.errorState === null;
    const hasError = !loading && !!nlpSearch.errorState && nlpSearch.errorState !== (0, $htnqN.NLPSearchErrorState).Default;
    const answerString = nlpSearch.nlpResults?.length ? nlpSearch.nlpResults[0].nlpResult : nlpSearch.nlpResult || '';
    const answerFormat = nlpSearch.format;
    const followUps = nlpSearch.nlpFollowUpResults?.followUps;
    const errorStateSuggestedQueries = nlpSearch.nlpSuggestedQueries;
    const sources = nlpSearch.uniqueSources;
    const disclaimer = nlpSearch.disclaimer;
    const answerEditor = nlpSearch.nlpResultEditor;
    const extraAPIAnalyticsAttributes = nlpSearch.extraAPIAnalyticsAttributes;
    const authorityUiMetadata = nlpSearch.authority_ui_metadata;
    const requestId = nlpSearch.extraAPIAnalyticsAttributes?.requestId;
    const answerCardType = (0, $e8f4d0b6d7c43b83$export$694ee0cc469a8709)(isReadingAids, smartAnswersRoute);
    const isHelloValue = (0, $aTjYs.isHello)(cloudId); // Which inline-Lumina element types this answer contains, e.g. ['smart-link', 'smart-link-list'].
    const luminaContentTypesKey = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('kd_sain_enable_inline_lumina') ? (0, $b47b63f9e1c9c8da$export$4e3a85aba66b9a32)(Object.values(luminaContentMap)).join('|') : undefined, [
        luminaContentMap
    ]);
    const luminaContentTypes = (0, $cozmU.useMemo)(()=>luminaContentTypesKey === undefined ? undefined : luminaContentTypesKey ? luminaContentTypesKey.split('|') : [], [
        luminaContentTypesKey
    ]);
    const commonAttributes = (0, $cozmU.useMemo)(()=>({
            cloudId: cloudId,
            orgId: orgId ?? '',
            queryHash: (0, $9oghv.sha256Hash)(query),
            baseQueryHash: (0, $9oghv.sha256Hash)(baseQuery),
            query: query,
            appliedFilters: parsedFilters,
            searchSessionId: searchSessionId,
            source: source,
            answerString: answerString,
            answerLength: answerString.length,
            answerWordCount: answerString.split(/\s+/).length,
            answerFormat: answerFormat,
            answerCardType: answerCardType,
            sources: sources,
            followUps: followUps || [],
            errorStateSuggestedQueries: errorStateSuggestedQueries || [],
            errorState: nlpSearch.errorState,
            errorCode: nlpSearch.errorCode,
            networkErrorReason: nlpSearch.networkErrorReason,
            networkErrorDetails: nlpSearch.networkErrorDetails,
            backendFailureType: nlpSearch.backendFailureType,
            networkErrorDiagnosticType: nlpSearch.networkErrorDiagnosticType,
            networkErrorFailureStage: nlpSearch.networkErrorFailureStage,
            responseContentType: nlpSearch.responseContentType,
            networkErrorTraceId: nlpSearch.networkErrorTraceId,
            streamEventsReceived: nlpSearch.streamEventsReceived,
            networkErrorDuration: nlpSearch.networkErrorDuration,
            extraAttributes: {
                featureGates: {
                    precomputedDefinitionsEnabled: (0, $iDrrr.fg)('kd_enable_precomputed_definitions')
                },
                ...extraAnalyticsAttributes,
                ...extraAPIAnalyticsAttributes
            },
            apiSource: 'assistance-service',
            workspaceId: workspaceId ?? '',
            sessionId: sessionId,
            rovoJourneyId: rovoJourneyId,
            brand: brand,
            sourceProduct: sourceProduct,
            isReadingAids: isReadingAids,
            queryIntent: smartAnswersRoute,
            isHello: isHelloValue,
            ...luminaContentTypes !== undefined && {
                containsLuminaContent: luminaContentTypes.length > 0,
                luminaContentTypes: luminaContentTypes
            },
            luminaContentMap: luminaContentMap
        }), [
        cloudId,
        orgId,
        query,
        baseQuery,
        parsedFilters,
        searchSessionId,
        source,
        answerString,
        answerFormat,
        nlpSearch.errorState,
        nlpSearch.errorCode,
        nlpSearch.networkErrorReason,
        nlpSearch.networkErrorDetails,
        nlpSearch.backendFailureType,
        nlpSearch.networkErrorDiagnosticType,
        nlpSearch.networkErrorFailureStage,
        nlpSearch.responseContentType,
        nlpSearch.networkErrorTraceId,
        nlpSearch.streamEventsReceived,
        nlpSearch.networkErrorDuration,
        extraAnalyticsAttributes,
        extraAPIAnalyticsAttributes,
        workspaceId,
        sessionId,
        rovoJourneyId,
        brand,
        sourceProduct,
        isReadingAids,
        smartAnswersRoute,
        answerCardType,
        followUps,
        sources,
        errorStateSuggestedQueries,
        isHelloValue,
        luminaContentTypes,
        luminaContentMap
    ]);
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const onNavigateWithMouseEvent = (0, $cozmU.useCallback)((event)=>{
        if (!event.ctrlKey && !event.metaKey) onNavigate();
    }, [
        onNavigate
    ]);
    const getAIAnswerFn = (0, $cozmU.useCallback)(()=>{
        switch(smartAnswersRoute){
            case (0, $zzZbq.QueryIntent).PERSON:
                return (_args)=>(0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation') ? (0, $634e333e90210143$export$3b2275a59c992e87)({
                        tenantId: cloudId,
                        personQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    }) : (0, $634e333e90210143$export$b40bb50f32e7d452)({
                        tenantId: cloudId,
                        personQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    });
            case (0, $zzZbq.QueryIntent).TEAM:
                return (_args)=>(0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation') ? (0, $5440ea745c72f677$export$b9b0423f67d54dce)({
                        activityClient: activityClient,
                        orgId: orgId ?? '',
                        siteId: cloudId,
                        teamQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    }) : (0, $5440ea745c72f677$export$1d3fe260188fa7d9)({
                        activityClient: activityClient,
                        orgId: orgId ?? '',
                        siteId: cloudId,
                        teamQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    });
            case (0, $zzZbq.QueryIntent).TOPIC:
                return (_args)=>(0, $f015000a0fe91d29$export$d25837238feb3ab6)({
                        cloudId: cloudId,
                        query: query,
                        workspaceId: workspaceId ?? '',
                        sourceProduct: sourceProduct,
                        traceHeaders: traceHeaders
                    });
            case (0, $zzZbq.QueryIntent).AGENT:
                return ()=>(0, $7af6e4b8739a3031$export$9cab63c7e0de7ad8)({
                        query: query,
                        sourceProduct: sourceProduct ?? '',
                        limit: 7,
                        cloudId: cloudId,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    });
            case (0, $zzZbq.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY:
            case (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD:
                // data fetching is handled by the JiraNlToJqlCard internally,
                // this is to prevent streaming from being called
                setLoading(false);
                return null;
            case (0, $zzZbq.QueryIntent).VISUAL:
                // data fetching is handled by the VisualKnowledgeCard internally,
                // this is to prevent streaming from being called
                setLoading(false);
                return null;
            case (0, $zzZbq.QueryIntent).ORG_CHART:
                return ()=>(0, $634e333e90210143$export$b40bb50f32e7d452)({
                        tenantId: cloudId,
                        personQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    });
            default:
        }
        return getAIAnswer;
    }, [
        getAIAnswer,
        smartAnswersRoute,
        query,
        orgId,
        cloudId,
        activityClient,
        sourceProduct,
        workspaceId,
        traceHeaders
    ]);
    const updateContextCache = (0, $cozmU.useCallback)(({ collapsed: collapsed, liked: liked, reported: reported, recentWorkListExpanded: recentWorkListExpanded, sourcesExpanded: sourcesExpanded, fromFollowUp: fromFollowUp })=>{
        // Do not store session cache if Lumina
        if (isLuminaAnswer && !isReadingAids) return;
        const currentCache = JSON.parse((0, $6JEx2.getSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY)) || '{}');
        (0, $6JEx2.setSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
            query: query,
            additionalContext: additionalQueryContext || '',
            data: nlpSearch,
            collapsed: collapsed === undefined ? currentCache.collapsed : collapsed,
            liked: liked === undefined ? currentCache.liked : liked,
            reported: reported === undefined ? currentCache.reported : reported,
            fromFollowUp: fromFollowUp === undefined ? currentCache.fromFollowUp : fromFollowUp,
            recentWorkListExpanded: recentWorkListExpanded === undefined ? currentCache.recentWorkListExpanded : recentWorkListExpanded,
            sourcesExpanded: sourcesExpanded === undefined ? currentCache.sourcesExpanded : sourcesExpanded,
            ...(0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation') ? {
                extraAPIAnalyticsAttributes: {
                    requestId: requestId
                }
            } : {}
        }));
    }, [
        query,
        additionalQueryContext,
        nlpSearch,
        requestId,
        isReadingAids,
        isLuminaAnswer
    ]);
    const onFMPReached = (0, $cozmU.useCallback)(()=>{
        setIsFMPReached(true);
        fmpLoadedTsRef.current = Date.now();
    }, []);
    const onAnswerExpandedChange = (0, $cozmU.useCallback)((expanded)=>{
        setIsAnswerExpanded(expanded);
    }, []);
    const onAnswerMinimizedChange = (0, $cozmU.useCallback)((minimized)=>{
        setIsAnswerMinimized(minimized);
    }, []); // Mirror the intersection observer behaviour for the minimize/expand action.
    // Minimizing the answer is semantically equivalent to the dialog leaving the
    // viewport (user can no longer see the answer), so fire onAIAnswerDialogHidden
    // and clear any in-progress dwell timers. Re-expanding while the dialog is in
    // viewport is equivalent to the dialog re-entering the viewport, so fire
    // onAIAnswerDialogViewed and restart dwell tracking.
    // Tracks the previous value with a ref so we only react to actual transitions
    // and not on initial mount.
    const previousIsAnswerMinimizedRef = (0, $cozmU.useRef)(isAnswerMinimized); // Mirror of `isAnswerMinimized` in a ref so `handleIntersect` (which is closed over
    // by an IntersectionObserver created once on mount) can read the latest value
    // without us needing to recreate the observer on minimize/expand.
    const isAnswerMinimizedRef = (0, $cozmU.useRef)(isAnswerMinimized);
    (0, $cozmU.useEffect)(()=>{
        isAnswerMinimizedRef.current = isAnswerMinimized;
    }, [
        isAnswerMinimized
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() && !(0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled()) return;
        const previous = previousIsAnswerMinimizedRef.current;
        previousIsAnswerMinimizedRef.current = isAnswerMinimized; // Only fire minimize/expand side-effects after the answer is loaded.
        if (loading || !isAnswered && !hasError) return;
         // User just minimized the answer — fire hidden + clear dwell timers
        if (!previous && isAnswerMinimized) {
            fireAnalyticsEvent((0, $c64593c9127399aa$export$e1c446b3b8b22ff)({
                ...commonAttributes
            }, markViewportDwell()));
            if (dwellTimerRef.current && (0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) {
                clearTimeout(dwellTimerRef.current);
                dwellTimerRef.current = null;
            }
            return;
        } // User just expanded the answer while the dialog is in viewport — fire
        // viewed + restart dwell, mirroring the intersecting branch of handleIntersect.
        if (previous && !isAnswerMinimized && isFmpInViewport) {
            startViewportDwell();
            fireAnalyticsEvent((0, $0f9647babe97feca$export$e9cccbc780a694f3)({
                ...commonAttributes
            }));
            if ((0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) {
                if (smartAnswersRoute !== (0, $zzZbq.QueryIntent).TEAM && smartAnswersRoute !== (0, $zzZbq.QueryIntent).PERSON && smartAnswersRoute !== (0, $zzZbq.QueryIntent).AGENT && !dwellTrackedRef.current) dwellTimerRef.current = setTimeout(()=>{
                    dwellTrackedRef.current = true;
                    fireSAINUsageEvent({
                        metCriteria: (0, $bZMnB.SainAction).DWELL_REACHED,
                        dwellTime: markViewportDwell(),
                        commonAttributes: commonAttributes
                    });
                }, (0, $eySxZ.SAIN_USAGE_DWELL_THRESHOLD));
            }
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAnswerMinimized
    ]);
    (0, $cozmU.useEffect)(()=>{
        onAnswerExpandedStateChange?.(isAnswerExpanded);
    }, [
        isAnswerExpanded,
        onAnswerExpandedStateChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (answerLoadingRef) answerLoadingRef.current = !!loading;
    }, [
        loading,
        answerLoadingRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        (0, $a7513ed93542ee2f$export$a83a35d6598a5fb6).start(); // Reset FMP dwell tracking for new queries
        setIsFMPReached(false);
        setIsFmpInViewport(false);
        setIsAnswerMinimized(false);
        setResearchSteps({});
        if (dwellTimer) {
            clearTimeout(dwellTimer);
            setDwellTimer(null);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query
    ]);
    const handleIntersect = (entries)=>{
        entries.forEach((entry)=>{
            if (!loading && (isAnswered || hasError)) {
                if (entry.isIntersecting) {
                    // Skip the "viewed" tracking branch when the answer is minimized — the user
                    // can't actually see the answer content, so it shouldn't count as viewed
                    // or feed into dwell tracking. The minimize/expand events are handled by a
                    // dedicated effect above so we don't spuriously fire onAIAnswerDialogHidden
                    // from the else-branch in this case.
                    // Read minimize state via ref to get the latest value without recreating the observer.
                    if (isAnswerMinimizedRef.current) return;
                    startViewportDwell();
                    fireAnalyticsEvent((0, $0f9647babe97feca$export$e9cccbc780a694f3)({
                        ...commonAttributes
                    }));
                    if ((0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) {
                        if (smartAnswersRoute !== (0, $zzZbq.QueryIntent).TEAM && smartAnswersRoute !== (0, $zzZbq.QueryIntent).PERSON && smartAnswersRoute !== (0, $zzZbq.QueryIntent).AGENT && !dwellTrackedRef.current) dwellTimerRef.current = setTimeout(()=>{
                            dwellTrackedRef.current = true;
                            fireSAINUsageEvent({
                                metCriteria: (0, $bZMnB.SainAction).DWELL_REACHED,
                                dwellTime: markViewportDwell(),
                                commonAttributes: commonAttributes
                            });
                        }, (0, $eySxZ.SAIN_USAGE_DWELL_THRESHOLD));
                    } else if (smartAnswersRoute !== (0, $zzZbq.QueryIntent).TEAM && smartAnswersRoute !== (0, $zzZbq.QueryIntent).PERSON && !hasError && !dwellTracked) {
                        const usageTimer = setTimeout(()=>{
                            setDwellTracked(true);
                            fireSAINUsageEvent({
                                metCriteria: (0, $bZMnB.SainAction).DWELL_REACHED,
                                dwellTime: markViewportDwell(),
                                commonAttributes: commonAttributes
                            });
                        }, (0, $eySxZ.SAIN_USAGE_DWELL_THRESHOLD));
                        setDwellTimer(usageTimer); // DS team (Ala Qabaja & Nan Ma) wants to fire this event
                        // if user dwells on Definition for over 3 minutes
                        if (isReadingAids && !definitionDwellTimeTrackedRef.current && (0, $iDrrr.fg)('kd_definitions_dwell_fire_result_view')) definitionDwellTimeRef.current = setTimeout(()=>{
                            definitionDwellTimeTrackedRef.current = true;
                            fireSAINUsageEvent({
                                metCriteria: (0, $bZMnB.SainAction).DEFINITION_DWELL_MARKED,
                                dwellTime: markViewportDwell(),
                                commonAttributes: commonAttributes
                            });
                        }, 180000);
                    }
                } else {
                    // onAIAnswerDialogHidden is fired by the minimize/expand effect on line 655 when
                    // the user minimizes the answer, so firing it again on scroll-out would be
                    // a duplicate. The minimize/expand effect is the source of truth for hidden/
                    // viewed events while minimized.
                    // Read minimize state via ref to get the latest value without recreating the observer.
                    if (isAnswerMinimizedRef.current) return;
                    fireAnalyticsEvent((0, $c64593c9127399aa$export$e1c446b3b8b22ff)({
                        ...commonAttributes
                    }, markViewportDwell()));
                    if (dwellTimerRef.current && (0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) {
                        clearTimeout(dwellTimerRef.current);
                        dwellTimerRef.current = null;
                    } // DS team wants to fire this event once user exits viewport
                    if (isReadingAids && !definitionDwellTimeTrackedRef.current && (0, $iDrrr.fg)('kd_definitions_dwell_fire_result_view')) {
                        definitionDwellTimeTrackedRef.current = true; // clear timeout to avoid firing duplicate event at 3 minutes
                        if (definitionDwellTimeRef.current) clearTimeout(definitionDwellTimeRef.current);
                        fireSAINUsageEvent({
                            metCriteria: (0, $bZMnB.SainAction).DEFINITION_DWELL_MARKED,
                            dwellTime: markViewportDwell(),
                            commonAttributes: commonAttributes
                        });
                    }
                }
            } // Fire when the user scrolls the dialog out of the viewport while the
            // answer is still loading (i.e. before it is answered or errored).
            // Guarded so it fires at most once per load.
            if (loading && !entry.isIntersecting && !loadingHiddenTrackedRef.current) {
                loadingHiddenTrackedRef.current = true;
                fireAnalyticsEvent((0, $68497448a8541103$export$835458994fc126e4)({
                    ...commonAttributes
                }));
            }
        });
    };
    (0, $cozmU.useLayoutEffect)(()=>{
        const observer = new IntersectionObserver(handleIntersect, {
            threshold: 0.3
        });
        if (resultRef.current && tabHasFocus) observer.observe(resultRef.current);
        return ()=>{
            observer?.disconnect();
        }; // `isAnswerMinimized` is omitted from deps on purpose — recreating the observer
    // on minimize/expand fires a duplicate viewed/hidden event from the initial
    // intersection callback. `handleIntersect` reads the latest value via
    // `isAnswerMinimizedRef` instead.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        resultRef,
        isAnswered,
        hasError,
        tabHasFocus
    ]); // FMP dwell intersection observer
    (0, $cozmU.useLayoutEffect)(()=>{
        // Use different thresholds based on expanded state:
        // - Collapsed: 1.0 (100% in viewport)
        // - Expanded: 0.3 (30% in viewport)
        const threshold = isAnswerExpanded ? 0.3 : 1.0;
        const fmpObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (isFMPReached) // Always update viewport state when FMP is reached, regardless of tab focus
                // Tab focus is handled separately in the dwell timer hook
                setIsFmpInViewport(entry.isIntersecting);
            });
        }, {
            threshold: threshold
        });
        if (resultRef.current && isFMPReached) fmpObserver.observe(resultRef.current);
        return ()=>{
            fmpObserver?.disconnect();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        resultRef,
        isFMPReached,
        isAnswerExpanded
    ]);
    (0, $cozmU.useEffect)(()=>{
        const cached = JSON.parse((0, $6JEx2.getSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY)) || '{}');
        if (cached?.query === query && cached?.additionalContext === additionalQueryContext) {
            if ((0, $iDrrr.fg)('kd_sain_enable_inline_lumina')) {
                const { processedText: processedText, boundaryContents: boundaryContents } = (0, $f3OgL.extractMarkdownText)(cached.data.nlpResult ?? '', (0, $b2270b423e154e70$export$84f2194b2008422), (0, $b2270b423e154e70$export$192ba1edc601a546), (0, $b2270b423e154e70$export$ea5ceaf3fa709ad4));
                const luminaContentMap = {};
                boundaryContents.forEach((content, index)=>{
                    luminaContentMap[`${0, $b2270b423e154e70$export$b2ac4f39739d467d}${index}`] = content;
                });
                setLuminaContentMap(luminaContentMap);
                setData({
                    ...cached.data,
                    nlpResult: processedText
                });
            } else setData(cached.data);
            if (cached.liked !== undefined) {
                setLiked(cached.liked); // if a like is cached, disable likes
                setLikesDisabled(true);
            }
            if (cached.reported !== undefined) setInitialReported(cached.reported);
            setLoading(false);
        } else {
            (0, $6JEx2.deleteSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY));
            setLoading(true); // Re-arm the loading-hidden analytics guard for this new load.
            loadingHiddenTrackedRef.current = false;
            setLiked(undefined);
            setLikesDisabled(false);
            (0, $b2270b423e154e70$export$6dbb893b575831e8)({
                cloudId: cloudId,
                locale: locale,
                query: (0, $273cb466e56a9a66$export$90c8c71ce0c72494)(query, selectedProduct, smartAnswersRoute),
                additional_context: additionalQueryContext,
                source: source,
                followUpsEnabled: followUpsEnabled && !cached.fromFollowUp,
                getAIAnswer: getAIAnswerFn(),
                setLoading: setLoading,
                partialResponse: partialResponse,
                partialResponseAbortControllerRef: partialResponseAbortControllerRef,
                setPartialResponse: setPartialResponse,
                setData: setData,
                setAnswerStreamed: setAnswerStreamed,
                parsedFilters: parsedFilters,
                selectedProduct: mappedProductFilter,
                isReadingAids: isReadingAids,
                fireAnalyticsEvent: fireAnalyticsEvent,
                setQueryReasoning: setQueryReasoning,
                setResearchSteps: setResearchSteps,
                setDynamicLayoutSubAgentMessages: setDynamicLayoutSubAgentMessages,
                setIsLuminaAnswer: setIsLuminaAnswer,
                setLuminaContentMap: setLuminaContentMap,
                experimentContext: experimentContext,
                queryIntentClassificationData: queryIntentClassificationData,
                referrer: referrer,
                searchSessionId: searchSessionId,
                sourceProduct: sourceProduct,
                queryIntent: smartAnswersRoute
            });
        }
        filtersRef.current = selectedFilters;
        if ((0, $iDrrr.fg)('kd_fix_duplicate_sain_stream_calls')) selectedProductRef.current = selectedProduct;
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query,
        additionalQueryContext
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('kd_hide_sain_for_unsupported_product_filters') && !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(filtersRef.current, selectedFilters) || !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(selectedProductRef.current, selectedProduct)) {
            (0, $6JEx2.deleteSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY));
            setLoading(true); // Re-arm the loading-hidden analytics guard for this new load.
            loadingHiddenTrackedRef.current = false;
            setLiked(undefined);
            setLikesDisabled(false);
            if ((0, $iDrrr.fg)('kd_fix_abort_errors')) {
                setData((0, $hZTED.DEFAULT_EMPTY_NLP_SEARCH_STATE));
                setPartialResponse(undefined);
            }
            (0, $b2270b423e154e70$export$6dbb893b575831e8)({
                cloudId: cloudId,
                locale: locale,
                query: (0, $273cb466e56a9a66$export$90c8c71ce0c72494)(query, selectedProduct, smartAnswersRoute),
                source: source,
                followUpsEnabled: followUpsEnabled,
                getAIAnswer: getAIAnswerFn(),
                setLoading: setLoading,
                partialResponse: partialResponse,
                partialResponseAbortControllerRef: partialResponseAbortControllerRef,
                setPartialResponse: setPartialResponse,
                setData: setData,
                setAnswerStreamed: setAnswerStreamed,
                parsedFilters: parsedFilters,
                selectedProduct: mappedProductFilter,
                isReadingAids: isReadingAids,
                fireAnalyticsEvent: fireAnalyticsEvent,
                setQueryReasoning: setQueryReasoning,
                setResearchSteps: setResearchSteps,
                setDynamicLayoutSubAgentMessages: setDynamicLayoutSubAgentMessages,
                setIsLuminaAnswer: setIsLuminaAnswer,
                setLuminaContentMap: setLuminaContentMap,
                experimentContext: experimentContext,
                queryIntentClassificationData: queryIntentClassificationData,
                referrer: referrer,
                searchSessionId: searchSessionId,
                sourceProduct: sourceProduct,
                queryIntent: smartAnswersRoute
            });
        }
        filtersRef.current = selectedFilters;
        selectedProductRef.current = selectedProduct; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedFilters,
        selectedProduct
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isAnswered) {
            // if a person or team query returns no data don't log result shown
            const numAddtlWhoMatches = smartAnswersRoute === (0, $zzZbq.QueryIntent).PERSON ? (0, $a52d76eb98115dba$export$e25821f3420be6ad)({
                answerString: answerString,
                smartAnswersRoute: smartAnswersRoute
            }) : 0;
            if ((smartAnswersRoute === (0, $zzZbq.QueryIntent).PERSON || smartAnswersRoute === (0, $zzZbq.QueryIntent).TEAM || smartAnswersRoute === (0, $zzZbq.QueryIntent).AGENT) && (0, $a52d76eb98115dba$export$e25821f3420be6ad)({
                answerString: answerString,
                smartAnswersRoute: smartAnswersRoute
            }) < 1) {
                markLoadedTs();
                callbacks?.onAIAnswerAnalyticsFired?.();
                return;
            }
            fireAnalyticsEvent((0, $h0U7J.onAIAnswerResultShown)({
                ...commonAttributes,
                isStreamed: answerStreamed,
                loadTime: markLoadedTs(),
                fmpLoadTime: fmpMarkLoadedTs(),
                experimentLayers: experimentContext?.experimentLayers,
                ...isBlueLinkAnalyticsEnabled && {
                    blueLinkCount: (0, $63458847df53b6c8$export$9b73daf8fd4da40f)(answerString)
                },
                ...(0, $iDrrr.fg)('rovo_authoritative_answer_attribution') && {
                    authorityUiMetadata: authorityUiMetadata
                },
                extraAttributes: {
                    ...commonAttributes.extraAttributes,
                    multipleUserResultsShown: numAddtlWhoMatches > 0,
                    numAddtlWhoMatches: numAddtlWhoMatches,
                    isCuratedDefinition: !!answerEditor,
                    isPrecomputedDefinition: nlpSearch.customDefinitionType === (0, $9u8Y2.NLPSearchCustomDefinitionType).PRECOMPUTED
                }
            }));
            (0, $7DMz5.SAINFeatureControl).triggerNonPrimaryClickTrackingExposure();
            if (numAddtlWhoMatches > 0) fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
            callbacks?.onAIAnswerAnalyticsFired?.();
        } else if (hasError) {
            fireAnalyticsEvent((0, $189f541bd063b636$export$bd496fce1657ba31)({
                ...commonAttributes,
                isStreamed: answerStreamed,
                loadTime: markLoadedTs(),
                fmpLoadTime: fmpMarkLoadedTs()
            }));
            callbacks?.onAIAnswerAnalyticsFired?.();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        isAnswered
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        trackAIInteractionInit();
        fireAnalyticsEvent((0, $3010e3f8742304a1$export$17e25c724e0ebb55)(commonAttributes));
        if (!isReadingAids && query && smartAnswersRoute) fireAnalyticsEvent((0, $a92ce6609ffd286a$export$67b8bcd639e29c44)(commonAttributes, smartAnswersRoute));
        return ()=>{
            fireAnalyticsEvent((0, $c64593c9127399aa$export$e1c446b3b8b22ff)({
                ...commonAttributes
            }, markViewportDwell()));
            fireAnalyticsEvent((0, $4eab0bf5f1608099$export$c075b0a4ec670c87)({
                ...commonAttributes,
                isReadingAids: isReadingAids,
                sourceProduct: sourceProduct,
                dwellTime: loadedTsRef.current ? Date.now() - loadedTsRef.current : 0,
                loadTime: markLoadedTs(),
                fmpLoadTime: fmpMarkLoadedTs()
            }));
            trackAIInteractionDismiss();
            if (!loadedTsRef.current) fireAnalyticsEvent((0, $597405ac0b3b2570$export$cae33476d80498a)({
                ...commonAttributes
            }));
             // DS team wants to fire this event once user closes Definition
            if (isReadingAids && !definitionDwellTimeTrackedRef.current && (0, $iDrrr.fg)('kd_definitions_dwell_fire_result_view')) {
                definitionDwellTimeTrackedRef.current = true; // clear timeout to avoid firing duplicate event at 3 minutes
                if (definitionDwellTimeRef.current) clearTimeout(definitionDwellTimeRef.current);
                fireSAINUsageEvent({
                    metCriteria: (0, $bZMnB.SainAction).DEFINITION_DWELL_MARKED,
                    dwellTime: markViewportDwell(),
                    commonAttributes: commonAttributes
                });
            }
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const handleWindowBlurOrClose = ()=>{
            if (tabHasFocus && !loading && (isAnswered || hasError)) {
                fireAnalyticsEvent((0, $c64593c9127399aa$export$e1c446b3b8b22ff)({
                    ...commonAttributes
                }, markViewportDwell()));
                if (dwellTimerRef.current && (0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) {
                    clearTimeout(dwellTimerRef.current);
                    dwellTimerRef.current = null;
                } // DS team wants to fire this event once user leaves tab with Definition still open
                if (isReadingAids && !definitionDwellTimeTrackedRef.current && (0, $iDrrr.fg)('kd_definitions_dwell_fire_result_view')) {
                    definitionDwellTimeTrackedRef.current = true; // clear timeout to avoid firing duplicate event at 3 minutes
                    if (definitionDwellTimeRef.current) clearTimeout(definitionDwellTimeRef.current);
                    fireSAINUsageEvent({
                        metCriteria: (0, $bZMnB.SainAction).DEFINITION_DWELL_MARKED,
                        dwellTime: markViewportDwell(),
                        commonAttributes: commonAttributes
                    });
                }
            }
            setTabHasFocus(false);
        };
        const handleWindowFocus = ()=>{
            setTabHasFocus(true);
            if (!dwellTrackedRef.current && !dwellTimerRef.current && (0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) dwellTimerRef.current = setTimeout(()=>{
                dwellTrackedRef.current = true;
                fireSAINUsageEvent({
                    metCriteria: (0, $bZMnB.SainAction).DWELL_REACHED,
                    dwellTime: markViewportDwell(),
                    commonAttributes: commonAttributes
                });
            }, (0, $eySxZ.SAIN_USAGE_DWELL_THRESHOLD));
        };
        const removeBlurListener = (0, $cbY7C.bind)(window, {
            type: 'blur',
            listener: handleWindowBlurOrClose
        });
        const removeFocusListener = (0, $cbY7C.bind)(window, {
            type: 'focus',
            listener: handleWindowFocus
        });
        const removeCloseListener = (0, $cbY7C.bind)(window, {
            type: 'beforeunload',
            listener: handleWindowBlurOrClose
        });
        return ()=>{
            removeBlurListener();
            removeFocusListener();
            removeCloseListener();
            if ((0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) {
                if (dwellTimerRef.current) {
                    clearTimeout(dwellTimerRef.current);
                    dwellTimerRef.current = null;
                }
            } else if (dwellTimer) clearTimeout(dwellTimer);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tabHasFocus,
        loading
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (onLoad && !loading && (isAnswered || hasError)) onLoad();
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        isAnswered,
        hasError
    ]);
    const AIDialogWrapper = wrapper ? wrapper : (0, $aMSTz.SearchDialog);
    const AILoadingWrapper = loadingWrapper ? loadingWrapper : (0, $28ffaa5aebbd61cc$export$476294a9cde8f045);
    const renderDefinition = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7220d3f091bca8d4$export$d1b852cfff73cbe8), null); // SAIN in FPS
    const renderSearchPageSmartAnswer = ()=>{
        if ((smartAnswersRoute === (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY || smartAnswersRoute === (0, $zzZbq.QueryIntent).KEYWORD_OR_ACRONYM || smartAnswersRoute === (0, $zzZbq.QueryIntent).NAVIGATIONAL && (0, $7DMz5.SAINFeatureControl).isNavigationalIntentEnabled()) && shouldServeTabsExperiment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AIDialogWrapper, null, (0, $7DMz5.SAINFeatureControl).canRenderLumina() && isLuminaAnswer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12ca716b9376ab26$export$b547d87531f467be), {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange,
            queryIntent: smartAnswersRoute
        }) : (0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c6a21b3a2fe9d946$export$2b53936d5706be63), {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange,
            onAnswerMinimizedChange: onAnswerMinimizedChange,
            queryIntent: smartAnswersRoute,
            floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fd49c31ba41c686c$export$3698d894d0a161e5), {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange,
            queryIntent: smartAnswersRoute,
            onAnswerMinimizedChange: onAnswerMinimizedChange,
            floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef
        }));
        else if ((0, $iDrrr.fg)('kd_sain_enable_expand_when_streaming')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AIDialogWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $005c7db905c9053b$export$827de04ba3667da0), {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange
        }));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AIDialogWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $243c0d4568578f49$export$7d8a07a50ae14953), {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange
        }));
    };
    const renderSearchPageKnowledgeCard = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AIDialogWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0d6d5a5257f57329$export$ab2444a256fc8a9b), {
            onFMPReached: onFMPReached
        })); // Quick search and advanced search
    const renderDefaultSmartAnswer = ()=>{
        return (0, $iDrrr.fg)('kd_sain_enable_expand_when_streaming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4405991c63379ccf$export$cf72ef8498afcbc2), {
            LoadingWrapper: AILoadingWrapper,
            DialogWrapper: AIDialogWrapper,
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d365ffe2a496da37$export$b054d5cce3d1302d), {
            LoadingWrapper: AILoadingWrapper,
            DialogWrapper: AIDialogWrapper,
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange
        });
    };
    const renderExperience = ()=>{
        switch(smartAnswersRoute){
            case (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY:
            case (0, $zzZbq.QueryIntent).KEYWORD_OR_ACRONYM:
            case (0, $zzZbq.QueryIntent).DATE:
            case (0, $zzZbq.QueryIntent).LOCATION:
                return renderSearchPageSmartAnswer();
            case (0, $zzZbq.QueryIntent).NAVIGATIONAL:
                return (0, $7DMz5.SAINFeatureControl).isNavigationalIntentEnabled() ? renderSearchPageSmartAnswer() : null;
            case (0, $zzZbq.QueryIntent).PERSON:
            case (0, $zzZbq.QueryIntent).TEAM:
            case (0, $zzZbq.QueryIntent).TOPIC:
            case (0, $zzZbq.QueryIntent).AGENT:
            case (0, $zzZbq.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY:
            case (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD:
            case (0, $zzZbq.QueryIntent).ORG_CHART:
            case (0, $zzZbq.QueryIntent).VISUAL:
                return renderSearchPageKnowledgeCard();
            default:
                return isReadingAids ? renderDefinition() : renderDefaultSmartAnswer();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3hVWe.AIAnswerContext).Provider, {
        value: {
            loading: loading,
            partialResponse: partialResponse,
            isAnswered: isAnswered,
            hasError: hasError,
            advancedSearchUrl: advancedSearchUrl,
            userDetails: userDetails,
            disclaimer: disclaimer,
            onNavigate: onNavigateWithMouseEvent,
            onClose: onClose,
            updateContextCache: updateContextCache,
            fireAnalyticsEvent: fireAnalyticsEvent,
            setQuery: setQuery,
            setData: setData,
            commonAttributes: commonAttributes,
            liked: liked,
            setLiked: setLiked,
            likesDisabled: likesDisabled,
            setLikesDisabled: setLikesDisabled,
            initialReported: initialReported,
            isReadingAids: isReadingAids,
            dynamicLayoutSubAgentMessages: dynamicLayoutSubAgentMessages,
            setDynamicLayoutSubAgentMessages: setDynamicLayoutSubAgentMessages,
            readingAidsOptions: readingAidsOptions,
            cardProviderProps: cardProviderProps,
            baseQuery: baseQuery,
            cardTemplate: cardTemplate,
            smartAnswersRoute: smartAnswersRoute,
            queryIntentClassificationData: queryIntentClassificationData,
            queryIntentDetectionMetadata: queryIntentDetectionMetadata,
            queryIntentDetectionTraceId: queryIntentDetectionTraceId,
            brand: brand,
            answerEditor: answerEditor,
            closeParentDialog: closeParentDialog,
            additionalQueryContext: additionalQueryContext,
            callbacks: callbacks,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            definitionToggleEnabled: definitionToggleEnabled,
            sourceProduct: sourceProduct,
            showChatFollowUps: showChatFollowUps,
            queryReasoning: queryReasoning,
            researchSteps: researchSteps,
            showGenericFooter: showGenericFooter ?? false,
            initiallyExpanded: initiallyExpanded ?? false,
            traceHeaders: traceHeaders,
            luminaContentMap: luminaContentMap,
            authorityUiMetadata: authorityUiMetadata
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $86daeed37675c499$var$styles.root,
        ref: resultRef
    }, renderExperience()), !loading && (isAnswered || hasError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a393edda7edb3fe8$export$6220c1b7224eb2a2), null));
};
const $86daeed37675c499$export$effb3597bac74419 = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { definitionExperienceName: definitionExperienceName, isReadingAids: isReadingAids, source: source, sourceProduct: sourceProduct, sourceSubProduct: sourceSubProduct, smartAnswersRoute: smartAnswersRoute, query: query, userGeneratedAI: userGeneratedAI } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog"
    }, (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "hasSAINComponent",
        value: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "sainExperienceName",
        value: (0, $b8dde4ad487d9f98$export$38439c13a4683ecf)(smartAnswersRoute)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            hasSAINComponent: true,
            sainExperienceName: (0, $b8dde4ad487d9f98$export$38439c13a4683ecf)(smartAnswersRoute)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14367db50208fb8a$export$e926676385687eaf), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fNTq8.AIEventsInstrumentationProvider), {
        config: {
            product: sourceProduct ?? 'unknown',
            subproduct: sourceSubProduct ?? 'unknown',
            aiFeatureName: isReadingAids ? 'aiDefinitions' : 'smartAnswers',
            aiExperienceName: isReadingAids ? definitionExperienceName : (0, $b8dde4ad487d9f98$export$38439c13a4683ecf)(smartAnswersRoute),
            proactiveGeneratedAI: userGeneratedAI ? 0 : 1,
            userGeneratedAI: userGeneratedAI ? 1 : 0,
            isAIFeature: 1,
            source: source,
            channel: (0, $zzZbq.DEFAULT_GAS_CHANNEL)
        }
    }, (0, $iDrrr.fg)('kd_enable_smart_answer_key') || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86daeed37675c499$var$SearchAIDialogComponent, {
        ...props,
        key: query
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86daeed37675c499$var$SearchAIDialogComponent, props))));
});
module.exports["SearchAIDialog"] = $86daeed37675c499$export$effb3597bac74419;

});

parcelRegister("5AzUy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $8BQV6 = parcelRequire("8BQV6");


var $E1QOf = parcelRequire("E1QOf");


var $a33Aa = parcelRequire("a33Aa");


var $7SkLu = parcelRequire("7SkLu");

const $7ce401f883a6d6c9$var$UFOCustomCohortData = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UFOCustomCohortData(t0) {
    const { dataKey: dataKey, value: value } = t0;
    const interactionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    let t1;
    bb0: {
        if (!interactionContext) {
            t1 = undefined;
            break bb0;
        }
        const interactionId = (0, $E1QOf.getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) {
            t1 = undefined;
            break bb0;
        }
        (0, $a33Aa.addCohortingCustomData)(currentInteractionId, dataKey, value);
        t1 = undefined;
    }
    return null;
} : function UFOCustomCohortData({ dataKey: dataKey, value: value }) {
    const interactionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    (0, $cozmU.useMemo)(()=>{
        if (!interactionContext) return;
        const interactionId = (0, $E1QOf.getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        (0, $a33Aa.addCohortingCustomData)(currentInteractionId, dataKey, value);
    }, [
        dataKey,
        value,
        interactionContext
    ]);
    return null;
};
var /**
 * @deprecated Use `import { addUFOCustomCohortData } from '@atlaskit/react-ufo/add-ufo-custom-cohort-data'` instead.
 */ $7ce401f883a6d6c9$export$2e2bcd8739ae039 = $7ce401f883a6d6c9$var$UFOCustomCohortData;
module.exports["default"] = $7ce401f883a6d6c9$export$2e2bcd8739ae039;

});

parcelRegister("bZMnB", function(module, exports) {
var $55ceb08e10dcc2d0$export$c90526da16c2eaaa = /*#__PURE__*/ function(SainAction) {
    SainAction["SOURCE_CLICKED"] = "sourceLinkClicked";
    SainAction["POSITIVE_FEEDBACK_PROVIDED"] = "positiveFeedbackProvided";
    SainAction["NEGATIVE_FEEDBACK_PROVIDED"] = "negativeFeedbackProvided";
    SainAction["DWELL_REACHED"] = "dwellTimeReached";
    SainAction["COPY_CLICKED"] = "copyButtonClicked";
    SainAction["FOLLOWUP_CLICKED"] = "followupLinkClicked";
    SainAction["ERROR_STATE_SUGGESTED_QUERY_CLICKED"] = "errorStateSuggestedQueryClicked";
    SainAction["OPEN_CHAT_CLICKED"] = "openChatButtonClicked";
    SainAction["EXPAND_CLICKED"] = "expandButtonClicked";
    SainAction["READ_MORE_BUTTON_CLICKED"] = "readMoreButtonClicked";
    SainAction["TOPIC_CLICKED"] = "topicClicked";
    SainAction["RECENT_WORK_CLICKED"] = "recentWorkClicked";
    SainAction["COLLABORATOR_CLICKED"] = "collaboratorClicked";
    SainAction["VIEW_PROFILE_CLICKED"] = "viewProfileClicked";
    SainAction["TEAM_MEMBER_CLICKED"] = "teamMemberClicked";
    SainAction["TEAM_LIST_CLICKED"] = "teamListClicked";
    SainAction["TEAM_LIST_ITEM_CLICKED"] = "teamListItemClicked";
    SainAction["VIEW_TEAM_PAGE_CLICKED"] = "viewTeamPageClicked";
    SainAction["REPORTING_LINES_CLICKED"] = "reportingLinesClicked";
    SainAction["PERSON_SELECTED"] = "cardClicked";
    SainAction["BOOKMARK_CLICKED"] = "bookmarkClicked";
    SainAction["CHAT_CLICKED"] = "chatClicked";
    SainAction["JIRA_ISSUE_CLICKED"] = "jiraIssueCardClicked";
    SainAction["VIEW_ALL_SOURCES"] = "viewAllSourcesClicked";
    SainAction["JIRA_NL_TO_JQL_CLICKED"] = "jiraNlToJqlCardClicked";
    SainAction["JIRA_NL_TO_JQL_VIEW_ALL"] = "viewAllButtonClicked";
    SainAction["JIRA_NL_TO_JQL_WORK_ITEM_CLICKED"] = "workItemClicked";
    SainAction["SHOW_ON_GOOGLE_MAPS_CLICKED"] = "showOnGoogleMapsClicked";
    SainAction["TOPIC_KNOWLEDGE_CARD_CLICKED"] = "topicKnowledgeCardClicked";
    SainAction["NAVIGATIONAL_SEARCH_RESULT_CARD"] = "navigationalSearchResultCardClicked";
    SainAction["FMP_DWELL_START"] = "fmpDwellStart";
    SainAction["FMP_DWELL_START_EXPANDED"] = "fmpDwellStartExpanded";
    SainAction["FMP_DWELL_REACHED"] = "fmpDwellReached";
    SainAction["FMP_RESULT_EXITED"] = "fmpDwellExited";
    SainAction["AI_MODE_FOLLOWUP_CLICKED"] = "aiModeFollowupLinkClicked";
    SainAction["SHOW_MORE_TOPICS_CLICKED"] = "showMoreTopicsClicked";
    SainAction["DEFINITION_DWELL_MARKED"] = "definitionDwellMarked";
    SainAction["BLUE_LINK_CLICKED"] = "blueLinkClicked";
    SainAction["THIRD_PARTY_MESSAGE_CLICKED"] = "thirdPartyMessageClicked";
    SainAction["HIERARCHY_NODE_CLICKED"] = "hierarchyNodeClicked";
    SainAction["PROFILE_TAB_CLICKED"] = "profileTabClicked";
    SainAction["PROFILE_SECTION_CLICKED"] = "profileSectionClicked";
    return SainAction;
}({});
module.exports["SainAction"] = $55ceb08e10dcc2d0$export$c90526da16c2eaaa;

});

parcelRegister("eySxZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $cFVPs = parcelRequire("cFVPs");


var $4Tg3t = parcelRequire("4Tg3t");

const $34d7be492d39e63c$var$sainUsageEventStore = new Map();
const $34d7be492d39e63c$var$MAX_EVENTS = 10;
// React listeners for useSyncExternalStore
const $34d7be492d39e63c$var$listeners = new Set();
function $34d7be492d39e63c$var$emitChange() {
    $34d7be492d39e63c$var$listeners.forEach((listener)=>listener());
}
function $34d7be492d39e63c$export$ec068583843480e7(listener) {
    $34d7be492d39e63c$var$listeners.add(listener);
    return ()=>$34d7be492d39e63c$var$listeners.delete(listener);
}
function $34d7be492d39e63c$export$ab60d92959c37070() {
    return $34d7be492d39e63c$var$sainUsageEventStore;
}
function $34d7be492d39e63c$export$66247cb47ecd9c1b(requestId) {
    if (!$34d7be492d39e63c$var$sainUsageEventStore.has(requestId)) {
        $34d7be492d39e63c$var$sainUsageEventStore.set(requestId, true);
        if ($34d7be492d39e63c$var$sainUsageEventStore.size > $34d7be492d39e63c$var$MAX_EVENTS) {
            const oldestKey = $34d7be492d39e63c$var$sainUsageEventStore.keys().next().value;
            if (oldestKey) $34d7be492d39e63c$var$sainUsageEventStore.delete(oldestKey);
        }
        $34d7be492d39e63c$var$emitChange();
    }
}



var $bZMnB = parcelRequire("bZMnB");

const $e5a6739eacc8a9a3$export$a0cb7cf9977bca78 = 3000;
const $e5a6739eacc8a9a3$export$bf85f2c6a4e29d4e = ()=>{
    const { trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cFVPs.useAIEventsInstrumentation)();
    // eslint-disable-next-line @atlaskit/platform/ensure-use-sync-external-store-server-snapshot
    (0, $cozmU.useSyncExternalStore)((0, $34d7be492d39e63c$export$ec068583843480e7), (0, $34d7be492d39e63c$export$ab60d92959c37070));
    const fireSAINUsageEvent = (0, $cozmU.useCallback)(({ metCriteria: metCriteria, dwellTime: dwellTime, commonAttributes: commonAttributes, sourceProduct: sourceProduct, source: source })=>{
        const sanitizedCommonAttributes = commonAttributes ? (0, $4Tg3t.filterCommonAttributes)(commonAttributes) : {};
        // Handle FMP dwell cases - fire initial event with doesNotMeetMAUCriteria = true
        if (metCriteria === (0, $bZMnB.SainAction).FMP_DWELL_START || metCriteria === (0, $bZMnB.SainAction).FMP_DWELL_START_EXPANDED) {
            trackAIResultView({
                doesNotMeetMAUCriteria: true,
                attributes: {
                    mauEligibilityCriteria: metCriteria,
                    met_fmp_criteria: false,
                    sourceProduct: sourceProduct,
                    ...sanitizedCommonAttributes
                }
            });
            return;
        }
        if (metCriteria === (0, $bZMnB.SainAction).FMP_DWELL_REACHED) {
            // If dwell time reaches threshold, fire second event (could eventually count as usage criteria)
            trackAIResultView({
                doesNotMeetMAUCriteria: true,
                attributes: {
                    dwellTime: dwellTime,
                    mauEligibilityCriteria: metCriteria,
                    met_fmp_criteria: true,
                    sourceProduct: sourceProduct,
                    ...sanitizedCommonAttributes
                }
            });
            return;
        }
        if (metCriteria === (0, $bZMnB.SainAction).DEFINITION_DWELL_MARKED) {
            // If dwell time reaches threshold, fire second event (could eventually count as usage criteria)
            trackAIResultView({
                doesNotMeetMAUCriteria: true,
                attributes: {
                    dwellTime: dwellTime,
                    sourceProduct: sourceProduct,
                    aiDwellTimeMilliSeconds: dwellTime,
                    ...sanitizedCommonAttributes
                }
            });
            return;
        }
        if (metCriteria === (0, $bZMnB.SainAction).FMP_RESULT_EXITED) {
            trackAIResultView({
                doesNotMeetMAUCriteria: true,
                attributes: {
                    action: metCriteria,
                    dwellTime: dwellTime,
                    sourceProduct: sourceProduct,
                    trackingMethod: 'fmp',
                    ...sanitizedCommonAttributes
                }
            });
            return;
        }
        if (metCriteria) {
            // If usage criteria are provided, emit a viewed event with doesNotMeetMAUCriteria set to false
            // only once per SAIN request
            const requestId = commonAttributes?.extraAttributes?.requestId;
            const doesNotMeetMAUCriteria = (0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation') ? requestId ? (0, $34d7be492d39e63c$export$ab60d92959c37070)().has(requestId) : true // new behavior: need a requestId to meet MAU criteria to ensure only one MAU-met event is fired
             : false; // old behavior: always met MAU criteria
            trackAIResultView({
                doesNotMeetMAUCriteria: doesNotMeetMAUCriteria,
                attributes: {
                    dwellTime: dwellTime || 0,
                    mauEligibilityCriteria: metCriteria,
                    sourceProduct: sourceProduct,
                    ...sanitizedCommonAttributes
                }
            });
            if (!doesNotMeetMAUCriteria) (0, $34d7be492d39e63c$export$66247cb47ecd9c1b)(requestId);
            // In addition, emit an action/feedback event for the action that was met
            // (https://hello.atlassian.net/wiki/x/Vxb5DAE)
            switch(metCriteria){
                case (0, $bZMnB.SainAction).SOURCE_CLICKED:
                    {
                        // Override the `connectorInfo` attribute so it only reflects the single clicked
                        // source rather than every source in the answer. `extractConnectorInfo` handles
                        // the `kd_sain_connector_info_analytics` gate internally (returning `undefined`
                        // when disabled), so when the gate is off we fall back to the existing behavior
                        // of not including `connectorInfo` for this action.
                        const clickedConnectorInfo = source ? (0, $4Tg3t.extractConnectorInfo)([
                            source
                        ], commonAttributes?.isReadingAids) : undefined;
                        const includeSourceProductClicked = source?.product != null && (commonAttributes?.isReadingAids ? (0, $iDrrr.fg)('kd_definitions_source_product_clicked') : (0, $iDrrr.fg)('kd_sain_source_product_clicked'));
                        trackAIResultAction(metCriteria, {
                            attributes: {
                                dwellTime: dwellTime,
                                sourceProduct: sourceProduct,
                                ...sanitizedCommonAttributes,
                                ...clickedConnectorInfo !== undefined && {
                                    connectorInfo: clickedConnectorInfo
                                },
                                // Each surface uses its dedicated clicked-source product gate.
                                ...includeSourceProductClicked && {
                                    sourceProductClicked: source.product
                                }
                            }
                        });
                        break;
                    }
                case (0, $bZMnB.SainAction).COPY_CLICKED:
                case (0, $bZMnB.SainAction).FOLLOWUP_CLICKED:
                case (0, $bZMnB.SainAction).TOPIC_CLICKED:
                case (0, $bZMnB.SainAction).RECENT_WORK_CLICKED:
                case (0, $bZMnB.SainAction).COLLABORATOR_CLICKED:
                case (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED:
                case (0, $bZMnB.SainAction).TEAM_MEMBER_CLICKED:
                case (0, $bZMnB.SainAction).VIEW_TEAM_PAGE_CLICKED:
                case (0, $bZMnB.SainAction).OPEN_CHAT_CLICKED:
                case (0, $bZMnB.SainAction).JIRA_NL_TO_JQL_VIEW_ALL:
                case (0, $bZMnB.SainAction).JIRA_NL_TO_JQL_WORK_ITEM_CLICKED:
                case (0, $bZMnB.SainAction).VIEW_ALL_SOURCES:
                case (0, $bZMnB.SainAction).BLUE_LINK_CLICKED:
                    trackAIResultAction(metCriteria, {
                        attributes: {
                            dwellTime: dwellTime,
                            sourceProduct: sourceProduct,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                case (0, $bZMnB.SainAction).POSITIVE_FEEDBACK_PROVIDED:
                    trackAIFeedbackSubmit('up', {
                        attributes: {
                            dwellTime: dwellTime,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                case (0, $bZMnB.SainAction).NEGATIVE_FEEDBACK_PROVIDED:
                    trackAIFeedbackSubmit('down', {
                        attributes: {
                            dwellTime: dwellTime,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                case (0, $bZMnB.SainAction).AI_MODE_FOLLOWUP_CLICKED:
                    trackAIResultAction(metCriteria, {
                        attributes: {
                            dwellTime: dwellTime,
                            sourceProduct: sourceProduct,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                default:
                    break;
            }
        } else // If no usage criteria are provided, emit a viewed event with doesNotMeetMAUCriteria set to true
        trackAIResultView({
            doesNotMeetMAUCriteria: true,
            attributes: {
                dwellTime: dwellTime || 0,
                ...sanitizedCommonAttributes
            }
        });
    }, [
        trackAIResultView,
        trackAIResultAction,
        trackAIFeedbackSubmit
    ]);
    return {
        fireSAINUsageEvent: fireSAINUsageEvent
    };
};
module.exports["SAIN_USAGE_DWELL_THRESHOLD"] = $e5a6739eacc8a9a3$export$a0cb7cf9977bca78;
module.exports["useSAINUsageCriteriaMet"] = $e5a6739eacc8a9a3$export$bf85f2c6a4e29d4e;

});

parcelRegister("aTjYs", function(module, exports) {
const $5533ced57b27ed23$export$8e3fc93123f96c19 = (cloudId)=>{
    return cloudId === 'a436116f-02ce-4520-8fbb-7301462a1674';
};
module.exports["isHello"] = $5533ced57b27ed23$export$8e3fc93123f96c19;

});

parcelRegister("1AuMq", function(module, exports) {
function $5a1d8841e113bde7$export$10e7203252b63b0e(ari) {
    return ari.split('/').pop() || '';
}
module.exports["trimARI"] = $5a1d8841e113bde7$export$10e7203252b63b0e;

});

parcelRegister("b3ffN", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $9ivsj = parcelRequire("9ivsj");


var $IQ4Dz = parcelRequire("IQ4Dz");

var $5420b38fb3279371$var$DarkThemeStops = /*#__PURE__*/ function(DarkThemeStops) {
    DarkThemeStops["BLUE800"] = "#0055CC";
    DarkThemeStops["TEAL500"] = "#37B4C3";
    DarkThemeStops["YELLOW500"] = "#CF9F02";
    return DarkThemeStops;
}($5420b38fb3279371$var$DarkThemeStops || {});
var $5420b38fb3279371$var$LightThemeStops = /*#__PURE__*/ function(LightThemeStops) {
    LightThemeStops["BLUE600"] = "#1D7AFC";
    LightThemeStops["TEAL300"] = "#8BDBE5";
    LightThemeStops["YELLOW200"] = "#F8E6A0";
    return LightThemeStops;
}($5420b38fb3279371$var$LightThemeStops || {});
var $5420b38fb3279371$var$UpdatedDarkThemeStops = /*#__PURE__*/ function(UpdatedDarkThemeStops) {
    UpdatedDarkThemeStops["ORANGE"] = "#FCA700";
    UpdatedDarkThemeStops["GREEN"] = "#82B536";
    UpdatedDarkThemeStops["BLUE"] = "#357DE8";
    UpdatedDarkThemeStops["PURPLE"] = "#BF63F3";
    return UpdatedDarkThemeStops;
}($5420b38fb3279371$var$UpdatedDarkThemeStops || {});
var $5420b38fb3279371$var$UpdatedLightThemeStops = /*#__PURE__*/ function(UpdatedLightThemeStops) {
    UpdatedLightThemeStops["ORANGE"] = "#FCA700";
    UpdatedLightThemeStops["GREEN"] = "#6A9A23";
    UpdatedLightThemeStops["BLUE"] = "#1868DB";
    UpdatedLightThemeStops["PURPLE"] = "#AF59E0";
    return UpdatedLightThemeStops;
}($5420b38fb3279371$var$UpdatedLightThemeStops || {});
const $5420b38fb3279371$var$PRE_PULSE_ANIMATION_DURATION = 200;
const $5420b38fb3279371$var$TOTAL_PULSE_ANIMATION_DURATION = 800; // Helper function to convert hex color to rgba with alpha
const $5420b38fb3279371$var$hexToRgba = (hex, alpha)=>{
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}; // This injects a CSS property into the document for the --gradient-angle variable.
// This is needed so the browser understands how to animate the gradient-angle as an angle
// value. This is done this way because compiled doesn't support CSS variables at this time.
let $5420b38fb3279371$var$propertyInjected = false;
const $5420b38fb3279371$var$useGradientAngleProperty = ()=>{
    (0, $cozmU.useEffect)(()=>{
        if ($5420b38fb3279371$var$propertyInjected) return;
        $5420b38fb3279371$var$propertyInjected = true;
        try {
            const style = document.createElement('style');
            style.innerHTML = `
      			@property --gradient-angle {
        			syntax: '<angle>';
        			initial-value: 0deg;
        			inherits: false;
      			}
    		`;
            document.head.appendChild(style);
        } catch (e) {}
    }, []);
};
// Keyframes for rotating the gradient angle
// ts-ignore because jira build is failing, but this is legit
const $5420b38fb3279371$var$rotate = null; // Rainbow border styles
// Note: the actual gradient background varies by light/dark theme - this is added down below
const $5420b38fb3279371$var$borderCss = null; // Inner content box
const $5420b38fb3279371$var$innerBoxCss = null;
const $5420b38fb3279371$var$lightBackgroundGradientCss = null;
const $5420b38fb3279371$var$darkBackgroundGradientCss = null;
const $5420b38fb3279371$var$backgroundGlowContainerCss = null;
const $5420b38fb3279371$var$backgroundBlurCss = null;
const $5420b38fb3279371$var$lightBackgroundDefaultGradientCss = null; // Light theme blur with alpha transparency for loading states
const $5420b38fb3279371$var$lightBackgroundGeneratingGradientCss = null;
const $5420b38fb3279371$var$lightBackgroundTransparentGradientCss = null;
const $5420b38fb3279371$var$lightBackgroundPulseGradientCss = null;
const $5420b38fb3279371$var$darkBackgroundDefaultGradientCss = null; // Dark theme blur with alpha transparency for loading states
const $5420b38fb3279371$var$darkBackgroundGeneratingGradientCss = null;
const $5420b38fb3279371$var$darkBackgroundPulseGradientCss = null;
const $5420b38fb3279371$var$darkBackgroundTransparentGradientCss = null;
const $5420b38fb3279371$var$loadingStateStyles = {
    generating: "_1gBibyViE0 _0nFVCGFSlo _43vdfTHVQb _03m2nySHWH",
    'pre-pulse': "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1wydGWdnbC _0Of8r2dnbC _2Zuz6QdnbC _1ZnuxbdnbC",
    pulse: "_1gBibyViE0 _0nFVCGpFbM _43vdfTHVQb _03m2nySHWH _1jakNnR7gE",
    generated: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1wydGWdnbC _0Of8r2dnbC _2Zuz6QdnbC _1ZnuxbdnbC"
};
const $5420b38fb3279371$export$ca874e6b8d314598 = ({ children: children, isAnswerComplete: isAnswerComplete = false, loadingState: loadingState, testId: testId })=>{
    $5420b38fb3279371$var$useGradientAngleProperty();
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)(); // Internal state for automatic transitions
    const [internalLoadingState, setInternalLoadingState] = (0, $cozmU.useState)('generating'); // Use external loadingState if provided, otherwise use internal state
    const currentLoadingState = loadingState ?? internalLoadingState; // Handle automatic transitions when answer is complete
    (0, $cozmU.useEffect)(()=>{
        if (!isAnswerComplete || loadingState) // Don't auto-transition if external loadingState is provided
        return;
         // Start phase 2 transitions
        let timeoutIds = []; // Transition to pre-pulse immediately
        setInternalLoadingState('pre-pulse'); // Transition to pulse after 200ms
        timeoutIds.push(setTimeout(()=>{
            setInternalLoadingState('pulse');
        }, $5420b38fb3279371$var$PRE_PULSE_ANIMATION_DURATION)); // Transition to generated after 800ms total (600ms after pulse)
        timeoutIds.push(setTimeout(()=>{
            setInternalLoadingState('generated');
        }, $5420b38fb3279371$var$TOTAL_PULSE_ANIMATION_DURATION)); // Cleanup timeouts
        return ()=>{
            timeoutIds.forEach(clearTimeout);
        };
    }, [
        isAnswerComplete,
        loadingState
    ]); // Reset to generating when answer becomes incomplete
    (0, $cozmU.useEffect)(()=>{
        if (!isAnswerComplete && !loadingState) setInternalLoadingState('generating');
    }, [
        isAnswerComplete,
        loadingState
    ]); // Simplified approach for Compiled compatibility
    const isGenerating = currentLoadingState === 'generating';
    const isPrePulse = currentLoadingState === 'pre-pulse';
    const isPulse = currentLoadingState === 'pulse';
    const isGenerated = currentLoadingState === 'generated';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _4bt5LAYvD1 _2WAcuGYvD1 _3PxjEG8g64 _1mT5xdRAKS _0Of8r2HZdu _1ZnuxbHZdu _1wydGWHZdu _2Zuz6QHZdu",
            !isReducedMotion ? colorMode === 'dark' ? isGenerating ? "_2uo31f6o3P" : isPrePulse ? "_2uo31f7p9X" : isPulse ? "_2uo31fwtUy" : isGenerated ? "_2uo31f7p9X" : "_2uo31fMcUP" : isGenerating ? "_2uo31fcw9M" : isPrePulse ? "_2uo31fTcsH" : isPulse ? "_2uo31f41qY" : isGenerated ? "_2uo31fTcsH" : "_2uo31fNPHD" : colorMode === 'dark' ? "_2uo31fqCLE" : "_2uo31fAxJq",
            !isReducedMotion && $5420b38fb3279371$var$loadingStateStyles[currentLoadingState],
            isReducedMotion && isPrePulse && $5420b38fb3279371$var$loadingStateStyles[currentLoadingState],
            isReducedMotion && isGenerated && $5420b38fb3279371$var$loadingStateStyles[currentLoadingState]
        ]),
        style: {
            "--_92idzx": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 1)),
            "--_1vk81z2": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#82B536", 1)),
            "--_ki6hwq": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#357DE8", 1)),
            "--_9dqj5t": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#BF63F3", 1)),
            "--_1jec5hf": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0)),
            "--_8b5chw": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#82B536", 0)),
            "--_gvxzl9": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#357DE8", 0)),
            "--_ujjfrh": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#BF63F3", 0)),
            "--_3g7mui": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0.5)),
            "--_14o0mv1": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#82B536", 0.5)),
            "--_4a9n2u": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#357DE8", 0.5)),
            "--_ts8ymb": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#BF63F3", 0.5)),
            "--_1ysqspb": (0, $9aYkv.default)("#FCA700"),
            "--_1kd2sou": (0, $9aYkv.default)("#82B536"),
            "--_zaeqnl": (0, $9aYkv.default)("#357DE8"),
            "--_wanli": (0, $9aYkv.default)("#BF63F3"),
            "--_1456abr": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 1)),
            "--_t9jq7i": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#6A9A23", 1)),
            "--_1i41aq5": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#1868DB", 1)),
            "--_wnwy7": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#AF59E0", 1)),
            "--_jkwta5": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0)),
            "--_6jnsza": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#6A9A23", 0)),
            "--_1v3r5g3": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#1868DB", 0)),
            "--_1vct74": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#AF59E0", 0)),
            "--_1b9vnnu": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0.5)),
            "--_1tdjujc": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#6A9A23", 0.5)),
            "--_2itg5h": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#1868DB", 0.5)),
            "--_xlhaqx": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#AF59E0", 0.5)),
            "--_1c36rch": (0, $9aYkv.default)("#FCA700"),
            "--_hciyaa": (0, $9aYkv.default)("#6A9A23"),
            "--_1pbtgh9": (0, $9aYkv.default)("#1868DB"),
            "--_26o6n0": (0, $9aYkv.default)("#AF59E0"),
            "--_y94hvq": (0, $9aYkv.default)("#0055CC"),
            "--_vps1rq": (0, $9aYkv.default)("#37B4C3"),
            "--_a0mweg": (0, $9aYkv.default)("#CF9F02"),
            "--_i6w5ag": (0, $9aYkv.default)("#1D7AFC"),
            "--_7nv8o6": (0, $9aYkv.default)("#8BDBE5"),
            "--_1ey9p4c": (0, $9aYkv.default)("#F8E6A0")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2uo31fYbGa _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _42Yu6BdnbC _1pp6NdYbGa _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3PxjEG8g64 _39xV02N91d _0jFU0VN91d _1llTr60oWv",
            colorMode === 'dark' ? isGenerating ? "_2uo31f6o3P" : isPrePulse ? "_2uo31f7p9X" : isPulse ? "_2uo31fwtUy" : isGenerated ? "_2uo31f7p9X" : "_2uo31fMcUP" : isGenerating ? "_2uo31fcw9M" : isPrePulse ? "_2uo31fTcsH" : isPulse ? "_2uo31f41qY" : isGenerated ? "_2uo31fTcsH" : "_2uo31fNPHD",
            !isReducedMotion && ""
        ]),
        style: {
            "--_92idzx": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 1)),
            "--_1vk81z2": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#82B536", 1)),
            "--_ki6hwq": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#357DE8", 1)),
            "--_9dqj5t": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#BF63F3", 1)),
            "--_1jec5hf": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0)),
            "--_8b5chw": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#82B536", 0)),
            "--_gvxzl9": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#357DE8", 0)),
            "--_ujjfrh": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#BF63F3", 0)),
            "--_3g7mui": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0.5)),
            "--_14o0mv1": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#82B536", 0.5)),
            "--_4a9n2u": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#357DE8", 0.5)),
            "--_ts8ymb": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#BF63F3", 0.5)),
            "--_1ysqspb": (0, $9aYkv.default)("#FCA700"),
            "--_1kd2sou": (0, $9aYkv.default)("#82B536"),
            "--_zaeqnl": (0, $9aYkv.default)("#357DE8"),
            "--_wanli": (0, $9aYkv.default)("#BF63F3"),
            "--_1456abr": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 1)),
            "--_t9jq7i": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#6A9A23", 1)),
            "--_1i41aq5": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#1868DB", 1)),
            "--_wnwy7": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#AF59E0", 1)),
            "--_jkwta5": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0)),
            "--_6jnsza": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#6A9A23", 0)),
            "--_1v3r5g3": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#1868DB", 0)),
            "--_1vct74": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#AF59E0", 0)),
            "--_1b9vnnu": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0.5)),
            "--_1tdjujc": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#6A9A23", 0.5)),
            "--_2itg5h": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#1868DB", 0.5)),
            "--_xlhaqx": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#AF59E0", 0.5)),
            "--_1c36rch": (0, $9aYkv.default)("#FCA700"),
            "--_hciyaa": (0, $9aYkv.default)("#6A9A23"),
            "--_1pbtgh9": (0, $9aYkv.default)("#1868DB"),
            "--_26o6n0": (0, $9aYkv.default)("#AF59E0")
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _0KLXrulfZc _1mT5xdRAKS _42Yu6BiZR3 _39xV02N91d"
        ])
    }, children));
};
module.exports["AnimatedWrapper"] = $5420b38fb3279371$export$ca874e6b8d314598;

});

parcelRegister("aYqz2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");


var $4Tg3t = parcelRequire("4Tg3t");

function $3711c88a8522b3a9$export$4d3ad568e79b0fd1({ data: data, children: children }) {
    const value = (0, $4Tg3t.sanitizeSearchAIAnalyticsContextData)(data);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: value
    }, children);
}
module.exports["SearchAIAnalyticsContext"] = $3711c88a8522b3a9$export$4d3ad568e79b0fd1;

});

parcelRegister("uY2pq", function(module, exports) {
var $3e50bbae71b7b022$export$64b1ad5e685d86fd = /*#__PURE__*/ function(SearchAIAnalyticsContextLocation) {
    SearchAIAnalyticsContextLocation["AI_DEFINITION"] = "ai-definition";
    SearchAIAnalyticsContextLocation["SAIN_AGENT_CARD"] = "sain-agent-card";
    SearchAIAnalyticsContextLocation["SAIN_BOOKMARK"] = "sain-bookmark";
    SearchAIAnalyticsContextLocation["SAIN_JIRA_ISSUE_CARD"] = "sain-jira-issue-card";
    SearchAIAnalyticsContextLocation["SAIN_JIRA_NL_TO_JQL_CARD"] = "sain-jira-nl-to-jql-card";
    SearchAIAnalyticsContextLocation["SAIN_PERSON_CARD"] = "sain-person-card";
    SearchAIAnalyticsContextLocation["SAIN_Q_AND_A_CARD"] = "sain-q-and-a-card";
    SearchAIAnalyticsContextLocation["SAIN_TEAM_CARD"] = "sain-team-card";
    SearchAIAnalyticsContextLocation["SEARCH_RESULT_CONFLUENCE_CARD"] = "search-result-confluence-card";
    return SearchAIAnalyticsContextLocation;
}({});
module.exports["SearchAIAnalyticsContextLocation"] = $3e50bbae71b7b022$export$64b1ad5e685d86fd;

});

parcelRegister("kpjET", function(module, exports) {
/* ai-disclaimer-and-feedback.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $fHs3z = parcelRequire("fHs3z");


var $fodiz = parcelRequire("fodiz");


var $i1t43 = parcelRequire("i1t43");


var $iDrrr = parcelRequire("iDrrr");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $lEgaq = parcelRequire("lEgaq");


var $3hVWe = parcelRequire("3hVWe");


var $6O5Et = parcelRequire("6O5Et");


var $h1Grp = parcelRequire("h1Grp");


var $bZMnB = parcelRequire("bZMnB");


var $eySxZ = parcelRequire("eySxZ");


var $8tNXq = parcelRequire("8tNXq");




















var $93fnf = parcelRequire("93fnf");


var $c8bBH = parcelRequire("c8bBH");




const $7d1f13593b920bf8$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ai_feedback_report_consent_checkbox_label: {
        id: "search_ai.ai_feedback_report_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    ai_feedback_provide_additional_feedback_title: {
        id: "search_ai.ai_feedback_provide_additional_feedback_title",
        defaultMessage: "Provide additional feedback"
    },
    ai_feedback_like_button_tooltip: {
        id: "search_ai.ai_feedback_like_button_tooltip",
        defaultMessage: "Good response"
    },
    ai_feedback_dislike_button_tooltip: {
        id: "search_ai.ai_feedback_dislike_button_tooltip",
        defaultMessage: "Bad response"
    },
    ai_feedback_can_contact_checkbox_label: {
        id: "search_ai.ai_feedback_can_contact_checkbox_label",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the {privatePolicyLink}"
    },
    ai_feedback_private_policy_link: {
        id: "search_ai.ai_feedback_private_policy_link",
        defaultMessage: "Atlassian Privacy Policy"
    },
    ai_feedback_reason_out_of_date: {
        id: "search_ai.ai_feedback_reason_out_of_date",
        defaultMessage: "Out of date"
    },
    ai_feedback_reason_inaccurate: {
        id: "search_ai.ai_feedback_reason_inaccurate",
        defaultMessage: "Inaccurate"
    },
    ai_feedback_reason_too_long: {
        id: "search_ai.ai_feedback_reason_too_long",
        defaultMessage: "Too long"
    },
    ai_feedback_reason_too_short: {
        id: "search_ai.ai_feedback_reason_too_short",
        defaultMessage: "Too short"
    },
    ai_feedback_reason_wrong_sources: {
        id: "search_ai.ai_feedback_reason_wrong_sources",
        defaultMessage: "Wrong sources"
    },
    ai_feedback_reason_inappropriate: {
        id: "search_ai.ai_feedback_reason_inappropriate",
        defaultMessage: "Inappropriate or harmful"
    },
    ai_feedback_reason_other: {
        id: "search_ai.ai_feedback_reason_other",
        defaultMessage: "Other"
    },
    ai_feedback_reason_up_to_date: {
        id: "search_ai.ai_feedback_reason_up_to_date",
        defaultMessage: "Up to date"
    },
    ai_feedback_reason_accurate: {
        id: "search_ai.ai_feedback_reason_accurate",
        defaultMessage: "Accurate"
    },
    ai_feedback_reason_helpful: {
        id: "search_ai.ai_feedback_reason_helpful",
        defaultMessage: "Helpful"
    },
    ai_feedback_reason_following_instructions: {
        id: "search_ai.ai_feedback_reason_following_instructions",
        defaultMessage: "Following instructions"
    },
    ai_feedback_reason_good_sources: {
        id: "search_ai.ai_feedback_reason_good_sources",
        defaultMessage: "Good sources"
    },
    ai_feedback_flag_title: {
        id: "search_ai.ai_feedback_flag_title",
        defaultMessage: "Thank you"
    },
    ai_feedback_flag_description: {
        id: "search_ai.ai_feedback_flag_description",
        defaultMessage: "Your feedback helps to improve Rovo"
    },
    ai_feedback_flag_close_action: {
        id: "search_ai.ai_feedback_flag_close_action",
        defaultMessage: "I'm done"
    },
    ai_feedback_what_hasnt_gone_well_title: {
        id: "search_ai.ai_feedback_what_hasnt_gone_well_title",
        defaultMessage: "What hasn't gone well?"
    },
    ai_feedback_what_has_gone_well_title: {
        id: "search_ai.ai_feedback_what_has_gone_well_title",
        defaultMessage: "What has been going well?"
    },
    ai_feedback_additional_feedback_label: {
        id: "search_ai.ai_feedback_additional_feedback_label",
        defaultMessage: "Additional feedback"
    },
    ai_feedback_additional_feedback_placeholder: {
        id: "search_ai.ai_feedback_additional_feedback_placeholder",
        defaultMessage: "Tell us more"
    }
});


const $ff5baad0a85fb87d$var$LikeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    });
const $ff5baad0a85fb87d$var$ActiveLikeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        label: "",
        color: "var(--ds-icon-selected, #1868DB)"
    });
const $ff5baad0a85fb87d$var$DislikeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    });
const $ff5baad0a85fb87d$var$ActiveDislikeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
        label: "",
        color: "var(--ds-icon-selected, #1868DB)"
    });
const $ff5baad0a85fb87d$export$ee3da02b14ab91be = ({ liked: liked, setLiked: setLiked, setShowDisplayFlag: setShowDisplayFlag, onLikeButtonClickHandler: onLikeButtonClickHandler, onDislikeButtonClickHandler: onDislikeButtonClickHandler, onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler, onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        if (liked === undefined || liked === false) {
            setShowDisplayFlag(true);
            setLiked(true);
            onLikeButtonClickHandler && onLikeButtonClickHandler(e);
        } else {
            setLiked(undefined);
            onDeselectLikeButtonClickHandler && onDeselectLikeButtonClickHandler(e);
        }
    }, [
        setShowDisplayFlag,
        setLiked,
        onLikeButtonClickHandler,
        liked,
        onDeselectLikeButtonClickHandler
    ]);
    const dislikeButtonCallback = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        if (liked === undefined || liked === true) {
            setShowDisplayFlag(true);
            setLiked(false);
            onDislikeButtonClickHandler && onDislikeButtonClickHandler(e);
        } else {
            setLiked(undefined);
            onDeselectDislikeButtonClickHandler && onDeselectDislikeButtonClickHandler(e);
        }
    }, [
        setShowDisplayFlag,
        setLiked,
        onDislikeButtonClickHandler,
        liked,
        onDeselectDislikeButtonClickHandler
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: liked === true ? $ff5baad0a85fb87d$var$ActiveLikeIcon : $ff5baad0a85fb87d$var$LikeIcon,
        isSelected: liked === true,
        onClick: likeButtonCallback,
        label: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_like_button_tooltip),
        appearance: liked === true ? 'primary' : 'subtle',
        isTooltipDisabled: false,
        spacing: "compact",
        testId: "ai-answer-like-button",
        shape: "circle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: liked === false ? $ff5baad0a85fb87d$var$ActiveDislikeIcon : $ff5baad0a85fb87d$var$DislikeIcon,
        isSelected: liked === false,
        onClick: dislikeButtonCallback,
        label: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_dislike_button_tooltip),
        appearance: liked === false ? 'primary' : 'subtle',
        isTooltipDisabled: false,
        spacing: "compact",
        testId: "ai-answer-dislike-button",
        shape: "circle"
    }));
};









var $ad7Ou = parcelRequire("ad7Ou");


var $2uDbg = parcelRequire("2uDbg");


var $8Xvwd = parcelRequire("8Xvwd");


var $dUI0h = parcelRequire("dUI0h");







var $dinVW = parcelRequire("dinVW");




var $e3Wrf = parcelRequire("e3Wrf");


var $zzZbq = parcelRequire("zzZbq");

var $40eab6f0a1c6097d$export$1cf63b56d5de87d5 = /*#__PURE__*/ function(FeedbackCollectorModalVariant) {
    FeedbackCollectorModalVariant["POSITIVE"] = "positive";
    FeedbackCollectorModalVariant["NEGATIVE"] = "negative";
    return FeedbackCollectorModalVariant;
}({});




const $d2986553f1f9cb37$var$AkFeedbackCollector = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lavoB")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $d2986553f1f9cb37$export$21ca6c649ed55a5a = ({ entrypointId: entrypointId, attributes: attributes, attributesWithConsent: attributesWithConsent, userId: userId, userName: userName, onClose: onClose, onSubmit: onSubmit, variant: variant })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [hasConsent, setConsent] = (0, $cozmU.useState)(false);
    const [canContact, setCanContact] = (0, $cozmU.useState)(false);
    const [selectedReasons, setSelectedReasons] = (0, $cozmU.useState)([]);
    const [description, setDescription] = (0, $cozmU.useState)('');
    const POSITIVE_FEEDBACK_REASONS = [
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_up_to_date),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_accurate),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_helpful),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_following_instructions),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_good_sources),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_other)
    ];
    const NEGATIVE_FEEDBACK_REASONS = [
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_out_of_date),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_inaccurate),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_too_long),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_too_short),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_wrong_sources),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_inappropriate),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_other)
    ];
    const feedbackOptions = variant === (0, $40eab6f0a1c6097d$export$1cf63b56d5de87d5).POSITIVE ? POSITIVE_FEEDBACK_REASONS : NEGATIVE_FEEDBACK_REASONS;
    const handleReasonClick = (option)=>{
        setSelectedReasons((prev)=>prev.includes(option) ? prev.filter((r)=>r !== option) : [
                ...prev,
                option
            ]);
    };
    const feedbackObject = {
        ...attributes,
        ...hasConsent ? attributesWithConsent : {},
        ...selectedReasons.length > 0 ? {
            'Feedback Reasons': selectedReasons.join(', ')
        } : {}
    };
    const feedbackContext = Object.entries(feedbackObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $cozmU.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    const sendMetadata = {
        userId: userId
    };
    const getDescriptionWithMetadata = ()=>`
	${description}

	\`\`\`
	${JSON.stringify(sendMetadata, null, 2)}
	\`\`\`
  `;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2986553f1f9cb37$var$AkFeedbackCollector, {
        onClose: onClose,
        onSubmit: ()=>onSubmit({
                feedbackOptions: selectedReasons,
                additionalFeedbackAdded: description.length > 0,
                includeResponse: hasConsent,
                canContact: canContact
            }),
        showTypeField: false,
        showDefaultTextFields: false,
        atlassianAccountId: userId,
        name: userName,
        entrypointId: entrypointId,
        additionalFields: [
            {
                id: (0, $zzZbq.FEEDBACK_CONTEXT_CF),
                value: feedbackContext
            },
            {
                id: 'customfield_10043',
                value: canContact ? [
                    {
                        id: '10109'
                    }
                ] : [
                    {
                        id: '10111'
                    }
                ]
            }
        ],
        feedbackTitle: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_provide_additional_feedback_title),
        descriptionDefaultValue: getDescriptionWithMetadata(),
        summaryDefaultValue: description,
        canBeContactedFieldId: "undefined",
        showRequiredFieldsSummary: false,
        customContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold",
            color: "color.text.subtle"
        }, formatMessage(variant === (0, $40eab6f0a1c6097d$export$1cf63b56d5de87d5).POSITIVE ? (0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_what_has_gone_well_title : (0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_what_hasnt_gone_well_title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            shouldWrap: true
        }, feedbackOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                key: option,
                isSelected: selectedReasons.includes(option),
                onClick: ()=>handleReasonClick(option)
            }, option)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "feedback-summary",
            label: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_additional_feedback_label),
            isRequired: false,
            defaultValue: ""
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                ...fieldProps,
                name: "feedback-collector-description",
                minimumRows: 6,
                placeholder: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_additional_feedback_placeholder),
                onChange: (e)=>setDescription(e.target.value),
                value: description
            })), Object.keys(attributesWithConsent).length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Xvwd.CheckboxField), {
            name: "search-ai-include-prompt-and-response",
            defaultIsChecked: hasConsent
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                ...fieldProps,
                label: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_report_consent_checkbox_label),
                onChange: toggleConsentCheckbox
            })) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Xvwd.CheckboxField), {
            name: "can-be-contacted",
            defaultIsChecked: canContact
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                ...fieldProps,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_can_contact_checkbox_label, {
                    privatePolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: "https://www.atlassian.com/legal/privacy-policy",
                        target: "_blank"
                    }, formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_private_policy_link))
                })),
                onChange: (event)=>setCanContact(event.target.checked)
            }))))
    }));
};






const $4a58b9ec9be91f32$export$c71de71744353b85 = (0, $cozmU.lazy)(()=>(parcelRequire("ej9Uw")).then(({ AIFeedbackFlag: AIFeedbackFlag })=>({
            default: AIFeedbackFlag
        })));




const $e1d03c67c6cdc8ad$export$41116a477d95163a = function AIFeedback({ entrypointId: entrypointId, onLikeButtonClickHandler: onLikeButtonClickHandler, onDislikeButtonClickHandler: onDislikeButtonClickHandler, onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler, onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler, onFeedbackSubmitHandler: onFeedbackSubmitHandler, userDetails: userDetails, attributes: attributes, attributesWithConsent: attributesWithConsent = {}, liked: externalLike // set like state from the outside
 }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [showFeedbackModal, setShowFeedbackModal] = (0, $cozmU.useState)(false);
    const [showDisplayFlag, setShowDisplayFlag] = (0, $cozmU.useState)(false);
    const [liked, setLiked] = (0, $cozmU.useState)(externalLike);
    const onFeedbackSubmit = ({ feedbackOptions: feedbackOptions, additionalFeedbackAdded: additionalFeedbackAdded, includeResponse: includeResponse, canContact: canContact })=>{
        onFeedbackSubmitHandler?.({
            liked: liked,
            feedbackOptions: feedbackOptions,
            additionalFeedbackAdded: additionalFeedbackAdded,
            includeResponse: includeResponse,
            canContact: canContact
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff5baad0a85fb87d$export$ee3da02b14ab91be), {
        setShowDisplayFlag: setShowDisplayFlag,
        onLikeButtonClickHandler: onLikeButtonClickHandler,
        onDislikeButtonClickHandler: onDislikeButtonClickHandler,
        onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler,
        onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler,
        liked: liked,
        setLiked: setLiked
    })), showFeedbackModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d2986553f1f9cb37$export$21ca6c649ed55a5a), {
        entrypointId: entrypointId,
        attributes: attributes,
        attributesWithConsent: attributesWithConsent,
        userId: userDetails.id,
        userName: userDetails.name,
        onClose: ()=>setShowFeedbackModal(false),
        onSubmit: onFeedbackSubmit,
        variant: liked ? (0, $40eab6f0a1c6097d$export$1cf63b56d5de87d5).POSITIVE : (0, $40eab6f0a1c6097d$export$1cf63b56d5de87d5).NEGATIVE
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a58b9ec9be91f32$export$c71de71744353b85), {
        displayFlag: showDisplayFlag,
        onDismissed: ()=>setShowDisplayFlag(false),
        description: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_flag_description),
        title: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_flag_title),
        actions: [
            {
                content: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_provide_additional_feedback_title),
                onClick: ()=>{
                    setShowDisplayFlag(false);
                    setShowFeedbackModal(true);
                }
            },
            {
                content: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_flag_close_action),
                onClick: ()=>setShowDisplayFlag(false)
            }
        ]
    })));
};






var $j9bgP = parcelRequire("j9bgP");

/* sain-more-options-dropdown.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $lU4RT = parcelRequire("lU4RT");


var $7DqNt = parcelRequire("7DqNt");


var $9erVg = parcelRequire("9erVg");


var $6spAz = parcelRequire("6spAz");


var $gC2EJ = parcelRequire("gC2EJ");


var $6TaGl = parcelRequire("6TaGl");





var $iMnC5 = parcelRequire("iMnC5");




var $IOtUu = parcelRequire("IOtUu");


var $6dPGs = parcelRequire("6dPGs");


var $4QjIS = parcelRequire("4QjIS");











var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");














var $6JEx2 = parcelRequire("6JEx2");





var $lT1k3 = parcelRequire("lT1k3");

function $ffbc3a6135adf3d1$export$9534590fb6ce7f04({ isOpen: isOpen, onClose: onClose }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [promptText, setPromptText] = (0, $cozmU.useState)('');
    (0, $cozmU.useEffect)(()=>{
        if (isOpen) {
            const stored = (0, $6JEx2.getSessionItem)((0, $zzZbq.PROMPT_OVERRIDE_SESSION_KEY));
            setPromptText(stored || '');
        }
    }, [
        isOpen
    ]);
    const handleSave = (0, $cozmU.useCallback)(()=>{
        const trimmedPrompt = promptText.trim();
        if (trimmedPrompt) (0, $6JEx2.setSessionItem)((0, $zzZbq.PROMPT_OVERRIDE_SESSION_KEY), trimmedPrompt);
        else (0, $6JEx2.deleteSessionItem)((0, $zzZbq.PROMPT_OVERRIDE_SESSION_KEY));
        onClose();
    }, [
        promptText,
        onClose
    ]);
    const handleTextChange = (0, $cozmU.useCallback)((e)=>{
        setPromptText(e.target.value);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: "large",
        testId: "prompt-override-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lT1k3.messages).prompt_override_modal_title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lT1k3.messages).prompt_override_custom_prompt_label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        value: promptText,
        onChange: handleTextChange,
        placeholder: formatMessage((0, $lT1k3.messages).prompt_override_textarea_placeholder),
        testId: "prompt-override-textarea",
        resize: "vertical"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lT1k3.messages).prompt_override_help_text))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lT1k3.messages).prompt_override_cancel_button)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleSave,
        testId: "prompt-override-save-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lT1k3.messages).prompt_override_save_button))))));
}


const $af13dc6b3c05e823$var$messages = (0, $kSwu1.defineMessages)({
    debugger_menu_item: {
        id: "search_ai.debugger_menu_item",
        defaultMessage: "Debugger"
    },
    prompt_override_menu_item: {
        id: "search_ai.prompt_override_menu_item",
        defaultMessage: "Prompt override"
    },
    store_message_label: {
        id: "search_ai.store_message_label",
        defaultMessage: "Record this message to help us improve answer quality"
    },
    internal_lozenge: {
        id: "search_ai.internal_lozenge",
        defaultMessage: "INTERNAL"
    }
});
const $af13dc6b3c05e823$var$DROPDOWN_Z_INDEX = 900;
const $af13dc6b3c05e823$var$dropdownPanelStyles = {
    panel: "_39xV02aQBb",
    lozengeWrapper: "_39xV02E6Kk"
};
function $af13dc6b3c05e823$export$fcbb8fd6209efbc6() {
    const [isDebuggerModalOpen, setIsDebuggerModalOpen] = (0, $cozmU.useState)(false);
    const [isPromptOverrideModalOpen, setIsPromptOverrideModalOpen] = (0, $cozmU.useState)(false);
    const isArizeGateOn = (0, $iDrrr.fg)('kd_sain_enable_arize_hello_only');
    const showOnlineDebugger = (0, $iDrrr.fg)('kd_sain_online_debugger');
    const showPromptOverride = (0, $iDrrr.fg)('convo_ai_sain_enable_prompt_override_hello_only');
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [storeMessage, setStoreMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(()=>{
        try {
            const stored = (0, $6dPGs.getLocalStorageItemAsString)('search-ai.sain.store_message');
            return stored === null || stored === 'true';
        } catch  {
            return true;
        }
    });
    const onStoreMessageToggle = ()=>{
        const next = !storeMessage;
        setStoreMessage(next);
        try {
            (0, $6dPGs.setLocalStorageItem)('search-ai.sain.store_message', String(next));
        } catch  {}
    };
    const onMoreOptionsClick = (event)=>{
        event.stopPropagation();
    };
    const onDebuggerClick = ()=>{
        setIsDebuggerModalOpen(true);
    };
    const onPromptOverrideClick = ()=>{
        setIsPromptOverrideModalOpen(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...props,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: "More options",
                appearance: "subtle",
                spacing: "compact",
                testId: "sain-more-options-button",
                onClick: (e)=>{
                    onMoreOptionsClick(e);
                    props.onClick?.(e);
                }
            }),
        placement: "bottom-end",
        zIndex: $af13dc6b3c05e823$var$DROPDOWN_Z_INDEX
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $af13dc6b3c05e823$var$dropdownPanelStyles.panel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, showOnlineDebugger && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6spAz))), {
            label: ""
        }),
        onClick: onDebuggerClick,
        testId: "online-debugger-button"
    }, formatMessage($af13dc6b3c05e823$var$messages.debugger_menu_item)), showPromptOverride && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
            label: ""
        }),
        onClick: onPromptOverrideClick,
        testId: "prompt-override-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $af13dc6b3c05e823$var$messages.prompt_override_menu_item))), isArizeGateOn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7DqNt.default), {
        id: "sain-store-message-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lU4RT.default), {
        id: "sain-store-message",
        isSelected: storeMessage,
        onClick: onStoreMessageToggle,
        testId: "sain-store-message-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $af13dc6b3c05e823$var$messages.store_message_label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $af13dc6b3c05e823$var$dropdownPanelStyles.lozengeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
        text: formatMessage($af13dc6b3c05e823$var$messages.internal_lozenge),
        isRemovable: false,
        migration_fallback: "lozenge"
    })))))))), showOnlineDebugger && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4QjIS.OnlineDebuggerModal), {
        isOpen: isDebuggerModalOpen,
        onClose: ()=>setIsDebuggerModalOpen(false)
    }), showPromptOverride && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ffbc3a6135adf3d1$export$9534590fb6ce7f04), {
        isOpen: isPromptOverrideModalOpen,
        onClose: ()=>setIsPromptOverrideModalOpen(false)
    }));
}


const $3b7931cf87bf2e51$var$messages = (0, $kSwu1.defineMessages)({
    ai_content_disclaimer: {
        id: "search_ai.ai_content_disclaimer",
        defaultMessage: "Uses AI. Verify results."
    },
    ai_answer_component_copy_button: {
        id: "search_ai.ai_answer_component_copy_button",
        defaultMessage: "Copy"
    }
});
const $3b7931cf87bf2e51$var$copyIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
        color: "var(--ds-icon-subtlest, #6B6E76)",
        label: "copy"
    });
const $3b7931cf87bf2e51$var$styles = {
    heightWrapper: "_0jFU0VoWWg"
};
function $3b7931cf87bf2e51$export$7c1b08f310ac0a6a({ showFeedbackButtons: showFeedbackButtons, showCopyButton: showCopyButton, showAIUsageDisclaimer: showAIUsageDisclaimer = true, copyText: copyText, renderedContentRef: renderedContentRef }) {
    const { commonAttributes: commonAttributes, isAnswered: isAnswered } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { answerString: answerString } = commonAttributes;
    const feedbackOptions = (0, $h1Grp.useSmartAnswerCardFeedbackOptions)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const isArizeGateOn = (0, $iDrrr.fg)('kd_sain_enable_arize_hello_only');
    const showOnlineDebuggerButton = isAnswered && (0, $iDrrr.fg)('kd_sain_online_debugger');
    const showPromptOverrideButton = (0, $iDrrr.fg)('convo_ai_sain_enable_prompt_override_hello_only');
    const hasMoreOptions = isAnswered && (isArizeGateOn || showPromptOverrideButton);
    const showOnlineDebuggerInline = showOnlineDebuggerButton && !hasMoreOptions;
    const onLinkClickHandler = (event)=>{
        event.stopPropagation();
    };
    const onLikeButtonClickHandler = (event)=>{
        event.stopPropagation();
        feedbackOptions.onLikeButtonClickHandler();
    };
    const onDislikeButtonClickHandler = (event)=>{
        event.stopPropagation();
        feedbackOptions.onDislikeButtonClickHandler();
    };
    const onDeselectLikeButtonClickHandler = (event)=>{
        event.stopPropagation();
        feedbackOptions.onDeselectLikeButtonClickHandler();
    };
    const onDeselectDislikeButtonClickHandler = (event)=>{
        event.stopPropagation();
        feedbackOptions.onDeselectDislikeButtonClickHandler();
    };
    const onCopyButtonClickHandler = async (event)=>{
        event.stopPropagation();
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).COPY_CLICKED,
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $6O5Et.onAIAnswerCopyButtonClicked)(commonAttributes));
        if (copyText) await navigator.clipboard.writeText(copyText);
        else {
            const plainText = answerString.replace(/\s*\[\^\d+\^\]\s*/g, ' ').replace(/  +/g, ' ').trim();
            try {
                const node = renderedContentRef?.current;
                if (node) {
                    const clonedNode = node.cloneNode(true);
                    clonedNode.querySelectorAll((0, $lEgaq.SAIN_CITATION_SELECTOR)).forEach((el)=>el.remove());
                    const htmlBlob = new Blob([
                        clonedNode.innerHTML
                    ], {
                        type: 'text/html'
                    });
                    const textBlob = new Blob([
                        plainText
                    ], {
                        type: 'text/plain'
                    });
                    await navigator.clipboard.write([
                        new ClipboardItem({
                            'text/html': htmlBlob,
                            'text/plain': textBlob
                        })
                    ]);
                } else await navigator.clipboard.writeText(plainText);
            } catch  {
                await navigator.clipboard.writeText(plainText);
            }
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "end",
        grow: "fill",
        spread: "space-between",
        xcss: $3b7931cf87bf2e51$var$styles.heightWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.025"
    }, showAIUsageDisclaimer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: "",
        size: "small",
        spacing: "compact"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: (0, $zzZbq.ATLASSIAN_INTELLIGENCE_TRUST_LINK),
        onClick: onLinkClickHandler,
        rel: "noopener noreferrer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3b7931cf87bf2e51$var$messages.ai_content_disclaimer)))) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, showFeedbackButtons ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e1d03c67c6cdc8ad$export$41116a477d95163a), {
        entrypointId: feedbackOptions.entrypointId,
        userDetails: feedbackOptions.userDetails,
        attributes: feedbackOptions.attributes,
        attributesWithConsent: feedbackOptions.attributesWithConsent,
        onLikeButtonClickHandler: onLikeButtonClickHandler,
        onDislikeButtonClickHandler: onDislikeButtonClickHandler,
        onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler,
        onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler,
        onFeedbackSubmitHandler: feedbackOptions.onFeedbackSubmitHandler
    }) : null, showCopyButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: $3b7931cf87bf2e51$var$copyIcon,
        label: formatMessage($3b7931cf87bf2e51$var$messages.ai_answer_component_copy_button),
        onClick: onCopyButtonClickHandler,
        appearance: "subtle",
        isTooltipDisabled: false,
        spacing: "compact",
        shape: "circle",
        testId: "copy-button"
    }) : null, showOnlineDebuggerInline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j9bgP.OnlineDebuggerButton), null), hasMoreOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af13dc6b3c05e823$export$fcbb8fd6209efbc6), null)));
}
module.exports["AIDisclaimerAndFeedback"] = $3b7931cf87bf2e51$export$7c1b08f310ac0a6a;

});

parcelRegister("h1Grp", function(module, exports) {

var $bZMnB = parcelRequire("bZMnB");


var $eySxZ = parcelRequire("eySxZ");


var $8tNXq = parcelRequire("8tNXq");


var $zzZbq = parcelRequire("zzZbq");


var $3hVWe = parcelRequire("3hVWe");


var $4Tg3t = parcelRequire("4Tg3t");

const $740fc7030b799668$export$47b58698bef30558 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDeselectDislikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};





const $9b118bbd0d29337f$export$473e6bca52fdbe16 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDeselectLikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};



var $bIZaC = parcelRequire("bIZaC");




const $3218e8c3e413cf9e$export$67d198681f64796b = (props)=>{
    const { query: query, answerString: answerString, source: source, feedbackSentiment: feedbackSentiment, feedbackOptions: feedbackOptions, additionalFeedbackAdded: additionalFeedbackAdded, includeResponse: includeResponse, canContact: canContact } = props;
    return {
        action: 'submitted',
        actionSubject: 'aiAnswerFeedback',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            feedbackSentiment: feedbackSentiment,
            feedbackOptions: feedbackOptions,
            additionalFeedbackAdded: additionalFeedbackAdded,
            includeResponse: includeResponse,
            canContact: canContact
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};



var $7z5N5 = parcelRequire("7z5N5");

function $fcd16e1a27802e9e$export$7cac3b748a811283() {
    const { commonAttributes: commonAttributes, readingAidsOptions: readingAidsOptions, updateContextCache: updateContextCache, userDetails: userDetails } = (0, $3hVWe.useAIAnswerContext)();
    const { query: query, errorState: errorState, searchSessionId: searchSessionId, source: source, queryHash: queryHash, cloudId: cloudId, answerString: answerString, extraAttributes: extraAttributes } = commonAttributes;
    const { originalQuery: originalQuery } = extraAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const onLikeButtonClickHandler = ()=>{
        updateContextCache({
            collapsed: false,
            liked: true
        });
        fireAnalyticsEvent((0, $7z5N5.onLikeButtonClick)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).POSITIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    };
    const onDislikeButtonClickHandler = ()=>{
        updateContextCache({
            collapsed: false,
            liked: false
        });
        fireAnalyticsEvent((0, $bIZaC.onDislikeButtonClick)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).NEGATIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    };
    const onDeselectLikeButtonClickHandler = ()=>{
        updateContextCache({
            collapsed: false,
            liked: undefined
        });
        fireAnalyticsEvent((0, $9b118bbd0d29337f$export$473e6bca52fdbe16)(commonAttributes));
    };
    const onDeselectDislikeButtonClickHandler = ()=>{
        updateContextCache({
            collapsed: false,
            liked: undefined
        });
        fireAnalyticsEvent((0, $740fc7030b799668$export$47b58698bef30558)(commonAttributes));
    };
    const onFeedbackSubmitHandler = ({ liked: liked, feedbackOptions: feedbackOptions, additionalFeedbackAdded: additionalFeedbackAdded, includeResponse: includeResponse, canContact: canContact })=>{
        fireAnalyticsEvent((0, $3218e8c3e413cf9e$export$67d198681f64796b)({
            ...commonAttributes,
            feedbackSentiment: liked ? 'positive' : 'negative',
            feedbackOptions: feedbackOptions,
            additionalFeedbackAdded: additionalFeedbackAdded,
            includeResponse: includeResponse,
            canContact: canContact
        }));
    };
    const feedbackAttributes = {
        searchSessionId: searchSessionId,
        source: source,
        queryHash: queryHash,
        cloudId: cloudId,
        documentId: readingAidsOptions?.contentARI,
        errorState: errorState
    };
    const feedbackAttributesWithConsent = {
        transformedPrompt: query,
        originalPrompt: originalQuery,
        answer: answerString
    };
    const feedbackOptions = {
        attributes: feedbackAttributes,
        attributesWithConsent: feedbackAttributesWithConsent,
        entrypointId: (0, $zzZbq.FEEDBACK_ENTRYPOINT_ID_SAIN),
        onLikeButtonClickHandler: onLikeButtonClickHandler,
        onDislikeButtonClickHandler: onDislikeButtonClickHandler,
        onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler,
        onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler,
        onFeedbackSubmitHandler: onFeedbackSubmitHandler,
        userDetails: userDetails
    };
    return feedbackOptions;
}
module.exports["useSmartAnswerCardFeedbackOptions"] = $fcd16e1a27802e9e$export$7cac3b748a811283;

});

parcelRegister("lavoB", function(module, exports) {

let $f692e2b2ecda8234$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f692e2b2ecda8234$var$load("6wr18"),
    $f692e2b2ecda8234$var$load("ffEVr"),
    $f692e2b2ecda8234$var$load("Wowvf"),
    $f692e2b2ecda8234$var$load("hhss7"),
    $f692e2b2ecda8234$var$load("7gL7H")
]).then(()=>parcelRequire('91uAX'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("ej9Uw", function(module, exports) {

let $a6aa871bd154cbaa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a6aa871bd154cbaa$var$load("1ocnt").then(()=>parcelRequire('hPzO4'));

});

parcelRegister("lPcf8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eDWBm = parcelRequire("eDWBm");


var $cuvLu = parcelRequire("cuvLu");

const $eb3f7933f4ae0ee0$var$useLogException = ()=>{
    return (0, $cozmU.useCallback)(async (error)=>{
        (0, $cuvLu.logger).error({
            error: error,
            functionName: 'useLogException'
        });
    }, []);
};
const $eb3f7933f4ae0ee0$export$e926676385687eaf = (props)=>{
    const onException = $eb3f7933f4ae0ee0$var$useLogException();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eDWBm.ErrorBoundary), {
        ...props,
        onException: onException
    }, props.children);
};
module.exports["ErrorBoundary"] = $eb3f7933f4ae0ee0$export$e926676385687eaf;

});

parcelRegister("bE9h1", function(module, exports) {

let $87aa9fa7f0d924ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $87aa9fa7f0d924ad$var$load("cTPK8").then(()=>parcelRequire('ewOJJ'));

});

parcelRegister("aiIBH", function(module, exports) {
/* smart-answer-card-body-generating.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $cJ0FD = parcelRequire("cJ0FD");


var $9ivsj = parcelRequire("9ivsj");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $3hVWe = parcelRequire("3hVWe");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


const $c75d50a61266072a$export$62d54f79d0abe5c8 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "3",
        cy: "14",
        r: "1",
        fill: '#1F69DA'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "7",
        cy: "14",
        r: "1",
        fill: '#C16CD4'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "11",
        cy: "14",
        r: "1",
        fill: '#F5A117'
    }));
};



var $7qJqb = parcelRequire("7qJqb");


var $kSORO = parcelRequire("kSORO");


var $8tNXq = parcelRequire("8tNXq");


var $7DMz5 = parcelRequire("7DMz5");


var $24oKg = parcelRequire("24oKg");


var $9LgVw = parcelRequire("9LgVw");

const $738473f8dd204ed0$var$styles = {
    containerNewSAINLoading: "_1Znuxb5zaO _2Zuz6Q5zaO _0Of8r25zaO _1wydGW5zaO _0jFU0Vk3g7 _3X9j4qyIAw",
    inline: "_2Zuz6Q2ADO _1Znuxb2ADO _1wydGW2ADO _0Of8r22ADO",
    inlineAnimation: "_3iDTPbccYA _1RrJLit2nV",
    jiraNlToJqlCardHeightOverride: "_0jFU0V2LXa",
    jiraNlToJqlSmartlinkCardHeightOverride: "_0jFU0Vk3g7",
    navigationalCardHeightOverride: "_0jFU0VehCh",
    luminaOverride: "_0jFU0VaG3x _0Of8r2Pgdg _2Zuz6QPgdg _1ZnuxbPgdg",
    borderlessNoPadding: "_0jFU0Voaux _0Of8r2Pgdg _2Zuz6QPgdg _1ZnuxbPgdg _1wydGWPgdg",
    luminaTallHeightOverride: "_0jFU0Vheo5 _0Of8r2Pgdg _2Zuz6QPgdg _1ZnuxbPgdg",
    sourcesSidePanelOverride: "_0jFU0VqfN2"
};
const $738473f8dd204ed0$var$SKELETON_HEIGHT_LINE = '16px';
const $738473f8dd204ed0$var$SKELETON_BORDER_RADIUS = "var(--ds-radius-medium, 6px)";
const $738473f8dd204ed0$var$skeletonLinesStandard = [
    {
        width: '100%',
        height: $738473f8dd204ed0$var$SKELETON_HEIGHT_LINE
    },
    {
        width: '100%',
        height: $738473f8dd204ed0$var$SKELETON_HEIGHT_LINE
    },
    {
        width: '90%',
        height: $738473f8dd204ed0$var$SKELETON_HEIGHT_LINE
    }
]; /** Borderless UX: 3 lines (two full-width, one 75%). */ 
const $738473f8dd204ed0$var$skeletonLinesBorderless = [
    {
        width: '100%',
        height: $738473f8dd204ed0$var$SKELETON_HEIGHT_LINE
    },
    {
        width: '100%',
        height: $738473f8dd204ed0$var$SKELETON_HEIGHT_LINE
    },
    {
        width: '75%',
        height: $738473f8dd204ed0$var$SKELETON_HEIGHT_LINE
    }
];
function $738473f8dd204ed0$var$getSkeletonLines(isBorderlessUX) {
    return isBorderlessUX ? $738473f8dd204ed0$var$skeletonLinesBorderless : $738473f8dd204ed0$var$skeletonLinesStandard;
}
function $738473f8dd204ed0$export$950bbac928c95aa6({ heightOverride: heightOverride }) {
    const { commonAttributes: commonAttributes, queryReasoning: queryReasoning } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    const normalizeReasoningString = (str)=>{
        if (!str) return str;
        let result = `${str.charAt(0).toLowerCase()}${str.slice(1)}`; // Remove trailing period if it exists
        if (result.endsWith('.')) result = result.slice(0, -1);
        return result;
    };
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $kSORO.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: (0, $w6R6I.cx)($738473f8dd204ed0$var$styles.containerNewSAINLoading, heightOverride === 'jiraNlToJqlCard' && $738473f8dd204ed0$var$styles.jiraNlToJqlCardHeightOverride, heightOverride === 'jiraNlToJqlSmartlinkCard' && $738473f8dd204ed0$var$styles.jiraNlToJqlSmartlinkCardHeightOverride, heightOverride === 'navigationalCard' && $738473f8dd204ed0$var$styles.navigationalCardHeightOverride, heightOverride === 'lumina' && ((0, $iDrrr.fg)('kd_team_26_sain_borderless_update') || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled()) && $738473f8dd204ed0$var$styles.luminaOverride, !heightOverride && ((0, $iDrrr.fg)('kd_team_26_sain_borderless_update') || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled()) && $738473f8dd204ed0$var$styles.borderlessNoPadding, !heightOverride && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && $738473f8dd204ed0$var$styles.sourcesSidePanelOverride, heightOverride === 'lumina' && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && $738473f8dd204ed0$var$styles.luminaTallHeightOverride),
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: 'space.100',
        xcss: $738473f8dd204ed0$var$styles.inline,
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9LgVw))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: 'color.text.subtle'
    }, queryReasoning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $24oKg.messages).smart_answer_card_rovo_generating,
        values: {
            queryReasoning: normalizeReasoningString(queryReasoning)
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).smart_answer_card_rovo_is_thinking), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $738473f8dd204ed0$var$styles.inlineAnimation
    }, isReducedMotion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c75d50a61266072a$export$62d54f79d0abe5c8), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7qJqb.RovoGeneratingAnimation), null)))), $738473f8dd204ed0$var$getSkeletonLines((0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled()).map((line, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            key: index,
            width: line.width,
            height: line.height,
            color: "var(--ds-skeleton-subtle, #17171708)",
            borderRadius: $738473f8dd204ed0$var$SKELETON_BORDER_RADIUS
        })), heightOverride === 'lumina' && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "256px",
        height: "166px",
        color: "var(--ds-skeleton-subtle, #17171708)",
        borderRadius: $738473f8dd204ed0$var$SKELETON_BORDER_RADIUS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "256px",
        height: "166px",
        color: "var(--ds-skeleton-subtle, #17171708)",
        borderRadius: $738473f8dd204ed0$var$SKELETON_BORDER_RADIUS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "256px",
        height: "166px",
        color: "var(--ds-skeleton-subtle, #17171708)",
        borderRadius: $738473f8dd204ed0$var$SKELETON_BORDER_RADIUS
    })));
}
module.exports["SmartAnswerCardBodyGenerating"] = $738473f8dd204ed0$export$950bbac928c95aa6;

});

parcelRegister("jtIlq", function(module, exports) {
const $c84c1835c8e6cc3a$export$89dd6b6e370100a2 = (props)=>{
    const { answerString: answerString, brand: brand, query: query, queryHash: queryHash, searchSessionId: searchSessionId, source: source, targetMarker: targetMarker, answerCardType: answerCardType, location: location, isAuxClick: isAuxClick, isContextMenu: isContextMenu, queryLength: queryLength, wordCount: wordCount, queryIntent: queryIntent, jiraNlToJqlCardVariant: jiraNlToJqlCardVariant, elementInteracted: elementInteracted, imageCount: imageCount, imageIndex: imageIndex, imageSimilarity: imageSimilarity, imageMaxVisibleCount: imageMaxVisibleCount } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'knowledgeCardLink',
        source: source,
        eventType: 'track',
        attributes: {
            brand: brand,
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            targetMarker: targetMarker,
            location: location,
            answerCardType: answerCardType,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu,
            queryLength: queryLength,
            wordCount: wordCount,
            queryIntent: queryIntent,
            jiraNlToJqlCardVariant: jiraNlToJqlCardVariant,
            elementInteracted: elementInteracted,
            imageCount: imageCount,
            imageIndex: imageIndex,
            imageSimilarity: imageSimilarity,
            imageMaxVisibleCount: imageMaxVisibleCount
        },
        nonPrivacySafeAttributes: {
            answerString: answerString,
            query: query
        }
    };
};
module.exports["onNonGenerativeKnowledgeCardLinkClick"] = $c84c1835c8e6cc3a$export$89dd6b6e370100a2;

});

parcelRegister("dsm4u", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $fodiz = parcelRequire("fodiz");


var $i1t43 = parcelRequire("i1t43");


var $9iaFM = parcelRequire("9iaFM");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");


var $cFVPs = parcelRequire("cFVPs");


var $3hVWe = parcelRequire("3hVWe");


var $1mpi6 = parcelRequire("1mpi6");


var $bZMnB = parcelRequire("bZMnB");


var $eySxZ = parcelRequire("eySxZ");


var $8tNXq = parcelRequire("8tNXq");


var $kisaw = parcelRequire("kisaw");


var $zzZbq = parcelRequire("zzZbq");


var $aqqYN = parcelRequire("aqqYN");


var $1UlLI = parcelRequire("1UlLI");


var $jtIlq = parcelRequire("jtIlq");


var $9oghv = parcelRequire("9oghv");


var $kpjET = parcelRequire("kpjET");

/* separator-line.tsx generated by @compiled/babel-plugin v3.0.1 */ 



var $iMnC5 = parcelRequire("iMnC5");

const $05099f6c2a6daf9f$var$styles = {
    line: "_0jFU0VHZdu _39xV02N91d _0KLXrueZ10"
};
const $05099f6c2a6daf9f$export$8be205ba9c2e6f62 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $05099f6c2a6daf9f$var$styles.line
    });



var $i3wdq = parcelRequire("i3wdq");

const $04894e3a3b018384$var$messages = (0, $kSwu1.defineMessages)({
    topic_knowledge_card_why_tooltip: {
        id: "search_ai.topic_knowledge_card.why_tooltip",
        defaultMessage: "We think your search might be related to {topicName}"
    },
    topic_knowledge_card_people_heading: {
        id: "search_ai.topic_knowledge_card.people_heading",
        defaultMessage: "People"
    },
    topic_knowledge_card_people_view_all_cta: {
        id: "search_ai.topic_knowledge_card.people_view_all_cta",
        defaultMessage: "View all"
    }
});
const $04894e3a3b018384$export$559a249c395cc3e2 = ({ onFMPReached: onFMPReached })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString, brand: brand, cloudId: cloudId, query: query, searchSessionId: searchSessionId } = commonAttributes;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { tenantContext: { cloudUrl: cloudUrl } } = (0, $kisaw.useTenantContext)(cloudId);
    const analyticsAttributes = (0, $cozmU.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $9oghv.sha256Hash)(query),
            brand: brand,
            source: 'topic_knowledge_card',
            query: query,
            answerString: answerString,
            answerCardType: (0, $zzZbq.AnswerCardType).TOPIC
        }), [
        searchSessionId,
        query,
        brand,
        answerString
    ]);
    (0, $cozmU.useEffect)(()=>{
        onFMPReached?.();
        trackAIInteractionInit();
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $1mpi6.onNonGenerativeAIAnswerResultShown)(analyticsAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleTopicClick = ()=>{
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).TOPIC_KNOWLEDGE_CARD_CLICKED,
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $jtIlq.onNonGenerativeKnowledgeCardLinkClick)(analyticsAttributes));
    };
    const topicData = JSON.parse(answerString);
    const relatedUsers = topicData.users;
    const topicUrl = cloudUrl ? `${cloudUrl}/wiki/topics/${topicData.topic.id}` : '';
    const getUserUrl = (userId)=>{
        return cloudUrl ? `${cloudUrl}/wiki/people/${userId}` : '';
    };
    // if reached here, this means we query intent as topic
    // but topic query did not find topic for id returned by query intent
    if (topicData.topic.message) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i3wdq.KnowledgeCard), {
        name: "smart-answers-topic-knowledge-card",
        size: "full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: topicUrl,
        appearance: "subtle",
        onClick: handleTopicClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "large",
        color: "color.link",
        weight: "semibold"
    }, topicData.topic.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage($04894e3a3b018384$var$messages.topic_knowledge_card_why_tooltip, {
            topicName: topicData.topic.name
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "",
        size: "small",
        color: "var(--ds-text-subtlest, #6B6E76)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, topicData.topic.description), relatedUsers.nodes && relatedUsers.nodes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $05099f6c2a6daf9f$export$8be205ba9c2e6f62), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h6",
        size: "small"
    }, formatMessage($04894e3a3b018384$var$messages.topic_knowledge_card_people_heading)), relatedUsers.nodes.length > 4 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: topicUrl,
        appearance: "subtle",
        onClick: handleTopicClick,
        testId: "view-all-people-cta"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage($04894e3a3b018384$var$messages.topic_knowledge_card_people_view_all_cta)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.Grid), {
        templateColumns: "1fr 1fr",
        gap: "space.100"
    }, relatedUsers.nodes.slice(0, 4).map(({ user: user })=>user && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: getUserUrl(user.accountId),
            appearance: "subtle",
            key: user.id,
            testId: "topic-person-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aqqYN.KnowledgeCardsRow), {
            primaryText: user.name,
            secondaryText: user.extendedProfile?.jobTitle ?? '',
            pictureUrl: user.picture,
            type: (0, $1UlLI.KnowledgeCardsRowType).PERSON
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true
    })));
};
module.exports["TopicKnowledgeCard"] = $04894e3a3b018384$export$559a249c395cc3e2;

});

parcelRegister("1mpi6", function(module, exports) {
const $1f58c85daee7e042$export$5a7faebf1192b4e4 = ({ searchSessionId: searchSessionId, queryHash: queryHash, brand: brand, source: source, query: query, answerString: answerString, answerCardType: answerCardType, fmpLoadTime: fmpLoadTime, resourceType: resourceType, imageCount: imageCount, imageMaxVisibleCount: imageMaxVisibleCount, isHello: isHello })=>{
    return {
        action: 'shown',
        actionSubject: 'aiAnswerResult',
        source: source,
        eventType: 'track',
        attributes: {
            searchSessionId: searchSessionId,
            queryHash: queryHash,
            brand: brand,
            source: source,
            answerCardType: answerCardType,
            fmpLoadTime: fmpLoadTime,
            resourceType: resourceType,
            imageCount: imageCount,
            imageMaxVisibleCount: imageMaxVisibleCount,
            isHello: isHello
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
module.exports["onNonGenerativeAIAnswerResultShown"] = $1f58c85daee7e042$export$5a7faebf1192b4e4;

});

parcelRegister("i3wdq", function(module, exports) {
/* KnowledgeCard.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $a1L5E = parcelRequire("a1L5E");

const $6f4bbb71feeafa31$var$knowledgeCardStyles = {
    default: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    compact: "_0Of8r28HPE _1Znuxb8HPE _2Zuz6Q8HPE _1wydGW8HPE",
    full: "_0Of8r25zaO _1Znuxb5zaO _2Zuz6Q5zaO _1wydGW5zaO"
};
const $6f4bbb71feeafa31$var$defaultInlineProps = {
    alignBlock: 'center',
    grow: 'fill',
    space: 'space.050'
};
const $6f4bbb71feeafa31$export$ab2444a256fc8a9b = ({ name: name, size: size, children: children, containerStyles: containerStyles, ...inlineProps })=>{
    const knowledgeCardProps = {
        ...$6f4bbb71feeafa31$var$defaultInlineProps,
        ...inlineProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        ...knowledgeCardProps,
        xcss: containerStyles ?? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $w6R6I.cx)($6f4bbb71feeafa31$var$knowledgeCardStyles.default, size === 'full' ? $6f4bbb71feeafa31$var$knowledgeCardStyles.full : $6f4bbb71feeafa31$var$knowledgeCardStyles.compact)
    }, children)));
};
module.exports["KnowledgeCard"] = $6f4bbb71feeafa31$export$ab2444a256fc8a9b;

});

parcelRegister("jXQUy", function(module, exports) {

var $5hJlu = parcelRequire("5hJlu");

const $acdc855de2da24d5$export$8a4355009b280d8c = (cloudId)=>new (0, $5hJlu.default)({
        url: '/gateway/api/directory/graphql',
        productIdentifier: 'rovo',
        cloudId: cloudId
    });
module.exports["createProfileClient"] = $acdc855de2da24d5$export$8a4355009b280d8c;

});

parcelRegister("9T3jg", function(module, exports) {
var $5a727b0364f0f178$export$ba9062c439fa44bc = /*#__PURE__*/ function(KnowledgeCardsIntentType) {
    KnowledgeCardsIntentType["PERSON"] = "PERSON";
    KnowledgeCardsIntentType["TEAM"] = "TEAM";
    KnowledgeCardsIntentType["AGENT"] = "AGENT";
    KnowledgeCardsIntentType["VISUAL"] = "VISUAL";
    return KnowledgeCardsIntentType;
}({});
module.exports["KnowledgeCardsIntentType"] = $5a727b0364f0f178$export$ba9062c439fa44bc;

});

parcelRegister("3TiFP", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $06aa11e767251fd7$export$63a5aef02e499ea6 = (props)=>{
    const { source: source, location: location, position: position, shownAfterCardBodyExpanded: shownAfterCardBodyExpanded, isAuxClick: isAuxClick, isContextMenu: isContextMenu } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'knowledgeCardLink',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            location: location,
            position: position,
            shownAfterCardBodyExpanded: shownAfterCardBodyExpanded,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }
    };
};
module.exports["onKnowledgeCardLinkClick"] = $06aa11e767251fd7$export$63a5aef02e499ea6;

});

parcelRegister("jAV5L", function(module, exports) {

let $e43daa5e90402260$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e43daa5e90402260$var$load("Lm7SH"),
    $e43daa5e90402260$var$load("6wr18"),
    $e43daa5e90402260$var$load("aLwQm"),
    $e43daa5e90402260$var$load("7LDtT"),
    $e43daa5e90402260$var$load("Wowvf"),
    $e43daa5e90402260$var$load("hhss7"),
    $e43daa5e90402260$var$load("1FRba"),
    $e43daa5e90402260$var$load("4x9Jx"),
    $e43daa5e90402260$var$load("jL1Ke"),
    $e43daa5e90402260$var$load("5MQ0D"),
    $e43daa5e90402260$var$load("5He1y"),
    $e43daa5e90402260$var$load("ffEVr"),
    $e43daa5e90402260$var$load("6zCMk"),
    $e43daa5e90402260$var$load("8hP2l"),
    $e43daa5e90402260$var$load("1XtfK"),
    $e43daa5e90402260$var$load("k7QWO")
]).then(()=>parcelRequire('fqHdA'));

});

parcelRegister("66eSg", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hMCZS = parcelRequire("hMCZS");


var $9T3jg = parcelRequire("9T3jg");

const $39940d89fb6a2fb7$export$cf6047b656d24746 = (props)=>{
    const { cloudId: cloudId, currentUserId: currentUserId, viewAllUrl: viewAllUrl } = props;
    const backupViewAllUrl = `https://hello.atlassian.net/people/${currentUserId}/work`;
    const { href: profileWorkList, onNavigate: profileWorkListOnNavigate } = (0, $hMCZS.navigateToTeamsApp)(props.type === (0, $9T3jg.KnowledgeCardsIntentType).PERSON ? {
        type: 'USER_WORK',
        payload: {
            userId: currentUserId || ''
        },
        cloudId: cloudId
    } : {
        type: 'TEAM',
        payload: {
            teamId: props.teamId || ''
        },
        cloudId: cloudId
    });
    const { href: worksWithHref, onNavigate: worksWithOnNavigate } = (0, $hMCZS.navigateToTeamsApp)(props.type === (0, $9T3jg.KnowledgeCardsIntentType).PERSON ? {
        type: 'USER',
        payload: {
            userId: currentUserId || '',
            section: 'workswith'
        },
        cloudId: cloudId
    } : {
        type: 'TEAM',
        payload: {
            teamId: props.teamId || ''
        },
        cloudId: cloudId
    });
    const { href: profileHref, onNavigate: profileOnNavigate } = (0, $hMCZS.navigateToTeamsApp)(props.type === (0, $9T3jg.KnowledgeCardsIntentType).PERSON ? {
        type: 'USER',
        payload: {
            userId: currentUserId || ''
        },
        cloudId: cloudId
    } : {
        type: 'TEAM',
        payload: {
            teamId: props.teamId || ''
        },
        cloudId: cloudId
    });
    const toUser = (userId)=>(0, $hMCZS.navigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: userId
            },
            cloudId: cloudId
        });
    const viewAllLink = (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileWorkList : viewAllUrl || backupViewAllUrl;
    return {
        viewAllLink: viewAllLink,
        viewAllOnNavigate: profileWorkListOnNavigate,
        worksWithHref: worksWithHref,
        worksWithOnNavigate: worksWithOnNavigate,
        profileHref: profileHref,
        profileOnNavigate: profileOnNavigate,
        toUser: toUser
    };
};
module.exports["useTeamsAppLinks"] = $39940d89fb6a2fb7$export$cf6047b656d24746;

});

parcelRegister("hgyck", function(module, exports) {
/* knowledge-cards-topics.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $br26d = parcelRequire("br26d");

const $f27b52137a9c9645$var$styles = {
    root: ""
};
const $f27b52137a9c9645$export$71025593c3acaa9c = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $f27b52137a9c9645$var$styles.root
    }, /*#__PURE__*/ $cozmU.createElement((0, $br26d.AITopicsByPerson), props));
};
module.exports["KnowledgeCardsTopics"] = $f27b52137a9c9645$export$71025593c3acaa9c;

});

parcelRegister("hXc9i", function(module, exports) {
/* knowledge-badge.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $7ZB0A = parcelRequire("7ZB0A");


var $gznGh = parcelRequire("gznGh");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");

const $4e32f7a5738cba8e$var$styles = {
    knowledgeBadge: "_0bjKvDKxmn _2V7sgONvrM _3vBAKH9r67 _3hxITi6wH8 _3iDTPbccYA",
    buttonLink: "_0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX _2XsHFMFQfX _0adFHs1Y8M"
};
const $4e32f7a5738cba8e$export$7e867bde3d2da523 = ({ name: name, url: url, onBadgeClick: onBadgeClick = ()=>{} })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4e32f7a5738cba8e$var$styles.knowledgeBadge,
        backgroundColor: "color.background.input"
    }, /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
        href: url,
        appearance: "subtle",
        onClick: ()=>{
            onBadgeClick();
        },
        spacing: "none",
        target: "_blank"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        xcss: $4e32f7a5738cba8e$var$styles.buttonLink
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gznGh))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, name))));
module.exports["KnowledgeBadge"] = $4e32f7a5738cba8e$export$7e867bde3d2da523;

});

parcelRegister("fwt1L", function(module, exports) {
var $8e8ce1cfbf72b105$export$ee18e55fb2f84827 = /*#__PURE__*/ function(RelatedEntityType) {
    RelatedEntityType["KEY_PHRASE"] = "KEY_PHRASE";
    RelatedEntityType["TOPIC"] = "TOPIC";
    RelatedEntityType["USER"] = "USER";
    RelatedEntityType["CONFLUENCE_DOCUMENT"] = "CONFLUENCE_DOCUMENT";
    RelatedEntityType["CONFLUENCE_PAGE"] = "CONFLUENCE_PAGE";
    RelatedEntityType["CONFLUENCE_BLOGPOST"] = "CONFLUENCE_BLOGPOST";
    return RelatedEntityType;
}({});
module.exports["RelatedEntityType"] = $8e8ce1cfbf72b105$export$ee18e55fb2f84827;

});

parcelRegister("2i5Nf", function(module, exports) {

var $cuvLu = parcelRequire("cuvLu");

const $683e2b07cbdf088e$export$1e54b1f2535dc14e = (surfaceAttributes)=>{
    try {
        return {
            action: 'shown',
            actionSubjectId: 'aiTopic',
            actionSubject: 'surface',
            eventType: 'track',
            attributes: {
                ...surfaceAttributes
            }
        };
    } catch (error) {
        (0, $cuvLu.logger).error({
            error: error,
            functionName: 'onSurfaceShown'
        });
        return {};
    }
};
const $683e2b07cbdf088e$export$9eff5105a9d90d9e = (entityClickAttributes)=>{
    try {
        return {
            action: 'clicked',
            actionSubjectId: 'aiTopic',
            actionSubject: 'relatedEntity',
            eventType: 'ui',
            attributes: {
                ...entityClickAttributes
            }
        };
    } catch (error) {
        (0, $cuvLu.logger).error({
            error: error,
            functionName: 'onRelatedEntityClick'
        });
        return {};
    }
};
const $683e2b07cbdf088e$export$fbceb4fd6d209a9a = (showMoreRelatedEntitiesClickedAttributes)=>{
    return {
        action: 'clicked',
        actionSubjectId: 'aiTopic',
        actionSubject: 'toggleMoreRelatedEntities',
        eventType: 'ui',
        attributes: {
            ...showMoreRelatedEntitiesClickedAttributes
        }
    };
};
module.exports["onSurfaceShown"] = $683e2b07cbdf088e$export$1e54b1f2535dc14e;
module.exports["onRelatedEntityClick"] = $683e2b07cbdf088e$export$9eff5105a9d90d9e;
module.exports["onToggleMoreRelatedEntitiesClick"] = $683e2b07cbdf088e$export$fbceb4fd6d209a9a;

});

parcelRegister("agblG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f137acf5ce5ba150$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ai_topics_surface_header_user: {
        id: "search_ai.ai_topics.surface.header",
        defaultMessage: "Topics this person knows about"
    },
    ai_topics_surface_header_generic: {
        id: "search_ai.ai_topics.related_topics.header",
        defaultMessage: "Related topics"
    },
    ai_topics_surface_header_person: {
        id: "search_ai.ai_topics.surface.person_header",
        defaultMessage: "Topics {userName} knows about"
    },
    ai_topics_surface_header_beta_lozenge: {
        id: "search_ai.ai_topics.related_topics.header_beta_lozenge",
        defaultMessage: "BETA"
    },
    ai_topics_surface_footer_beta_lozenge: {
        id: "search_ai.ai_topics.related_topics.footer_beta_lozenge",
        defaultMessage: "BETA"
    },
    ai_topics_surface_footer_content_may_vary: {
        id: "search_ai.ai_topics.related_topics.footer_content_may_vary",
        defaultMessage: "Content quality may vary"
    },
    ai_topics_surface_footer_powered_by_ai: {
        id: "search_ai.ai_topics.related_topics.footer_powered_by_ai",
        defaultMessage: "Powered by AI"
    },
    ai_topics_user_feedback_prompt: {
        id: "search_ai.ai_topics.feedback.prompt.user",
        defaultMessage: "Are these topics correctly associated with this user?"
    },
    ai_topics_page_feedback_prompt: {
        id: "search_ai.ai_topics.feedback.prompt.page",
        defaultMessage: "Do these topics accurately reflect the contents of this page?"
    },
    ai_topics_page_feedback_button_text: {
        id: "search_ai.ai_topics.feedback.prompt.button",
        defaultMessage: "Submit feedback"
    },
    ai_topics_profile_feedback_text: {
        id: "search_ai.ai_topics.profile.prompt",
        defaultMessage: "Do these topics look accurate for this person?"
    },
    ai_topics_card_header_text: {
        id: "search_ai.ai_topics.card.header",
        defaultMessage: "Topics related to \"{searchQuery}\""
    },
    ai_topics_card_feedback_prompt: {
        id: "search_ai.ai_topics.card.feedback_prompt",
        defaultMessage: "Are these relevant to your search?"
    },
    ai_topics_rovo_branding_text: {
        id: "search_ai.ai_topics.rovo_branding_text",
        defaultMessage: "Rovo"
    },
    ai_topics_show_more_topics_text: {
        id: "search_ai.ai_topics.show_more_topics_text",
        defaultMessage: "Show more topics"
    },
    ai_topics_show_fewer_topics_text: {
        id: "search_ai.ai_topics.show_fewer_topics_text",
        defaultMessage: "Show fewer topics"
    }
});
module.exports["messages"] = $f137acf5ce5ba150$export$defe85febe8b728c;

});

parcelRegister("7EwcU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6JEx2 = parcelRequire("6JEx2");


var $gABt9 = parcelRequire("gABt9");


var $zzZbq = parcelRequire("zzZbq");

const $da7892fe0a7ba62e$export$da4042a87a471c60 = `
  query RelatedEntities(
    $entityId: String!
    $entityType: KnowledgeDiscoveryEntityType!
    $relatedEntityType: KnowledgeDiscoveryEntityType!
    $cloudId: String!
    $first: Int
    $after: String
  ) {
    knowledgeDiscovery {
      relatedEntities(
        entityId: $entityId
        entityType: $entityType
        relatedEntityType: $relatedEntityType
        cloudId: $cloudId
        first: $first
        after: $after
      ) @optIn(to: "KnowledgeDiscovery Get Related Entities") {
        ... on KnowledgeDiscoveryRelatedEntityConnection {
          __typename
          nodes {
            ... on KnowledgeDiscoveryTopic {
              id
              name
              description
              documentCount
              updatedAt
              type
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
        ... on QueryError {
          message
        }
      }
    }
  }
`;


const $b206aa7741ad2572$export$a6a63d73bee8e09d = (variables)=>{
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: (0, $da7892fe0a7ba62e$export$da4042a87a471c60),
                variables: variables
            })
        },
        queryParams: {
            q: 'RelatedEntities'
        }
    };
    return (0, $gABt9.utils).requestService({
        url: (0, $zzZbq.DEFAULT_GRAPHQL_ENDPOINT)
    }, options);
};


var $0f20332e4211008a$export$e11ed46440979a9c = /*#__PURE__*/ function(RelatedEntitiesResult) {
    RelatedEntitiesResult["KnowledgeDiscoveryRelatedEntityConnection"] = "KnowledgeDiscoveryRelatedEntityConnection";
    RelatedEntitiesResult["QueryError"] = "QueryError";
    return RelatedEntitiesResult;
}({});



var $fwt1L = parcelRequire("fwt1L");

const $254b85def434a166$export$b08faa9b0d12bdd8 = 'atlassian.search-dialog.ai-topics-component';
const $254b85def434a166$export$977fb96428acdf48 = ()=>{
    const [aiRelatedTopics, setAIRelatedTopics] = (0, $cozmU.useState)([]);
    const [error, setError] = (0, $cozmU.useState)('');
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const fetchRelatedTopics = async ({ entityId: entityId, cloudId: cloudId, principalEntityType: principalEntityType })=>{
        if (!entityId) {
            setAIRelatedTopics([]);
            return;
        }
        const cache = JSON.parse((0, $6JEx2.getSessionItem)($254b85def434a166$export$b08faa9b0d12bdd8) || '{}');
        if (cache?.entityId === entityId) setAIRelatedTopics(cache.topics);
        else {
            setAIRelatedTopics([]);
            (0, $6JEx2.deleteSessionItem)($254b85def434a166$export$b08faa9b0d12bdd8);
            setIsLoading(true);
            try {
                const { data: data } = await (0, $b206aa7741ad2572$export$a6a63d73bee8e09d)({
                    entityId: entityId,
                    entityType: principalEntityType,
                    relatedEntityType: (0, $fwt1L.RelatedEntityType).TOPIC,
                    cloudId: cloudId,
                    first: 5
                });
                if (data.knowledgeDiscovery.__typename === (0, $0f20332e4211008a$export$e11ed46440979a9c).QueryError) setError('REQUEST_ERROR');
                else if (data.knowledgeDiscovery.relatedEntities?.nodes) {
                    const entities = data.knowledgeDiscovery.relatedEntities.nodes;
                    setAIRelatedTopics(entities);
                    (0, $6JEx2.setSessionItem)($254b85def434a166$export$b08faa9b0d12bdd8, JSON.stringify({
                        entityId: entityId,
                        topics: entities
                    }));
                }
            } catch  {
                setError('NETWORK_ERROR');
            } finally{
                setIsLoading(false);
            }
        }
    };
    const resetTopics = (0, $cozmU.useCallback)(()=>{
        setAIRelatedTopics([]);
    }, [
        setAIRelatedTopics
    ]);
    const showTopics = !isLoading && !error && aiRelatedTopics.length > 0;
    return {
        aiRelatedTopics: aiRelatedTopics,
        fetchRelatedTopics: fetchRelatedTopics,
        showTopics: showTopics,
        resetTopics: resetTopics
    };
};
module.exports["useRelatedTopics"] = $254b85def434a166$export$977fb96428acdf48;

});

parcelRegister("jDZkE", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");

async function $a6477302ddfc174b$export$ebe243ab960e089b({ url: url, body: body }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        }
    };
    return (0, $gABt9.utils).requestService({
        url: url
    }, options);
}
module.exports["fetchRestResponse"] = $a6477302ddfc174b$export$ebe243ab960e089b;

});

parcelRegister("8cQty", function(module, exports) {

let $5f98264cc0a82491$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f98264cc0a82491$var$load("cqTuN").then(()=>parcelRequire('5X7NK'));

});

parcelRegister("7Ktzp", function(module, exports) {

let $5a43c44540ae9f28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a43c44540ae9f28$var$load("5HcXV").then(()=>parcelRequire('iqm7a'));

});

parcelRegister("3OvSI", function(module, exports) {

let $2c6ec59c27646bf7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c6ec59c27646bf7$var$load("dy4Zx").then(()=>parcelRequire('16e2H'));

});

parcelRegister("3KmhA", function(module, exports) {

let $2ba6f3d2a25215de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2ba6f3d2a25215de$var$load("17hGM").then(()=>parcelRequire('JVRDQ'));

});

parcelRegister("1AEVX", function(module, exports) {

let $1288e7dbed343dc7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1288e7dbed343dc7$var$load("7ZfPc").then(()=>parcelRequire('aZy6m'));

});

parcelRegister("gQR0I", function(module, exports) {

let $c44a9f7a8414e316$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c44a9f7a8414e316$var$load("23syh").then(()=>parcelRequire('hEaEz'));

});

parcelRegister("fZZNg", function(module, exports) {

let $ba5c7c74ba8b8e9e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba5c7c74ba8b8e9e$var$load("3pbEP").then(()=>parcelRequire('a4GAP'));

});

parcelRegister("85e4s", function(module, exports) {

let $5e29b48ac9db1c06$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e29b48ac9db1c06$var$load("6O1JJ").then(()=>parcelRequire('jej7M'));

});

parcelRegister("5aiwI", function(module, exports) {

let $3c2c41f3ce57d161$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c2c41f3ce57d161$var$load("lewFW").then(()=>parcelRequire('3BrK1'));

});

parcelRegister("d0yG9", function(module, exports) {

let $97862cf403be8595$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $97862cf403be8595$var$load("7mRqV").then(()=>parcelRequire('httqX'));

});

parcelRegister("566HE", function(module, exports) {

let $3b62b659daa3372f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3b62b659daa3372f$var$load("5ix7K").then(()=>parcelRequire('6j35k'));

});

parcelRegister("7hJxV", function(module, exports) {

let $54dd737884576733$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $54dd737884576733$var$load("lU5wW").then(()=>parcelRequire('dvlvz'));

});

parcelRegister("8Yv6U", function(module, exports) {

let $688c0f31371a9310$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $688c0f31371a9310$var$load("16eo8").then(()=>parcelRequire('bwrHA'));

});

parcelRegister("6KeUd", function(module, exports) {

let $4e9299ec0eb2e4d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e9299ec0eb2e4d7$var$load("5njHu").then(()=>parcelRequire('2ulWo'));

});

parcelRegister("Xhn9f", function(module, exports) {

let $0b22fc974e85e594$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0b22fc974e85e594$var$load("kAWge").then(()=>parcelRequire('jCOw3'));

});

parcelRegister("lKGOU", function(module, exports) {

let $fd5f1c073ca9943e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd5f1c073ca9943e$var$load("fijpJ").then(()=>parcelRequire('2fJ4d'));

});

parcelRegister("51a3b", function(module, exports) {

let $3a74d788b3412ed6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a74d788b3412ed6$var$load("d7K0J").then(()=>parcelRequire('84muJ'));

});

parcelRegister("drfHK", function(module, exports) {

let $9c89fa9851663521$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c89fa9851663521$var$load("2gJYs").then(()=>parcelRequire('9rn6b'));

});

parcelRegister("i8A0w", function(module, exports) {

let $d344e7aa42fbc21b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d344e7aa42fbc21b$var$load("cQNNu").then(()=>parcelRequire('6DxsI'));

});

parcelRegister("bYxqJ", function(module, exports) {

let $8b7f3ad77d984ad0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b7f3ad77d984ad0$var$load("dAZOq").then(()=>parcelRequire('iS2kL'));

});

parcelRegister("fMBja", function(module, exports) {

let $b7d84754a9bc59e2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b7d84754a9bc59e2$var$load("dUypO").then(()=>parcelRequire('dhB8X'));

});

parcelRegister("lFCIm", function(module, exports) {

let $fc6b752d4410b7ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fc6b752d4410b7ae$var$load("aFsqY").then(()=>parcelRequire('cGRC5'));

});

parcelRegister("3OZQe", function(module, exports) {

let $2c86030be33d1bb4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c86030be33d1bb4$var$load("bwfbG").then(()=>parcelRequire('72Yep'));

});

parcelRegister("iytmX", function(module, exports) {

let $037c6c1d3ad04744$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $037c6c1d3ad04744$var$load("a5an6").then(()=>parcelRequire('g9LLU'));

});

parcelRegister("1sS5a", function(module, exports) {

let $11125b997b08e39e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11125b997b08e39e$var$load("chC7H").then(()=>parcelRequire('3v3Ps'));

});

parcelRegister("039lM", function(module, exports) {

let $009788aec3eac91a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $009788aec3eac91a$var$load("gZI2F").then(()=>parcelRequire('61k6M'));

});

parcelRegister("dmWtJ", function(module, exports) {
/* icon-stack.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $f863157e85a6bcec$var$styles = {
    list: "_3iDTPbQ4SZ _2YgrGrP0S5 _0rIjykPgdg _43nrzTPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
    item: "_0rIjykPgdg _43nrzTPgdg _0GTcwRPgdg"
}; // Icon rotations for the shuffled/notebook look — keyed by index.
// Matches the ICON_ROTATIONS map used in the Rovo chat button (SourceButtonIcons):
// index 1 → -6deg, index 3 → 8deg, all others → no rotation.
const $f863157e85a6bcec$var$ICON_ROTATIONS = {
    1: -6,
    3: 8
};
const $f863157e85a6bcec$var$unboundStyles = {
    list: "_0aNu0LYbGa _2xTnZxHZdu",
    listEditorOverrides: "_2Zuz6QAASz",
    item: "_0bjKvDKxmn _0KLXrulfZc _2OUyjtcDWF _3iDTPbccYA _2xTnZxA17z"
};
const $f863157e85a6bcec$var$DEFAULT_MAX_STACK_SIZE = 3;
function $f863157e85a6bcec$export$1483abeb36a40e41({ children: children, maxStackSize: maxStackSize, testId: testId, addEditorStyleOverrides: addEditorStyleOverrides, shuffled: shuffled = false }) {
    maxStackSize = maxStackSize ?? $f863157e85a6bcec$var$DEFAULT_MAX_STACK_SIZE;
    return /*#__PURE__*/ $cozmU.createElement("ul", {
        "aria-hidden": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $f863157e85a6bcec$var$styles.list,
            $f863157e85a6bcec$var$unboundStyles.list,
            addEditorStyleOverrides && $f863157e85a6bcec$var$unboundStyles.listEditorOverrides
        ])
    }, (0, $cozmU.Children).map(children, (child, index)=>child && /*#__PURE__*/ $cozmU.createElement("li", {
            style: {
                zIndex: shuffled ? index + 1 : maxStackSize - index,
                transform: shuffled && $f863157e85a6bcec$var$ICON_ROTATIONS[index] !== undefined ? `rotate(${$f863157e85a6bcec$var$ICON_ROTATIONS[index]}deg)` : undefined
            },
            className: (0, $hekY6.default)([
                $f863157e85a6bcec$var$styles.item,
                $f863157e85a6bcec$var$unboundStyles.item
            ])
        }, child)));
}
module.exports["IconStack"] = $f863157e85a6bcec$export$1483abeb36a40e41;

});

parcelRegister("j8bJ5", function(module, exports) {
/* open-chat-input-box.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $f6cdQ = parcelRequire("f6cdQ");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $hdBxM = parcelRequire("hdBxM");


var $e3Wrf = parcelRequire("e3Wrf");


var $3hVWe = parcelRequire("3hVWe");


var $dDQsD = parcelRequire("dDQsD");


var $4Tg3t = parcelRequire("4Tg3t");

const $570f2b736386676c$export$ff46c9751614b747 = ({ chatInputQuery: chatInputQuery, ...props })=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerSendChatInput',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            chatInputQuery: chatInputQuery
        }
    };
};



var $bZMnB = parcelRequire("bZMnB");


var $eySxZ = parcelRequire("eySxZ");


var $8tNXq = parcelRequire("8tNXq");


var $7DMz5 = parcelRequire("7DMz5");


var $9LgVw = parcelRequire("9LgVw");


var $5OgwG = parcelRequire("5OgwG");

const $1778ab1934d48668$var$styles = {
    wrapper: "_23rrnHCu3Z _39xV02N91d _42Yu6BN779 _24h04i2Njc",
    wrapperShownStyles: "_3iDTPbvLZJ _1YKVNs7dHp",
    wrapperHiddenStyles: "_3iDTPbYbGa _1YKVNsdnbC",
    root: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _39xV02N91d _0Of8r28HPE _2Zuz6Q5zaO _1Znuxb5zaO _1wydGW8HPE _0KLXrunmFW _24h04i2Njc",
    inputIconButtonWrapperStyles: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _42Yu6BbFo4",
    enhancedRoot: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _23rrnHCu3Z _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _39xV02N91d _42Yu6BN779 _0Of8r25zaO _2Zuz6Q5zaO _1Znuxb5zaO _1wydGW8HPE _0KLXrulfZc _24h04i2Njc _1mT5xdRAKS",
    sendButtonOverlay: "_1mT5xdWVPG _0Bm75G8HPE _4ApkO28HPE"
};
const $1778ab1934d48668$export$ca627f6f5c214661 = ({ query: queryProp, searchSessionId: searchSessionIdProp, isVisible: isVisible, source: source = 'sain', commonAttributes: commonAttributesProp, onVisibilityChange: onVisibilityChange, title: title, onHideTransitionEnd: onHideTransitionEnd } = {})=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const [showOpenChatInput, setShowOpenChatInput] = (0, $cozmU.useState)(true);
    const [inputValue, setInputValue] = (0, $cozmU.useState)('');
    const { commonAttributes: contextCommonAttributes, showChatFollowUps: showChatFollowUps } = (0, $3hVWe.useAIAnswerContext)();
    const commonAttributes = commonAttributesProp ?? contextCommonAttributes;
    const query = queryProp ?? commonAttributes.query;
    const searchSessionId = searchSessionIdProp ?? commonAttributes.searchSessionId;
    const { answerString: answerString } = commonAttributes; // Only apply the improved SAIN layout when source is 'sain' — the FPS entry
    // point (fps-open-chat-input-box) reuses this component and must keep its
    // own appearance regardless of the gate state.
    const isImprovedChatOptionsEnabled = source === 'sain' && (0, $7DMz5.SAINFeatureControl).isImprovedChatOptionsEnabled();
    const shouldRender = isVisible ?? showChatFollowUps;
    const isSendDisabled = !inputValue.trim();
    const fireSendAnalytics = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $570f2b736386676c$export$ff46c9751614b747)({
            chatInputQuery: inputValue,
            ...commonAttributes
        }));
        fireAnalyticsEvent((0, $dDQsD.onOpenChatButtonClick)({
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).OPEN_CHAT_CLICKED,
            commonAttributes: commonAttributes
        });
    }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        inputValue,
        commonAttributes
    ]);
    const handleKeyDown = (event)=>{
        if (inputValue.trim() && event.key === 'Enter') {
            event.preventDefault();
            fireSendAnalytics();
            sendToChat();
        }
    };
    const sendToChat = (0, $cozmU.useCallback)(()=>{
        // Carry the prior turn (and seed the chat name) only when there is a
        // SAIN answer to forward. This keeps the box future-proof: when no
        // answer is present (e.g. FPS results today) the user lands in a clean
        // new chat with only what they typed, and once an answer is available
        // the host simply passes `query` + `answerString` to carry the context
        // — no change needed here.
        const hasAnswerToCarry = Boolean(query && answerString);
        publish({
            type: 'chat-new',
            source: source,
            data: {
                ...hasAnswerToCarry ? {
                    name: query.substring(0, 30)
                } : {},
                dialogues: hasAnswerToCarry ? [
                    {
                        human_message: {
                            content: query
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ] : [],
                prompt: inputValue,
                sourceId: searchSessionId
            }
        });
        setShowOpenChatInput(false); // Notify the host at the point the box hides itself (after a prompt is
        // submitted), so sibling chrome (e.g. a title rendered above the box by
        // the host) can hide together with it. We deliberately don't emit an
        // initial `true` on mount — hosts own the box's starting visibility.
        onVisibilityChange?.(false);
    }, [
        inputValue,
        query,
        searchSessionId,
        publish,
        answerString,
        source,
        onVisibilityChange
    ]);
    const handleButtonClick = (0, $cozmU.useCallback)(()=>{
        fireSendAnalytics();
        sendToChat();
    }, [
        fireSendAnalytics,
        sendToChat
    ]);
    const handleTransitionEnd = (0, $cozmU.useCallback)((event)=>{
        // Fire only when the box's own fade-out (opacity) finishes after it has hidden itself
        if (!showOpenChatInput && event.propertyName === 'opacity' && event.target === event.currentTarget) onHideTransitionEnd?.();
    }, [
        showOpenChatInput,
        onHideTransitionEnd
    ]);
    if (!shouldRender) return null;
    if (isImprovedChatOptionsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($1778ab1934d48668$var$styles.enhancedRoot, showOpenChatInput ? $1778ab1934d48668$var$styles.wrapperShownStyles : $1778ab1934d48668$var$styles.wrapperHiddenStyles),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
        style: {
            boxShadow: '0 -2px 50px 8px rgba(30, 31, 33, 0.08)'
        },
        onTransitionEnd: handleTransitionEnd
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        "aria-label": formatMessage((0, $5OgwG.messages).ai_answer_open_chat_input_box_ask_rovo),
        placeholder: formatMessage((0, $5OgwG.messages).ai_answer_open_chat_input_box_ask_rovo),
        value: inputValue,
        onChange: (e)=>setInputValue(e.target.value),
        onKeyDown: handleKeyDown,
        appearance: "none",
        minimumRows: 2,
        testId: "lumina-input-to-chat-text-area"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1778ab1934d48668$var$styles.sendButtonOverlay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "primary",
        isDisabled: isSendDisabled,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))),
        label: formatMessage((0, $5OgwG.messages).ai_answer_open_chat_input_box_send_query),
        onClick: handleButtonClick,
        testId: "lumina-input-to-chat-submit"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($1778ab1934d48668$var$styles.wrapper, showOpenChatInput ? $1778ab1934d48668$var$styles.wrapperShownStyles : $1778ab1934d48668$var$styles.wrapperHiddenStyles),
        onTransitionEnd: handleTransitionEnd
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "large",
        weight: "medium"
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1778ab1934d48668$var$styles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1778ab1934d48668$var$styles.inputIconButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9LgVw))),
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        placeholder: formatMessage((0, $5OgwG.messages).ai_answer_open_chat_input_box_ask_rovo),
        value: inputValue,
        onChange: (e)=>setInputValue(e.target.value),
        onKeyDown: handleKeyDown,
        appearance: "none",
        minimumRows: 1,
        style: {
            paddingTop: '9px'
        },
        testId: "lumina-input-to-chat-text-area"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1778ab1934d48668$var$styles.inputIconButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "primary",
        isDisabled: isSendDisabled,
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))),
        label: formatMessage((0, $5OgwG.messages).ai_answer_open_chat_input_box_send_query),
        onClick: handleButtonClick,
        testId: "lumina-input-to-chat-submit"
    }))))));
};
module.exports["OpenChatInputBox"] = $1778ab1934d48668$export$ca627f6f5c214661;

});

parcelRegister("k8nNQ", function(module, exports) {

let $ea8704cc1947e622$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ea8704cc1947e622$var$load("dfnmm"),
    $ea8704cc1947e622$var$load("jgFQ5"),
    $ea8704cc1947e622$var$load("1YU2Y"),
    $ea8704cc1947e622$var$load("4GjU8"),
    $ea8704cc1947e622$var$load("6fJCf"),
    $ea8704cc1947e622$var$load("duEFL"),
    $ea8704cc1947e622$var$load("1pJPT"),
    $ea8704cc1947e622$var$load("7EorR"),
    $ea8704cc1947e622$var$load("cvcNg"),
    $ea8704cc1947e622$var$load("iZR3N"),
    $ea8704cc1947e622$var$load("4zz48"),
    $ea8704cc1947e622$var$load("jXM1T"),
    $ea8704cc1947e622$var$load("39XCn"),
    $ea8704cc1947e622$var$load("jw3lv"),
    $ea8704cc1947e622$var$load("7rqWx"),
    $ea8704cc1947e622$var$load("aIze1"),
    $ea8704cc1947e622$var$load("3Cky6"),
    $ea8704cc1947e622$var$load("kG5Ju"),
    $ea8704cc1947e622$var$load("il8bj"),
    $ea8704cc1947e622$var$load("4N1MY"),
    $ea8704cc1947e622$var$load("6wr18"),
    $ea8704cc1947e622$var$load("aFLSJ"),
    $ea8704cc1947e622$var$load("ffEVr"),
    $ea8704cc1947e622$var$load("6bjEk"),
    $ea8704cc1947e622$var$load("hVFIb")
]).then(()=>parcelRequire('eWlk7'));

});

parcelRegister("7ydRw", function(module, exports) {

let $57f67623fbf2f524$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $57f67623fbf2f524$var$load("kbtA5").then(()=>parcelRequire('lndDI'));

});

parcelRegister("2vPXD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gABt9 = parcelRequire("gABt9");

async function $cafae28ddf3d73b8$var$fetchRestResponse({ url: url, body: body }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        }
    };
    return (0, $gABt9.utils).requestService({
        url: url
    }, options);
}
const $cafae28ddf3d73b8$var$OBJECT_RESOLVER_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $cafae28ddf3d73b8$export$ce7efc011dbfc5b9 = ({ urls: urls })=>{
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [objectResolverData, setObjectResolverData] = (0, $cozmU.useState)([]);
    const urlKeys = (0, $cozmU.useMemo)(()=>urls.join('|'), [
        urls
    ]);
    (0, $cozmU.useEffect)(()=>{
        const fetchObjectResolver = async ()=>{
            if (!urls.length) {
                setIsLoading(false);
                return;
            }
            try {
                setIsLoading(true);
                const objectResolver = await $cafae28ddf3d73b8$var$fetchRestResponse({
                    url: $cafae28ddf3d73b8$var$OBJECT_RESOLVER_ENDPOINT,
                    body: urls.map((url)=>({
                            resourceUrl: url
                        }))
                });
                if (!objectResolver) {
                    setIsLoading(false);
                    return;
                }
                const objectData = objectResolver.filter((obj)=>obj.status === 200);
                setObjectResolverData(objectData.map((objData)=>objData.body.data));
                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);
            }
        };
        fetchObjectResolver();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        urlKeys
    ]);
    return {
        isLoading: isLoading,
        objectResolverData: objectResolverData
    };
};
module.exports["useFetchSmartLinkData"] = $cafae28ddf3d73b8$export$ce7efc011dbfc5b9;

});

parcelRegister("kYeKA", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iHsYL = parcelRequire("iHsYL");

var $e52c82032f5b8894$exports = {};
$e52c82032f5b8894$exports = JSON.parse("{\"v\":\"5.9.0\",\"fr\":29.9700012207031,\"ip\":0,\"op\":95.0000038694293,\"w\":1920,\"h\":1080,\"nm\":\"Comp 1\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"Shape Layer 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[502.345,0,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"mn\":\"ADBE Gaussian Blur 2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":50.4,\"ix\":1}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"mn\":\"ADBE Gaussian Blur 2-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":1,\"ix\":2}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"mn\":\"ADBE Gaussian Blur 2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}}]},{\"ty\":5,\"nm\":\"Levels\",\"np\":11,\"mn\":\"ADBE Easy Levels2\",\"ix\":2,\"en\":1,\"ef\":[{\"ty\":7,\"nm\":\"Channel:\",\"mn\":\"ADBE Easy Levels2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":1,\"ix\":1}},{},{\"ty\":0,\"nm\":\"Input Black\",\"mn\":\"ADBE Easy Levels2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}},{\"ty\":0,\"nm\":\"Input White\",\"mn\":\"ADBE Easy Levels2-0004\",\"ix\":4,\"v\":{\"a\":0,\"k\":1,\"ix\":4}},{\"ty\":0,\"nm\":\"Gamma\",\"mn\":\"ADBE Easy Levels2-0005\",\"ix\":5,\"v\":{\"a\":0,\"k\":1,\"ix\":5}},{\"ty\":0,\"nm\":\"Output Black\",\"mn\":\"ADBE Easy Levels2-0006\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Output White\",\"mn\":\"ADBE Easy Levels2-0007\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}},{\"ty\":7,\"nm\":\"Clip To Output Black\",\"mn\":\"ADBE Easy Levels2-0008\",\"ix\":8,\"v\":{\"a\":0,\"k\":3,\"ix\":8}},{\"ty\":7,\"nm\":\"Clip To Output White\",\"mn\":\"ADBE Easy Levels2-0009\",\"ix\":9,\"v\":{\"a\":0,\"k\":3,\"ix\":9}}]},{\"ty\":5,\"nm\":\"CC Radial Fast Blur\",\"np\":5,\"mn\":\"CC Radial Fast Blur\",\"ix\":3,\"en\":1,\"ef\":[{\"ty\":3,\"nm\":\"Center\",\"mn\":\"CC Radial Fast Blur-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":[960,540],\"ix\":1}},{\"ty\":0,\"nm\":\"Amount\",\"mn\":\"CC Radial Fast Blur-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":51,\"ix\":2}},{\"ty\":7,\"nm\":\"Zoom\",\"mn\":\"CC Radial Fast Blur-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":1,\"ix\":3}}]}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":2,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[317.555,317.555],\"ix\":2},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":50.479,\"s\":[1486.1,615.223],\"to\":[0,0],\"ti\":[0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":63,\"s\":[1486.1,400],\"to\":[0,0],\"ti\":[0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":72.74,\"s\":[1486.1,575.917],\"to\":[0,0],\"ti\":[0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":79,\"s\":[1486.1,528.917],\"to\":[0,0],\"ti\":[0,0]},{\"t\":82.0000033399285,\"s\":[1486.1,615.223]}],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"gf\",\"o\":{\"a\":0,\"k\":100,\"ix\":10},\"r\":1,\"bm\":0,\"g\":{\"p\":3,\"k\":{\"a\":0,\"k\":[0,0.594,0.384,0.713,0.461,0.777,0.645,0.66,1,0.961,0.906,0.607],\"ix\":9}},\"s\":{\"a\":0,\"k\":[1244.484,582.344],\"ix\":5},\"e\":{\"a\":0,\"k\":[1727.031,624.016],\"ix\":6},\"t\":1,\"nm\":\"Gradient Fill 1\",\"mn\":\"ADBE Vector Graphic - G-Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-497.223,10],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"Shape Layer 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":20.479,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0.076},\"t\":21,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":33,\"s\":[1486.1,400,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":42.74,\"s\":[1486.1,575.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":49,\"s\":[1486.1,528.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":52.0000021180034,\"s\":[1486.1,615.223,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"mn\":\"ADBE Gaussian Blur 2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":50.7,\"ix\":1}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"mn\":\"ADBE Gaussian Blur 2-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":1,\"ix\":2}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"mn\":\"ADBE Gaussian Blur 2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}}]},{\"ty\":5,\"nm\":\"Levels\",\"np\":11,\"mn\":\"ADBE Easy Levels2\",\"ix\":2,\"en\":1,\"ef\":[{\"ty\":7,\"nm\":\"Channel:\",\"mn\":\"ADBE Easy Levels2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":1,\"ix\":1}},{},{\"ty\":0,\"nm\":\"Alpha Input Black\",\"mn\":\"ADBE Easy Levels2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}},{\"ty\":0,\"nm\":\"Alpha Input White\",\"mn\":\"ADBE Easy Levels2-0004\",\"ix\":4,\"v\":{\"a\":0,\"k\":1,\"ix\":4}},{\"ty\":0,\"nm\":\"Alpha Gamma\",\"mn\":\"ADBE Easy Levels2-0005\",\"ix\":5,\"v\":{\"a\":0,\"k\":1,\"ix\":5}},{\"ty\":0,\"nm\":\"Alpha Output Black\",\"mn\":\"ADBE Easy Levels2-0006\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Alpha Output White\",\"mn\":\"ADBE Easy Levels2-0007\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}},{\"ty\":7,\"nm\":\"Clip To Output Black\",\"mn\":\"ADBE Easy Levels2-0008\",\"ix\":8,\"v\":{\"a\":0,\"k\":3,\"ix\":8}},{\"ty\":7,\"nm\":\"Clip To Output White\",\"mn\":\"ADBE Easy Levels2-0009\",\"ix\":9,\"v\":{\"a\":0,\"k\":3,\"ix\":9}}]},{\"ty\":5,\"nm\":\"CC Radial Fast Blur\",\"np\":5,\"mn\":\"CC Radial Fast Blur\",\"ix\":3,\"en\":1,\"ef\":[{\"ty\":3,\"nm\":\"Center\",\"mn\":\"CC Radial Fast Blur-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":[960,540],\"ix\":1}},{\"ty\":0,\"nm\":\"Amount\",\"mn\":\"CC Radial Fast Blur-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":51,\"ix\":2}},{\"ty\":7,\"nm\":\"Zoom\",\"mn\":\"CC Radial Fast Blur-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":1,\"ix\":3}}]}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[317.555,317.555],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.749019607843,0.388235294118,0.952941176471,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-497.223,10],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"Shape Layer 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[2454.1,1191.14,0],\"ix\":2,\"l\":2},\"a\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":1,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":8,\"s\":[1486.1,784.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":15,\"s\":[1486.1,575.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.333,\"y\":0},\"t\":21.441,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":24.00000097754,\"s\":[1486.1,575.917,0]}],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"mn\":\"ADBE Gaussian Blur 2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":46.3,\"ix\":1}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"mn\":\"ADBE Gaussian Blur 2-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":1,\"ix\":2}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"mn\":\"ADBE Gaussian Blur 2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}}]},{\"ty\":5,\"nm\":\"Levels\",\"np\":11,\"mn\":\"ADBE Easy Levels2\",\"ix\":2,\"en\":1,\"ef\":[{\"ty\":7,\"nm\":\"Channel:\",\"mn\":\"ADBE Easy Levels2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":1,\"ix\":1}},{},{\"ty\":0,\"nm\":\"Alpha Input Black\",\"mn\":\"ADBE Easy Levels2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}},{\"ty\":0,\"nm\":\"Alpha Input White\",\"mn\":\"ADBE Easy Levels2-0004\",\"ix\":4,\"v\":{\"a\":0,\"k\":1,\"ix\":4}},{\"ty\":0,\"nm\":\"Alpha Gamma\",\"mn\":\"ADBE Easy Levels2-0005\",\"ix\":5,\"v\":{\"a\":0,\"k\":1,\"ix\":5}},{\"ty\":0,\"nm\":\"Alpha Output Black\",\"mn\":\"ADBE Easy Levels2-0006\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Alpha Output White\",\"mn\":\"ADBE Easy Levels2-0007\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}},{\"ty\":7,\"nm\":\"Clip To Output Black\",\"mn\":\"ADBE Easy Levels2-0008\",\"ix\":8,\"v\":{\"a\":0,\"k\":3,\"ix\":8}},{\"ty\":7,\"nm\":\"Clip To Output White\",\"mn\":\"ADBE Easy Levels2-0009\",\"ix\":9,\"v\":{\"a\":0,\"k\":3,\"ix\":9}}]},{\"ty\":5,\"nm\":\"CC Radial Fast Blur\",\"np\":5,\"mn\":\"CC Radial Fast Blur\",\"ix\":3,\"en\":1,\"ef\":[{\"ty\":3,\"nm\":\"Center\",\"mn\":\"CC Radial Fast Blur-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":[960,540],\"ix\":1}},{\"ty\":0,\"nm\":\"Amount\",\"mn\":\"CC Radial Fast Blur-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":50,\"ix\":2}},{\"ty\":7,\"nm\":\"Zoom\",\"mn\":\"CC Radial Fast Blur-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":1,\"ix\":3}}]}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[317.555,317.555],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"gf\",\"o\":{\"a\":0,\"k\":100,\"ix\":10},\"r\":1,\"bm\":0,\"g\":{\"p\":3,\"k\":{\"a\":0,\"k\":[0,0,0.396,1,0.724,0.182,0.396,1,1,0.364,0.396,1],\"ix\":9}},\"s\":{\"a\":0,\"k\":[0,0],\"ix\":5},\"e\":{\"a\":0,\"k\":[100,0],\"ix\":6},\"t\":1,\"nm\":\"Gradient Fill 1\",\"mn\":\"ADBE Vector Graphic - G-Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-497.223,10],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}],\"markers\":[]}");


const $8ca28c87450183a6$var$loadingAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: (0, (/*@__PURE__*/$parcel$interopDefault($e52c82032f5b8894$exports))),
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};
const $8ca28c87450183a6$var$loadingAnimationStyles = null;
const $8ca28c87450183a6$var$jiraOverrideStyles = null;
const $8ca28c87450183a6$export$1110722318fbbc6b = ({ onAnimationShown: onAnimationShown, source: source })=>{
    (0, $cozmU.useEffect)(()=>{
        onAnimationShown?.(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iHsYL)) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored because an external consumer needs to override the style with styled component. https://atlassian.slack.com/archives/C06K9T53N66/p1745962052140289?thread_ts=1745868665.350719&cid=C06K9T53N66
    ), {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhToncF0J _3OE6xYODnY _39xV02HMkp _0jFU0Vey7F _1VJPcasUvU",
            source === 'jira-highlight-actions' && "_2IhTonF3IB _3OE6xY8ija",
            "dot-animation-loader"
        ]),
        ...$8ca28c87450183a6$var$loadingAnimationOptions
    });
};
module.exports["DotAnimationLoader"] = $8ca28c87450183a6$export$1110722318fbbc6b;

});

parcelRegister("h0U7J", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

/**
 * Derives non-UGC authority attributes from the authoritative-answer metadata so
 * they can be attached to the existing aiAnswerResult shown event. Only counts,
 * booleans, and the coarse authority level/confidence are emitted — never source
 * titles, expert names, URLs, or reasoning text.
 */ const $f09050a325aeee13$var$getAuthorityAttributes = (authorityUiMetadata)=>{
    if (!authorityUiMetadata) return {
        hasAuthoritativeSources: false
    };
    return {
        hasAuthoritativeSources: true,
        authorityLevel: authorityUiMetadata.authorityLevel,
        isHighlyAuthoritative: authorityUiMetadata.isHighlyAuthoritative ?? authorityUiMetadata.highlyAuthoritative ?? false,
        overallConfidence: authorityUiMetadata.overallConfidence,
        authoritativeSourceCount: authorityUiMetadata.sources?.length ?? 0,
        authoritativeExpertCount: authorityUiMetadata.domainExperts?.length ?? 0
    };
};
const $f09050a325aeee13$export$bc6497c5d340e00a = ({ isStreamed: isStreamed, loadTime: loadTime, fmpLoadTime: fmpLoadTime, experimentLayers: experimentLayers, blueLinkCount: blueLinkCount, authorityUiMetadata: authorityUiMetadata, ...props })=>{
    const { query: query, answerString: answerString, source: source, cloudId: cloudId } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerResult',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            cloudId: cloudId,
            isStreamed: isStreamed,
            loadTime: loadTime,
            fmpLoadTime: fmpLoadTime,
            blueLinkCount: blueLinkCount,
            ...experimentLayers && {
                backendExperiments: {
                    experimentLayers: experimentLayers
                }
            },
            ...$f09050a325aeee13$var$getAuthorityAttributes(authorityUiMetadata)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
module.exports["onAIAnswerResultShown"] = $f09050a325aeee13$export$bc6497c5d340e00a;

});

parcelRegister("hZTED", function(module, exports) {

var $htnqN = parcelRequire("htnqN");

const $4195fdef80fa1f78$export$fd2b85accaf97974 = {
    errorState: (0, $htnqN.NLPSearchErrorState).Default,
    format: null,
    disclaimer: null,
    nlpResults: [],
    uniqueSources: []
};
module.exports["DEFAULT_EMPTY_NLP_SEARCH_STATE"] = $4195fdef80fa1f78$export$fd2b85accaf97974;

});

parcelRegister("lEgaq", function(module, exports) {
const $126e4170420ccea3$export$f5f7924ac6f8609b = 'data-sain-citation';
const $126e4170420ccea3$export$110c96b5e53088b6 = '[data-sain-citation]';
module.exports["SAIN_CITATION_ATTRIBUTE"] = $126e4170420ccea3$export$f5f7924ac6f8609b;
module.exports["SAIN_CITATION_SELECTOR"] = $126e4170420ccea3$export$110c96b5e53088b6;

});

parcelRegister("6O5Et", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $b4e21899d850c11f$export$476afff83df695b3 = (props, copySource = 'answer')=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerCopy',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            copySource: copySource
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
module.exports["onAIAnswerCopyButtonClicked"] = $b4e21899d850c11f$export$476afff83df695b3;

});

parcelRegister("j9bgP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $6spAz = parcelRequire("6spAz");


var $lT1k3 = parcelRequire("lT1k3");


var $4QjIS = parcelRequire("4QjIS");

const $3ac44a319e685d85$var$ColoredBugIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6spAz))), {
        color: "var(--ds-icon-subtlest, #6B6E76)",
        label: ""
    });
const $3ac44a319e685d85$export$6e6fdd8d215e1d59 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isSAINDebuggerModalOpen, setIsSAINDebuggerModalOpen] = (0, $cozmU.useState)(false);
    const openDebuggerModal = (0, $cozmU.useCallback)((e)=>{
        e.stopPropagation();
        onClick?.(e);
        setIsSAINDebuggerModalOpen(true);
    }, [
        onClick
    ]);
    const closeDebuggerModal = (0, $cozmU.useCallback)(()=>setIsSAINDebuggerModalOpen(false), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: $3ac44a319e685d85$var$ColoredBugIcon,
        label: formatMessage((0, $lT1k3.messages).ai_debugger_icon_label),
        onClick: openDebuggerModal,
        appearance: "subtle",
        isTooltipDisabled: false,
        spacing: "compact",
        testId: "sain-online-debugger-button",
        color: "var(--ds-icon-subtlest, #6B6E76)",
        shape: "circle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4QjIS.OnlineDebuggerModal), {
        isOpen: isSAINDebuggerModalOpen,
        onClose: closeDebuggerModal
    }));
};
module.exports["OnlineDebuggerButton"] = $3ac44a319e685d85$export$6e6fdd8d215e1d59;

});

parcelRegister("4QjIS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");


var $iDrrr = parcelRequire("iDrrr");


var $hMjUh = parcelRequire("hMjUh");


var $3hVWe = parcelRequire("3hVWe");


var $zzZbq = parcelRequire("zzZbq");


var $lT1k3 = parcelRequire("lT1k3");


var $6R26v = parcelRequire("6R26v");


var $ftCDW = parcelRequire("ftCDW");


var $cXvSx = parcelRequire("cXvSx");


var $lIZC4 = parcelRequire("lIZC4");


var $7Mjvn = parcelRequire("7Mjvn");


var $8ynLJ = parcelRequire("8ynLJ");


var $61d8U = parcelRequire("61d8U");


var $9UsEc = parcelRequire("9UsEc");


var $kV3xA = parcelRequire("kV3xA");


var $aAdO3 = parcelRequire("aAdO3");

function $28d8eb347c66ef20$export$c8392feccb7e3f1f({ isOpen: isOpen, onClose: onClose }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, smartAnswersRoute: smartAnswersRoute, queryIntentClassificationData: queryIntentClassificationData, queryIntentDetectionMetadata: queryIntentDetectionMetadata, queryIntentDetectionTraceId: queryIntentDetectionTraceId } = (0, $3hVWe.useAIAnswerContext)();
    const isNaturalLanguageQuery = smartAnswersRoute === (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY;
    const { extraAttributes: extraAttributes, sources: sources } = commonAttributes;
    const debuggerData = (0, $cozmU.useMemo)(()=>(0, $6R26v.normalizeDebuggerData)(extraAttributes, (0, $iDrrr.fg)('kd_consolidate_sources_analytics') ? sources : undefined, (0, $iDrrr.fg)('kd_fe_persons_intent_detection_els') ? {
            intentData: queryIntentClassificationData,
            detectionMetadata: queryIntentDetectionMetadata,
            intentDetectionTraceId: queryIntentDetectionTraceId
        } : undefined), [
        extraAttributes,
        sources,
        queryIntentClassificationData,
        queryIntentDetectionMetadata,
        queryIntentDetectionTraceId
    ]);
    const showPluginsPanels = isNaturalLanguageQuery && !debuggerData.minions.hasMinionOutputs && debuggerData.pluginInvocations.hasPluginInvocations;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: "x-large",
        testId: "sain-online-debugger-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMjUh.default), {
        id: "sain-online-debugger-tabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ftCDW.DebuggerTabList), {
        isNaturalLanguageQuery: isNaturalLanguageQuery,
        hasMinionOutputs: debuggerData.minions.hasMinionOutputs,
        hasPluginInvocations: debuggerData.pluginInvocations.hasPluginInvocations,
        hasElsData: debuggerData.elsOverview.hasElsData,
        roundCount: debuggerData.minions.roundCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aAdO3.RequestOverviewPanel), {
        ...debuggerData.requestOverview,
        isNaturalLanguageQuery: isNaturalLanguageQuery
    }), debuggerData.elsOverview.hasElsData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXvSx.ElsOverviewPanel), debuggerData.elsOverview), showPluginsPanels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kV3xA.RawSearchResultsPanel), {
        searchResults: debuggerData.rawSearch.searchResults
    }), showPluginsPanels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61d8U.RankedSearchResultsPanel), {
        rankedDocumentsWithChunks: debuggerData.rankedSearch.rankedDocumentsWithChunks
    }), showPluginsPanels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8ynLJ.PluginInvocationsPanel), {
        nonSearchPluginInvocations: debuggerData.pluginInvocations.nonSearchPluginInvocations
    }), isNaturalLanguageQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Mjvn.OrchestrationOverviewPanel), {
        orchestrationRounds: debuggerData.minions.orchestrationRounds
    }), isNaturalLanguageQuery && debuggerData.minions.hasMinionOutputs && debuggerData.minions.orchestrationRounds.map((round, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lIZC4.LoopPanel), {
            key: `loop-panel-${index}`,
            round: round,
            roundIndex: index
        })), isNaturalLanguageQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9UsEc.RawJsonPanel), {
        rawJson: debuggerData.rawJson.rawJson
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null)));
}
module.exports["OnlineDebuggerModal"] = $28d8eb347c66ef20$export$c8392feccb7e3f1f;

});

parcelRegister("lT1k3", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $834ca13a4b04c199$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ai_debugger_icon_label: {
        id: "search_ai.ai_debugger_icon_label",
        defaultMessage: "Debugger"
    },
    ai_debugger_modal_title: {
        id: "search_ai.ai_debugger_modal_title",
        defaultMessage: "SAIN Debugging Panel"
    },
    ai_debugger_modal_original_query_subheading: {
        id: "search_ai.ai_debugger_modal_original_query_subheading",
        defaultMessage: "Original Query"
    },
    ai_debugger_modal_transformed_query_subheading: {
        id: "search_ai.ai_debugger_modal_transformed_query_subheading",
        defaultMessage: "Transformed Query"
    },
    ai_debugger_modal_detected_intent_subheading: {
        id: "search_ai.ai_debugger_modal_final_routing_intent_subheading",
        defaultMessage: "Final Routing Intent"
    },
    ai_debugger_modal_trace_id_subheading: {
        id: "search_ai.ai_debugger_modal_trace_id_subheading",
        defaultMessage: "Trace ID"
    },
    ai_debugger_modal_answer_trace_id_subheading: {
        id: "search_ai.ai_debugger_modal_answer_trace_id_subheading",
        defaultMessage: "Answer Trace ID"
    },
    ai_debugger_modal_model_subheading: {
        id: "search_ai.ai_debugger_modal_model_subheading",
        defaultMessage: "Answer Generation Model"
    },
    ai_debugger_modal_sources_subheading: {
        id: "search_ai.ai_debugger_modal_sources_subheading",
        defaultMessage: "Sources"
    },
    ai_debugger_modal_cached_answer_subheading: {
        id: "search_ai.ai_debugger_modal_cached_answer_subheading",
        defaultMessage: "Cached answer"
    },
    ai_debugger_modal_copy_button_text: {
        id: "search_ai.ai_debugger_modal_copy_button_text",
        defaultMessage: "Copy JSON"
    },
    ai_debugger_modal_copy_button_copied_text: {
        id: "search_ai.ai_debugger_modal_copy_button_copied_text",
        defaultMessage: "JSON Copied"
    },
    ai_debugger_modal_tab_request_overview: {
        id: "search_ai.ai_debugger_modal_tab_request_overview",
        defaultMessage: "Request Overview"
    },
    ai_debugger_modal_tab_raw_search_results: {
        id: "search_ai.ai_debugger_modal_tab_raw_search_results",
        defaultMessage: "Raw Search Results"
    },
    ai_debugger_modal_tab_ranked_search_results: {
        id: "search_ai.ai_debugger_modal_tab_ranked_search_results",
        defaultMessage: "Ranked Search Results"
    },
    ai_debugger_modal_tab_plugin_invocations: {
        id: "search_ai.ai_debugger_modal_tab_plugin_invocations",
        defaultMessage: "Plugin Invocations"
    },
    ai_debugger_modal_tab_raw_json: {
        id: "search_ai.ai_debugger_modal_tab_raw_json",
        defaultMessage: "Raw JSON"
    },
    ai_debugger_modal_copy_trace_id_label: {
        id: "search_ai.ai_debugger_modal_copy_trace_id_label",
        defaultMessage: "Copy Trace ID"
    },
    ai_debugger_modal_trace_id_copied_text: {
        id: "search_ai.ai_debugger_modal_trace_id_copied_text",
        defaultMessage: "Trace ID copied"
    },
    ai_debugger_modal_splunk_link_label: {
        id: "search_ai.ai_debugger_modal_splunk_link_label",
        defaultMessage: "Splunk"
    },
    ai_debugger_modal_tab_els_overview: {
        id: "search_ai.ai_debugger_modal_tab_els_overview",
        defaultMessage: "ELS Overview"
    },
    ai_debugger_modal_intent_detection_trace_id_subheading: {
        id: "search_ai.ai_debugger_modal_intent_detection_trace_id_subheading",
        defaultMessage: "Intent Detection Trace ID"
    },
    ai_debugger_modal_intent_detection_trace_id_diverged: {
        id: "search_ai.ai_debugger_modal_intent_detection_trace_id_diverged",
        defaultMessage: "Differs from the request Trace ID above"
    },
    ai_debugger_modal_copy_intent_detection_trace_id_label: {
        id: "search_ai.ai_debugger_modal_copy_intent_detection_trace_id_label",
        defaultMessage: "Copy Intent Detection Trace ID"
    },
    ai_debugger_modal_original_intent_subheading: {
        id: "search_ai.ai_debugger_modal_original_intent_prediction_subheading",
        defaultMessage: "Original Intent Prediction"
    },
    ai_debugger_modal_els_trace_id_subheading: {
        id: "search_ai.ai_debugger_modal_els_trace_id_subheading",
        defaultMessage: "ELS Trace ID"
    },
    ai_debugger_modal_detection_metadata_subheading: {
        id: "search_ai.ai_debugger_modal_detection_metadata_subheading",
        defaultMessage: "Detection Metadata"
    },
    ai_debugger_modal_detection_method_label: {
        id: "search_ai.ai_debugger_modal_detection_method_label",
        defaultMessage: "Method"
    },
    ai_debugger_modal_detection_model_label: {
        id: "search_ai.ai_debugger_modal_detection_model_label",
        defaultMessage: "Model"
    },
    ai_debugger_modal_detection_latency_label: {
        id: "search_ai.ai_debugger_modal_detection_latency_label",
        defaultMessage: "Latency (ms)"
    },
    ai_debugger_modal_detection_cache_hit_label: {
        id: "search_ai.ai_debugger_modal_detection_cache_hit_label",
        defaultMessage: "Cache Hit"
    },
    ai_debugger_modal_prefilter_entities_subheading_with_count: {
        id: "search_ai.ai_debugger_modal_prefilter_entities_subheading_with_count",
        defaultMessage: "Prefilter Entities ({count})"
    },
    ai_debugger_modal_prefilter_entity_confidence_label: {
        id: "search_ai.ai_debugger_modal_prefilter_entity_confidence_label",
        defaultMessage: "Confidence"
    },
    ai_debugger_modal_prefilter_entity_clarification_label: {
        id: "search_ai.ai_debugger_modal_prefilter_entity_clarification_label",
        defaultMessage: "Clarification Level"
    },
    ai_debugger_modal_prefilter_entity_mention_label: {
        id: "search_ai.ai_debugger_modal_prefilter_entity_mention_label",
        defaultMessage: "Mention"
    },
    ai_debugger_modal_prefilter_entity_type_label: {
        id: "search_ai.ai_debugger_modal_prefilter_entity_type_label",
        defaultMessage: "Entity Type"
    },
    ai_debugger_modal_persons_subheading_with_count: {
        id: "search_ai.ai_debugger_modal_persons_subheading_with_count",
        defaultMessage: "Persons ({count})"
    },
    ai_debugger_modal_entity_id_label: {
        id: "search_ai.ai_debugger_modal_entity_id_label",
        defaultMessage: "ID"
    },
    ai_debugger_modal_person_account_id_label: {
        id: "search_ai.ai_debugger_modal_person_account_id_label",
        defaultMessage: "Account ID"
    },
    ai_debugger_modal_person_email_label: {
        id: "search_ai.ai_debugger_modal_person_email_label",
        defaultMessage: "Email"
    },
    ai_debugger_modal_person_job_title_label: {
        id: "search_ai.ai_debugger_modal_person_job_title_label",
        defaultMessage: "Job Title"
    },
    ai_debugger_modal_person_department_label: {
        id: "search_ai.ai_debugger_modal_person_department_label",
        defaultMessage: "Department"
    },
    ai_debugger_modal_person_organization_label: {
        id: "search_ai.ai_debugger_modal_person_organization_label",
        defaultMessage: "Organization"
    },
    ai_debugger_modal_person_location_label: {
        id: "search_ai.ai_debugger_modal_person_location_label",
        defaultMessage: "Location"
    },
    ai_debugger_modal_person_zone_info_label: {
        id: "search_ai.ai_debugger_modal_person_zone_info_label",
        defaultMessage: "Zone Info"
    },
    ai_debugger_modal_els_empty_state: {
        id: "search_ai.ai_debugger_modal_els_empty_state",
        defaultMessage: "No ELS data available for this request."
    },
    ai_debugger_modal_expand_label: {
        id: "search_ai.ai_debugger_modal_expand_label",
        defaultMessage: "Expand"
    },
    ai_debugger_modal_collapse_label: {
        id: "search_ai.ai_debugger_modal_collapse_label",
        defaultMessage: "Collapse"
    },
    ai_debugger_modal_success_label: {
        id: "search_ai.ai_debugger_modal_success_label",
        defaultMessage: "Success"
    },
    ai_debugger_modal_failed_label: {
        id: "search_ai.ai_debugger_modal_failed_label",
        defaultMessage: "Failed"
    },
    ai_debugger_modal_search_results_heading: {
        id: "search_ai.ai_debugger_modal_search_results_heading",
        defaultMessage: "Search Results ({count})"
    },
    ai_debugger_modal_ranked_documents_heading: {
        id: "search_ai.ai_debugger_modal_ranked_documents_heading",
        defaultMessage: "Ranked Documents ({count})"
    },
    ai_debugger_modal_tab_orchestration_overview: {
        id: "search_ai.ai_debugger_modal_tab_orchestration_overview",
        defaultMessage: "Orchestration Overview"
    },
    ai_debugger_modal_tab_loop: {
        id: "search_ai.ai_debugger_modal_tab_loop",
        defaultMessage: "Loop {number}"
    },
    ai_debugger_modal_orchestration_loop_heading: {
        id: "search_ai.ai_debugger_modal_orchestration_loop_heading",
        defaultMessage: "Loop {number}"
    },
    ai_debugger_modal_orchestration_loop_with_count: {
        id: "search_ai.ai_debugger_modal_orchestration_loop_with_count",
        defaultMessage: "Loop {number} - {count} {count, plural, one {minion} other {minions}}"
    },
    ai_debugger_modal_orchestration_minions_count: {
        id: "search_ai.ai_debugger_modal_orchestration_minions_count",
        defaultMessage: "{count} {count, plural, one {minion} other {minions}}"
    },
    ai_debugger_modal_no_orchestration_data: {
        id: "search_ai.ai_debugger_modal_no_orchestration_data",
        defaultMessage: "No minion outputs to show."
    },
    ai_debugger_modal_minion_input_label: {
        id: "search_ai.ai_debugger_modal_minion_input_label",
        defaultMessage: "Input"
    },
    ai_debugger_modal_minion_output_label: {
        id: "search_ai.ai_debugger_modal_minion_output_label",
        defaultMessage: "Output"
    },
    ai_debugger_modal_execution_duration: {
        id: "search_ai.ai_debugger_modal_execution_duration",
        defaultMessage: "{duration}ms"
    },
    ai_debugger_modal_execution_duration_label: {
        id: "search_ai.ai_debugger_modal_execution_duration_label",
        defaultMessage: "Duration"
    },
    ai_debugger_modal_minion_name_label: {
        id: "search_ai.ai_debugger_modal_minion_name_label",
        defaultMessage: "Minion Name"
    },
    ai_debugger_modal_disabled: {
        id: "search_ai.ai_debugger_modal_disabled",
        defaultMessage: "disabled"
    },
    ai_debugger_modal_minion_extra_info_label: {
        id: "search_ai.ai_debugger_modal_plugin_output_label",
        defaultMessage: "Extra Info"
    },
    ai_debugger_modal_no_plugins_invoked: {
        id: "search_ai.ai_debugger_modal_no_plugins_invoked",
        defaultMessage: "No additional plugins invoked."
    },
    ai_debugger_modal_teamwork_unnamed_team: {
        id: "search_ai.ai_debugger_modal_teamwork_unnamed_team",
        defaultMessage: "Unnamed Team"
    },
    ai_debugger_modal_teamwork_members_count: {
        id: "search_ai.ai_debugger_modal_teamwork_members_count",
        defaultMessage: "Members: {count}"
    },
    ai_debugger_modal_teamwork_state: {
        id: "search_ai.ai_debugger_modal_teamwork_state",
        defaultMessage: "State: {state}"
    },
    ai_debugger_modal_teamwork_creator: {
        id: "search_ai.ai_debugger_modal_teamwork_creator",
        defaultMessage: "Creator: {creator}"
    },
    ai_debugger_modal_teamwork_show_count: {
        id: "search_ai.ai_debugger_modal_teamwork_show_count",
        defaultMessage: "Show {count} {count, plural, one {member} other {members}}"
    },
    ai_debugger_modal_teamwork_hide_count: {
        id: "search_ai.ai_debugger_modal_teamwork_hide_count",
        defaultMessage: "Hide {count} {count, plural, one {member} other {members}}"
    },
    ai_debugger_modal_author_label: {
        id: "search_ai.ai_debugger_modal_author_label",
        defaultMessage: "Author: {author}"
    },
    ai_debugger_modal_teamwork_document_updated: {
        id: "search_ai.ai_debugger_modal_teamwork_document_updated",
        defaultMessage: "Updated: {date}"
    },
    ai_debugger_modal_page_search_space: {
        id: "search_ai.ai_debugger_modal_page_search_space",
        defaultMessage: "Space: {space}"
    },
    ai_debugger_modal_page_search_count: {
        id: "search_ai.ai_debugger_modal_page_search_count",
        defaultMessage: "{count} {count, plural, one {page} other {pages}} found"
    },
    ai_debugger_modal_function_results_count: {
        id: "search_ai.ai_debugger_modal_function_results_count",
        defaultMessage: "Function Results ({count})"
    },
    ai_debugger_modal_raw_search_results_heading: {
        id: "search_ai.ai_debugger_modal_raw_search_results_heading",
        defaultMessage: "{count, plural, one {Raw Search Result ({count})} other {Raw Search Results ({count})}}"
    },
    ai_debugger_modal_table_url_header: {
        id: "search_ai.ai_debugger_modal_table_url_header",
        defaultMessage: "Document URL"
    },
    ai_debugger_modal_table_doc_index_header: {
        id: "search_ai.ai_debugger_modal_table_doc_index_header",
        defaultMessage: "#"
    },
    ai_debugger_modal_no_raw_search_results: {
        id: "search_ai.ai_debugger_modal_no_raw_search_results",
        defaultMessage: "No raw search results available."
    },
    ai_debugger_modal_ranked_search_results_heading: {
        id: "search_ai.ai_debugger_modal_ranked_search_results_heading",
        defaultMessage: "{count, plural, one {Ranked Document with Chunks ({count})} other {Ranked Documents with Chunks ({count})}}"
    },
    ai_debugger_modal_table_chunk_id_header: {
        id: "search_ai.ai_debugger_modal_table_chunk_id_header",
        defaultMessage: "Chunk ID"
    },
    ai_debugger_modal_table_chunk_score_header: {
        id: "search_ai.ai_debugger_modal_table_chunk_score_header",
        defaultMessage: "Score"
    },
    ai_debugger_modal_table_chunk_rank_header: {
        id: "search_ai.ai_debugger_modal_table_chunk_rank_header",
        defaultMessage: "Rank"
    },
    ai_debugger_modal_no_ranked_search_results: {
        id: "search_ai.ai_debugger_modal_no_ranked_search_results",
        defaultMessage: "No ranked search results available."
    },
    ai_debugger_modal_unable_to_match_chunks: {
        id: "search_ai.ai_debugger_modal_unable_to_match_chunks",
        defaultMessage: "Unable to match chunks"
    },
    ai_debugger_modal_plugins_invoked_subheading: {
        id: "search_ai.ai_debugger_modal_plugins_invoked_subheading",
        defaultMessage: "Plugins Invoked"
    },
    prompt_override_button_label: {
        id: "search_ai.prompt_override_button_label",
        defaultMessage: "Prompt override"
    },
    prompt_override_modal_title: {
        id: "search_ai.prompt_override_modal_title",
        defaultMessage: "Custom System Prompt Override"
    },
    prompt_override_custom_prompt_label: {
        id: "search_ai.prompt_override_custom_prompt_label",
        defaultMessage: "Custom Prompt:"
    },
    prompt_override_textarea_placeholder: {
        id: "search_ai.prompt_override_textarea_placeholder",
        defaultMessage: "Enter your custom system prompt here..."
    },
    prompt_override_help_text: {
        id: "search_ai.prompt_override_help_text",
        defaultMessage: "This prompt will override the default system prompt for AI requests during this session."
    },
    prompt_override_cancel_button: {
        id: "search_ai.prompt_override_cancel_button",
        defaultMessage: "Cancel"
    },
    prompt_override_save_button: {
        id: "search_ai.prompt_override_save_button",
        defaultMessage: "Save"
    }
});
module.exports["messages"] = $834ca13a4b04c199$export$defe85febe8b728c;

});

parcelRegister("bIZaC", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $ff375125b11d6992$export$c4c8b81ee90e6af2 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDislikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
module.exports["onDislikeButtonClick"] = $ff375125b11d6992$export$c4c8b81ee90e6af2;

});

parcelRegister("7z5N5", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $d72bf611d64ecd70$export$5b155f527aff26b9 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerLikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
module.exports["onLikeButtonClick"] = $d72bf611d64ecd70$export$5b155f527aff26b9;

});

parcelRegister("7qJqb", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $cozmU = parcelRequire("cozmU");

const $eab2f21eaddd320a$export$f3f282f819d3a3cc = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "3",
        cy: "14",
        r: "1",
        fill: '#1F69DA'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "opacity",
        values: "0;1;1;1;",
        dur: "0.8s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "7",
        cy: "14",
        r: "1",
        fill: '#C16CD4'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "opacity",
        values: "0;0;1;1;",
        dur: "0.8s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "11",
        cy: "14",
        r: "1",
        fill: '#F5A117'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "opacity",
        values: "0;0;0;1;",
        dur: "0.8s",
        repeatCount: "indefinite",
        begin: "0s"
    })));
};
module.exports["RovoGeneratingAnimation"] = $eab2f21eaddd320a$export$f3f282f819d3a3cc;

});

parcelRegister("kSORO", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $345c4b3767ab340d$export$a43930cde520e30 = (props, isAnimated)=>{
    const { query: query, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerLoadingDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            isAnimated: isAnimated
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
module.exports["onAIAnswerLoadingDialogShown"] = $345c4b3767ab340d$export$a43930cde520e30;

});

parcelRegister("24oKg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9ee8edf58ce8906b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    smart_answer_card_generating: {
        id: "search_ai.smart_answer_card_generating",
        defaultMessage: "Generating"
    },
    smart_answer_card_title: {
        id: "search_ai.smart_answer_card.title",
        defaultMessage: "Answer"
    },
    smart_answer_card_dynamic_layout_title: {
        id: "search_ai.smart_answer_card_dynamic_layout_title",
        defaultMessage: "Overview"
    },
    smart_answer_card_rovo_generating: {
        id: "search_ai.smart_answer_card_rovo_generating",
        defaultMessage: "Rovo is {queryReasoning}"
    },
    smart_answer_card_rovo_is_thinking: {
        id: "search_ai.smart_answer_card_rovo_is_thinking",
        defaultMessage: "Rovo is thinking"
    },
    related_links_title: {
        id: "search_ai.related_links_list_label",
        defaultMessage: "Related links"
    },
    hide_answer: {
        id: "search_ai.smart_answer_card.hide_answer",
        defaultMessage: "Hide answer"
    }
});
module.exports["messages"] = $9ee8edf58ce8906b$export$defe85febe8b728c;

});

parcelRegister("9LgVw", function(module, exports) {
module.exports = new URL("Rovo.e24f6f93.svg", import.meta.url).toString();

});

parcelRegister("kisaw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gABt9 = parcelRequire("gABt9");


var $zzZbq = parcelRequire("zzZbq");

const $2158bd65b0fea07b$var$SearchTenantContextQuery = `
  query SearchTenantContextQuery($cloudId: ID!) {
    tenantContexts(cloudIds: [$cloudId]) {
      cloudUrl
    }
	}
`;
const $2158bd65b0fea07b$var$fetchTenantContext = (variables)=>{
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: $2158bd65b0fea07b$var$SearchTenantContextQuery,
                variables: variables
            })
        }
    };
    return (0, $gABt9.utils).requestService({
        url: (0, $zzZbq.DEFAULT_GRAPHQL_ENDPOINT)
    }, options);
};
const $2158bd65b0fea07b$export$28e7c557f4d454d9 = (cloudId)=>{
    const [tenantContext, setTenantContext] = (0, $cozmU.useState)({});
    const [hasError, setHasError] = (0, $cozmU.useState)(false);
    const fetchContext = (0, $cozmU.useCallback)(async ()=>{
        try {
            const { data: data } = await $2158bd65b0fea07b$var$fetchTenantContext({
                cloudId: cloudId
            });
            if (data?.tenantContexts && data.tenantContexts.length > 0) setTenantContext(data.tenantContexts[0]);
            else setHasError(true);
        } catch (e) {
            setHasError(true);
        }
    }, [
        cloudId
    ]);
    (0, $cozmU.useEffect)(()=>{
        fetchContext();
    }, [
        fetchContext
    ]);
    return {
        tenantContext: tenantContext,
        hasError: hasError
    };
};
module.exports["useTenantContext"] = $2158bd65b0fea07b$export$28e7c557f4d454d9;

});

parcelRegister("aqqYN", function(module, exports) {
/* knowledge-cards-row.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $apU4q = parcelRequire("apU4q");


var $1UlLI = parcelRequire("1UlLI");


var $lJqiq = parcelRequire("lJqiq");


var $43jvb = parcelRequire("43jvb");


var $9K2hX = parcelRequire("9K2hX");

const $4115b74ed5746564$var$i18n = (0, $kSwu1.defineMessages)({
    knowledgeRowTypeWork: {
        id: "search_ai.knowledge_cards.row.knowledge-row-type.work",
        defaultMessage: "Work Item"
    },
    knowledgeRowTypeAgent: {
        id: "search_ai.knowledge_cards.row.knowledge-row-type.agent",
        defaultMessage: "Agent"
    },
    knowledgeRowTypePerson: {
        id: "search_ai.knowledge_cards.row.knowledge-row-type.person",
        defaultMessage: "Person"
    }
});
const $4115b74ed5746564$var$styles = {
    root: "_0bjKvDKxmn _2xTnZx2ADO _1eOmH6d1Zr _0ReiIH7zJH"
};
const $4115b74ed5746564$export$96be17c41f7933d9 = ({ primaryText: primaryText, secondaryText: secondaryText, pictureUrl: pictureUrl, type: type, triggerProps: triggerProps, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, contentTypeName: contentTypeName })=>{
    const intl = (0, $kSwu1.useIntl)();
    const altText = contentTypeName ? (0, $43jvb.formatContentTypeName)(contentTypeName) : type === (0, $1UlLI.KnowledgeCardsRowType).PERSON ? intl.formatMessage($4115b74ed5746564$var$i18n.knowledgeRowTypePerson) : intl.formatMessage($4115b74ed5746564$var$i18n.knowledgeRowTypeWork);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4115b74ed5746564$var$styles.root,
        paddingInline: "space.200",
        paddingBlock: "space.100",
        ...triggerProps,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, type === (0, $1UlLI.KnowledgeCardsRowType).PERSON ? /*#__PURE__*/ $cozmU.createElement((0, $lJqiq.PersonStyles), {
        src: pictureUrl,
        alt: altText
    }) : /*#__PURE__*/ $cozmU.createElement((0, $9K2hX.WorkStyles), {
        src: pictureUrl,
        alt: altText
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        spread: "space-between"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: 1
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xxsmall"
    }, primaryText)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 1
    }, secondaryText))));
};
const $4115b74ed5746564$export$465f421106844c87 = ({ primaryText: primaryText, secondaryText: secondaryText, pictureUrl: pictureUrl, type: type, triggerProps: triggerProps, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, contentTypeName: contentTypeName })=>{
    const intl = (0, $kSwu1.useIntl)();
    const altText = contentTypeName ? (0, $43jvb.formatContentTypeName)(contentTypeName) : type === (0, $1UlLI.KnowledgeCardsRowType).WORK ? intl.formatMessage($4115b74ed5746564$var$i18n.knowledgeRowTypeWork) : type === (0, $1UlLI.KnowledgeCardsRowType).AGENT ? intl.formatMessage($4115b74ed5746564$var$i18n.knowledgeRowTypeAgent) : intl.formatMessage($4115b74ed5746564$var$i18n.knowledgeRowTypePerson);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4115b74ed5746564$var$styles.root,
        paddingInline: "space.200",
        paddingBlock: "space.075",
        ...triggerProps,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, type === (0, $1UlLI.KnowledgeCardsRowType).WORK ? /*#__PURE__*/ $cozmU.createElement((0, $9K2hX.WorkStyles), {
        src: pictureUrl,
        alt: altText
    }) : type === (0, $1UlLI.KnowledgeCardsRowType).AGENT ? /*#__PURE__*/ $cozmU.createElement((0, $apU4q.AgentStyles), {
        src: pictureUrl,
        alt: altText
    }) : /*#__PURE__*/ $cozmU.createElement((0, $lJqiq.PersonStyles), {
        src: pictureUrl,
        alt: altText
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: 1
    }, primaryText), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 1
    }, secondaryText))));
};
module.exports["KnowledgeCardsRow"] = $4115b74ed5746564$export$96be17c41f7933d9;
module.exports["KnowledgeCardsRowRefresh"] = $4115b74ed5746564$export$465f421106844c87;

});

parcelRegister("1UlLI", function(module, exports) {
var $e3379cc3d34812dc$export$f6d5eb0487369ad6 = /*#__PURE__*/ function(KnowledgeCardsRowType) {
    KnowledgeCardsRowType["PERSON"] = "PERSON";
    KnowledgeCardsRowType["WORK"] = "WORK";
    KnowledgeCardsRowType["AGENT"] = "AGENT";
    return KnowledgeCardsRowType;
}({});
module.exports["KnowledgeCardsRowType"] = $e3379cc3d34812dc$export$f6d5eb0487369ad6;

});

parcelRegister("br26d", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $I7hWB = parcelRequire("I7hWB");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $3hVWe = parcelRequire("3hVWe");


var $bZMnB = parcelRequire("bZMnB");


var $eySxZ = parcelRequire("eySxZ");


var $8tNXq = parcelRequire("8tNXq");


var $lPcf8 = parcelRequire("lPcf8");


var $kisaw = parcelRequire("kisaw");


var $hXc9i = parcelRequire("hXc9i");


var $fwt1L = parcelRequire("fwt1L");


var $2i5Nf = parcelRequire("2i5Nf");


var $agblG = parcelRequire("agblG");


var $kcKX3 = parcelRequire("kcKX3");


var $7EwcU = parcelRequire("7EwcU");

const $72912c5bf209e671$var$AITopicsByPersonComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ userId: userId, userName: userName, cloudId: cloudId, sessionId: sessionId, v2styles: v2styles = false })=>{
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { aiRelatedTopics: aiRelatedTopics, fetchRelatedTopics: fetchRelatedTopics, showTopics: showTopics } = (0, $7EwcU.useRelatedTopics)();
    const wrapperRef = (0, $cozmU.useRef)(null);
    const [showMore, setShowMore] = (0, $cozmU.useState)(false);
    const { breakElems: breakElems } = (0, $kcKX3.useTopicBreakElems)(wrapperRef, showTopics);
    const { tenantContext: tenantContext } = (0, $kisaw.useTenantContext)(cloudId);
    const { cloudUrl: cloudUrl } = tenantContext;
    const onBadgeClickHandler = ({ topicId: topicId, position: position, shownAfterCardBodyExpanded: shownAfterCardBodyExpanded })=>{
        fireAnalyticsEvent((0, $2i5Nf.onRelatedEntityClick)({
            clickedEntityId: topicId,
            clickedEntityType: 'topic',
            principalEntityType: (0, $fwt1L.RelatedEntityType).USER,
            principalEntityId: userId,
            sessionId: sessionId,
            location: 'personCard',
            position: position,
            shownAfterCardBodyExpanded: shownAfterCardBodyExpanded
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).TOPIC_CLICKED,
            commonAttributes: commonAttributes
        });
    };
    const onShowMoreTopicsClick = ()=>{
        fireAnalyticsEvent((0, $2i5Nf.onToggleMoreRelatedEntitiesClick)({
            sessionId: sessionId,
            location: 'personCard',
            expanded: !showMore
        }));
        if (!showMore) fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SHOW_MORE_TOPICS_CLICKED,
            commonAttributes: commonAttributes
        });
        setShowMore((s)=>!s);
    };
    (0, $cozmU.useEffect)(()=>{
        fetchRelatedTopics({
            entityId: userId,
            principalEntityType: (0, $fwt1L.RelatedEntityType).USER,
            cloudId: cloudId
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (showTopics) fireAnalyticsEvent((0, $2i5Nf.onSurfaceShown)({
            principalEntityId: userId,
            principalEntityType: (0, $fwt1L.RelatedEntityType).USER,
            relatedTopics: aiRelatedTopics.map((topic)=>topic.id),
            sessionId: sessionId,
            location: 'personCard'
        }));
    }, [
        showTopics,
        aiRelatedTopics,
        userId,
        fireAnalyticsEvent,
        sessionId
    ]);
    const firstName = userName.split(' ')[0];
    return showTopics ? v2styles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        ref: wrapperRef,
        space: "space.100",
        rowSpace: "space.100",
        alignBlock: "center",
        shouldWrap: true
    }, (breakElems < 0 ? aiRelatedTopics : aiRelatedTopics.slice(0, Math.max(1, breakElems))).map((topic, position)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXc9i.KnowledgeBadge), {
            key: topic.id,
            name: topic.name,
            url: `/wiki/topics/${topic.id}`,
            onBadgeClick: ()=>onBadgeClickHandler({
                    topicId: topic.id,
                    position: position,
                    shownAfterCardBodyExpanded: false
                })
        })), breakElems < aiRelatedTopics.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        onClick: ()=>(0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation') ? onShowMoreTopicsClick() : setShowMore((s)=>!s),
        icon: (iconProps)=>showMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps,
                size: "small"
            }),
        label: showMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $agblG.messages).ai_topics_show_fewer_topics_text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $agblG.messages).ai_topics_show_more_topics_text),
        spacing: "compact"
    }) : null), showMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        shouldWrap: true
    }, aiRelatedTopics.slice(breakElems).map((topic, position)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXc9i.KnowledgeBadge), {
            key: topic.id,
            name: topic.name,
            url: cloudUrl ? `${cloudUrl}/wiki/topics/${topic.id}` : undefined,
            onBadgeClick: ()=>onBadgeClickHandler({
                    topicId: topic.id,
                    position: breakElems + position,
                    shownAfterCardBodyExpanded: true
                })
        })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xxsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $agblG.messages).ai_topics_surface_header_person,
        values: {
            userName: firstName
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        rowSpace: "space.100",
        shouldWrap: true
    }, aiRelatedTopics.map((topic, position)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXc9i.KnowledgeBadge), {
            key: topic.id,
            name: topic.name,
            url: cloudUrl ? `${cloudUrl}/wiki/topics/${topic.id}` : undefined,
            onBadgeClick: ()=>onBadgeClickHandler({
                    topicId: topic.id,
                    position: position,
                    shownAfterCardBodyExpanded: false
                })
        }))))) : null;
});
const $72912c5bf209e671$export$98ee922d18019998 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($72912c5bf209e671$var$AITopicsByPersonComponent, props));
module.exports["AITopicsByPerson"] = $72912c5bf209e671$export$98ee922d18019998;

});

parcelRegister("dDQsD", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $569708f7a87c1cd2$export$689a00fa0f31e3ff = ({ experimentCohort: experimentCohort, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerOpenChatButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            experimentCohort: experimentCohort
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
module.exports["onOpenChatButtonClick"] = $569708f7a87c1cd2$export$689a00fa0f31e3ff;

});

parcelRegister("5OgwG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1589bfa747ca2c19$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ai_answer_card_collapse_button: {
        id: "search_ai.ai_answer_card_collapse_button",
        defaultMessage: "Collapse"
    },
    ai_answer_card_expand_button: {
        id: "search_ai.ai_answer_card_expand_button",
        defaultMessage: "Expand"
    },
    ai_answer_card_tab_ai_answer: {
        id: "search_ai.ai_answer_card_tab_ai_answer",
        defaultMessage: "AI Answer"
    },
    ai_answer_card_tab_sources: {
        id: "search_ai.ai_answer_card_tab_sources",
        defaultMessage: "Sources"
    },
    ai_answer_card_tab_sources_with_pluralization: {
        id: "search_ai.ai_answer_card_tab_sources_with_pluralization",
        defaultMessage: "{sourcesCount, plural, one {Source} other {Sources {sourcesCount}}}"
    },
    ai_answer_card_read_more_button: {
        id: "search_ai.ai_answer_card_read_more_button",
        defaultMessage: "Read more"
    },
    ai_answer_card_show_more_button: {
        id: "search_ai.ai_answer_card_show_more_button",
        defaultMessage: "Show more"
    },
    ai_answer_open_chat_input_box_ask_rovo: {
        id: "search_ai.ai_answer_open_chat_input_box_ask_rovo",
        defaultMessage: "Ask Rovo anything"
    },
    ai_answer_card_early_stop_text: {
        id: "search_ai.ai_answer_card_early_stop_text",
        defaultMessage: "Rovo couldn't generate an answer for \"{searchQuery}\". Try rephrasing your query."
    },
    ai_answer_card_early_stop_close_button_label: {
        id: "search_ai.ai_answer_card_early_stop_close_button",
        defaultMessage: "Close"
    },
    ai_answer_open_chat_input_box_send_query: {
        id: "search_ai.ai_answer_open_chat_input_box_send_query",
        defaultMessage: "Send query"
    }
});
module.exports["messages"] = $1589bfa747ca2c19$export$defe85febe8b728c;

});

parcelRegister("6R26v", function(module, exports) {

var $1Nf9V = parcelRequire("1Nf9V");


var $dP3C2 = parcelRequire("dP3C2");


var $4762y = parcelRequire("4762y");


var $4hGoz = parcelRequire("4hGoz");


var $izeRj = parcelRequire("izeRj");


var $4WM05 = parcelRequire("4WM05");


var $614SU = parcelRequire("614SU");


var $agj0v = parcelRequire("agj0v");


var $9S2qh = parcelRequire("9S2qh");


var $hmEvS = parcelRequire("hmEvS");


var $cOpQd = parcelRequire("cOpQd");


var $5J4us = parcelRequire("5J4us");

const $c4e2d49fa2b5e1bc$export$6f0a258f64ff7a99 = (extraAttributes, sources, elsOptions)=>{
    const { originalQuery: originalQuery, transformedQuery: transformedQuery, traceId: traceId, answerGenerationModel: answerGenerationModel, cacheInfo: cacheInfo, sources: extraSources = [], pluginInvocations: pluginInvocations = [], minion_outputs: minion_outputs = [], rawJson: rawJson } = extraAttributes ?? {};
    const resolvedSources = sources !== undefined ? sources : extraSources;
    // Extract search data from both plugins and minions, then merge
    const pluginSearchInfo = (0, $614SU.getSearchResultsFromPlugins)(pluginInvocations);
    const minionSearchInfo = (0, $4WM05.getSearchResultsFromMinions)(minion_outputs);
    const searchExtraInfo = (0, $agj0v.mergeSearchExtraInfo)(pluginSearchInfo, minionSearchInfo);
    const rankedDocumentsWithChunks = (0, $izeRj.getRankedDocumentsWithChunks)(searchExtraInfo);
    const orchestrationRounds = (0, $5J4us.getOrchestrationRounds)(minion_outputs);
    const elsOverview = (0, $cOpQd.normalizeElsOverview)(elsOptions?.intentData, elsOptions?.detectionMetadata);
    // The intent-detection call and the ELS call share the same trace. Prefer the
    // dedicated intent-detection trace ID (captured from the intent-detection response
    // headers) and fall back to the ELS trace ID when it was not captured separately.
    const intentDetectionTraceId = elsOptions?.intentDetectionTraceId ?? elsOverview.elsTraceId;
    return {
        requestOverview: {
            originalQuery: originalQuery ?? null,
            transformedQuery: transformedQuery ?? null,
            traceId: traceId ?? null,
            intentDetectionTraceId: intentDetectionTraceId ?? null,
            intentDetectionTimestamp: elsOverview.timestamp,
            originalIntent: elsOverview.originalIntent,
            finalRoutingDecision: elsOverview.finalRoutingDecision,
            detectionMetadata: (0, $hmEvS.normalizeDetectionMetadata)(elsOptions?.detectionMetadata),
            modelName: (0, $1Nf9V.extractModelName)(answerGenerationModel),
            cacheHit: (0, $9S2qh.normalizeCacheHit)(cacheInfo),
            sources: resolvedSources,
            invokedPluginNames: (0, $dP3C2.extractUniquePluginNames)(pluginInvocations)
        },
        rankedSearch: {
            searchExtraInfo: searchExtraInfo,
            rankedDocumentsWithChunks: rankedDocumentsWithChunks
        },
        rawSearch: {
            searchResults: searchExtraInfo?.searchResults ?? []
        },
        pluginInvocations: {
            allPluginInvocations: pluginInvocations,
            nonSearchPluginInvocations: (0, $4hGoz.filterNonSearchPlugins)(pluginInvocations),
            hasPluginInvocations: pluginInvocations ? pluginInvocations.length > 0 : false
        },
        minions: {
            allMinionOutputs: minion_outputs,
            nonSearchMinionOutputs: (0, $4762y.filterNonSearchMinions)(minion_outputs),
            hasMinionOutputs: minion_outputs ? minion_outputs.length > 0 : false,
            orchestrationRounds: orchestrationRounds,
            roundCount: orchestrationRounds.length
        },
        rawJson: {
            rawJson: rawJson
        },
        elsOverview: elsOverview
    };
};
module.exports["normalizeDebuggerData"] = $c4e2d49fa2b5e1bc$export$6f0a258f64ff7a99;

});

parcelRegister("ftCDW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bxtKM = parcelRequire("bxtKM");


var $dkVNA = parcelRequire("dkVNA");


var $lT1k3 = parcelRequire("lT1k3");

const $b69d7ae01770c92a$export$77c21587411d3943 = ({ isNaturalLanguageQuery: isNaturalLanguageQuery, hasMinionOutputs: hasMinionOutputs, hasPluginInvocations: hasPluginInvocations, hasElsData: hasElsData, roundCount: roundCount })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const showPluginsTabs = isNaturalLanguageQuery && !hasMinionOutputs && hasPluginInvocations;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dkVNA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_request_overview)), hasElsData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_els_overview)), showPluginsTabs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_raw_search_results)), showPluginsTabs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_ranked_search_results)), showPluginsTabs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_plugin_invocations)), isNaturalLanguageQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_orchestration_overview)), isNaturalLanguageQuery && hasMinionOutputs && Array.from({
        length: roundCount
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), {
            key: `loop-${index}`
        }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_loop, {
            number: index
        }))), isNaturalLanguageQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_raw_json)));
};
module.exports["DebuggerTabList"] = $b69d7ae01770c92a$export$77c21587411d3943;

});

parcelRegister("cXvSx", function(module, exports) {
/* els-overview-panel.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

var $3pCca = parcelRequire("3pCca");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $gRGWz = parcelRequire("gRGWz");


var $8MLeD = parcelRequire("8MLeD");


var $lT1k3 = parcelRequire("lT1k3");


var $6VKp9 = parcelRequire("6VKp9");


var $7LI7r = parcelRequire("7LI7r");


var $78oRC = parcelRequire("78oRC");

const $87db37ad69e8596f$var$styles = {
    twoColumnGrid: "_2iEGP2Lmr7",
    entityCard: "_0bjKvDKxmn _0Of8r22ADO _1wydGW2ADO _0LQT5E8HPE _03SyCP8HPE"
};
const $87db37ad69e8596f$var$Field = ({ label: label, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, value ?? 'null'));
const $87db37ad69e8596f$export$e75eed738c8c7f90 = ({ hasElsData: hasElsData, elsTraceId: elsTraceId, timestamp: timestamp, prefilterEntities: prefilterEntities, persons: persons })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!hasElsData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: "sain-online-debugger-els-overview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_els_empty_state))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: "sain-online-debugger-els-overview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "sain-online-debugger-els-trace-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_els_trace_id_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, elsTraceId ?? 'null'), elsTraceId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MLeD.CopyButton), {
        copyText: elsTraceId,
        copyLabel: formatMessage((0, $lT1k3.messages).ai_debugger_modal_copy_trace_id_label),
        copiedLabel: formatMessage((0, $lT1k3.messages).ai_debugger_modal_trace_id_copied_text),
        testId: "sain-online-debugger-copy-els-trace-id-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $78oRC.SplunkLink), {
        traceId: elsTraceId,
        timestamp: timestamp,
        variant: "els",
        testId: "sain-online-debugger-els-trace-id-splunk-link"
    }))), prefilterEntities.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VKp9.ExpandableSection), {
        title: formatMessage((0, $lT1k3.messages).ai_debugger_modal_prefilter_entities_subheading_with_count, {
            count: prefilterEntities.length
        }),
        testId: "sain-online-debugger-prefilter-entities-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, prefilterEntities.map((entity, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: entity.id ?? `prefilter-entity-${index}`,
            xcss: $87db37ad69e8596f$var$styles.entityCard,
            backgroundColor: "color.background.neutral",
            testId: "sain-online-debugger-prefilter-entity"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold"
        }, entity.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
            xcss: $87db37ad69e8596f$var$styles.twoColumnGrid,
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87db37ad69e8596f$var$Field, {
            label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_prefilter_entity_type_label),
            value: entity.entityType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87db37ad69e8596f$var$Field, {
            label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_prefilter_entity_mention_label),
            value: entity.mention
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87db37ad69e8596f$var$Field, {
            label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_entity_id_label),
            value: entity.id
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87db37ad69e8596f$var$Field, {
            label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_prefilter_entity_confidence_label),
            value: entity.confidenceScore
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87db37ad69e8596f$var$Field, {
            label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_prefilter_entity_clarification_label),
            value: entity.clarificationLevel
        })))))), persons.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VKp9.ExpandableSection), {
        title: formatMessage((0, $lT1k3.messages).ai_debugger_modal_persons_subheading_with_count, {
            count: persons.length
        }),
        testId: "sain-online-debugger-persons-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, persons.map((person, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: person.accountId ?? `person-${index}`,
            xcss: $87db37ad69e8596f$var$styles.entityCard,
            backgroundColor: "color.background.neutral",
            testId: "sain-online-debugger-person"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold"
        }, person.name ?? 'null'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
            xcss: $87db37ad69e8596f$var$styles.twoColumnGrid,
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87db37ad69e8596f$var$Field, {
            label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_person_account_id_label),
            value: person.accountId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87db37ad69e8596f$var$Field, {
            label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_person_email_label),
            value: person.email
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87db37ad69e8596f$var$Field, {
            label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_person_job_title_label),
            value: person.jobTitle
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87db37ad69e8596f$var$Field, {
            label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_person_department_label),
            value: person.department
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87db37ad69e8596f$var$Field, {
            label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_person_organization_label),
            value: person.organization
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87db37ad69e8596f$var$Field, {
            label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_person_location_label),
            value: person.location
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87db37ad69e8596f$var$Field, {
            label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_person_zone_info_label),
            value: person.zoneInfo
        }))))))));
};
module.exports["ElsOverviewPanel"] = $87db37ad69e8596f$export$e75eed738c8c7f90;

});

parcelRegister("lIZC4", function(module, exports) {
/* loop-panel.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $3pCca = parcelRequire("3pCca");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $gRGWz = parcelRequire("gRGWz");


var $lPcf8 = parcelRequire("lPcf8");


var $kJmyb = parcelRequire("kJmyb");


var $izeRj = parcelRequire("izeRj");


var $lT1k3 = parcelRequire("lT1k3");


var $9kYnS = parcelRequire("9kYnS");


var $2IyOa = parcelRequire("2IyOa");


var $3AbYV = parcelRequire("3AbYV");


var $5J4us = parcelRequire("5J4us");


var $7LI7r = parcelRequire("7LI7r");

const $ae2c26e8d2f5c295$var$styles = {
    minionCard: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _0KLXru66of",
    pressable: "_0Of8r28HPE _1Znuxb5zaO _1wydGW8HPE _2Zuz6Q5zaO _0wOv4Q7zJH _39xV02N91d",
    expandedContent: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXruDMqu _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    borderedBox: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXru66of",
    sectionPadding: "_0Of8r28HPE _1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO",
    codeBlock: "_0bjKvDKxmn _4bt5LAIZbP _2WAcuGIZbP _0KLXru7Cj1 _0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _1ANEUSlpBW _3W2Oc84hR5 _0NUa3rgZxp",
    expandableHeader: "_0Of8r22ADO _1Znuxb8HPE _1wydGW2ADO _2Zuz6Q8HPE _0wOv4Q7zJH _39xV02N91d",
    expandableContent: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    searchResultsGrid: "_2iEGP2UfmU",
    rankedDocsGrid: "_2iEGP2VIym",
    gridCell: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _3W2Oc84hR5",
    gridCellWithLeftBorder: "_1Vs123NvrM _421I1o6wH8 _0obpEh9r67",
    gridHeader: "_0KLXruDMqu"
};
const $ae2c26e8d2f5c295$var$ExpandableSection = ({ title: title, children: children, defaultExpanded: defaultExpanded = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.borderedBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: ()=>setIsExpanded(!isExpanded),
        xcss: $ae2c26e8d2f5c295$var$styles.expandableHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_collapse_label),
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_expand_label),
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, title))), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.expandableContent
    }, children));
};
const $ae2c26e8d2f5c295$var$MinionExpandableItem = ({ minion: minion, index: index })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const minionInfo = (0, $kJmyb.getMinionOutputItem)(minion);
    const isSearchMinion = minionInfo.minion_id?.toLowerCase().includes((0, $9kYnS.MinionName).SEARCH);
    const { extraInfo: extraInfo, parsedOutput: parsedOutput, functionResults: functionResults, searchExtraInfo: searchExtraInfo } = (0, $5J4us.parseMinionExtraInfo)(minionInfo.minion_extra_info, minionInfo.minion_id, isSearchMinion ?? false);
    const rankedDocumentsWithChunks = (0, $izeRj.getRankedDocumentsWithChunks)(searchExtraInfo);
    const rawSearchResults = searchExtraInfo?.searchResults ?? [];
    const executionDuration = minionInfo.minion_execution_duration;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.minionCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: ()=>setIsExpanded(!isExpanded),
        xcss: $ae2c26e8d2f5c295$var$styles.pressable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_collapse_label),
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_expand_label),
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, minionInfo.minion_id || `Minion ${index + 1}`)), executionDuration !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_execution_duration_label), ":", ' ', formatMessage((0, $lT1k3.messages).ai_debugger_modal_execution_duration, {
        duration: executionDuration
    })))), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.expandedContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, minionInfo.minion_input && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.borderedBox, $ae2c26e8d2f5c295$var$styles.sectionPadding)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold",
        size: "small"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_minion_input_label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.codeBlock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, typeof minionInfo.minion_input === 'object' ? JSON.stringify(minionInfo.minion_input, null, 2) : minionInfo.minion_input)))), minionInfo.minion_output && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2c26e8d2f5c295$var$ExpandableSection, {
        title: formatMessage((0, $lT1k3.messages).ai_debugger_modal_minion_output_label)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.codeBlock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, typeof minionInfo.minion_output === 'object' ? JSON.stringify(minionInfo.minion_output, null, 2) : minionInfo.minion_output))), functionResults && functionResults.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2c26e8d2f5c295$var$ExpandableSection, {
        title: formatMessage((0, $lT1k3.messages).ai_debugger_modal_function_results_count, {
            count: functionResults.length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, functionResults.map((result, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2IyOa.FunctionResult), {
            key: idx,
            result: result,
            index: idx
        })))), (parsedOutput || extraInfo) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2c26e8d2f5c295$var$ExpandableSection, {
        title: formatMessage((0, $lT1k3.messages).ai_debugger_modal_minion_extra_info_label)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3AbYV.PluginOutputRenderer), {
        parsedOutput: parsedOutput,
        extraInfo: extraInfo
    })), isSearchMinion && rawSearchResults.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2c26e8d2f5c295$var$ExpandableSection, {
        title: formatMessage((0, $lT1k3.messages).ai_debugger_modal_raw_search_results_heading, {
            count: rawSearchResults.length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.borderedBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $ae2c26e8d2f5c295$var$styles.searchResultsGrid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_url_header))), rawSearchResults.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: url,
            xcss: $ae2c26e8d2f5c295$var$styles.gridCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: url,
            target: "_blank"
        }, url)))))), isSearchMinion && rankedDocumentsWithChunks.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2c26e8d2f5c295$var$ExpandableSection, {
        title: formatMessage((0, $lT1k3.messages).ai_debugger_modal_ranked_search_results_heading, {
            count: rankedDocumentsWithChunks.length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.borderedBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $ae2c26e8d2f5c295$var$styles.rankedDocsGrid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_doc_index_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder, $ae2c26e8d2f5c295$var$styles.gridHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_url_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder, $ae2c26e8d2f5c295$var$styles.gridHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_chunk_id_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder, $ae2c26e8d2f5c295$var$styles.gridHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_chunk_score_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder, $ae2c26e8d2f5c295$var$styles.gridHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_chunk_rank_header))), rankedDocumentsWithChunks.map((doc, docIndex)=>{
        const chunkCount = Math.max(doc.chunks.length, 1);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: doc.url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ae2c26e8d2f5c295$var$styles.gridCell,
            style: {
                gridRow: `span ${chunkCount}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "semibold"
        }, docIndex + 1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder),
            style: {
                gridRow: `span ${chunkCount}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: doc.url,
            target: "_blank"
        }, doc.url)), doc.chunks.length > 0 ? doc.chunks.map((chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
                key: chunk.chunk_id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, chunk.chunk_id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, chunk.score.toFixed(4))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, chunk.rank)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_unable_to_match_chunks))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, "-")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, "-"))));
    }))))))));
};
const $ae2c26e8d2f5c295$export$99187093ec4738cf = ({ round: round, roundIndex: roundIndex })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: `sain-online-debugger-loop-${roundIndex}-panel`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_orchestration_loop_with_count, {
        number: roundIndex,
        count: round.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, round.map((minion, minionIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2c26e8d2f5c295$var$MinionExpandableItem, {
            key: (0, $kJmyb.getMinionOutputItem)(minion).minion_id || minionIndex,
            minion: minion,
            index: minionIndex
        }))))));
};
module.exports["LoopPanel"] = $ae2c26e8d2f5c295$export$99187093ec4738cf;

});

parcelRegister("7Mjvn", function(module, exports) {
/* orchestration-overview-panel.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

var $3pCca = parcelRequire("3pCca");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $gRGWz = parcelRequire("gRGWz");


var $IOtUu = parcelRequire("IOtUu");


var $kJmyb = parcelRequire("kJmyb");


var $lT1k3 = parcelRequire("lT1k3");


var $7LI7r = parcelRequire("7LI7r");

const $a5b738d83e7d73f2$var$styles = {
    minionGrid: "_2iEGP2wA97"
};
const $a5b738d83e7d73f2$export$fb4e2149d28f72b3 = ({ orchestrationRounds: orchestrationRounds })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (orchestrationRounds.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: "sain-online-debugger-orchestration-overview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_no_orchestration_data))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: "sain-online-debugger-orchestration-overview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, orchestrationRounds.map((round, roundIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: roundIndex
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_orchestration_loop_heading, {
            number: roundIndex
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            text: formatMessage((0, $lT1k3.messages).ai_debugger_modal_orchestration_minions_count, {
                count: round.length
            }),
            isRemovable: false,
            migration_fallback: "lozenge"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
            xcss: $a5b738d83e7d73f2$var$styles.minionGrid,
            gap: "space.100",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_minion_name_label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_execution_duration_label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_minion_input_label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, round.map((minion, minionIndex)=>{
            const minionInfo = (0, $kJmyb.getMinionOutputItem)(minion);
            const minionId = minionInfo.minion_id;
            const minionInput = minionInfo.minion_input;
            const executionDuration = minionInfo.minion_execution_duration;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
                key: `${minionId}-${minionIndex}`,
                xcss: $a5b738d83e7d73f2$var$styles.minionGrid,
                gap: "space.100",
                alignItems: "center"
            }, minionId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtle"
            }, minionId) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtlest",
                testId: "disabled-minion-id"
            }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_disabled)), executionDuration !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtle"
            }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_execution_duration, {
                duration: executionDuration
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtlest",
                testId: "disabled-execution-duration"
            }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_disabled)), minionInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtle"
            }, typeof minionInput === 'object' ? JSON.stringify(minionInput, null, 2) : minionInput) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtlest",
                testId: "disabled-minion-input"
            }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_disabled)));
        }))))))));
};
module.exports["OrchestrationOverviewPanel"] = $a5b738d83e7d73f2$export$fb4e2149d28f72b3;

});

parcelRegister("8ynLJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $gRGWz = parcelRequire("gRGWz");


var $3nKR8 = parcelRequire("3nKR8");


var $lT1k3 = parcelRequire("lT1k3");


var $7LI7r = parcelRequire("7LI7r");

const $f9cc317b71411006$export$8eddb41fbb2fcd3f = ({ nonSearchPluginInvocations: nonSearchPluginInvocations })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: "sain-online-debugger-plugin-invocations-panel"
    }, nonSearchPluginInvocations.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.0"
    }, nonSearchPluginInvocations.map((plugin, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3nKR8.PluginInvocationItem), {
            key: plugin.plugin_invocation_id || index,
            plugin: plugin,
            index: index
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_no_plugins_invoked))));
};
module.exports["PluginInvocationsPanel"] = $f9cc317b71411006$export$8eddb41fbb2fcd3f;

});

parcelRegister("61d8U", function(module, exports) {
/* ranked-search-results-panel.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $3pCca = parcelRequire("3pCca");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $gRGWz = parcelRequire("gRGWz");


var $lT1k3 = parcelRequire("lT1k3");


var $7LI7r = parcelRequire("7LI7r");

const $1953b8642f0f994c$var$styles = {
    rankedDocsGrid: "_2iEGP2VIym _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _1Vs123NvrM _421I1o6wH8 _0obpEh9r67",
    gridHeader: "_0KLXruDMqu _0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _1aEeYeNvrM _3587oR6wH8 _1uR5uv9r67",
    gridCell: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _1aEeYeNvrM _3587oR6wH8 _1uR5uv9r67",
    gridUrlCell: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _1aEeYeNvrM _3587oR6wH8 _1uR5uv9r67 _3W2Oc84hR5"
};
const $1953b8642f0f994c$export$39197e0ebf675eb2 = ({ rankedDocumentsWithChunks: rankedDocumentsWithChunks })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: "sain-online-debugger-ranked-search-results-panel"
    }, rankedDocumentsWithChunks.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_no_ranked_search_results)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_ranked_search_results_heading, {
        count: rankedDocumentsWithChunks.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $1953b8642f0f994c$var$styles.rankedDocsGrid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1953b8642f0f994c$var$styles.gridHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_doc_index_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1953b8642f0f994c$var$styles.gridHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_url_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1953b8642f0f994c$var$styles.gridHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_chunk_id_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1953b8642f0f994c$var$styles.gridHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_chunk_score_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1953b8642f0f994c$var$styles.gridHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_chunk_rank_header))), rankedDocumentsWithChunks.map((doc, index)=>{
        const chunkCount = Math.max(doc.chunks.length, 1);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: `${doc.url}-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1953b8642f0f994c$var$styles.gridCell,
            style: {
                gridRow: `span ${chunkCount}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "semibold"
        }, index + 1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1953b8642f0f994c$var$styles.gridUrlCell,
            style: {
                gridRow: `span ${chunkCount}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: doc.url,
            target: "_blank"
        }, doc.url)), doc.chunks.length > 0 ? doc.chunks.map((chunk, chunkIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
                key: `${chunk.chunk_id}-${chunkIndex}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $1953b8642f0f994c$var$styles.gridCell
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, chunk.chunk_id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $1953b8642f0f994c$var$styles.gridCell
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, chunk.score.toFixed(4))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $1953b8642f0f994c$var$styles.gridCell
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, chunk.rank)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1953b8642f0f994c$var$styles.gridCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_unable_to_match_chunks))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1953b8642f0f994c$var$styles.gridCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, "-")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1953b8642f0f994c$var$styles.gridCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, "-"))));
    })))));
};
module.exports["RankedSearchResultsPanel"] = $1953b8642f0f994c$export$39197e0ebf675eb2;

});

parcelRegister("9UsEc", function(module, exports) {
/* raw-json-panel.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $azTKI = parcelRequire("azTKI");


var $fHs3z = parcelRequire("fHs3z");


var $chu6R = parcelRequire("chu6R");


var $iMnC5 = parcelRequire("iMnC5");


var $gRGWz = parcelRequire("gRGWz");


var $lT1k3 = parcelRequire("lT1k3");


var $7LI7r = parcelRequire("7LI7r");

const $08be90183ca9ea64$var$styles = {
    copyJsonButton: "_2XsHFMIZbP"
};
const $08be90183ca9ea64$var$formatJson = (data)=>{
    return JSON.stringify(data, null, 2);
};
const $08be90183ca9ea64$export$c1727a1710dac2d1 = ({ rawJson: rawJson })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [jsonCopied, setJsonCopied] = (0, $cozmU.useState)(false);
    const copyFinalResponseJson = (0, $cozmU.useCallback)(async ()=>{
        try {
            if (!rawJson) return;
            const jsonString = $08be90183ca9ea64$var$formatJson(rawJson);
            if (!jsonString) return;
            await navigator.clipboard.writeText(jsonString);
            setJsonCopied(true);
            setTimeout(()=>{
                setJsonCopied(false);
            }, 2500);
        } catch  {
            return;
        }
    }, [
        rawJson
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $08be90183ca9ea64$var$styles.copyJsonButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: copyFinalResponseJson,
        iconBefore: jsonCopied ? (0, (/*@__PURE__*/$parcel$interopDefault($chu6R))) : (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z)))
    }, jsonCopied ? formatMessage((0, $lT1k3.messages).ai_debugger_modal_copy_button_copied_text) : formatMessage((0, $lT1k3.messages).ai_debugger_modal_copy_button_text))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $azTKI.default), {
        language: "json",
        text: $08be90183ca9ea64$var$formatJson(rawJson ?? null),
        shouldWrapLongLines: true
    })));
};
module.exports["RawJsonPanel"] = $08be90183ca9ea64$export$c1727a1710dac2d1;

});

parcelRegister("kV3xA", function(module, exports) {
/* raw-search-results-panel.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $3pCca = parcelRequire("3pCca");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $gRGWz = parcelRequire("gRGWz");


var $lT1k3 = parcelRequire("lT1k3");


var $7LI7r = parcelRequire("7LI7r");

const $8a3882a721380e47$var$styles = {
    singleColumnGrid: "_2iEGP2UfmU _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _1Vs123NvrM _421I1o6wH8 _0obpEh9r67",
    gridHeader: "_0KLXruDMqu _0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _1aEeYeNvrM _3587oR6wH8 _1uR5uv9r67",
    gridUrlCell: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _1aEeYeNvrM _3587oR6wH8 _1uR5uv9r67 _3W2Oc84hR5"
};
const $8a3882a721380e47$export$4809e441463be887 = ({ searchResults: searchResults })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: "sain-online-debugger-raw-search-results-panel"
    }, searchResults.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_raw_search_results_heading, {
        count: searchResults.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $8a3882a721380e47$var$styles.singleColumnGrid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8a3882a721380e47$var$styles.gridHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_url_header))), searchResults.map((url, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: `${url}-${index}`,
            xcss: $8a3882a721380e47$var$styles.gridUrlCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: url,
            target: "_blank"
        }, url))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_no_raw_search_results))));
};
module.exports["RawSearchResultsPanel"] = $8a3882a721380e47$export$4809e441463be887;

});

parcelRegister("aAdO3", function(module, exports) {
/* request-overview-panel.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $3pCca = parcelRequire("3pCca");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $gRGWz = parcelRequire("gRGWz");


var $IOtUu = parcelRequire("IOtUu");


var $8MLeD = parcelRequire("8MLeD");


var $6Skkp = parcelRequire("6Skkp");


var $lT1k3 = parcelRequire("lT1k3");


var $7LI7r = parcelRequire("7LI7r");


var $78oRC = parcelRequire("78oRC");

const $9269137e932107dc$var$styles = {
    twoColumnGrid: "_2iEGP2Lmr7"
};
const $9269137e932107dc$export$fff5f67a3c73a716 = ({ originalQuery: originalQuery, transformedQuery: transformedQuery, traceId: traceId, intentDetectionTraceId: intentDetectionTraceId, intentDetectionTimestamp: intentDetectionTimestamp, originalIntent: originalIntent, finalRoutingDecision: finalRoutingDecision, detectionMetadata: detectionMetadata, modelName: modelName, cacheHit: cacheHit, sources: sources, isNaturalLanguageQuery: isNaturalLanguageQuery, invokedPluginNames: invokedPluginNames })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const intentDetectionTraceIdDiverged = !!intentDetectionTraceId && !!traceId && intentDetectionTraceId !== traceId;
    const displayCacheHit = cacheHit === null ? 'disabled' : cacheHit.toString();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: "sain-online-debugger-request-overview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $9269137e932107dc$var$styles.twoColumnGrid,
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_original_query_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, originalQuery ?? 'null')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_transformed_query_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, transformedQuery ?? 'null'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $9269137e932107dc$var$styles.twoColumnGrid,
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "sain-online-debugger-original-intent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_original_intent_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, originalIntent ?? 'null')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "sain-online-debugger-final-routing-decision"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_detected_intent_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, finalRoutingDecision ?? 'null')), intentDetectionTraceId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "sain-online-debugger-intent-detection-trace-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_intent_detection_trace_id_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intentDetectionTraceId), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MLeD.CopyButton), {
        copyText: intentDetectionTraceId,
        copyLabel: formatMessage((0, $lT1k3.messages).ai_debugger_modal_copy_intent_detection_trace_id_label),
        copiedLabel: formatMessage((0, $lT1k3.messages).ai_debugger_modal_trace_id_copied_text),
        testId: "sain-online-debugger-copy-intent-detection-trace-id-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $78oRC.SplunkLink), {
        traceId: intentDetectionTraceId,
        timestamp: intentDetectionTimestamp,
        variant: "intentDetection",
        testId: "sain-online-debugger-intent-detection-trace-id-splunk-link"
    })), intentDetectionTraceIdDiverged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.warning"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_intent_detection_trace_id_diverged))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_answer_trace_id_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, traceId ?? 'null'), traceId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MLeD.CopyButton), {
        copyText: traceId,
        copyLabel: formatMessage((0, $lT1k3.messages).ai_debugger_modal_copy_trace_id_label),
        copiedLabel: formatMessage((0, $lT1k3.messages).ai_debugger_modal_trace_id_copied_text),
        testId: "sain-online-debugger-copy-trace-id-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $78oRC.SplunkLink), {
        traceId: traceId,
        timestamp: intentDetectionTimestamp,
        testId: "sain-online-debugger-answer-trace-id-splunk-link"
    }))), isNaturalLanguageQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_model_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, modelName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_cached_answer_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, displayCacheHit)))), detectionMetadata && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_detection_metadata_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $9269137e932107dc$var$styles.twoColumnGrid,
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_detection_method_label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, detectionMetadata.method ?? 'null')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_detection_model_label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, detectionMetadata.model ?? 'null')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_detection_latency_label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, detectionMetadata.latencyMs ?? 'null')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_detection_cache_hit_label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, detectionMetadata.cacheHit === null ? 'null' : detectionMetadata.cacheHit.toString())))), isNaturalLanguageQuery && invokedPluginNames.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_plugins_invoked_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, invokedPluginNames.map((pluginName)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            key: pluginName,
            text: pluginName,
            color: (0, $6Skkp.getPluginTagColor)(pluginName),
            isRemovable: false,
            migration_fallback: "lozenge"
        })))), isNaturalLanguageQuery && sources.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_sources_subheading)), sources.map((source, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            key: source.ari ?? source.id,
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, index + 1, "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: source.url,
            target: "_blank"
        }, source.title))))));
};
module.exports["RequestOverviewPanel"] = $9269137e932107dc$export$fff5f67a3c73a716;

});

parcelRegister("apU4q", function(module, exports) {
/* agent-styles.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $e324c4543a86b9df$export$f23caa50568db2b0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDKTcp _39xV02Uofl _0jFU0VUofl",
            __cmplp.className
        ])
    });
});
module.exports["AgentStyles"] = $e324c4543a86b9df$export$f23caa50568db2b0;

});

parcelRegister("lJqiq", function(module, exports) {
/* person-styles.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $f72cf7c4fbe681a5$export$bf503936295d1d98 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _39xV02Uofl _0jFU0VUofl",
            __cmplp.className
        ])
    });
});
module.exports["PersonStyles"] = $f72cf7c4fbe681a5$export$bf503936295d1d98;

});

parcelRegister("43jvb", function(module, exports) {
/**
 * Converts a GraphQL __typename (PascalCase) to a human-readable format for alt text.
 *
 * Examples:
 * - "ConfluencePage" → "Confluence Page"
 * - "JiraIssue" → "Jira Issue"
 * - "BitbucketPullRequest" → "Bitbucket Pull Request"
 * - "TownsquareGoal" → "Townsquare Goal"
 *
 * @param typeName - The GraphQL __typename value
 * @returns Human-readable formatted string
 */ function $ef06f3dec2ca89f2$export$aeeed0811af42dc5(typeName) {
    if (!typeName) return '';
    let result = '';
    for(let i = 0; i < typeName.length; i++){
        const char = typeName[i];
        // Add space before uppercase letters (except the first character)
        if (i > 0 && char === char.toUpperCase() && char !== char.toLowerCase()) result += ' ';
        result += char;
    }
    return result;
}
module.exports["formatContentTypeName"] = $ef06f3dec2ca89f2$export$aeeed0811af42dc5;

});

parcelRegister("9K2hX", function(module, exports) {
/* work-styles.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $748919a09e20f311$export$b32bf078e8b397e9 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDdnbC _39xV02oWWg _0jFU0VoWWg",
            __cmplp.className
        ])
    });
});
module.exports["WorkStyles"] = $748919a09e20f311$export$b32bf078e8b397e9;

});

parcelRegister("kcKX3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $b366b346be0bef0b$var$BUTTON_WIDTH = 20;
const $b366b346be0bef0b$var$PADDING_BLOCK_END = 16;
const $b366b346be0bef0b$var$TOPIC_INLINE_SPACE = 8;
const $b366b346be0bef0b$export$6e050707ceb5a52f = (wrapperRef, showTopics)=>{
    const [breakElems, setBreakElems] = (0, $cozmU.useState)(-1);
    const [topicLengths, setTopicLengths] = (0, $cozmU.useState)([]);
    (0, $cozmU.useEffect)(()=>{
        const observer = new ResizeObserver((topics)=>{
            const wrapper = topics[0];
            const cwidth = wrapper.target.clientWidth;
            const tl = topicLengths;
            var runningWidth = 0;
            var elemsHold = 0;
            // on first run, all topics are displayed so we can loop through and get the lengths
            if (tl.length === 0) for (const topic of Array.from(wrapper.target.children)){
                const width = topic.scrollWidth;
                tl.push(width);
            }
            for(let i = 0; i < tl.length; i++){
                const width = topicLengths[i];
                if (runningWidth + width + $b366b346be0bef0b$var$PADDING_BLOCK_END + $b366b346be0bef0b$var$BUTTON_WIDTH <= cwidth) elemsHold += 1;
                runningWidth += width + $b366b346be0bef0b$var$TOPIC_INLINE_SPACE;
            }
            setBreakElems(elemsHold);
            // on first run, save the topic lengths so we can reuse
            if (topicLengths.length === 0) setTopicLengths(tl);
        });
        if (wrapperRef.current) observer.observe(wrapperRef.current);
        return ()=>{
            observer.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showTopics
    ]);
    return {
        breakElems: breakElems
    };
};
module.exports["useTopicBreakElems"] = $b366b346be0bef0b$export$6e050707ceb5a52f;

});

parcelRegister("1Nf9V", function(module, exports) {
const $c6236f5d17be7ea0$export$fda8ebbceae980b6 = (answerGenerationModel)=>{
    if (answerGenerationModel?.model_usage && typeof answerGenerationModel.model_usage === 'object') {
        const keys = Object.keys(answerGenerationModel.model_usage);
        return keys[0] ?? 'null';
    }
    return 'null';
};
module.exports["extractModelName"] = $c6236f5d17be7ea0$export$fda8ebbceae980b6;

});

parcelRegister("dP3C2", function(module, exports) {
const $f5b0b766cbb1f718$export$25fa9bb580a33ec7 = (pluginInvocations)=>{
    if (!Array.isArray(pluginInvocations)) return [];
    return [
        ...new Set(pluginInvocations.map((p)=>p.plugin_name).filter((name)=>Boolean(name)))
    ];
};
module.exports["extractUniquePluginNames"] = $f5b0b766cbb1f718$export$25fa9bb580a33ec7;

});

parcelRegister("4762y", function(module, exports) {

var $9kYnS = parcelRequire("9kYnS");

const $b5380383f002e2ac$export$fabd92b0068ace48 = (minionOutputs)=>{
    if (!Array.isArray(minionOutputs)) return [];
    return minionOutputs.filter((minion)=>{
        const minionInfo = Array.isArray(minion) ? minion[0] : minion;
        return !minionInfo.minion_id?.toLowerCase().includes((0, $9kYnS.MinionName).SEARCH);
    });
};
module.exports["filterNonSearchMinions"] = $b5380383f002e2ac$export$fabd92b0068ace48;

});

parcelRegister("4hGoz", function(module, exports) {

var $badUP = parcelRequire("badUP");

const $f2a3a514766e6b00$export$b79df509190735d5 = (pluginInvocations)=>{
    if (!Array.isArray(pluginInvocations)) return [];
    return pluginInvocations.filter((plugin)=>plugin.plugin_name !== (0, $badUP.PluginName).SEARCH);
};
module.exports["filterNonSearchPlugins"] = $f2a3a514766e6b00$export$b79df509190735d5;

});

parcelRegister("izeRj", function(module, exports) {
const $7e45e15a5194ddbf$export$1f23ec3fd5426403 = (searchExtraInfo)=>{
    if (!searchExtraInfo?.rankedDocuments || !searchExtraInfo?.rawRankedDocumentsInfoMap) return [];
    const { rankedDocuments: rankedDocuments, rawRankedDocumentsInfoMap: rawRankedDocumentsInfoMap } = searchExtraInfo;
    const chunkArrays = Object.values(rawRankedDocumentsInfoMap);
    return rankedDocuments.map((url, index)=>({
            url: url,
            chunks: chunkArrays[index]?.sort((a, b)=>a.chunk_id - b.chunk_id) ?? []
        }));
};
module.exports["getRankedDocumentsWithChunks"] = $7e45e15a5194ddbf$export$1f23ec3fd5426403;

});

parcelRegister("4WM05", function(module, exports) {

var $9kYnS = parcelRequire("9kYnS");

const $064360b402655e5b$export$bf63c148d8c5608b = (minionOutputs)=>{
    if (!Array.isArray(minionOutputs)) return null;
    // Find search minion - check if minion_id contains 'search' (case insensitive)
    const searchMinion = minionOutputs.find((minion)=>{
        const minionInfo = Array.isArray(minion) ? minion[0] : minion;
        return minionInfo.minion_id?.toLowerCase().includes((0, $9kYnS.MinionName).SEARCH);
    });
    if (!searchMinion) return null;
    const minionInfo = Array.isArray(searchMinion) ? searchMinion[0] : searchMinion;
    if (!minionInfo.minion_extra_info) return null;
    try {
        const parsedExtraInfo = JSON.parse(minionInfo.minion_extra_info);
        // Extract from functionMessage.pluginInvocationInfo.extraInfo
        if (parsedExtraInfo.functionMessage?.pluginInvocationInfo?.extraInfo) try {
            return JSON.parse(parsedExtraInfo.functionMessage.pluginInvocationInfo.extraInfo);
        } catch  {
            return null;
        }
        return null;
    } catch  {
        return null;
    }
};
module.exports["getSearchResultsFromMinions"] = $064360b402655e5b$export$bf63c148d8c5608b;

});

parcelRegister("614SU", function(module, exports) {

var $badUP = parcelRequire("badUP");

const $a5a5f591ff56ba7b$export$9007e115c1a30684 = (pluginInvocations)=>{
    if (!Array.isArray(pluginInvocations)) return null;
    const searchPlugin = pluginInvocations.find((plugin)=>plugin.plugin_name === (0, $badUP.PluginName).SEARCH);
    if (!searchPlugin?.plugin_extra_info) return null;
    try {
        return JSON.parse(searchPlugin.plugin_extra_info);
    } catch  {
        return null;
    }
};
module.exports["getSearchResultsFromPlugins"] = $a5a5f591ff56ba7b$export$9007e115c1a30684;

});

parcelRegister("agj0v", function(module, exports) {
const $dbb4f2f53a15a957$export$15d9e451202b41ba = (pluginSearchInfo, minionSearchInfo)=>{
    // If we have plugin search info, use it (it has more complete data like rawRankedDocumentsInfoMap)
    if (pluginSearchInfo) return pluginSearchInfo;
    // Otherwise, use minion search info
    return minionSearchInfo;
};
module.exports["mergeSearchExtraInfo"] = $dbb4f2f53a15a957$export$15d9e451202b41ba;

});

parcelRegister("9S2qh", function(module, exports) {
const $389964e4852aec55$export$60b013a10d8ce23 = (cacheInfo)=>{
    if (!cacheInfo) return null;
    return cacheInfo.cache_hit ?? null;
};
module.exports["normalizeCacheHit"] = $389964e4852aec55$export$60b013a10d8ce23;

});

parcelRegister("hmEvS", function(module, exports) {
const $88d38fecedfe221e$export$cff16549bafd61f9 = (detectionMetadata)=>detectionMetadata ? {
        method: detectionMetadata.method ?? null,
        model: detectionMetadata.model ?? null,
        latencyMs: typeof detectionMetadata.latencyMs === 'number' ? detectionMetadata.latencyMs : null,
        cacheHit: typeof detectionMetadata.cacheHit === 'boolean' ? detectionMetadata.cacheHit : null
    } : null;
module.exports["normalizeDetectionMetadata"] = $88d38fecedfe221e$export$cff16549bafd61f9;

});

parcelRegister("cOpQd", function(module, exports) {

var $zzZbq = parcelRequire("zzZbq");

const $79d074a9a2b31656$var$isPersonIntent = (intentData)=>intentData.classification === (0, $zzZbq.QueryIntent).PERSON;
const $79d074a9a2b31656$export$1cd69381fdad244f = (intentData, detectionMetadata)=>{
    const persons = intentData && $79d074a9a2b31656$var$isPersonIntent(intentData) && Array.isArray(intentData.persons) ? intentData.persons : [];
    const prefilterEntities = detectionMetadata?.prefilterEntities ?? [];
    const originalIntent = detectionMetadata?.originalIntent ?? null;
    const elsTraceId = detectionMetadata?.elsTraceId ?? null;
    const hasElsData = prefilterEntities.length > 0 || persons.length > 0 || elsTraceId !== null;
    return {
        hasElsData: hasElsData,
        finalRoutingDecision: intentData?.classification ?? null,
        originalIntent: originalIntent,
        elsTraceId: elsTraceId,
        timestamp: detectionMetadata?.timestamp ?? null,
        prefilterEntities: prefilterEntities,
        persons: persons
    };
};
module.exports["normalizeElsOverview"] = $79d074a9a2b31656$export$1cd69381fdad244f;

});

parcelRegister("5J4us", function(module, exports) {

var $2adW1 = parcelRequire("2adW1");


var $baaZA = parcelRequire("baaZA");

const $ef1500d73dac0c9e$export$702a9b90e43f0129 = (text)=>{
    const match = text.match(/\[([^\]]+)\]\(([^)]+)\)/);
    if (!match) return null;
    const [, name, url] = match;
    const accountIdMatch = url.match(/\/people\/([^/]+)/);
    const accountId = accountIdMatch ? accountIdMatch[1] : null;
    return {
        name: name,
        url: url,
        accountId: accountId
    };
};
const $ef1500d73dac0c9e$export$167366d10321aef5 = (minionExtraInfo, minionId, isSearchMinion)=>{
    let extraInfo = null;
    let parsedOutput = null;
    let functionResults = null;
    let searchExtraInfo = null;
    if (!minionExtraInfo) return {
        extraInfo: extraInfo,
        parsedOutput: parsedOutput,
        functionResults: functionResults,
        searchExtraInfo: searchExtraInfo
    };
    try {
        const parsedExtraInfo = JSON.parse(minionExtraInfo);
        // Case 1 & 2: Has functionMessage (single function call result)
        if (parsedExtraInfo.functionMessage) {
            const { pluginInvocationInfo: pluginInvocationInfo, output: output } = parsedExtraInfo.functionMessage;
            if (isSearchMinion && pluginInvocationInfo?.extraInfo) // Search minion: extract nested search results from extraInfo
            try {
                searchExtraInfo = JSON.parse(pluginInvocationInfo.extraInfo);
            } catch  {
                extraInfo = pluginInvocationInfo.extraInfo;
            }
            else {
                // Non-search minion: parse the output for structured display
                const rawOutput = pluginInvocationInfo?.output || output;
                if (typeof rawOutput === 'string') {
                    parsedOutput = (0, $baaZA.parsePluginOutput)(minionId, rawOutput);
                    if (!parsedOutput) extraInfo = rawOutput;
                }
            }
        } else if (Array.isArray(parsedExtraInfo.results) && parsedExtraInfo.results.length > 0) functionResults = parsedExtraInfo.results;
        else if (parsedExtraInfo.content) extraInfo = parsedExtraInfo.content;
    } catch  {
        // Case 5: JSON parsing failed, use raw string
        extraInfo = minionExtraInfo;
    }
    return {
        extraInfo: extraInfo,
        parsedOutput: parsedOutput,
        functionResults: functionResults,
        searchExtraInfo: searchExtraInfo
    };
};
const $ef1500d73dac0c9e$export$f14fe30fd1a0b725 = (minionOutputs)=>{
    if (!Array.isArray(minionOutputs) || minionOutputs.length === 0) return [];
    // Check if it's already a rounds structure (array of arrays)
    if ((0, $2adW1.isOrchestrationStructure)(minionOutputs)) return minionOutputs;
    // Wrap flat array in a single round
    return [
        minionOutputs
    ];
};
module.exports["parseMarkdownLink"] = $ef1500d73dac0c9e$export$702a9b90e43f0129;
module.exports["parseMinionExtraInfo"] = $ef1500d73dac0c9e$export$167366d10321aef5;
module.exports["getOrchestrationRounds"] = $ef1500d73dac0c9e$export$f14fe30fd1a0b725;

});

parcelRegister("8MLeD", function(module, exports) {
/* copy-button.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $fHs3z = parcelRequire("fHs3z");


var $chu6R = parcelRequire("chu6R");


var $hBYtq = parcelRequire("hBYtq");


var $lpNn5 = parcelRequire("lpNn5");

const $f4001d2d7d88a108$var$TIMEOUT_DELAY = 2500;
const $f4001d2d7d88a108$var$buttonStyles = {
    root: "_0bjKvDKxmn _0jFU0Vey7F _39xV02ey7F _03SyCPPgdg _0LQT5EPgdg",
    cursorDisabledStyles: "_30huDKYbGa _0wOv4Q18ZR"
};
const $f4001d2d7d88a108$export$4f2558dd25106ae2 = ({ copyText: copyText, copyLabel: copyLabel, copiedLabel: copiedLabel, testId: testId })=>{
    const [isCopied, setIsCopied] = (0, $cozmU.useState)(false);
    const [currentTooltipLabel, setCurrentTooltipLabel] = (0, $cozmU.useState)(copyLabel);
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useLayoutEffect(()=>{
        updateTooltip.current?.();
    }, [
        currentTooltipLabel
    ]);
    const copyTextToClipboard = async ()=>{
        try {
            if (!copyText) return;
            await navigator.clipboard.writeText(copyText);
            setIsCopied(true);
            setCurrentTooltipLabel(copiedLabel);
            setTimeout(()=>{
                setIsCopied(false);
                setCurrentTooltipLabel(copyLabel);
            }, $f4001d2d7d88a108$var$TIMEOUT_DELAY);
        } catch (_e) {
            // Failed to copy
            throw new Error('Failed to copy');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return currentTooltipLabel;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($f4001d2d7d88a108$var$buttonStyles.root, isCopied ? $f4001d2d7d88a108$var$buttonStyles.cursorDisabledStyles : undefined),
        isDisabled: isCopied,
        onClick: copyTextToClipboard,
        "aria-label": copyLabel,
        testId: testId
    }, isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        label: copiedLabel,
        color: "var(--ds-icon-accent-green, #22A06B)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
        label: copyLabel,
        color: "var(--ds-icon-subtle, #505258)"
    })));
};
module.exports["CopyButton"] = $f4001d2d7d88a108$export$4f2558dd25106ae2;

});

parcelRegister("6VKp9", function(module, exports) {
/* expandable-section.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $lT1k3 = parcelRequire("lT1k3");

const $46a35387fb0a1175$var$styles = {
    borderedBox: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXru66of",
    header: "_0Of8r22ADO _1Znuxb8HPE _1wydGW2ADO _2Zuz6Q8HPE _0wOv4Q7zJH _39xV02N91d",
    content: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67"
};
const $46a35387fb0a1175$export$e86ef41bc845761 = ({ title: title, children: children, defaultExpanded: defaultExpanded = false, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $46a35387fb0a1175$var$styles.borderedBox,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: ()=>setIsExpanded(!isExpanded),
        xcss: $46a35387fb0a1175$var$styles.header,
        testId: testId ? `${testId}-toggle` : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_collapse_label),
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_expand_label),
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "bold"
    }, title))), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $46a35387fb0a1175$var$styles.content,
        testId: testId ? `${testId}-content` : undefined
    }, children));
};
module.exports["ExpandableSection"] = $46a35387fb0a1175$export$e86ef41bc845761;

});

parcelRegister("7LI7r", function(module, exports) {
/* panel-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $dinVW = parcelRequire("dinVW");

const $8493a884ae6435e0$var$styles = {
    root: "_39xV02N91d _0Of8r22ADO _1wydGW2ADO"
};
const $8493a884ae6435e0$export$2ddb90ad54e5f587 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $8493a884ae6435e0$var$styles.root,
        testId: testId
    }, children);
module.exports["Panel"] = $8493a884ae6435e0$export$2ddb90ad54e5f587;

});

parcelRegister("78oRC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $aE8iq = parcelRequire("aE8iq");


var $en9UX = parcelRequire("en9UX");


var $8C3jf = parcelRequire("8C3jf");


var $lT1k3 = parcelRequire("lT1k3");

const $f6b57ecb1a8b1f03$var$getSplunkUrlForVariant = (variant, traceId, timestamp)=>{
    switch(variant){
        case 'intentDetection':
            return (0, $en9UX.getSplunkIntentDetectionTraceUrl)(traceId, timestamp);
        case 'els':
            return (0, $aE8iq.getSplunkElsTraceUrl)(traceId, timestamp);
        default:
            return (0, $8C3jf.getSplunkTraceUrl)(traceId, timestamp);
    }
};
const $f6b57ecb1a8b1f03$export$456be951bc279306 = ({ traceId: traceId, timestamp: timestamp, variant: variant = 'default', testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const splunkUrl = $f6b57ecb1a8b1f03$var$getSplunkUrlForVariant(variant, traceId, timestamp);
    if (!splunkUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: splunkUrl,
        target: "_blank",
        testId: testId
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_splunk_link_label));
};
module.exports["SplunkLink"] = $f6b57ecb1a8b1f03$export$456be951bc279306;

});

parcelRegister("kJmyb", function(module, exports) {
const $a21a1dd5d77d9ec8$export$be4d3e7f2d62c728 = (minion)=>{
    return Array.isArray(minion) ? minion[0] : minion;
};
module.exports["getMinionOutputItem"] = $a21a1dd5d77d9ec8$export$be4d3e7f2d62c728;

});

parcelRegister("9kYnS", function(module, exports) {
var $b79ec1f3f50b1758$export$ea22648b9de9e52c = /*#__PURE__*/ function(MinionName) {
    MinionName["TEAMWORK_AGENT"] = "TeamworkAgent";
    MinionName["SEARCH"] = "search";
    return MinionName;
}({});
module.exports["MinionName"] = $b79ec1f3f50b1758$export$ea22648b9de9e52c;

});

parcelRegister("2IyOa", function(module, exports) {
/* function-result.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $5avUB = parcelRequire("5avUB");


var $chu6R = parcelRequire("chu6R");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $c6XYw = parcelRequire("c6XYw");


var $lT1k3 = parcelRequire("lT1k3");

const $a85b82d1edaf032f$var$functionResultStyles = {
    functionCard: "_0bjKvDKxmn _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0KLXruDMqu",
    outputContent: "_0bjKvDKxmn _4bt5LAIZbP _2WAcuGIZbP _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0KLXru66of _0NUa3rBfNa",
    preformatted: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _1ANEUSlpBW _0WKd3Gfx9v"
};
const $a85b82d1edaf032f$export$c460f77fbe5ab0de = ({ result: result, index: index })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const info = result.pluginInvocationInfo;
    if (!info) return null;
    const isSuccess = info.status === (0, $c6XYw.FunctionResultStatus).SUCCESS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a85b82d1edaf032f$var$functionResultStyles.functionCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: ()=>setIsExpanded(!isExpanded)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_collapse_label),
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_expand_label),
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        size: "small"
    }, index + 1, ". ", info.name || 'Unknown Function')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        label: info.status || 'Unknown',
        color: "var(--ds-icon-success, #6A9A23)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
        label: info.status || 'Unknown',
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: isSuccess ? 'color.text.success' : 'color.text.danger'
    }, info.status || 'Unknown')))), isExpanded && info.output && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a85b82d1edaf032f$var$functionResultStyles.outputContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "pre",
        xcss: $a85b82d1edaf032f$var$functionResultStyles.preformatted
    }, info.output))));
};
module.exports["FunctionResult"] = $a85b82d1edaf032f$export$c460f77fbe5ab0de;

});

parcelRegister("3AbYV", function(module, exports) {
/* plugin-output-renderer.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $lT1k3 = parcelRequire("lT1k3");


var $fa5QD = parcelRequire("fa5QD");


var $6fiLQ = parcelRequire("6fiLQ");


var $9nsLV = parcelRequire("9nsLV");

const $65960bc791dba5c8$var$styles = {
    numberBox: "_4ouGXIoWWg _3YEZNOdnbC",
    linkBox: "_4bt5LAnQyn _2WAcuGnQyn _3W2Oc8wPeg _2O5Vij7dHp",
    divider: "_0jFU0VHZdu _0KLXruDMqu _3138428HPE _1DCdHi8HPE"
};
const $65960bc791dba5c8$var$TeamworkRenderer = ({ data: data })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, data.data.header && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, data.data.header), data.data.sections.map((section, sectionIdx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            key: sectionIdx,
            space: "space.150"
        }, section.sectionHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium",
            size: "small"
        }, section.sectionHeader), section.teams && section.teams.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, section.teams.map((team, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9nsLV.TeamworkTeamCard), {
                key: idx,
                team: team,
                index: idx
            }))), section.documents && section.documents.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, section.documents.map((doc, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6fiLQ.TeamworkDocumentCard), {
                key: idx,
                doc: doc,
                index: idx
            }))))));
};
const $65960bc791dba5c8$var$SearchPluginRenderer = ({ extraInfo: extraInfo })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, extraInfo.searchResults && extraInfo.searchResults.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_search_results_heading, {
        count: extraInfo.searchResults.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, extraInfo.searchResults.map((url, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            key: idx,
            space: "space.050",
            alignBlock: "start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $65960bc791dba5c8$var$styles.numberBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, idx + 1, ".")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $65960bc791dba5c8$var$styles.linkBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: url,
            target: "_blank"
        }, url)))))), extraInfo.searchResults && extraInfo.searchResults.length > 0 && extraInfo.rankedDocuments && extraInfo.rankedDocuments.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $65960bc791dba5c8$var$styles.divider
    }), extraInfo.rankedDocuments && extraInfo.rankedDocuments.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_ranked_documents_heading, {
        count: extraInfo.rankedDocuments.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, extraInfo.rankedDocuments.map((url, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            key: idx,
            space: "space.050",
            alignBlock: "start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $65960bc791dba5c8$var$styles.numberBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, idx + 1, ".")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $65960bc791dba5c8$var$styles.linkBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: url,
            target: "_blank"
        }, url)))))));
};
const $65960bc791dba5c8$export$50ae64692e52fc4f = ({ parsedOutput: parsedOutput, extraInfo: extraInfo })=>{
    // Render based on parsed output type
    if (parsedOutput) switch(parsedOutput.type){
        case 'teamwork':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($65960bc791dba5c8$var$TeamworkRenderer, {
                data: parsedOutput
            });
        case 'pageSearch':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fa5QD.PageSearchCard), {
                data: parsedOutput.data
            });
    }
     // Fallback to string display
    if (typeof extraInfo === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, extraInfo);
     // Render search plugin extra info
    if (extraInfo && (extraInfo.searchResults || extraInfo.rankedDocuments)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($65960bc791dba5c8$var$SearchPluginRenderer, {
        extraInfo: extraInfo
    });
    return null;
};
module.exports["PluginOutputRenderer"] = $65960bc791dba5c8$export$50ae64692e52fc4f;

});

parcelRegister("3nKR8", function(module, exports) {
/* plugin-invocation.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $5avUB = parcelRequire("5avUB");


var $chu6R = parcelRequire("chu6R");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $lPcf8 = parcelRequire("lPcf8");


var $lT1k3 = parcelRequire("lT1k3");


var $baaZA = parcelRequire("baaZA");


var $kBYCn = parcelRequire("kBYCn");


var $badUP = parcelRequire("badUP");


var $3AbYV = parcelRequire("3AbYV");

/**
 * Parses plugin data to extract displayable information.
 *
 * Different plugin types have different data structures:
 *
 * 1. Search Plugin:
 *    - Uses plugin_extra_info containing searchResults/rankedDocuments as JSON
 *    - Falls back to raw string if JSON parsing fails
 *
 * 2. Other Plugins (Teamwork, People, Page Search, etc.):
 *    - Uses plugin_output containing structured text
 *    - Attempts to parse output using parsePluginOutput for structured display
 */ const $de25e2fc659989b5$var$parsePluginExtraInfo = ({ pluginName: pluginName, pluginExtraInfo: pluginExtraInfo, pluginOutput: pluginOutput })=>{
    let extraInfo;
    let parsedOutput = null; // Search plugin: parse plugin_extra_info for search results
    if (pluginName === (0, $badUP.PluginName).SEARCH) try {
        if (pluginExtraInfo) extraInfo = JSON.parse(pluginExtraInfo);
    } catch  {
        extraInfo = pluginExtraInfo;
    }
    else {
        extraInfo = pluginOutput;
        if (typeof extraInfo === 'string') parsedOutput = (0, $baaZA.parsePluginOutput)(pluginName, extraInfo);
    }
    return {
        extraInfo: extraInfo,
        parsedOutput: parsedOutput
    };
};
const $de25e2fc659989b5$var$pluginInvocationStyles = {
    pressable: "_0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0wOv4Q7zJH _39xV02N91d",
    content: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXru66of"
};
const $de25e2fc659989b5$export$213f6c57639a4547 = ({ plugin: plugin, index: index })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const isSuccess = plugin.plugin_invocation_status === (0, $kBYCn.PluginInvocationStatus).PLUGIN_FINISHED;
    const StatusIcon = isSuccess ? (0, (/*@__PURE__*/$parcel$interopDefault($chu6R))) : (0, (/*@__PURE__*/$parcel$interopDefault($5avUB)));
    const statusColor = isSuccess ? "var(--ds-icon-success, #6A9A23)" : "var(--ds-icon-danger, #C9372C)";
    const statusText = isSuccess ? formatMessage((0, $lT1k3.messages).ai_debugger_modal_success_label) : formatMessage((0, $lT1k3.messages).ai_debugger_modal_failed_label);
    const expandLabel = formatMessage((0, $lT1k3.messages).ai_debugger_modal_expand_label);
    const collapseLabel = formatMessage((0, $lT1k3.messages).ai_debugger_modal_collapse_label);
    const { extraInfo: extraInfo, parsedOutput: parsedOutput } = $de25e2fc659989b5$var$parsePluginExtraInfo({
        pluginName: plugin.plugin_name,
        pluginExtraInfo: plugin.plugin_extra_info,
        pluginOutput: plugin.plugin_output
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: ()=>setIsExpanded(!isExpanded),
        xcss: $de25e2fc659989b5$var$pluginInvocationStyles.pressable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: collapseLabel,
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: expandLabel,
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, plugin.plugin_name || `Plugin ${index + 1}`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(StatusIcon, {
        label: statusText,
        color: statusColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: isSuccess ? 'color.text.success' : 'color.text.danger'
    }, statusText)))), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $de25e2fc659989b5$var$pluginInvocationStyles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3AbYV.PluginOutputRenderer), {
        parsedOutput: parsedOutput,
        extraInfo: extraInfo
    })))));
};
module.exports["PluginInvocationItem"] = $de25e2fc659989b5$export$213f6c57639a4547;

});

parcelRegister("6Skkp", function(module, exports) {

var $iQ1xn = parcelRequire("iQ1xn");

const $e9a86c11a9e34acc$export$cb8121cdf102bdd9 = (pluginName)=>{
    if (!pluginName) return 0, $iQ1xn.DEFAULT_PLUGIN_TAG_COLOR;
    if (pluginName in (0, $iQ1xn.PLUGIN_TAG_COLOR)) return (0, $iQ1xn.PLUGIN_TAG_COLOR)[pluginName];
    return 0, $iQ1xn.DEFAULT_PLUGIN_TAG_COLOR;
};
module.exports["getPluginTagColor"] = $e9a86c11a9e34acc$export$cb8121cdf102bdd9;

});

parcelRegister("badUP", function(module, exports) {
var $3a16d2177b76af26$export$a80387b071fd4173 = /*#__PURE__*/ function(PluginName) {
    PluginName["TEAMWORK"] = "teamwork";
    PluginName["PAGE_SEARCH_PLUGIN"] = "Page-Search-Plugin";
    PluginName["SEARCH"] = "search";
    PluginName["PEOPLE"] = "people";
    return PluginName;
}({});
module.exports["PluginName"] = $3a16d2177b76af26$export$a80387b071fd4173;

});

parcelRegister("2adW1", function(module, exports) {
const $1020c2e6b7181502$export$a5ce513682ddb349 = (minionOutputs)=>{
    if (!Array.isArray(minionOutputs) || minionOutputs.length === 0) return false;
    // Check if first element is an array (indicating rounds structure)
    return Array.isArray(minionOutputs[0]);
};
module.exports["isOrchestrationStructure"] = $1020c2e6b7181502$export$a5ce513682ddb349;

});

parcelRegister("baaZA", function(module, exports) {

var $390xH = parcelRequire("390xH");


var $8L4Ur = parcelRequire("8L4Ur");


var $badUP = parcelRequire("badUP");

const $fa720d82c3e4bf85$export$cc2e1f911cfb137c = (pluginName, output)=>{
    switch(pluginName){
        case (0, $badUP.PluginName).TEAMWORK:
            {
                const teamworkData = (0, $8L4Ur.parseTeamworkOutput)(output);
                if (teamworkData) return {
                    type: 'teamwork',
                    data: teamworkData
                };
                break;
            }
        case (0, $badUP.PluginName).PAGE_SEARCH_PLUGIN:
            {
                const pageSearchData = (0, $390xH.parsePageSearchOutput)(output);
                if (pageSearchData) return {
                    type: 'pageSearch',
                    data: pageSearchData
                };
                break;
            }
    }
    return null;
};
module.exports["parsePluginOutput"] = $fa720d82c3e4bf85$export$cc2e1f911cfb137c;

});

parcelRegister("aE8iq", function(module, exports) {

var $7xFlv = parcelRequire("7xFlv");


var $grLIz = parcelRequire("grLIz");

const $815557be36c5b1a7$export$a13411c4aa89e097 = (traceId, timestamp)=>{
    if (!traceId) return undefined;
    return (0, $7xFlv.buildSplunkUrl)(`\`micros_kserving-entity-linking\` env=prod* ${traceId}`, (0, $grLIz.getSplunkTimeRangeParams)(timestamp));
};
module.exports["getSplunkElsTraceUrl"] = $815557be36c5b1a7$export$a13411c4aa89e097;

});

parcelRegister("en9UX", function(module, exports) {

var $7xFlv = parcelRequire("7xFlv");


var $grLIz = parcelRequire("grLIz");

const $b0aa489ea03f4abc$export$204726a50d73a25 = (traceId, timestamp)=>{
    if (!traceId) return undefined;
    return (0, $7xFlv.buildSplunkUrl)(`\`micros_xp-knowledge-discovery\` traceId = "${traceId}"`, (0, $grLIz.getSplunkTimeRangeParams)(timestamp));
};
module.exports["getSplunkIntentDetectionTraceUrl"] = $b0aa489ea03f4abc$export$204726a50d73a25;

});

parcelRegister("8C3jf", function(module, exports) {

var $7xFlv = parcelRequire("7xFlv");


var $grLIz = parcelRequire("grLIz");

const $75378f8170efa456$export$a60a055e6522aaa = (traceId, timestamp)=>{
    if (!traceId) return undefined;
    return (0, $7xFlv.buildSplunkUrl)(`traceId = "${traceId}"`, (0, $grLIz.getSplunkTimeRangeParams)(timestamp));
};
module.exports["getSplunkTraceUrl"] = $75378f8170efa456$export$a60a055e6522aaa;

});

parcelRegister("c6XYw", function(module, exports) {
var $27d32892120f0993$export$5731613326371a4a = /*#__PURE__*/ function(FunctionResultStatus) {
    FunctionResultStatus["SUCCESS"] = "SUCCESS";
    FunctionResultStatus["ERROR"] = "ERROR";
    return FunctionResultStatus;
}({});
module.exports["FunctionResultStatus"] = $27d32892120f0993$export$5731613326371a4a;

});

parcelRegister("fa5QD", function(module, exports) {
/* page-search-card.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $lT1k3 = parcelRequire("lT1k3");


const $cb3cafbeb8a13861$var$Card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("bE9h1")).then(({ Card: Card })=>({
            default: Card
        })));
const $cb3cafbeb8a13861$var$styles = {
    card: "_0bjKvDKxmn _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _0KLXruDMqu _1DCdHi2ADO",
    itemNumber: "_4ouGXIoWWg _3YEZNOdnbC _1ANEUSLRg7",
    snippet: "_4bt5LAnQyn _2WAcuGnQyn _3W2Oc8wPeg"
};
const $cb3cafbeb8a13861$var$PageCard = ({ page: page, index: index })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb3cafbeb8a13861$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb3cafbeb8a13861$var$styles.itemNumber
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        color: "color.text"
    }, index + 1, ".")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, page.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: page.url,
            target: "_blank"
        }, page.title)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb3cafbeb8a13861$var$Card, {
        appearance: "inline",
        url: page.url
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, page.title), page.space && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_page_search_space, {
        space: page.space
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200"
    }, page.author && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_author_label, {
        author: page.author
    })), page.date && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, page.date)), page.snippet && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb3cafbeb8a13861$var$styles.snippet
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, page.snippet))));
};
const $cb3cafbeb8a13861$export$fbdb7e4b907b475b = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, data.header && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, data.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_page_search_count, {
        count: data.pages.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, data.pages.map((page, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb3cafbeb8a13861$var$PageCard, {
            key: idx,
            page: page,
            index: idx
        }))));
};
module.exports["PageSearchCard"] = $cb3cafbeb8a13861$export$fbdb7e4b907b475b;

});

parcelRegister("6fiLQ", function(module, exports) {
/* teamwork-document-card.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $jxGuq = parcelRequire("jxGuq");


var $lT1k3 = parcelRequire("lT1k3");

const $ce675b55a4c0c1d4$var$pluginInvocationStyles = {
    teamworkCard: "_0bjKvDKxmn _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _0KLXruDMqu _1DCdHi2ADO",
    teamworkItemNumber: "_4ouGXIoWWg _3YEZNOdnbC _1ANEUSLRg7"
};
const $ce675b55a4c0c1d4$export$4bdcb2db328c0713 = ({ doc: doc, index: index })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ce675b55a4c0c1d4$var$pluginInvocationStyles.teamworkCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ce675b55a4c0c1d4$var$pluginInvocationStyles.teamworkItemNumber
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, index + 1, ".")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, doc.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: doc.url,
        target: "_blank"
    }, doc.title || doc.url) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, doc.title), doc.type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, doc.type))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200",
        alignBlock: "center"
    }, doc.author && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_author_label, {
        author: (0, $jxGuq.formatMarkdownLinkAsText)(doc.author)
    })), doc.updated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_teamwork_document_updated, {
        date: new Date(doc.updated).toLocaleDateString()
    }))), doc.ari && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, doc.ari)));
};
module.exports["TeamworkDocumentCard"] = $ce675b55a4c0c1d4$export$4bdcb2db328c0713;

});

parcelRegister("9nsLV", function(module, exports) {
/* teamwork-team-card.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $jxGuq = parcelRequire("jxGuq");


var $lT1k3 = parcelRequire("lT1k3");

const $090b81aac414f11d$var$pluginInvocationStyles = {
    teamworkCard: "_0bjKvDKxmn _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _0KLXruDMqu _1DCdHi2ADO",
    teamworkMembersList: "_4bt5LAIZbP _2WAcuGIZbP _3138422ADO _2XsHFMNHnM _0NUa3rgZxp",
    teamworkItemNumber: "_4ouGXIoWWg _3YEZNOdnbC _1ANEUSLRg7"
};
const $090b81aac414f11d$export$f27472f36b5cad7b = ({ team: team, index: index })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [showMembers, setShowMembers] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $090b81aac414f11d$var$pluginInvocationStyles.teamworkCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $090b81aac414f11d$var$pluginInvocationStyles.teamworkItemNumber
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        color: "color.text"
    }, index + 1, ".")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        color: "color.text"
    }, team.name || formatMessage((0, $lT1k3.messages).ai_debugger_modal_teamwork_unnamed_team))), team.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, team.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200",
        alignBlock: "center"
    }, team.memberCount !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_teamwork_members_count, {
        count: team.memberCount
    })), team.teamState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_teamwork_state, {
        state: team.teamState
    }))), team.creator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_teamwork_creator, {
        creator: team.creator
    })), team.ari && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, team.ari), team.members.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        iconBefore: showMembers ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))),
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setShowMembers(!showMembers)
    }, showMembers ? formatMessage((0, $lT1k3.messages).ai_debugger_modal_teamwork_hide_count, {
        count: team.members.length
    }) : formatMessage((0, $lT1k3.messages).ai_debugger_modal_teamwork_show_count, {
        count: team.members.length
    })), showMembers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $090b81aac414f11d$var$pluginInvocationStyles.teamworkMembersList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, team.members.map((member, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: idx
        }, (0, $jxGuq.formatMarkdownLinkAsText)(member))))))));
};
module.exports["TeamworkTeamCard"] = $090b81aac414f11d$export$f27472f36b5cad7b;

});

parcelRegister("kBYCn", function(module, exports) {
var $719bafe69d01c26b$export$7088950d16b52135 = /*#__PURE__*/ function(PluginInvocationStatus) {
    PluginInvocationStatus["PLUGIN_FINISHED"] = "PLUGIN_FINISHED";
    PluginInvocationStatus["PLUGIN_ERRORED"] = "PLUGIN_ERRORED";
    return PluginInvocationStatus;
}({});
module.exports["PluginInvocationStatus"] = $719bafe69d01c26b$export$7088950d16b52135;

});

parcelRegister("iQ1xn", function(module, exports) {

var $badUP = parcelRequire("badUP");

const $86be65b82995f8e3$export$254d68b455df6f6b = {
    [(0, $badUP.PluginName).SEARCH]: 'green',
    [(0, $badUP.PluginName).PEOPLE]: 'blue',
    [(0, $badUP.PluginName).TEAMWORK]: 'purple',
    [(0, $badUP.PluginName).PAGE_SEARCH_PLUGIN]: 'yellow'
};
const $86be65b82995f8e3$export$92abffed8cc5f142 = 'gray';
module.exports["PLUGIN_TAG_COLOR"] = $86be65b82995f8e3$export$254d68b455df6f6b;
module.exports["DEFAULT_PLUGIN_TAG_COLOR"] = $86be65b82995f8e3$export$92abffed8cc5f142;

});

parcelRegister("390xH", function(module, exports) {
const $beb9f99e78229947$export$97b80a86e0bee15d = (output)=>{
    const lines = output.split('\n');
    const result = {
        pages: []
    };
    let currentPage = null;
    let headerCaptured = false;
    const savePage = ()=>{
        if (currentPage && currentPage.title) result.pages.push(currentPage);
    };
    for (const line of lines){
        const trimmedLine = line.trim();
        // Capture header
        if (!headerCaptured && trimmedLine.startsWith('Here are')) {
            result.header = trimmedLine;
            headerCaptured = true;
            continue;
        }
        // Start of a new page entry (title line)
        if (trimmedLine.startsWith('- title:')) {
            // Save previous page if exists
            savePage();
            currentPage = {
                title: trimmedLine.substring(9).trim()
            };
            continue;
        }
        // Parse page fields
        if (currentPage) {
            if (trimmedLine.startsWith('url:')) currentPage.url = trimmedLine.substring(4).trim();
            else if (trimmedLine.startsWith('space:')) currentPage.space = trimmedLine.substring(6).trim();
            else if (trimmedLine.startsWith('date:')) currentPage.date = trimmedLine.substring(5).trim();
            else if (trimmedLine.startsWith('author:')) currentPage.author = trimmedLine.substring(7).trim();
            else if (trimmedLine.startsWith('snippet:')) currentPage.snippet = trimmedLine.substring(8).trim();
        }
    }
    // Save the last page
    savePage();
    return result.pages.length > 0 ? result : null;
};
module.exports["parsePageSearchOutput"] = $beb9f99e78229947$export$97b80a86e0bee15d;

});

parcelRegister("8L4Ur", function(module, exports) {
const $4c1a5e8c336543e6$export$21986be684877eaa = (output)=>{
    const lines = output.split('\n');
    const result = {
        sections: []
    };
    let currentTeam = null;
    let currentDocument = null;
    let inMembersSection = false;
    let headerLines = [];
    let currentSection = {};
    lines.forEach((line)=>{
        const trimmedLine = line.trim();
        // Capture main header
        if (trimmedLine.startsWith('Here are') && !result.header && !currentTeam && !currentDocument) {
            headerLines.push(trimmedLine);
            return;
        }
        // Section headers (like "Here are the Confluence documents:")
        if (trimmedLine.startsWith('Here are the') && trimmedLine.endsWith(':') && !currentTeam && !currentDocument) {
            // Save previous section if exists
            if (currentSection.teams || currentSection.documents) result.sections.push(currentSection);
            currentSection = {
                sectionHeader: trimmedLine.slice(0, -1)
            }; // Remove trailing colon
            return;
        }
        // Start of a new team
        if (trimmedLine.startsWith('- type: Team')) {
            // Save previous item
            if (currentTeam) {
                if (!currentSection.teams) currentSection.teams = [];
                currentSection.teams.push(currentTeam);
            }
            if (currentDocument) {
                if (!currentSection.documents) currentSection.documents = [];
                currentSection.documents.push(currentDocument);
            }
            currentTeam = {
                type: 'Team',
                members: []
            };
            currentDocument = null;
            inMembersSection = false;
            return;
        }
        // Start of a new document (Confluence Page, Confluence Blog Post, etc.)
        if (trimmedLine.startsWith('- type: Confluence') || trimmedLine.startsWith('- type: Jira')) {
            // Save previous item
            if (currentTeam) {
                if (!currentSection.teams) currentSection.teams = [];
                currentSection.teams.push(currentTeam);
            }
            if (currentDocument) {
                if (!currentSection.documents) currentSection.documents = [];
                currentSection.documents.push(currentDocument);
            }
            currentDocument = {
                type: trimmedLine.substring(8).trim()
            };
            currentTeam = null;
            inMembersSection = false;
            return;
        }
        // Parse fields
        if (currentTeam) {
            // Team parsing
            if (inMembersSection && trimmedLine.startsWith('- [')) currentTeam.members.push(trimmedLine.substring(2).trim());
            else if (trimmedLine.startsWith('- ')) {
                const colonIndex = trimmedLine.indexOf(':');
                if (colonIndex !== -1) {
                    const fieldName = trimmedLine.substring(2, colonIndex).toLowerCase();
                    const fieldValue = trimmedLine.substring(colonIndex + 1).trim();
                    switch(fieldName){
                        case 'ari':
                            currentTeam.ari = fieldValue;
                            break;
                        case 'name':
                            currentTeam.name = fieldValue;
                            break;
                        case 'description':
                            currentTeam.description = fieldValue;
                            break;
                        case 'creator':
                            currentTeam.creator = fieldValue;
                            break;
                        case 'member count':
                            currentTeam.memberCount = parseInt(fieldValue, 10);
                            break;
                        case 'teamstate':
                            currentTeam.teamState = fieldValue;
                            inMembersSection = false;
                            break;
                        case 'members':
                            inMembersSection = true;
                            currentTeam.members = [];
                            break;
                    }
                }
            }
        } else if (currentDocument && trimmedLine.startsWith('- ')) {
            // Document parsing
            const colonIndex = trimmedLine.indexOf(':');
            if (colonIndex !== -1) {
                const fieldName = trimmedLine.substring(2, colonIndex).toLowerCase();
                const fieldValue = trimmedLine.substring(colonIndex + 1).trim();
                switch(fieldName){
                    case 'ari':
                        currentDocument.ari = fieldValue;
                        break;
                    case 'title':
                        currentDocument.title = fieldValue;
                        break;
                    case 'url':
                        currentDocument.url = fieldValue;
                        break;
                    case 'author':
                        currentDocument.author = fieldValue;
                        break;
                    case 'updated':
                        currentDocument.updated = fieldValue;
                        break;
                }
            }
        }
    });
    // Save last item
    if (currentTeam) {
        if (!currentSection.teams) currentSection.teams = [];
        currentSection.teams.push(currentTeam);
    }
    if (currentDocument) {
        if (!currentSection.documents) currentSection.documents = [];
        currentSection.documents.push(currentDocument);
    }
    // Save last section
    if (currentSection.teams || currentSection.documents) result.sections.push(currentSection);
    if (headerLines.length > 0) result.header = headerLines.join(' ');
    return result.sections.length > 0 ? result : null;
};
module.exports["parseTeamworkOutput"] = $4c1a5e8c336543e6$export$21986be684877eaa;

});

parcelRegister("7xFlv", function(module, exports) {
/**
 * Builds a Splunk search URL for the given search query and time-range params.
 */ const $c2ac4ed70fa6b8dd$export$e015db0b6490c3ab = (query, timeRangeParams)=>`https://splunk.paas-inf.net/en-US/app/search/search?q=search%20${encodeURIComponent(query)}&display.page.search.mode=smart${timeRangeParams}`;
module.exports["buildSplunkUrl"] = $c2ac4ed70fa6b8dd$export$e015db0b6490c3ab;

});

parcelRegister("grLIz", function(module, exports) {
const $019a007e15a2bbf1$var$TIME_WINDOW_BUFFER_SECONDS = 900; // 15 minutes
/**
 * Converts a timestamp (ISO 8601 string or epoch milliseconds) to epoch seconds.
 * Returns `undefined` when the timestamp is missing or unparseable.
 */ const $019a007e15a2bbf1$var$toEpochSeconds = (timestamp)=>{
    if (timestamp === null || timestamp === undefined || timestamp === '') return undefined;
    const ms = typeof timestamp === 'number' ? timestamp : new Date(timestamp).getTime();
    if (Number.isNaN(ms)) return undefined;
    return Math.floor(ms / 1000);
};
const $019a007e15a2bbf1$export$f32c0bfabfe29945 = (timestamp)=>{
    const epochSeconds = $019a007e15a2bbf1$var$toEpochSeconds(timestamp);
    if (epochSeconds === undefined) return '';
    const earliest = epochSeconds - $019a007e15a2bbf1$var$TIME_WINDOW_BUFFER_SECONDS;
    const latest = epochSeconds + $019a007e15a2bbf1$var$TIME_WINDOW_BUFFER_SECONDS;
    return `&earliest=${earliest}&latest=${latest}`;
};
module.exports["getSplunkTimeRangeParams"] = $019a007e15a2bbf1$export$f32c0bfabfe29945;

});

parcelRegister("jxGuq", function(module, exports) {

var $5J4us = parcelRequire("5J4us");

const $52a506f226b267ba$export$c064dfbb0e9baaa8 = (text)=>{
    const parsed = (0, $5J4us.parseMarkdownLink)(text);
    if (!parsed) return text;
    return parsed.accountId ? `${parsed.name} (${parsed.accountId})` : parsed.name;
};
module.exports["formatMarkdownLinkAsText"] = $52a506f226b267ba$export$c064dfbb0e9baaa8;

});


//# sourceMappingURL=definition-popup-content.a7e01fa7.js.map
